// This file is auto-generated. Do not edit!

export default [
  {
    id: "0x8eaf7b29f02ba8d8c1d7aeb587403dcb16e2e943e4e2f5f94b0963c2386406c9",
    name: "USDC / PAXG",
    irm: "0x870aC11D48B15DB9a138Cf899d20F13F79Ba00BC",
    lltv: "915000000000000000",
    oracle: "0xDd1778F71a4a1C6A0eFebd8AE9f8848634CE1101",
    loanToken: {
      address: "0xA0b86991c6218b36c1d19D4a2e9Eb0cE3606eB48",
      symbol: "USDC",
    },
    collateralToken: {
      address: "0x45804880De22913dAFE09f4980848ECE6EcbAf78",
      symbol: "PAXG",
    },
  },
  {
    id: "0xe7e9694b754c4d4f7e21faf7223f6fa71abaeb10296a4c43a54a7977149687d2",
    name: "USDT / wstETH",
    irm: "0x870aC11D48B15DB9a138Cf899d20F13F79Ba00BC",
    lltv: "860000000000000000",
    oracle: "0x95DB30fAb9A3754e42423000DF27732CB2396992",
    loanToken: {
      address: "0xdAC17F958D2ee523a2206206994597C13D831ec7",
      symbol: "USDT",
    },
    collateralToken: {
      address: "0x7f39C581F595B53c5cb19bD0b3f8dA6c935E2Ca0",
      symbol: "wstETH",
    },
  },
  {
    id: "0x3a85e619751152991742810df6ec69ce473daef99e28a64ab2340d7b7ccfee49",
    name: "USDC / WBTC",
    irm: "0x870aC11D48B15DB9a138Cf899d20F13F79Ba00BC",
    lltv: "860000000000000000",
    oracle: "0xDddd770BADd886dF3864029e4B377B5F6a2B6b83",
    loanToken: {
      address: "0xA0b86991c6218b36c1d19D4a2e9Eb0cE3606eB48",
      symbol: "USDC",
    },
    collateralToken: {
      address: "0x2260FAC5E5542a773Aa44fBCfeDf7C193bc2C599",
      symbol: "WBTC",
    },
  },
  {
    id: "0x64d65c9a2d91c36d56fbc42d69e979335320169b3df63bf92789e2c8883fcc64",
    name: "USDC / cbBTC",
    irm: "0x870aC11D48B15DB9a138Cf899d20F13F79Ba00BC",
    lltv: "860000000000000000",
    oracle: "0xA6D6950c9F177F1De7f7757FB33539e3Ec60182a",
    loanToken: {
      address: "0xA0b86991c6218b36c1d19D4a2e9Eb0cE3606eB48",
      symbol: "USDC",
    },
    collateralToken: {
      address: "0xcbB7C0000aB88B473b1f5aFd9ef808440eed33Bf",
      symbol: "cbBTC",
    },
  },
  {
    id: "0xa921ef34e2fc7a27ccc50ae7e4b154e16c9799d3387076c421423ef52ac4df99",
    name: "USDT / WBTC",
    irm: "0x870aC11D48B15DB9a138Cf899d20F13F79Ba00BC",
    lltv: "860000000000000000",
    oracle: "0x008bF4B1cDA0cc9f0e882E0697f036667652E1ef",
    loanToken: {
      address: "0xdAC17F958D2ee523a2206206994597C13D831ec7",
      symbol: "USDT",
    },
    collateralToken: {
      address: "0x2260FAC5E5542a773Aa44fBCfeDf7C193bc2C599",
      symbol: "WBTC",
    },
  },
  {
    id: "0xb8fc70e82bc5bb53e773626fcc6a23f7eefa036918d7ef216ecfb1950a94a85e",
    name: "WETH / wstETH",
    irm: "0x870aC11D48B15DB9a138Cf899d20F13F79Ba00BC",
    lltv: "965000000000000000",
    oracle: "0xbD60A6770b27E084E8617335ddE769241B0e71D8",
    loanToken: {
      address: "0xC02aaA39b223FE8D0A0e5C4F27eAD9083C756Cc2",
      symbol: "WETH",
    },
    collateralToken: {
      address: "0x7f39C581F595B53c5cb19bD0b3f8dA6c935E2Ca0",
      symbol: "wstETH",
    },
  },
  {
    id: "0x85d59152eeeab7ca024804895b358868d8dd1e134171be400d7792d5604a212c",
    name: "PYUSD / weETH",
    irm: "0x870aC11D48B15DB9a138Cf899d20F13F79Ba00BC",
    lltv: "860000000000000000",
    oracle: "0x221898dA0890Fc5fb6c890Fcdc051FA97946eE11",
    loanToken: {
      address: "0x6c3ea9036406852006290770BEdFcAbA0e23A0e8",
      symbol: "PYUSD",
    },
    collateralToken: {
      address: "0xCd5fE23C85820F7B72D0926FC9b05b43E359b7ee",
      symbol: "weETH",
    },
  },
  {
    id: "0xb323495f7e4148be5643a4ea4a8221eef163e4bccfdedc2a6f4696baacbc86cc",
    name: "USDC / wstETH",
    irm: "0x870aC11D48B15DB9a138Cf899d20F13F79Ba00BC",
    lltv: "860000000000000000",
    oracle: "0x48F7E36EB6B826B2dF4B2E630B62Cd25e89E40e2",
    loanToken: {
      address: "0xA0b86991c6218b36c1d19D4a2e9Eb0cE3606eB48",
      symbol: "USDC",
    },
    collateralToken: {
      address: "0x7f39C581F595B53c5cb19bD0b3f8dA6c935E2Ca0",
      symbol: "wstETH",
    },
  },
  {
    id: "0x41c41d0c9aadbf4751f5ee215ed5a16954a4b34e1b70fca5393d4b08858fa3fa",
    name: "PYUSD / PRIME",
    irm: "0x870aC11D48B15DB9a138Cf899d20F13F79Ba00BC",
    lltv: "860000000000000000",
    oracle: "0x335e5718bC20028d5e357473a3736C187Ca6b07e",
    loanToken: {
      address: "0x6c3ea9036406852006290770BEdFcAbA0e23A0e8",
      symbol: "PYUSD",
    },
    collateralToken: {
      address: "0x19ebb35279A16207Ec4ba82799CC64715065F7F6",
      symbol: "PRIME",
    },
  },
  {
    id: "0x0f9563442d64ab3bd3bcb27058db0b0d4046a4c46f0acd811dacae9551d2b129",
    name: "USDC / sdeUSD",
    irm: "0x870aC11D48B15DB9a138Cf899d20F13F79Ba00BC",
    lltv: "915000000000000000",
    oracle: "0x65F9f6d537C2D628D1c2663896436817440eDB72",
    loanToken: {
      address: "0xA0b86991c6218b36c1d19D4a2e9Eb0cE3606eB48",
      symbol: "USDC",
    },
    collateralToken: {
      address: "0x5C5b196aBE0d54485975D1Ec29617D42D9198326",
      symbol: "sdeUSD",
    },
  },
  {
    id: "0x90ef0c5a0dc7c4de4ad4585002d44e9d411d212d2f6258e94948beecf8b4c0d5",
    name: "PYUSD / sUSDe",
    irm: "0x870aC11D48B15DB9a138Cf899d20F13F79Ba00BC",
    lltv: "915000000000000000",
    oracle: "0xE6212D05cB5aF3C821Fef1C1A233a678724F9E7E",
    loanToken: {
      address: "0x6c3ea9036406852006290770BEdFcAbA0e23A0e8",
      symbol: "PYUSD",
    },
    collateralToken: {
      address: "0x9D39A5DE30e57443BfF2A8307A4256c8797A3497",
      symbol: "sUSDe",
    },
  },
  {
    id: "0x88a18b2f4d94e7ad27a381b15531c06abf05a7c99dd5d3c3679875fed6f7e742",
    name: "USDtb / sUSDe",
    irm: "0x870aC11D48B15DB9a138Cf899d20F13F79Ba00BC",
    lltv: "915000000000000000",
    oracle: "0x67BcC03438D7d71c39343d7AD21cb73Dc19aDB89",
    loanToken: {
      address: "0xC139190F447e929f090Edeb554D95AbB8b18aC1C",
      symbol: "USDtb",
    },
    collateralToken: {
      address: "0x9D39A5DE30e57443BfF2A8307A4256c8797A3497",
      symbol: "sUSDe",
    },
  },
  {
    id: "0xc9629945524f3fde56c7e8854a6c3d48e76b9d97236abbe73c750fcc7aeb8501",
    name: "PYUSD / syrupUSDC",
    irm: "0x870aC11D48B15DB9a138Cf899d20F13F79Ba00BC",
    lltv: "915000000000000000",
    oracle: "0xc8043d248551Ed19B33cbc89dCCd69148c827039",
    loanToken: {
      address: "0x6c3ea9036406852006290770BEdFcAbA0e23A0e8",
      symbol: "PYUSD",
    },
    collateralToken: {
      address: "0x80ac24aA929eaF5013f6436cdA2a7ba190f5Cc0b",
      symbol: "syrupUSDC",
    },
  },
  {
    id: "0xe51f9aaad25d0e755429cf77076b3c2d37cb1228ed81f8a5482f2102c220eef5",
    name: "PYUSD / kBTC",
    irm: "0x870aC11D48B15DB9a138Cf899d20F13F79Ba00BC",
    lltv: "860000000000000000",
    oracle: "0x007db14ca0d171fA583955fEF3917B2b9A95CF18",
    loanToken: {
      address: "0x6c3ea9036406852006290770BEdFcAbA0e23A0e8",
      symbol: "PYUSD",
    },
    collateralToken: {
      address: "0x73E0C0d45E048D25Fc26Fa3159b0aA04BfA4Db98",
      symbol: "kBTC",
    },
  },
  {
    id: "0x3274643db77a064abd3bc851de77556a4ad2e2f502f4f0c80845fa8f909ecf0b",
    name: "USDT / sUSDS",
    irm: "0x870aC11D48B15DB9a138Cf899d20F13F79Ba00BC",
    lltv: "965000000000000000",
    oracle: "0x0C426d174FC88B7A25d59945Ab2F7274Bf7B4C79",
    loanToken: {
      address: "0xdAC17F958D2ee523a2206206994597C13D831ec7",
      symbol: "USDT",
    },
    collateralToken: {
      address: "0xa3931d71877C0E7a3148CB7Eb4463524FEc27fbD",
      symbol: "sUSDS",
    },
  },
  {
    id: "0xea4bfb18df0ee6bffb7b3f0270899a8adb92ab6b684709634c8276128813cfd4",
    name: "RLUSD / weETH",
    irm: "0x870aC11D48B15DB9a138Cf899d20F13F79Ba00BC",
    lltv: "860000000000000000",
    oracle: "0x6ab351FfDe101BB24a97332f4f7162C1711f110b",
    loanToken: {
      address: "0x8292Bb45bf1Ee4d140127049757C2E0fF06317eD",
      symbol: "RLUSD",
    },
    collateralToken: {
      address: "0xCd5fE23C85820F7B72D0926FC9b05b43E359b7ee",
      symbol: "weETH",
    },
  },
  {
    id: "0x37e7484d642d90f14451f1910ba4b7b8e4c3ccdd0ec28f8b2bdb35479e472ba7",
    name: "WETH / weETH",
    irm: "0x870aC11D48B15DB9a138Cf899d20F13F79Ba00BC",
    lltv: "945000000000000000",
    oracle: "0xbDd2F2D473E8D63d1BFb0185B5bDB8046ca48a72",
    loanToken: {
      address: "0xC02aaA39b223FE8D0A0e5C4F27eAD9083C756Cc2",
      symbol: "WETH",
    },
    collateralToken: {
      address: "0xCd5fE23C85820F7B72D0926FC9b05b43E359b7ee",
      symbol: "weETH",
    },
  },
  {
    id: "0xe83d72fa5b00dcd46d9e0e860d95aa540d5ec106da5833108a9f826f21f36f52",
    name: "USDC / AA_FalconXUSDC",
    irm: "0x870aC11D48B15DB9a138Cf899d20F13F79Ba00BC",
    lltv: "770000000000000000",
    oracle: "0x52eA2C12734B5bB61e1edf52Bb0f01D9206493Fc",
    loanToken: {
      address: "0xA0b86991c6218b36c1d19D4a2e9Eb0cE3606eB48",
      symbol: "USDC",
    },
    collateralToken: {
      address: "0xC26A6Fa2C37b38E549a4a1807543801Db684f99C",
      symbol: "AA_FalconXUSDC",
    },
  },
  {
    id: "0xd0e50cdac92fe2172043f5e0c36532c6369d24947e40968f34a5e8819ca9ec5d",
    name: "WETH / wstETH",
    irm: "0x870aC11D48B15DB9a138Cf899d20F13F79Ba00BC",
    lltv: "945000000000000000",
    oracle: "0xbD60A6770b27E084E8617335ddE769241B0e71D8",
    loanToken: {
      address: "0xC02aaA39b223FE8D0A0e5C4F27eAD9083C756Cc2",
      symbol: "WETH",
    },
    collateralToken: {
      address: "0x7f39C581F595B53c5cb19bD0b3f8dA6c935E2Ca0",
      symbol: "wstETH",
    },
  },
  {
    id: "0x6a7e36eb088bd501d73f7ab4c5b8671358559341a78ce521c9e499dc0bc642b9",
    name: "PYUSD / LBTC",
    irm: "0x870aC11D48B15DB9a138Cf899d20F13F79Ba00BC",
    lltv: "860000000000000000",
    oracle: "0x0AeAa9320d78a5Edb9387A08682d1738BCc64b1f",
    loanToken: {
      address: "0x6c3ea9036406852006290770BEdFcAbA0e23A0e8",
      symbol: "PYUSD",
    },
    collateralToken: {
      address: "0x8236a87084f8B84306f72007F36F2618A5634494",
      symbol: "LBTC",
    },
  },
  {
    id: "0x1590cb22d797e226df92ebc6e0153427e207299916e7e4e53461389ad68272fb",
    name: "USDC / wsrUSD",
    irm: "0x870aC11D48B15DB9a138Cf899d20F13F79Ba00BC",
    lltv: "945000000000000000",
    oracle: "0x938D2eDb20425cF80F008E7ec314Eb456940Da15",
    loanToken: {
      address: "0xA0b86991c6218b36c1d19D4a2e9Eb0cE3606eB48",
      symbol: "USDC",
    },
    collateralToken: {
      address: "0xd3fD63209FA2D55B07A0f6db36C2f43900be3094",
      symbol: "wsrUSD",
    },
  },
  {
    id: "0x9bc98c2f20ac58287ef2c860eea53a2fdc27c17a7817ff1206c0b7840cc7cd79",
    name: "USDC / PT-reUSD-25JUN2026",
    irm: "0x870aC11D48B15DB9a138Cf899d20F13F79Ba00BC",
    lltv: "915000000000000000",
    oracle: "0x12d66602C691Aa93E90415aB22FB0760695AC768",
    loanToken: {
      address: "0xA0b86991c6218b36c1d19D4a2e9Eb0cE3606eB48",
      symbol: "USDC",
    },
    collateralToken: {
      address: "0x3EAA0F0f0A5d3D595ae4e4b0D27f439d01c3E7b2",
      symbol: "PT-reUSD-25JUN2026",
    },
  },
  {
    id: "0x23a7d0ff682b323363fb8ba58327ed87001f6306e09b7fd7413bbe4698e749c8",
    name: "USDC / msY",
    irm: "0x870aC11D48B15DB9a138Cf899d20F13F79Ba00BC",
    lltv: "860000000000000000",
    oracle: "0xB0b6Fc449CcF81Ff4129A86ddc814412E3Cd9Aa4",
    loanToken: {
      address: "0xA0b86991c6218b36c1d19D4a2e9Eb0cE3606eB48",
      symbol: "USDC",
    },
    collateralToken: {
      address: "0x890A5122Aa1dA30fEC4286DE7904Ff808F0bd74A",
      symbol: "msY",
    },
  },
  {
    id: "0xe07d416323a1afbfe0bf2fe27ffb549ff565cf5c86d21b79fc60664038e597c9",
    name: "USDC / savUSD",
    irm: "0x870aC11D48B15DB9a138Cf899d20F13F79Ba00BC",
    lltv: "915000000000000000",
    oracle: "0x839940de5043e7c6eDaf063714AFe7F20De5ff12",
    loanToken: {
      address: "0xA0b86991c6218b36c1d19D4a2e9Eb0cE3606eB48",
      symbol: "USDC",
    },
    collateralToken: {
      address: "0xb8D89678E75a973E74698c976716308abB8a46A4",
      symbol: "savUSD",
    },
  },
  {
    id: "0xdbf4bc065d4e76f4505a523f2bba5e5ccdca94c16d67c3a6ff1dadbcbb26d4aa",
    name: "USDT / stcUSD",
    irm: "0x870aC11D48B15DB9a138Cf899d20F13F79Ba00BC",
    lltv: "915000000000000000",
    oracle: "0x8C257cb4Ba8d5a78B3d82e2aAeC211700e94a814",
    loanToken: {
      address: "0xdAC17F958D2ee523a2206206994597C13D831ec7",
      symbol: "USDT",
    },
    collateralToken: {
      address: "0x88887bE419578051FF9F4eb6C858A951921D8888",
      symbol: "stcUSD",
    },
  },
  {
    id: "0x34377fc4f617c51818e92c79df31ff270c6a91bc94ad32e367fdf59b9f4ac5dd",
    name: "USDC / weETH",
    irm: "0x870aC11D48B15DB9a138Cf899d20F13F79Ba00BC",
    lltv: "770000000000000000",
    oracle: "0xa3A7A3ceFee206f9d7Fe00eC3C83324ED4228411",
    loanToken: {
      address: "0xA0b86991c6218b36c1d19D4a2e9Eb0cE3606eB48",
      symbol: "USDC",
    },
    collateralToken: {
      address: "0xCd5fE23C85820F7B72D0926FC9b05b43E359b7ee",
      symbol: "weETH",
    },
  },
  {
    id: "0x4565ac05d38b19374ccbb04c17cca60ca9353cd41824f0803d0fc7704f60eaed",
    name: "USDC / reUSD",
    irm: "0x870aC11D48B15DB9a138Cf899d20F13F79Ba00BC",
    lltv: "915000000000000000",
    oracle: "0xA66a4F03Fd8031973f8C7718904ce32385f54E70",
    loanToken: {
      address: "0xA0b86991c6218b36c1d19D4a2e9Eb0cE3606eB48",
      symbol: "USDC",
    },
    collateralToken: {
      address: "0x5086bf358635B81D8C47C66d1C8b9E567Db70c72",
      symbol: "reUSD",
    },
  },
  {
    id: "0xb74aae3bada73b0bd1087bd110d35afaa390de0451e5745091fbb5d296684e1c",
    name: "USDT / USDT",
    irm: "0x870aC11D48B15DB9a138Cf899d20F13F79Ba00BC",
    lltv: "980000000000000000",
    oracle: "0x24CC84c52f15c06170c1b7cBfaeD4b9D1D1FDd55",
    loanToken: {
      address: "0xdAC17F958D2ee523a2206206994597C13D831ec7",
      symbol: "USDT",
    },
    collateralToken: {
      address: "0x3D4762b4bB4B4C922377Fe5b887E900D7fB64cDf",
      symbol: "USDT",
    },
  },
  {
    id: "0xd570c19c0dc0fbe4ab7faf4a37c4150e1c141c8aada8ca3e1b4b6c1b712af93d",
    name: "USDC / stUSDS",
    irm: "0x870aC11D48B15DB9a138Cf899d20F13F79Ba00BC",
    lltv: "860000000000000000",
    oracle: "0xba3D2Dc1670763c6729CC923A922C7513C0f9DD0",
    loanToken: {
      address: "0xA0b86991c6218b36c1d19D4a2e9Eb0cE3606eB48",
      symbol: "USDC",
    },
    collateralToken: {
      address: "0x99CD4Ec3f88A45940936F469E4bB72A2A701EEB9",
      symbol: "stUSDS",
    },
  },
  {
    id: "0x002278ea242ec722813b4fe3c8eeaa07dbc331c731cc0b4248a1bf0771f933ea",
    name: "USDC / PST",
    irm: "0x870aC11D48B15DB9a138Cf899d20F13F79Ba00BC",
    lltv: "860000000000000000",
    oracle: "0xa5657B406Fc4282039861C6fcA64452aeFEC8ac0",
    loanToken: {
      address: "0xA0b86991c6218b36c1d19D4a2e9Eb0cE3606eB48",
      symbol: "USDC",
    },
    collateralToken: {
      address: "0x22aE3D9a738471f405169Af055d31c687087d4c7",
      symbol: "PST",
    },
  },
  {
    id: "0xa75bb490ecfee90c86a9d22ebc2dde42fb83478b3f18722b9fc6f5f668cab124",
    name: "USDC / PT-apyUSD-18JUN2026",
    irm: "0x870aC11D48B15DB9a138Cf899d20F13F79Ba00BC",
    lltv: "860000000000000000",
    oracle: "0xAc0Fa280aD4BA07F750DFa550aA3C3f182ca8B3e",
    loanToken: {
      address: "0xA0b86991c6218b36c1d19D4a2e9Eb0cE3606eB48",
      symbol: "USDC",
    },
    collateralToken: {
      address: "0x3365554a61CeFF74A76528f9e86C1E87946d16a5",
      symbol: "PT-apyUSD-18JUN2026",
    },
  },
  {
    id: "0x6cf7e63f37d7f2ca2b86d1415eeedd4173b30f9974e8a706016e1f798b479b03",
    name: "USDC / muBOND",
    irm: "0x870aC11D48B15DB9a138Cf899d20F13F79Ba00BC",
    lltv: "860000000000000000",
    oracle: "0x2B239c8368e2F8B176FD75CcD4362eC66673Ea0b",
    loanToken: {
      address: "0xA0b86991c6218b36c1d19D4a2e9Eb0cE3606eB48",
      symbol: "USDC",
    },
    collateralToken: {
      address: "0x09AD9c6DcadCc3aB0b3E107E8E7DA69c2eEa8599",
      symbol: "muBOND",
    },
  },
  {
    id: "0xbe50eed784490d6c32f398902b55eb5e1bd5af89e1f554993ad5fea899be090b",
    name: "PYUSD / WBTC",
    irm: "0x870aC11D48B15DB9a138Cf899d20F13F79Ba00BC",
    lltv: "860000000000000000",
    oracle: "0x4124b5Cb815A21E26fF86c8A6A0A074c7fa2Dd1D",
    loanToken: {
      address: "0x6c3ea9036406852006290770BEdFcAbA0e23A0e8",
      symbol: "PYUSD",
    },
    collateralToken: {
      address: "0x2260FAC5E5542a773Aa44fBCfeDf7C193bc2C599",
      symbol: "WBTC",
    },
  },
  {
    id: "0xef2c308b5abecf5c8750a1aa82b47c558005feb7a03f4f8e1ad682d71ac8d0ba",
    name: "USDC / mF-ONE",
    irm: "0x870aC11D48B15DB9a138Cf899d20F13F79Ba00BC",
    lltv: "915000000000000000",
    oracle: "0x0cB1928EcA8783F05a07D9Ae2AfB33f38BFBEb78",
    loanToken: {
      address: "0xA0b86991c6218b36c1d19D4a2e9Eb0cE3606eB48",
      symbol: "USDC",
    },
    collateralToken: {
      address: "0x238a700eD6165261Cf8b2e544ba797BC11e466Ba",
      symbol: "mF-ONE",
    },
  },
  {
    id: "0x7e585a933ffe8443c371b4f8cfeb4430f5f6a14c2f32a898c26662c67a1cb8b8",
    name: "USDC / wstETH",
    irm: "0x870aC11D48B15DB9a138Cf899d20F13F79Ba00BC",
    lltv: "860000000000000000",
    oracle: "0xe087AD7FE989cF63F8383579D160a20Ee7e69F9F",
    loanToken: {
      address: "0xA0b86991c6218b36c1d19D4a2e9Eb0cE3606eB48",
      symbol: "USDC",
    },
    collateralToken: {
      address: "0x7f39C581F595B53c5cb19bD0b3f8dA6c935E2Ca0",
      symbol: "wstETH",
    },
  },
  {
    id: "0xbbf7ce1b40d32d3e3048f5cf27eeaa6de8cb27b80194690aab191a63381d8c99",
    name: "USDC / siUSD",
    irm: "0x870aC11D48B15DB9a138Cf899d20F13F79Ba00BC",
    lltv: "915000000000000000",
    oracle: "0xd2cC46b9B2D761502eF933320ecf0268EC0dfa6d",
    loanToken: {
      address: "0xA0b86991c6218b36c1d19D4a2e9Eb0cE3606eB48",
      symbol: "USDC",
    },
    collateralToken: {
      address: "0xDBDC1Ef57537E34680B898E1FEBD3D68c7389bCB",
      symbol: "siUSD",
    },
  },
  {
    id: "0x94b823e6bd8ea533b4e33fbc307faea0b307301bc48763acc4d4aa4def7636cd",
    name: "USDC / WETH",
    irm: "0x870aC11D48B15DB9a138Cf899d20F13F79Ba00BC",
    lltv: "860000000000000000",
    oracle: "0x0F948CBa8231Db7898ef36A4212581Ad7b1B4580",
    loanToken: {
      address: "0xA0b86991c6218b36c1d19D4a2e9Eb0cE3606eB48",
      symbol: "USDC",
    },
    collateralToken: {
      address: "0xC02aaA39b223FE8D0A0e5C4F27eAD9083C756Cc2",
      symbol: "WETH",
    },
  },
  {
    id: "0xd9e34b1eed46d123ac1b69b224de1881dbc88798bc7b70f504920f62f58f28cc",
    name: "USDC / wstUSR",
    irm: "0x870aC11D48B15DB9a138Cf899d20F13F79Ba00BC",
    lltv: "915000000000000000",
    oracle: "0xDa850a72080024e17c1590fbf6ea7a826dB90760",
    loanToken: {
      address: "0xA0b86991c6218b36c1d19D4a2e9Eb0cE3606eB48",
      symbol: "USDC",
    },
    collateralToken: {
      address: "0x1202F5C7b4B9E47a1A484E8B270be34dbbC75055",
      symbol: "wstUSR",
    },
  },
  {
    id: "0x4fe72543c5c95cd6b5f3cb516cd235ba882e2e705fe3424db6f99dfe5811d0d3",
    name: "USDT / cbBTC",
    irm: "0x870aC11D48B15DB9a138Cf899d20F13F79Ba00BC",
    lltv: "860000000000000000",
    oracle: "0x9F983115741D0F7F2EAE07831415057AD3de34d2",
    loanToken: {
      address: "0xdAC17F958D2ee523a2206206994597C13D831ec7",
      symbol: "USDT",
    },
    collateralToken: {
      address: "0xcbB7C0000aB88B473b1f5aFd9ef808440eed33Bf",
      symbol: "cbBTC",
    },
  },
  {
    id: "0x24852d8d7464402ddcd717415e009d42bf7427d6a8893487f83c75ee0f4a0ea6",
    name: "USDC / dCOMP",
    irm: "0x870aC11D48B15DB9a138Cf899d20F13F79Ba00BC",
    lltv: "625000000000000000",
    oracle: "0x0798dE3DDb22c289A653c020863AaA7ef33C05d7",
    loanToken: {
      address: "0xA0b86991c6218b36c1d19D4a2e9Eb0cE3606eB48",
      symbol: "USDC",
    },
    collateralToken: {
      address: "0x91d14789071e5E195FFC9F745348736677De3292",
      symbol: "dCOMP",
    },
  },
  {
    id: "0xff527fe9c6516f9d82a3d51422ccb031d123266e6e26d4c22c942a948c180a75",
    name: "EURC / WBTC",
    irm: "0x870aC11D48B15DB9a138Cf899d20F13F79Ba00BC",
    lltv: "860000000000000000",
    oracle: "0x9CB3f4276bcD149b3668e1a645a964bC12877b89",
    loanToken: {
      address: "0x1aBaEA1f7C830bD89Acc67eC4af516284b1bC33c",
      symbol: "EURC",
    },
    collateralToken: {
      address: "0x2260FAC5E5542a773Aa44fBCfeDf7C193bc2C599",
      symbol: "WBTC",
    },
  },
  {
    id: "0x3fea56ab83b05840dc83dc6b3d2f2fbd938147cbaa8126bac529e6c820058253",
    name: "USDT / PT-reUSD-25JUN2026",
    irm: "0x870aC11D48B15DB9a138Cf899d20F13F79Ba00BC",
    lltv: "915000000000000000",
    oracle: "0x5749F59D948910896527b20763a6d91F54227955",
    loanToken: {
      address: "0xdAC17F958D2ee523a2206206994597C13D831ec7",
      symbol: "USDT",
    },
    collateralToken: {
      address: "0x3EAA0F0f0A5d3D595ae4e4b0D27f439d01c3E7b2",
      symbol: "PT-reUSD-25JUN2026",
    },
  },
  {
    id: "0xed05fcc2893b78b3fa468d21b6e4d2925e7f2c64eb1f16279757c43f87502a99",
    name: "USDC / PT-apxUSD-18JUN2026",
    irm: "0x870aC11D48B15DB9a138Cf899d20F13F79Ba00BC",
    lltv: "860000000000000000",
    oracle: "0x4DFceF82eaEE9eA817bEb1279336F7D0Ebf2b685",
    loanToken: {
      address: "0xA0b86991c6218b36c1d19D4a2e9Eb0cE3606eB48",
      symbol: "USDC",
    },
    collateralToken: {
      address: "0x92a6A01B07984de46c24E8EBa248449beB8B1dCB",
      symbol: "PT-apxUSD-18JUN2026",
    },
  },
  {
    id: "0x45671fb8d5dea1c4fbca0b8548ad742f6643300eeb8dbd34ad64a658b2b05bca",
    name: "USDT / cbBTC",
    irm: "0x870aC11D48B15DB9a138Cf899d20F13F79Ba00BC",
    lltv: "860000000000000000",
    oracle: "0x0E053750DFA4E809E5f7b119832C799c2aA138ac",
    loanToken: {
      address: "0xdAC17F958D2ee523a2206206994597C13D831ec7",
      symbol: "USDT",
    },
    collateralToken: {
      address: "0xcbB7C0000aB88B473b1f5aFd9ef808440eed33Bf",
      symbol: "cbBTC",
    },
  },
  {
    id: "0xb8fef900b383db2dbbf4458c7f46acf5b140f26d603a6d1829963f241b82510e",
    name: "USDC / OETH",
    irm: "0x870aC11D48B15DB9a138Cf899d20F13F79Ba00BC",
    lltv: "860000000000000000",
    oracle: "0xE8aDfF9117151fb5ad7313873780b87cC56EEDB0",
    loanToken: {
      address: "0xA0b86991c6218b36c1d19D4a2e9Eb0cE3606eB48",
      symbol: "USDC",
    },
    collateralToken: {
      address: "0x856c4Efb76C1D1AE02e20CEB03A2A6a08b0b8dC3",
      symbol: "OETH",
    },
  },
  {
    id: "0xf8c5aa31ea6b2a068a9eddb46dd110cae57bf0f12be9583a3f9a818effecba89",
    name: "USDC / PT-USD3-17DEC2026",
    irm: "0x870aC11D48B15DB9a138Cf899d20F13F79Ba00BC",
    lltv: "860000000000000000",
    oracle: "0xe5E6Ec063E63A9D0c6Ac041d0AD2bd03F7f08d72",
    loanToken: {
      address: "0xA0b86991c6218b36c1d19D4a2e9Eb0cE3606eB48",
      symbol: "USDC",
    },
    collateralToken: {
      address: "0x7f47c3e6b2c00fC4eB4d5Ae50d0Ab0Ab6888Eb4D",
      symbol: "PT-USD3-17DEC2026",
    },
  },
  {
    id: "0xb55c0ebe12c4af149ce74ba4d83ca847c3be6787921b36b51a4d98bd105163e2",
    name: "USDC / wJAAA",
    irm: "0x870aC11D48B15DB9a138Cf899d20F13F79Ba00BC",
    lltv: "980000000000000000",
    oracle: "0x2E4eb0647FD1F9029499D41153a7CCCb1aB5D886",
    loanToken: {
      address: "0xA0b86991c6218b36c1d19D4a2e9Eb0cE3606eB48",
      symbol: "USDC",
    },
    collateralToken: {
      address: "0x86b495e4Cb00AB18Ad94BFD7920479cC79E8eBFE",
      symbol: "wJAAA",
    },
  },
  {
    id: "0x0a15460ad263c2186fe0b5df20a8cf71d55f3cfa06de15edcf6138f6b8edd8bf",
    name: "USDC / rETH",
    irm: "0x870aC11D48B15DB9a138Cf899d20F13F79Ba00BC",
    lltv: "860000000000000000",
    oracle: "0x36Cb058364a811636685ef15a71E8ea99043f815",
    loanToken: {
      address: "0xA0b86991c6218b36c1d19D4a2e9Eb0cE3606eB48",
      symbol: "USDC",
    },
    collateralToken: {
      address: "0xae78736Cd615f374D3085123A210448E74Fc6393",
      symbol: "rETH",
    },
  },
  {
    id: "0xa128dddc761075df9a9a60689f3a41a989b245aad506352c509c0c3a76a9ec6b",
    name: "RLUSD / WBTC",
    irm: "0x870aC11D48B15DB9a138Cf899d20F13F79Ba00BC",
    lltv: "860000000000000000",
    oracle: "0xF58725eb213161E9054C97F970DC80b2d0327E8d",
    loanToken: {
      address: "0x8292Bb45bf1Ee4d140127049757C2E0fF06317eD",
      symbol: "RLUSD",
    },
    collateralToken: {
      address: "0x2260FAC5E5542a773Aa44fBCfeDf7C193bc2C599",
      symbol: "WBTC",
    },
  },
  {
    id: "0xe1b65304edd8ceaea9b629df4c3c926a37d1216e27900505c04f14b2ed279f33",
    name: "USDC / RLP",
    irm: "0x870aC11D48B15DB9a138Cf899d20F13F79Ba00BC",
    lltv: "860000000000000000",
    oracle: "0x19018450A02bC5c1994eaD517498311f64B2626a",
    loanToken: {
      address: "0xA0b86991c6218b36c1d19D4a2e9Eb0cE3606eB48",
      symbol: "USDC",
    },
    collateralToken: {
      address: "0x4956b52aE2fF65D74CA2d61207523288e4528f96",
      symbol: "RLP",
    },
  },
  {
    id: "0x9c28c8fa039a8df548a7f27adf062d751b0f2e9b9131931810535543adb23291",
    name: "USDC / apyUSD",
    irm: "0x870aC11D48B15DB9a138Cf899d20F13F79Ba00BC",
    lltv: "860000000000000000",
    oracle: "0xff1487BDa8049a536F912e41E27B82a8A3845862",
    loanToken: {
      address: "0xA0b86991c6218b36c1d19D4a2e9Eb0cE3606eB48",
      symbol: "USDC",
    },
    collateralToken: {
      address: "0x38EEb52F0771140d10c4E9A9a72349A329Fe8a6A",
      symbol: "apyUSD",
    },
  },
  {
    id: "0xf5c5df23559b0fb56560a7578ea17d81e245153ba64b8132df026c9358864d27",
    name: "PYUSD / wstETH",
    irm: "0x870aC11D48B15DB9a138Cf899d20F13F79Ba00BC",
    lltv: "860000000000000000",
    oracle: "0x9f02D619a875B0CA383D21772e136fC18B637916",
    loanToken: {
      address: "0x6c3ea9036406852006290770BEdFcAbA0e23A0e8",
      symbol: "PYUSD",
    },
    collateralToken: {
      address: "0x7f39C581F595B53c5cb19bD0b3f8dA6c935E2Ca0",
      symbol: "wstETH",
    },
  },
  {
    id: "0x6d2fba32b8649d92432d036c16aa80779034b7469b63abc259b17678857f31c2",
    name: "USDC / wstETH",
    irm: "0x870aC11D48B15DB9a138Cf899d20F13F79Ba00BC",
    lltv: "860000000000000000",
    oracle: "0x167D283aCAC1b9ff39466A75aA82902f340f1F4D",
    loanToken: {
      address: "0xA0b86991c6218b36c1d19D4a2e9Eb0cE3606eB48",
      symbol: "USDC",
    },
    collateralToken: {
      address: "0x7f39C581F595B53c5cb19bD0b3f8dA6c935E2Ca0",
      symbol: "wstETH",
    },
  },
  {
    id: "0xb7a75cabc2e8eadd0bc661340a9e359d9828bed6d5cbbcd64188bca8c01e399e",
    name: "EURCV / WBTC",
    irm: "0x870aC11D48B15DB9a138Cf899d20F13F79Ba00BC",
    lltv: "860000000000000000",
    oracle: "0x40721232bBd09e15E5Fc6c4F1E20a8465Be6A8E4",
    loanToken: {
      address: "0x5F7827FDeb7c20b443265Fc2F40845B715385Ff2",
      symbol: "EURCV",
    },
    collateralToken: {
      address: "0x2260FAC5E5542a773Aa44fBCfeDf7C193bc2C599",
      symbol: "WBTC",
    },
  },
  {
    id: "0x49b89ee666acc242de6a2f25ffdbb25dcc693a7f4746d8d4afeb51c440fa938a",
    name: "USDC / AVLT",
    irm: "0x870aC11D48B15DB9a138Cf899d20F13F79Ba00BC",
    lltv: "860000000000000000",
    oracle: "0x2C7aA77cC726B35b1F182D90d45292e0BE38a841",
    loanToken: {
      address: "0xA0b86991c6218b36c1d19D4a2e9Eb0cE3606eB48",
      symbol: "USDC",
    },
    collateralToken: {
      address: "0x74dB7a52773A52699dbC0c01b1254E5301E3e119",
      symbol: "AVLT",
    },
  },
  {
    id: "0xb374528d44b6ab6e0cecc87e0481f45d892f38baec90c1d318851969ec14ea5f",
    name: "USDS / wstETH",
    irm: "0x870aC11D48B15DB9a138Cf899d20F13F79Ba00BC",
    lltv: "860000000000000000",
    oracle: "0xc9A9440d1545047b2Ce3624DB425410cF2EAE292",
    loanToken: {
      address: "0xdC035D45d973E3EC169d2276DDab16f1e407384F",
      symbol: "USDS",
    },
    collateralToken: {
      address: "0x7f39C581F595B53c5cb19bD0b3f8dA6c935E2Ca0",
      symbol: "wstETH",
    },
  },
  {
    id: "0x1d09bf979a167075f5608686642fd3cdb458de742a234175892fa03f23693f6b",
    name: "USDC / v-wmtUSDC",
    irm: "0x870aC11D48B15DB9a138Cf899d20F13F79Ba00BC",
    lltv: "860000000000000000",
    oracle: "0x6969A0296d9fEC77e794651469e362105d2307e8",
    loanToken: {
      address: "0xA0b86991c6218b36c1d19D4a2e9Eb0cE3606eB48",
      symbol: "USDC",
    },
    collateralToken: {
      address: "0xF65460B84c13eeb911303336Ab0f9D63CC79839f",
      symbol: "v-wmtUSDC",
    },
  },
  {
    id: "0x8924445a76b678c536df977ed9222fb0b23ee5311497dd0223fe6270bb20b4e6",
    name: "USDC / sUSN",
    irm: "0x870aC11D48B15DB9a138Cf899d20F13F79Ba00BC",
    lltv: "860000000000000000",
    oracle: "0xC415Cc3F04F9074A9562aEEe02591e65D39A94aa",
    loanToken: {
      address: "0xA0b86991c6218b36c1d19D4a2e9Eb0cE3606eB48",
      symbol: "USDC",
    },
    collateralToken: {
      address: "0xE24a3DC889621612422A64E6388927901608B91D",
      symbol: "sUSN",
    },
  },
  {
    id: "0x5d41b8d23ccf6d9e9f7e2b1b357d92bba6ef0367d6ef8ceda965f73e52108461",
    name: "USDC / USP",
    irm: "0x870aC11D48B15DB9a138Cf899d20F13F79Ba00BC",
    lltv: "860000000000000000",
    oracle: "0x5096642B7c7CD82198932f3FADd873EC2fcDeb6d",
    loanToken: {
      address: "0xA0b86991c6218b36c1d19D4a2e9Eb0cE3606eB48",
      symbol: "USDC",
    },
    collateralToken: {
      address: "0x098697bA3Fee4eA76294C5d6A466a4e3b3E95FE6",
      symbol: "USP",
    },
  },
  {
    id: "0xa9f70093360419b4544f17a4553ac5847d896be23f020295bd95c24af4df700e",
    name: "USDT / wsrUSD",
    irm: "0x870aC11D48B15DB9a138Cf899d20F13F79Ba00BC",
    lltv: "945000000000000000",
    oracle: "0x03dfCa9A320ca88fA6a0A132F34822e4B13d6fa0",
    loanToken: {
      address: "0xdAC17F958D2ee523a2206206994597C13D831ec7",
      symbol: "USDT",
    },
    collateralToken: {
      address: "0xd3fD63209FA2D55B07A0f6db36C2f43900be3094",
      symbol: "wsrUSD",
    },
  },
  {
    id: "0xb317d11c2bc2c0c8e6ea3c6517731cf667c86f2c716624be50319a6d32a97e8d",
    name: "USDC / msY",
    irm: "0x870aC11D48B15DB9a138Cf899d20F13F79Ba00BC",
    lltv: "915000000000000000",
    oracle: "0xB0b6Fc449CcF81Ff4129A86ddc814412E3Cd9Aa4",
    loanToken: {
      address: "0xA0b86991c6218b36c1d19D4a2e9Eb0cE3606eB48",
      symbol: "USDC",
    },
    collateralToken: {
      address: "0x890A5122Aa1dA30fEC4286DE7904Ff808F0bd74A",
      symbol: "msY",
    },
  },
  {
    id: "0x61765602144e91e5ac9f9e98b8584eae308f9951596fd7f5e0f59f21cd2bf664",
    name: "USDC / weETH",
    irm: "0x870aC11D48B15DB9a138Cf899d20F13F79Ba00BC",
    lltv: "860000000000000000",
    oracle: "0x5635a2F38c5dFd1d8fDB176d9CB5AEFA07bf6A68",
    loanToken: {
      address: "0xA0b86991c6218b36c1d19D4a2e9Eb0cE3606eB48",
      symbol: "USDC",
    },
    collateralToken: {
      address: "0xCd5fE23C85820F7B72D0926FC9b05b43E359b7ee",
      symbol: "weETH",
    },
  },
  {
    id: "0xd8a8e6667f58aa9229e8979bd619742b1660ee856c200a93e407dbccb7222323",
    name: "PYUSD / cbBTC",
    irm: "0x870aC11D48B15DB9a138Cf899d20F13F79Ba00BC",
    lltv: "860000000000000000",
    oracle: "0x7681692A9F228fd7dAc0679238D467729Af4E9ca",
    loanToken: {
      address: "0x6c3ea9036406852006290770BEdFcAbA0e23A0e8",
      symbol: "PYUSD",
    },
    collateralToken: {
      address: "0xcbB7C0000aB88B473b1f5aFd9ef808440eed33Bf",
      symbol: "cbBTC",
    },
  },
  {
    id: "0xd98cd88ae5b336086b39fb1d62ba6171282e946105b010143f0e89f8fe7cff36",
    name: "WETH / savETH",
    irm: "0x870aC11D48B15DB9a138Cf899d20F13F79Ba00BC",
    lltv: "915000000000000000",
    oracle: "0x943da86D8686f86F0b3b43fF78A92AAE1A6Ed3a7",
    loanToken: {
      address: "0xC02aaA39b223FE8D0A0e5C4F27eAD9083C756Cc2",
      symbol: "WETH",
    },
    collateralToken: {
      address: "0xDA06eE2dACF9245Aa80072a4407deBDea0D7e341",
      symbol: "savETH",
    },
  },
  {
    id: "0xeb17955ea422baeddbfb0b8d8c9086c5be7a9cfdefb292119a102e981a30062e",
    name: "USDC / stcUSD",
    irm: "0x870aC11D48B15DB9a138Cf899d20F13F79Ba00BC",
    lltv: "915000000000000000",
    oracle: "0x8E3386B2f6084eB1B0988070c3d826995BD175c0",
    loanToken: {
      address: "0xA0b86991c6218b36c1d19D4a2e9Eb0cE3606eB48",
      symbol: "USDC",
    },
    collateralToken: {
      address: "0x88887bE419578051FF9F4eb6C858A951921D8888",
      symbol: "stcUSD",
    },
  },
  {
    id: "0x69ef7fd17b42cd7df6d885aee1b11380837afbc1664b25587041cf193b31617b",
    name: "USDC / PT-USDat-27AUG2026",
    irm: "0x870aC11D48B15DB9a138Cf899d20F13F79Ba00BC",
    lltv: "915000000000000000",
    oracle: "0xDA25BFf53bF9E12c728Cd83Ff9Fc22c581f564CD",
    loanToken: {
      address: "0xA0b86991c6218b36c1d19D4a2e9Eb0cE3606eB48",
      symbol: "USDC",
    },
    collateralToken: {
      address: "0x1D69402390657308C91179aa184bF992908c1e08",
      symbol: "PT-USDat-27AUG2026",
    },
  },
  {
    id: "0xdf6ca97d41975a6996e9db491cb38152b65d7c00807dfe15d95d8d76e5d122e0",
    name: "USDT / PT-sUSDD-27AUG2026",
    irm: "0x870aC11D48B15DB9a138Cf899d20F13F79Ba00BC",
    lltv: "915000000000000000",
    oracle: "0x1F96824a00DD81bF4694471d1F0741E6A4de0cc2",
    loanToken: {
      address: "0xdAC17F958D2ee523a2206206994597C13D831ec7",
      symbol: "USDT",
    },
    collateralToken: {
      address: "0xD341A146A4fD20eA89898E4d86Ae1829bF3A1c23",
      symbol: "PT-sUSDD-27AUG2026",
    },
  },
  {
    id: "0x755f954513d31d5f24aaf3d0cdc5e913a28383f8ea8ff85be9ffffa7371fb64d",
    name: "USDC / PRIME",
    irm: "0x870aC11D48B15DB9a138Cf899d20F13F79Ba00BC",
    lltv: "860000000000000000",
    oracle: "0x999eFF9cA63D23A60A0Cd19B9F65A0918674119a",
    loanToken: {
      address: "0xA0b86991c6218b36c1d19D4a2e9Eb0cE3606eB48",
      symbol: "USDC",
    },
    collateralToken: {
      address: "0x19ebb35279A16207Ec4ba82799CC64715065F7F6",
      symbol: "PRIME",
    },
  },
  {
    id: "0x09dc9e7eb5d8fc54b2bc41d1135fd4e99057a580f680321faeb90c7a21e631c1",
    name: "USDC / WBTC",
    irm: "0x870aC11D48B15DB9a138Cf899d20F13F79Ba00BC",
    lltv: "860000000000000000",
    oracle: "0xf1561bC4b3D1bA49053986Fb9ee88D4fE22d0Cf4",
    loanToken: {
      address: "0xA0b86991c6218b36c1d19D4a2e9Eb0cE3606eB48",
      symbol: "USDC",
    },
    collateralToken: {
      address: "0x2260FAC5E5542a773Aa44fBCfeDf7C193bc2C599",
      symbol: "WBTC",
    },
  },
  {
    id: "0xb7843fe78e7e7fd3106a1b939645367967d1f986c2e45edb8932ad1896450877",
    name: "USDT / XAUt",
    irm: "0x870aC11D48B15DB9a138Cf899d20F13F79Ba00BC",
    lltv: "770000000000000000",
    oracle: "0xc7d1FE3fBe90e8f755250CA3Ce4d2aE50873d9dc",
    loanToken: {
      address: "0xdAC17F958D2ee523a2206206994597C13D831ec7",
      symbol: "USDT",
    },
    collateralToken: {
      address: "0x68749665FF8D2d112Fa859AA293F07A622782F38",
      symbol: "XAUt",
    },
  },
  {
    id: "0x908b037029b5c0671ba3b362eaf289c3199560d1d4632e6cb527cc7240fa006e",
    name: "USDC / PT-apxUSD-5NOV2026",
    irm: "0x870aC11D48B15DB9a138Cf899d20F13F79Ba00BC",
    lltv: "860000000000000000",
    oracle: "0xFb8B9A1b92B0F6CC3bb940F6CA670ca7dA455f9d",
    loanToken: {
      address: "0xA0b86991c6218b36c1d19D4a2e9Eb0cE3606eB48",
      symbol: "USDC",
    },
    collateralToken: {
      address: "0xAF687B5EcB525Ccea96115088999B4eD80C388b6",
      symbol: "PT-apxUSD-5NOV2026",
    },
  },
  {
    id: "0xba3ba077d9c838696b76e29a394ae9f0d1517a372e30fd9a0fc19c516fb4c5a7",
    name: "USDC / cbBTC",
    irm: "0x870aC11D48B15DB9a138Cf899d20F13F79Ba00BC",
    lltv: "860000000000000000",
    oracle: "0xc7BE7593FD5453Db5AdcC1d7103f2211d4F2e40D",
    loanToken: {
      address: "0xA0b86991c6218b36c1d19D4a2e9Eb0cE3606eB48",
      symbol: "USDC",
    },
    collateralToken: {
      address: "0xcbB7C0000aB88B473b1f5aFd9ef808440eed33Bf",
      symbol: "cbBTC",
    },
  },
  {
    id: "0xa0c6499787a7d046f91f2687558c021e2baae5a378885280a448183a926ef5f7",
    name: "USDC / upUSDC",
    irm: "0x870aC11D48B15DB9a138Cf899d20F13F79Ba00BC",
    lltv: "915000000000000000",
    oracle: "0xf2c9EE3Fdc5D1e360d51b4840B4096F63913dF93",
    loanToken: {
      address: "0xA0b86991c6218b36c1d19D4a2e9Eb0cE3606eB48",
      symbol: "USDC",
    },
    collateralToken: {
      address: "0x80E1048eDE66ec4c364b4F22C8768fc657FF6A42",
      symbol: "upUSDC",
    },
  },
  {
    id: "0x251b7cbc2c33ba4eabe3b7163ad0fdd3cfb97de80d8377f0f48b8d31aee7606f",
    name: "WETH / rETH",
    irm: "0x870aC11D48B15DB9a138Cf899d20F13F79Ba00BC",
    lltv: "945000000000000000",
    oracle: "0x837e3ceD92Aa5d045208A2Fd292a1e2DF9cFfA14",
    loanToken: {
      address: "0xC02aaA39b223FE8D0A0e5C4F27eAD9083C756Cc2",
      symbol: "WETH",
    },
    collateralToken: {
      address: "0xae78736Cd615f374D3085123A210448E74Fc6393",
      symbol: "rETH",
    },
  },
  {
    id: "0xa23d5a03779d1b54b2ea1f9224f9a5567594cf43916257514bda4344ec83466d",
    name: "USDT / USDT",
    irm: "0x870aC11D48B15DB9a138Cf899d20F13F79Ba00BC",
    lltv: "945000000000000000",
    oracle: "0x24CC84c52f15c06170c1b7cBfaeD4b9D1D1FDd55",
    loanToken: {
      address: "0xdAC17F958D2ee523a2206206994597C13D831ec7",
      symbol: "USDT",
    },
    collateralToken: {
      address: "0x3D4762b4bB4B4C922377Fe5b887E900D7fB64cDf",
      symbol: "USDT",
    },
  },
  {
    id: "0xbf02d6c6852fa0b8247d5514d0c91e6c1fbde9a168ac3fd2033028b5ee5ce6d0",
    name: "USDC / LBTC",
    irm: "0x870aC11D48B15DB9a138Cf899d20F13F79Ba00BC",
    lltv: "860000000000000000",
    oracle: "0xDCc04fFaCD7B49035cCdBbbA59a5f955944129DB",
    loanToken: {
      address: "0xA0b86991c6218b36c1d19D4a2e9Eb0cE3606eB48",
      symbol: "USDC",
    },
    collateralToken: {
      address: "0x8236a87084f8B84306f72007F36F2618A5634494",
      symbol: "LBTC",
    },
  },
  {
    id: "0x9de73bf59b4b09f9b974081c30a2570174f212ea62de8da777c7770a4832ae72",
    name: "USDC / mHYPER",
    irm: "0x870aC11D48B15DB9a138Cf899d20F13F79Ba00BC",
    lltv: "770000000000000000",
    oracle: "0xdabD6Bb1c67a911C077c4E63b1c9cf1c0b11F1C0",
    loanToken: {
      address: "0xA0b86991c6218b36c1d19D4a2e9Eb0cE3606eB48",
      symbol: "USDC",
    },
    collateralToken: {
      address: "0x9b5528528656DBC094765E2abB79F293c21191B9",
      symbol: "mHYPER",
    },
  },
  {
    id: "0x51c6fa2e3ab990af15e95a8c91e93482d7a87068c60133e1c7e8000f91ec7618",
    name: "USDC / mHyperBTC",
    irm: "0x870aC11D48B15DB9a138Cf899d20F13F79Ba00BC",
    lltv: "770000000000000000",
    oracle: "0xecE51FE8f29a514441fB5D414faD449482eAA3c1",
    loanToken: {
      address: "0xA0b86991c6218b36c1d19D4a2e9Eb0cE3606eB48",
      symbol: "USDC",
    },
    collateralToken: {
      address: "0xC8495EAFf71D3A563b906295fCF2f685b1783085",
      symbol: "mHyperBTC",
    },
  },
  {
    id: "0x3c16c2d107caade490b1d513ccc54cbd06a30f20ad6a9aaad8c744413872514a",
    name: "wstETH / ynETHx",
    irm: "0x870aC11D48B15DB9a138Cf899d20F13F79Ba00BC",
    lltv: "915000000000000000",
    oracle: "0xB1E676190A86DA2Cb99afD0496538ABe1D4C164D",
    loanToken: {
      address: "0x7f39C581F595B53c5cb19bD0b3f8dA6c935E2Ca0",
      symbol: "wstETH",
    },
    collateralToken: {
      address: "0x657d9ABA1DBb59e53f9F3eCAA878447dCfC96dCb",
      symbol: "ynETHx",
    },
  },
  {
    id: "0x0b352b7550acdb1f39fea4b8f9ef8ac2d7953613b92599610b8fbec8a98a51d1",
    name: "EURCV / wstETH",
    irm: "0x870aC11D48B15DB9a138Cf899d20F13F79Ba00BC",
    lltv: "860000000000000000",
    oracle: "0x44D6d497fb53294f283983E2931972840eb3DD90",
    loanToken: {
      address: "0x5F7827FDeb7c20b443265Fc2F40845B715385Ff2",
      symbol: "EURCV",
    },
    collateralToken: {
      address: "0x7f39C581F595B53c5cb19bD0b3f8dA6c935E2Ca0",
      symbol: "wstETH",
    },
  },
  {
    id: "0x39d11026eae1c6ec02aa4c0910778664089cdd97c3fd23f68f7cd05e2e95af48",
    name: "DAI / sUSDe",
    irm: "0x870aC11D48B15DB9a138Cf899d20F13F79Ba00BC",
    lltv: "860000000000000000",
    oracle: "0x5D916980D5Ae1737a8330Bf24dF812b2911Aae25",
    loanToken: {
      address: "0x6B175474E89094C44Da98b954EedeAC495271d0F",
      symbol: "DAI",
    },
    collateralToken: {
      address: "0x9D39A5DE30e57443BfF2A8307A4256c8797A3497",
      symbol: "sUSDe",
    },
  },
  {
    id: "0x88abdf8693e663144c3544b9442e9b04520016d6ebc57aa76424c00ab1683c9d",
    name: "RLUSD / wstETH",
    irm: "0x870aC11D48B15DB9a138Cf899d20F13F79Ba00BC",
    lltv: "860000000000000000",
    oracle: "0x4e58cea93a5252547c99D04042de646b17531653",
    loanToken: {
      address: "0x8292Bb45bf1Ee4d140127049757C2E0fF06317eD",
      symbol: "RLUSD",
    },
    collateralToken: {
      address: "0x7f39C581F595B53c5cb19bD0b3f8dA6c935E2Ca0",
      symbol: "wstETH",
    },
  },
  {
    id: "0x2a0b893471c785a1f0fda00df7fca578b703eef7ae7186d2429c2824b5212467",
    name: "USDC / wFalconX",
    irm: "0x870aC11D48B15DB9a138Cf899d20F13F79Ba00BC",
    lltv: "915000000000000000",
    oracle: "0x52eA2C12734B5bB61e1edf52Bb0f01D9206493Fc",
    loanToken: {
      address: "0xA0b86991c6218b36c1d19D4a2e9Eb0cE3606eB48",
      symbol: "USDC",
    },
    collateralToken: {
      address: "0x4614F7A56A3Eb83b2Ff9fA4B4b9575B28Fb68644",
      symbol: "wFalconX",
    },
  },
  {
    id: "0xb37c30f34bff11c81ee8400133965f450a5f7c5d81ba2cf5740076f49eabc95c",
    name: "USDC / PT-apyUSD-5NOV2026",
    irm: "0x870aC11D48B15DB9a138Cf899d20F13F79Ba00BC",
    lltv: "860000000000000000",
    oracle: "0x100187B3074116255c5C644eAd561E920f654E65",
    loanToken: {
      address: "0xA0b86991c6218b36c1d19D4a2e9Eb0cE3606eB48",
      symbol: "USDC",
    },
    collateralToken: {
      address: "0xb5Be35D8fF83D431899b95851CB17a2B4bcEF150",
      symbol: "PT-apyUSD-5NOV2026",
    },
  },
  {
    id: "0xce68c7aa336675e42bbc8eaa8b5ecc7ebd816bf8625b5316330c6ac2dabc4cf2",
    name: "WBTC / SolvBTC",
    irm: "0x870aC11D48B15DB9a138Cf899d20F13F79Ba00BC",
    lltv: "945000000000000000",
    oracle: "0xB8e05308cAB856Da6aaD922860cf9cE87Be2413a",
    loanToken: {
      address: "0x2260FAC5E5542a773Aa44fBCfeDf7C193bc2C599",
      symbol: "WBTC",
    },
    collateralToken: {
      address: "0x7A56E1C57C7475CCf742a1832B028F0456652F97",
      symbol: "SolvBTC",
    },
  },
  {
    id: "0xf02d2e8f427a2b91785b3d09690ef9d3811bf674ba97b00bafc7665004a6dd97",
    name: "USDC / PT-sUSDD-27AUG2026",
    irm: "0x870aC11D48B15DB9a138Cf899d20F13F79Ba00BC",
    lltv: "915000000000000000",
    oracle: "0x208C784A15347bF51919C0850ae869ca764B595D",
    loanToken: {
      address: "0xA0b86991c6218b36c1d19D4a2e9Eb0cE3606eB48",
      symbol: "USDC",
    },
    collateralToken: {
      address: "0xD341A146A4fD20eA89898E4d86Ae1829bF3A1c23",
      symbol: "PT-sUSDD-27AUG2026",
    },
  },
  {
    id: "0x7a25fb17b8bd83a934ad87d9d1725188fc129992ca816f3145b4ab7f673c98c3",
    name: "EURCV / wstETH",
    irm: "0x870aC11D48B15DB9a138Cf899d20F13F79Ba00BC",
    lltv: "860000000000000000",
    oracle: "0xF13B2929b84fA6da4855942B2ea60E82B080C5a1",
    loanToken: {
      address: "0x5F7827FDeb7c20b443265Fc2F40845B715385Ff2",
      symbol: "EURCV",
    },
    collateralToken: {
      address: "0x7f39C581F595B53c5cb19bD0b3f8dA6c935E2Ca0",
      symbol: "wstETH",
    },
  },
  {
    id: "0xe3df58f9d3011b7481ff36b939fa5f8da642f34ea5792d25d3958dbf1efa26d7",
    name: "USDC / USD3",
    irm: "0x870aC11D48B15DB9a138Cf899d20F13F79Ba00BC",
    lltv: "915000000000000000",
    oracle: "0x68b4c2B2b2e245AB54a3bD55DfD5A9d84f029C06",
    loanToken: {
      address: "0xA0b86991c6218b36c1d19D4a2e9Eb0cE3606eB48",
      symbol: "USDC",
    },
    collateralToken: {
      address: "0x056B269Eb1f75477a8666ae8C7fE01b64dD55eCc",
      symbol: "USD3",
    },
  },
  {
    id: "0xf4e9fb49e95a34320aea8b5e0ef515391a72368c39bdcf8ad8910645fd6eab97",
    name: "USDC / syzUSD",
    irm: "0x870aC11D48B15DB9a138Cf899d20F13F79Ba00BC",
    lltv: "915000000000000000",
    oracle: "0x0604084149dCB25a1739899624333D69dB1A507e",
    loanToken: {
      address: "0xA0b86991c6218b36c1d19D4a2e9Eb0cE3606eB48",
      symbol: "USDC",
    },
    collateralToken: {
      address: "0x6DFF69eb720986E98Bb3E8b26cb9E02Ec1a35D12",
      symbol: "syzUSD",
    },
  },
  {
    id: "0x5f8a138ba332398a9116910f4d5e5dcd9b207024c5290ce5bc87bc2dbd8e4a86",
    name: "WETH / ETH+",
    irm: "0x870aC11D48B15DB9a138Cf899d20F13F79Ba00BC",
    lltv: "945000000000000000",
    oracle: "0x0705CDc1e56f837D7F97Bc2bAE36bE3670dA02C0",
    loanToken: {
      address: "0xC02aaA39b223FE8D0A0e5C4F27eAD9083C756Cc2",
      symbol: "WETH",
    },
    collateralToken: {
      address: "0xE72B141DF173b999AE7c1aDcbF60Cc9833Ce56a8",
      symbol: "ETH+",
    },
  },
  {
    id: "0x4bb22a5f6313fc9d7b5e1438967bfcd0a513a839d26662dd8d235629942400e2",
    name: "USDC / PT-sUSDat-27AUG2026",
    irm: "0x870aC11D48B15DB9a138Cf899d20F13F79Ba00BC",
    lltv: "915000000000000000",
    oracle: "0x4FcF6507b4a9ed8b174AB2aFE51340f506DfbB39",
    loanToken: {
      address: "0xA0b86991c6218b36c1d19D4a2e9Eb0cE3606eB48",
      symbol: "USDC",
    },
    collateralToken: {
      address: "0xc689f76F90FE1762faC55983Ff25ae71033A84F7",
      symbol: "PT-sUSDat-27AUG2026",
    },
  },
  {
    id: "0x7421c2741e064e8c53fcb5de9faf7f0025dce75bc1caf26774dd878291c81dac",
    name: "EURC / wstETH",
    irm: "0x870aC11D48B15DB9a138Cf899d20F13F79Ba00BC",
    lltv: "860000000000000000",
    oracle: "0x6Eb9F4128CeBc8B885A4d8562Db1Addf097f7348",
    loanToken: {
      address: "0x1aBaEA1f7C830bD89Acc67eC4af516284b1bC33c",
      symbol: "EURC",
    },
    collateralToken: {
      address: "0x7f39C581F595B53c5cb19bD0b3f8dA6c935E2Ca0",
      symbol: "wstETH",
    },
  },
  {
    id: "0x12cacbbd1c88513cce13d54927f5f1301335779353817bc5e791e71d200f2199",
    name: "USDS / WETH",
    irm: "0x870aC11D48B15DB9a138Cf899d20F13F79Ba00BC",
    lltv: "860000000000000000",
    oracle: "0x76b2242ea5BE1FCBBF4206EA09601EA5aB22Af4d",
    loanToken: {
      address: "0xdC035D45d973E3EC169d2276DDab16f1e407384F",
      symbol: "USDS",
    },
    collateralToken: {
      address: "0xC02aaA39b223FE8D0A0e5C4F27eAD9083C756Cc2",
      symbol: "WETH",
    },
  },
  {
    id: "0xacc49fbf58feb1ac971acce68f8adc177c43682d6a7087bbd4991a05cb7a2c67",
    name: "USDC / srRoyUSDC",
    irm: "0x870aC11D48B15DB9a138Cf899d20F13F79Ba00BC",
    lltv: "915000000000000000",
    oracle: "0x86A807dc5E689F78e280B18413001Ca0c2426Ab0",
    loanToken: {
      address: "0xA0b86991c6218b36c1d19D4a2e9Eb0cE3606eB48",
      symbol: "USDC",
    },
    collateralToken: {
      address: "0xcD9f5907F92818bC06c9Ad70217f089E190d2a32",
      symbol: "srRoyUSDC",
    },
  },
  {
    id: "0xae60b71b407e0517ead445b7113a7ffa07ea4a9379d526ade541a3e9ec777cb4",
    name: "USDC / sNUSD",
    irm: "0x870aC11D48B15DB9a138Cf899d20F13F79Ba00BC",
    lltv: "915000000000000000",
    oracle: "0x28E82e7f25DbcD487af27C80DE4F62553260fecA",
    loanToken: {
      address: "0xA0b86991c6218b36c1d19D4a2e9Eb0cE3606eB48",
      symbol: "USDC",
    },
    collateralToken: {
      address: "0x08EFCC2F3e61185D0EA7F8830B3FEc9Bfa2EE313",
      symbol: "sNUSD",
    },
  },
  {
    id: "0x138eec0e4a1937eb92ebc70043ed539661dd7ed5a89fb92a720b341650288a40",
    name: "WETH / WBTC",
    irm: "0x870aC11D48B15DB9a138Cf899d20F13F79Ba00BC",
    lltv: "915000000000000000",
    oracle: "0xc29B3Bc033640baE31ca53F8a0Eb892AdF68e663",
    loanToken: {
      address: "0xC02aaA39b223FE8D0A0e5C4F27eAD9083C756Cc2",
      symbol: "WETH",
    },
    collateralToken: {
      address: "0x2260FAC5E5542a773Aa44fBCfeDf7C193bc2C599",
      symbol: "WBTC",
    },
  },
  {
    id: "0x42c2b592fc759fad461fb5c80d5ea214a496f70d8594398d69af68c2f3798de6",
    name: "USDC / PT-srUSDat-27AUG2026",
    irm: "0x870aC11D48B15DB9a138Cf899d20F13F79Ba00BC",
    lltv: "915000000000000000",
    oracle: "0x32966C34D92BA0d7E34206E4674b12460CeD32D7",
    loanToken: {
      address: "0xA0b86991c6218b36c1d19D4a2e9Eb0cE3606eB48",
      symbol: "USDC",
    },
    collateralToken: {
      address: "0x2D433b943FB8c015AE409444B7F960ED288082b4",
      symbol: "PT-srUSDat-27AUG2026",
    },
  },
  {
    id: "0x0a834fe24f42cf9cbf0644926c5637a9da42dbfae8c4c4ca0c2f2d9c712896d3",
    name: "USDC / wbravUSDC",
    irm: "0x870aC11D48B15DB9a138Cf899d20F13F79Ba00BC",
    lltv: "860000000000000000",
    oracle: "0x6BAC818dF5654eA824cE723de51d7C7d9fD2f4FF",
    loanToken: {
      address: "0xA0b86991c6218b36c1d19D4a2e9Eb0cE3606eB48",
      symbol: "USDC",
    },
    collateralToken: {
      address: "0x7309E1E2e74af170c69bdE8FCB30397f8697D5FF",
      symbol: "wbravUSDC",
    },
  },
  {
    id: "0x32e253d33f1594a67fc6ef51bf7a39cc4bf2d14904998dee769706fcde489ed9",
    name: "USDC / wsrUSD",
    irm: "0x870aC11D48B15DB9a138Cf899d20F13F79Ba00BC",
    lltv: "915000000000000000",
    oracle: "0x938D2eDb20425cF80F008E7ec314Eb456940Da15",
    loanToken: {
      address: "0xA0b86991c6218b36c1d19D4a2e9Eb0cE3606eB48",
      symbol: "USDC",
    },
    collateralToken: {
      address: "0xd3fD63209FA2D55B07A0f6db36C2f43900be3094",
      symbol: "wsrUSD",
    },
  },
  {
    id: "0x9972be1fc530a3f5a34db25ee8ab4962cc4099cb65b2db22897c92cc9d22f59f",
    name: "USDC / sDOLA",
    irm: "0x870aC11D48B15DB9a138Cf899d20F13F79Ba00BC",
    lltv: "915000000000000000",
    oracle: "0xE661712f6bf8b7E444484DB428f495D7D4ecE3A3",
    loanToken: {
      address: "0xA0b86991c6218b36c1d19D4a2e9Eb0cE3606eB48",
      symbol: "USDC",
    },
    collateralToken: {
      address: "0xb45ad160634c528Cc3D2926d9807104FA3157305",
      symbol: "sDOLA",
    },
  },
  {
    id: "0x58b332ca359ff83620416be363c874947c2d1ae7b5913d367ed761d1ad422b19",
    name: "msETH / weETH",
    irm: "0x870aC11D48B15DB9a138Cf899d20F13F79Ba00BC",
    lltv: "915000000000000000",
    oracle: "0xbDd2F2D473E8D63d1BFb0185B5bDB8046ca48a72",
    loanToken: {
      address: "0x64351fC9810aDAd17A690E4e1717Df5e7e085160",
      symbol: "msETH",
    },
    collateralToken: {
      address: "0xCd5fE23C85820F7B72D0926FC9b05b43E359b7ee",
      symbol: "weETH",
    },
  },
  {
    id: "0x2cbfb38723a8d9a2ad1607015591a78cfe3a5949561b39bde42c242b22874ec0",
    name: "WETH / cbBTC",
    irm: "0x870aC11D48B15DB9a138Cf899d20F13F79Ba00BC",
    lltv: "915000000000000000",
    oracle: "0x8F653cCFEbA16cF2c0B0D16bc82Bd6756C64f5D4",
    loanToken: {
      address: "0xC02aaA39b223FE8D0A0e5C4F27eAD9083C756Cc2",
      symbol: "WETH",
    },
    collateralToken: {
      address: "0xcbB7C0000aB88B473b1f5aFd9ef808440eed33Bf",
      symbol: "cbBTC",
    },
  },
  {
    id: "0x1cfdc0154ae6b9f1887a8250f2582d55606e1a2008e65108fb83dd50a928593e",
    name: "USDC / PT-RLP-9APR2026",
    irm: "0x870aC11D48B15DB9a138Cf899d20F13F79Ba00BC",
    lltv: "860000000000000000",
    oracle: "0x89C3Dd5E0c78136EfE412e57CC05A7835EF9F501",
    loanToken: {
      address: "0xA0b86991c6218b36c1d19D4a2e9Eb0cE3606eB48",
      symbol: "USDC",
    },
    collateralToken: {
      address: "0x29fD7180E5cCEd14Ad148c7997e6B6857a8BE86e",
      symbol: "PT-RLP-9APR2026",
    },
  },
  {
    id: "0x80c97dd236bafc6c5e41e84797efea2853511455f189525a8df70826a38cb282",
    name: "EURCV / WBTC",
    irm: "0x870aC11D48B15DB9a138Cf899d20F13F79Ba00BC",
    lltv: "860000000000000000",
    oracle: "0xd9547692d9a01cB10D9CF4Bf41381355A6570415",
    loanToken: {
      address: "0x5F7827FDeb7c20b443265Fc2F40845B715385Ff2",
      symbol: "EURCV",
    },
    collateralToken: {
      address: "0x2260FAC5E5542a773Aa44fBCfeDf7C193bc2C599",
      symbol: "WBTC",
    },
  },
  {
    id: "0x1247f1c237eceae0602eab1470a5061a6dd8f734ba88c7cdc5d6109fb0026b28",
    name: "DAI / sUSDe",
    irm: "0x870aC11D48B15DB9a138Cf899d20F13F79Ba00BC",
    lltv: "915000000000000000",
    oracle: "0x5D916980D5Ae1737a8330Bf24dF812b2911Aae25",
    loanToken: {
      address: "0x6B175474E89094C44Da98b954EedeAC495271d0F",
      symbol: "DAI",
    },
    collateralToken: {
      address: "0x9D39A5DE30e57443BfF2A8307A4256c8797A3497",
      symbol: "sUSDe",
    },
  },
  {
    id: "0x8e7cc042d739a365c43d0a52d5f24160fa7ae9b7e7c9a479bd02a56041d4cf77",
    name: "USDC / USR",
    irm: "0x870aC11D48B15DB9a138Cf899d20F13F79Ba00BC",
    lltv: "915000000000000000",
    oracle: "0x8875ceb24E656FCA062759BDCF870F59A2B0187b",
    loanToken: {
      address: "0xA0b86991c6218b36c1d19D4a2e9Eb0cE3606eB48",
      symbol: "USDC",
    },
    collateralToken: {
      address: "0x66a1E37c9b0eAddca17d3662D6c05F4DECf3e110",
      symbol: "USR",
    },
  },
  {
    id: "0x124ddf1fa02a94085d1fcc35c46c7e180ddb8a0d3ec1181cf67a75341501c9e6",
    name: "PYUSD / wstETH",
    irm: "0x870aC11D48B15DB9a138Cf899d20F13F79Ba00BC",
    lltv: "860000000000000000",
    oracle: "0x27679a17b7419fB10Bd9D143f21407760fdA5C53",
    loanToken: {
      address: "0x6c3ea9036406852006290770BEdFcAbA0e23A0e8",
      symbol: "PYUSD",
    },
    collateralToken: {
      address: "0x7f39C581F595B53c5cb19bD0b3f8dA6c935E2Ca0",
      symbol: "wstETH",
    },
  },
  {
    id: "0xe4cfbee9af4ad713b41bf79f009ca02b17c001a0c0e7bd2e6a89b1111b3d3f08",
    name: "USDC / tBTC",
    irm: "0x870aC11D48B15DB9a138Cf899d20F13F79Ba00BC",
    lltv: "770000000000000000",
    oracle: "0x57bfdF6aB73995C5af58A95A16798190e366CA5b",
    loanToken: {
      address: "0xA0b86991c6218b36c1d19D4a2e9Eb0cE3606eB48",
      symbol: "USDC",
    },
    collateralToken: {
      address: "0x18084fbA666a33d37592fA2633fD49a74DD93a88",
      symbol: "tBTC",
    },
  },
  {
    id: "0x6a57d77b9a173c5ed10d432e7009dd1ee9a97fac62a7bc970b4bd715e2fff5c8",
    name: "USDT / wstETH",
    irm: "0x870aC11D48B15DB9a138Cf899d20F13F79Ba00BC",
    lltv: "860000000000000000",
    oracle: "0xe087AD7FE989cF63F8383579D160a20Ee7e69F9F",
    loanToken: {
      address: "0xdAC17F958D2ee523a2206206994597C13D831ec7",
      symbol: "USDT",
    },
    collateralToken: {
      address: "0x7f39C581F595B53c5cb19bD0b3f8dA6c935E2Ca0",
      symbol: "wstETH",
    },
  },
  {
    id: "0x43e925e52d7873fa8acac90dd5f246087d55b3a34c344b71884a6352491ff459",
    name: "USDC / fxSAVE",
    irm: "0x870aC11D48B15DB9a138Cf899d20F13F79Ba00BC",
    lltv: "860000000000000000",
    oracle: "0x16931Dcc888754Ae780B153598376a6474DE4440",
    loanToken: {
      address: "0xA0b86991c6218b36c1d19D4a2e9Eb0cE3606eB48",
      symbol: "USDC",
    },
    collateralToken: {
      address: "0x7743e50F534a7f9F1791DdE7dCD89F7783Eefc39",
      symbol: "fxSAVE",
    },
  },
  {
    id: "0x5eaaebc81e9e27972ab458811d1b60828e8ab51ef6620f9b3918fd7e68eecec1",
    name: "USDT / PT-stcUSD-23JUL2026",
    irm: "0x870aC11D48B15DB9a138Cf899d20F13F79Ba00BC",
    lltv: "915000000000000000",
    oracle: "0x11aEFbf08bAB2b3f3141c2CC4749A638c4c3b674",
    loanToken: {
      address: "0xdAC17F958D2ee523a2206206994597C13D831ec7",
      symbol: "USDT",
    },
    collateralToken: {
      address: "0x2d3C279E5FcDF5b793c0a75ed90738D7369B0b83",
      symbol: "PT-stcUSD-23JUL2026",
    },
  },
  {
    id: "0x710f02caee4555b8ff75b7d48e5b52adc48898dc0c670b977fb1ea83bf4e7d8a",
    name: "USDT / stUSDS",
    irm: "0x870aC11D48B15DB9a138Cf899d20F13F79Ba00BC",
    lltv: "860000000000000000",
    oracle: "0x9C56D403d26C0aE00FA2e767e12F6b588c203B3c",
    loanToken: {
      address: "0xdAC17F958D2ee523a2206206994597C13D831ec7",
      symbol: "USDT",
    },
    collateralToken: {
      address: "0x99CD4Ec3f88A45940936F469E4bB72A2A701EEB9",
      symbol: "stUSDS",
    },
  },
  {
    id: "0xf6a056627a51e511ec7f48332421432ea6971fc148d8f3c451e14ea108026549",
    name: "WBTC / LBTC",
    irm: "0x870aC11D48B15DB9a138Cf899d20F13F79Ba00BC",
    lltv: "945000000000000000",
    oracle: "0xa98105B8227E0f2157816Feb7A331364A9B74F80",
    loanToken: {
      address: "0x2260FAC5E5542a773Aa44fBCfeDf7C193bc2C599",
      symbol: "WBTC",
    },
    collateralToken: {
      address: "0x8236a87084f8B84306f72007F36F2618A5634494",
      symbol: "LBTC",
    },
  },
  {
    id: "0x461da96754b33fec844fc5e5718bf24298a2c832d8216c5ffd17a5230548f01f",
    name: "eUSD / WBTC",
    irm: "0x870aC11D48B15DB9a138Cf899d20F13F79Ba00BC",
    lltv: "860000000000000000",
    oracle: "0x032F1C64899b2C89835E51aCeD9434b0aDEaA69d",
    loanToken: {
      address: "0xA0d69E286B938e21CBf7E51D71F6A4c8918f482F",
      symbol: "eUSD",
    },
    collateralToken: {
      address: "0x2260FAC5E5542a773Aa44fBCfeDf7C193bc2C599",
      symbol: "WBTC",
    },
  },
  {
    id: "0x9bd88295d990d547adbc2a423d2fa7ced972e6c062226a009cc102dcb5d74eb2",
    name: "USDC / ILLIQUID_PERPDEX_COLL",
    irm: "0x870aC11D48B15DB9a138Cf899d20F13F79Ba00BC",
    lltv: "945000000000000000",
    oracle: "0x6779b2F08611906FcE70c70c596e05859701235d",
    loanToken: {
      address: "0xA0b86991c6218b36c1d19D4a2e9Eb0cE3606eB48",
      symbol: "USDC",
    },
    collateralToken: {
      address: "0x610209DAbf47375307Bb2A3263F85440Eedc7834",
      symbol: "ILLIQUID_PERPDEX_COLL",
    },
  },
  {
    id: "0x78e99fb97b709b77bf76ac955212bbaab9e19ee44799c8fe4826bb129cabae09",
    name: "USDC / rRLP",
    irm: "0x870aC11D48B15DB9a138Cf899d20F13F79Ba00BC",
    lltv: "860000000000000000",
    oracle: "0xD4F41C6DF780bb143Ec5b4B02ffc5fAC73d764b1",
    loanToken: {
      address: "0xA0b86991c6218b36c1d19D4a2e9Eb0cE3606eB48",
      symbol: "USDC",
    },
    collateralToken: {
      address: "0x64688b6E895a64C3584FF1420d4119342558A504",
      symbol: "rRLP",
    },
  },
  {
    id: "0x975feca64f09bc115acf99f33ed30e799e22217fbb3d6f447e1a43c6ac2386a8",
    name: "USDC / mM1-USD",
    irm: "0x870aC11D48B15DB9a138Cf899d20F13F79Ba00BC",
    lltv: "860000000000000000",
    oracle: "0x72D028037d6B4dE722370ac6e9EEED5eDe9cF0A0",
    loanToken: {
      address: "0xA0b86991c6218b36c1d19D4a2e9Eb0cE3606eB48",
      symbol: "USDC",
    },
    collateralToken: {
      address: "0xCc5C22C7A6BCC25e66726AeF011dDE74289ED203",
      symbol: "mM1-USD",
    },
  },
  {
    id: "0x8e6aeb10c401de3279ac79b4b2ea15fc94b7d9cfc098d6c2a1ff7b2b26d9d02c",
    name: "DAI / USDe",
    irm: "0x870aC11D48B15DB9a138Cf899d20F13F79Ba00BC",
    lltv: "915000000000000000",
    oracle: "0xaE4750d0813B5E37A51f7629beedd72AF1f9cA35",
    loanToken: {
      address: "0x6B175474E89094C44Da98b954EedeAC495271d0F",
      symbol: "DAI",
    },
    collateralToken: {
      address: "0x4c9EDD5852cd905f086C759E8383e09bff1E68B3",
      symbol: "USDe",
    },
  },
  {
    id: "0xc9098061d437a9dd53b0070cb33df6fca1a0a5ead288588c88699b0420c1c078",
    name: "msUSD / sUSDe",
    irm: "0x870aC11D48B15DB9a138Cf899d20F13F79Ba00BC",
    lltv: "915000000000000000",
    oracle: "0x5D916980D5Ae1737a8330Bf24dF812b2911Aae25",
    loanToken: {
      address: "0xab5eB14c09D416F0aC63661E57EDB7AEcDb9BEfA",
      symbol: "msUSD",
    },
    collateralToken: {
      address: "0x9D39A5DE30e57443BfF2A8307A4256c8797A3497",
      symbol: "sUSDe",
    },
  },
  {
    id: "0xa7cff07327839b03b2f0355d0951bb487cd8deeef9a21dfc851a8a3d932c42b8",
    name: "USDC / n-st-liUSD4w",
    irm: "0x870aC11D48B15DB9a138Cf899d20F13F79Ba00BC",
    lltv: "860000000000000000",
    oracle: "0x9FB57943926749B49a644F237A28b491c9b465E0",
    loanToken: {
      address: "0xA0b86991c6218b36c1d19D4a2e9Eb0cE3606eB48",
      symbol: "USDC",
    },
    collateralToken: {
      address: "0x9FB57943926749B49a644F237A28b491c9b465E0",
      symbol: "n-st-liUSD4w",
    },
  },
  {
    id: "0xdc5333039bcf15f1237133f74d5806675d83d9cf19cfd4cfdd9be674842651bf",
    name: "USDT / sUSDe",
    irm: "0x870aC11D48B15DB9a138Cf899d20F13F79Ba00BC",
    lltv: "915000000000000000",
    oracle: "0xE47E36457D0cF83A74AE1e45382B7A044f7abd99",
    loanToken: {
      address: "0xdAC17F958D2ee523a2206206994597C13D831ec7",
      symbol: "USDT",
    },
    collateralToken: {
      address: "0x9D39A5DE30e57443BfF2A8307A4256c8797A3497",
      symbol: "sUSDe",
    },
  },
  {
    id: "0xc2ab3fb4c64dc05d69a833cbedb82d6869d05135f3a164c0c7b844c8f0a3a220",
    name: "WBTC / sBTCD",
    irm: "0x870aC11D48B15DB9a138Cf899d20F13F79Ba00BC",
    lltv: "770000000000000000",
    oracle: "0x332ebF042a7B7D87A8a2628186f8A5B12d8a6d94",
    loanToken: {
      address: "0x2260FAC5E5542a773Aa44fBCfeDf7C193bc2C599",
      symbol: "WBTC",
    },
    collateralToken: {
      address: "0x3BC801419479865B24b4d32faB0Bf64638Abbd5f",
      symbol: "sBTCD",
    },
  },
  {
    id: "0x031c7333014af51e4fd18031d14e4eaada58348cde3f6dc6ea8cca16f7387fb2",
    name: "USDC / mAPOLLO",
    irm: "0x870aC11D48B15DB9a138Cf899d20F13F79Ba00BC",
    lltv: "860000000000000000",
    oracle: "0xCA72269A34E2C2BEFe9dDa14AfEB7B5C0021a316",
    loanToken: {
      address: "0xA0b86991c6218b36c1d19D4a2e9Eb0cE3606eB48",
      symbol: "USDC",
    },
    collateralToken: {
      address: "0x7CF9DEC92ca9FD46f8d86e7798B72624Bc116C05",
      symbol: "mAPOLLO",
    },
  },
  {
    id: "0x702b7ec7628de2622e51e1bb34a7e6ad9e95f3a25a2ed361e4ce621f23f5e642",
    name: "USDC / PT-cUSD-23JUL2026",
    irm: "0x870aC11D48B15DB9a138Cf899d20F13F79Ba00BC",
    lltv: "915000000000000000",
    oracle: "0x25b30502467639E8FA118451105269e9B9813DD2",
    loanToken: {
      address: "0xA0b86991c6218b36c1d19D4a2e9Eb0cE3606eB48",
      symbol: "USDC",
    },
    collateralToken: {
      address: "0x928FB6ED39100a92B2480f5cbB93453f98D9F4cE",
      symbol: "PT-cUSD-23JUL2026",
    },
  },
  {
    id: "0xeea9a2431eba248f1cc4d8d3d2a34b31cbf4884ecc602f9270372f892a2ba185",
    name: "PYUSD / PAXG",
    irm: "0x870aC11D48B15DB9a138Cf899d20F13F79Ba00BC",
    lltv: "770000000000000000",
    oracle: "0xa0514F4035F013941cf63C203dCED759C95CFACE",
    loanToken: {
      address: "0x6c3ea9036406852006290770BEdFcAbA0e23A0e8",
      symbol: "PYUSD",
    },
    collateralToken: {
      address: "0x45804880De22913dAFE09f4980848ECE6EcbAf78",
      symbol: "PAXG",
    },
  },
  {
    id: "0x6d95bf5fad1b0427205ee2b595f80b52e22394173de0832efa79fde88abb8525",
    name: "USDC / MORPHO",
    irm: "0x870aC11D48B15DB9a138Cf899d20F13F79Ba00BC",
    lltv: "625000000000000000",
    oracle: "0xEEcD66e6C723c1506532a5f646cC8a502c026A2E",
    loanToken: {
      address: "0xA0b86991c6218b36c1d19D4a2e9Eb0cE3606eB48",
      symbol: "USDC",
    },
    collateralToken: {
      address: "0x58D97B57BB95320F9a05dC918Aef65434969c2B2",
      symbol: "MORPHO",
    },
  },
  {
    id: "0x3758a9e2abbd67b5621f23ec482608f2f98b3c792874661ce49df7843aadcfd2",
    name: "USDT / WETH",
    irm: "0x870aC11D48B15DB9a138Cf899d20F13F79Ba00BC",
    lltv: "860000000000000000",
    oracle: "0x0F948CBa8231Db7898ef36A4212581Ad7b1B4580",
    loanToken: {
      address: "0xdAC17F958D2ee523a2206206994597C13D831ec7",
      symbol: "USDT",
    },
    collateralToken: {
      address: "0xC02aaA39b223FE8D0A0e5C4F27eAD9083C756Cc2",
      symbol: "WETH",
    },
  },
  {
    id: "0xc581c5f70bd1afa283eed57d1418c6432cbff1d862f94eaf58fdd4e46afbb67f",
    name: "DAI / USDe",
    irm: "0x870aC11D48B15DB9a138Cf899d20F13F79Ba00BC",
    lltv: "860000000000000000",
    oracle: "0xaE4750d0813B5E37A51f7629beedd72AF1f9cA35",
    loanToken: {
      address: "0x6B175474E89094C44Da98b954EedeAC495271d0F",
      symbol: "DAI",
    },
    collateralToken: {
      address: "0x4c9EDD5852cd905f086C759E8383e09bff1E68B3",
      symbol: "USDe",
    },
  },
  {
    id: "0xfd039edc69eac5eaab4a10463fdbcaca75d6eddb1f0e00248d73fc977fb2554b",
    name: "USDT / PT-cUSD-23JUL2026",
    irm: "0x870aC11D48B15DB9a138Cf899d20F13F79Ba00BC",
    lltv: "915000000000000000",
    oracle: "0x25b30502467639E8FA118451105269e9B9813DD2",
    loanToken: {
      address: "0xdAC17F958D2ee523a2206206994597C13D831ec7",
      symbol: "USDT",
    },
    collateralToken: {
      address: "0x928FB6ED39100a92B2480f5cbB93453f98D9F4cE",
      symbol: "PT-cUSD-23JUL2026",
    },
  },
  {
    id: "0x41b12bac98fdc74ffeb513771b0bd341a14733f57072f7236cf3730af06d7fa2",
    name: "USDC / ROY-ST-apyUSD",
    irm: "0x870aC11D48B15DB9a138Cf899d20F13F79Ba00BC",
    lltv: "915000000000000000",
    oracle: "0xfcC6676c57E70daA29478cc6633122D135cD5A6F",
    loanToken: {
      address: "0xA0b86991c6218b36c1d19D4a2e9Eb0cE3606eB48",
      symbol: "USDC",
    },
    collateralToken: {
      address: "0xBd373c9D3D8976a4FECC504a93c768BBE8C3227C",
      symbol: "ROY-ST-apyUSD",
    },
  },
  {
    id: "0xf0edbb36183591ff28c56fdb283fdd6896cf1298990e5913208902adb87d2b75",
    name: "WETH / ynETHx",
    irm: "0x870aC11D48B15DB9a138Cf899d20F13F79Ba00BC",
    lltv: "915000000000000000",
    oracle: "0xc28F86C86F79282E2d2A1f45442339C55f7eB22D",
    loanToken: {
      address: "0xC02aaA39b223FE8D0A0e5C4F27eAD9083C756Cc2",
      symbol: "WETH",
    },
    collateralToken: {
      address: "0x657d9ABA1DBb59e53f9F3eCAA878447dCfC96dCb",
      symbol: "ynETHx",
    },
  },
  {
    id: "0x9337a95dcb09d10abb33fdb955dd27b46e345f5510d54d9403f570f8f37b5983",
    name: "PYUSD / WBTC",
    irm: "0x870aC11D48B15DB9a138Cf899d20F13F79Ba00BC",
    lltv: "860000000000000000",
    oracle: "0xc53c90d6E9A5B69E4ABf3d5Ae4c79225C7FeF3d2",
    loanToken: {
      address: "0x6c3ea9036406852006290770BEdFcAbA0e23A0e8",
      symbol: "PYUSD",
    },
    collateralToken: {
      address: "0x2260FAC5E5542a773Aa44fBCfeDf7C193bc2C599",
      symbol: "WBTC",
    },
  },
  {
    id: "0xfd0d72a4f0469598b566b1bc5fe64835f828f90b1fb7d746148c086164cd4cc2",
    name: "USDC / AZND",
    irm: "0x870aC11D48B15DB9a138Cf899d20F13F79Ba00BC",
    lltv: "860000000000000000",
    oracle: "0x270B2bD4CC6d935aa08b70eAC518E2907EB5588b",
    loanToken: {
      address: "0xA0b86991c6218b36c1d19D4a2e9Eb0cE3606eB48",
      symbol: "USDC",
    },
    collateralToken: {
      address: "0x52c66B5E7f8Fde20843De900C5C8B4b0F23708A0",
      symbol: "AZND",
    },
  },
  {
    id: "0xad656d430bb3d8c1469bf45c8ad4ebae1b04be04757c69fa424eec78d7b3f4dc",
    name: "USDC / WOUSD",
    irm: "0x870aC11D48B15DB9a138Cf899d20F13F79Ba00BC",
    lltv: "915000000000000000",
    oracle: "0x7c65985C35181d51EF7571fA40211B57659b7D80",
    loanToken: {
      address: "0xA0b86991c6218b36c1d19D4a2e9Eb0cE3606eB48",
      symbol: "USDC",
    },
    collateralToken: {
      address: "0xD2af830E8CBdFed6CC11Bab697bB25496ed6FA62",
      symbol: "WOUSD",
    },
  },
  {
    id: "0x39d6cc9211d023cc16708a2378d821d394d8cfaa3640e3a4d4638d292e10035d",
    name: "WBTC / cbBTC",
    irm: "0x870aC11D48B15DB9a138Cf899d20F13F79Ba00BC",
    lltv: "945000000000000000",
    oracle: "0x3eF1F71723d633deE9834c5a7577c39B13C17aeb",
    loanToken: {
      address: "0x2260FAC5E5542a773Aa44fBCfeDf7C193bc2C599",
      symbol: "WBTC",
    },
    collateralToken: {
      address: "0xcbB7C0000aB88B473b1f5aFd9ef808440eed33Bf",
      symbol: "cbBTC",
    },
  },
  {
    id: "0xdbffac82c2dc7e8aa781bd05746530b0068d80929f23ac1628580e27810bc0c5",
    name: "USDT / WETH",
    irm: "0x870aC11D48B15DB9a138Cf899d20F13F79Ba00BC",
    lltv: "915000000000000000",
    oracle: "0xe9eE579684716c7Bb837224F4c7BeEfA4f1F3d7f",
    loanToken: {
      address: "0xdAC17F958D2ee523a2206206994597C13D831ec7",
      symbol: "USDT",
    },
    collateralToken: {
      address: "0xC02aaA39b223FE8D0A0e5C4F27eAD9083C756Cc2",
      symbol: "WETH",
    },
  },
  {
    id: "0xbc99de6a88904cd0e69042ad6f266e63182801f030c636507c3caf590ffd84fe",
    name: "USDC / cbBTC",
    irm: "0x870aC11D48B15DB9a138Cf899d20F13F79Ba00BC",
    lltv: "860000000000000000",
    oracle: "0x9F983115741D0F7F2EAE07831415057AD3de34d2",
    loanToken: {
      address: "0xA0b86991c6218b36c1d19D4a2e9Eb0cE3606eB48",
      symbol: "USDC",
    },
    collateralToken: {
      address: "0xcbB7C0000aB88B473b1f5aFd9ef808440eed33Bf",
      symbol: "cbBTC",
    },
  },
  {
    id: "0x1bd93f3ef76c3debad2b6023291af6a81125e71adfe775c2177afd7b79f7e41e",
    name: "USDT / PT-srUSDe-25JUN2026",
    irm: "0x870aC11D48B15DB9a138Cf899d20F13F79Ba00BC",
    lltv: "915000000000000000",
    oracle: "0x20358B3340D8400Df30B1177e9EcDbB0FF2c19Ab",
    loanToken: {
      address: "0xdAC17F958D2ee523a2206206994597C13D831ec7",
      symbol: "USDT",
    },
    collateralToken: {
      address: "0x619D75E3b790eBC21c289f2805Bb7177A7D732E2",
      symbol: "PT-srUSDe-25JUN2026",
    },
  },
  {
    id: "0xc2c53d2b868e163da71de14a5113cc2743fc9b5ad7488334720ed2846566a8f6",
    name: "USDT / weETH",
    irm: "0x870aC11D48B15DB9a138Cf899d20F13F79Ba00BC",
    lltv: "860000000000000000",
    oracle: "0x631bEa187ae9D90B76ccf91aa8F5E3EE1cDc0F87",
    loanToken: {
      address: "0xdAC17F958D2ee523a2206206994597C13D831ec7",
      symbol: "USDT",
    },
    collateralToken: {
      address: "0xCd5fE23C85820F7B72D0926FC9b05b43E359b7ee",
      symbol: "weETH",
    },
  },
  {
    id: "0xe475337d11be1db07f7c5a156e511f05d1844308e66e17d2ba5da0839d3b34d9",
    name: "DAI / sUSDe",
    irm: "0x870aC11D48B15DB9a138Cf899d20F13F79Ba00BC",
    lltv: "945000000000000000",
    oracle: "0x5D916980D5Ae1737a8330Bf24dF812b2911Aae25",
    loanToken: {
      address: "0x6B175474E89094C44Da98b954EedeAC495271d0F",
      symbol: "DAI",
    },
    collateralToken: {
      address: "0x9D39A5DE30e57443BfF2A8307A4256c8797A3497",
      symbol: "sUSDe",
    },
  },
  {
    id: "0x2fb3713487c7812e7309935b034f40228841666f6b048faf31fd2110ae674f20",
    name: "USDC / PT-stcUSD-23JUL2026",
    irm: "0x870aC11D48B15DB9a138Cf899d20F13F79Ba00BC",
    lltv: "915000000000000000",
    oracle: "0x11aEFbf08bAB2b3f3141c2CC4749A638c4c3b674",
    loanToken: {
      address: "0xA0b86991c6218b36c1d19D4a2e9Eb0cE3606eB48",
      symbol: "USDC",
    },
    collateralToken: {
      address: "0x2d3C279E5FcDF5b793c0a75ed90738D7369B0b83",
      symbol: "PT-stcUSD-23JUL2026",
    },
  },
  {
    id: "0xa0534c78620867b7c8706e3b6df9e69a2bc67c783281b7a77e034ed75cee012e",
    name: "WETH / ezETH",
    irm: "0x870aC11D48B15DB9a138Cf899d20F13F79Ba00BC",
    lltv: "945000000000000000",
    oracle: "0x94f93f1eADb8a2f73C415AD4C19cB791e6D0192b",
    loanToken: {
      address: "0xC02aaA39b223FE8D0A0e5C4F27eAD9083C756Cc2",
      symbol: "WETH",
    },
    collateralToken: {
      address: "0xbf5495Efe5DB9ce00f80364C8B423567e58d2110",
      symbol: "ezETH",
    },
  },
  {
    id: "0x03f715ef1ae508ab3e1faf4dffdbf2a077d1f0ad10c5aad42cf4438d5e3328af",
    name: "USDC / PT-stcUSD-29JAN2026",
    irm: "0x870aC11D48B15DB9a138Cf899d20F13F79Ba00BC",
    lltv: "915000000000000000",
    oracle: "0xC86CfE9dE224bf0A14Ea83949591a54467BE647D",
    loanToken: {
      address: "0xA0b86991c6218b36c1d19D4a2e9Eb0cE3606eB48",
      symbol: "USDC",
    },
    collateralToken: {
      address: "0xC3c7E5E277d31CD24a3Ac4cC9af3B6770F30eA33",
      symbol: "PT-stcUSD-29JAN2026",
    },
  },
  {
    id: "0x7dea3baf843210ce0a4a9e6374cea47dcd55384fb36d2d701e69b221867b39e5",
    name: "USDC / ONDO",
    irm: "0x870aC11D48B15DB9a138Cf899d20F13F79Ba00BC",
    lltv: "625000000000000000",
    oracle: "0x77cc1e24DA5826E5780481A11C9899E6f43Dbd63",
    loanToken: {
      address: "0xA0b86991c6218b36c1d19D4a2e9Eb0cE3606eB48",
      symbol: "USDC",
    },
    collateralToken: {
      address: "0xfAbA6f8e4a5E8Ab82F62fe7C39859FA577269BE3",
      symbol: "ONDO",
    },
  },
  {
    id: "0xc2bc5e1e304fb1ea103dcbee37ece3c7e9219fb4b2b19d8ffdf81c39f4fbf180",
    name: "USDC / PT-srNUSD-28MAY2026",
    irm: "0x870aC11D48B15DB9a138Cf899d20F13F79Ba00BC",
    lltv: "915000000000000000",
    oracle: "0x0D07087b26b28995a66050f5bb7197D439221DE3",
    loanToken: {
      address: "0xA0b86991c6218b36c1d19D4a2e9Eb0cE3606eB48",
      symbol: "USDC",
    },
    collateralToken: {
      address: "0x82b853DB31F025858792d8fA969f2a1Dc245C179",
      symbol: "PT-srNUSD-28MAY2026",
    },
  },
  {
    id: "0x746235dba016c0e25b9d91051f4883719d4a863eb3ebfb546912e09611214535",
    name: "USDC / bdUSD",
    irm: "0x870aC11D48B15DB9a138Cf899d20F13F79Ba00BC",
    lltv: "860000000000000000",
    oracle: "0x1D8Cbc63Ee5eF7B33cB1eE7b32ad90d619e4D3cF",
    loanToken: {
      address: "0xA0b86991c6218b36c1d19D4a2e9Eb0cE3606eB48",
      symbol: "USDC",
    },
    collateralToken: {
      address: "0xF8F226dA66244F89e70C5B5D1a5C5b0d505Eb1d8",
      symbol: "bdUSD",
    },
  },
  {
    id: "0x7384bd82fb2f2a562555d4aab25583b4e40deed124b7c95dc16be34547434193",
    name: "EURC / WETH",
    irm: "0x870aC11D48B15DB9a138Cf899d20F13F79Ba00BC",
    lltv: "860000000000000000",
    oracle: "0x7E5c3ccAb5D4f02d67d18b36b1E3b586eB194748",
    loanToken: {
      address: "0x1aBaEA1f7C830bD89Acc67eC4af516284b1bC33c",
      symbol: "EURC",
    },
    collateralToken: {
      address: "0xC02aaA39b223FE8D0A0e5C4F27eAD9083C756Cc2",
      symbol: "WETH",
    },
  },
  {
    id: "0x140fe48783fe88d2a52b31705577d917628caaf74ff79865b39d4c2aa6c2fd3c",
    name: "USDe / eUSDe",
    irm: "0x870aC11D48B15DB9a138Cf899d20F13F79Ba00BC",
    lltv: "915000000000000000",
    oracle: "0xaE4750d0813B5E37A51f7629beedd72AF1f9cA35",
    loanToken: {
      address: "0x4c9EDD5852cd905f086C759E8383e09bff1E68B3",
      symbol: "USDe",
    },
    collateralToken: {
      address: "0x90D2af7d622ca3141efA4d8f1F24d86E5974Cc8F",
      symbol: "eUSDe",
    },
  },
  {
    id: "0xbfed072faee09b963949defcdb91094465c34c6c62d798b906274ef3563c9cac",
    name: "USDC / srUSD",
    irm: "0x870aC11D48B15DB9a138Cf899d20F13F79Ba00BC",
    lltv: "915000000000000000",
    oracle: "0xf3FB6f72f1bbD5dFfC03c8c120E7692559643B6d",
    loanToken: {
      address: "0xA0b86991c6218b36c1d19D4a2e9Eb0cE3606eB48",
      symbol: "USDC",
    },
    collateralToken: {
      address: "0x738d1115B90efa71AE468F1287fc864775e23a31",
      symbol: "srUSD",
    },
  },
  {
    id: "0x0fc05005f1a0346bc2f29bd5e1da2023d7f93b4a95e211526ea3205329c9d079",
    name: "LBTC / WBTC",
    irm: "0x870aC11D48B15DB9a138Cf899d20F13F79Ba00BC",
    lltv: "945000000000000000",
    oracle: "0xb7e622716CF9F32206C8bD05041CDDE87812D532",
    loanToken: {
      address: "0x8236a87084f8B84306f72007F36F2618A5634494",
      symbol: "LBTC",
    },
    collateralToken: {
      address: "0x2260FAC5E5542a773Aa44fBCfeDf7C193bc2C599",
      symbol: "WBTC",
    },
  },
  {
    id: "0x85ab69d50add7daa0934b5224889af0a882f2e3b4572d82c771dd0875f4eaa9b",
    name: "WETH / pufETH",
    irm: "0x870aC11D48B15DB9a138Cf899d20F13F79Ba00BC",
    lltv: "945000000000000000",
    oracle: "0x0bA399d2fC01429dD625Db463b11EbA13284db95",
    loanToken: {
      address: "0xC02aaA39b223FE8D0A0e5C4F27eAD9083C756Cc2",
      symbol: "WETH",
    },
    collateralToken: {
      address: "0xD9A442856C234a39a81a089C06451EBAa4306a72",
      symbol: "pufETH",
    },
  },
  {
    id: "0x11db9f2c7bda8c2af6a6a72db18aa5eb9290cb99cf75a3c0abacf1b84b8eaf77",
    name: "WETH / amphrETH",
    irm: "0x870aC11D48B15DB9a138Cf899d20F13F79Ba00BC",
    lltv: "860000000000000000",
    oracle: "0x0642aaB8ca0a9F3784ea59988c47D4cCe6056Aee",
    loanToken: {
      address: "0xC02aaA39b223FE8D0A0e5C4F27eAD9083C756Cc2",
      symbol: "WETH",
    },
    collateralToken: {
      address: "0x5fD13359Ba15A84B76f7F87568309040176167cd",
      symbol: "amphrETH",
    },
  },
  {
    id: "0xa4774e3e693fff2ebd1dcbbd69b1b0a5b9bb0ccc753bfda5dd07bdac97c4818a",
    name: "USDT / syrupUSDT",
    irm: "0x870aC11D48B15DB9a138Cf899d20F13F79Ba00BC",
    lltv: "915000000000000000",
    oracle: "0x34e50151c21c5f3499AcE66c7157aA547892e997",
    loanToken: {
      address: "0xdAC17F958D2ee523a2206206994597C13D831ec7",
      symbol: "USDT",
    },
    collateralToken: {
      address: "0x356B8d89c1e1239Cbbb9dE4815c39A1474d5BA7D",
      symbol: "syrupUSDT",
    },
  },
  {
    id: "0xbd1ad3b968f5f0552dbd8cf1989a62881407c5cccf9e49fb3657c8731caf0c1f",
    name: "USDC / deUSD",
    irm: "0x870aC11D48B15DB9a138Cf899d20F13F79Ba00BC",
    lltv: "860000000000000000",
    oracle: "0x1325Eb089Ac14B437E78D5D481e32611F6907eF8",
    loanToken: {
      address: "0xA0b86991c6218b36c1d19D4a2e9Eb0cE3606eB48",
      symbol: "USDC",
    },
    collateralToken: {
      address: "0x15700B564Ca08D9439C58cA5053166E8317aa138",
      symbol: "deUSD",
    },
  },
  {
    id: "0x2287407f0f42ad5ad224f70e4d9da37f02770f79959df703d6cfee8afc548e0d",
    name: "WETH / STONE",
    irm: "0x870aC11D48B15DB9a138Cf899d20F13F79Ba00BC",
    lltv: "945000000000000000",
    oracle: "0xcF45D565252D56b5d377631982c8543e80a4c6a1",
    loanToken: {
      address: "0xC02aaA39b223FE8D0A0e5C4F27eAD9083C756Cc2",
      symbol: "WETH",
    },
    collateralToken: {
      address: "0x7122985656e38BDC0302Db86685bb972b145bD3C",
      symbol: "STONE",
    },
  },
  {
    id: "0x760b14c9003f08ac4bf0cfb02596ee4d6f0548a4fde5826bfd56befb9ed62ae9",
    name: "DAI / PT-USDe-31JUL2025",
    irm: "0x870aC11D48B15DB9a138Cf899d20F13F79Ba00BC",
    lltv: "915000000000000000",
    oracle: "0xFCaE69BEF9B6c96D89D58664d8aeA84BddCe2E5c",
    loanToken: {
      address: "0x6B175474E89094C44Da98b954EedeAC495271d0F",
      symbol: "DAI",
    },
    collateralToken: {
      address: "0x917459337CaAC939D41d7493B3999f571D20D667",
      symbol: "PT-USDe-31JUL2025",
    },
  },
  {
    id: "0x9d1d0c9b76eefefc881db90f4f646dcc088121451616634544ce8129c4e574b1",
    name: "tGBP / WBTC",
    irm: "0x870aC11D48B15DB9a138Cf899d20F13F79Ba00BC",
    lltv: "860000000000000000",
    oracle: "0xA2eDAA8FBd476f740a912112471C7df61187FfcF",
    loanToken: {
      address: "0x27f6c8289550fCE67f6B50BeD1F519966aFE5287",
      symbol: "tGBP",
    },
    collateralToken: {
      address: "0x2260FAC5E5542a773Aa44fBCfeDf7C193bc2C599",
      symbol: "WBTC",
    },
  },
  {
    id: "0x729badf297ee9f2f6b3f717b96fd355fc6ec00422284ce1968e76647b258cf44",
    name: "USDC / syrupUSDC",
    irm: "0x870aC11D48B15DB9a138Cf899d20F13F79Ba00BC",
    lltv: "915000000000000000",
    oracle: "0x80032f4cb6E3573b9ed61E888AF658E48Fb790cC",
    loanToken: {
      address: "0xA0b86991c6218b36c1d19D4a2e9Eb0cE3606eB48",
      symbol: "USDC",
    },
    collateralToken: {
      address: "0x80ac24aA929eaF5013f6436cdA2a7ba190f5Cc0b",
      symbol: "syrupUSDC",
    },
  },
  {
    id: "0xefcd445941835ff675c7fb5a7ef7ef9a0fae020950dec5cd46ffbaea13dde382",
    name: "EURC / cbBTC",
    irm: "0x870aC11D48B15DB9a138Cf899d20F13F79Ba00BC",
    lltv: "860000000000000000",
    oracle: "0xC7cD76010D7D41506faB468A99EDAe654b94fD0B",
    loanToken: {
      address: "0x1aBaEA1f7C830bD89Acc67eC4af516284b1bC33c",
      symbol: "EURC",
    },
    collateralToken: {
      address: "0xcbB7C0000aB88B473b1f5aFd9ef808440eed33Bf",
      symbol: "cbBTC",
    },
  },
  {
    id: "0x95c28d447950ca6c8bbfd25fc05b80b1fd7a1cdd17a3610b4b3f1ffc8dc2e2ed",
    name: "USDC / mHYPER",
    irm: "0x870aC11D48B15DB9a138Cf899d20F13F79Ba00BC",
    lltv: "860000000000000000",
    oracle: "0xdabD6Bb1c67a911C077c4E63b1c9cf1c0b11F1C0",
    loanToken: {
      address: "0xA0b86991c6218b36c1d19D4a2e9Eb0cE3606eB48",
      symbol: "USDC",
    },
    collateralToken: {
      address: "0x9b5528528656DBC094765E2abB79F293c21191B9",
      symbol: "mHYPER",
    },
  },
  {
    id: "0x973e9dd45799efe8775417bcc420a3ab84a583587b2108985746e2fe201d0c83",
    name: "USDC / YFI",
    irm: "0x870aC11D48B15DB9a138Cf899d20F13F79Ba00BC",
    lltv: "770000000000000000",
    oracle: "0x637060c43e0Bf6ab68AB59e7ad72ceE45cE84Ad5",
    loanToken: {
      address: "0xA0b86991c6218b36c1d19D4a2e9Eb0cE3606eB48",
      symbol: "USDC",
    },
    collateralToken: {
      address: "0x0bc529c00C6401aEF6D220BE8C6Ea1667F6Ad93e",
      symbol: "YFI",
    },
  },
  {
    id: "0x3c5a244b778095e1e1b2e44b7c2ecc9bf4fda9cd85cc22740e09205a7a4bf510",
    name: "USDT / WBTC",
    irm: "0x870aC11D48B15DB9a138Cf899d20F13F79Ba00BC",
    lltv: "860000000000000000",
    oracle: "0xf1561bC4b3D1bA49053986Fb9ee88D4fE22d0Cf4",
    loanToken: {
      address: "0xdAC17F958D2ee523a2206206994597C13D831ec7",
      symbol: "USDT",
    },
    collateralToken: {
      address: "0x2260FAC5E5542a773Aa44fBCfeDf7C193bc2C599",
      symbol: "WBTC",
    },
  },
  {
    id: "0xc54d7acf14de29e0e5527cabd7a576506870346a78a11a6762e2cca66322ec41",
    name: "WETH / wstETH",
    irm: "0x870aC11D48B15DB9a138Cf899d20F13F79Ba00BC",
    lltv: "945000000000000000",
    oracle: "0x2a01EB9496094dA03c4E364Def50f5aD1280AD72",
    loanToken: {
      address: "0xC02aaA39b223FE8D0A0e5C4F27eAD9083C756Cc2",
      symbol: "WETH",
    },
    collateralToken: {
      address: "0x7f39C581F595B53c5cb19bD0b3f8dA6c935E2Ca0",
      symbol: "wstETH",
    },
  },
  {
    id: "0xf57808b9489bcbe7e7c67fd5227b0a4267a384ebb80301a097e4fa1f3fcb3234",
    name: "USDC / BAL",
    irm: "0x870aC11D48B15DB9a138Cf899d20F13F79Ba00BC",
    lltv: "625000000000000000",
    oracle: "0xc0A2874eAcD380A186fafe6eb4420B31d98EA3F4",
    loanToken: {
      address: "0xA0b86991c6218b36c1d19D4a2e9Eb0cE3606eB48",
      symbol: "USDC",
    },
    collateralToken: {
      address: "0xba100000625a3754423978a60c9317c58a424e3D",
      symbol: "BAL",
    },
  },
  {
    id: "0x423cb007534ac88febb8ce39f544ab303e8b757f8415ed891fc76550f8f4c965",
    name: "USDA / wstETH",
    irm: "0x870aC11D48B15DB9a138Cf899d20F13F79Ba00BC",
    lltv: "860000000000000000",
    oracle: "0xBC693693fDBB177Ad05ff38633110016BC043AC5",
    loanToken: {
      address: "0x0000206329b97DB379d5E1Bf586BbDB969C63274",
      symbol: "USDA",
    },
    collateralToken: {
      address: "0x7f39C581F595B53c5cb19bD0b3f8dA6c935E2Ca0",
      symbol: "wstETH",
    },
  },
  {
    id: "0x85c7f4374f3a403b36d54cc284983b2b02bbd8581ee0f3c36494447b87d9fcab",
    name: "USDC / sUSDe",
    irm: "0x870aC11D48B15DB9a138Cf899d20F13F79Ba00BC",
    lltv: "915000000000000000",
    oracle: "0x873CD44b860DEDFe139f93e12A4AcCa0926Ffb87",
    loanToken: {
      address: "0xA0b86991c6218b36c1d19D4a2e9Eb0cE3606eB48",
      symbol: "USDC",
    },
    collateralToken: {
      address: "0x9D39A5DE30e57443BfF2A8307A4256c8797A3497",
      symbol: "sUSDe",
    },
  },
  {
    id: "0xf5de1cd86d1b96dae889356d9515a1ccfd6caae8570f8d6d49c218bb203d045d",
    name: "USDC / PT-reUSD-18DEC2025",
    irm: "0x870aC11D48B15DB9a138Cf899d20F13F79Ba00BC",
    lltv: "915000000000000000",
    oracle: "0xaDCf2842253E6880da41A35172E31EaDD2E80545",
    loanToken: {
      address: "0xA0b86991c6218b36c1d19D4a2e9Eb0cE3606eB48",
      symbol: "USDC",
    },
    collateralToken: {
      address: "0xCb95d32B87D2ECEB196Af2152147de371aF3C7C9",
      symbol: "PT-reUSD-18DEC2025",
    },
  },
  {
    id: "0xb23a77bb62863186a99c7e87d1a4f542cb8865eec6536206f0960bb9c00512f5",
    name: "USDC / jrUSDe",
    irm: "0x870aC11D48B15DB9a138Cf899d20F13F79Ba00BC",
    lltv: "860000000000000000",
    oracle: "0xfDB578391A7807891bb03BeA590d2C2409F771A2",
    loanToken: {
      address: "0xA0b86991c6218b36c1d19D4a2e9Eb0cE3606eB48",
      symbol: "USDC",
    },
    collateralToken: {
      address: "0xC58D044404d8B14e953C115E67823784dEA53d8F",
      symbol: "jrUSDe",
    },
  },
  {
    id: "0x6a6c8e41a6a7ccbea68e1e6a19ece1fdd863b2b6c9e0f71bbcd4dcbe8b1062e8",
    name: "USDT / wstETH",
    irm: "0x870aC11D48B15DB9a138Cf899d20F13F79Ba00BC",
    lltv: "860000000000000000",
    oracle: "0xA1bDbfD967620332b9Fd7D60885e19EBBE49B882",
    loanToken: {
      address: "0xdAC17F958D2ee523a2206206994597C13D831ec7",
      symbol: "USDT",
    },
    collateralToken: {
      address: "0x7f39C581F595B53c5cb19bD0b3f8dA6c935E2Ca0",
      symbol: "wstETH",
    },
  },
  {
    id: "0x883b22b724b422729ec0688e6ed71da1c5105ac6610810624f25263d7c2e7bf3",
    name: "WETH / ARM-WETH-eETH",
    irm: "0x870aC11D48B15DB9a138Cf899d20F13F79Ba00BC",
    lltv: "860000000000000000",
    oracle: "0x349D24B6444FBe5999eF92d0fe2EBFfbBAf70943",
    loanToken: {
      address: "0xC02aaA39b223FE8D0A0e5C4F27eAD9083C756Cc2",
      symbol: "WETH",
    },
    collateralToken: {
      address: "0xfB0A3CF9B019BFd8827443d131b235B3E0FC58d2",
      symbol: "ARM-WETH-eETH",
    },
  },
  {
    id: "0x698fe98247a40c5771537b5786b2f3f9d78eb487b4ce4d75533cd0e94d88a115",
    name: "WETH / weETH",
    irm: "0x870aC11D48B15DB9a138Cf899d20F13F79Ba00BC",
    lltv: "860000000000000000",
    oracle: "0x3fa58b74e9a8eA8768eb33c8453e9C2Ed089A40a",
    loanToken: {
      address: "0xC02aaA39b223FE8D0A0e5C4F27eAD9083C756Cc2",
      symbol: "WETH",
    },
    collateralToken: {
      address: "0xCd5fE23C85820F7B72D0926FC9b05b43E359b7ee",
      symbol: "weETH",
    },
  },
  {
    id: "0x4f7a6aae31dce0ceb7d6e049bd9e161942365de33ed891a77ed7c98cc8e6cc2b",
    name: "WETH / ccmETH",
    irm: "0x870aC11D48B15DB9a138Cf899d20F13F79Ba00BC",
    lltv: "980000000000000000",
    oracle: "0x083011f1d3B6886d188B89891b70f157e03b55ef",
    loanToken: {
      address: "0xC02aaA39b223FE8D0A0e5C4F27eAD9083C756Cc2",
      symbol: "WETH",
    },
    collateralToken: {
      address: "0xB144B3b2D2a7d82e53BC70659Be03Bcd21CD94e8",
      symbol: "ccmETH",
    },
  },
  {
    id: "0x7dde86a1e94561d9690ec678db673c1a6396365f7d1d65e129c5fff0990ff758",
    name: "USDC / WETH",
    irm: "0x870aC11D48B15DB9a138Cf899d20F13F79Ba00BC",
    lltv: "860000000000000000",
    oracle: "0xdC6fd5831277c693b1054e19E94047cB37c77615",
    loanToken: {
      address: "0xA0b86991c6218b36c1d19D4a2e9Eb0cE3606eB48",
      symbol: "USDC",
    },
    collateralToken: {
      address: "0xC02aaA39b223FE8D0A0e5C4F27eAD9083C756Cc2",
      symbol: "WETH",
    },
  },
  {
    id: "0x79b4e55cef9e7c214b5cc965e1984229ada26a66051e35366a75c4d92b776735",
    name: "USDC / PT-srUSDe-15JAN2026",
    irm: "0x870aC11D48B15DB9a138Cf899d20F13F79Ba00BC",
    lltv: "915000000000000000",
    oracle: "0x2A0326538eF89BA50d532Aa061baDCb5C87E1e8e",
    loanToken: {
      address: "0xA0b86991c6218b36c1d19D4a2e9Eb0cE3606eB48",
      symbol: "USDC",
    },
    collateralToken: {
      address: "0x1Fb3C5c35D95F48e48FFC8e36bCCe5CB5f29F57c",
      symbol: "PT-srUSDe-15JAN2026",
    },
  },
  {
    id: "0x1eda1b67414336cab3914316cb58339ddaef9e43f939af1fed162a989c98bc20",
    name: "USDC / USD0++",
    irm: "0x870aC11D48B15DB9a138Cf899d20F13F79Ba00BC",
    lltv: "965000000000000000",
    oracle: "0xBf877B424bE6d06cA4755aF2c677120eC71cac53",
    loanToken: {
      address: "0xA0b86991c6218b36c1d19D4a2e9Eb0cE3606eB48",
      symbol: "USDC",
    },
    collateralToken: {
      address: "0x35D8949372D46B7a3D5A56006AE77B215fc69bC0",
      symbol: "USD0++",
    },
  },
  {
    id: "0x2049bea9dfae8189895616ff4bf229c9c664e266b29c9ffe692b100be4879714",
    name: "WETH / ARM-WETH-stETH",
    irm: "0x870aC11D48B15DB9a138Cf899d20F13F79Ba00BC",
    lltv: "915000000000000000",
    oracle: "0x2097fC94A1505185654fc55880b1D2853e82664A",
    loanToken: {
      address: "0xC02aaA39b223FE8D0A0e5C4F27eAD9083C756Cc2",
      symbol: "WETH",
    },
    collateralToken: {
      address: "0x85B78AcA6Deae198fBF201c82DAF6Ca21942acc6",
      symbol: "ARM-WETH-stETH",
    },
  },
  {
    id: "0x3eb3899b02600e4c5c626a1dc3f9167c08d0675b7adbdd0daf78111574234f8b",
    name: "USDS / wstETH",
    irm: "0x870aC11D48B15DB9a138Cf899d20F13F79Ba00BC",
    lltv: "860000000000000000",
    oracle: "0x871B119C40d512AD3839c7F15456d4717be8F12C",
    loanToken: {
      address: "0xdC035D45d973E3EC169d2276DDab16f1e407384F",
      symbol: "USDS",
    },
    collateralToken: {
      address: "0x7f39C581F595B53c5cb19bD0b3f8dA6c935E2Ca0",
      symbol: "wstETH",
    },
  },
  {
    id: "0xa5beccdffd156dfe8c0871f143648c512f0a34f37c8a4ae2ff31ebfe944641d1",
    name: "PYUSD / sUSDS",
    irm: "0x870aC11D48B15DB9a138Cf899d20F13F79Ba00BC",
    lltv: "945000000000000000",
    oracle: "0x59e347aEF154aDcAe639d0cE032Cb3f5dCB4a6E4",
    loanToken: {
      address: "0x6c3ea9036406852006290770BEdFcAbA0e23A0e8",
      symbol: "PYUSD",
    },
    collateralToken: {
      address: "0xa3931d71877C0E7a3148CB7Eb4463524FEc27fbD",
      symbol: "sUSDS",
    },
  },
  {
    id: "0x29ae8cad946d861464d5e829877245a863a18157c0cde2c3524434dafa34e476",
    name: "USDT / sUSDD",
    irm: "0x870aC11D48B15DB9a138Cf899d20F13F79Ba00BC",
    lltv: "915000000000000000",
    oracle: "0x8c0a80C09aE8A8cdd66F4F51598d7b494eCF8154",
    loanToken: {
      address: "0xdAC17F958D2ee523a2206206994597C13D831ec7",
      symbol: "USDT",
    },
    collateralToken: {
      address: "0xC5d6A7B61d18AfA11435a889557b068BB9f29930",
      symbol: "sUSDD",
    },
  },
  {
    id: "0x9d582055d36f8d8b3b5924b9be6b8357fd766c635592a1ca8dac5f31c6acca04",
    name: "USDC / ynRWAx",
    irm: "0x870aC11D48B15DB9a138Cf899d20F13F79Ba00BC",
    lltv: "770000000000000000",
    oracle: "0xF8Ef29C14eA6FeB5F403D121A161e415014e93Dc",
    loanToken: {
      address: "0xA0b86991c6218b36c1d19D4a2e9Eb0cE3606eB48",
      symbol: "USDC",
    },
    collateralToken: {
      address: "0x01Ba69727E2860b37bc1a2bd56999c1aFb4C15D8",
      symbol: "ynRWAx",
    },
  },
  {
    id: "0x0ff9c1f2b9cb037ecb14029cbacd3a94470458cf5c6884f09c46ae354765d789",
    name: "USDC / srNUSD",
    irm: "0x870aC11D48B15DB9a138Cf899d20F13F79Ba00BC",
    lltv: "915000000000000000",
    oracle: "0x9E1031D287416b45C89d62780768d35dF24DF4Be",
    loanToken: {
      address: "0xA0b86991c6218b36c1d19D4a2e9Eb0cE3606eB48",
      symbol: "USDC",
    },
    collateralToken: {
      address: "0x65a44528e8868166401eA08b549E19552af589dB",
      symbol: "srNUSD",
    },
  },
  {
    id: "0xf78b7d3a62437f78097745a5e3117a50c56a02ec5f072cba8d988a129c6d4fb6",
    name: "WETH / beraSTONE",
    irm: "0x870aC11D48B15DB9a138Cf899d20F13F79Ba00BC",
    lltv: "915000000000000000",
    oracle: "0xaE95c514054fe072036035F3AEfc4bF31EA9dEE5",
    loanToken: {
      address: "0xC02aaA39b223FE8D0A0e5C4F27eAD9083C756Cc2",
      symbol: "WETH",
    },
    collateralToken: {
      address: "0x97Ad75064b20fb2B2447feD4fa953bF7F007a706",
      symbol: "beraSTONE",
    },
  },
  {
    id: "0x49bb2d114be9041a787432952927f6f144f05ad3e83196a7d062f374ee11d0ee",
    name: "WETH / ezETH",
    irm: "0x870aC11D48B15DB9a138Cf899d20F13F79Ba00BC",
    lltv: "860000000000000000",
    oracle: "0x61025e2B0122ac8bE4e37365A4003d87ad888Cc3",
    loanToken: {
      address: "0xC02aaA39b223FE8D0A0e5C4F27eAD9083C756Cc2",
      symbol: "WETH",
    },
    collateralToken: {
      address: "0xbf5495Efe5DB9ce00f80364C8B423567e58d2110",
      symbol: "ezETH",
    },
  },
  {
    id: "0xe3a65a68d203a3e3cbd4a59e4604db431439ee6eeb3f88268d7f57e415df7e94",
    name: "ZCHF / WBTC",
    irm: "0x870aC11D48B15DB9a138Cf899d20F13F79Ba00BC",
    lltv: "860000000000000000",
    oracle: "0x2B397B78d26e763a4c599E77a5Ab5a224a64825b",
    loanToken: {
      address: "0xB58E61C3098d85632Df34EecfB899A1Ed80921cB",
      symbol: "ZCHF",
    },
    collateralToken: {
      address: "0x2260FAC5E5542a773Aa44fBCfeDf7C193bc2C599",
      symbol: "WBTC",
    },
  },
  {
    id: "0x8bfd8f4f146c660f201a34b7a05d5eade3dc95b7b329210703855b60ad871a24",
    name: "WETH / tETH",
    irm: "0x870aC11D48B15DB9a138Cf899d20F13F79Ba00BC",
    lltv: "915000000000000000",
    oracle: "0xe3Ae1F1fEAcf65f58f83652d8BF631908aeef5a0",
    loanToken: {
      address: "0xC02aaA39b223FE8D0A0e5C4F27eAD9083C756Cc2",
      symbol: "WETH",
    },
    collateralToken: {
      address: "0xD11c452fc99cF405034ee446803b6F6c1F6d5ED8",
      symbol: "tETH",
    },
  },
  {
    id: "0x6b4803875fa6248dd04adfcda489c675f26f88d03555a0a277d7a572098a038c",
    name: "USDC / srmHYPER",
    irm: "0x870aC11D48B15DB9a138Cf899d20F13F79Ba00BC",
    lltv: "915000000000000000",
    oracle: "0xCA233D1a063D3737956054d8355Cc1e90594F848",
    loanToken: {
      address: "0xA0b86991c6218b36c1d19D4a2e9Eb0cE3606eB48",
      symbol: "USDC",
    },
    collateralToken: {
      address: "0x627EA69929212916Ec57B1b26d2E1a19F6129B53",
      symbol: "srmHYPER",
    },
  },
  {
    id: "0x904142eba80012455c361f3c442b9c89c0dd0fb86c7d8f062c4425bfa2314eb9",
    name: "USDC / reUSDe",
    irm: "0x870aC11D48B15DB9a138Cf899d20F13F79Ba00BC",
    lltv: "770000000000000000",
    oracle: "0x0D63495E3e827297C2686158055989da78Eb47fe",
    loanToken: {
      address: "0xA0b86991c6218b36c1d19D4a2e9Eb0cE3606eB48",
      symbol: "USDC",
    },
    collateralToken: {
      address: "0xdDC0f880ff6e4e22E4B74632fBb43Ce4DF6cCC5a",
      symbol: "reUSDe",
    },
  },
  {
    id: "0x54cebd0c5d5ad84f551a883991c39c470e081a20452eaef47eec2377ffae9f98",
    name: "USDC / jrUSDe",
    irm: "0x870aC11D48B15DB9a138Cf899d20F13F79Ba00BC",
    lltv: "915000000000000000",
    oracle: "0xfDB578391A7807891bb03BeA590d2C2409F771A2",
    loanToken: {
      address: "0xA0b86991c6218b36c1d19D4a2e9Eb0cE3606eB48",
      symbol: "USDC",
    },
    collateralToken: {
      address: "0xC58D044404d8B14e953C115E67823784dEA53d8F",
      symbol: "jrUSDe",
    },
  },
  {
    id: "0xb62aac664f81d19f21a158aa0373967ef60fd1ac8de4a9091bd225c007973ca6",
    name: "USDC / PT-sNUSD-4JUN2026",
    irm: "0x870aC11D48B15DB9a138Cf899d20F13F79Ba00BC",
    lltv: "860000000000000000",
    oracle: "0x725007419b5807631ff113028CdcccdFA254a2Bc",
    loanToken: {
      address: "0xA0b86991c6218b36c1d19D4a2e9Eb0cE3606eB48",
      symbol: "USDC",
    },
    collateralToken: {
      address: "0x6C65dB1d88C8edA1e3dEbF2B2eF3D0EcE8600466",
      symbol: "PT-sNUSD-4JUN2026",
    },
  },
  {
    id: "0x802ec6e878dc9fe6905b8a0a18962dcca10440a87fa2242fbf4a0461c7b0c789",
    name: "USDC / PT-cUSD-29JAN2026",
    irm: "0x870aC11D48B15DB9a138Cf899d20F13F79Ba00BC",
    lltv: "915000000000000000",
    oracle: "0xE1a701F28a95ECC49d671dc477f66A61Ac976f47",
    loanToken: {
      address: "0xA0b86991c6218b36c1d19D4a2e9Eb0cE3606eB48",
      symbol: "USDC",
    },
    collateralToken: {
      address: "0x545A490f9ab534AdF409A2E682bc4098f49952e3",
      symbol: "PT-cUSD-29JAN2026",
    },
  },
  {
    id: "0xfcb68ab820f4abe96d6c1461ede57e0d4b8671b7235c62fc5b3f4151cc46d42c",
    name: "USDCV / wstETH",
    irm: "0x870aC11D48B15DB9a138Cf899d20F13F79Ba00BC",
    lltv: "860000000000000000",
    oracle: "0x8000D6731A305A84aB7415D06488c160Ad86FAb0",
    loanToken: {
      address: "0x5422374B27757da72d5265cC745ea906E0446634",
      symbol: "USDCV",
    },
    collateralToken: {
      address: "0x7f39C581F595B53c5cb19bD0b3f8dA6c935E2Ca0",
      symbol: "wstETH",
    },
  },
  {
    id: "0x6df56abb95e9f3f96049448e1c98d208deb1add8a3d0c7a23e5e5466dba4edbd",
    name: "USDC / iUSD",
    irm: "0x870aC11D48B15DB9a138Cf899d20F13F79Ba00BC",
    lltv: "915000000000000000",
    oracle: "0x570F093895fEA613e9eD7Ff10DD135E4026A7D34",
    loanToken: {
      address: "0xA0b86991c6218b36c1d19D4a2e9Eb0cE3606eB48",
      symbol: "USDC",
    },
    collateralToken: {
      address: "0x48f9e38f3070AD8945DFEae3FA70987722E3D89c",
      symbol: "iUSD",
    },
  },
  {
    id: "0x972b343b611a3cf2559a04bf2c0b8e45d1c69a1c1d94dc852ca6e16a924b006b",
    name: "USDC / MVL",
    irm: "0x870aC11D48B15DB9a138Cf899d20F13F79Ba00BC",
    lltv: "770000000000000000",
    oracle: "0x856e1fbf235561A31bA6A20654814A30F96459a6",
    loanToken: {
      address: "0xA0b86991c6218b36c1d19D4a2e9Eb0cE3606eB48",
      symbol: "USDC",
    },
    collateralToken: {
      address: "0xA849EaaE994fb86Afa73382e9Bd88c2B6b18Dc71",
      symbol: "MVL",
    },
  },
  {
    id: "0x0eed5a89c7d397d02fd0b9b8e42811ca67e50ed5aeaa4f22e506516c716cfbbf",
    name: "WETH / pufETH",
    irm: "0x870aC11D48B15DB9a138Cf899d20F13F79Ba00BC",
    lltv: "860000000000000000",
    oracle: "0x7A5628D0f541c697D7E9Bd7DC5a0598b306C13Fc",
    loanToken: {
      address: "0xC02aaA39b223FE8D0A0e5C4F27eAD9083C756Cc2",
      symbol: "WETH",
    },
    collateralToken: {
      address: "0xD9A442856C234a39a81a089C06451EBAa4306a72",
      symbol: "pufETH",
    },
  },
  {
    id: "0x7e1c2cc61cc013e9c6b4c0c9e5be0bddf95d2f4de64e4adc05665b0389c95bc4",
    name: "USDC / n-st-mAPOLLO",
    irm: "0x870aC11D48B15DB9a138Cf899d20F13F79Ba00BC",
    lltv: "860000000000000000",
    oracle: "0x091356E6793a0d960174eaAb4d470E39A99DD673",
    loanToken: {
      address: "0xA0b86991c6218b36c1d19D4a2e9Eb0cE3606eB48",
      symbol: "USDC",
    },
    collateralToken: {
      address: "0x091356E6793a0d960174eaAb4d470E39A99DD673",
      symbol: "n-st-mAPOLLO",
    },
  },
  {
    id: "0x7ad683900a4017394d76a43cd695a2756cfe96387cb0aa3f8cf3ef73135f85b3",
    name: "WETH / hETH",
    irm: "0x870aC11D48B15DB9a138Cf899d20F13F79Ba00BC",
    lltv: "945000000000000000",
    oracle: "0xCBd0fC83C8c68A3ab0B04FB0544fE65C8AA2CDfA",
    loanToken: {
      address: "0xC02aaA39b223FE8D0A0e5C4F27eAD9083C756Cc2",
      symbol: "WETH",
    },
    collateralToken: {
      address: "0x270B7748CdF8243bFe68FaCE7230ef0fCE695389",
      symbol: "hETH",
    },
  },
  {
    id: "0xd5211d0e3f4a30d5c98653d988585792bb7812221f04801be73a44ceecb11e89",
    name: "WETH / osETH",
    irm: "0x870aC11D48B15DB9a138Cf899d20F13F79Ba00BC",
    lltv: "860000000000000000",
    oracle: "0x224F2F1333b45E34fFCfC3bD01cE43C73A914498",
    loanToken: {
      address: "0xC02aaA39b223FE8D0A0e5C4F27eAD9083C756Cc2",
      symbol: "WETH",
    },
    collateralToken: {
      address: "0xf1C9acDc66974dFB6dEcB12aA385b9cD01190E38",
      symbol: "osETH",
    },
  },
  {
    id: "0x8aa8614fca17b7efd787e3677bab78fce4a4928866375e86275001515b1f8114",
    name: "WETH / ETH0",
    irm: "0x870aC11D48B15DB9a138Cf899d20F13F79Ba00BC",
    lltv: "945000000000000000",
    oracle: "0x5E0032be06D79734819f05C4965eAeD53e1E4774",
    loanToken: {
      address: "0xC02aaA39b223FE8D0A0e5C4F27eAD9083C756Cc2",
      symbol: "WETH",
    },
    collateralToken: {
      address: "0x734eec7930bc84eC5732022B9EB949A81fB89AbE",
      symbol: "ETH0",
    },
  },
  {
    id: "0x27b9a0a5bfee98a31eb51e3850250d103a9f8e41673c782defc66aa943af0e65",
    name: "USDC / PT-srUSDe-2APR2026",
    irm: "0x870aC11D48B15DB9a138Cf899d20F13F79Ba00BC",
    lltv: "915000000000000000",
    oracle: "0x8B417d1e0C08d8005B7Ca1d5ebbc72Ea877DB391",
    loanToken: {
      address: "0xA0b86991c6218b36c1d19D4a2e9Eb0cE3606eB48",
      symbol: "USDC",
    },
    collateralToken: {
      address: "0x9Bf45ab47747F4B4dD09B3C2c73953484b4eB375",
      symbol: "PT-srUSDe-2APR2026",
    },
  },
  {
    id: "0x5c706a82e9ec6e40dd5e81b00b09099cef09bd501a56085ad9c17f7965fc5897",
    name: "USDC / CTOKEN3",
    irm: "0x870aC11D48B15DB9a138Cf899d20F13F79Ba00BC",
    lltv: "860000000000000000",
    oracle: "0x2D2D50726D8F791FDf029994f662A6eC374d0119",
    loanToken: {
      address: "0xA0b86991c6218b36c1d19D4a2e9Eb0cE3606eB48",
      symbol: "USDC",
    },
    collateralToken: {
      address: "0xd00E55a0E5A3fabB220c6175D8947313Fc7F2f33",
      symbol: "CTOKEN3",
    },
  },
  {
    id: "0xdbcb3abc60f6e1a2c6a4acfc7225950c80c1bc192ae366e3dd55c86581fbf039",
    name: "USDC / CTOKEN2",
    irm: "0x870aC11D48B15DB9a138Cf899d20F13F79Ba00BC",
    lltv: "860000000000000000",
    oracle: "0xc308970A7b72818e1b3FdbaB61dC345E1f3247e0",
    loanToken: {
      address: "0xA0b86991c6218b36c1d19D4a2e9Eb0cE3606eB48",
      symbol: "USDC",
    },
    collateralToken: {
      address: "0xE89feD9a81cB8B19338f70367181A1A4Db5d06ae",
      symbol: "CTOKEN2",
    },
  },
  {
    id: "0x7f37bf3c7b9c08416f87f8a29a4c3142c0c08903316dd39ae473cc7b1dd4f9e3",
    name: "USDC / CTOKEN1",
    irm: "0x870aC11D48B15DB9a138Cf899d20F13F79Ba00BC",
    lltv: "860000000000000000",
    oracle: "0x08A9d6B4f11BeCA41F78C8097baB2AbD2fC5710c",
    loanToken: {
      address: "0xA0b86991c6218b36c1d19D4a2e9Eb0cE3606eB48",
      symbol: "USDC",
    },
    collateralToken: {
      address: "0x387D46494F6dc5c6b26aBC20Ae40623AC041dD92",
      symbol: "CTOKEN1",
    },
  },
  {
    id: "0x6029eea874791e01e2f3ce361f2e08839cd18b1e26eea6243fa3e43fe8f6fa23",
    name: "eUSD / wstETH",
    irm: "0x870aC11D48B15DB9a138Cf899d20F13F79Ba00BC",
    lltv: "860000000000000000",
    oracle: "0xBC693693fDBB177Ad05ff38633110016BC043AC5",
    loanToken: {
      address: "0xA0d69E286B938e21CBf7E51D71F6A4c8918f482F",
      symbol: "eUSD",
    },
    collateralToken: {
      address: "0x7f39C581F595B53c5cb19bD0b3f8dA6c935E2Ca0",
      symbol: "wstETH",
    },
  },
  {
    id: "0xf9a116d22917bc9080e2c989738bc821099d358280df8f81ead58557bd39fdad",
    name: "USDCV / WBTC",
    irm: "0x870aC11D48B15DB9a138Cf899d20F13F79Ba00BC",
    lltv: "860000000000000000",
    oracle: "0x032F1C64899b2C89835E51aCeD9434b0aDEaA69d",
    loanToken: {
      address: "0x5422374B27757da72d5265cC745ea906E0446634",
      symbol: "USDCV",
    },
    collateralToken: {
      address: "0x2260FAC5E5542a773Aa44fBCfeDf7C193bc2C599",
      symbol: "WBTC",
    },
  },
  {
    id: "0xf5b23a40974bcc0092cefc5c1d8031f74721ea092e73a5e6c86b2d63e509d449",
    name: "USDC / GOLDX",
    irm: "0x870aC11D48B15DB9a138Cf899d20F13F79Ba00BC",
    lltv: "625000000000000000",
    oracle: "0xfC3E7613c95A32Da88CFF88AbE60D09B32215f8D",
    loanToken: {
      address: "0xA0b86991c6218b36c1d19D4a2e9Eb0cE3606eB48",
      symbol: "USDC",
    },
    collateralToken: {
      address: "0x591b64e554191873C148EaDFb5B748b2B56Bf4e7",
      symbol: "GOLDX",
    },
  },
  {
    id: "0xe95187ba4e7668ab4434bbb17d1dfd7b87e878242eee3e73dac9fdb79a4d0d99",
    name: "USDC / EIGEN",
    irm: "0x870aC11D48B15DB9a138Cf899d20F13F79Ba00BC",
    lltv: "770000000000000000",
    oracle: "0x9cfc49118bF066a1255a1A923890940594fd5770",
    loanToken: {
      address: "0xA0b86991c6218b36c1d19D4a2e9Eb0cE3606eB48",
      symbol: "USDC",
    },
    collateralToken: {
      address: "0xec53bF9167f50cDEB3Ae105f56099aaaB9061F83",
      symbol: "EIGEN",
    },
  },
  {
    id: "0x7aae9136d142aa7ec2a3ad155fb42489ed7ed93a74c589eb1643916ae19f0833",
    name: "USDC / cUSDOUSDC",
    irm: "0x870aC11D48B15DB9a138Cf899d20F13F79Ba00BC",
    lltv: "915000000000000000",
    oracle: "0x04d1ACfEB737E10fb5e849222Be17aA8855c54E6",
    loanToken: {
      address: "0xA0b86991c6218b36c1d19D4a2e9Eb0cE3606eB48",
      symbol: "USDC",
    },
    collateralToken: {
      address: "0x90455bd11Ce8a67C57d467e634Dc142b8e4105Aa",
      symbol: "cUSDOUSDC",
    },
  },
  {
    id: "0xa59b6c3c6d1df322195bfb48ddcdcca1a4c0890540e8ee75815765096c1e8971",
    name: "USDC / USD0USD0++",
    irm: "0x870aC11D48B15DB9a138Cf899d20F13F79Ba00BC",
    lltv: "965000000000000000",
    oracle: "0xBf877B424bE6d06cA4755aF2c677120eC71cac53",
    loanToken: {
      address: "0xA0b86991c6218b36c1d19D4a2e9Eb0cE3606eB48",
      symbol: "USDC",
    },
    collateralToken: {
      address: "0x1d08E7adC263CfC70b1BaBe6dC5Bb339c16Eec52",
      symbol: "USD0USD0++",
    },
  },
  {
    id: "0x38fa7d75c15a0f11cc46e2d1987a05c26a836d0da6b4430657ec5ece38a25a45",
    name: "USDC / SYRUP",
    irm: "0x870aC11D48B15DB9a138Cf899d20F13F79Ba00BC",
    lltv: "625000000000000000",
    oracle: "0x7F5Aa02a60ec79Dc6a2a5454D753c8AdCB98CE96",
    loanToken: {
      address: "0xA0b86991c6218b36c1d19D4a2e9Eb0cE3606eB48",
      symbol: "USDC",
    },
    collateralToken: {
      address: "0x643C4E15d7d62Ad0aBeC4a9BD4b001aA3Ef52d66",
      symbol: "SYRUP",
    },
  },
  {
    id: "0x864c9b82eb066ae2c038ba763dfc0221001e62fc40925530056349633eb0a259",
    name: "USDC / USD0USD0++",
    irm: "0x870aC11D48B15DB9a138Cf899d20F13F79Ba00BC",
    lltv: "860000000000000000",
    oracle: "0x7bEc5E135845B37136167ea62Bd8C0354b1Ef246",
    loanToken: {
      address: "0xA0b86991c6218b36c1d19D4a2e9Eb0cE3606eB48",
      symbol: "USDC",
    },
    collateralToken: {
      address: "0x1d08E7adC263CfC70b1BaBe6dC5Bb339c16Eec52",
      symbol: "USD0USD0++",
    },
  },
  {
    id: "0x60fce64eeeaec462a3fdf674f786ad71e4eef6e717d848d992a8631a5cb0b4b2",
    name: "USDA / weETH",
    irm: "0x870aC11D48B15DB9a138Cf899d20F13F79Ba00BC",
    lltv: "770000000000000000",
    oracle: "0xF8DB6a27a5033d029e38eF8B8C2C5DCB48aADB53",
    loanToken: {
      address: "0x0000206329b97DB379d5E1Bf586BbDB969C63274",
      symbol: "USDA",
    },
    collateralToken: {
      address: "0xCd5fE23C85820F7B72D0926FC9b05b43E359b7ee",
      symbol: "weETH",
    },
  },
  {
    id: "0xfcd3b104b9a592d4377edd68f48ecf60082d787b64ca97a3385f3cc4cb9bd20f",
    name: "AUSD / wstETH",
    irm: "0x870aC11D48B15DB9a138Cf899d20F13F79Ba00BC",
    lltv: "860000000000000000",
    oracle: "0x038CE929913fF768D7cB1EF439FF23C6210a7A03",
    loanToken: {
      address: "0x00000000eFE302BEAA2b3e6e1b18d08D69a9012a",
      symbol: "AUSD",
    },
    collateralToken: {
      address: "0x7f39C581F595B53c5cb19bD0b3f8dA6c935E2Ca0",
      symbol: "wstETH",
    },
  },
  {
    id: "0x6d1dae6238f6f296abb77d9e17a8429132458146bc89d1d2b20516b87a40dee7",
    name: "USDC / EIGEN",
    irm: "0x870aC11D48B15DB9a138Cf899d20F13F79Ba00BC",
    lltv: "625000000000000000",
    oracle: "0xbe308966ce24Ffa95FA2f9Ace0ea5c054d4e552c",
    loanToken: {
      address: "0xA0b86991c6218b36c1d19D4a2e9Eb0cE3606eB48",
      symbol: "USDC",
    },
    collateralToken: {
      address: "0xec53bF9167f50cDEB3Ae105f56099aaaB9061F83",
      symbol: "EIGEN",
    },
  },
  {
    id: "0x278ca5513e54e0718a93515d453442f8ecc9a3640dfaf3a88db69f4c8a4880d9",
    name: "USDC / liUSD-1w",
    irm: "0x870aC11D48B15DB9a138Cf899d20F13F79Ba00BC",
    lltv: "860000000000000000",
    oracle: "0xFEC88f8539B8469644025A2955FD1d21577fc40c",
    loanToken: {
      address: "0xA0b86991c6218b36c1d19D4a2e9Eb0cE3606eB48",
      symbol: "USDC",
    },
    collateralToken: {
      address: "0x12b004719fb632f1E7c010c6F5D6009Fb4258442",
      symbol: "liUSD-1w",
    },
  },
  {
    id: "0x2d60540b94a0a0cb3cc6dad6c7360cf8a4a32273da0b4da73aea9810dd2a2c1e",
    name: "USDC / WETH",
    irm: "0x870aC11D48B15DB9a138Cf899d20F13F79Ba00BC",
    lltv: "625000000000000000",
    oracle: "0x7B872DcA70d9abBCD175b20aD3D3A796A7250828",
    loanToken: {
      address: "0xA0b86991c6218b36c1d19D4a2e9Eb0cE3606eB48",
      symbol: "USDC",
    },
    collateralToken: {
      address: "0xC02aaA39b223FE8D0A0e5C4F27eAD9083C756Cc2",
      symbol: "WETH",
    },
  },
  {
    id: "0x5cebfae10f5e88d33df2421923f3d9f32359429fda2f78edacc9b4fdb09b0553",
    name: "USDC / PT-USDG-28MAY2026",
    irm: "0x870aC11D48B15DB9a138Cf899d20F13F79Ba00BC",
    lltv: "945000000000000000",
    oracle: "0xEA268c588072e2639448E3a9433AB92E871335E2",
    loanToken: {
      address: "0xA0b86991c6218b36c1d19D4a2e9Eb0cE3606eB48",
      symbol: "USDC",
    },
    collateralToken: {
      address: "0x9db38D74a0D29380899aD354121DfB521aDb0548",
      symbol: "PT-USDG-28MAY2026",
    },
  },
  {
    id: "0x526d6d2e334afcb8ffc183eba1bdb1ed58e5a71fa9bd1a75a95eb71c6808081f",
    name: "USDC / SPYon",
    irm: "0x870aC11D48B15DB9a138Cf899d20F13F79Ba00BC",
    lltv: "625000000000000000",
    oracle: "0x234B9b65B4E16A258CDEac08377c31A45164DDd1",
    loanToken: {
      address: "0xA0b86991c6218b36c1d19D4a2e9Eb0cE3606eB48",
      symbol: "USDC",
    },
    collateralToken: {
      address: "0xFeDC5f4a6c38211c1338aa411018DFAf26612c08",
      symbol: "SPYon",
    },
  },
  {
    id: "0x82076a47f01513bb21a227c64f6c358c6748fe007155dac9f56d5524b2f1f512",
    name: "WBTC / wstETH",
    irm: "0x870aC11D48B15DB9a138Cf899d20F13F79Ba00BC",
    lltv: "915000000000000000",
    oracle: "0xAe12416c1F21B0698c27fe042D9309C83baC6597",
    loanToken: {
      address: "0x2260FAC5E5542a773Aa44fBCfeDf7C193bc2C599",
      symbol: "WBTC",
    },
    collateralToken: {
      address: "0x7f39C581F595B53c5cb19bD0b3f8dA6c935E2Ca0",
      symbol: "wstETH",
    },
  },
  {
    id: "0xcec858380cba2d9ca710fce3ce864d74c3f620d53826f69d08508902e09be86f",
    name: "USDT / USDe",
    irm: "0x870aC11D48B15DB9a138Cf899d20F13F79Ba00BC",
    lltv: "915000000000000000",
    oracle: "0xAf5060C11D3E8325a8ECF84c07fAB7Ac2297A72d",
    loanToken: {
      address: "0xdAC17F958D2ee523a2206206994597C13D831ec7",
      symbol: "USDT",
    },
    collateralToken: {
      address: "0x4c9EDD5852cd905f086C759E8383e09bff1E68B3",
      symbol: "USDe",
    },
  },
  {
    id: "0xaa805b43e61bba8a44e225057b4f1749e2fdd8c3c77abb4ef868c8c19d668281",
    name: "USDC / CASH+",
    irm: "0x870aC11D48B15DB9a138Cf899d20F13F79Ba00BC",
    lltv: "860000000000000000",
    oracle: "0x9fD1d2fFD1a156C01dC2D98dD80E96E75ADff351",
    loanToken: {
      address: "0xA0b86991c6218b36c1d19D4a2e9Eb0cE3606eB48",
      symbol: "USDC",
    },
    collateralToken: {
      address: "0x498D9329555471bF6073A5f2D047F746d522A373",
      symbol: "CASH+",
    },
  },
  {
    id: "0xab5423d55497b642df74011621b4c72a3c9b446e8800cf988644bcdbd747d58f",
    name: "EURe / wbC3M",
    irm: "0x870aC11D48B15DB9a138Cf899d20F13F79Ba00BC",
    lltv: "980000000000000000",
    oracle: "0xFf3b8bA537BC156e38dE00b1465EB174ae31d799",
    loanToken: {
      address: "0x3231Cb76718CDeF2155FC47b5286d82e6eDA273f",
      symbol: "EURe",
    },
    collateralToken: {
      address: "0x95D7337d43340E2721960Dc402D9b9117f0d81a2",
      symbol: "wbC3M",
    },
  },
  {
    id: "0x83b7ad16905809ea36482f4fbf6cfee9c9f316d128de9a5da1952607d5e4df5e",
    name: "USDC / csUSDL",
    irm: "0x870aC11D48B15DB9a138Cf899d20F13F79Ba00BC",
    lltv: "965000000000000000",
    oracle: "0xDDBCAAc63306428D10ff4C6832caE1991244C056",
    loanToken: {
      address: "0xA0b86991c6218b36c1d19D4a2e9Eb0cE3606eB48",
      symbol: "USDC",
    },
    collateralToken: {
      address: "0xbEeFc011e94f43b8B7b455eBaB290C7Ab4E216f1",
      symbol: "csUSDL",
    },
  },
  {
    id: "0xc576cddfd1ee8332d683417548801d6835fa15fb2332a647452248987a8eded3",
    name: "PYUSD / wbIB01",
    irm: "0x870aC11D48B15DB9a138Cf899d20F13F79Ba00BC",
    lltv: "965000000000000000",
    oracle: "0xf71C9A825E7da621d6C1BfaFdcad80a78642Cb40",
    loanToken: {
      address: "0x6c3ea9036406852006290770BEdFcAbA0e23A0e8",
      symbol: "PYUSD",
    },
    collateralToken: {
      address: "0xcA2A7068e551d5C4482eb34880b194E4b945712F",
      symbol: "wbIB01",
    },
  },
  {
    id: "0x03157b7411956c938c497a28d3d2efdc2761a6f659a0397b29285766f7b9bc0c",
    name: "USDC / tacUSD",
    irm: "0x870aC11D48B15DB9a138Cf899d20F13F79Ba00BC",
    lltv: "915000000000000000",
    oracle: "0x2bE2Ed266AcE03009bf613F9100420FD2F56be75",
    loanToken: {
      address: "0xA0b86991c6218b36c1d19D4a2e9Eb0cE3606eB48",
      symbol: "USDC",
    },
    collateralToken: {
      address: "0x699e04F98dE2Fc395a7dcBf36B48EC837A976490",
      symbol: "tacUSD",
    },
  },
  {
    id: "0x185df29d35001b5657c9c964284ddbeee83a40c83e6c6e89432463e2157e075c",
    name: "USDC / PT-lvlUSD-29MAY2025",
    irm: "0x870aC11D48B15DB9a138Cf899d20F13F79Ba00BC",
    lltv: "915000000000000000",
    oracle: "0xC0EFB90F40e8Dd4CB3bC20837D30E388549a8405",
    loanToken: {
      address: "0xA0b86991c6218b36c1d19D4a2e9Eb0cE3606eB48",
      symbol: "USDC",
    },
    collateralToken: {
      address: "0x9BcA74F805AB0a22DDD0886dB0942199a0feBa71",
      symbol: "PT-lvlUSD-29MAY2025",
    },
  },
  {
    id: "0xcaed724b01632abce28ebf87f72c918174a2300341296315bbfa685abb23d46f",
    name: "USDT / hsUSDf",
    irm: "0x870aC11D48B15DB9a138Cf899d20F13F79Ba00BC",
    lltv: "915000000000000000",
    oracle: "0xb1C05B323C66CBe087eC79Ae2eeEf8FC7aFa3F40",
    loanToken: {
      address: "0xdAC17F958D2ee523a2206206994597C13D831ec7",
      symbol: "USDT",
    },
    collateralToken: {
      address: "0xfD953337376000F142dDa1aB4d6a2c32a2f15F7b",
      symbol: "hsUSDf",
    },
  },
  {
    id: "0x828cfff0521d112618241c523bfc569c9b987d9dd8c525ce7d2f05c8ddbb4450",
    name: "USDC / hsUSDf",
    irm: "0x870aC11D48B15DB9a138Cf899d20F13F79Ba00BC",
    lltv: "915000000000000000",
    oracle: "0xb1C05B323C66CBe087eC79Ae2eeEf8FC7aFa3F40",
    loanToken: {
      address: "0xA0b86991c6218b36c1d19D4a2e9Eb0cE3606eB48",
      symbol: "USDC",
    },
    collateralToken: {
      address: "0xfD953337376000F142dDa1aB4d6a2c32a2f15F7b",
      symbol: "hsUSDf",
    },
  },
  {
    id: "0xfa87949abc5866c303f172dccd59fbd57591dee9233b4cd90035906a689eff48",
    name: "USDC / DUSD",
    irm: "0x870aC11D48B15DB9a138Cf899d20F13F79Ba00BC",
    lltv: "915000000000000000",
    oracle: "0x945aBbf104bCE0E310Cb08aa415D04277bF0C146",
    loanToken: {
      address: "0xA0b86991c6218b36c1d19D4a2e9Eb0cE3606eB48",
      symbol: "USDC",
    },
    collateralToken: {
      address: "0x1e33E98aF620F1D563fcD3cfd3C75acE841204ef",
      symbol: "DUSD",
    },
  },
  {
    id: "0x6bf042818eade8df169e915e9a496d1d8b53f41bf3459b5a72666fb18ed68266",
    name: "USDC / splDXY-BULL",
    irm: "0x870aC11D48B15DB9a138Cf899d20F13F79Ba00BC",
    lltv: "915000000000000000",
    oracle: "0xCDF488746af18804d7446751D075Df7Fc27B53d0",
    loanToken: {
      address: "0xA0b86991c6218b36c1d19D4a2e9Eb0cE3606eB48",
      symbol: "USDC",
    },
    collateralToken: {
      address: "0x8dbcF452799f50D3382105a19FdBfA57B7f29C73",
      symbol: "splDXY-BULL",
    },
  },
  {
    id: "0x2ded00f9b5591ac60f7df01f5776dec67f7d7f977885ad1a6c16aab6aed66131",
    name: "USDC / splDXY-BEAR",
    irm: "0x870aC11D48B15DB9a138Cf899d20F13F79Ba00BC",
    lltv: "915000000000000000",
    oracle: "0xA4e55909A631ea8A4efF407108f9E6382e84A67C",
    loanToken: {
      address: "0xA0b86991c6218b36c1d19D4a2e9Eb0cE3606eB48",
      symbol: "USDC",
    },
    collateralToken: {
      address: "0xDC7366b8BB83f9ABa2B4F989194D6c03D0A20DE9",
      symbol: "splDXY-BEAR",
    },
  },
  {
    id: "0x9b966d26e14749cdf3be6fcf44ef404f1428b3c2f8c9e9a5172437e440597715",
    name: "USDC / COMP",
    irm: "0x870aC11D48B15DB9a138Cf899d20F13F79Ba00BC",
    lltv: "625000000000000000",
    oracle: "0x1e96338CBF45c0432C22A40729335050a9855F53",
    loanToken: {
      address: "0xA0b86991c6218b36c1d19D4a2e9Eb0cE3606eB48",
      symbol: "USDC",
    },
    collateralToken: {
      address: "0xc00e94Cb662C3520282E6f5717214004A7f26888",
      symbol: "COMP",
    },
  },
  {
    id: "0x42dcfb38bb98767afb6e38ccf90d59d0d3f0aa216beb3a234f12850323d17536",
    name: "DAI / sUSDe",
    irm: "0x870aC11D48B15DB9a138Cf899d20F13F79Ba00BC",
    lltv: "770000000000000000",
    oracle: "0x5D916980D5Ae1737a8330Bf24dF812b2911Aae25",
    loanToken: {
      address: "0x6B175474E89094C44Da98b954EedeAC495271d0F",
      symbol: "DAI",
    },
    collateralToken: {
      address: "0x9D39A5DE30e57443BfF2A8307A4256c8797A3497",
      symbol: "sUSDe",
    },
  },
  {
    id: "0xd601632eb1345413cde7418f228513bae6ca7fdc52a00384ea9239c2a9f9a935",
    name: "WETH / LsETH",
    irm: "0x870aC11D48B15DB9a138Cf899d20F13F79Ba00BC",
    lltv: "860000000000000000",
    oracle: "0x225088Eb3AeFA007F8FF69ef6E3233C1dF1a4a43",
    loanToken: {
      address: "0xC02aaA39b223FE8D0A0e5C4F27eAD9083C756Cc2",
      symbol: "WETH",
    },
    collateralToken: {
      address: "0x8c1BEd5b9a0928467c9B1341Da1D7BD5e10b6549",
      symbol: "LsETH",
    },
  },
  {
    id: "0xb48bb53f0f2690c71e8813f2dc7ed6fca9ac4b0ace3faa37b4a8e5ece38fa1a2",
    name: "USDC / USD0++",
    irm: "0x870aC11D48B15DB9a138Cf899d20F13F79Ba00BC",
    lltv: "860000000000000000",
    oracle: "0x1325Eb089Ac14B437E78D5D481e32611F6907eF8",
    loanToken: {
      address: "0xA0b86991c6218b36c1d19D4a2e9Eb0cE3606eB48",
      symbol: "USDC",
    },
    collateralToken: {
      address: "0x35D8949372D46B7a3D5A56006AE77B215fc69bC0",
      symbol: "USD0++",
    },
  },
  {
    id: "0xa458018cf1a6e77ebbcc40ba5776ac7990e523b7cc5d0c1e740a4bbc13190d8f",
    name: "DAI / PT-USDS-14AUG2025",
    irm: "0x870aC11D48B15DB9a138Cf899d20F13F79Ba00BC",
    lltv: "965000000000000000",
    oracle: "0xD7c8498fF648CBB9E79d6470cf7F639e696D27A5",
    loanToken: {
      address: "0x6B175474E89094C44Da98b954EedeAC495271d0F",
      symbol: "DAI",
    },
    collateralToken: {
      address: "0xFfEc096c087C13Cc268497B89A613cACE4DF9A48",
      symbol: "PT-USDS-14AUG2025",
    },
  },
  {
    id: "0x5f5bfaa51137098abc90b249c93b6051987877ada76135bb3dd7502b10d184a3",
    name: "USDC / lvlUSD",
    irm: "0x870aC11D48B15DB9a138Cf899d20F13F79Ba00BC",
    lltv: "915000000000000000",
    oracle: "0x6779b2F08611906FcE70c70c596e05859701235d",
    loanToken: {
      address: "0xA0b86991c6218b36c1d19D4a2e9Eb0cE3606eB48",
      symbol: "USDC",
    },
    collateralToken: {
      address: "0x7C1156E515aA1A2E851674120074968C905aAF37",
      symbol: "lvlUSD",
    },
  },
  {
    id: "0x4005ba6eb7d2221fe58102bd320aa6d83c47b212771bc950ab71c5074d9ab0ec",
    name: "USDC / PT-slvlUSD-25SEP2025",
    irm: "0x870aC11D48B15DB9a138Cf899d20F13F79Ba00BC",
    lltv: "915000000000000000",
    oracle: "0x2C459AB29dB32671029725168043d563580217B4",
    loanToken: {
      address: "0xA0b86991c6218b36c1d19D4a2e9Eb0cE3606eB48",
      symbol: "USDC",
    },
    collateralToken: {
      address: "0x2CA5f2C4300450D53214B00546795c1c07B89acB",
      symbol: "PT-slvlUSD-25SEP2025",
    },
  },
  {
    id: "0xab04bdfbeef6de62e3020d44710d6461eccfb901b9659f866844805fca115f2f",
    name: "WBTC / cbBTC",
    irm: "0x870aC11D48B15DB9a138Cf899d20F13F79Ba00BC",
    lltv: "945000000000000000",
    oracle: "0xD776c7be7a06212c0F93eD478d3ba4Ce4fA55D31",
    loanToken: {
      address: "0x2260FAC5E5542a773Aa44fBCfeDf7C193bc2C599",
      symbol: "WBTC",
    },
    collateralToken: {
      address: "0xcbB7C0000aB88B473b1f5aFd9ef808440eed33Bf",
      symbol: "cbBTC",
    },
  },
  {
    id: "0xdf2654405b27b5cf7a8f5fd78337e0440d37cbc797de38b1421752671f0ed3b6",
    name: "USDC / XPC",
    irm: "0x870aC11D48B15DB9a138Cf899d20F13F79Ba00BC",
    lltv: "980000000000000000",
    oracle: "0x45ea97920376A864FB8377163efB6622ebf694fa",
    loanToken: {
      address: "0xA0b86991c6218b36c1d19D4a2e9Eb0cE3606eB48",
      symbol: "USDC",
    },
    collateralToken: {
      address: "0xCE8e559Ac89c2bDC97Bdb5F58705c54dB9cB77dC",
      symbol: "XPC",
    },
  },
  {
    id: "0xfd8493f09eb6203615221378d89f53fcd92ff4f7d62cca87eece9a2fff59e86f",
    name: "DAI / USDe",
    irm: "0x870aC11D48B15DB9a138Cf899d20F13F79Ba00BC",
    lltv: "770000000000000000",
    oracle: "0xaE4750d0813B5E37A51f7629beedd72AF1f9cA35",
    loanToken: {
      address: "0x6B175474E89094C44Da98b954EedeAC495271d0F",
      symbol: "DAI",
    },
    collateralToken: {
      address: "0x4c9EDD5852cd905f086C759E8383e09bff1E68B3",
      symbol: "USDe",
    },
  },
  {
    id: "0x8411eeb07c8e32de0b3784b6b967346a45593bfd8baeb291cc209dc195c7b3ad",
    name: "USDC / PT-USD0++-27MAR2025",
    irm: "0x870aC11D48B15DB9a138Cf899d20F13F79Ba00BC",
    lltv: "915000000000000000",
    oracle: "0xE316c92D2B1f50a53E72461856fD50b2519e5800",
    loanToken: {
      address: "0xA0b86991c6218b36c1d19D4a2e9Eb0cE3606eB48",
      symbol: "USDC",
    },
    collateralToken: {
      address: "0x5BaE9a5D67d1CA5b09B14c91935f635CFBF3b685",
      symbol: "PT-USD0++-27MAR2025",
    },
  },
  {
    id: "0x4e6a548f893de0d63ef3c61e335ebc76c41443a626516e8481284bc1ed63771d",
    name: "USDC / mBASIS",
    irm: "0x870aC11D48B15DB9a138Cf899d20F13F79Ba00BC",
    lltv: "915000000000000000",
    oracle: "0x2E3E64eE52Bd06B3bfA602aeBda8897478d9a5BA",
    loanToken: {
      address: "0xA0b86991c6218b36c1d19D4a2e9Eb0cE3606eB48",
      symbol: "USDC",
    },
    collateralToken: {
      address: "0x2a8c22E3b10036f3AEF5875d04f8441d4188b656",
      symbol: "mBASIS",
    },
  },
  {
    id: "0xbf6687cb042a09451e66ebc11d7716c49fb8ccc75f484f7fab0eed6624bd5838",
    name: "USDC / mMEV",
    irm: "0x870aC11D48B15DB9a138Cf899d20F13F79Ba00BC",
    lltv: "915000000000000000",
    oracle: "0x91C96e6a720CFC294bEB22D059bb6255654d7411",
    loanToken: {
      address: "0xA0b86991c6218b36c1d19D4a2e9Eb0cE3606eB48",
      symbol: "USDC",
    },
    collateralToken: {
      address: "0x030b69280892c888670EDCDCD8B69Fd8026A0BF3",
      symbol: "mMEV",
    },
  },
  {
    id: "0x1f1ca1956b469f17c9b1b4b0290bd00147e23f6c475e7d503eb323839d3643db",
    name: "WETH / yETH",
    irm: "0x870aC11D48B15DB9a138Cf899d20F13F79Ba00BC",
    lltv: "915000000000000000",
    oracle: "0xD1Da32f5A539f85E38B84E2cf83d0588fbE9991F",
    loanToken: {
      address: "0xC02aaA39b223FE8D0A0e5C4F27eAD9083C756Cc2",
      symbol: "WETH",
    },
    collateralToken: {
      address: "0x8464F6eCAe1EA58EC816C13f964030eAb8Ec123A",
      symbol: "yETH",
    },
  },
  {
    id: "0x0ae5b657763648ef56c7ae34854108c51f4306a0ad0bd11473f53cc1d7dbc7ae",
    name: "apxUSD / USDC",
    irm: "0x870aC11D48B15DB9a138Cf899d20F13F79Ba00BC",
    lltv: "965000000000000000",
    oracle: "0x8AEcE772EF6E4438Def7393c4ca96DeEA10576A9",
    loanToken: {
      address: "0x98A878b1Cd98131B271883B390f68D2c90674665",
      symbol: "apxUSD",
    },
    collateralToken: {
      address: "0xA0b86991c6218b36c1d19D4a2e9Eb0cE3606eB48",
      symbol: "USDC",
    },
  },
  {
    id: "0x97bb820669a19ba5fa6de964a466292edd67957849f9631eb8b830c382f58b7f",
    name: "USDC / MKR",
    irm: "0x870aC11D48B15DB9a138Cf899d20F13F79Ba00BC",
    lltv: "770000000000000000",
    oracle: "0x6686788B4315A4F93d822c1Bf73910556FCe2d5a",
    loanToken: {
      address: "0xA0b86991c6218b36c1d19D4a2e9Eb0cE3606eB48",
      symbol: "USDC",
    },
    collateralToken: {
      address: "0x9f8F72aA9304c8B593d555F12eF6589cC3A579A2",
      symbol: "MKR",
    },
  },
  {
    id: "0xc6ae8e71e11ef511acee3f6cc6ad2af67b862877d459e3789905f537c85db5e3",
    name: "DAI / PT-sUSDE-25SEP2025",
    irm: "0x870aC11D48B15DB9a138Cf899d20F13F79Ba00BC",
    lltv: "915000000000000000",
    oracle: "0x26394307806F4DD1ea053EC61CFFCa15613a4573",
    loanToken: {
      address: "0x6B175474E89094C44Da98b954EedeAC495271d0F",
      symbol: "DAI",
    },
    collateralToken: {
      address: "0x9F56094C450763769BA0EA9Fe2876070c0fD5F77",
      symbol: "PT-sUSDE-25SEP2025",
    },
  },
  {
    id: "0x780ae97d04af2ac851520d332fc61328a2a8131c68f9eee0d99c552c428da7ec",
    name: "USDC / PT-wstUSR-1740182579",
    irm: "0x870aC11D48B15DB9a138Cf899d20F13F79Ba00BC",
    lltv: "915000000000000000",
    oracle: "0x4EA91B4cA1AcEDa9444F4d4b1fd9c28b78062C20",
    loanToken: {
      address: "0xA0b86991c6218b36c1d19D4a2e9Eb0cE3606eB48",
      symbol: "USDC",
    },
    collateralToken: {
      address: "0xD0097149AA4CC0d0e1fC99B8BD73fC17dC32C1E9",
      symbol: "PT-wstUSR-1740182579",
    },
  },
  {
    id: "0x21b67f89513da0b0c94af8778134a1ba3f762f944f16208b42cc0663b07eaf05",
    name: "USDC / PT-iUSD-4DEC2025",
    irm: "0x870aC11D48B15DB9a138Cf899d20F13F79Ba00BC",
    lltv: "915000000000000000",
    oracle: "0xbc85ebE0a1C134fFB1C545016540431e060c878C",
    loanToken: {
      address: "0xA0b86991c6218b36c1d19D4a2e9Eb0cE3606eB48",
      symbol: "USDC",
    },
    collateralToken: {
      address: "0xb44cdBEF3145C1c1E772e8228E1154c80e70618e",
      symbol: "PT-iUSD-4DEC2025",
    },
  },
  {
    id: "0xd3c7b3668b91b90f7571817009503826025159111743b95f542730b42c94d3ea",
    name: "USDC / QQQon",
    irm: "0x870aC11D48B15DB9a138Cf899d20F13F79Ba00BC",
    lltv: "625000000000000000",
    oracle: "0x78a9d9BCae51Da68e8A706020B2e895a935Da52C",
    loanToken: {
      address: "0xA0b86991c6218b36c1d19D4a2e9Eb0cE3606eB48",
      symbol: "USDC",
    },
    collateralToken: {
      address: "0x0e397938C1Aa0680954093495B70A9F5e2249aBa",
      symbol: "QQQon",
    },
  },
  {
    id: "0x2545c16bb6edadc9ad720f8d0a705d7637d1d0d8deb50b79b829a2795ef2cf74",
    name: "USDT / PENDLE-LPT-WRAPPED",
    irm: "0x870aC11D48B15DB9a138Cf899d20F13F79Ba00BC",
    lltv: "915000000000000000",
    oracle: "0x5FAB77bAf915FC1a4a5ba2Ec8E1E99b24F4F95C8",
    loanToken: {
      address: "0xdAC17F958D2ee523a2206206994597C13D831ec7",
      symbol: "USDT",
    },
    collateralToken: {
      address: "0x5d4573Aa9759870fD7CeB62A58f75A5F5559360a",
      symbol: "PENDLE-LPT-WRAPPED",
    },
  },
  {
    id: "0x346afa2b6d528222a2f9721ded6e7e2c40ac94877a598f5dae5013c651d2a462",
    name: "USDC / PT-sUSDE-27MAR2025",
    irm: "0x870aC11D48B15DB9a138Cf899d20F13F79Ba00BC",
    lltv: "915000000000000000",
    oracle: "0x9c0174fE7748F318dcB7300b93B170b6026280B0",
    loanToken: {
      address: "0xA0b86991c6218b36c1d19D4a2e9Eb0cE3606eB48",
      symbol: "USDC",
    },
    collateralToken: {
      address: "0xE00bd3Df25fb187d6ABBB620b3dfd19839947b81",
      symbol: "PT-sUSDE-27MAR2025",
    },
  },
  {
    id: "0x7b6129564616bf5c2390d7c2b202d48fb1798146bdb4b90eb0dad035607a32ec",
    name: "USDC / PENDLE-LPT-WRAPPED",
    irm: "0x870aC11D48B15DB9a138Cf899d20F13F79Ba00BC",
    lltv: "860000000000000000",
    oracle: "0x03A9b374D8cED8489e64498167Efc72BCD5112Ca",
    loanToken: {
      address: "0xA0b86991c6218b36c1d19D4a2e9Eb0cE3606eB48",
      symbol: "USDC",
    },
    collateralToken: {
      address: "0x2ec5F3E6EF81117C159e7C79C436f474F08b94c3",
      symbol: "PENDLE-LPT-WRAPPED",
    },
  },
  {
    id: "0xb0a9ac81a8c6a5274aa1a8337aed35a2cb2cd4feb5c6d3b39d41f234fbf2955b",
    name: "USDT / PT-USDe-25SEP2025",
    irm: "0x870aC11D48B15DB9a138Cf899d20F13F79Ba00BC",
    lltv: "915000000000000000",
    oracle: "0xe6aBD3B78Abbb1cc1Ee76c5c3689Aa9646481Fbb",
    loanToken: {
      address: "0xdAC17F958D2ee523a2206206994597C13D831ec7",
      symbol: "USDT",
    },
    collateralToken: {
      address: "0xBC6736d346a5eBC0dEbc997397912CD9b8FAe10a",
      symbol: "PT-USDe-25SEP2025",
    },
  },
  {
    id: "0x83dfc8c6f626e74cdbf7d718648030601467b4e0fe9016f90068449afd7cbc44",
    name: "USDC / v1rRLP",
    irm: "0x870aC11D48B15DB9a138Cf899d20F13F79Ba00BC",
    lltv: "860000000000000000",
    oracle: "0xbB4C55D68E8D39666BC1FC388c98341acB77a588",
    loanToken: {
      address: "0xA0b86991c6218b36c1d19D4a2e9Eb0cE3606eB48",
      symbol: "USDC",
    },
    collateralToken: {
      address: "0xe687787e9A7D17cbc6125772E55EFA7471cC44eE",
      symbol: "v1rRLP",
    },
  },
  {
    id: "0x60154d71ec96b7aee2864326662cb731172f1ebd6ca0e64af9bc8659831ed0ff",
    name: "USDC / yUSD",
    irm: "0x870aC11D48B15DB9a138Cf899d20F13F79Ba00BC",
    lltv: "915000000000000000",
    oracle: "0x87A45c3A7a5f10D5a02531eF26c3bc2BC2011083",
    loanToken: {
      address: "0xA0b86991c6218b36c1d19D4a2e9Eb0cE3606eB48",
      symbol: "USDC",
    },
    collateralToken: {
      address: "0x19Ebd191f7A24ECE672ba13A302212b5eF7F35cb",
      symbol: "yUSD",
    },
  },
  {
    id: "0x544b0a093b130a3fb01b72a1279ab848575f049c73da3b5c9c718f9350a1519c",
    name: "USDC / PT-csUSDL-31JUL2025",
    irm: "0x870aC11D48B15DB9a138Cf899d20F13F79Ba00BC",
    lltv: "915000000000000000",
    oracle: "0xB54673451c1e5Fd5CD97763954A6Fb843A5f8e47",
    loanToken: {
      address: "0xA0b86991c6218b36c1d19D4a2e9Eb0cE3606eB48",
      symbol: "USDC",
    },
    collateralToken: {
      address: "0xf10A134A987E22ffa9463570A6D1eb92a63Fc178",
      symbol: "PT-csUSDL-31JUL2025",
    },
  },
  {
    id: "0x23aec60d42e0f4c38342f054d2b7acff4390dc6b0ed8826f24d3920eece8ce5d",
    name: "USDC / yvETH",
    irm: "0x870aC11D48B15DB9a138Cf899d20F13F79Ba00BC",
    lltv: "770000000000000000",
    oracle: "0xc6C4f6c7A758DB88e9df5C702cE74F8753820535",
    loanToken: {
      address: "0xA0b86991c6218b36c1d19D4a2e9Eb0cE3606eB48",
      symbol: "USDC",
    },
    collateralToken: {
      address: "0x52817c7AFB99eb6724B0DCc1DEA561C959df50A1",
      symbol: "yvETH",
    },
  },
  {
    id: "0x8d177cc2597296e8ff4816be51fe2482add89de82bdfaba3118c7948a6b2bc02",
    name: "USDC / PT-sUSDE-29MAY2025",
    irm: "0x870aC11D48B15DB9a138Cf899d20F13F79Ba00BC",
    lltv: "915000000000000000",
    oracle: "0xcc62A6fad56ee6277250eabe49959002dA42191C",
    loanToken: {
      address: "0xA0b86991c6218b36c1d19D4a2e9Eb0cE3606eB48",
      symbol: "USDC",
    },
    collateralToken: {
      address: "0xb7de5dFCb74d25c2f21841fbd6230355C50d9308",
      symbol: "PT-sUSDE-29MAY2025",
    },
  },
  {
    id: "0x8b1bc4d682b04a16309a8adf77b35de0c42063a7944016cfc37a79ccac0007b6",
    name: "USDC / slvlUSD",
    irm: "0x870aC11D48B15DB9a138Cf899d20F13F79Ba00BC",
    lltv: "915000000000000000",
    oracle: "0x50356C32c984BF921a0eFB1F4264Ac328e429c2c",
    loanToken: {
      address: "0xA0b86991c6218b36c1d19D4a2e9Eb0cE3606eB48",
      symbol: "USDC",
    },
    collateralToken: {
      address: "0x4737D9b4592B40d51e110b94c9C043c6654067Ae",
      symbol: "slvlUSD",
    },
  },
  {
    id: "0x9b3085076cf24f9cf8d6405af8a6fc32f9d69c63727be646940e448036fee33d",
    name: "USDC / stGLD",
    irm: "0x870aC11D48B15DB9a138Cf899d20F13F79Ba00BC",
    lltv: "770000000000000000",
    oracle: "0x41bffa349e35Cdcd4794a4FD1a61d35e5418C780",
    loanToken: {
      address: "0xA0b86991c6218b36c1d19D4a2e9Eb0cE3606eB48",
      symbol: "USDC",
    },
    collateralToken: {
      address: "0x8d301801d899dC81fEabBDE69407A53b82bdBF19",
      symbol: "stGLD",
    },
  },
  {
    id: "0x2daab4eb520e7eab0a6d432d2edfb11775c9544a6b5e441c2e0f74abcd48f975",
    name: "USDC / PT-USD0++-31OCT2024",
    irm: "0x870aC11D48B15DB9a138Cf899d20F13F79Ba00BC",
    lltv: "860000000000000000",
    oracle: "0xf782f01FF276a28D3c43e8034aD84508671c9ff3",
    loanToken: {
      address: "0xA0b86991c6218b36c1d19D4a2e9Eb0cE3606eB48",
      symbol: "USDC",
    },
    collateralToken: {
      address: "0x270d664d2Fc7D962012a787Aec8661CA83DF24EB",
      symbol: "PT-USD0++-31OCT2024",
    },
  },
  {
    id: "0xba761af4134efb0855adfba638945f454f0a704af11fc93439e20c7c5ebab942",
    name: "WETH / rsETH",
    irm: "0x870aC11D48B15DB9a138Cf899d20F13F79Ba00BC",
    lltv: "945000000000000000",
    oracle: "0x2A2658Fc208Ed00e11D96d3F7470618924466877",
    loanToken: {
      address: "0xC02aaA39b223FE8D0A0e5C4F27eAD9083C756Cc2",
      symbol: "WETH",
    },
    collateralToken: {
      address: "0xA1290d69c65A6Fe4DF752f95823fae25cB99e5A7",
      symbol: "rsETH",
    },
  },
  {
    id: "0xec97655fab06b53bfad9d8c2358768aed5a1c97b204d3e51e2a7cb0cb786a264",
    name: "WETH / hgETH",
    irm: "0x870aC11D48B15DB9a138Cf899d20F13F79Ba00BC",
    lltv: "915000000000000000",
    oracle: "0x56DBC0F2784cd959e57FCC9Cd83C3B7A24eE678C",
    loanToken: {
      address: "0xC02aaA39b223FE8D0A0e5C4F27eAD9083C756Cc2",
      symbol: "WETH",
    },
    collateralToken: {
      address: "0xc824A08dB624942c5E5F330d56530cD1598859fD",
      symbol: "hgETH",
    },
  },
  {
    id: "0x608929d6de2a10bacf1046ff157ae38df5b9f466fb89413211efb8f63c63833a",
    name: "USDT / WETH",
    irm: "0x870aC11D48B15DB9a138Cf899d20F13F79Ba00BC",
    lltv: "860000000000000000",
    oracle: "0xe9eE579684716c7Bb837224F4c7BeEfA4f1F3d7f",
    loanToken: {
      address: "0xdAC17F958D2ee523a2206206994597C13D831ec7",
      symbol: "USDT",
    },
    collateralToken: {
      address: "0xC02aaA39b223FE8D0A0e5C4F27eAD9083C756Cc2",
      symbol: "WETH",
    },
  },
  {
    id: "0x2a9a5c436719badcfadbad3ad8e8179a160ded758603eaa03a883f922a1790d3",
    name: "USDC / PT-sNUSD-5MAR2026",
    irm: "0x870aC11D48B15DB9a138Cf899d20F13F79Ba00BC",
    lltv: "770000000000000000",
    oracle: "0xe8465B52E106d98157d82b46cA566CB9d09482A9",
    loanToken: {
      address: "0xA0b86991c6218b36c1d19D4a2e9Eb0cE3606eB48",
      symbol: "USDC",
    },
    collateralToken: {
      address: "0x54Bf2659B5CdFd86b75920e93C0844c0364F5166",
      symbol: "PT-sNUSD-5MAR2026",
    },
  },
  {
    id: "0x931944ee9a9f91f26b1e8f6339089bbf1d6f9c20b5845742da8633f7297cfa66",
    name: "WETH / n-LP-OETH-WETH",
    irm: "0x870aC11D48B15DB9a138Cf899d20F13F79Ba00BC",
    lltv: "915000000000000000",
    oracle: "0x2716561755154Eef59Bc48Eb13712510b27F167F",
    loanToken: {
      address: "0xC02aaA39b223FE8D0A0e5C4F27eAD9083C756Cc2",
      symbol: "WETH",
    },
    collateralToken: {
      address: "0x2716561755154Eef59Bc48Eb13712510b27F167F",
      symbol: "n-LP-OETH-WETH",
    },
  },
  {
    id: "0xb7ad412532006bf876534ccae59900ddd9d1d1e394959065cb39b12b22f94ff5",
    name: "WETH / agETH",
    irm: "0x870aC11D48B15DB9a138Cf899d20F13F79Ba00BC",
    lltv: "915000000000000000",
    oracle: "0xcb6a6fDFdb18eC9A004465aEf74ff9092FD4f89A",
    loanToken: {
      address: "0xC02aaA39b223FE8D0A0e5C4F27eAD9083C756Cc2",
      symbol: "WETH",
    },
    collateralToken: {
      address: "0xe1B4d34E8754600962Cd944B535180Bd758E6c2e",
      symbol: "agETH",
    },
  },
  {
    id: "0xf9acc677910cc17f650416a22e2a14d5da7ccb9626db18f1bf94efe64f92b372",
    name: "USDC / WETH",
    irm: "0x870aC11D48B15DB9a138Cf899d20F13F79Ba00BC",
    lltv: "915000000000000000",
    oracle: "0xdC6fd5831277c693b1054e19E94047cB37c77615",
    loanToken: {
      address: "0xA0b86991c6218b36c1d19D4a2e9Eb0cE3606eB48",
      symbol: "USDC",
    },
    collateralToken: {
      address: "0xC02aaA39b223FE8D0A0e5C4F27eAD9083C756Cc2",
      symbol: "WETH",
    },
  },
  {
    id: "0x9c765f69d8a8e40d2174824bc5107d05d7f0d0f81181048c9403262aeb1ab457",
    name: "USDC / LINK",
    irm: "0x870aC11D48B15DB9a138Cf899d20F13F79Ba00BC",
    lltv: "770000000000000000",
    oracle: "0x2b6eFE10F7C7c0f2fD172213ad99017855a8E512",
    loanToken: {
      address: "0xA0b86991c6218b36c1d19D4a2e9Eb0cE3606eB48",
      symbol: "USDC",
    },
    collateralToken: {
      address: "0x514910771AF9Ca656af840dff83E8264EcF986CA",
      symbol: "LINK",
    },
  },
  {
    id: "0x7a5d67805cb78fad2596899e0c83719ba89df353b931582eb7d3041fd5a06dc8",
    name: "USDC / PT-USDe-25SEP2025",
    irm: "0x870aC11D48B15DB9a138Cf899d20F13F79Ba00BC",
    lltv: "915000000000000000",
    oracle: "0xe6aBD3B78Abbb1cc1Ee76c5c3689Aa9646481Fbb",
    loanToken: {
      address: "0xA0b86991c6218b36c1d19D4a2e9Eb0cE3606eB48",
      symbol: "USDC",
    },
    collateralToken: {
      address: "0xBC6736d346a5eBC0dEbc997397912CD9b8FAe10a",
      symbol: "PT-USDe-25SEP2025",
    },
  },
  {
    id: "0xcacd4c39af872ddecd48b650557ff5bcc7d3338194c0f5b2038e0d4dec5dc022",
    name: "WETH / rswETH",
    irm: "0x870aC11D48B15DB9a138Cf899d20F13F79Ba00BC",
    lltv: "945000000000000000",
    oracle: "0x56e2d0957d2376dF4A0519b91D1Fa19D2d63bd9b",
    loanToken: {
      address: "0xC02aaA39b223FE8D0A0e5C4F27eAD9083C756Cc2",
      symbol: "WETH",
    },
    collateralToken: {
      address: "0xFAe103DC9cf190eD75350761e95403b7b8aFa6c0",
      symbol: "rswETH",
    },
  },
  {
    id: "0xca8d00403e4abd941d991e2410dc8b990c04ccf5d7bb20e8cd284959c851d0aa",
    name: "USDC / LBTC",
    irm: "0x870aC11D48B15DB9a138Cf899d20F13F79Ba00BC",
    lltv: "860000000000000000",
    oracle: "0xB962ecE4655CC4d9c8FC564C02F91154e0832d72",
    loanToken: {
      address: "0xA0b86991c6218b36c1d19D4a2e9Eb0cE3606eB48",
      symbol: "USDC",
    },
    collateralToken: {
      address: "0x8236a87084f8B84306f72007F36F2618A5634494",
      symbol: "LBTC",
    },
  },
  {
    id: "0xe7399fdebc318d76dfec7356caafcf8cd4b91287e139a3ec423f09aeeb656fc4",
    name: "USDC / DAI",
    irm: "0x870aC11D48B15DB9a138Cf899d20F13F79Ba00BC",
    lltv: "860000000000000000",
    oracle: "0x50537098C66075f62E1234e6F9a394111d5D22ed",
    loanToken: {
      address: "0xA0b86991c6218b36c1d19D4a2e9Eb0cE3606eB48",
      symbol: "USDC",
    },
    collateralToken: {
      address: "0x6B175474E89094C44Da98b954EedeAC495271d0F",
      symbol: "DAI",
    },
  },
  {
    id: "0x3f246a31d3583a4c0ab8d83ea46907b188b8b463edb1c45af62b6265335084ee",
    name: "USDC / PENDLE-LPT-WRAPPED",
    irm: "0x870aC11D48B15DB9a138Cf899d20F13F79Ba00BC",
    lltv: "860000000000000000",
    oracle: "0x5c7907f8d8F41D97a844350116e0A500B507351C",
    loanToken: {
      address: "0xA0b86991c6218b36c1d19D4a2e9Eb0cE3606eB48",
      symbol: "USDC",
    },
    collateralToken: {
      address: "0x5F0E654410a281E7Ed04c370B9D25d2A0286b935",
      symbol: "PENDLE-LPT-WRAPPED",
    },
  },
  {
    id: "0xe256ade8f3adad7ac2ff44de16e82ea39ad1303c71555204e14d9633aff21ebe",
    name: "WETH / n-st-weETH",
    irm: "0x870aC11D48B15DB9a138Cf899d20F13F79Ba00BC",
    lltv: "945000000000000000",
    oracle: "0x7f723feE1E65A7d26bE51A05AF0B5eFEE4a7d5ae",
    loanToken: {
      address: "0xC02aaA39b223FE8D0A0e5C4F27eAD9083C756Cc2",
      symbol: "WETH",
    },
    collateralToken: {
      address: "0x7f723feE1E65A7d26bE51A05AF0B5eFEE4a7d5ae",
      symbol: "n-st-weETH",
    },
  },
  {
    id: "0x9c7cda0f3bb23579bbeed7186b4de76239d68eca71d905b1e06fd10867b9dcfc",
    name: "wstETH / ezETH",
    irm: "0x870aC11D48B15DB9a138Cf899d20F13F79Ba00BC",
    lltv: "945000000000000000",
    oracle: "0xf12e6702c3582C7dA9602A31b2b2807d698284C6",
    loanToken: {
      address: "0x7f39C581F595B53c5cb19bD0b3f8dA6c935E2Ca0",
      symbol: "wstETH",
    },
    collateralToken: {
      address: "0xbf5495Efe5DB9ce00f80364C8B423567e58d2110",
      symbol: "ezETH",
    },
  },
  {
    id: "0xbc552f0b14dd6f8e60b760a534ac1d8613d3539153b4d9675d697e048f2edc7e",
    name: "USDC / PT-sUSDE-31JUL2025",
    irm: "0x870aC11D48B15DB9a138Cf899d20F13F79Ba00BC",
    lltv: "915000000000000000",
    oracle: "0x1376913337ceC523B4DDEAD8a60eDb1fA43fF1E3",
    loanToken: {
      address: "0xA0b86991c6218b36c1d19D4a2e9Eb0cE3606eB48",
      symbol: "USDC",
    },
    collateralToken: {
      address: "0x3b3fB9C57858EF816833dC91565EFcd85D96f634",
      symbol: "PT-sUSDE-31JUL2025",
    },
  },
  {
    id: "0xfc5578b6f3b424dd5c5d34471699b302b320913010f8870fe0276cfaa5d925f2",
    name: "USDC / sBTCD",
    irm: "0x870aC11D48B15DB9a138Cf899d20F13F79Ba00BC",
    lltv: "770000000000000000",
    oracle: "0x2ED5777431184D2fe33dd993A776960a2FD408B7",
    loanToken: {
      address: "0xA0b86991c6218b36c1d19D4a2e9Eb0cE3606eB48",
      symbol: "USDC",
    },
    collateralToken: {
      address: "0x3BC801419479865B24b4d32faB0Bf64638Abbd5f",
      symbol: "sBTCD",
    },
  },
  {
    id: "0x8abcf6d7bb7a4bd8720fef5fa27917ac50a88cf2bf1a97002f43fec3919a373c",
    name: "USDC / stcUSD",
    irm: "0x870aC11D48B15DB9a138Cf899d20F13F79Ba00BC",
    lltv: "860000000000000000",
    oracle: "0xb1E92b4e1E546B02a0f07500e68bE1380Cb694A1",
    loanToken: {
      address: "0xA0b86991c6218b36c1d19D4a2e9Eb0cE3606eB48",
      symbol: "USDC",
    },
    collateralToken: {
      address: "0x88887bE419578051FF9F4eb6C858A951921D8888",
      symbol: "stcUSD",
    },
  },
  {
    id: "0xc4e18eb6d0e9b0fa90a15bc0a98190cbf3d5ba763af410346f5174b014cefd8d",
    name: "AUSD / sUSDe",
    irm: "0x870aC11D48B15DB9a138Cf899d20F13F79Ba00BC",
    lltv: "945000000000000000",
    oracle: "0x873CD44b860DEDFe139f93e12A4AcCa0926Ffb87",
    loanToken: {
      address: "0x00000000eFE302BEAA2b3e6e1b18d08D69a9012a",
      symbol: "AUSD",
    },
    collateralToken: {
      address: "0x9D39A5DE30e57443BfF2A8307A4256c8797A3497",
      symbol: "sUSDe",
    },
  },
  {
    id: "0xe37784e5ff9c2795395c5a41a0cb7ae1da4a93d67bfdd8654b9ff86b3065941c",
    name: "DAI / PT-sUSDE-26DEC2024",
    irm: "0x870aC11D48B15DB9a138Cf899d20F13F79Ba00BC",
    lltv: "915000000000000000",
    oracle: "0x81E5E28F33D314e9211885d6f0F4080E755e4595",
    loanToken: {
      address: "0x6B175474E89094C44Da98b954EedeAC495271d0F",
      symbol: "DAI",
    },
    collateralToken: {
      address: "0xEe9085fC268F6727d5D4293dBABccF901ffDCC29",
      symbol: "PT-sUSDE-26DEC2024",
    },
  },
  {
    id: "0x3889dee51674c6e728f7d05f11a3407c6853e433a0e63f8febbc45887a26a475",
    name: "USDC / MC-USR",
    irm: "0x870aC11D48B15DB9a138Cf899d20F13F79Ba00BC",
    lltv: "915000000000000000",
    oracle: "0x96d7c2C12339e44d2C74878227147b54fF6Ff3a7",
    loanToken: {
      address: "0xA0b86991c6218b36c1d19D4a2e9Eb0cE3606eB48",
      symbol: "USDC",
    },
    collateralToken: {
      address: "0xD50DA5F859811A91fD1876C9461fD39c23C747Ad",
      symbol: "MC-USR",
    },
  },
  {
    id: "0xc978f01522ff64adafd91856065d602c56e326a0368b895bd9244d5998e60076",
    name: "USDC / PT-savUSD-14MAY2026",
    irm: "0x870aC11D48B15DB9a138Cf899d20F13F79Ba00BC",
    lltv: "915000000000000000",
    oracle: "0xe4697081220447D1646f9c87f60Fc43aA56a3cdE",
    loanToken: {
      address: "0xA0b86991c6218b36c1d19D4a2e9Eb0cE3606eB48",
      symbol: "USDC",
    },
    collateralToken: {
      address: "0x606B5C773dC4D6E625C411cF60565f8c30C467d2",
      symbol: "PT-savUSD-14MAY2026",
    },
  },
  {
    id: "0x9a22b395719a866a9d99d6717c2c2cc1da5d6d6658abaeb8481fe28ef2ee56b9",
    name: "USDT / LBTC",
    irm: "0x870aC11D48B15DB9a138Cf899d20F13F79Ba00BC",
    lltv: "860000000000000000",
    oracle: "0xDCc04fFaCD7B49035cCdBbbA59a5f955944129DB",
    loanToken: {
      address: "0xdAC17F958D2ee523a2206206994597C13D831ec7",
      symbol: "USDT",
    },
    collateralToken: {
      address: "0x8236a87084f8B84306f72007F36F2618A5634494",
      symbol: "LBTC",
    },
  },
  {
    id: "0x3c83f77bde9541f8d3d82533b19bbc1f97eb2f1098bb991728acbfbede09cc5d",
    name: "WETH / rETH",
    irm: "0x870aC11D48B15DB9a138Cf899d20F13F79Ba00BC",
    lltv: "945000000000000000",
    oracle: "0x1b4A3F92e5Fffd1d35A98751c9FE4472483579bB",
    loanToken: {
      address: "0xC02aaA39b223FE8D0A0e5C4F27eAD9083C756Cc2",
      symbol: "WETH",
    },
    collateralToken: {
      address: "0xae78736Cd615f374D3085123A210448E74Fc6393",
      symbol: "rETH",
    },
  },
  {
    id: "0x55724b06cc5a9a985d07b0b8e291cec90ca6fc462e044fa700431e08f31e5928",
    name: "WETH / wbrETH",
    irm: "0x870aC11D48B15DB9a138Cf899d20F13F79Ba00BC",
    lltv: "915000000000000000",
    oracle: "0x6067E3828fB6B3d863B235668DAd8AaC5A14ed00",
    loanToken: {
      address: "0xC02aaA39b223FE8D0A0e5C4F27eAD9083C756Cc2",
      symbol: "WETH",
    },
    collateralToken: {
      address: "0x91094D333e018f81874D62E27522479BEC131b5f",
      symbol: "wbrETH",
    },
  },
  {
    id: "0xf3c6624976f69d18911f7c21ea4d2da926a8554963dd347ced9c1a60ac4ff74e",
    name: "USDC / PENDLE-LPT-WRAPPED",
    irm: "0x870aC11D48B15DB9a138Cf899d20F13F79Ba00BC",
    lltv: "915000000000000000",
    oracle: "0xF5fc624BC71074524E5960808D10a7EEf582e0fE",
    loanToken: {
      address: "0xA0b86991c6218b36c1d19D4a2e9Eb0cE3606eB48",
      symbol: "USDC",
    },
    collateralToken: {
      address: "0x7bAFb26A485bf7bB4B0D0b02996c79C5Af6493bc",
      symbol: "PENDLE-LPT-WRAPPED",
    },
  },
  {
    id: "0xbed987dd46049adb1ff34de8ef761a9da3b08890fa7fff629ea9b66d049de823",
    name: "USDC / sUSDf",
    irm: "0x870aC11D48B15DB9a138Cf899d20F13F79Ba00BC",
    lltv: "915000000000000000",
    oracle: "0xC793DeA5e437BF4BC4d8F24C7F3b9f31BC6892A7",
    loanToken: {
      address: "0xA0b86991c6218b36c1d19D4a2e9Eb0cE3606eB48",
      symbol: "USDC",
    },
    collateralToken: {
      address: "0xc8CF6D7991f15525488b2A83Df53468D682Ba4B0",
      symbol: "sUSDf",
    },
  },
  {
    id: "0xeec6c7e2ddb7578f2a7d86fc11cf9da005df34452ad9b9189c51266216f5d71b",
    name: "USDC / PT-wstUSR-25SEP2025",
    irm: "0x870aC11D48B15DB9a138Cf899d20F13F79Ba00BC",
    lltv: "915000000000000000",
    oracle: "0x5CB13E10beb0Bc0760988F16196b016536afc6c0",
    loanToken: {
      address: "0xA0b86991c6218b36c1d19D4a2e9Eb0cE3606eB48",
      symbol: "USDC",
    },
    collateralToken: {
      address: "0x23E60d1488525bf4685f53b3aa8E676c30321066",
      symbol: "PT-wstUSR-25SEP2025",
    },
  },
  {
    id: "0xaa6189e70bebc2c6b8e95cdb8bc7999f00618c2ebdb65cee7b8d3ffd7d744010",
    name: "USDR / wstETH",
    irm: "0x870aC11D48B15DB9a138Cf899d20F13F79Ba00BC",
    lltv: "860000000000000000",
    oracle: "0x27679a17b7419fB10Bd9D143f21407760fdA5C53",
    loanToken: {
      address: "0x7B43E3875440B44613DC3bC08E7763e6Da63C8f8",
      symbol: "USDR",
    },
    collateralToken: {
      address: "0x7f39C581F595B53c5cb19bD0b3f8dA6c935E2Ca0",
      symbol: "wstETH",
    },
  },
  {
    id: "0xcfd9f683c6ab4b3c95e450e3faaf582c2b5fe938ef7405c4d60f2e9fd77415cc",
    name: "WBTC / PT-corn-SolvBTC.BBN-26DEC2024",
    irm: "0x870aC11D48B15DB9a138Cf899d20F13F79Ba00BC",
    lltv: "915000000000000000",
    oracle: "0x309b563107f6AfBEa888acF1E1BffE0dB8a8d08B",
    loanToken: {
      address: "0x2260FAC5E5542a773Aa44fBCfeDf7C193bc2C599",
      symbol: "WBTC",
    },
    collateralToken: {
      address: "0x23e479ddcda990E8523494895759bD98cD2fDBF6",
      symbol: "PT-corn-SolvBTC.BBN-26DEC2024",
    },
  },
  {
    id: "0x77a998b117849e6be7680406ba21cc8527fab2b98b7f57e9c70126554a921d47",
    name: "USDC / synUSD",
    irm: "0x870aC11D48B15DB9a138Cf899d20F13F79Ba00BC",
    lltv: "860000000000000000",
    oracle: "0xe58B6Ea87b5ce04FC0Cb51eAb64eBb7EA8e6Ba56",
    loanToken: {
      address: "0xA0b86991c6218b36c1d19D4a2e9Eb0cE3606eB48",
      symbol: "USDC",
    },
    collateralToken: {
      address: "0x1b2CB79a4564206f53Ba80b4d780F251b4Ae6765",
      symbol: "synUSD",
    },
  },
  {
    id: "0x7e6871aaad29d837d2146ab1fc4113d85177fa5cec30d6d61a49ab1865bac0c9",
    name: "USDC / oBTC",
    irm: "0x870aC11D48B15DB9a138Cf899d20F13F79Ba00BC",
    lltv: "860000000000000000",
    oracle: "0xA6D6950c9F177F1De7f7757FB33539e3Ec60182a",
    loanToken: {
      address: "0xA0b86991c6218b36c1d19D4a2e9Eb0cE3606eB48",
      symbol: "USDC",
    },
    collateralToken: {
      address: "0x1Ee774B40eECef1ed4BB702C83A97dc949c900e5",
      symbol: "oBTC",
    },
  },
  {
    id: "0xd3620cb7eb220164e7493dfef3217a14db3dc24360e9ed5f4eaf36cf6cc09c4d",
    name: "wstETH / USDS",
    irm: "0x870aC11D48B15DB9a138Cf899d20F13F79Ba00BC",
    lltv: "860000000000000000",
    oracle: "0x77a04317eF0819A7d20F79e70CeF87d088D7F995",
    loanToken: {
      address: "0x7f39C581F595B53c5cb19bD0b3f8dA6c935E2Ca0",
      symbol: "wstETH",
    },
    collateralToken: {
      address: "0xdC035D45d973E3EC169d2276DDab16f1e407384F",
      symbol: "USDS",
    },
  },
  {
    id: "0xd8909210afccc90a67730342d4a4695d437cd898164c59e2f54dfa40b53db2c0",
    name: "USDA / sDAI",
    irm: "0x870aC11D48B15DB9a138Cf899d20F13F79Ba00BC",
    lltv: "965000000000000000",
    oracle: "0x9d4eb56E054e4bFE961F861E351F606987784B65",
    loanToken: {
      address: "0x0000206329b97DB379d5E1Bf586BbDB969C63274",
      symbol: "USDA",
    },
    collateralToken: {
      address: "0x83F20F44975D03b1b09e64809B757c47f942BEeA",
      symbol: "sDAI",
    },
  },
  {
    id: "0xdb760246f6859780f6c1b272d47a8f64710777121118e56e0cdb4b8b744a3094",
    name: "DAI / USDe",
    irm: "0x870aC11D48B15DB9a138Cf899d20F13F79Ba00BC",
    lltv: "945000000000000000",
    oracle: "0xaE4750d0813B5E37A51f7629beedd72AF1f9cA35",
    loanToken: {
      address: "0x6B175474E89094C44Da98b954EedeAC495271d0F",
      symbol: "DAI",
    },
    collateralToken: {
      address: "0x4c9EDD5852cd905f086C759E8383e09bff1E68B3",
      symbol: "USDe",
    },
  },
  {
    id: "0x12dbf4937132ff2c6445212519295ce9afbee3c765ba626af5b197fe6c3941a0",
    name: "WETH / cbBTC",
    irm: "0x870aC11D48B15DB9a138Cf899d20F13F79Ba00BC",
    lltv: "915000000000000000",
    oracle: "0x998Eaa364282Ad9Ac33F934e97bef3d660389366",
    loanToken: {
      address: "0xC02aaA39b223FE8D0A0e5C4F27eAD9083C756Cc2",
      symbol: "WETH",
    },
    collateralToken: {
      address: "0xcbB7C0000aB88B473b1f5aFd9ef808440eed33Bf",
      symbol: "cbBTC",
    },
  },
  {
    id: "0x18b52e40c13af881209b78e14bdd5f094a6c7fa39ce411e0d119e9201f71dc20",
    name: "WBTC / pumpBTC",
    irm: "0x870aC11D48B15DB9a138Cf899d20F13F79Ba00BC",
    lltv: "945000000000000000",
    oracle: "0x427C6C90bFcbb69e0Df2e7Ac0aBeDEe7001b9EAc",
    loanToken: {
      address: "0x2260FAC5E5542a773Aa44fBCfeDf7C193bc2C599",
      symbol: "WBTC",
    },
    collateralToken: {
      address: "0xF469fBD2abcd6B9de8E169d128226C0Fc90a012e",
      symbol: "pumpBTC",
    },
  },
  {
    id: "0xae4571cdcad4191b9a59d1bb27a10a1b05c92c84fe423e4886d5781a30a9c8f1",
    name: "DAI / PT-eUSDE-29MAY2025",
    irm: "0x870aC11D48B15DB9a138Cf899d20F13F79Ba00BC",
    lltv: "915000000000000000",
    oracle: "0x39a695Eb6d0C01F6977521E5E79EA8bc232b506a",
    loanToken: {
      address: "0x6B175474E89094C44Da98b954EedeAC495271d0F",
      symbol: "DAI",
    },
    collateralToken: {
      address: "0x50D2C7992b802Eef16c04FeADAB310f31866a545",
      symbol: "PT-eUSDE-29MAY2025",
    },
  },
  {
    id: "0x5e3e6b1e01c5708055548d82d01db741e37d03b948a7ef9f3d4b962648bcbfa7",
    name: "DAI / PT-sUSDE-27MAR2025",
    irm: "0x870aC11D48B15DB9a138Cf899d20F13F79Ba00BC",
    lltv: "915000000000000000",
    oracle: "0x38d130cEe60CDa080A3b3aC94C79c34B6Fc919A7",
    loanToken: {
      address: "0x6B175474E89094C44Da98b954EedeAC495271d0F",
      symbol: "DAI",
    },
    collateralToken: {
      address: "0xE00bd3Df25fb187d6ABBB620b3dfd19839947b81",
      symbol: "PT-sUSDE-27MAR2025",
    },
  },
  {
    id: "0xcc63ab57cdcd6dd24cd42db3ebe829fb1b56da89fcd17cea6202cf6b69d02393",
    name: "USDC / PT-wstUSR-27MAR2025",
    irm: "0x870aC11D48B15DB9a138Cf899d20F13F79Ba00BC",
    lltv: "915000000000000000",
    oracle: "0x7B456f32202F6C2d5b429912EB86D1D368C0dd36",
    loanToken: {
      address: "0xA0b86991c6218b36c1d19D4a2e9Eb0cE3606eB48",
      symbol: "USDC",
    },
    collateralToken: {
      address: "0xA8c8861b5ccF8CCe0ade6811CD2A7A7d3222B0B8",
      symbol: "PT-wstUSR-27MAR2025",
    },
  },
  {
    id: "0x8a71a66ac828c2b6d4f8accce5859aba0822b502f3833bec4aff09479affffdb",
    name: "USDC / PT-cUSDO-20NOV2025",
    irm: "0x870aC11D48B15DB9a138Cf899d20F13F79Ba00BC",
    lltv: "915000000000000000",
    oracle: "0x0dF910a47452B995F545D66eb135f38D0FbB142E",
    loanToken: {
      address: "0xA0b86991c6218b36c1d19D4a2e9Eb0cE3606eB48",
      symbol: "USDC",
    },
    collateralToken: {
      address: "0xB10DA2F9147f9cf2B8826877Cd0c95c18A0f42dc",
      symbol: "PT-cUSDO-20NOV2025",
    },
  },
  {
    id: "0x9e0551b676d0e1d4ba7f896c9ffb02d461afa18452e8f4e121065ce1d3e38055",
    name: "USDC / GHO",
    irm: "0x870aC11D48B15DB9a138Cf899d20F13F79Ba00BC",
    lltv: "860000000000000000",
    oracle: "0xDddd770BADd886dF3864029e4B377B5F6a2B6b83",
    loanToken: {
      address: "0xA0b86991c6218b36c1d19D4a2e9Eb0cE3606eB48",
      symbol: "USDC",
    },
    collateralToken: {
      address: "0x40D16FC0246aD3160Ccc09B8D0D3A2cD28aE6C2f",
      symbol: "GHO",
    },
  },
  {
    id: "0xd92a4247468eca1edc0c5b26cacfcdd7daaf666c5d26bd5e3ca5f70a9073a196",
    name: "USDe / PT-USDe-25SEP2025",
    irm: "0x870aC11D48B15DB9a138Cf899d20F13F79Ba00BC",
    lltv: "915000000000000000",
    oracle: "0x771d56303814d47ed20c7DF7F5d8C45600Df12B7",
    loanToken: {
      address: "0x4c9EDD5852cd905f086C759E8383e09bff1E68B3",
      symbol: "USDe",
    },
    collateralToken: {
      address: "0xBC6736d346a5eBC0dEbc997397912CD9b8FAe10a",
      symbol: "PT-USDe-25SEP2025",
    },
  },
  {
    id: "0x407d8c123443d362ffdfe73208068ef158a21d1a44a988c9acc23a51bade7905",
    name: "DAI / PT-sUSDE-29MAY2025",
    irm: "0x870aC11D48B15DB9a138Cf899d20F13F79Ba00BC",
    lltv: "915000000000000000",
    oracle: "0xE84f7e0a890e5e57d0beEa2c8716dDf0c9846B4A",
    loanToken: {
      address: "0x6B175474E89094C44Da98b954EedeAC495271d0F",
      symbol: "DAI",
    },
    collateralToken: {
      address: "0xb7de5dFCb74d25c2f21841fbd6230355C50d9308",
      symbol: "PT-sUSDE-29MAY2025",
    },
  },
  {
    id: "0x0e75bf0dc5ea84f72e39f4c07229eb0eb9609fcddf67cf20e93922a03dacd1b3",
    name: "USDC / AA_GauntletTestUSDC",
    irm: "0x870aC11D48B15DB9a138Cf899d20F13F79Ba00BC",
    lltv: "770000000000000000",
    oracle: "0x14D27F89b748E983Bf78551906B4C7E4A11d6c64",
    loanToken: {
      address: "0xA0b86991c6218b36c1d19D4a2e9Eb0cE3606eB48",
      symbol: "USDC",
    },
    collateralToken: {
      address: "0x99e05CDBeAC5D91150935C59FF8e9ba9945d6884",
      symbol: "AA_GauntletTestUSDC",
    },
  },
  {
    id: "0xb81eaed0df42ff6646c8daf4fe38afab93b13b6a89c9750d08e705223a45e2ef",
    name: "DAI / PT-sUSDE-31JUL2025",
    irm: "0x870aC11D48B15DB9a138Cf899d20F13F79Ba00BC",
    lltv: "915000000000000000",
    oracle: "0x78804d5290F250A8066145D16A99bd3ea920b732",
    loanToken: {
      address: "0x6B175474E89094C44Da98b954EedeAC495271d0F",
      symbol: "DAI",
    },
    collateralToken: {
      address: "0x3b3fB9C57858EF816833dC91565EFcd85D96f634",
      symbol: "PT-sUSDE-31JUL2025",
    },
  },
  {
    id: "0x12e703583b8a2a46a85d9d383b6156bbcf73db6b47a6f97c38771c56dd1bdd6c",
    name: "USDC / PT-USD0++-26JUN2025",
    irm: "0x870aC11D48B15DB9a138Cf899d20F13F79Ba00BC",
    lltv: "915000000000000000",
    oracle: "0x3F9Df85F511eFe36a5f751017B3A117f3501C7e5",
    loanToken: {
      address: "0xA0b86991c6218b36c1d19D4a2e9Eb0cE3606eB48",
      symbol: "USDC",
    },
    collateralToken: {
      address: "0xf696FE29Ef85E892b5926313897D178288faA07e",
      symbol: "PT-USD0++-26JUN2025",
    },
  },
  {
    id: "0x8bbd1763671eb82a75d5f7ca33a0023ffabdd9d1a3d4316f34753685ae988e80",
    name: "WETH / apxETH",
    irm: "0x870aC11D48B15DB9a138Cf899d20F13F79Ba00BC",
    lltv: "860000000000000000",
    oracle: "0x037D67A5E6F19d0Fb26A6603d2D4fE9d70eC3258",
    loanToken: {
      address: "0xC02aaA39b223FE8D0A0e5C4F27eAD9083C756Cc2",
      symbol: "WETH",
    },
    collateralToken: {
      address: "0x9Ba021B0a9b958B5E75cE9f6dff97C7eE52cb3E6",
      symbol: "apxETH",
    },
  },
  {
    id: "0x04951431341b022886954b9d99310ac2f738eb69fe5b4408042f0b505c9ef302",
    name: "WETH / wstETH",
    irm: "0x870aC11D48B15DB9a138Cf899d20F13F79Ba00BC",
    lltv: "945000000000000000",
    oracle: "0xcBd5323D71a3424A7e0Fd11c367565bad3838867",
    loanToken: {
      address: "0xC02aaA39b223FE8D0A0e5C4F27eAD9083C756Cc2",
      symbol: "WETH",
    },
    collateralToken: {
      address: "0x7f39C581F595B53c5cb19bD0b3f8dA6c935E2Ca0",
      symbol: "wstETH",
    },
  },
  {
    id: "0x934b5427f2dbcddaddb59e04b8bbb41ef30fb7481eef95366ffa5da4290f1359",
    name: "USDC / PT-fxSAVE-30OCT2025",
    irm: "0x870aC11D48B15DB9a138Cf899d20F13F79Ba00BC",
    lltv: "915000000000000000",
    oracle: "0xc8532581681f2d8f20D38b038a5a4fbFCef6cc6f",
    loanToken: {
      address: "0xA0b86991c6218b36c1d19D4a2e9Eb0cE3606eB48",
      symbol: "USDC",
    },
    collateralToken: {
      address: "0x21aacE56a8F21210b7E76d8eF1a77253Db85BF0a",
      symbol: "PT-fxSAVE-30OCT2025",
    },
  },
  {
    id: "0xadde643934dde529ac12bfe4000db236f886f95f8d186ce802b014d28b0f181f",
    name: "WETH / PT-tETH-25SEP2025",
    irm: "0x870aC11D48B15DB9a138Cf899d20F13F79Ba00BC",
    lltv: "915000000000000000",
    oracle: "0x59b49d7984F374A82d486e423dc098d638542706",
    loanToken: {
      address: "0xC02aaA39b223FE8D0A0e5C4F27eAD9083C756Cc2",
      symbol: "WETH",
    },
    collateralToken: {
      address: "0xfe72382695dC280e7392a0BE795128a126E9b7AE",
      symbol: "PT-tETH-25SEP2025",
    },
  },
  {
    id: "0x2a9b860303f3af6ee3fb8bdfe8b3a89c2ebb9426b76a0d717e49efd36663de8d",
    name: "WETH / USDS",
    irm: "0x870aC11D48B15DB9a138Cf899d20F13F79Ba00BC",
    lltv: "860000000000000000",
    oracle: "0xf751b1D7C04c63B953e4AccC94f825DBAfda166d",
    loanToken: {
      address: "0xC02aaA39b223FE8D0A0e5C4F27eAD9083C756Cc2",
      symbol: "WETH",
    },
    collateralToken: {
      address: "0xdC035D45d973E3EC169d2276DDab16f1e407384F",
      symbol: "USDS",
    },
  },
  {
    id: "0x2afd063a5af8e050069cfad4da95c81768b85b140bea2bd89e00407b15ce82c8",
    name: "USDC / PT-jrUSDe-2APR2026",
    irm: "0x870aC11D48B15DB9a138Cf899d20F13F79Ba00BC",
    lltv: "860000000000000000",
    oracle: "0xb847B24b5D13C3F67347005c9B57074b01978bAA",
    loanToken: {
      address: "0xA0b86991c6218b36c1d19D4a2e9Eb0cE3606eB48",
      symbol: "USDC",
    },
    collateralToken: {
      address: "0xd0609Ac13000d88B0BEbf5Bb21074916eDd92Bb1",
      symbol: "PT-jrUSDe-2APR2026",
    },
  },
  {
    id: "0x1c06f86ff1fe0f46937b13a6a489aa4f44e8f4b23fc5ed63f65d7381ad22267c",
    name: "USDC / yUSD",
    irm: "0x870aC11D48B15DB9a138Cf899d20F13F79Ba00BC",
    lltv: "915000000000000000",
    oracle: "0xD3746bD055C5e61F240F92546466EFA5E854AA2a",
    loanToken: {
      address: "0xA0b86991c6218b36c1d19D4a2e9Eb0cE3606eB48",
      symbol: "USDC",
    },
    collateralToken: {
      address: "0x1CE7D9942ff78c328A4181b9F3826fEE6D845A97",
      symbol: "yUSD",
    },
  },
  {
    id: "0x9105a5447f3eecdf768f04da12d580a878106e2e6b234312db2ee0f304539e35",
    name: "USDT / reUSD",
    irm: "0x870aC11D48B15DB9a138Cf899d20F13F79Ba00BC",
    lltv: "915000000000000000",
    oracle: "0xA66a4F03Fd8031973f8C7718904ce32385f54E70",
    loanToken: {
      address: "0xdAC17F958D2ee523a2206206994597C13D831ec7",
      symbol: "USDT",
    },
    collateralToken: {
      address: "0x5086bf358635B81D8C47C66d1C8b9E567Db70c72",
      symbol: "reUSD",
    },
  },
  {
    id: "0xb4067ef4e1339fa827bb20acc43e720fb20952c61b0f5ad14785fa090618ae6e",
    name: "USDC / PT-wstUSR-1750896030",
    irm: "0x870aC11D48B15DB9a138Cf899d20F13F79Ba00BC",
    lltv: "915000000000000000",
    oracle: "0xBe94eD0c1649775fA5Fc51862aBe7A8D9D43CA2a",
    loanToken: {
      address: "0xA0b86991c6218b36c1d19D4a2e9Eb0cE3606eB48",
      symbol: "USDC",
    },
    collateralToken: {
      address: "0x4A977653c58CFD82d42fd706cf68A0c1B6d0ca56",
      symbol: "PT-wstUSR-1750896030",
    },
  },
  {
    id: "0x66c19b7c49ce674e964eb917d117d987b693f508f2c1e3f71ac914454ed42e13",
    name: "WETH / savETH",
    irm: "0x870aC11D48B15DB9a138Cf899d20F13F79Ba00BC",
    lltv: "945000000000000000",
    oracle: "0xa11B7867be57105beFF6f16b295b28B08eb808EB",
    loanToken: {
      address: "0xC02aaA39b223FE8D0A0e5C4F27eAD9083C756Cc2",
      symbol: "WETH",
    },
    collateralToken: {
      address: "0xDA06eE2dACF9245Aa80072a4407deBDea0D7e341",
      symbol: "savETH",
    },
  },
  {
    id: "0x6dd2c4f44111a54f4de7919ac33b3038dd03df491e8c6e77a4363ae0d6e8a872",
    name: "USDC / MKR",
    irm: "0x870aC11D48B15DB9a138Cf899d20F13F79Ba00BC",
    lltv: "385000000000000000",
    oracle: "0x6686788B4315A4F93d822c1Bf73910556FCe2d5a",
    loanToken: {
      address: "0xA0b86991c6218b36c1d19D4a2e9Eb0cE3606eB48",
      symbol: "USDC",
    },
    collateralToken: {
      address: "0x9f8F72aA9304c8B593d555F12eF6589cC3A579A2",
      symbol: "MKR",
    },
  },
  {
    id: "0x92e5fe774a581e52428b4f8d6a775f35619a2e0a184363ae123fae478056d1cd",
    name: "USDC / USD0++",
    irm: "0x870aC11D48B15DB9a138Cf899d20F13F79Ba00BC",
    lltv: "860000000000000000",
    oracle: "0xa1A67065670D838Bd34C9aE31906a60c175687b3",
    loanToken: {
      address: "0xA0b86991c6218b36c1d19D4a2e9Eb0cE3606eB48",
      symbol: "USDC",
    },
    collateralToken: {
      address: "0x35D8949372D46B7a3D5A56006AE77B215fc69bC0",
      symbol: "USD0++",
    },
  },
  {
    id: "0xba5bb3ccec8df00a56ac1f4d97ae0fd1461f262b6d4f29631bdec717fa6017fd",
    name: "USDtb / USDe",
    irm: "0x870aC11D48B15DB9a138Cf899d20F13F79Ba00BC",
    lltv: "915000000000000000",
    oracle: "0xaE4750d0813B5E37A51f7629beedd72AF1f9cA35",
    loanToken: {
      address: "0xC139190F447e929f090Edeb554D95AbB8b18aC1C",
      symbol: "USDtb",
    },
    collateralToken: {
      address: "0x4c9EDD5852cd905f086C759E8383e09bff1E68B3",
      symbol: "USDe",
    },
  },
  {
    id: "0x7e79c25831c97175922df132d09b02f93103a2306b1d71e57a7714ddd4c15d13",
    name: "USDC / USDC",
    irm: "0x870aC11D48B15DB9a138Cf899d20F13F79Ba00BC",
    lltv: "980000000000000000",
    oracle: "0x379BD0B8C9b5E022bb26DceBeBAB92F19A7C573E",
    loanToken: {
      address: "0xA0b86991c6218b36c1d19D4a2e9Eb0cE3606eB48",
      symbol: "USDC",
    },
    collateralToken: {
      address: "0xA0b86991c6218b36c1d19D4a2e9Eb0cE3606eB48",
      symbol: "USDC",
    },
  },
  {
    id: "0x8f46cd82c4c44a090c3d72bd7a84baf4e69ee50331d5deae514f86fe062b0748",
    name: "DAI / PT-sUSDE-24OCT2024",
    irm: "0x870aC11D48B15DB9a138Cf899d20F13F79Ba00BC",
    lltv: "860000000000000000",
    oracle: "0xaE4750d0813B5E37A51f7629beedd72AF1f9cA35",
    loanToken: {
      address: "0x6B175474E89094C44Da98b954EedeAC495271d0F",
      symbol: "DAI",
    },
    collateralToken: {
      address: "0xAE5099C39f023C91d3dd55244CAFB36225B0850E",
      symbol: "PT-sUSDE-24OCT2024",
    },
  },
  {
    id: "0x60f855f6b8c6919c2a4f3ab5f367fc923e3172e6dc8f4e8b6c448eb2d43421a1",
    name: "USDU / USDC",
    irm: "0x870aC11D48B15DB9a138Cf899d20F13F79Ba00BC",
    lltv: "915000000000000000",
    oracle: "0x0996a315D21C0B2c827dDdF83Fd1623940f8BeA0",
    loanToken: {
      address: "0xdde3eC717f220Fc6A29D6a4Be73F91DA5b718e55",
      symbol: "USDU",
    },
    collateralToken: {
      address: "0xA0b86991c6218b36c1d19D4a2e9Eb0cE3606eB48",
      symbol: "USDC",
    },
  },
  {
    id: "0xab0dcab71e65c05b7f241ea79a33452c87e62db387129e4abe15e458d433e4d8",
    name: "DAI / PT-USDe-27MAR2025",
    irm: "0x870aC11D48B15DB9a138Cf899d20F13F79Ba00BC",
    lltv: "915000000000000000",
    oracle: "0xA8ccE51046d760291f77eC1EB98147A75730Dcd5",
    loanToken: {
      address: "0x6B175474E89094C44Da98b954EedeAC495271d0F",
      symbol: "DAI",
    },
    collateralToken: {
      address: "0x8A47b431A7D947c6a3ED6E42d501803615a97EAa",
      symbol: "PT-USDe-27MAR2025",
    },
  },
  {
    id: "0xad4e8d88af223e332e97db2f59ff8ddbc6297287ebf44280c86c5f16a5e52f86",
    name: "USDC / expVaultBTC",
    irm: "0x870aC11D48B15DB9a138Cf899d20F13F79Ba00BC",
    lltv: "860000000000000000",
    oracle: "0xE220515C1CB370F5ffFAbBb3f9Eade69b8BA1f6c",
    loanToken: {
      address: "0xA0b86991c6218b36c1d19D4a2e9Eb0cE3606eB48",
      symbol: "USDC",
    },
    collateralToken: {
      address: "0x97F7957F74B3eA8A372e1Fa0a153Bb9bd7b1CA61",
      symbol: "expVaultBTC",
    },
  },
  {
    id: "0xe2e675b00579db50f69c29a4ff980a3a90f65023d9d83505f16bc6ec65591b9f",
    name: "USDe / PT-sUSDE-25SEP2025",
    irm: "0x870aC11D48B15DB9a138Cf899d20F13F79Ba00BC",
    lltv: "915000000000000000",
    oracle: "0xc28690681238CA9a35EacF7daBbe9d07B4722e9D",
    loanToken: {
      address: "0x4c9EDD5852cd905f086C759E8383e09bff1E68B3",
      symbol: "USDe",
    },
    collateralToken: {
      address: "0x9F56094C450763769BA0EA9Fe2876070c0fD5F77",
      symbol: "PT-sUSDE-25SEP2025",
    },
  },
  {
    id: "0x70014ba4411257948ddbe73fc1d65056721c31a583fc1ead7fba4c57b5e9790d",
    name: "USDC / MKR",
    irm: "0x870aC11D48B15DB9a138Cf899d20F13F79Ba00BC",
    lltv: "625000000000000000",
    oracle: "0x6686788B4315A4F93d822c1Bf73910556FCe2d5a",
    loanToken: {
      address: "0xA0b86991c6218b36c1d19D4a2e9Eb0cE3606eB48",
      symbol: "USDC",
    },
    collateralToken: {
      address: "0x9f8F72aA9304c8B593d555F12eF6589cC3A579A2",
      symbol: "MKR",
    },
  },
  {
    id: "0xdcfd3558f75a13a3c430ee71df056b5570cbd628da91e33c27eec7c42603247b",
    name: "USDC / sUSDS",
    irm: "0x870aC11D48B15DB9a138Cf899d20F13F79Ba00BC",
    lltv: "945000000000000000",
    oracle: "0x6f2B373A397464090645c726eE6685123afEE36f",
    loanToken: {
      address: "0xA0b86991c6218b36c1d19D4a2e9Eb0cE3606eB48",
      symbol: "USDC",
    },
    collateralToken: {
      address: "0xa3931d71877C0E7a3148CB7Eb4463524FEc27fbD",
      symbol: "sUSDS",
    },
  },
  {
    id: "0x9ec52d7195bafeba7137fa4d707a0f674a04a6d658c9066bcdbebc6d81eb0011",
    name: "WETH / ETH+",
    irm: "0x870aC11D48B15DB9a138Cf899d20F13F79Ba00BC",
    lltv: "860000000000000000",
    oracle: "0x3308Fed4625E5C5b176E4B7458F20B54C26C38ED",
    loanToken: {
      address: "0xC02aaA39b223FE8D0A0e5C4F27eAD9083C756Cc2",
      symbol: "WETH",
    },
    collateralToken: {
      address: "0xE72B141DF173b999AE7c1aDcbF60Cc9833Ce56a8",
      symbol: "ETH+",
    },
  },
  {
    id: "0x465f938458d50025fcb0b9d7c8bd977d7cb467079a29a488ccd359122e632ce1",
    name: "pmUSD / USDC",
    irm: "0x870aC11D48B15DB9a138Cf899d20F13F79Ba00BC",
    lltv: "915000000000000000",
    oracle: "0x33e0Fc81dA49D5547FfF3DA8b4C823aaD7A3819C",
    loanToken: {
      address: "0xC0c17dD08263C16f6b64E772fB9B723Bf1344DdF",
      symbol: "pmUSD",
    },
    collateralToken: {
      address: "0xA0b86991c6218b36c1d19D4a2e9Eb0cE3606eB48",
      symbol: "USDC",
    },
  },
  {
    id: "0xd2db5df9946c2090bbe2c52d8b8b80a95bffca8bd19a6151b1ae7687f888f6ab",
    name: "USDC / PT-AIDaUSDT-30OCT2025",
    irm: "0x870aC11D48B15DB9a138Cf899d20F13F79Ba00BC",
    lltv: "860000000000000000",
    oracle: "0x7e3aF96b9954baf8cf891547dF0dB666fd9bC5C6",
    loanToken: {
      address: "0xA0b86991c6218b36c1d19D4a2e9Eb0cE3606eB48",
      symbol: "USDC",
    },
    collateralToken: {
      address: "0x968547d91681c8c9e135710Fc94BC6C35E26607e",
      symbol: "PT-AIDaUSDT-30OCT2025",
    },
  },
  {
    id: "0x0ec590b250f171c22d39958a55a0589091431fe90599d55409c39aeb01363cb0",
    name: "USDT / USR",
    irm: "0x870aC11D48B15DB9a138Cf899d20F13F79Ba00BC",
    lltv: "915000000000000000",
    oracle: "0x8875ceb24E656FCA062759BDCF870F59A2B0187b",
    loanToken: {
      address: "0xdAC17F958D2ee523a2206206994597C13D831ec7",
      symbol: "USDT",
    },
    collateralToken: {
      address: "0x66a1E37c9b0eAddca17d3662D6c05F4DECf3e110",
      symbol: "USR",
    },
  },
  {
    id: "0x0f8ff4fa22195841e7fd1e0520f650a4d71247f75b9a1eb4ecabe111776a118c",
    name: "USDC / mEDGE",
    irm: "0x870aC11D48B15DB9a138Cf899d20F13F79Ba00BC",
    lltv: "860000000000000000",
    oracle: "0xa9247a26Ec95D1E72C2BbC941b402df5Efe4E13A",
    loanToken: {
      address: "0xA0b86991c6218b36c1d19D4a2e9Eb0cE3606eB48",
      symbol: "USDC",
    },
    collateralToken: {
      address: "0xbB51E2a15A9158EBE2b0Ceb8678511e063AB7a55",
      symbol: "mEDGE",
    },
  },
  {
    id: "0x5021a2692eaffb6f9debf1d829d9d509298caf08e6aa453e2703debef71d2c5b",
    name: "USDT / PT-wsrUSD-30OCT2025",
    irm: "0x870aC11D48B15DB9a138Cf899d20F13F79Ba00BC",
    lltv: "915000000000000000",
    oracle: "0x211Cd125045A395c7054D132F3aC53e21D9A2C25",
    loanToken: {
      address: "0xdAC17F958D2ee523a2206206994597C13D831ec7",
      symbol: "USDT",
    },
    collateralToken: {
      address: "0x10a099BAf814B5FDa138c4e6b60eD42c0d975be8",
      symbol: "PT-wsrUSD-30OCT2025",
    },
  },
  {
    id: "0x815a63c710a16ec72d2e7c424b1c62b35aafdfdd685b8f8409465d4daf4ece75",
    name: "USDC / PENDLE-LPT-WRAPPED",
    irm: "0x870aC11D48B15DB9a138Cf899d20F13F79Ba00BC",
    lltv: "915000000000000000",
    oracle: "0x0C9d7deF5F5Bda3c1dB32FC2f520C0e2eae8f122",
    loanToken: {
      address: "0xA0b86991c6218b36c1d19D4a2e9Eb0cE3606eB48",
      symbol: "USDC",
    },
    collateralToken: {
      address: "0xaB025d7b57B0902A2797599F3eB07477400e62B0",
      symbol: "PENDLE-LPT-WRAPPED",
    },
  },
  {
    id: "0xe57ae1be21921a42b873c88c3e659174a8df631ddfabbae029e7e26869934f15",
    name: "USDC / PT-AIDaUSDC-30OCT2025",
    irm: "0x870aC11D48B15DB9a138Cf899d20F13F79Ba00BC",
    lltv: "860000000000000000",
    oracle: "0x28b04B36423455B2186AF28171A240d35b6579F4",
    loanToken: {
      address: "0xA0b86991c6218b36c1d19D4a2e9Eb0cE3606eB48",
      symbol: "USDC",
    },
    collateralToken: {
      address: "0xAa6ee47AEbAEF8d0E159B6d0962AcD82dF335b0F",
      symbol: "PT-AIDaUSDC-30OCT2025",
    },
  },
  {
    id: "0x015bffbe12c95a0fe61001440bf9e9b2040cb181f9bcfb680ee268e7cb6c7d2f",
    name: "WBTC / mBTC",
    irm: "0x870aC11D48B15DB9a138Cf899d20F13F79Ba00BC",
    lltv: "915000000000000000",
    oracle: "0x96605c8f73328f3D6CC484BbE074c5F4c93eCF6B",
    loanToken: {
      address: "0x2260FAC5E5542a773Aa44fBCfeDf7C193bc2C599",
      symbol: "WBTC",
    },
    collateralToken: {
      address: "0x007115416AB6c266329a03B09a8aa39aC2eF7d9d",
      symbol: "mBTC",
    },
  },
  {
    id: "0x3414a681ae9b32c5284c87f5002a32990e5c91cacf5d4db0c4a98fcf4cf96d46",
    name: "USDC / K",
    irm: "0x870aC11D48B15DB9a138Cf899d20F13F79Ba00BC",
    lltv: "625000000000000000",
    oracle: "0xdC86f24d6aC94929812DC4A10e53b0ed0D7C7176",
    loanToken: {
      address: "0xA0b86991c6218b36c1d19D4a2e9Eb0cE3606eB48",
      symbol: "USDC",
    },
    collateralToken: {
      address: "0x0107006da856F5225ee585a2316a0339209F4439",
      symbol: "K",
    },
  },
  {
    id: "0x7182fd5e9c6a77156d6ac024d1e462b9ca3a85463961957a5e3d367c9ce44b84",
    name: "USDC / deUSD",
    irm: "0x870aC11D48B15DB9a138Cf899d20F13F79Ba00BC",
    lltv: "860000000000000000",
    oracle: "0x2aebFD1191F5a283298608002d30459a1cD7A24C",
    loanToken: {
      address: "0xA0b86991c6218b36c1d19D4a2e9Eb0cE3606eB48",
      symbol: "USDC",
    },
    collateralToken: {
      address: "0x15700B564Ca08D9439C58cA5053166E8317aa138",
      symbol: "deUSD",
    },
  },
  {
    id: "0x44e1d6d8c57a522dafc54b6466a4a9377eb1413d68e79cf162abdf15d5f2c36c",
    name: "USDT / ezUSD",
    irm: "0x870aC11D48B15DB9a138Cf899d20F13F79Ba00BC",
    lltv: "915000000000000000",
    oracle: "0x9bCA11a6F98E2Ad31781cAcb4483a1642fD85dDf",
    loanToken: {
      address: "0xdAC17F958D2ee523a2206206994597C13D831ec7",
      symbol: "USDT",
    },
    collateralToken: {
      address: "0x77B80F4ac4c6Cbb4982689749177349cf1635115",
      symbol: "ezUSD",
    },
  },
  {
    id: "0xfd3e5c20340aeba93f78f7dc4657dc1e11b553c68c545acc836321a14b47e457",
    name: "wUSDL / wstETH",
    irm: "0x870aC11D48B15DB9a138Cf899d20F13F79Ba00BC",
    lltv: "860000000000000000",
    oracle: "0xFb4b72b632CEC456321fEe556b7D4c9Af8D455e1",
    loanToken: {
      address: "0x7751E2F4b8ae93EF6B79d86419d42FE3295A4559",
      symbol: "wUSDL",
    },
    collateralToken: {
      address: "0x7f39C581F595B53c5cb19bD0b3f8dA6c935E2Ca0",
      symbol: "wstETH",
    },
  },
  {
    id: "0x3f5ae84a3b35a3533114b30e6e8c61a3d6469828f237a55e13e4c6a187391574",
    name: "EURCV / USDC",
    irm: "0x870aC11D48B15DB9a138Cf899d20F13F79Ba00BC",
    lltv: "860000000000000000",
    oracle: "0xC4Cd46Bc6873186A2726d56Da77F17Dcc7eF5BB8",
    loanToken: {
      address: "0x5F7827FDeb7c20b443265Fc2F40845B715385Ff2",
      symbol: "EURCV",
    },
    collateralToken: {
      address: "0xA0b86991c6218b36c1d19D4a2e9Eb0cE3606eB48",
      symbol: "USDC",
    },
  },
  {
    id: "0xd729b6742d6eadee7ee38ecf85e9f0ba060398e28089adf2e5e0f43224e4688a",
    name: "USDC / PT-tUSDe-25SEP2025",
    irm: "0x870aC11D48B15DB9a138Cf899d20F13F79Ba00BC",
    lltv: "915000000000000000",
    oracle: "0x72ec24886A36A1C632D284Ed49293Ecd13e3eCa6",
    loanToken: {
      address: "0xA0b86991c6218b36c1d19D4a2e9Eb0cE3606eB48",
      symbol: "USDC",
    },
    collateralToken: {
      address: "0xd0a4B74A6B62aA2b6C02349463D9041606608F36",
      symbol: "PT-tUSDe-25SEP2025",
    },
  },
  {
    id: "0xb3e1073bd0f794b671d967d6cc9fb4d2c228093ddcbcacfd98c4f95169cf9299",
    name: "USDC / ctStableUSDT",
    irm: "0x870aC11D48B15DB9a138Cf899d20F13F79Ba00BC",
    lltv: "860000000000000000",
    oracle: "0x598245A00248dCfE567117cA6740038Fbf6bED43",
    loanToken: {
      address: "0xA0b86991c6218b36c1d19D4a2e9Eb0cE3606eB48",
      symbol: "USDC",
    },
    collateralToken: {
      address: "0x6503de9FE77d256d9d823f2D335Ce83EcE9E153f",
      symbol: "ctStableUSDT",
    },
  },
  {
    id: "0xf982e67987ed310641bb33f1e7ebf3a0a2930f6b00d8f6b089440ace18f76c9b",
    name: "USDC / PT-wsrUSD-26FEB2026",
    irm: "0x870aC11D48B15DB9a138Cf899d20F13F79Ba00BC",
    lltv: "915000000000000000",
    oracle: "0xc98751D712732B80E688228A8eEFC905F116D1b1",
    loanToken: {
      address: "0xA0b86991c6218b36c1d19D4a2e9Eb0cE3606eB48",
      symbol: "USDC",
    },
    collateralToken: {
      address: "0x5AA4AfE7359d5a68D193f03E013d553DEb7DbD1f",
      symbol: "PT-wsrUSD-26FEB2026",
    },
  },
  {
    id: "0x2ff84b7e69d082105546a1a76e27da4352d248458f5f7e89104e63786d232cae",
    name: "EURCV / WBTC",
    irm: "0x870aC11D48B15DB9a138Cf899d20F13F79Ba00BC",
    lltv: "860000000000000000",
    oracle: "0xD122315BD4E89386045F51f6e65A6EeDb0dD31b9",
    loanToken: {
      address: "0x5F7827FDeb7c20b443265Fc2F40845B715385Ff2",
      symbol: "EURCV",
    },
    collateralToken: {
      address: "0x2260FAC5E5542a773Aa44fBCfeDf7C193bc2C599",
      symbol: "WBTC",
    },
  },
  {
    id: "0xad73d5e139a939a0c7dc7b821e5a103a3a9cf45c4352b373b1dabc421c7f3d59",
    name: "USDC / sUSDD",
    irm: "0x870aC11D48B15DB9a138Cf899d20F13F79Ba00BC",
    lltv: "915000000000000000",
    oracle: "0x7be435DA1e3287Ad0ACb62c2a16e0B2D4643719f",
    loanToken: {
      address: "0xA0b86991c6218b36c1d19D4a2e9Eb0cE3606eB48",
      symbol: "USDC",
    },
    collateralToken: {
      address: "0xC5d6A7B61d18AfA11435a889557b068BB9f29930",
      symbol: "sUSDD",
    },
  },
  {
    id: "0x5bbe26d0fb39f882b7a66c65c91be40b99cf1bf8072f65a4cf6211270c590e37",
    name: "EURCV / USDC",
    irm: "0x870aC11D48B15DB9a138Cf899d20F13F79Ba00BC",
    lltv: "860000000000000000",
    oracle: "0x574d924DbB19C2dcb7de74dE323c9C038201676f",
    loanToken: {
      address: "0x5F7827FDeb7c20b443265Fc2F40845B715385Ff2",
      symbol: "EURCV",
    },
    collateralToken: {
      address: "0xA0b86991c6218b36c1d19D4a2e9Eb0cE3606eB48",
      symbol: "USDC",
    },
  },
  {
    id: "0x9b8155080ad3636e3e42d48a6b0ed91fc6c26714672e7b6309b6cad4c2352be7",
    name: "WETH / cbBTC",
    irm: "0x870aC11D48B15DB9a138Cf899d20F13F79Ba00BC",
    lltv: "860000000000000000",
    oracle: "0x542e1FbF057dE360923CfA2d5c757fa2f05692F7",
    loanToken: {
      address: "0xC02aaA39b223FE8D0A0e5C4F27eAD9083C756Cc2",
      symbol: "WETH",
    },
    collateralToken: {
      address: "0xcbB7C0000aB88B473b1f5aFd9ef808440eed33Bf",
      symbol: "cbBTC",
    },
  },
  {
    id: "0x5109cda72b0603e1bac4631ddebd3104bea6414e686c3f7aa2cb3c65795602f0",
    name: "FRAX / USDe",
    irm: "0x870aC11D48B15DB9a138Cf899d20F13F79Ba00BC",
    lltv: "945000000000000000",
    oracle: "0xaE4750d0813B5E37A51f7629beedd72AF1f9cA35",
    loanToken: {
      address: "0x853d955aCEf822Db058eb8505911ED77F175b99e",
      symbol: "FRAX",
    },
    collateralToken: {
      address: "0x4c9EDD5852cd905f086C759E8383e09bff1E68B3",
      symbol: "USDe",
    },
  },
  {
    id: "0xa240f4ced8f0847aff93013c353dbd667d37a7671a9e85df15ccc47a52fd66f2",
    name: "wUSDM / WBTC",
    irm: "0x870aC11D48B15DB9a138Cf899d20F13F79Ba00BC",
    lltv: "860000000000000000",
    oracle: "0xfAc3Ef1d7a4762e295B176cbD4685129b48DE2b1",
    loanToken: {
      address: "0x57F5E098CaD7A3D1Eed53991D4d66C45C9AF7812",
      symbol: "wUSDM",
    },
    collateralToken: {
      address: "0x2260FAC5E5542a773Aa44fBCfeDf7C193bc2C599",
      symbol: "WBTC",
    },
  },
  {
    id: "0x78f475027e780e2cf62a9dc347c4f7aa61d20a1e16534ffe1c52fe3e69bbf469",
    name: "USDC / PENDLE-LPT-WRAPPED",
    irm: "0x870aC11D48B15DB9a138Cf899d20F13F79Ba00BC",
    lltv: "915000000000000000",
    oracle: "0xF5ab93318Fa098082a0EcD6BaB15c6DBC9B746a8",
    loanToken: {
      address: "0xA0b86991c6218b36c1d19D4a2e9Eb0cE3606eB48",
      symbol: "USDC",
    },
    collateralToken: {
      address: "0x60C8A22c0E5ffe2410391782C9D666bF9edCAf2a",
      symbol: "PENDLE-LPT-WRAPPED",
    },
  },
  {
    id: "0x45ac9035a947d17da1528b15a659ba09878b0e50298e4ba805be72fc02b51b84",
    name: "USDC / n-st-sUSDe",
    irm: "0x870aC11D48B15DB9a138Cf899d20F13F79Ba00BC",
    lltv: "915000000000000000",
    oracle: "0xAf14d06A65C91541a5b2db627eCd1c92d7d9C48B",
    loanToken: {
      address: "0xA0b86991c6218b36c1d19D4a2e9Eb0cE3606eB48",
      symbol: "USDC",
    },
    collateralToken: {
      address: "0xAf14d06A65C91541a5b2db627eCd1c92d7d9C48B",
      symbol: "n-st-sUSDe",
    },
  },
  {
    id: "0x3014f330e8237f0588bc63137735ae85b07026e10642b1bfbfe2887ba9c46dc0",
    name: "WBTC / WBTC",
    irm: "0x870aC11D48B15DB9a138Cf899d20F13F79Ba00BC",
    lltv: "945000000000000000",
    oracle: "0x10d9eafEF4fBfa993A12EA41E707BCc2df5C1E42",
    loanToken: {
      address: "0x2260FAC5E5542a773Aa44fBCfeDf7C193bc2C599",
      symbol: "WBTC",
    },
    collateralToken: {
      address: "0x2260FAC5E5542a773Aa44fBCfeDf7C193bc2C599",
      symbol: "WBTC",
    },
  },
  {
    id: "0x1f719d50287d50d75ef7f84a430a5168d0b2f8591debbac404f522687876cd52",
    name: "JPYR / USDT",
    irm: "0x870aC11D48B15DB9a138Cf899d20F13F79Ba00BC",
    lltv: "915000000000000000",
    oracle: "0xF8Be2a629A229DFa46bE9754955D46003cE1792B",
    loanToken: {
      address: "0xAf5D2cf39F2d4E2F5900D6cf37ab3596866347e4",
      symbol: "JPYR",
    },
    collateralToken: {
      address: "0xdAC17F958D2ee523a2206206994597C13D831ec7",
      symbol: "USDT",
    },
  },
  {
    id: "0xac357133ae9d12a9507faeeeb5af0087cf83ad17732bdab2abf95781d3b130a9",
    name: "USDC / alphaMUSD",
    irm: "0x870aC11D48B15DB9a138Cf899d20F13F79Ba00BC",
    lltv: "915000000000000000",
    oracle: "0xa405070BFE6236B6c1aF391E4777eb262eAB4Ce8",
    loanToken: {
      address: "0xA0b86991c6218b36c1d19D4a2e9Eb0cE3606eB48",
      symbol: "USDC",
    },
    collateralToken: {
      address: "0x52317a47585A6ACDfbD7a29B494c3E2baAE96aBc",
      symbol: "alphaMUSD",
    },
  },
  {
    id: "0x06cb6aaee2279b46185dc2c8c107b4a56ff6550ea86063ec011fa4a52920841b",
    name: "DAI / WBTC",
    irm: "0x870aC11D48B15DB9a138Cf899d20F13F79Ba00BC",
    lltv: "860000000000000000",
    oracle: "0xeA1433b67667878941Ca2a61C359e379397b155E",
    loanToken: {
      address: "0x6B175474E89094C44Da98b954EedeAC495271d0F",
      symbol: "DAI",
    },
    collateralToken: {
      address: "0x2260FAC5E5542a773Aa44fBCfeDf7C193bc2C599",
      symbol: "WBTC",
    },
  },
  {
    id: "0xd95c5285ed6009b272a25a94539bd1ae5af0e9020ad482123e01539ae43844e1",
    name: "DAI / wstETH",
    irm: "0x870aC11D48B15DB9a138Cf899d20F13F79Ba00BC",
    lltv: "860000000000000000",
    oracle: "0xb6F9A5da6dFA52Dc8F61592E83d22502C65D3bC8",
    loanToken: {
      address: "0x6B175474E89094C44Da98b954EedeAC495271d0F",
      symbol: "DAI",
    },
    collateralToken: {
      address: "0x7f39C581F595B53c5cb19bD0b3f8dA6c935E2Ca0",
      symbol: "wstETH",
    },
  },
  {
    id: "0x495130878b7d2f1391e21589a8bcaef22cbc7e1fbbd6866127193b3cc239d8b1",
    name: "USDC / wbIB01",
    irm: "0x870aC11D48B15DB9a138Cf899d20F13F79Ba00BC",
    lltv: "965000000000000000",
    oracle: "0x6E8F5b2DF218443E87fe8aA9811E6956716dde88",
    loanToken: {
      address: "0xA0b86991c6218b36c1d19D4a2e9Eb0cE3606eB48",
      symbol: "USDC",
    },
    collateralToken: {
      address: "0xcA2A7068e551d5C4482eb34880b194E4b945712F",
      symbol: "wbIB01",
    },
  },
  {
    id: "0xdffc48c16cca3880240220ab8791e5a7e5a41233ca11a5999f0dd4294d221aed",
    name: "WETH / AA_Re7WETH",
    irm: "0x870aC11D48B15DB9a138Cf899d20F13F79Ba00BC",
    lltv: "980000000000000000",
    oracle: "0x604Ff8d40Aeb9aaa266420Cad2c5de0dE0A10b16",
    loanToken: {
      address: "0xC02aaA39b223FE8D0A0e5C4F27eAD9083C756Cc2",
      symbol: "WETH",
    },
    collateralToken: {
      address: "0x454bB3cb427B21e1c052A080e21A57753cd6969e",
      symbol: "AA_Re7WETH",
    },
  },
  {
    id: "0x459687783a68f4cf4e230618f88ce135d1cd459a850f6496751c2a9c1c6e852e",
    name: "USDA / ezETH",
    irm: "0x870aC11D48B15DB9a138Cf899d20F13F79Ba00BC",
    lltv: "770000000000000000",
    oracle: "0xd5116061F4a1FFac23E9c6c9f6B4AF28b9AF7676",
    loanToken: {
      address: "0x0000206329b97DB379d5E1Bf586BbDB969C63274",
      symbol: "USDA",
    },
    collateralToken: {
      address: "0xbf5495Efe5DB9ce00f80364C8B423567e58d2110",
      symbol: "ezETH",
    },
  },
  {
    id: "0x4d7cd47f8d03671ed67a4aa6f97159379e67b3f41154039546fa99a280cdba1c",
    name: "WBTC / gmBTC",
    irm: "0x870aC11D48B15DB9a138Cf899d20F13F79Ba00BC",
    lltv: "860000000000000000",
    oracle: "0x393F908049Ba46FcC6803369dC836f756c0124a3",
    loanToken: {
      address: "0x2260FAC5E5542a773Aa44fBCfeDf7C193bc2C599",
      symbol: "WBTC",
    },
    collateralToken: {
      address: "0x91AE9C5fa27Bc20251E7B580343e0968D3aE4891",
      symbol: "gmBTC",
    },
  },
  {
    id: "0x355c9a4c12f60a10ab3b68507bfab21bd6913182037ffe25d94dabffea45429f",
    name: "WETH / ezETH",
    irm: "0x870aC11D48B15DB9a138Cf899d20F13F79Ba00BC",
    lltv: "625000000000000000",
    oracle: "0x61025e2B0122ac8bE4e37365A4003d87ad888Cc3",
    loanToken: {
      address: "0xC02aaA39b223FE8D0A0e5C4F27eAD9083C756Cc2",
      symbol: "WETH",
    },
    collateralToken: {
      address: "0xbf5495Efe5DB9ce00f80364C8B423567e58d2110",
      symbol: "ezETH",
    },
  },
  {
    id: "0x89613b0381d73cf379c507bf731cd79f9bd06c28372284b7559fc47fb2873ba7",
    name: "USDC / PT-mMEV-31JUL2025",
    irm: "0x870aC11D48B15DB9a138Cf899d20F13F79Ba00BC",
    lltv: "915000000000000000",
    oracle: "0x4DD5060174B344A88E04DD7085BD6b2bfD98da2F",
    loanToken: {
      address: "0xA0b86991c6218b36c1d19D4a2e9Eb0cE3606eB48",
      symbol: "USDC",
    },
    collateralToken: {
      address: "0x1132065009850C72E27B7950C0f9285d1D103589",
      symbol: "PT-mMEV-31JUL2025",
    },
  },
  {
    id: "0x3197babfc8c9f0fd05fbd5b48e2c5b3d3eeec8277586c02f933a17f5e83e067a",
    name: "WBTC / wstETH",
    irm: "0x870aC11D48B15DB9a138Cf899d20F13F79Ba00BC",
    lltv: "860000000000000000",
    oracle: "0xAe12416c1F21B0698c27fe042D9309C83baC6597",
    loanToken: {
      address: "0x2260FAC5E5542a773Aa44fBCfeDf7C193bc2C599",
      symbol: "WBTC",
    },
    collateralToken: {
      address: "0x7f39C581F595B53c5cb19bD0b3f8dA6c935E2Ca0",
      symbol: "wstETH",
    },
  },
  {
    id: "0x97efa214630ff5ed8f2194e7f173344f3a2f93bf8f5c6653d0509312efc9fae1",
    name: "USDC / PT-mEDGE-31JUL2025",
    irm: "0x870aC11D48B15DB9a138Cf899d20F13F79Ba00BC",
    lltv: "860000000000000000",
    oracle: "0x07Ed3029AE401f4B012A257BB0721dee3bE695C3",
    loanToken: {
      address: "0xA0b86991c6218b36c1d19D4a2e9Eb0cE3606eB48",
      symbol: "USDC",
    },
    collateralToken: {
      address: "0x7f01d0FCe9BC646389483384C41B4d71c7139f11",
      symbol: "PT-mEDGE-31JUL2025",
    },
  },
  {
    id: "0x1929f8139224cb7d5db8c270addc9ce366d37ad279e1135f73c0adce74b0f936",
    name: "WETH / sDAI",
    irm: "0x870aC11D48B15DB9a138Cf899d20F13F79Ba00BC",
    lltv: "860000000000000000",
    oracle: "0x0f9bb760D76af1B5Ca89102084E1963F6698AFda",
    loanToken: {
      address: "0xC02aaA39b223FE8D0A0e5C4F27eAD9083C756Cc2",
      symbol: "WETH",
    },
    collateralToken: {
      address: "0x83F20F44975D03b1b09e64809B757c47f942BEeA",
      symbol: "sDAI",
    },
  },
  {
    id: "0x2325461da586eb4defde435b8baa5e5fced15cc0bce490daed53828f49776544",
    name: "WETH / LsETH",
    irm: "0x870aC11D48B15DB9a138Cf899d20F13F79Ba00BC",
    lltv: "915000000000000000",
    oracle: "0x756F5d3735Aa73740A4461f017529afDDfa3AB8a",
    loanToken: {
      address: "0xC02aaA39b223FE8D0A0e5C4F27eAD9083C756Cc2",
      symbol: "WETH",
    },
    collateralToken: {
      address: "0x8c1BEd5b9a0928467c9B1341Da1D7BD5e10b6549",
      symbol: "LsETH",
    },
  },
  {
    id: "0xa9abd614ac94eee663b472bac0f704ece4469c3ce12df1d84565c7781541793e",
    name: "USDC / mMEV",
    irm: "0x870aC11D48B15DB9a138Cf899d20F13F79Ba00BC",
    lltv: "860000000000000000",
    oracle: "0x19359e9c02E711c0d81Cd47073739C2bfD03f9ec",
    loanToken: {
      address: "0xA0b86991c6218b36c1d19D4a2e9Eb0cE3606eB48",
      symbol: "USDC",
    },
    collateralToken: {
      address: "0x030b69280892c888670EDCDCD8B69Fd8026A0BF3",
      symbol: "mMEV",
    },
  },
  {
    id: "0xbd33e0ae076c82cfd0fa8d759ea83a296190f9f98d9f79b74a0eb4a294d8bf42",
    name: "USDC / weETH",
    irm: "0x870aC11D48B15DB9a138Cf899d20F13F79Ba00BC",
    lltv: "770000000000000000",
    oracle: "0x90CFE73B913ee1B93EA75Aa47134b7330289a458",
    loanToken: {
      address: "0xA0b86991c6218b36c1d19D4a2e9Eb0cE3606eB48",
      symbol: "USDC",
    },
    collateralToken: {
      address: "0xCd5fE23C85820F7B72D0926FC9b05b43E359b7ee",
      symbol: "weETH",
    },
  },
  {
    id: "0x50e26162f35945381884ea34bf5c1d5d9f15c9305febbc1f890c916963ba0f2b",
    name: "wUSDL / WBTC",
    irm: "0x870aC11D48B15DB9a138Cf899d20F13F79Ba00BC",
    lltv: "860000000000000000",
    oracle: "0x715c67c9b32ccF70C24539978649E80a4E4950Bd",
    loanToken: {
      address: "0x7751E2F4b8ae93EF6B79d86419d42FE3295A4559",
      symbol: "wUSDL",
    },
    collateralToken: {
      address: "0x2260FAC5E5542a773Aa44fBCfeDf7C193bc2C599",
      symbol: "WBTC",
    },
  },
  {
    id: "0xdb1966b0052cc35716936b66a42982563f5c1db86a181f0b0dc6feb36dffbc28",
    name: "USDT / syrupUSDC",
    irm: "0x870aC11D48B15DB9a138Cf899d20F13F79Ba00BC",
    lltv: "915000000000000000",
    oracle: "0x80032f4cb6E3573b9ed61E888AF658E48Fb790cC",
    loanToken: {
      address: "0xdAC17F958D2ee523a2206206994597C13D831ec7",
      symbol: "USDT",
    },
    collateralToken: {
      address: "0x80ac24aA929eaF5013f6436cdA2a7ba190f5Cc0b",
      symbol: "syrupUSDC",
    },
  },
  {
    id: "0xb98ad8501bd97ce0684b30b3645e31713e658e98d1955e8b677fb2585eaa9893",
    name: "USDC / mTBILL",
    irm: "0x870aC11D48B15DB9a138Cf899d20F13F79Ba00BC",
    lltv: "965000000000000000",
    oracle: "0x253aACb28f65f2C835Bd3eaB89c67447001F3041",
    loanToken: {
      address: "0xA0b86991c6218b36c1d19D4a2e9Eb0cE3606eB48",
      symbol: "USDC",
    },
    collateralToken: {
      address: "0xDD629E5241CbC5919847783e6C96B2De4754e438",
      symbol: "mTBILL",
    },
  },
  {
    id: "0xa92b15e14a894c10730434dd0cf2239101b2c1baedcf9abccd93076e4aebe364",
    name: "wUSDM / wstETH",
    irm: "0x870aC11D48B15DB9a138Cf899d20F13F79Ba00BC",
    lltv: "860000000000000000",
    oracle: "0xdB565Ff31EB988123F0B2F5d019B2139708ef50D",
    loanToken: {
      address: "0x57F5E098CaD7A3D1Eed53991D4d66C45C9AF7812",
      symbol: "wUSDM",
    },
    collateralToken: {
      address: "0x7f39C581F595B53c5cb19bD0b3f8dA6c935E2Ca0",
      symbol: "wstETH",
    },
  },
  {
    id: "0xb7aaedc202cc26f4d714507605efdd2d03cf9f4994a814cb19bb49a513a506a8",
    name: "WETH / rsETH",
    irm: "0x870aC11D48B15DB9a138Cf899d20F13F79Ba00BC",
    lltv: "860000000000000000",
    oracle: "0x4098B3f2a0E8897d7f253e3035F7DD3285594daD",
    loanToken: {
      address: "0xC02aaA39b223FE8D0A0e5C4F27eAD9083C756Cc2",
      symbol: "WETH",
    },
    collateralToken: {
      address: "0xA1290d69c65A6Fe4DF752f95823fae25cB99e5A7",
      symbol: "rsETH",
    },
  },
  {
    id: "0x96905763efe6da2cee9553fa567ef4daa8c4d057ce8d2973c26d424d5a59eb8a",
    name: "USDC / wUSCC",
    irm: "0x870aC11D48B15DB9a138Cf899d20F13F79Ba00BC",
    lltv: "980000000000000000",
    oracle: "0x68066D2891254F1F3285Cac0bB16B65B28EE3cAb",
    loanToken: {
      address: "0xA0b86991c6218b36c1d19D4a2e9Eb0cE3606eB48",
      symbol: "USDC",
    },
    collateralToken: {
      address: "0xF458Ad24B1dE7c653e8471efB0b87710b316b7D9",
      symbol: "wUSCC",
    },
  },
  {
    id: "0x06f2842602373d247c4934f7656e513955ccc4c377f0febc0d9ca2c3bcc191b1",
    name: "USDC / sDAI",
    irm: "0x870aC11D48B15DB9a138Cf899d20F13F79Ba00BC",
    lltv: "965000000000000000",
    oracle: "0x6CAFE228eC0B0bC2D076577d56D35Fe704318f6d",
    loanToken: {
      address: "0xA0b86991c6218b36c1d19D4a2e9Eb0cE3606eB48",
      symbol: "USDC",
    },
    collateralToken: {
      address: "0x83F20F44975D03b1b09e64809B757c47f942BEeA",
      symbol: "sDAI",
    },
  },
  {
    id: "0x1def309fa6c5b6ee7044b67154f15872af6c7e240f1e103f6a46cd82fb351688",
    name: "USDC / aprUSR",
    irm: "0x870aC11D48B15DB9a138Cf899d20F13F79Ba00BC",
    lltv: "915000000000000000",
    oracle: "0xD8891e132D450220125185eEB82e64a008abd3D3",
    loanToken: {
      address: "0xA0b86991c6218b36c1d19D4a2e9Eb0cE3606eB48",
      symbol: "USDC",
    },
    collateralToken: {
      address: "0x5085Dd6FAd07c12e38fae01bc2a4938d2C08B1Bc",
      symbol: "aprUSR",
    },
  },
  {
    id: "0xd3d60d19f04614baecb74e134b7bdd775dd7b37950f084ffcf4c05869ed260f1",
    name: "AUSD / wstETH",
    irm: "0x870aC11D48B15DB9a138Cf899d20F13F79Ba00BC",
    lltv: "860000000000000000",
    oracle: "0x27679a17b7419fB10Bd9D143f21407760fdA5C53",
    loanToken: {
      address: "0x00000000eFE302BEAA2b3e6e1b18d08D69a9012a",
      symbol: "AUSD",
    },
    collateralToken: {
      address: "0x7f39C581F595B53c5cb19bD0b3f8dA6c935E2Ca0",
      symbol: "wstETH",
    },
  },
  {
    id: "0xb1eac1c0f3ad13fb45b01beac8458c055c903b1bff8cb882346635996a774f77",
    name: "DAI / sDAI",
    irm: "0x870aC11D48B15DB9a138Cf899d20F13F79Ba00BC",
    lltv: "980000000000000000",
    oracle: "0x9d4eb56E054e4bFE961F861E351F606987784B65",
    loanToken: {
      address: "0x6B175474E89094C44Da98b954EedeAC495271d0F",
      symbol: "DAI",
    },
    collateralToken: {
      address: "0x83F20F44975D03b1b09e64809B757c47f942BEeA",
      symbol: "sDAI",
    },
  },
  {
    id: "0x2f94feaa932b09ef82b27f72661fbd770444ce350f9ebd6f1248c391bfd669b1",
    name: "USDC / sUSDf",
    irm: "0x870aC11D48B15DB9a138Cf899d20F13F79Ba00BC",
    lltv: "915000000000000000",
    oracle: "0x74008068faf8A4804000E140169Ac9A2E2aC41D2",
    loanToken: {
      address: "0xA0b86991c6218b36c1d19D4a2e9Eb0cE3606eB48",
      symbol: "USDC",
    },
    collateralToken: {
      address: "0xc8CF6D7991f15525488b2A83Df53468D682Ba4B0",
      symbol: "sUSDf",
    },
  },
  {
    id: "0x1b1ee1ee5370849479edc8af35ba966353c030c7837de172d45f1e1689756a18",
    name: "ZCHF / WETH",
    irm: "0x870aC11D48B15DB9a138Cf899d20F13F79Ba00BC",
    lltv: "860000000000000000",
    oracle: "0x0d3B0cFDF76DF7D0d0f9784A96C90384Bb3335E7",
    loanToken: {
      address: "0xB58E61C3098d85632Df34EecfB899A1Ed80921cB",
      symbol: "ZCHF",
    },
    collateralToken: {
      address: "0xC02aaA39b223FE8D0A0e5C4F27eAD9083C756Cc2",
      symbol: "WETH",
    },
  },
  {
    id: "0xf213843ac8ce2c8408182fc80c9e8f9911b420cce24adec8ea105ae44de087ad",
    name: "USDT / sDAI",
    irm: "0x870aC11D48B15DB9a138Cf899d20F13F79Ba00BC",
    lltv: "965000000000000000",
    oracle: "0x7538C68d863b28E34b986C1E8daFEDa31D824923",
    loanToken: {
      address: "0xdAC17F958D2ee523a2206206994597C13D831ec7",
      symbol: "USDT",
    },
    collateralToken: {
      address: "0x83F20F44975D03b1b09e64809B757c47f942BEeA",
      symbol: "sDAI",
    },
  },
  {
    id: "0xe7a01a04908247c9bafb7e2872d14c67a9ae6463762dcf72751b8711e987a62a",
    name: "USDe / PT-eUSDE-29MAY2025",
    irm: "0x870aC11D48B15DB9a138Cf899d20F13F79Ba00BC",
    lltv: "915000000000000000",
    oracle: "0x2c9e49d332C84ABe8A3E42E903705F3146f452D8",
    loanToken: {
      address: "0x4c9EDD5852cd905f086C759E8383e09bff1E68B3",
      symbol: "USDe",
    },
    collateralToken: {
      address: "0x50D2C7992b802Eef16c04FeADAB310f31866a545",
      symbol: "PT-eUSDE-29MAY2025",
    },
  },
  {
    id: "0xc88b82b38429b51297b0584d23837c60a7e8fdab9572816b628a2102b42c81c4",
    name: "USDC / JPYC",
    irm: "0x870aC11D48B15DB9a138Cf899d20F13F79Ba00BC",
    lltv: "915000000000000000",
    oracle: "0xE335e87D8907457E10EF66EdB0fa728aeD596fb5",
    loanToken: {
      address: "0xA0b86991c6218b36c1d19D4a2e9Eb0cE3606eB48",
      symbol: "USDC",
    },
    collateralToken: {
      address: "0xE7C3D8C9a439feDe00D2600032D5dB0Be71C3c29",
      symbol: "JPYC",
    },
  },
  {
    id: "0x19dcbfc7c624d947342c2164ea65c322c8f09adfdf8d00d0e1429163a0c8b9cb",
    name: "WETH / WBTC",
    irm: "0x870aC11D48B15DB9a138Cf899d20F13F79Ba00BC",
    lltv: "915000000000000000",
    oracle: "0x4FA38B8b62dCFeFa808c2de40ED2D65D4eb78D80",
    loanToken: {
      address: "0xC02aaA39b223FE8D0A0e5C4F27eAD9083C756Cc2",
      symbol: "WETH",
    },
    collateralToken: {
      address: "0x2260FAC5E5542a773Aa44fBCfeDf7C193bc2C599",
      symbol: "WBTC",
    },
  },
  {
    id: "0xd7d707a87302a1162288c61b3573a4229d2eb593e991afde07e731b7801bbb87",
    name: "USDC / weETH",
    irm: "0x870aC11D48B15DB9a138Cf899d20F13F79Ba00BC",
    lltv: "860000000000000000",
    oracle: "0xA5e9132dFec3629289BCbccf8fabAAaFc2118D9C",
    loanToken: {
      address: "0xA0b86991c6218b36c1d19D4a2e9Eb0cE3606eB48",
      symbol: "USDC",
    },
    collateralToken: {
      address: "0xCd5fE23C85820F7B72D0926FC9b05b43E359b7ee",
      symbol: "weETH",
    },
  },
  {
    id: "0xfb7c3a3af1ab477a2224b1387d0fd233ee9fb80e8208011996e4fd5aacd50c36",
    name: "USDT / WBTC",
    irm: "0x870aC11D48B15DB9a138Cf899d20F13F79Ba00BC",
    lltv: "860000000000000000",
    oracle: "0x7a7e2E2c51Fd10B34B2d1598daB971C42D4385AF",
    loanToken: {
      address: "0xdAC17F958D2ee523a2206206994597C13D831ec7",
      symbol: "USDT",
    },
    collateralToken: {
      address: "0x2260FAC5E5542a773Aa44fBCfeDf7C193bc2C599",
      symbol: "WBTC",
    },
  },
  {
    id: "0x3bb29b62affbedc60b8446b235aaa349d5e3bad96c09bca1d7a2d693c06669aa",
    name: "USDC / sDAI",
    irm: "0x870aC11D48B15DB9a138Cf899d20F13F79Ba00BC",
    lltv: "945000000000000000",
    oracle: "0x6CAFE228eC0B0bC2D076577d56D35Fe704318f6d",
    loanToken: {
      address: "0xA0b86991c6218b36c1d19D4a2e9Eb0cE3606eB48",
      symbol: "USDC",
    },
    collateralToken: {
      address: "0x83F20F44975D03b1b09e64809B757c47f942BEeA",
      symbol: "sDAI",
    },
  },
  {
    id: "0x1f9de540488a4ed6b5cb8a10ac626a1c0f52f7a70486869aeda26ca89b0cb6f3",
    name: "USDT / weETH",
    irm: "0x870aC11D48B15DB9a138Cf899d20F13F79Ba00BC",
    lltv: "770000000000000000",
    oracle: "0x2C305ddAb8F995270fC512aD7356A60cb3bc3fD4",
    loanToken: {
      address: "0xdAC17F958D2ee523a2206206994597C13D831ec7",
      symbol: "USDT",
    },
    collateralToken: {
      address: "0xCd5fE23C85820F7B72D0926FC9b05b43E359b7ee",
      symbol: "weETH",
    },
  },
  {
    id: "0x211e20e4dda74a7d0dee434047453176b36628849ad5206ca665928250ede671",
    name: "EURC / WBTC",
    irm: "0x870aC11D48B15DB9a138Cf899d20F13F79Ba00BC",
    lltv: "860000000000000000",
    oracle: "0x3589EC5d8A32d08AAA3DD26F198325312c0994E3",
    loanToken: {
      address: "0x1aBaEA1f7C830bD89Acc67eC4af516284b1bC33c",
      symbol: "EURC",
    },
    collateralToken: {
      address: "0x2260FAC5E5542a773Aa44fBCfeDf7C193bc2C599",
      symbol: "WBTC",
    },
  },
  {
    id: "0xee27705177f7f2aefe7d3e9fa18f1c7b8c0e879c0c89ea90baa30e6d190bbd1f",
    name: "USDe / PT-tUSDe-25SEP2025",
    irm: "0x870aC11D48B15DB9a138Cf899d20F13F79Ba00BC",
    lltv: "915000000000000000",
    oracle: "0x43e1B0Afaef39d6BA0C8b65c2D2E48e98af5956E",
    loanToken: {
      address: "0x4c9EDD5852cd905f086C759E8383e09bff1E68B3",
      symbol: "USDe",
    },
    collateralToken: {
      address: "0xd0a4B74A6B62aA2b6C02349463D9041606608F36",
      symbol: "PT-tUSDe-25SEP2025",
    },
  },
  {
    id: "0xeb9a6eba208057e4cefd06867b9f859dd435f6bca13bd3863a22169d7e4eaa95",
    name: "USDT / weETH",
    irm: "0x870aC11D48B15DB9a138Cf899d20F13F79Ba00BC",
    lltv: "770000000000000000",
    oracle: "0x8112582343CFBA0C92ABf54ba90341e44c2Cc6B5",
    loanToken: {
      address: "0xdAC17F958D2ee523a2206206994597C13D831ec7",
      symbol: "USDT",
    },
    collateralToken: {
      address: "0xCd5fE23C85820F7B72D0926FC9b05b43E359b7ee",
      symbol: "weETH",
    },
  },
  {
    id: "0xc05c85b825e8a98e0777503a1e7de59b4ae030891942c32a2cd0559ba487812e",
    name: "USDC / weETH",
    irm: "0x870aC11D48B15DB9a138Cf899d20F13F79Ba00BC",
    lltv: "860000000000000000",
    oracle: "0x96DBA1c4c257fC2CBa1A05602150906104302605",
    loanToken: {
      address: "0xA0b86991c6218b36c1d19D4a2e9Eb0cE3606eB48",
      symbol: "USDC",
    },
    collateralToken: {
      address: "0xCd5fE23C85820F7B72D0926FC9b05b43E359b7ee",
      symbol: "weETH",
    },
  },
  {
    id: "0xaa5a04bc4ff48ca058c4b2f031ddf8bc9952a622e721bd1625310d16c4c88485",
    name: "USDC / n-st-mHYPER",
    irm: "0x870aC11D48B15DB9a138Cf899d20F13F79Ba00BC",
    lltv: "770000000000000000",
    oracle: "0x2A5c94fe8fa6c0c8D2A87E5C71ad628caA092ce4",
    loanToken: {
      address: "0xA0b86991c6218b36c1d19D4a2e9Eb0cE3606eB48",
      symbol: "USDC",
    },
    collateralToken: {
      address: "0x2A5c94fe8fa6c0c8D2A87E5C71ad628caA092ce4",
      symbol: "n-st-mHYPER",
    },
  },
  {
    id: "0x736939cf768d5e454a17cad9b06a40436686a2ca69e4c9dbbaf3b92d25a42cda",
    name: "EURC / WETH",
    irm: "0x870aC11D48B15DB9a138Cf899d20F13F79Ba00BC",
    lltv: "860000000000000000",
    oracle: "0xa25f00b36b03D137869915Ff55e6BC78D5dDc07E",
    loanToken: {
      address: "0x1aBaEA1f7C830bD89Acc67eC4af516284b1bC33c",
      symbol: "EURC",
    },
    collateralToken: {
      address: "0xC02aaA39b223FE8D0A0e5C4F27eAD9083C756Cc2",
      symbol: "WETH",
    },
  },
  {
    id: "0x2079c2997029e59282260866e7fe280ae0dade21abc2a274be623e69c07ef719",
    name: "WETH / WBTC",
    irm: "0x870aC11D48B15DB9a138Cf899d20F13F79Ba00BC",
    lltv: "915000000000000000",
    oracle: "0x846B66FAb7147C6c18886f4f87ED160598c36fEA",
    loanToken: {
      address: "0xC02aaA39b223FE8D0A0e5C4F27eAD9083C756Cc2",
      symbol: "WETH",
    },
    collateralToken: {
      address: "0x2260FAC5E5542a773Aa44fBCfeDf7C193bc2C599",
      symbol: "WBTC",
    },
  },
  {
    id: "0x79cad5afdeffd68a722b33477f013a8541af0d974568f161b69481fb01b2b93e",
    name: "USDC / WBTC",
    irm: "0x870aC11D48B15DB9a138Cf899d20F13F79Ba00BC",
    lltv: "965000000000000000",
    oracle: "0xA6D6950c9F177F1De7f7757FB33539e3Ec60182a",
    loanToken: {
      address: "0xA0b86991c6218b36c1d19D4a2e9Eb0cE3606eB48",
      symbol: "USDC",
    },
    collateralToken: {
      address: "0x2260FAC5E5542a773Aa44fBCfeDf7C193bc2C599",
      symbol: "WBTC",
    },
  },
  {
    id: "0x37da2f57710260fe171bf226403a796bdd939d8342293acc9db8b6c73155a309",
    name: "EURC / wstETH",
    irm: "0x870aC11D48B15DB9a138Cf899d20F13F79Ba00BC",
    lltv: "860000000000000000",
    oracle: "0x88f8d223f0fB0ec0A1Ff5b42FFFdC071a6519080",
    loanToken: {
      address: "0x1aBaEA1f7C830bD89Acc67eC4af516284b1bC33c",
      symbol: "EURC",
    },
    collateralToken: {
      address: "0x7f39C581F595B53c5cb19bD0b3f8dA6c935E2Ca0",
      symbol: "wstETH",
    },
  },
  {
    id: "0x631e64ae8498821a5605bd3c14e253ffbf207f87411e2aeffc91a32a126cc13d",
    name: "PYUSD / WETH",
    irm: "0x870aC11D48B15DB9a138Cf899d20F13F79Ba00BC",
    lltv: "860000000000000000",
    oracle: "0x1FcB6213410b0a97496189ab704A014af4FDbEBc",
    loanToken: {
      address: "0x6c3ea9036406852006290770BEdFcAbA0e23A0e8",
      symbol: "PYUSD",
    },
    collateralToken: {
      address: "0xC02aaA39b223FE8D0A0e5C4F27eAD9083C756Cc2",
      symbol: "WETH",
    },
  },
  {
    id: "0xc5452afcc3f0f2c1ba26bc948283348b244f865da4b6ec5689535975db901bc9",
    name: "USDC / WBTC",
    irm: "0x870aC11D48B15DB9a138Cf899d20F13F79Ba00BC",
    lltv: "860000000000000000",
    oracle: "0x8f6419E32c198789931D07910A1BE1C75D8d09C1",
    loanToken: {
      address: "0xA0b86991c6218b36c1d19D4a2e9Eb0cE3606eB48",
      symbol: "USDC",
    },
    collateralToken: {
      address: "0x2260FAC5E5542a773Aa44fBCfeDf7C193bc2C599",
      symbol: "WBTC",
    },
  },
  {
    id: "0xa4b710bcd83f9098e0b610285aa1163cf08eccb4e334bd633874fffb3b0e8ae5",
    name: "USDT / WBTC",
    irm: "0x870aC11D48B15DB9a138Cf899d20F13F79Ba00BC",
    lltv: "860000000000000000",
    oracle: "0x92b6E98e1894C6B7A53e23a8a0e340Cca8b0d45e",
    loanToken: {
      address: "0xdAC17F958D2ee523a2206206994597C13D831ec7",
      symbol: "USDT",
    },
    collateralToken: {
      address: "0x2260FAC5E5542a773Aa44fBCfeDf7C193bc2C599",
      symbol: "WBTC",
    },
  },
  {
    id: "0x7c000eacd6c13e1b0c7ea34a7fc5bed776ac2f80d29e28d74fac612c9c436400",
    name: "USDC / WBTC",
    irm: "0x870aC11D48B15DB9a138Cf899d20F13F79Ba00BC",
    lltv: "860000000000000000",
    oracle: "0xE2725383B79b810576fe7a31C91Bb60D9A1D0FAD",
    loanToken: {
      address: "0xA0b86991c6218b36c1d19D4a2e9Eb0cE3606eB48",
      symbol: "USDC",
    },
    collateralToken: {
      address: "0x2260FAC5E5542a773Aa44fBCfeDf7C193bc2C599",
      symbol: "WBTC",
    },
  },
  {
    id: "0x7f8aa8ea57fd7d7fc2b7d807c81478eacf2f52919e5e0e0c72a2c375b8a5b42c",
    name: "USDC / WETH",
    irm: "0x870aC11D48B15DB9a138Cf899d20F13F79Ba00BC",
    lltv: "945000000000000000",
    oracle: "0x727c2B72d9723a3cd053962d5bB2bffcA2F9a54d",
    loanToken: {
      address: "0xA0b86991c6218b36c1d19D4a2e9Eb0cE3606eB48",
      symbol: "USDC",
    },
    collateralToken: {
      address: "0xC02aaA39b223FE8D0A0e5C4F27eAD9083C756Cc2",
      symbol: "WETH",
    },
  },
  {
    id: "0x099fa033fe832f4bbe8345f12f9ce192bb32f5d017d4843b1fa3f6aeefc65942",
    name: "WBTC / sBTCD",
    irm: "0x870aC11D48B15DB9a138Cf899d20F13F79Ba00BC",
    lltv: "770000000000000000",
    oracle: "0x9A740B60400Cdc8d14FA8668eD314f9b1956Efc8",
    loanToken: {
      address: "0x2260FAC5E5542a773Aa44fBCfeDf7C193bc2C599",
      symbol: "WBTC",
    },
    collateralToken: {
      address: "0x3BC801419479865B24b4d32faB0Bf64638Abbd5f",
      symbol: "sBTCD",
    },
  },
  {
    id: "0x1e6e9014fc7b882490a0cd420475069563f80c319b5bf3ab2e4162b0549dd4dc",
    name: "wstETH / weETH",
    irm: "0x870aC11D48B15DB9a138Cf899d20F13F79Ba00BC",
    lltv: "945000000000000000",
    oracle: "0x6a8D47bA22631A0DE7e0e83DBc21c384a5994102",
    loanToken: {
      address: "0x7f39C581F595B53c5cb19bD0b3f8dA6c935E2Ca0",
      symbol: "wstETH",
    },
    collateralToken: {
      address: "0xCd5fE23C85820F7B72D0926FC9b05b43E359b7ee",
      symbol: "weETH",
    },
  },
  {
    id: "0x51ac4100851b7186b82d4101838b7c89678430adcf5e728f9e895131b49709b1",
    name: "USDC / PT-ysUSDC-31JUL2025",
    irm: "0x870aC11D48B15DB9a138Cf899d20F13F79Ba00BC",
    lltv: "915000000000000000",
    oracle: "0xc901A408fEf71A2D485B328FBcff55e2Ea8acf01",
    loanToken: {
      address: "0xA0b86991c6218b36c1d19D4a2e9Eb0cE3606eB48",
      symbol: "USDC",
    },
    collateralToken: {
      address: "0x11105208Abb3Ce206922Bf4cd6B2D5F98CAC2F0d",
      symbol: "PT-ysUSDC-31JUL2025",
    },
  },
  {
    id: "0x9f4d8ba585b21520f23072010bcc8f861dff2856059d785eb5b7fb00bc7c575c",
    name: "WBTC / PT-corn-SolvBTC.BBN-26DEC2024",
    irm: "0x870aC11D48B15DB9a138Cf899d20F13F79Ba00BC",
    lltv: "860000000000000000",
    oracle: "0x3F72603328248f0459a13d72dC85cEe40f8268a7",
    loanToken: {
      address: "0x2260FAC5E5542a773Aa44fBCfeDf7C193bc2C599",
      symbol: "WBTC",
    },
    collateralToken: {
      address: "0x23e479ddcda990E8523494895759bD98cD2fDBF6",
      symbol: "PT-corn-SolvBTC.BBN-26DEC2024",
    },
  },
  {
    id: "0x5c8a6157f109ab2af0d3be0b82134e67ee19dbd0c35f96ba8b89bb173faefb10",
    name: "rUSD / WBTC",
    irm: "0x870aC11D48B15DB9a138Cf899d20F13F79Ba00BC",
    lltv: "860000000000000000",
    oracle: "0x032F1C64899b2C89835E51aCeD9434b0aDEaA69d",
    loanToken: {
      address: "0x09D4214C03D01F49544C0448DBE3A27f768F2b34",
      symbol: "rUSD",
    },
    collateralToken: {
      address: "0x2260FAC5E5542a773Aa44fBCfeDf7C193bc2C599",
      symbol: "WBTC",
    },
  },
  {
    id: "0xa6bb1fa76ed380d7245bc56eb4fd35013342358130dd68f2b3b05c8123ea2444",
    name: "WETH / LBTC",
    irm: "0x870aC11D48B15DB9a138Cf899d20F13F79Ba00BC",
    lltv: "915000000000000000",
    oracle: "0x2Ca92Ff15daa2AAfb1b29e6f80ce402F58635903",
    loanToken: {
      address: "0xC02aaA39b223FE8D0A0e5C4F27eAD9083C756Cc2",
      symbol: "WETH",
    },
    collateralToken: {
      address: "0x8236a87084f8B84306f72007F36F2618A5634494",
      symbol: "LBTC",
    },
  },
  {
    id: "0xee697d5fd14636527c282a321481bba380c4fa5d3b9d520141285c89ebab6784",
    name: "tGBP / USDC",
    irm: "0x870aC11D48B15DB9a138Cf899d20F13F79Ba00BC",
    lltv: "915000000000000000",
    oracle: "0x37cAfCE35a74f518Eb544fbff5C6BbB1B8122A70",
    loanToken: {
      address: "0x27f6c8289550fCE67f6B50BeD1F519966aFE5287",
      symbol: "tGBP",
    },
    collateralToken: {
      address: "0xA0b86991c6218b36c1d19D4a2e9Eb0cE3606eB48",
      symbol: "USDC",
    },
  },
  {
    id: "0x62aad0b7cfadc9d66eafe559ecd2a084f74062f396c193973b124db9fee481c4",
    name: "WETH / WBTC",
    irm: "0x870aC11D48B15DB9a138Cf899d20F13F79Ba00BC",
    lltv: "915000000000000000",
    oracle: "0x46D18c1240dbC050d5e1224663EA22037df3A009",
    loanToken: {
      address: "0xC02aaA39b223FE8D0A0e5C4F27eAD9083C756Cc2",
      symbol: "WETH",
    },
    collateralToken: {
      address: "0x2260FAC5E5542a773Aa44fBCfeDf7C193bc2C599",
      symbol: "WBTC",
    },
  },
  {
    id: "0xae1839e7d779b32e91e2128405525b7f38478f38fed74b9a4795e8ed952592b7",
    name: "USDT / wbIB01",
    irm: "0x870aC11D48B15DB9a138Cf899d20F13F79Ba00BC",
    lltv: "965000000000000000",
    oracle: "0xC890f55Ef93A0E798D4B9a022252Ae2781047524",
    loanToken: {
      address: "0xdAC17F958D2ee523a2206206994597C13D831ec7",
      symbol: "USDT",
    },
    collateralToken: {
      address: "0xcA2A7068e551d5C4482eb34880b194E4b945712F",
      symbol: "wbIB01",
    },
  },
  {
    id: "0x514efda728a646dcafe4fdc9afe4ea214709e110ac1b2b78185ae00c1782cc82",
    name: "WBTC / swBTC",
    irm: "0x870aC11D48B15DB9a138Cf899d20F13F79Ba00BC",
    lltv: "945000000000000000",
    oracle: "0x99ADb404Ec05f43B897Ae2f917BfA7C5FDd24708",
    loanToken: {
      address: "0x2260FAC5E5542a773Aa44fBCfeDf7C193bc2C599",
      symbol: "WBTC",
    },
    collateralToken: {
      address: "0x8DB2350D78aBc13f5673A411D4700BCF87864dDE",
      symbol: "swBTC",
    },
  },
  {
    id: "0xb5b0ff0fccf16dff5bef6d2d001d60f5c4ab49df1020a01073d3ad635c80e8d5",
    name: "USDT / sUSDS",
    irm: "0x870aC11D48B15DB9a138Cf899d20F13F79Ba00BC",
    lltv: "945000000000000000",
    oracle: "0x0C426d174FC88B7A25d59945Ab2F7274Bf7B4C79",
    loanToken: {
      address: "0xdAC17F958D2ee523a2206206994597C13D831ec7",
      symbol: "USDT",
    },
    collateralToken: {
      address: "0xa3931d71877C0E7a3148CB7Eb4463524FEc27fbD",
      symbol: "sUSDS",
    },
  },
  {
    id: "0x19cc9b90c4ecde78f4644f4d5ebc938fbadf30f6e4cae95485192f038b23e1f3",
    name: "USDT / weETH",
    irm: "0x870aC11D48B15DB9a138Cf899d20F13F79Ba00BC",
    lltv: "770000000000000000",
    oracle: "0xa3A7A3ceFee206f9d7Fe00eC3C83324ED4228411",
    loanToken: {
      address: "0xdAC17F958D2ee523a2206206994597C13D831ec7",
      symbol: "USDT",
    },
    collateralToken: {
      address: "0xCd5fE23C85820F7B72D0926FC9b05b43E359b7ee",
      symbol: "weETH",
    },
  },
  {
    id: "0xf7cff44cf5333952f0c04a16d3db6f9fabba22c4e947654e3f79c6d6cda763fe",
    name: "EURC / WBTC",
    irm: "0x870aC11D48B15DB9a138Cf899d20F13F79Ba00BC",
    lltv: "860000000000000000",
    oracle: "0x0361A2be7a250077263272A0Eb8067c480749645",
    loanToken: {
      address: "0x1aBaEA1f7C830bD89Acc67eC4af516284b1bC33c",
      symbol: "EURC",
    },
    collateralToken: {
      address: "0x2260FAC5E5542a773Aa44fBCfeDf7C193bc2C599",
      symbol: "WBTC",
    },
  },
  {
    id: "0x2b1800a3b96cc786e4ae6d8f0c8047c0000fc2587939a3fbf14301a170d76537",
    name: "WETH / rswETH",
    irm: "0x870aC11D48B15DB9a138Cf899d20F13F79Ba00BC",
    lltv: "860000000000000000",
    oracle: "0x32aE7f50aAD360a0E991fA60E52d667A0241709A",
    loanToken: {
      address: "0xC02aaA39b223FE8D0A0e5C4F27eAD9083C756Cc2",
      symbol: "WETH",
    },
    collateralToken: {
      address: "0xFAe103DC9cf190eD75350761e95403b7b8aFa6c0",
      symbol: "rswETH",
    },
  },
  {
    id: "0x1ca7ff6b26581fe3155f391f3960d32a033b5f7d537b1f1932b2021a6cf4f706",
    name: "USDT / sDAI",
    irm: "0x870aC11D48B15DB9a138Cf899d20F13F79Ba00BC",
    lltv: "945000000000000000",
    oracle: "0x7538C68d863b28E34b986C1E8daFEDa31D824923",
    loanToken: {
      address: "0xdAC17F958D2ee523a2206206994597C13D831ec7",
      symbol: "USDT",
    },
    collateralToken: {
      address: "0x83F20F44975D03b1b09e64809B757c47f942BEeA",
      symbol: "sDAI",
    },
  },
  {
    id: "0x147390b94333d30c4bd51c8e79e8f90f6e827e3ea97ecbfe2dc52a1ea67aa008",
    name: "USDC / PT-AIDaUSDT-14AUG2025",
    irm: "0x870aC11D48B15DB9a138Cf899d20F13F79Ba00BC",
    lltv: "915000000000000000",
    oracle: "0x75A7c9FDe77ad4c70aB5E9a0a020D8E9064A64f0",
    loanToken: {
      address: "0xA0b86991c6218b36c1d19D4a2e9Eb0cE3606eB48",
      symbol: "USDC",
    },
    collateralToken: {
      address: "0xA28194DE3de7166Ee81C2E13c864b9C7CcA1b8eF",
      symbol: "PT-AIDaUSDT-14AUG2025",
    },
  },
  {
    id: "0xa8e5d35b7dd3ed81d84a82e999d8360d73f4c3d7b9e356b58b3ec4d2ea724262",
    name: "USDC / PT-wsrUSD-30OCT2025",
    irm: "0x870aC11D48B15DB9a138Cf899d20F13F79Ba00BC",
    lltv: "915000000000000000",
    oracle: "0x211Cd125045A395c7054D132F3aC53e21D9A2C25",
    loanToken: {
      address: "0xA0b86991c6218b36c1d19D4a2e9Eb0cE3606eB48",
      symbol: "USDC",
    },
    collateralToken: {
      address: "0x10a099BAf814B5FDa138c4e6b60eD42c0d975be8",
      symbol: "PT-wsrUSD-30OCT2025",
    },
  },
  {
    id: "0xcf90e73ee616097c10278bfedc410a1addc3fd4c5c80b93ef248b91bbd4c062c",
    name: "USDC / PT-RUSD-30OCT2025",
    irm: "0x870aC11D48B15DB9a138Cf899d20F13F79Ba00BC",
    lltv: "915000000000000000",
    oracle: "0x40234d69Ea50c3C6171062f8A0af39835755049A",
    loanToken: {
      address: "0xA0b86991c6218b36c1d19D4a2e9Eb0cE3606eB48",
      symbol: "USDC",
    },
    collateralToken: {
      address: "0xdcFDf8434e8FDfFF2dD7dfC9299877e813348EE7",
      symbol: "PT-RUSD-30OCT2025",
    },
  },
  {
    id: "0x7110edd22b88dbc096b78384900d29d84e9edee2a06d5c0d36f957a94ce4ccba",
    name: "USDT / PT-RUSD-31JUL2025",
    irm: "0x870aC11D48B15DB9a138Cf899d20F13F79Ba00BC",
    lltv: "915000000000000000",
    oracle: "0x81BB2E546F138CE48df9C64268f6C89F9413e128",
    loanToken: {
      address: "0xdAC17F958D2ee523a2206206994597C13D831ec7",
      symbol: "USDT",
    },
    collateralToken: {
      address: "0xf736acF34FF7Cd9B3565b73a1f15E652859bF322",
      symbol: "PT-RUSD-31JUL2025",
    },
  },
  {
    id: "0xeeabdcb98e9f7ec216d259a2c026bbb701971efae0b44eec79a86053f9b128b6",
    name: "WETH / rsETH",
    irm: "0x870aC11D48B15DB9a138Cf899d20F13F79Ba00BC",
    lltv: "860000000000000000",
    oracle: "0x423671566dE77E9Cb50E9bE4383BA78fFC808a4e",
    loanToken: {
      address: "0xC02aaA39b223FE8D0A0e5C4F27eAD9083C756Cc2",
      symbol: "WETH",
    },
    collateralToken: {
      address: "0xA1290d69c65A6Fe4DF752f95823fae25cB99e5A7",
      symbol: "rsETH",
    },
  },
  {
    id: "0x3e37bd6e02277f15f93cd7534ce039e60d19d9298f4d1bc6a3a4f7bf64de0a1c",
    name: "USDC / PT-sUSDE-25SEP2025",
    irm: "0x870aC11D48B15DB9a138Cf899d20F13F79Ba00BC",
    lltv: "915000000000000000",
    oracle: "0x5139aa359F7F7FdE869305e8C7AD001B28E1C99a",
    loanToken: {
      address: "0xA0b86991c6218b36c1d19D4a2e9Eb0cE3606eB48",
      symbol: "USDC",
    },
    collateralToken: {
      address: "0x9F56094C450763769BA0EA9Fe2876070c0fD5F77",
      symbol: "PT-sUSDE-25SEP2025",
    },
  },
  {
    id: "0xd647ec76fd3d2e6fb2133fd496a150f91d86956ad02b0b654435501527d3da0c",
    name: "USDC / PT-wsrUSD-31JUL2025",
    irm: "0x870aC11D48B15DB9a138Cf899d20F13F79Ba00BC",
    lltv: "915000000000000000",
    oracle: "0xEf2730755ce3AA5F20eFbff6bD3eE8942760942b",
    loanToken: {
      address: "0xA0b86991c6218b36c1d19D4a2e9Eb0cE3606eB48",
      symbol: "USDC",
    },
    collateralToken: {
      address: "0x3bd0C522eA444eA2B3F28777e8C20248b6E33252",
      symbol: "PT-wsrUSD-31JUL2025",
    },
  },
  {
    id: "0x10b401f4254a7039b7168c5a614c81ea8be698186cfb33aa56ac2adbcf0e88f9",
    name: "USDC / PT-RUSD-31JUL2025",
    irm: "0x870aC11D48B15DB9a138Cf899d20F13F79Ba00BC",
    lltv: "915000000000000000",
    oracle: "0x2F9CEb1663BE430218a151D20ce805aCAc968C97",
    loanToken: {
      address: "0xA0b86991c6218b36c1d19D4a2e9Eb0cE3606eB48",
      symbol: "USDC",
    },
    collateralToken: {
      address: "0xf736acF34FF7Cd9B3565b73a1f15E652859bF322",
      symbol: "PT-RUSD-31JUL2025",
    },
  },
  {
    id: "0x94226011a4286b72d32ed7259954726d3fb0ba8b5ab319ccd57dbf4e7bfb069c",
    name: "USDC / wsrUSD",
    irm: "0x870aC11D48B15DB9a138Cf899d20F13F79Ba00BC",
    lltv: "915000000000000000",
    oracle: "0x03dfCa9A320ca88fA6a0A132F34822e4B13d6fa0",
    loanToken: {
      address: "0xA0b86991c6218b36c1d19D4a2e9Eb0cE3606eB48",
      symbol: "USDC",
    },
    collateralToken: {
      address: "0xd3fD63209FA2D55B07A0f6db36C2f43900be3094",
      symbol: "wsrUSD",
    },
  },
  {
    id: "0x1fab8977755133e036ef547713b9be3da9d2805118e62eb28ff59a7cd9ff75a7",
    name: "mUSD / wstETH",
    irm: "0x870aC11D48B15DB9a138Cf899d20F13F79Ba00BC",
    lltv: "860000000000000000",
    oracle: "0x95A18975379B6e114730C020bC6b1B133F4c7826",
    loanToken: {
      address: "0xacA92E438df0B2401fF60dA7E4337B687a2435DA",
      symbol: "mUSD",
    },
    collateralToken: {
      address: "0x7f39C581F595B53c5cb19bD0b3f8dA6c935E2Ca0",
      symbol: "wstETH",
    },
  },
  {
    id: "0xc6ba0a0bf96fbde89da661f4dfce15de5961d3163345c21d801be8a99190a584",
    name: "mUSD / wstETH",
    irm: "0x870aC11D48B15DB9a138Cf899d20F13F79Ba00BC",
    lltv: "860000000000000000",
    oracle: "0xe087AD7FE989cF63F8383579D160a20Ee7e69F9F",
    loanToken: {
      address: "0xacA92E438df0B2401fF60dA7E4337B687a2435DA",
      symbol: "mUSD",
    },
    collateralToken: {
      address: "0x7f39C581F595B53c5cb19bD0b3f8dA6c935E2Ca0",
      symbol: "wstETH",
    },
  },
  {
    id: "0x013c86b45cf32f8912a233e954057fe45d1607a81d13cf5ac3a484230a07c49d",
    name: "AUSD / WBTC",
    irm: "0x870aC11D48B15DB9a138Cf899d20F13F79Ba00BC",
    lltv: "860000000000000000",
    oracle: "0x6Fe4f9E836dD4002ab30728B6AE05EBD915035B6",
    loanToken: {
      address: "0x00000000eFE302BEAA2b3e6e1b18d08D69a9012a",
      symbol: "AUSD",
    },
    collateralToken: {
      address: "0x2260FAC5E5542a773Aa44fBCfeDf7C193bc2C599",
      symbol: "WBTC",
    },
  },
  {
    id: "0xfe9529b421abbc798f4a72b2dcf8c16ec2cc4f0114e472c8da81a26e601dc67e",
    name: "mUSD / WBTC",
    irm: "0x870aC11D48B15DB9a138Cf899d20F13F79Ba00BC",
    lltv: "860000000000000000",
    oracle: "0xf1561bC4b3D1bA49053986Fb9ee88D4fE22d0Cf4",
    loanToken: {
      address: "0xacA92E438df0B2401fF60dA7E4337B687a2435DA",
      symbol: "mUSD",
    },
    collateralToken: {
      address: "0x2260FAC5E5542a773Aa44fBCfeDf7C193bc2C599",
      symbol: "WBTC",
    },
  },
  {
    id: "0xb0ca701def0e39cd932db109b69daa9aa4b0f19605c3289c063c1162841a5f08",
    name: "mUSD / WETH",
    irm: "0x870aC11D48B15DB9a138Cf899d20F13F79Ba00BC",
    lltv: "860000000000000000",
    oracle: "0x0F948CBa8231Db7898ef36A4212581Ad7b1B4580",
    loanToken: {
      address: "0xacA92E438df0B2401fF60dA7E4337B687a2435DA",
      symbol: "mUSD",
    },
    collateralToken: {
      address: "0xC02aaA39b223FE8D0A0e5C4F27eAD9083C756Cc2",
      symbol: "WETH",
    },
  },
  {
    id: "0x2a9d6aaedb5fdcdb9f3b9904f93ca57a2455454b2a801aeeb1218ee61e8d3e98",
    name: "EURCV / WETH",
    irm: "0x870aC11D48B15DB9a138Cf899d20F13F79Ba00BC",
    lltv: "860000000000000000",
    oracle: "0x2bAD04c6213e46b6Ee69425E5b2c9cBE45254539",
    loanToken: {
      address: "0x5F7827FDeb7c20b443265Fc2F40845B715385Ff2",
      symbol: "EURCV",
    },
    collateralToken: {
      address: "0xC02aaA39b223FE8D0A0e5C4F27eAD9083C756Cc2",
      symbol: "WETH",
    },
  },
  {
    id: "0x2e2e38effbd96643982da3ab8970e602a5de74484c258e969d94d605f7c4602f",
    name: "USDCV / wstETH",
    irm: "0x870aC11D48B15DB9a138Cf899d20F13F79Ba00BC",
    lltv: "860000000000000000",
    oracle: "0xBC693693fDBB177Ad05ff38633110016BC043AC5",
    loanToken: {
      address: "0x5422374B27757da72d5265cC745ea906E0446634",
      symbol: "USDCV",
    },
    collateralToken: {
      address: "0x7f39C581F595B53c5cb19bD0b3f8dA6c935E2Ca0",
      symbol: "wstETH",
    },
  },
  {
    id: "0xe59f8ab47630b48774eed6eca865af9edcb807218fe9b59978c17de9c8473eb8",
    name: "EURCV / WBTC",
    irm: "0x870aC11D48B15DB9a138Cf899d20F13F79Ba00BC",
    lltv: "860000000000000000",
    oracle: "0x710db675ead4bE51EdC95E890ae1224168Eb6C2c",
    loanToken: {
      address: "0x5F7827FDeb7c20b443265Fc2F40845B715385Ff2",
      symbol: "EURCV",
    },
    collateralToken: {
      address: "0x2260FAC5E5542a773Aa44fBCfeDf7C193bc2C599",
      symbol: "WBTC",
    },
  },
  {
    id: "0x147977320f168afc651b7e5a1849cc1b1e64e329e1bf0212fa49dcb2856074a4",
    name: "USDC / PT-USD0++-27MAR2025",
    irm: "0x870aC11D48B15DB9a138Cf899d20F13F79Ba00BC",
    lltv: "915000000000000000",
    oracle: "0x9cba7f915744728F183eB706e37971d73A4929F6",
    loanToken: {
      address: "0xA0b86991c6218b36c1d19D4a2e9Eb0cE3606eB48",
      symbol: "USDC",
    },
    collateralToken: {
      address: "0x5BaE9a5D67d1CA5b09B14c91935f635CFBF3b685",
      symbol: "PT-USD0++-27MAR2025",
    },
  },
  {
    id: "0x5ffa710641fbb144618f351fbb57f74aed75ecd2ea3fced21d1c2fdb58763f50",
    name: "AUSD / sDAI",
    irm: "0x870aC11D48B15DB9a138Cf899d20F13F79Ba00BC",
    lltv: "965000000000000000",
    oracle: "0xd6361d441EA8Fd285F7cd8b7d406b424e50c5429",
    loanToken: {
      address: "0x00000000eFE302BEAA2b3e6e1b18d08D69a9012a",
      symbol: "AUSD",
    },
    collateralToken: {
      address: "0x83F20F44975D03b1b09e64809B757c47f942BEeA",
      symbol: "sDAI",
    },
  },
  {
    id: "0x944f5ebb33029e05ee338c2f4eb6ce0952f43a0524d5c8dd93d2e58a8dd8b55c",
    name: "USDT / PT-cUSD-29JAN2026",
    irm: "0x870aC11D48B15DB9a138Cf899d20F13F79Ba00BC",
    lltv: "915000000000000000",
    oracle: "0x74DE78a994EA17535c60d0bd3C72465dAad75039",
    loanToken: {
      address: "0xdAC17F958D2ee523a2206206994597C13D831ec7",
      symbol: "USDT",
    },
    collateralToken: {
      address: "0x545A490f9ab534AdF409A2E682bc4098f49952e3",
      symbol: "PT-cUSD-29JAN2026",
    },
  },
  {
    id: "0x87a3e5dbcd822f2a543bea1365b7dd99ad9a1cb460061278319732e63207c792",
    name: "WETH / autoETH",
    irm: "0x870aC11D48B15DB9a138Cf899d20F13F79Ba00BC",
    lltv: "860000000000000000",
    oracle: "0xA16104e432595B34Bd49c31D5Be2Fecc83a88867",
    loanToken: {
      address: "0xC02aaA39b223FE8D0A0e5C4F27eAD9083C756Cc2",
      symbol: "WETH",
    },
    collateralToken: {
      address: "0x0A2b94F6871c1D7A32Fe58E1ab5e6deA2f114E56",
      symbol: "autoETH",
    },
  },
  {
    id: "0xe61a903174169e4897669e9bc4419eb7582b36d1a3d3df633dccab88da6e2ccd",
    name: "USDC / PT-lvlUSD-25SEP2025",
    irm: "0x870aC11D48B15DB9a138Cf899d20F13F79Ba00BC",
    lltv: "915000000000000000",
    oracle: "0x5BAe86006Ed1Ea3DD2891bF56f27Ac4A098D5601",
    loanToken: {
      address: "0xA0b86991c6218b36c1d19D4a2e9Eb0cE3606eB48",
      symbol: "USDC",
    },
    collateralToken: {
      address: "0x207F7205fd6c4b602Fa792C8b2B60e6006D4a0b8",
      symbol: "PT-lvlUSD-25SEP2025",
    },
  },
  {
    id: "0x85252bb8485c99bba46fe149c7dd2aad83672640f53c630890673cf1848ba16e",
    name: "USDC / weETH",
    irm: "0x870aC11D48B15DB9a138Cf899d20F13F79Ba00BC",
    lltv: "860000000000000000",
    oracle: "0xa3A7A3ceFee206f9d7Fe00eC3C83324ED4228411",
    loanToken: {
      address: "0xA0b86991c6218b36c1d19D4a2e9Eb0cE3606eB48",
      symbol: "USDC",
    },
    collateralToken: {
      address: "0xCd5fE23C85820F7B72D0926FC9b05b43E359b7ee",
      symbol: "weETH",
    },
  },
  {
    id: "0x3a3b0aab54883f5b2561d8327fbe234142db4f50f87574cd07daf2ed3fbee01a",
    name: "USDC / PT-iUSD-4SEP2025",
    irm: "0x870aC11D48B15DB9a138Cf899d20F13F79Ba00BC",
    lltv: "915000000000000000",
    oracle: "0x826F361C22A687DbC34B52777a1c3Dcf1F5e3B70",
    loanToken: {
      address: "0xA0b86991c6218b36c1d19D4a2e9Eb0cE3606eB48",
      symbol: "USDC",
    },
    collateralToken: {
      address: "0x5f2F6324AA5590e408BA892e39ceC4C0afB16068",
      symbol: "PT-iUSD-4SEP2025",
    },
  },
  {
    id: "0x3f4d954d48cf36587b7b4dca20a4783bfb0a8ca4b35e17e6f3bfb034fde3bebc",
    name: "USDT / sUSDD",
    irm: "0x870aC11D48B15DB9a138Cf899d20F13F79Ba00BC",
    lltv: "945000000000000000",
    oracle: "0x0e16E4Cda06c47190127fd5050CC884C0c2f65A5",
    loanToken: {
      address: "0xdAC17F958D2ee523a2206206994597C13D831ec7",
      symbol: "USDT",
    },
    collateralToken: {
      address: "0xC5d6A7B61d18AfA11435a889557b068BB9f29930",
      symbol: "sUSDD",
    },
  },
  {
    id: "0x05702edf1c4709808b62fe65a7d082dccc9386f858ae460ef207ec8dd1debfa2",
    name: "USDC / PT-sUSDE-27NOV2025",
    irm: "0x870aC11D48B15DB9a138Cf899d20F13F79Ba00BC",
    lltv: "915000000000000000",
    oracle: "0x639c6f403822E1bDA434BEb2034Beb54f725BA0c",
    loanToken: {
      address: "0xA0b86991c6218b36c1d19D4a2e9Eb0cE3606eB48",
      symbol: "USDC",
    },
    collateralToken: {
      address: "0xe6A934089BBEe34F832060CE98848359883749B3",
      symbol: "PT-sUSDE-27NOV2025",
    },
  },
  {
    id: "0xb82cb1140daae367c1f39dd6b4ec6a3aaef997764c84634ad8a4114571c15ef3",
    name: "USDC / PT-RUSD-26FEB2026",
    irm: "0x870aC11D48B15DB9a138Cf899d20F13F79Ba00BC",
    lltv: "915000000000000000",
    oracle: "0x55FcD62CCaC955A4754712a641524A271322Cd36",
    loanToken: {
      address: "0xA0b86991c6218b36c1d19D4a2e9Eb0cE3606eB48",
      symbol: "USDC",
    },
    collateralToken: {
      address: "0xeEAa924eB3667F30Be02Db9C55d87566a3F4dF7A",
      symbol: "PT-RUSD-26FEB2026",
    },
  },
  {
    id: "0xcc6fbc7f375c5d8206667dd9b1beac424983b2a5c850f1d429499fcc574ddb6c",
    name: "wM / WBTC",
    irm: "0x870aC11D48B15DB9a138Cf899d20F13F79Ba00BC",
    lltv: "860000000000000000",
    oracle: "0x032F1C64899b2C89835E51aCeD9434b0aDEaA69d",
    loanToken: {
      address: "0x437cc33344a0B27A429f795ff6B469C72698B291",
      symbol: "wM",
    },
    collateralToken: {
      address: "0x2260FAC5E5542a773Aa44fBCfeDf7C193bc2C599",
      symbol: "WBTC",
    },
  },
  {
    id: "0x8c6983dfc0a25aa3ca77cd26a4b2bb509538cf7c87e7b289de7bd1fa1db48aff",
    name: "USDC / JAB78",
    irm: "0x870aC11D48B15DB9a138Cf899d20F13F79Ba00BC",
    lltv: "860000000000000000",
    oracle: "0x49897Dc703631b69adA1588361064f0048127A79",
    loanToken: {
      address: "0xA0b86991c6218b36c1d19D4a2e9Eb0cE3606eB48",
      symbol: "USDC",
    },
    collateralToken: {
      address: "0x1D7f5b3EC252b931A63A24a3A4b482CF26E7ecB4",
      symbol: "JAB78",
    },
  },
  {
    id: "0x5a2a33f40130ff2211d18847521c695e7899a3132ca059ab7122f3e9a5e7cc26",
    name: "EURC / wstETH",
    irm: "0x870aC11D48B15DB9a138Cf899d20F13F79Ba00BC",
    lltv: "860000000000000000",
    oracle: "0x916659a044Df8F7F0B17C6b60B7774BCF15AfDd0",
    loanToken: {
      address: "0x1aBaEA1f7C830bD89Acc67eC4af516284b1bC33c",
      symbol: "EURC",
    },
    collateralToken: {
      address: "0x7f39C581F595B53c5cb19bD0b3f8dA6c935E2Ca0",
      symbol: "wstETH",
    },
  },
  {
    id: "0x2b9a4565ad690184ba336e340792856634927b8d9f729461719e0c259fc27400",
    name: "EURC / WETH",
    irm: "0x870aC11D48B15DB9a138Cf899d20F13F79Ba00BC",
    lltv: "860000000000000000",
    oracle: "0x9cBF8132d872B66A72007C0EE934320Eb147D5D0",
    loanToken: {
      address: "0x1aBaEA1f7C830bD89Acc67eC4af516284b1bC33c",
      symbol: "EURC",
    },
    collateralToken: {
      address: "0xC02aaA39b223FE8D0A0e5C4F27eAD9083C756Cc2",
      symbol: "WETH",
    },
  },
  {
    id: "0x19e3b4f8dba2571dca8ec5f4babf5031d26fd0a17c6357162c2b66bd254930dd",
    name: "wM / WBTC",
    irm: "0x870aC11D48B15DB9a138Cf899d20F13F79Ba00BC",
    lltv: "860000000000000000",
    oracle: "0x09dbf9502d43445b33883837a51D06Fc9B9CdEC4",
    loanToken: {
      address: "0x437cc33344a0B27A429f795ff6B469C72698B291",
      symbol: "wM",
    },
    collateralToken: {
      address: "0x2260FAC5E5542a773Aa44fBCfeDf7C193bc2C599",
      symbol: "WBTC",
    },
  },
  {
    id: "0xf8680eb9c4fcd2be3d155cf7b1b0a2b56c6ad8c67beeceb5bb0bdb581a6cbbf2",
    name: "AUSD / sUSDe",
    irm: "0x870aC11D48B15DB9a138Cf899d20F13F79Ba00BC",
    lltv: "915000000000000000",
    oracle: "0xE582a48f2E51d96d222dD3FcffED3665b5dc92bB",
    loanToken: {
      address: "0x00000000eFE302BEAA2b3e6e1b18d08D69a9012a",
      symbol: "AUSD",
    },
    collateralToken: {
      address: "0x9D39A5DE30e57443BfF2A8307A4256c8797A3497",
      symbol: "sUSDe",
    },
  },
  {
    id: "0x404567e12200f3db52df4ac233366f92015f21de716eaa3ea8425b3da5fc481e",
    name: "USDT / cbBTC",
    irm: "0x870aC11D48B15DB9a138Cf899d20F13F79Ba00BC",
    lltv: "860000000000000000",
    oracle: "0xA6D6950c9F177F1De7f7757FB33539e3Ec60182a",
    loanToken: {
      address: "0xdAC17F958D2ee523a2206206994597C13D831ec7",
      symbol: "USDT",
    },
    collateralToken: {
      address: "0xcbB7C0000aB88B473b1f5aFd9ef808440eed33Bf",
      symbol: "cbBTC",
    },
  },
  {
    id: "0x7f494ab3b467f1a5fc5e2edb22a7c727e809cd37f68d33a06450e1fb486ff3da",
    name: "RLUSD / sUSDe",
    irm: "0x870aC11D48B15DB9a138Cf899d20F13F79Ba00BC",
    lltv: "915000000000000000",
    oracle: "0x16988dA49BaC55847a4f8E2634329BfFF9D53816",
    loanToken: {
      address: "0x8292Bb45bf1Ee4d140127049757C2E0fF06317eD",
      symbol: "RLUSD",
    },
    collateralToken: {
      address: "0x9D39A5DE30e57443BfF2A8307A4256c8797A3497",
      symbol: "sUSDe",
    },
  },
  {
    id: "0x25cc86b7d19547ada6cdef99039c5772d2a8c440308d736b5780900a84aef25c",
    name: "RLUSD / WBTC",
    irm: "0x870aC11D48B15DB9a138Cf899d20F13F79Ba00BC",
    lltv: "860000000000000000",
    oracle: "0xB7671538574f0daAA99462cecfA4b57D07bFC46a",
    loanToken: {
      address: "0x8292Bb45bf1Ee4d140127049757C2E0fF06317eD",
      symbol: "RLUSD",
    },
    collateralToken: {
      address: "0x2260FAC5E5542a773Aa44fBCfeDf7C193bc2C599",
      symbol: "WBTC",
    },
  },
  {
    id: "0x9a2e756dc954e22fd45fbc165b3e981743944b23178075f1f88470142bf7d7e4",
    name: "AUSD / WBTC",
    irm: "0x870aC11D48B15DB9a138Cf899d20F13F79Ba00BC",
    lltv: "860000000000000000",
    oracle: "0xf1561bC4b3D1bA49053986Fb9ee88D4fE22d0Cf4",
    loanToken: {
      address: "0x00000000eFE302BEAA2b3e6e1b18d08D69a9012a",
      symbol: "AUSD",
    },
    collateralToken: {
      address: "0x2260FAC5E5542a773Aa44fBCfeDf7C193bc2C599",
      symbol: "WBTC",
    },
  },
  {
    id: "0x7a7018e22a8bb2d08112eae9391e09f065a8ae7ae502c1c23dc96c21411a6efd",
    name: "USDC / EIGEN",
    irm: "0x870aC11D48B15DB9a138Cf899d20F13F79Ba00BC",
    lltv: "770000000000000000",
    oracle: "0x85AFf9753d4F6711413A3a80B23EE6F27a805fe6",
    loanToken: {
      address: "0xA0b86991c6218b36c1d19D4a2e9Eb0cE3606eB48",
      symbol: "USDC",
    },
    collateralToken: {
      address: "0xec53bF9167f50cDEB3Ae105f56099aaaB9061F83",
      symbol: "EIGEN",
    },
  },
  {
    id: "0x718af3af39b183758849486340b69466e3e89b84b7884188323416621ee91cb7",
    name: "USDC / UNI",
    irm: "0x870aC11D48B15DB9a138Cf899d20F13F79Ba00BC",
    lltv: "625000000000000000",
    oracle: "0x630A3B4a095220f4b36082DEc1DeaE903346e372",
    loanToken: {
      address: "0xA0b86991c6218b36c1d19D4a2e9Eb0cE3606eB48",
      symbol: "USDC",
    },
    collateralToken: {
      address: "0x1f9840a85d5aF5bf1D1762F925BDADdC4201F984",
      symbol: "UNI",
    },
  },
  {
    id: "0x7d1306d23f9f1e419697b8275001db9ea74b3c75190a7db8f5d81fed2fb94561",
    name: "VUSD / WETH",
    irm: "0x870aC11D48B15DB9a138Cf899d20F13F79Ba00BC",
    lltv: "860000000000000000",
    oracle: "0x4F90106502F3560a8e1Cc7A6801C706fa8DABA27",
    loanToken: {
      address: "0xCa83DDE9c22254f58e771bE5E157773212AcBAc3",
      symbol: "VUSD",
    },
    collateralToken: {
      address: "0xC02aaA39b223FE8D0A0e5C4F27eAD9083C756Cc2",
      symbol: "WETH",
    },
  },
  {
    id: "0x87520c1ed853f77141a260f0cb6ed35f7825928aea20357d64f041253bffcd04",
    name: "USDR / WBTC",
    irm: "0x870aC11D48B15DB9a138Cf899d20F13F79Ba00BC",
    lltv: "860000000000000000",
    oracle: "0xb5c9734dd253E16c8164277944D868f34c94F194",
    loanToken: {
      address: "0x7B43E3875440B44613DC3bC08E7763e6Da63C8f8",
      symbol: "USDR",
    },
    collateralToken: {
      address: "0x2260FAC5E5542a773Aa44fBCfeDf7C193bc2C599",
      symbol: "WBTC",
    },
  },
  {
    id: "0xa4942ce9152aaeb5cab0403d8b3ba08142b61460b4776e6fd4a83d234d309d0c",
    name: "tGBP / WETH",
    irm: "0x870aC11D48B15DB9a138Cf899d20F13F79Ba00BC",
    lltv: "860000000000000000",
    oracle: "0xCfb7146378E96B7291421d4A74E6B8Ac30e9F9F4",
    loanToken: {
      address: "0x27f6c8289550fCE67f6B50BeD1F519966aFE5287",
      symbol: "tGBP",
    },
    collateralToken: {
      address: "0xC02aaA39b223FE8D0A0e5C4F27eAD9083C756Cc2",
      symbol: "WETH",
    },
  },
  {
    id: "0x9e32ab8636950d7c00bc4666d8f3a0d005feeab26fbf7097528b75bb30a7a9b8",
    name: "ARSs / USDC",
    irm: "0x870aC11D48B15DB9a138Cf899d20F13F79Ba00BC",
    lltv: "385000000000000000",
    oracle: "0xab4EBFd6B79d11a7c187988EcEBE9fF8aB9aF32D",
    loanToken: {
      address: "0x9a1bFb2B9E3d1959Ed11636bc56DB0aB7b4473A9",
      symbol: "ARSs",
    },
    collateralToken: {
      address: "0xA0b86991c6218b36c1d19D4a2e9Eb0cE3606eB48",
      symbol: "USDC",
    },
  },
  {
    id: "0xa7b72c690ee59492ac826bd77b80c09ff0c5aab6346e6bda5ac828c9a4f6de0b",
    name: "RLUSD / weETH",
    irm: "0x870aC11D48B15DB9a138Cf899d20F13F79Ba00BC",
    lltv: "860000000000000000",
    oracle: "0xda9884dDbe3A13044Db7e1cDA75A2689ec59d009",
    loanToken: {
      address: "0x8292Bb45bf1Ee4d140127049757C2E0fF06317eD",
      symbol: "RLUSD",
    },
    collateralToken: {
      address: "0xCd5fE23C85820F7B72D0926FC9b05b43E359b7ee",
      symbol: "weETH",
    },
  },
  {
    id: "0x94e08261235c49638bba42ab2883394ea69bbf9f2a420bde48757775d0f1a182",
    name: "WETH / PT-tETH-29MAY2025",
    irm: "0x870aC11D48B15DB9a138Cf899d20F13F79Ba00BC",
    lltv: "915000000000000000",
    oracle: "0xE7De10Defe1f817bFF1dE246020B800471535eDc",
    loanToken: {
      address: "0xC02aaA39b223FE8D0A0e5C4F27eAD9083C756Cc2",
      symbol: "WETH",
    },
    collateralToken: {
      address: "0x84D17Ef6BeC165484c320B852eEB294203e191be",
      symbol: "PT-tETH-29MAY2025",
    },
  },
  {
    id: "0xd65e28bab75824acd03cbdc2c1a090d758b936e0aaba7bdaef8228bd1f1ada13",
    name: "USDQ / WBTC",
    irm: "0x870aC11D48B15DB9a138Cf899d20F13F79Ba00BC",
    lltv: "860000000000000000",
    oracle: "0xb5c9734dd253E16c8164277944D868f34c94F194",
    loanToken: {
      address: "0xc83e27f270cce0A3A3A29521173a83F402c1768b",
      symbol: "USDQ",
    },
    collateralToken: {
      address: "0x2260FAC5E5542a773Aa44fBCfeDf7C193bc2C599",
      symbol: "WBTC",
    },
  },
  {
    id: "0xbd0f74a1a29311741e6f10d2c947c429a22b1d13b5ae7c6871a71a5900e761b9",
    name: "tGBP / wstETH",
    irm: "0x870aC11D48B15DB9a138Cf899d20F13F79Ba00BC",
    lltv: "860000000000000000",
    oracle: "0xd210737572c6B62808b2A1722a4bB1aE3Ca0209E",
    loanToken: {
      address: "0x27f6c8289550fCE67f6B50BeD1F519966aFE5287",
      symbol: "tGBP",
    },
    collateralToken: {
      address: "0x7f39C581F595B53c5cb19bD0b3f8dA6c935E2Ca0",
      symbol: "wstETH",
    },
  },
  {
    id: "0xa7a12ca111ee142547e5346a473e6c7c79571276846c5cf40b63f131ccf9a72b",
    name: "tGBP / weETH",
    irm: "0x870aC11D48B15DB9a138Cf899d20F13F79Ba00BC",
    lltv: "860000000000000000",
    oracle: "0x23D7167438457DdEAc3bFc7C1ac383B7A7335425",
    loanToken: {
      address: "0x27f6c8289550fCE67f6B50BeD1F519966aFE5287",
      symbol: "tGBP",
    },
    collateralToken: {
      address: "0xCd5fE23C85820F7B72D0926FC9b05b43E359b7ee",
      symbol: "weETH",
    },
  },
  {
    id: "0xdf99a1e09b2a05d0f54a5fc4cc3de7ba9372eb0b7793cee58a18c385394bc05a",
    name: "wM / wstETH",
    irm: "0x870aC11D48B15DB9a138Cf899d20F13F79Ba00BC",
    lltv: "860000000000000000",
    oracle: "0xBC693693fDBB177Ad05ff38633110016BC043AC5",
    loanToken: {
      address: "0x437cc33344a0B27A429f795ff6B469C72698B291",
      symbol: "wM",
    },
    collateralToken: {
      address: "0x7f39C581F595B53c5cb19bD0b3f8dA6c935E2Ca0",
      symbol: "wstETH",
    },
  },
  {
    id: "0x77ab943f0cee8ddc5221a035b23229cf504e5a1459b7c11f73e17234245c1e9c",
    name: "AUSD / wstETH",
    irm: "0x870aC11D48B15DB9a138Cf899d20F13F79Ba00BC",
    lltv: "860000000000000000",
    oracle: "0xe087AD7FE989cF63F8383579D160a20Ee7e69F9F",
    loanToken: {
      address: "0x00000000eFE302BEAA2b3e6e1b18d08D69a9012a",
      symbol: "AUSD",
    },
    collateralToken: {
      address: "0x7f39C581F595B53c5cb19bD0b3f8dA6c935E2Ca0",
      symbol: "wstETH",
    },
  },
  {
    id: "0x77f2949b8d763ebc6fb103cd6b5f5226497cb564104b0c110194b53c1ba77c7f",
    name: "AUSD / WETH",
    irm: "0x870aC11D48B15DB9a138Cf899d20F13F79Ba00BC",
    lltv: "860000000000000000",
    oracle: "0x0F948CBa8231Db7898ef36A4212581Ad7b1B4580",
    loanToken: {
      address: "0x00000000eFE302BEAA2b3e6e1b18d08D69a9012a",
      symbol: "AUSD",
    },
    collateralToken: {
      address: "0xC02aaA39b223FE8D0A0e5C4F27eAD9083C756Cc2",
      symbol: "WETH",
    },
  },
  {
    id: "0x016c61eba37bd0bca915bebc742af53677ad5d1174ba1b88cb2cab5c03217c22",
    name: "RLUSD / wstETH",
    irm: "0x870aC11D48B15DB9a138Cf899d20F13F79Ba00BC",
    lltv: "860000000000000000",
    oracle: "0x957f6A2DC22094E77785057109069165c1Cf2c2f",
    loanToken: {
      address: "0x8292Bb45bf1Ee4d140127049757C2E0fF06317eD",
      symbol: "RLUSD",
    },
    collateralToken: {
      address: "0x7f39C581F595B53c5cb19bD0b3f8dA6c935E2Ca0",
      symbol: "wstETH",
    },
  },
  {
    id: "0x30d99308a5f2f4673b2cc5ad1718c731e6c790e20e26d23611f6e8d3422bda41",
    name: "RLUSD / WETH",
    irm: "0x870aC11D48B15DB9a138Cf899d20F13F79Ba00BC",
    lltv: "860000000000000000",
    oracle: "0x2DE7967f06a7Be992b62c35030EcC5eD14F842dB",
    loanToken: {
      address: "0x8292Bb45bf1Ee4d140127049757C2E0fF06317eD",
      symbol: "RLUSD",
    },
    collateralToken: {
      address: "0xC02aaA39b223FE8D0A0e5C4F27eAD9083C756Cc2",
      symbol: "WETH",
    },
  },
  {
    id: "0x7eca9fb16d58c469255032436cb11acf177a35ef8d9fe018717ffe8b0f06727a",
    name: "USDQ / wstETH",
    irm: "0x870aC11D48B15DB9a138Cf899d20F13F79Ba00BC",
    lltv: "860000000000000000",
    oracle: "0x27679a17b7419fB10Bd9D143f21407760fdA5C53",
    loanToken: {
      address: "0xc83e27f270cce0A3A3A29521173a83F402c1768b",
      symbol: "USDQ",
    },
    collateralToken: {
      address: "0x7f39C581F595B53c5cb19bD0b3f8dA6c935E2Ca0",
      symbol: "wstETH",
    },
  },
  {
    id: "0x4758ddbbcb96c8d0c10f46ca260d505e32399c2dd995380a832578ee84ef2d54",
    name: "WETH / PT-corn-eBTC-27MAR2025",
    irm: "0x870aC11D48B15DB9a138Cf899d20F13F79Ba00BC",
    lltv: "915000000000000000",
    oracle: "0x4be8e081Cdb407de2528E5a427d61975ea5d237F",
    loanToken: {
      address: "0xC02aaA39b223FE8D0A0e5C4F27eAD9083C756Cc2",
      symbol: "WETH",
    },
    collateralToken: {
      address: "0x44A7876cA99460ef3218bf08b5f52E2dbE199566",
      symbol: "PT-corn-eBTC-27MAR2025",
    },
  },
  {
    id: "0x58fa2543a8e941ea9513ed2074977a3711567a87872e865d6c409ea33b999095",
    name: "USDC / WETH",
    irm: "0x870aC11D48B15DB9a138Cf899d20F13F79Ba00BC",
    lltv: "770000000000000000",
    oracle: "0x5EA7998188E9b9ea1b146067ef29D32D7a7fE70C",
    loanToken: {
      address: "0xA0b86991c6218b36c1d19D4a2e9Eb0cE3606eB48",
      symbol: "USDC",
    },
    collateralToken: {
      address: "0xC02aaA39b223FE8D0A0e5C4F27eAD9083C756Cc2",
      symbol: "WETH",
    },
  },
  {
    id: "0x5891e1a10d90840de3267086b4e9f56b051e6f1c0b622f5c5021481509371637",
    name: "wM / wstETH",
    irm: "0x870aC11D48B15DB9a138Cf899d20F13F79Ba00BC",
    lltv: "860000000000000000",
    oracle: "0x038CE929913fF768D7cB1EF439FF23C6210a7A03",
    loanToken: {
      address: "0x437cc33344a0B27A429f795ff6B469C72698B291",
      symbol: "wM",
    },
    collateralToken: {
      address: "0x7f39C581F595B53c5cb19bD0b3f8dA6c935E2Ca0",
      symbol: "wstETH",
    },
  },
  {
    id: "0xcdd0937441cf68705dbef2d3fccb85914360861c8431145d650c36d3c9092616",
    name: "USDC / rETH",
    irm: "0x870aC11D48B15DB9a138Cf899d20F13F79Ba00BC",
    lltv: "860000000000000000",
    oracle: "0xCD0C5c58A67D2313120f036308a69F642e7b8AE4",
    loanToken: {
      address: "0xA0b86991c6218b36c1d19D4a2e9Eb0cE3606eB48",
      symbol: "USDC",
    },
    collateralToken: {
      address: "0xae78736Cd615f374D3085123A210448E74Fc6393",
      symbol: "rETH",
    },
  },
  {
    id: "0x0cb56971212f588d1ea229118f35126b50f9aec4fa1c19bf7860bdcc0e02210e",
    name: "EURC / cbBTC",
    irm: "0x870aC11D48B15DB9a138Cf899d20F13F79Ba00BC",
    lltv: "860000000000000000",
    oracle: "0x794B6C9cb12dA89aa8F505053AE0d33356C2fefB",
    loanToken: {
      address: "0x1aBaEA1f7C830bD89Acc67eC4af516284b1bC33c",
      symbol: "EURC",
    },
    collateralToken: {
      address: "0xcbB7C0000aB88B473b1f5aFd9ef808440eed33Bf",
      symbol: "cbBTC",
    },
  },
  {
    id: "0x0188775134d3541a13801c090658734743bcfe54662b045644f8e19d31958dfa",
    name: "wstETH / rsETH",
    irm: "0x870aC11D48B15DB9a138Cf899d20F13F79Ba00BC",
    lltv: "945000000000000000",
    oracle: "0x24C02eB0b4c2819f9B33264e367bb6536c9fe664",
    loanToken: {
      address: "0x7f39C581F595B53c5cb19bD0b3f8dA6c935E2Ca0",
      symbol: "wstETH",
    },
    collateralToken: {
      address: "0xA1290d69c65A6Fe4DF752f95823fae25cB99e5A7",
      symbol: "rsETH",
    },
  },
  {
    id: "0xd174bb7b8dd6ef16b116753b56679932ee13382b94f81bf66a2b37962cb41f56",
    name: "USDC / PT-sUSDE-5FEB2026",
    irm: "0x870aC11D48B15DB9a138Cf899d20F13F79Ba00BC",
    lltv: "915000000000000000",
    oracle: "0xFAfb71F2fe9a4330c34a192812F36D8d6f07f095",
    loanToken: {
      address: "0xA0b86991c6218b36c1d19D4a2e9Eb0cE3606eB48",
      symbol: "USDC",
    },
    collateralToken: {
      address: "0xE8483517077afa11A9B07f849cee2552f040d7b2",
      symbol: "PT-sUSDE-5FEB2026",
    },
  },
  {
    id: "0xac4c417d1b829805891a5577c04e518576df78690cc6abf3d4280deea33bb25a",
    name: "AUSD / weETH",
    irm: "0x870aC11D48B15DB9a138Cf899d20F13F79Ba00BC",
    lltv: "860000000000000000",
    oracle: "0x2b939B2d784537cb0ca97c9f31e95E2A5dC886D0",
    loanToken: {
      address: "0x00000000eFE302BEAA2b3e6e1b18d08D69a9012a",
      symbol: "AUSD",
    },
    collateralToken: {
      address: "0xCd5fE23C85820F7B72D0926FC9b05b43E359b7ee",
      symbol: "weETH",
    },
  },
  {
    id: "0x693ba455f49e69daba49904640dab1277538c5f4e524da79b2ec2070d12f694e",
    name: "AUSD / WETH",
    irm: "0x870aC11D48B15DB9a138Cf899d20F13F79Ba00BC",
    lltv: "860000000000000000",
    oracle: "0x727c2B72d9723a3cd053962d5bB2bffcA2F9a54d",
    loanToken: {
      address: "0x00000000eFE302BEAA2b3e6e1b18d08D69a9012a",
      symbol: "AUSD",
    },
    collateralToken: {
      address: "0xC02aaA39b223FE8D0A0e5C4F27eAD9083C756Cc2",
      symbol: "WETH",
    },
  },
  {
    id: "0x40c87599919c5af2427d6c75fa5dd3ca98feb041d9d06a7b24c8076d300f7dab",
    name: "USDC / PT-DUSD-29JAN2026",
    irm: "0x870aC11D48B15DB9a138Cf899d20F13F79Ba00BC",
    lltv: "915000000000000000",
    oracle: "0xf3745CF96d3bE787bcBEa21953ED721431eed09d",
    loanToken: {
      address: "0xA0b86991c6218b36c1d19D4a2e9Eb0cE3606eB48",
      symbol: "USDC",
    },
    collateralToken: {
      address: "0x97Ca796aEd60a4E34A7D7878f399b51e8718FBf7",
      symbol: "PT-DUSD-29JAN2026",
    },
  },
  {
    id: "0x9f1b791e05f1fde3aaf191bea1c77aef5c0f8f8eade8d232028b85b819bc8eae",
    name: "USDC / EURCV",
    irm: "0x870aC11D48B15DB9a138Cf899d20F13F79Ba00BC",
    lltv: "860000000000000000",
    oracle: "0x012b000F718d00944c9Ec64f9DBE2b3F22Af1DaC",
    loanToken: {
      address: "0xA0b86991c6218b36c1d19D4a2e9Eb0cE3606eB48",
      symbol: "USDC",
    },
    collateralToken: {
      address: "0x5F7827FDeb7c20b443265Fc2F40845B715385Ff2",
      symbol: "EURCV",
    },
  },
  {
    id: "0x7e32fa74340bd1ae6623618b76ef6c4d9023dae1fa16fe9783f6285e7215c110",
    name: "PYUSD / USDe",
    irm: "0x870aC11D48B15DB9a138Cf899d20F13F79Ba00BC",
    lltv: "945000000000000000",
    oracle: "0x1E34520bD7aD812A3abf014d6C02888193B24c4e",
    loanToken: {
      address: "0x6c3ea9036406852006290770BEdFcAbA0e23A0e8",
      symbol: "PYUSD",
    },
    collateralToken: {
      address: "0x4c9EDD5852cd905f086C759E8383e09bff1E68B3",
      symbol: "USDe",
    },
  },
  {
    id: "0x35b9438b7d90d478694dfbdba841571850902c1cc619c53c53eeee6e0a5804b0",
    name: "rUSD / wstETH",
    irm: "0x870aC11D48B15DB9a138Cf899d20F13F79Ba00BC",
    lltv: "860000000000000000",
    oracle: "0xBC693693fDBB177Ad05ff38633110016BC043AC5",
    loanToken: {
      address: "0x09D4214C03D01F49544C0448DBE3A27f768F2b34",
      symbol: "rUSD",
    },
    collateralToken: {
      address: "0x7f39C581F595B53c5cb19bD0b3f8dA6c935E2Ca0",
      symbol: "wstETH",
    },
  },
  {
    id: "0xddffaa9ca0528280492f20dc97d3e2f400b32cc38d85964672d7b313f569a5a3",
    name: "USDe / PT-USDe-31JUL2025",
    irm: "0x870aC11D48B15DB9a138Cf899d20F13F79Ba00BC",
    lltv: "915000000000000000",
    oracle: "0x7cE5c29d249c0E318c85503b1565B81ED7483019",
    loanToken: {
      address: "0x4c9EDD5852cd905f086C759E8383e09bff1E68B3",
      symbol: "USDe",
    },
    collateralToken: {
      address: "0x917459337CaAC939D41d7493B3999f571D20D667",
      symbol: "PT-USDe-31JUL2025",
    },
  },
  {
    id: "0xc3b37a18d5b15f8e5b78bcdc014ffb3f22933bde4e5f6a36dedf36db87e68585",
    name: "RLUSD / WETH",
    irm: "0x870aC11D48B15DB9a138Cf899d20F13F79Ba00BC",
    lltv: "860000000000000000",
    oracle: "0x18803b5c20962244F0A99fC3b7d7e614762385eB",
    loanToken: {
      address: "0x8292Bb45bf1Ee4d140127049757C2E0fF06317eD",
      symbol: "RLUSD",
    },
    collateralToken: {
      address: "0xC02aaA39b223FE8D0A0e5C4F27eAD9083C756Cc2",
      symbol: "WETH",
    },
  },
  {
    id: "0xa9b14ece2cac9895eafbd3c7bce566bd502b4376cccb928479a04bc474519025",
    name: "USDT / stUSD",
    irm: "0x870aC11D48B15DB9a138Cf899d20F13F79Ba00BC",
    lltv: "965000000000000000",
    oracle: "0xd884fa9fe289EB06Cc22667252fA6Bea87A91CC3",
    loanToken: {
      address: "0xdAC17F958D2ee523a2206206994597C13D831ec7",
      symbol: "USDT",
    },
    collateralToken: {
      address: "0x0022228a2cc5E7eF0274A7Baa600d44da5aB5776",
      symbol: "stUSD",
    },
  },
  {
    id: "0x337c38319219b36c0b4d5b10c259f3ef301f5ac0159c8ab1bcc6b23f762238cf",
    name: "CANA / WBTC",
    irm: "0x870aC11D48B15DB9a138Cf899d20F13F79Ba00BC",
    lltv: "770000000000000000",
    oracle: "0xCddf5875A966f7b2946875007DF7406C38755ec3",
    loanToken: {
      address: "0x01995A697752266d8E748738aAa3F06464B8350B",
      symbol: "CANA",
    },
    collateralToken: {
      address: "0x2260FAC5E5542a773Aa44fBCfeDf7C193bc2C599",
      symbol: "WBTC",
    },
  },
  {
    id: "0x6c9f0450065ae8f41fa1377b33798881393bf77c1b6d8ba9de52b1a6abc9daf3",
    name: "CANA / WETH",
    irm: "0x870aC11D48B15DB9a138Cf899d20F13F79Ba00BC",
    lltv: "770000000000000000",
    oracle: "0x361d90375C97BD216794D42648B7027242027a09",
    loanToken: {
      address: "0x01995A697752266d8E748738aAa3F06464B8350B",
      symbol: "CANA",
    },
    collateralToken: {
      address: "0xC02aaA39b223FE8D0A0e5C4F27eAD9083C756Cc2",
      symbol: "WETH",
    },
  },
  {
    id: "0xcb12dcbc7c6c4f20ca1537a3cc1a41ec27501f85a3e322a710d9a16a88a28c0e",
    name: "PYUSD / PT-sUSDE-7MAY2026",
    irm: "0x870aC11D48B15DB9a138Cf899d20F13F79Ba00BC",
    lltv: "915000000000000000",
    oracle: "0x3B1BFDB445Eb31bCFB7932A33309cBf1089681dA",
    loanToken: {
      address: "0x6c3ea9036406852006290770BEdFcAbA0e23A0e8",
      symbol: "PYUSD",
    },
    collateralToken: {
      address: "0x3de0ff76E8b528C092d47b9DaC775931cef80F49",
      symbol: "PT-sUSDE-7MAY2026",
    },
  },
  {
    id: "0x48a0da254e4df7b1046baa5ef11beb7916203886ce153a07a6d28c5d63cf8fad",
    name: "RLUSD / sUSDe",
    irm: "0x870aC11D48B15DB9a138Cf899d20F13F79Ba00BC",
    lltv: "915000000000000000",
    oracle: "0xd22384C58E5B9332F218e419dE1b9C796ac61ABB",
    loanToken: {
      address: "0x8292Bb45bf1Ee4d140127049757C2E0fF06317eD",
      symbol: "RLUSD",
    },
    collateralToken: {
      address: "0x9D39A5DE30e57443BfF2A8307A4256c8797A3497",
      symbol: "sUSDe",
    },
  },
  {
    id: "0xdde45ad7e78bba0142b84c657963d42861d5bd6e667376fcc1239df14e7b1119",
    name: "USDC / unknown",
    irm: "0x870aC11D48B15DB9a138Cf899d20F13F79Ba00BC",
    lltv: "945000000000000000",
    oracle: "0xCc00d98162fEf57d6A1057a36C25D5326e3805c8",
    loanToken: {
      address: "0xA0b86991c6218b36c1d19D4a2e9Eb0cE3606eB48",
      symbol: "USDC",
    },
    collateralToken: {
      address: "0x76589A6707a765f499BBF33C7be4db41C1Db7f58",
      symbol: "unknown",
    },
  },
  {
    id: "0xca432a8b0f33541cfe164d388823d05b607db43b690d4856f343eec3b42402c0",
    name: "USDC / PT-mHYPER-30APR2026",
    irm: "0x870aC11D48B15DB9a138Cf899d20F13F79Ba00BC",
    lltv: "770000000000000000",
    oracle: "0x2ece0C95B840A80ECD67e2BAb0d7193Cb34F3CF7",
    loanToken: {
      address: "0xA0b86991c6218b36c1d19D4a2e9Eb0cE3606eB48",
      symbol: "USDC",
    },
    collateralToken: {
      address: "0xD87169640666649F1E6F92034dcA9e4Ae748dE69",
      symbol: "PT-mHYPER-30APR2026",
    },
  },
  {
    id: "0x45d97c66db5e803b9446802702f087d4293a2f74b370105dc3a88a278bf6bb21",
    name: "DAI / PT-USDe-25SEP2025",
    irm: "0x870aC11D48B15DB9a138Cf899d20F13F79Ba00BC",
    lltv: "915000000000000000",
    oracle: "0x076a476329CAf84Ef7FED997063a0055900eE00f",
    loanToken: {
      address: "0x6B175474E89094C44Da98b954EedeAC495271d0F",
      symbol: "DAI",
    },
    collateralToken: {
      address: "0xBC6736d346a5eBC0dEbc997397912CD9b8FAe10a",
      symbol: "PT-USDe-25SEP2025",
    },
  },
  {
    id: "0xa84573d73bcd78cd295b3a35b4419877584a4cc3208161128addf15d9a90e5fb",
    name: "AUSD / WBTC",
    irm: "0x870aC11D48B15DB9a138Cf899d20F13F79Ba00BC",
    lltv: "860000000000000000",
    oracle: "0x09dbf9502d43445b33883837a51D06Fc9B9CdEC4",
    loanToken: {
      address: "0x00000000eFE302BEAA2b3e6e1b18d08D69a9012a",
      symbol: "AUSD",
    },
    collateralToken: {
      address: "0x2260FAC5E5542a773Aa44fBCfeDf7C193bc2C599",
      symbol: "WBTC",
    },
  },
  {
    id: "0xa02ad0cf521ba5e5b20d1bcb98043eb091807e2b3bf26df5aad1ad154a3b8d45",
    name: "USDC / PT-RLP-4DEC2025",
    irm: "0x870aC11D48B15DB9a138Cf899d20F13F79Ba00BC",
    lltv: "860000000000000000",
    oracle: "0x78b00016EbCA1325A27CE201e26C07aCdCD52E5E",
    loanToken: {
      address: "0xA0b86991c6218b36c1d19D4a2e9Eb0cE3606eB48",
      symbol: "USDC",
    },
    collateralToken: {
      address: "0x3A70F0C696dcB3A4aB3833cD9726397dD61AC85e",
      symbol: "PT-RLP-4DEC2025",
    },
  },
  {
    id: "0x98809e0a4fb92b7d7def2a2a49bbe7bdacdf70cbcf53a04b765cf1afbf45b013",
    name: "USDC / ynUSDx",
    irm: "0x870aC11D48B15DB9a138Cf899d20F13F79Ba00BC",
    lltv: "915000000000000000",
    oracle: "0xE8f758fD4fcC24199959475C0E55D6FbdB8526eE",
    loanToken: {
      address: "0xA0b86991c6218b36c1d19D4a2e9Eb0cE3606eB48",
      symbol: "USDC",
    },
    collateralToken: {
      address: "0x3DB228FE836D99Ccb25Ec4dfdC80ED6d2CDdCB4b",
      symbol: "ynUSDx",
    },
  },
  {
    id: "0x5ec557cc91d5e27844ff87b2378e87498debb3f9ae6016e03a91da33673775f4",
    name: "USDC / xPRISM",
    irm: "0x870aC11D48B15DB9a138Cf899d20F13F79Ba00BC",
    lltv: "860000000000000000",
    oracle: "0x3ca09869054C1d5C4e38de06b505045cA3cED279",
    loanToken: {
      address: "0xA0b86991c6218b36c1d19D4a2e9Eb0cE3606eB48",
      symbol: "USDC",
    },
    collateralToken: {
      address: "0x12E04c932D682a2999b4582F7c9B86171B73220D",
      symbol: "xPRISM",
    },
  },
  {
    id: "0x8c8b097bec263ba5244013904e70b34c8461c2ca722651380c39e3ff2bae8f4c",
    name: "USDC / apxUSD",
    irm: "0x870aC11D48B15DB9a138Cf899d20F13F79Ba00BC",
    lltv: "860000000000000000",
    oracle: "0x5AE614f49b7a805aA22a6692a991eDD99eA85CFB",
    loanToken: {
      address: "0xA0b86991c6218b36c1d19D4a2e9Eb0cE3606eB48",
      symbol: "USDC",
    },
    collateralToken: {
      address: "0x98A878b1Cd98131B271883B390f68D2c90674665",
      symbol: "apxUSD",
    },
  },
  {
    id: "0x3c81a7e3cbcdeeecc7d9f7c45ed28ef62d63357cfcc7295e9d2b3368f0386b46",
    name: "FRAX / USDe",
    irm: "0x870aC11D48B15DB9a138Cf899d20F13F79Ba00BC",
    lltv: "915000000000000000",
    oracle: "0xaE4750d0813B5E37A51f7629beedd72AF1f9cA35",
    loanToken: {
      address: "0x853d955aCEf822Db058eb8505911ED77F175b99e",
      symbol: "FRAX",
    },
    collateralToken: {
      address: "0x4c9EDD5852cd905f086C759E8383e09bff1E68B3",
      symbol: "USDe",
    },
  },
  {
    id: "0x9a3d1baed83bc5c05739810350a7224617f41cd809a85f0db7aad0772ec968a5",
    name: "USDC / stUSDS",
    irm: "0x870aC11D48B15DB9a138Cf899d20F13F79Ba00BC",
    lltv: "860000000000000000",
    oracle: "0x9D278a48bDC6591D99C1bc1Cdb27775097105FB5",
    loanToken: {
      address: "0xA0b86991c6218b36c1d19D4a2e9Eb0cE3606eB48",
      symbol: "USDC",
    },
    collateralToken: {
      address: "0x99CD4Ec3f88A45940936F469E4bB72A2A701EEB9",
      symbol: "stUSDS",
    },
  },
  {
    id: "0xa67befc86e760d94b973ac3fe3489fcb55b5f897d8aefc1d292a9a4f44f48370",
    name: "WBTC / PT-LBTC-26JUN2025",
    irm: "0x870aC11D48B15DB9a138Cf899d20F13F79Ba00BC",
    lltv: "915000000000000000",
    oracle: "0x74e21F62b34284e914A48A0be0a1c377029a0FBe",
    loanToken: {
      address: "0x2260FAC5E5542a773Aa44fBCfeDf7C193bc2C599",
      symbol: "WBTC",
    },
    collateralToken: {
      address: "0x6cA4d5d2eCb72E3Bbf17543B3367746B80D22694",
      symbol: "PT-LBTC-26JUN2025",
    },
  },
  {
    id: "0xfae6c3fca4d2fe61c62d29541e84a728b660a0dbc99217750c1080a8fc7d0e45",
    name: "USDC / PT-eUSDE-14AUG2025",
    irm: "0x870aC11D48B15DB9a138Cf899d20F13F79Ba00BC",
    lltv: "915000000000000000",
    oracle: "0x89703C1bedC64B0B740c5af8bF634745b7B5d863",
    loanToken: {
      address: "0xA0b86991c6218b36c1d19D4a2e9Eb0cE3606eB48",
      symbol: "USDC",
    },
    collateralToken: {
      address: "0x14Bdc3A3AE09f5518b923b69489CBcAfB238e617",
      symbol: "PT-eUSDE-14AUG2025",
    },
  },
  {
    id: "0xb6f4eebd60871f99bf464ae0b67045a26797cf7ef57c458d57e08c205f84feac",
    name: "USDC / eBTC",
    irm: "0x870aC11D48B15DB9a138Cf899d20F13F79Ba00BC",
    lltv: "860000000000000000",
    oracle: "0x1bE22EEfa7d0fD5BE8171E947bfDE7C009493D1f",
    loanToken: {
      address: "0xA0b86991c6218b36c1d19D4a2e9Eb0cE3606eB48",
      symbol: "USDC",
    },
    collateralToken: {
      address: "0x657e8C867D8B37dCC18fA4Caead9C45EB088C642",
      symbol: "eBTC",
    },
  },
  {
    id: "0xf42b0dd39d1f852412283354dcb10eb7a39238832608f030d5163411e4197d43",
    name: "USDT / PT-csUSDL-31JUL2025",
    irm: "0x870aC11D48B15DB9a138Cf899d20F13F79Ba00BC",
    lltv: "915000000000000000",
    oracle: "0xB54673451c1e5Fd5CD97763954A6Fb843A5f8e47",
    loanToken: {
      address: "0xdAC17F958D2ee523a2206206994597C13D831ec7",
      symbol: "USDT",
    },
    collateralToken: {
      address: "0xf10A134A987E22ffa9463570A6D1eb92a63Fc178",
      symbol: "PT-csUSDL-31JUL2025",
    },
  },
  {
    id: "0xa3e20a0e33357222868bc091ce27bf08096c0f30c300b85f027e4ac7b7b56766",
    name: "WBTC / PT-corn-SolvBTC.BBN-26DEC2024",
    irm: "0x870aC11D48B15DB9a138Cf899d20F13F79Ba00BC",
    lltv: "860000000000000000",
    oracle: "0x3A7bB36Ee3f3eE32A60e9f2b33c1e5f2E83ad766",
    loanToken: {
      address: "0x2260FAC5E5542a773Aa44fBCfeDf7C193bc2C599",
      symbol: "WBTC",
    },
    collateralToken: {
      address: "0x23e479ddcda990E8523494895759bD98cD2fDBF6",
      symbol: "PT-corn-SolvBTC.BBN-26DEC2024",
    },
  },
  {
    id: "0x5739f22793593f94fead5875cc7423bbbd47355714af64a5f55368bec0f0b9fe",
    name: "WBTC / PT-corn-SolvBTC.BBN-26DEC2024",
    irm: "0x870aC11D48B15DB9a138Cf899d20F13F79Ba00BC",
    lltv: "860000000000000000",
    oracle: "0xFEe9B887e04eB7F54EB3977df4EeCAD0B0CBda5A",
    loanToken: {
      address: "0x2260FAC5E5542a773Aa44fBCfeDf7C193bc2C599",
      symbol: "WBTC",
    },
    collateralToken: {
      address: "0x23e479ddcda990E8523494895759bD98cD2fDBF6",
      symbol: "PT-corn-SolvBTC.BBN-26DEC2024",
    },
  },
  {
    id: "0x8a0384fe5b1a68ff217845752287f432029b20754fbce577b6a5f8a80030a825",
    name: "WBTC / PT-LBTC-26JUN2025",
    irm: "0x870aC11D48B15DB9a138Cf899d20F13F79Ba00BC",
    lltv: "915000000000000000",
    oracle: "0xE99c483129063C257a0B29257c66ac25ED65316b",
    loanToken: {
      address: "0x2260FAC5E5542a773Aa44fBCfeDf7C193bc2C599",
      symbol: "WBTC",
    },
    collateralToken: {
      address: "0x6cA4d5d2eCb72E3Bbf17543B3367746B80D22694",
      symbol: "PT-LBTC-26JUN2025",
    },
  },
  {
    id: "0x0f84816cd17292edba65f7c2e88a7aace40dad7cc79399b49b66f7cc81ecdfd2",
    name: "USDT / PT-sUSDE-27NOV2025",
    irm: "0x870aC11D48B15DB9a138Cf899d20F13F79Ba00BC",
    lltv: "915000000000000000",
    oracle: "0x639c6f403822E1bDA434BEb2034Beb54f725BA0c",
    loanToken: {
      address: "0xdAC17F958D2ee523a2206206994597C13D831ec7",
      symbol: "USDT",
    },
    collateralToken: {
      address: "0xe6A934089BBEe34F832060CE98848359883749B3",
      symbol: "PT-sUSDE-27NOV2025",
    },
  },
  {
    id: "0xac186e6bc9008c06fa2f015f2d41a90d9b74c232de4f826a45511242228b5c1b",
    name: "USDCV / USDC",
    irm: "0x870aC11D48B15DB9a138Cf899d20F13F79Ba00BC",
    lltv: "945000000000000000",
    oracle: "0xDC809f2a5098aF6A8b20d30EFCd065528f541e4f",
    loanToken: {
      address: "0x5422374B27757da72d5265cC745ea906E0446634",
      symbol: "USDCV",
    },
    collateralToken: {
      address: "0xA0b86991c6218b36c1d19D4a2e9Eb0cE3606eB48",
      symbol: "USDC",
    },
  },
  {
    id: "0x21e55c99123958ff5667f824948c97d0f64dfaa6e2848062e72bc68d200d35f9",
    name: "USDC / PT-eUSDE-29MAY2025",
    irm: "0x870aC11D48B15DB9a138Cf899d20F13F79Ba00BC",
    lltv: "915000000000000000",
    oracle: "0x9c0363336Bf9DaF57a16BB4e2867459bf4Dd5EB0",
    loanToken: {
      address: "0xA0b86991c6218b36c1d19D4a2e9Eb0cE3606eB48",
      symbol: "USDC",
    },
    collateralToken: {
      address: "0x50D2C7992b802Eef16c04FeADAB310f31866a545",
      symbol: "PT-eUSDE-29MAY2025",
    },
  },
  {
    id: "0xdeca5331fa55b630026fedf5b2bfa0d384b35dbebd9921832e67ad305f48d8d8",
    name: "USDT / PT-RUSD-26FEB2026",
    irm: "0x870aC11D48B15DB9a138Cf899d20F13F79Ba00BC",
    lltv: "915000000000000000",
    oracle: "0x55FcD62CCaC955A4754712a641524A271322Cd36",
    loanToken: {
      address: "0xdAC17F958D2ee523a2206206994597C13D831ec7",
      symbol: "USDT",
    },
    collateralToken: {
      address: "0xeEAa924eB3667F30Be02Db9C55d87566a3F4dF7A",
      symbol: "PT-RUSD-26FEB2026",
    },
  },
  {
    id: "0xcf30228b60d9ec544889f5a77a2fada8e8d19ab921e0d7d35c7d011b54ade4d0",
    name: "USDT / PT-wsrUSD-26FEB2026",
    irm: "0x870aC11D48B15DB9a138Cf899d20F13F79Ba00BC",
    lltv: "915000000000000000",
    oracle: "0xc98751D712732B80E688228A8eEFC905F116D1b1",
    loanToken: {
      address: "0xdAC17F958D2ee523a2206206994597C13D831ec7",
      symbol: "USDT",
    },
    collateralToken: {
      address: "0x5AA4AfE7359d5a68D193f03E013d553DEb7DbD1f",
      symbol: "PT-wsrUSD-26FEB2026",
    },
  },
  {
    id: "0x704e020b95cbf452e7a30545d5f72a241c4238eebf9d1c67657fdd4a488581e0",
    name: "USDC / WBTC",
    irm: "0x870aC11D48B15DB9a138Cf899d20F13F79Ba00BC",
    lltv: "860000000000000000",
    oracle: "0x56C136FC58686C8409f46458056C3F960d3Ef21D",
    loanToken: {
      address: "0xA0b86991c6218b36c1d19D4a2e9Eb0cE3606eB48",
      symbol: "USDC",
    },
    collateralToken: {
      address: "0x2260FAC5E5542a773Aa44fBCfeDf7C193bc2C599",
      symbol: "WBTC",
    },
  },
  {
    id: "0x19ab5f7fa9a014d6e5c07384ac34f56e517f449c75f3c9cdc1e0ccd06313419b",
    name: "USDC / PT-USD0++-26JUN2025",
    irm: "0x870aC11D48B15DB9a138Cf899d20F13F79Ba00BC",
    lltv: "915000000000000000",
    oracle: "0xcc72714413FC14A72D7946f6187209db7A676b73",
    loanToken: {
      address: "0xA0b86991c6218b36c1d19D4a2e9Eb0cE3606eB48",
      symbol: "USDC",
    },
    collateralToken: {
      address: "0xf696FE29Ef85E892b5926313897D178288faA07e",
      symbol: "PT-USD0++-26JUN2025",
    },
  },
  {
    id: "0xfd2e0d55ed4fcc26fec66f2bb890a8eeb985e456ac236b29127c75db3e1e23c8",
    name: "USDT / PENDLE-LPT-WRAPPED",
    irm: "0x870aC11D48B15DB9a138Cf899d20F13F79Ba00BC",
    lltv: "915000000000000000",
    oracle: "0xD72918C89697a6d40a6288662D1e752D1734464f",
    loanToken: {
      address: "0xdAC17F958D2ee523a2206206994597C13D831ec7",
      symbol: "USDT",
    },
    collateralToken: {
      address: "0x7bAFb26A485bf7bB4B0D0b02996c79C5Af6493bc",
      symbol: "PENDLE-LPT-WRAPPED",
    },
  },
  {
    id: "0x198132864e7974fb451dfebeb098b3b7e7e65566667fb1cf1116db4fb2ad23f9",
    name: "WBTC / PT-LBTC-27MAR2025",
    irm: "0x870aC11D48B15DB9a138Cf899d20F13F79Ba00BC",
    lltv: "860000000000000000",
    oracle: "0xbeB935DC2ce0Bf829F37D7fb147144E7AF0a0D91",
    loanToken: {
      address: "0x2260FAC5E5542a773Aa44fBCfeDf7C193bc2C599",
      symbol: "WBTC",
    },
    collateralToken: {
      address: "0xEc5a52C685CC3Ad79a6a347aBACe330d69e0b1eD",
      symbol: "PT-LBTC-27MAR2025",
    },
  },
  {
    id: "0x1e6ff1bfeb04dd5680c58d24b48cfce57474bd97bcbfaa0d2cd8015bc40c4b52",
    name: "USDT / PT-USDG-28MAY2026",
    irm: "0x870aC11D48B15DB9a138Cf899d20F13F79Ba00BC",
    lltv: "945000000000000000",
    oracle: "0xEA268c588072e2639448E3a9433AB92E871335E2",
    loanToken: {
      address: "0xdAC17F958D2ee523a2206206994597C13D831ec7",
      symbol: "USDT",
    },
    collateralToken: {
      address: "0x9db38D74a0D29380899aD354121DfB521aDb0548",
      symbol: "PT-USDG-28MAY2026",
    },
  },
  {
    id: "0xac5e7868966e4ba9173c691a8f7e94a9f5966815121a0493042fb341db8d2d3f",
    name: "USDT / wstUSR",
    irm: "0x870aC11D48B15DB9a138Cf899d20F13F79Ba00BC",
    lltv: "915000000000000000",
    oracle: "0xDdFF4aCd31d0e1D3943dD2C3F07cC3a2Aa899e74",
    loanToken: {
      address: "0xdAC17F958D2ee523a2206206994597C13D831ec7",
      symbol: "USDT",
    },
    collateralToken: {
      address: "0x1202F5C7b4B9E47a1A484E8B270be34dbbC75055",
      symbol: "wstUSR",
    },
  },
  {
    id: "0x4920df078b7fe1c75fd0377387a3fc580c54367e481d9e1659c7443b72561040",
    name: "WBTC / yb-WBTC",
    irm: "0x870aC11D48B15DB9a138Cf899d20F13F79Ba00BC",
    lltv: "860000000000000000",
    oracle: "0xe559aa08f0Ac86dF7de8df46A00334Ff417803e7",
    loanToken: {
      address: "0x2260FAC5E5542a773Aa44fBCfeDf7C193bc2C599",
      symbol: "WBTC",
    },
    collateralToken: {
      address: "0xfBF3C16676055776Ab9B286492D8f13e30e2E763",
      symbol: "yb-WBTC",
    },
  },
  {
    id: "0xc8e32d7c6b217b0a620cd881549e9d66d9a4703c9473d1eee00d6033b4f839c5",
    name: "USDC / PT-cUSD-23JUL2026",
    irm: "0x870aC11D48B15DB9a138Cf899d20F13F79Ba00BC",
    lltv: "915000000000000000",
    oracle: "0x58BA947aCaF37B5155B452677Aedb581a24bBF40",
    loanToken: {
      address: "0xA0b86991c6218b36c1d19D4a2e9Eb0cE3606eB48",
      symbol: "USDC",
    },
    collateralToken: {
      address: "0x928FB6ED39100a92B2480f5cbB93453f98D9F4cE",
      symbol: "PT-cUSD-23JUL2026",
    },
  },
  {
    id: "0xb2f87218f0e2478ba7a2b8be9fe76cbd6f54f8654b9651d4bd1f0ea536674691",
    name: "USDT / PT-srUSDe-2APR2026",
    irm: "0x870aC11D48B15DB9a138Cf899d20F13F79Ba00BC",
    lltv: "915000000000000000",
    oracle: "0xaA22FA49aAAFf58e815E762Db287304a93F85a01",
    loanToken: {
      address: "0xdAC17F958D2ee523a2206206994597C13D831ec7",
      symbol: "USDT",
    },
    collateralToken: {
      address: "0x9Bf45ab47747F4B4dD09B3C2c73953484b4eB375",
      symbol: "PT-srUSDe-2APR2026",
    },
  },
  {
    id: "0xb8afc953c3cc8077b4a4bf459bede8d3f80be45ca1f244e4bca13b7b1030eed5",
    name: "USDC / PT-syrupUSDC-30OCT2025",
    irm: "0x870aC11D48B15DB9a138Cf899d20F13F79Ba00BC",
    lltv: "915000000000000000",
    oracle: "0x6Ba91462b71acbc312f6e1E9322275aD532786B8",
    loanToken: {
      address: "0xA0b86991c6218b36c1d19D4a2e9Eb0cE3606eB48",
      symbol: "USDC",
    },
    collateralToken: {
      address: "0x00026E3311937BAd48D9Ab894c42134306E1698D",
      symbol: "PT-syrupUSDC-30OCT2025",
    },
  },
  {
    id: "0xbed21964cf290ab95fa458da6c1f302f2278aec5f897c1b1da3054553ef5e90c",
    name: "WETH / sUSDS",
    irm: "0x870aC11D48B15DB9a138Cf899d20F13F79Ba00BC",
    lltv: "860000000000000000",
    oracle: "0x9F48b0791C701be7a51B66A4e550A5f0B52A8f5e",
    loanToken: {
      address: "0xC02aaA39b223FE8D0A0e5C4F27eAD9083C756Cc2",
      symbol: "WETH",
    },
    collateralToken: {
      address: "0xa3931d71877C0E7a3148CB7Eb4463524FEc27fbD",
      symbol: "sUSDS",
    },
  },
  {
    id: "0x92fa6ed4186351fba59f698ec4b6aeb674cdd2df73e2cb109eabece606b6398b",
    name: "USDT / PT-sUSDE-25SEP2025",
    irm: "0x870aC11D48B15DB9a138Cf899d20F13F79Ba00BC",
    lltv: "915000000000000000",
    oracle: "0x5139aa359F7F7FdE869305e8C7AD001B28E1C99a",
    loanToken: {
      address: "0xdAC17F958D2ee523a2206206994597C13D831ec7",
      symbol: "USDT",
    },
    collateralToken: {
      address: "0x9F56094C450763769BA0EA9Fe2876070c0fD5F77",
      symbol: "PT-sUSDE-25SEP2025",
    },
  },
  {
    id: "0x89c30faadb4d3e748583fe5862b257a9d408f9b64d8e79d4d94b3bd8f2592c1c",
    name: "USDT / PT-USDe-27NOV2025",
    irm: "0x870aC11D48B15DB9a138Cf899d20F13F79Ba00BC",
    lltv: "915000000000000000",
    oracle: "0x0beC5A0f7Bea1D14efC2663054D6D1E2B764b630",
    loanToken: {
      address: "0xdAC17F958D2ee523a2206206994597C13D831ec7",
      symbol: "USDT",
    },
    collateralToken: {
      address: "0x62C6E813b9589C3631Ba0Cdb013acdB8544038B7",
      symbol: "PT-USDe-27NOV2025",
    },
  },
  {
    id: "0xa315e92e30a1f0e76df5e18d05a1b5c021fe809f989a9d7c0a5585a0f94e34ed",
    name: "USDT / PT-syrupUSDC-30OCT2025",
    irm: "0x870aC11D48B15DB9a138Cf899d20F13F79Ba00BC",
    lltv: "915000000000000000",
    oracle: "0x6Ba91462b71acbc312f6e1E9322275aD532786B8",
    loanToken: {
      address: "0xdAC17F958D2ee523a2206206994597C13D831ec7",
      symbol: "USDT",
    },
    collateralToken: {
      address: "0x00026E3311937BAd48D9Ab894c42134306E1698D",
      symbol: "PT-syrupUSDC-30OCT2025",
    },
  },
  {
    id: "0x705b715d01315f83a979e5f4554a03e05bf9f7fec7c4b5072522e7188316de34",
    name: "USDT / wsrUSD",
    irm: "0x870aC11D48B15DB9a138Cf899d20F13F79Ba00BC",
    lltv: "915000000000000000",
    oracle: "0x938D2eDb20425cF80F008E7ec314Eb456940Da15",
    loanToken: {
      address: "0xdAC17F958D2ee523a2206206994597C13D831ec7",
      symbol: "USDT",
    },
    collateralToken: {
      address: "0xd3fD63209FA2D55B07A0f6db36C2f43900be3094",
      symbol: "wsrUSD",
    },
  },
  {
    id: "0xc987f1904559633e0df7eb180acdf9dfbcc75c49e776e7b6be1537e66d5f8c3b",
    name: "USDC / TSLAon",
    irm: "0x870aC11D48B15DB9a138Cf899d20F13F79Ba00BC",
    lltv: "625000000000000000",
    oracle: "0x4f3eFF3e62C1E2650B18b350368a78E328704059",
    loanToken: {
      address: "0xA0b86991c6218b36c1d19D4a2e9Eb0cE3606eB48",
      symbol: "USDC",
    },
    collateralToken: {
      address: "0xf6b1117ec07684D3958caD8BEb1b302bfD21103f",
      symbol: "TSLAon",
    },
  },
  {
    id: "0x96a4399f2c837f8aa34c39718e30625a84f9285991f0a08d1f2997e15bbeeaa8",
    name: "USDT / PT-syrupUSDC-28AUG2025",
    irm: "0x870aC11D48B15DB9a138Cf899d20F13F79Ba00BC",
    lltv: "915000000000000000",
    oracle: "0x96A20d205737bd9E2Acf5C122aa434428fff685d",
    loanToken: {
      address: "0xdAC17F958D2ee523a2206206994597C13D831ec7",
      symbol: "USDT",
    },
    collateralToken: {
      address: "0xCcE7D12f683c6dAe700154f0BAdf779C0bA1F89A",
      symbol: "PT-syrupUSDC-28AUG2025",
    },
  },
  {
    id: "0xd3146eb281fff405b3fe418723899a890cb2f29646160a07af81ca241e2ec96e",
    name: "USDC / PT-mMEV-30OCT2025",
    irm: "0x870aC11D48B15DB9a138Cf899d20F13F79Ba00BC",
    lltv: "915000000000000000",
    oracle: "0xEce23d4B46235c763B0b76fFaeF654E103FeC486",
    loanToken: {
      address: "0xA0b86991c6218b36c1d19D4a2e9Eb0cE3606eB48",
      symbol: "USDC",
    },
    collateralToken: {
      address: "0x61da65F0534C6A4F4c9757f2979A923c08d6D2aa",
      symbol: "PT-mMEV-30OCT2025",
    },
  },
  {
    id: "0x7e66ce6d3e2a27db0dab1d9c16dd313a4658eb6317a75d3bf8de8fe8a5880f96",
    name: "USDC / stakedao-crvUSDUSDC-f",
    irm: "0x870aC11D48B15DB9a138Cf899d20F13F79Ba00BC",
    lltv: "945000000000000000",
    oracle: "0x3bb43EF3EBF21E84c38e958fbF85af482d594C77",
    loanToken: {
      address: "0xA0b86991c6218b36c1d19D4a2e9Eb0cE3606eB48",
      symbol: "USDC",
    },
    collateralToken: {
      address: "0x393C0cf85E5a60b730e705396f3bea71648FA3A0",
      symbol: "stakedao-crvUSDUSDC-f",
    },
  },
  {
    id: "0x5c4120f5129199ac747086fe3d141e6fe904ea335a7b9aa4059d065603afcefc",
    name: "PYUSD / PT-sUSDE-5FEB2026",
    irm: "0x870aC11D48B15DB9a138Cf899d20F13F79Ba00BC",
    lltv: "915000000000000000",
    oracle: "0x3739295C17225F11D68bc5d73C04EB6eb407FC2d",
    loanToken: {
      address: "0x6c3ea9036406852006290770BEdFcAbA0e23A0e8",
      symbol: "PYUSD",
    },
    collateralToken: {
      address: "0xE8483517077afa11A9B07f849cee2552f040d7b2",
      symbol: "PT-sUSDE-5FEB2026",
    },
  },
  {
    id: "0x9ba82a4b7009e362b88f8c4b428e46ef2eedf7c62fe63adbc2b851733a70b848",
    name: "USDC / stakedao-crvUSDUSDC-f",
    irm: "0x870aC11D48B15DB9a138Cf899d20F13F79Ba00BC",
    lltv: "945000000000000000",
    oracle: "0xAAd341b4Dc66DCC2C5d6E86e1d252c311C62f757",
    loanToken: {
      address: "0xA0b86991c6218b36c1d19D4a2e9Eb0cE3606eB48",
      symbol: "USDC",
    },
    collateralToken: {
      address: "0xF169457F89bEeC726e0e9344a59C85328D285f2C",
      symbol: "stakedao-crvUSDUSDC-f",
    },
  },
  {
    id: "0xe09be287c4f6583dfef6aa61d71f6cc76062aa1294e79b5c7c0a69d69bc1dd72",
    name: "USDT / PENDLE-LPT-WRAPPED",
    irm: "0x870aC11D48B15DB9a138Cf899d20F13F79Ba00BC",
    lltv: "860000000000000000",
    oracle: "0xC78EC8E67571A0848a4272837DfE893e6cFA5F64",
    loanToken: {
      address: "0xdAC17F958D2ee523a2206206994597C13D831ec7",
      symbol: "USDT",
    },
    collateralToken: {
      address: "0xFbA26f44459FB83d98c9a8C8FDdca7cadca18A85",
      symbol: "PENDLE-LPT-WRAPPED",
    },
  },
  {
    id: "0x444327b909aa41043cc4f20209eefb2fbb37f1c38ff9ca312374a4ecc3f0a871",
    name: "USDC / SolvBTC",
    irm: "0x870aC11D48B15DB9a138Cf899d20F13F79Ba00BC",
    lltv: "860000000000000000",
    oracle: "0xe769524ab359F3DBf87187bB7Da6c7Cb3638af96",
    loanToken: {
      address: "0xA0b86991c6218b36c1d19D4a2e9Eb0cE3606eB48",
      symbol: "USDC",
    },
    collateralToken: {
      address: "0x7A56E1C57C7475CCf742a1832B028F0456652F97",
      symbol: "SolvBTC",
    },
  },
  {
    id: "0xa3819a7d2aee958ca0e7404137d012b51ea47d051db69d94656956eff8c80c23",
    name: "USDC / PT-syrupUSDC-28AUG2025",
    irm: "0x870aC11D48B15DB9a138Cf899d20F13F79Ba00BC",
    lltv: "860000000000000000",
    oracle: "0x3B74C5fd1005Cd98f349d5d9Df78EC8b15131fa5",
    loanToken: {
      address: "0xA0b86991c6218b36c1d19D4a2e9Eb0cE3606eB48",
      symbol: "USDC",
    },
    collateralToken: {
      address: "0xCcE7D12f683c6dAe700154f0BAdf779C0bA1F89A",
      symbol: "PT-syrupUSDC-28AUG2025",
    },
  },
  {
    id: "0xa6b5b5cc24a40900156a503afc6c898118b6d37ae545c2c144326fb95ac68e7a",
    name: "USDU / WETH",
    irm: "0x870aC11D48B15DB9a138Cf899d20F13F79Ba00BC",
    lltv: "860000000000000000",
    oracle: "0x0BB7EdDF8cD63f52676f1B527c6Cf5BE57604d92",
    loanToken: {
      address: "0xdde3eC717f220Fc6A29D6a4Be73F91DA5b718e55",
      symbol: "USDU",
    },
    collateralToken: {
      address: "0xC02aaA39b223FE8D0A0e5C4F27eAD9083C756Cc2",
      symbol: "WETH",
    },
  },
  {
    id: "0xeb3e4a68c675d88f5a4378eab966e717bdee6a0f38c5ca6da2560ac5d1534f60",
    name: "USDC / PT-slvlUSD-29MAY2025",
    irm: "0x870aC11D48B15DB9a138Cf899d20F13F79Ba00BC",
    lltv: "915000000000000000",
    oracle: "0xEaAf18E3D90e1A3741376383Beb41A2081b4Cb8F",
    loanToken: {
      address: "0xA0b86991c6218b36c1d19D4a2e9Eb0cE3606eB48",
      symbol: "USDC",
    },
    collateralToken: {
      address: "0x4D4062bAD41E03b1cdee4C06263F96EB81832341",
      symbol: "PT-slvlUSD-29MAY2025",
    },
  },
  {
    id: "0x83e10b446f0f2013bb5417fbab8de0371808da605d9d88bdd3ad9de4e7303048",
    name: "USDT / PT-sUSDE-31JUL2025",
    irm: "0x870aC11D48B15DB9a138Cf899d20F13F79Ba00BC",
    lltv: "945000000000000000",
    oracle: "0x1376913337ceC523B4DDEAD8a60eDb1fA43fF1E3",
    loanToken: {
      address: "0xdAC17F958D2ee523a2206206994597C13D831ec7",
      symbol: "USDT",
    },
    collateralToken: {
      address: "0x3b3fB9C57858EF816833dC91565EFcd85D96f634",
      symbol: "PT-sUSDE-31JUL2025",
    },
  },
  {
    id: "0x3ab41e2c5c20129a4d156c937ce4e23c3e5d310e460df8619da0f4acb68bb4b7",
    name: "EURC / cbBTC",
    irm: "0x870aC11D48B15DB9a138Cf899d20F13F79Ba00BC",
    lltv: "860000000000000000",
    oracle: "0xAB6b64a396c4D2640c8783E19298d5b3DB16bd3B",
    loanToken: {
      address: "0x1aBaEA1f7C830bD89Acc67eC4af516284b1bC33c",
      symbol: "EURC",
    },
    collateralToken: {
      address: "0xcbB7C0000aB88B473b1f5aFd9ef808440eed33Bf",
      symbol: "cbBTC",
    },
  },
  {
    id: "0x1a9ccaca2dba9469cd9cba3d077466761b05f465c412d2bf2c71614c4963dd84",
    name: "USDC / USCC",
    irm: "0x870aC11D48B15DB9a138Cf899d20F13F79Ba00BC",
    lltv: "915000000000000000",
    oracle: "0x68066D2891254F1F3285Cac0bB16B65B28EE3cAb",
    loanToken: {
      address: "0xA0b86991c6218b36c1d19D4a2e9Eb0cE3606eB48",
      symbol: "USDC",
    },
    collateralToken: {
      address: "0x14d60E7FDC0D71d8611742720E4C50E7a974020c",
      symbol: "USCC",
    },
  },
  {
    id: "0x3e6cea6ad0e3c8fd5bb51f9bd9b9af30946f1d245543f409b6add8b754c03d8b",
    name: "EURe / stEUR",
    irm: "0x870aC11D48B15DB9a138Cf899d20F13F79Ba00BC",
    lltv: "945000000000000000",
    oracle: "0xc20560B8C4E25f62946f8d3C496d097629986007",
    loanToken: {
      address: "0x3231Cb76718CDeF2155FC47b5286d82e6eDA273f",
      symbol: "EURe",
    },
    collateralToken: {
      address: "0x004626A008B1aCdC4c74ab51644093b155e59A23",
      symbol: "stEUR",
    },
  },
  {
    id: "0x9507d68c9c8663bd134680005cc0b3d8a891fa95db1905268933ac6bbc1d1feb",
    name: "WETH / hETH",
    irm: "0x870aC11D48B15DB9a138Cf899d20F13F79Ba00BC",
    lltv: "860000000000000000",
    oracle: "0xB20802c1f9483499e43d1199200A5fAB9E7ce0e0",
    loanToken: {
      address: "0xC02aaA39b223FE8D0A0e5C4F27eAD9083C756Cc2",
      symbol: "WETH",
    },
    collateralToken: {
      address: "0x270B7748CdF8243bFe68FaCE7230ef0fCE695389",
      symbol: "hETH",
    },
  },
  {
    id: "0x0cf0597c314f60b9e42d4666073014cf4f7cdf72dea45626aa1caad695c74f2a",
    name: "WETH / bbqWSTETH",
    irm: "0x870aC11D48B15DB9a138Cf899d20F13F79Ba00BC",
    lltv: "945000000000000000",
    oracle: "0x39f46eAd05fb7b67516cD4fA66FE11E5c422C546",
    loanToken: {
      address: "0xC02aaA39b223FE8D0A0e5C4F27eAD9083C756Cc2",
      symbol: "WETH",
    },
    collateralToken: {
      address: "0x833AdaeF212c5cD3f78906B44bBfb18258F238F0",
      symbol: "bbqWSTETH",
    },
  },
  {
    id: "0xfb8315a8e5a80db41a33bb9f7d9eaf14e2110c1f2aebdba16383c07c19dc6e28",
    name: "USDT / thBILL",
    irm: "0x870aC11D48B15DB9a138Cf899d20F13F79Ba00BC",
    lltv: "945000000000000000",
    oracle: "0x6d6cfa81bAcFC16b1cB9Ad2B0003A8158d188b3e",
    loanToken: {
      address: "0xdAC17F958D2ee523a2206206994597C13D831ec7",
      symbol: "USDT",
    },
    collateralToken: {
      address: "0x5FA487BCa6158c64046B2813623e20755091DA0b",
      symbol: "thBILL",
    },
  },
  {
    id: "0x82e2ceecfd27bd27c320edf8209e905176d377cb81479ade0fe13debf8e1e324",
    name: "USDC / wbrUSDC",
    irm: "0x870aC11D48B15DB9a138Cf899d20F13F79Ba00BC",
    lltv: "860000000000000000",
    oracle: "0x6BAC818dF5654eA824cE723de51d7C7d9fD2f4FF",
    loanToken: {
      address: "0xA0b86991c6218b36c1d19D4a2e9Eb0cE3606eB48",
      symbol: "USDC",
    },
    collateralToken: {
      address: "0x3EBFa39649EFb8aa0B4e8dCCCd25884D8223c1ee",
      symbol: "wbrUSDC",
    },
  },
  {
    id: "0x3924d0c6a624892fd2f26e1f920c30a1ccd010cc3af03e1e0678a3760aebee7a",
    name: "USDC / mTBILL",
    irm: "0x870aC11D48B15DB9a138Cf899d20F13F79Ba00BC",
    lltv: "945000000000000000",
    oracle: "0x24B9D8158b4cA704a5724ade57cb65136177D6df",
    loanToken: {
      address: "0xA0b86991c6218b36c1d19D4a2e9Eb0cE3606eB48",
      symbol: "USDC",
    },
    collateralToken: {
      address: "0xDD629E5241CbC5919847783e6C96B2De4754e438",
      symbol: "mTBILL",
    },
  },
  {
    id: "0x534e7046c3aebaa0c6c363cdbeb9392fc87af71cc16862479403a198fe04b206",
    name: "USDC / PT-USDe-27NOV2025",
    irm: "0x870aC11D48B15DB9a138Cf899d20F13F79Ba00BC",
    lltv: "915000000000000000",
    oracle: "0x0beC5A0f7Bea1D14efC2663054D6D1E2B764b630",
    loanToken: {
      address: "0xA0b86991c6218b36c1d19D4a2e9Eb0cE3606eB48",
      symbol: "USDC",
    },
    collateralToken: {
      address: "0x62C6E813b9589C3631Ba0Cdb013acdB8544038B7",
      symbol: "PT-USDe-27NOV2025",
    },
  },
  {
    id: "0xb4de9aa8a35ceb91e22abc51728c12b4bb5855659c5ac82a06ba9b321dddd080",
    name: "USDC / JPYC",
    irm: "0x870aC11D48B15DB9a138Cf899d20F13F79Ba00BC",
    lltv: "860000000000000000",
    oracle: "0xE335e87D8907457E10EF66EdB0fa728aeD596fb5",
    loanToken: {
      address: "0xA0b86991c6218b36c1d19D4a2e9Eb0cE3606eB48",
      symbol: "USDC",
    },
    collateralToken: {
      address: "0xE7C3D8C9a439feDe00D2600032D5dB0Be71C3c29",
      symbol: "JPYC",
    },
  },
  {
    id: "0x52a2d5888771320fc4556c4ea9e5ee79acf8ebfe020579a826d6413cb1e68aab",
    name: "PYUSD / WETH",
    irm: "0x870aC11D48B15DB9a138Cf899d20F13F79Ba00BC",
    lltv: "860000000000000000",
    oracle: "0xa91609499bAC91D21baE4995981AA3dA35C8FA9d",
    loanToken: {
      address: "0x6c3ea9036406852006290770BEdFcAbA0e23A0e8",
      symbol: "PYUSD",
    },
    collateralToken: {
      address: "0xC02aaA39b223FE8D0A0e5C4F27eAD9083C756Cc2",
      symbol: "WETH",
    },
  },
  {
    id: "0xe558fa92b631b4f6a2485df7c21702842c83248e11df15440d8ab2489237b29f",
    name: "PYUSD / WBTC",
    irm: "0x870aC11D48B15DB9a138Cf899d20F13F79Ba00BC",
    lltv: "860000000000000000",
    oracle: "0x984DB3538dC74F901E9A28f5b4C50c375db38fc0",
    loanToken: {
      address: "0x6c3ea9036406852006290770BEdFcAbA0e23A0e8",
      symbol: "PYUSD",
    },
    collateralToken: {
      address: "0x2260FAC5E5542a773Aa44fBCfeDf7C193bc2C599",
      symbol: "WBTC",
    },
  },
  {
    id: "0xf5247777a8d248b82a25ca32a29e47c06ca955cd314b69db07fc8f332e374702",
    name: "USDC / stakedao-crvUSDUSDT-f",
    irm: "0x870aC11D48B15DB9a138Cf899d20F13F79Ba00BC",
    lltv: "945000000000000000",
    oracle: "0xae5D2566e8145fe1D33cA7Cac7317c37204c83d9",
    loanToken: {
      address: "0xA0b86991c6218b36c1d19D4a2e9Eb0cE3606eB48",
      symbol: "USDC",
    },
    collateralToken: {
      address: "0x2343f786fc8366f0fA7C9A80B43CDA5731D9d1B4",
      symbol: "stakedao-crvUSDUSDT-f",
    },
  },
  {
    id: "0xd3af26d5fa9c23b4a873dab73c6877ec5e3c62f0a11721db36711420bdce416c",
    name: "USDC / yoUSD",
    irm: "0x870aC11D48B15DB9a138Cf899d20F13F79Ba00BC",
    lltv: "915000000000000000",
    oracle: "0xe3FD2b17A88679fBB802fb70c6Df98De921eA4da",
    loanToken: {
      address: "0xA0b86991c6218b36c1d19D4a2e9Eb0cE3606eB48",
      symbol: "USDC",
    },
    collateralToken: {
      address: "0x0000000f2eB9f69274678c76222B35eEc7588a65",
      symbol: "yoUSD",
    },
  },
  {
    id: "0xa6c4cbcfa20ec490e4ed3091a41a9c7cbefab586728fdde59ac3907e64c41989",
    name: "USD0 / wstETH",
    irm: "0x870aC11D48B15DB9a138Cf899d20F13F79Ba00BC",
    lltv: "860000000000000000",
    oracle: "0x57C9bf630b455869474Fc3655CE201beeE17f872",
    loanToken: {
      address: "0x73A15FeD60Bf67631dC6cd7Bc5B6e8da8190aCF5",
      symbol: "USD0",
    },
    collateralToken: {
      address: "0x7f39C581F595B53c5cb19bD0b3f8dA6c935E2Ca0",
      symbol: "wstETH",
    },
  },
  {
    id: "0x3bfa3a9647c28e21145dafcb09fd84f5a73831b2437a7ec8f7c686119911a0b5",
    name: "PYUSD / weETH",
    irm: "0x870aC11D48B15DB9a138Cf899d20F13F79Ba00BC",
    lltv: "860000000000000000",
    oracle: "0xa74850aFD42CbEfcfe7b4DB49929549CF6eA04A9",
    loanToken: {
      address: "0x6c3ea9036406852006290770BEdFcAbA0e23A0e8",
      symbol: "PYUSD",
    },
    collateralToken: {
      address: "0xCd5fE23C85820F7B72D0926FC9b05b43E359b7ee",
      symbol: "weETH",
    },
  },
  {
    id: "0x04f82076dd379cf1dc479cb166324b640f6c25b0793391d79ccfcb6efb61ee7b",
    name: "USDT / FLHYon",
    irm: "0x870aC11D48B15DB9a138Cf899d20F13F79Ba00BC",
    lltv: "860000000000000000",
    oracle: "0xD703c55B871D999eA5435aC3721B19296Ac249D1",
    loanToken: {
      address: "0xdAC17F958D2ee523a2206206994597C13D831ec7",
      symbol: "USDT",
    },
    collateralToken: {
      address: "0x54C1Ff361b402f66c13107421E6A431C3375EF24",
      symbol: "FLHYon",
    },
  },
  {
    id: "0x3bdb58058b41bb700458ba3df317e254244ddec7fc35fec93d2d53475cc6ebdc",
    name: "USDC / PT-syrupUSDC-28AUG2025",
    irm: "0x870aC11D48B15DB9a138Cf899d20F13F79Ba00BC",
    lltv: "915000000000000000",
    oracle: "0x3B74C5fd1005Cd98f349d5d9Df78EC8b15131fa5",
    loanToken: {
      address: "0xA0b86991c6218b36c1d19D4a2e9Eb0cE3606eB48",
      symbol: "USDC",
    },
    collateralToken: {
      address: "0xCcE7D12f683c6dAe700154f0BAdf779C0bA1F89A",
      symbol: "PT-syrupUSDC-28AUG2025",
    },
  },
  {
    id: "0x9df0fc9073632db5926b92f024165289b4ee4a9f8521dd6d3460f3544fe9770f",
    name: "USDT / PT-syrupUSDC-28AUG2025",
    irm: "0x870aC11D48B15DB9a138Cf899d20F13F79Ba00BC",
    lltv: "915000000000000000",
    oracle: "0x3B74C5fd1005Cd98f349d5d9Df78EC8b15131fa5",
    loanToken: {
      address: "0xdAC17F958D2ee523a2206206994597C13D831ec7",
      symbol: "USDT",
    },
    collateralToken: {
      address: "0xCcE7D12f683c6dAe700154f0BAdf779C0bA1F89A",
      symbol: "PT-syrupUSDC-28AUG2025",
    },
  },
  {
    id: "0xbd290578029fb5adc4a67b0a96ec409002478d1092e56429a00ed30a106de7f3",
    name: "DAI / PT-syrupUSDC-28AUG2025",
    irm: "0x870aC11D48B15DB9a138Cf899d20F13F79Ba00BC",
    lltv: "915000000000000000",
    oracle: "0xdcC91883A87D336a2EEC0213E9167b4A6CD5b175",
    loanToken: {
      address: "0x6B175474E89094C44Da98b954EedeAC495271d0F",
      symbol: "DAI",
    },
    collateralToken: {
      address: "0xCcE7D12f683c6dAe700154f0BAdf779C0bA1F89A",
      symbol: "PT-syrupUSDC-28AUG2025",
    },
  },
  {
    id: "0xbe4c211adca4400078db69af91ea0df98401adb5959510ae99edd06fee5146f7",
    name: "USDC / mTBILL",
    irm: "0x870aC11D48B15DB9a138Cf899d20F13F79Ba00BC",
    lltv: "980000000000000000",
    oracle: "0x6E8F5b2DF218443E87fe8aA9811E6956716dde88",
    loanToken: {
      address: "0xA0b86991c6218b36c1d19D4a2e9Eb0cE3606eB48",
      symbol: "USDC",
    },
    collateralToken: {
      address: "0xDD629E5241CbC5919847783e6C96B2De4754e438",
      symbol: "mTBILL",
    },
  },
  {
    id: "0x1fd06e789f16274478fac4b057163c1ae6cda1a5fbf223ffe52be5dfd659f033",
    name: "DAI / PT-eUSDE-14AUG2025",
    irm: "0x870aC11D48B15DB9a138Cf899d20F13F79Ba00BC",
    lltv: "915000000000000000",
    oracle: "0x4f98667af07f3faB3F7a77E65Fcf48c7335eAA7a",
    loanToken: {
      address: "0x6B175474E89094C44Da98b954EedeAC495271d0F",
      symbol: "DAI",
    },
    collateralToken: {
      address: "0x14Bdc3A3AE09f5518b923b69489CBcAfB238e617",
      symbol: "PT-eUSDE-14AUG2025",
    },
  },
  {
    id: "0xb80caf498db6593f2b93fdac04acd9ce35d90977936597b4bc0913eb6b5837d3",
    name: "USDC / sUSP",
    irm: "0x870aC11D48B15DB9a138Cf899d20F13F79Ba00BC",
    lltv: "915000000000000000",
    oracle: "0x373F6155264c3424Cd0D1cA2c7C29FF1998F19d0",
    loanToken: {
      address: "0xA0b86991c6218b36c1d19D4a2e9Eb0cE3606eB48",
      symbol: "USDC",
    },
    collateralToken: {
      address: "0x271C616157e69A43B4977412A64183Cf110Edf16",
      symbol: "sUSP",
    },
  },
  {
    id: "0x97a6a42743a088af55e27f828fa59e815acace008e5c33828084dd9b5632e6db",
    name: "USDC / PT-PendleInfiniFi-siUSD-9OCT2025",
    irm: "0x870aC11D48B15DB9a138Cf899d20F13F79Ba00BC",
    lltv: "915000000000000000",
    oracle: "0x66D71CcD303A4719ba5852eb04feEd800f0e6388",
    loanToken: {
      address: "0xA0b86991c6218b36c1d19D4a2e9Eb0cE3606eB48",
      symbol: "USDC",
    },
    collateralToken: {
      address: "0x711214da1A94F478B96C1Ca3D14A750f496F2a80",
      symbol: "PT-PendleInfiniFi-siUSD-9OCT2025",
    },
  },
  {
    id: "0x4c1bf39fc2e39a30560f5eb4b6e84eab91075a0f29566da91bd53131738470b1",
    name: "USDC / PT-fxSAVE-30APR2026",
    irm: "0x870aC11D48B15DB9a138Cf899d20F13F79Ba00BC",
    lltv: "915000000000000000",
    oracle: "0xc08B9fF2d373CF0769b003e80f7B87ea0599c0AC",
    loanToken: {
      address: "0xA0b86991c6218b36c1d19D4a2e9Eb0cE3606eB48",
      symbol: "USDC",
    },
    collateralToken: {
      address: "0xB1e926428ebEc4421cCE1eC6d9ff65d27F4b4bB6",
      symbol: "PT-fxSAVE-30APR2026",
    },
  },
  {
    id: "0x7dd7fd034b18a3cc6fccaec556e24cfa727757059f526eb87e9f26704c7a6dc2",
    name: "USDC / PT-srUSDe-25JUN2026",
    irm: "0x870aC11D48B15DB9a138Cf899d20F13F79Ba00BC",
    lltv: "915000000000000000",
    oracle: "0x20358B3340D8400Df30B1177e9EcDbB0FF2c19Ab",
    loanToken: {
      address: "0xA0b86991c6218b36c1d19D4a2e9Eb0cE3606eB48",
      symbol: "USDC",
    },
    collateralToken: {
      address: "0x619D75E3b790eBC21c289f2805Bb7177A7D732E2",
      symbol: "PT-srUSDe-25JUN2026",
    },
  },
  {
    id: "0x933cab0a47e50028d999e0b3c0fb9b81ef41f6ebcb02865dad98395d961cb2f4",
    name: "USDC / stakedao-crvfrxUSD",
    irm: "0x870aC11D48B15DB9a138Cf899d20F13F79Ba00BC",
    lltv: "945000000000000000",
    oracle: "0x1aD89B0ce49a1ED2A3D5e269971c3efadbF085c6",
    loanToken: {
      address: "0xA0b86991c6218b36c1d19D4a2e9Eb0cE3606eB48",
      symbol: "USDC",
    },
    collateralToken: {
      address: "0xeBc3554f3659e8425e1Fb30E6f99ae08A03EE932",
      symbol: "stakedao-crvfrxUSD",
    },
  },
  {
    id: "0x3b2e7f3b7e5c7392110542b754ba8523c358f25a2b88c586f2f1cd97d54196cc",
    name: "USDC / stakedao-PYcrvUSD",
    irm: "0x870aC11D48B15DB9a138Cf899d20F13F79Ba00BC",
    lltv: "945000000000000000",
    oracle: "0x3C7929733bc13BFCb76C301f68b6e44D590514E3",
    loanToken: {
      address: "0xA0b86991c6218b36c1d19D4a2e9Eb0cE3606eB48",
      symbol: "USDC",
    },
    collateralToken: {
      address: "0xd7A7992989C5B20eF48452C96aC4C6B71A17D61e",
      symbol: "stakedao-PYcrvUSD",
    },
  },
  {
    id: "0xdf034d0351a4c0af947e1a37ecd5ccbce60d72eac90de6fcad48c74e2869d14c",
    name: "USDC / PT-iUSD-25JUN2026",
    irm: "0x870aC11D48B15DB9a138Cf899d20F13F79Ba00BC",
    lltv: "915000000000000000",
    oracle: "0x4cE176581EB5C84713C2e653b5586a59699F990C",
    loanToken: {
      address: "0xA0b86991c6218b36c1d19D4a2e9Eb0cE3606eB48",
      symbol: "USDC",
    },
    collateralToken: {
      address: "0x5DbF246B37E1b9ac5D08bb38233d71322AE7D166",
      symbol: "PT-iUSD-25JUN2026",
    },
  },
  {
    id: "0x00edbb2e2de487431e8be432f8f51215b01bcda10503617e2ee9c7d674492b47",
    name: "USDC / srRoyUSDC",
    irm: "0x870aC11D48B15DB9a138Cf899d20F13F79Ba00BC",
    lltv: "860000000000000000",
    oracle: "0x62011dc01c0B9833C4E53e20456400e4EA4b8363",
    loanToken: {
      address: "0xA0b86991c6218b36c1d19D4a2e9Eb0cE3606eB48",
      symbol: "USDC",
    },
    collateralToken: {
      address: "0xcD9f5907F92818bC06c9Ad70217f089E190d2a32",
      symbol: "srRoyUSDC",
    },
  },
  {
    id: "0xe0800b3f305b167e65738adc54e03d48c7bf4fb03af2734b4a72034852ba4a7a",
    name: "USDC / sUSDEsUSDS",
    irm: "0x870aC11D48B15DB9a138Cf899d20F13F79Ba00BC",
    lltv: "915000000000000000",
    oracle: "0xa610254778D93aB09AF33D480D9465b98B9CD977",
    loanToken: {
      address: "0xA0b86991c6218b36c1d19D4a2e9Eb0cE3606eB48",
      symbol: "USDC",
    },
    collateralToken: {
      address: "0x3CEf1AFC0E8324b57293a6E7cE663781bbEFBB79",
      symbol: "sUSDEsUSDS",
    },
  },
  {
    id: "0x6945102310e45cff82d3c9d89aa3c6bde568fda9b55e6ea5c3170d1782c6effc",
    name: "USDC / PT-mEDGE-30OCT2025",
    irm: "0x870aC11D48B15DB9a138Cf899d20F13F79Ba00BC",
    lltv: "860000000000000000",
    oracle: "0x7E1Ce431813E1b63C0985FD1056cd25eC9d0071b",
    loanToken: {
      address: "0xA0b86991c6218b36c1d19D4a2e9Eb0cE3606eB48",
      symbol: "USDC",
    },
    collateralToken: {
      address: "0x2E3229674085F5490a4cC2558ab96aEDC3ab25D1",
      symbol: "PT-mEDGE-30OCT2025",
    },
  },
  {
    id: "0xe6a832e464f2afc8639ae6982c6dc06520b43a85babcddfd892781bbc95ad280",
    name: "USDC / PT-USD0++-31OCT2024",
    irm: "0x870aC11D48B15DB9a138Cf899d20F13F79Ba00BC",
    lltv: "860000000000000000",
    oracle: "0x360f5B35aac22CBbd8F0b6E916DaAeD1013FEaED",
    loanToken: {
      address: "0xA0b86991c6218b36c1d19D4a2e9Eb0cE3606eB48",
      symbol: "USDC",
    },
    collateralToken: {
      address: "0x270d664d2Fc7D962012a787Aec8661CA83DF24EB",
      symbol: "PT-USD0++-31OCT2024",
    },
  },
  {
    id: "0x02a2cfa7911c288dc918dc56b6b23b53557938f684fd01326f4b311b16178785",
    name: "USDT / PT-RUSD-30OCT2025",
    irm: "0x870aC11D48B15DB9a138Cf899d20F13F79Ba00BC",
    lltv: "915000000000000000",
    oracle: "0x40234d69Ea50c3C6171062f8A0af39835755049A",
    loanToken: {
      address: "0xdAC17F958D2ee523a2206206994597C13D831ec7",
      symbol: "USDT",
    },
    collateralToken: {
      address: "0xdcFDf8434e8FDfFF2dD7dfC9299877e813348EE7",
      symbol: "PT-RUSD-30OCT2025",
    },
  },
  {
    id: "0x1c6f0822b996c86b2cace788cc265beb4f84585456aba8f424c710e67116b93d",
    name: "USDC / deUSD",
    irm: "0x870aC11D48B15DB9a138Cf899d20F13F79Ba00BC",
    lltv: "915000000000000000",
    oracle: "0x2D949A3621cf5D3B0E6A9EC764aEAFa35F55AA10",
    loanToken: {
      address: "0xA0b86991c6218b36c1d19D4a2e9Eb0cE3606eB48",
      symbol: "USDC",
    },
    collateralToken: {
      address: "0x15700B564Ca08D9439C58cA5053166E8317aa138",
      symbol: "deUSD",
    },
  },
  {
    id: "0xd0d22868a9460dd837f020a1ba300b81f26520602cc61f2b515cf6413b15ddac",
    name: "USDe / PT-eUSDE-14AUG2025",
    irm: "0x870aC11D48B15DB9a138Cf899d20F13F79Ba00BC",
    lltv: "915000000000000000",
    oracle: "0xB2e3805DD677911e5A9D4cAfB1064DFd606c41D8",
    loanToken: {
      address: "0x4c9EDD5852cd905f086C759E8383e09bff1E68B3",
      symbol: "USDe",
    },
    collateralToken: {
      address: "0x14Bdc3A3AE09f5518b923b69489CBcAfB238e617",
      symbol: "PT-eUSDE-14AUG2025",
    },
  },
  {
    id: "0xfc238b7b39e0febab89433ab0380f2988b13671c1884d7ebb2f3eba4627261f0",
    name: "USDT / PENDLE-LPT-WRAPPED",
    irm: "0x870aC11D48B15DB9a138Cf899d20F13F79Ba00BC",
    lltv: "915000000000000000",
    oracle: "0x825059BF3122ea7Fe00c1ff3a898b116C00e3102",
    loanToken: {
      address: "0xdAC17F958D2ee523a2206206994597C13D831ec7",
      symbol: "USDT",
    },
    collateralToken: {
      address: "0x10cbdAe955725baC7bCc20335e304b4A48fD8919",
      symbol: "PENDLE-LPT-WRAPPED",
    },
  },
  {
    id: "0x5125fcd427c196c8796f1a7573109ad9884e6ece3208c25a9583b5999b4e03e4",
    name: "PYUSD / USYC",
    irm: "0x870aC11D48B15DB9a138Cf899d20F13F79Ba00BC",
    lltv: "980000000000000000",
    oracle: "0x3A2a2C9287be8b7056075f049f1fBDF8ECb81eda",
    loanToken: {
      address: "0x6c3ea9036406852006290770BEdFcAbA0e23A0e8",
      symbol: "PYUSD",
    },
    collateralToken: {
      address: "0x136471a34f6ef19fE571EFFC1CA711fdb8E49f2b",
      symbol: "USYC",
    },
  },
  {
    id: "0x68d35b050f930a801087aa0aca91da1bc32f84783277813b619e3e1d0bf00a2f",
    name: "USDC / unknown",
    irm: "0x870aC11D48B15DB9a138Cf899d20F13F79Ba00BC",
    lltv: "945000000000000000",
    oracle: "0x0833501FC146846D651D8F073e79a23bfB8193Ae",
    loanToken: {
      address: "0xA0b86991c6218b36c1d19D4a2e9Eb0cE3606eB48",
      symbol: "USDC",
    },
    collateralToken: {
      address: "0x92abCF6813150a9F78540cAa4feE6115a713F505",
      symbol: "unknown",
    },
  },
  {
    id: "0x7fd694cd13880ce994c61e8f8991ce0c9e321e3d50f548dd62a1b6e610d29f32",
    name: "USDT / PT-cUSDO-20NOV2025",
    irm: "0x870aC11D48B15DB9a138Cf899d20F13F79Ba00BC",
    lltv: "915000000000000000",
    oracle: "0xB9B803F4613bA39f5faeE45419b05A0a83068179",
    loanToken: {
      address: "0xdAC17F958D2ee523a2206206994597C13D831ec7",
      symbol: "USDT",
    },
    collateralToken: {
      address: "0xB10DA2F9147f9cf2B8826877Cd0c95c18A0f42dc",
      symbol: "PT-cUSDO-20NOV2025",
    },
  },
  {
    id: "0x060f95069f9cee9d77263f1f9e5295481584cefd97aa7b2fc9e55444d617fd1a",
    name: "USDC / AA_idle_Fasanara",
    irm: "0x870aC11D48B15DB9a138Cf899d20F13F79Ba00BC",
    lltv: "980000000000000000",
    oracle: "0xD0c30F4e6b3fCF1A9c59Ae286e1Cd9ECD98eDDb9",
    loanToken: {
      address: "0xA0b86991c6218b36c1d19D4a2e9Eb0cE3606eB48",
      symbol: "USDC",
    },
    collateralToken: {
      address: "0x45054c6753b4Bce40C5d54418DabC20b070F85bE",
      symbol: "AA_idle_Fasanara",
    },
  },
  {
    id: "0x0fa88adf15abc2732504165501e4ef98f339098d3c28121e9fdcc7386b02ca58",
    name: "USDT / zkBTC",
    irm: "0x870aC11D48B15DB9a138Cf899d20F13F79Ba00BC",
    lltv: "860000000000000000",
    oracle: "0xB07AFE977d99b521dF7fd3cA4D61d61439BA8C51",
    loanToken: {
      address: "0xdAC17F958D2ee523a2206206994597C13D831ec7",
      symbol: "USDT",
    },
    collateralToken: {
      address: "0x199CC8f0ac008Bdc8cF0B1CCd5187F84E168C4D2",
      symbol: "zkBTC",
    },
  },
  {
    id: "0x65e77bec5bf9528c9ac8490eb5edc715ef434ecaf05e860a6734b9a07f0a757a",
    name: "USDC / CASH+",
    irm: "0x870aC11D48B15DB9a138Cf899d20F13F79Ba00BC",
    lltv: "915000000000000000",
    oracle: "0x814b1DF0b72afe95Ec37eD4E5704D376840718DB",
    loanToken: {
      address: "0xA0b86991c6218b36c1d19D4a2e9Eb0cE3606eB48",
      symbol: "USDC",
    },
    collateralToken: {
      address: "0x498D9329555471bF6073A5f2D047F746d522A373",
      symbol: "CASH+",
    },
  },
  {
    id: "0x32b4a75db50a20f7435dfdcf54593a2e96fc97901321d3ab07268941dee93edb",
    name: "USDC / PT-siUSD-8JAN2026",
    irm: "0x870aC11D48B15DB9a138Cf899d20F13F79Ba00BC",
    lltv: "915000000000000000",
    oracle: "0x3c21Ae229b85EE9704D8C19F0fefAF52070b114E",
    loanToken: {
      address: "0xA0b86991c6218b36c1d19D4a2e9Eb0cE3606eB48",
      symbol: "USDC",
    },
    collateralToken: {
      address: "0x5510B080449d5E3Bf345b6635eD40A35B36b081f",
      symbol: "PT-siUSD-8JAN2026",
    },
  },
  {
    id: "0x8e39cd9ee896b76e7c7ab273743fa38699e5f01e4e8694f1ca5880b22e84f3fe",
    name: "USDC / mBTC",
    irm: "0x870aC11D48B15DB9a138Cf899d20F13F79Ba00BC",
    lltv: "860000000000000000",
    oracle: "0x47C162EA5896Bd8349Bad6049Fa38BcD509dBa44",
    loanToken: {
      address: "0xA0b86991c6218b36c1d19D4a2e9Eb0cE3606eB48",
      symbol: "USDC",
    },
    collateralToken: {
      address: "0x007115416AB6c266329a03B09a8aa39aC2eF7d9d",
      symbol: "mBTC",
    },
  },
  {
    id: "0x6f461100bb410de265f49dbc70a6c19555bd8cdc696322951b3a11a2e7fafc39",
    name: "USDC / mBASIS",
    irm: "0x870aC11D48B15DB9a138Cf899d20F13F79Ba00BC",
    lltv: "860000000000000000",
    oracle: "0xAC7C15CE3B8ddb8a245d10029269BEBF540C5827",
    loanToken: {
      address: "0xA0b86991c6218b36c1d19D4a2e9Eb0cE3606eB48",
      symbol: "USDC",
    },
    collateralToken: {
      address: "0x2a8c22E3b10036f3AEF5875d04f8441d4188b656",
      symbol: "mBASIS",
    },
  },
  {
    id: "0x33d375007cd71808e667224a9dbd9493e0f34368e5a1a27115ab24fe11e4b5a4",
    name: "USDC / PT-mAPOLLO-29JAN2026",
    irm: "0x870aC11D48B15DB9a138Cf899d20F13F79Ba00BC",
    lltv: "860000000000000000",
    oracle: "0xe8a557002f377Efc48EeD61bdBB8BEb875D79e02",
    loanToken: {
      address: "0xA0b86991c6218b36c1d19D4a2e9Eb0cE3606eB48",
      symbol: "USDC",
    },
    collateralToken: {
      address: "0x955E979D243907917fda6A3a811Fb55c555b7DBA",
      symbol: "PT-mAPOLLO-29JAN2026",
    },
  },
  {
    id: "0xfc12e6c22618e8dedee4935f13d553271576505bb779667b86f983a90f064e99",
    name: "USDC / AA_FalconXUSDC",
    irm: "0x870aC11D48B15DB9a138Cf899d20F13F79Ba00BC",
    lltv: "915000000000000000",
    oracle: "0x52eA2C12734B5bB61e1edf52Bb0f01D9206493Fc",
    loanToken: {
      address: "0xA0b86991c6218b36c1d19D4a2e9Eb0cE3606eB48",
      symbol: "USDC",
    },
    collateralToken: {
      address: "0xC26A6Fa2C37b38E549a4a1807543801Db684f99C",
      symbol: "AA_FalconXUSDC",
    },
  },
  {
    id: "0xaac3ffcdf8a75919657e789fa72ab742a7bbfdf5bb0b87e4bbeb3c29bbbbb05c",
    name: "USDC / PT-siUSD-26MAR2026",
    irm: "0x870aC11D48B15DB9a138Cf899d20F13F79Ba00BC",
    lltv: "915000000000000000",
    oracle: "0xEBC3653922FE589603b271D0EbD0cf7A666De343",
    loanToken: {
      address: "0xA0b86991c6218b36c1d19D4a2e9Eb0cE3606eB48",
      symbol: "USDC",
    },
    collateralToken: {
      address: "0xaF76B3AF3477E4a2cD0B7F80c3152108c19a25e5",
      symbol: "PT-siUSD-26MAR2026",
    },
  },
  {
    id: "0x457b54a03c6bba984470d5687ec6df7967c0168bdc0052315713bfd287cd576c",
    name: "USDC / PT-cUSDO-19JUN2025",
    irm: "0x870aC11D48B15DB9a138Cf899d20F13F79Ba00BC",
    lltv: "915000000000000000",
    oracle: "0x506f0CF6150677b91519639215Dc0b7f8d190D0A",
    loanToken: {
      address: "0xA0b86991c6218b36c1d19D4a2e9Eb0cE3606eB48",
      symbol: "USDC",
    },
    collateralToken: {
      address: "0x933B9FfEE0Ad3Ef8E4DBb52688ea905826D73755",
      symbol: "PT-cUSDO-19JUN2025",
    },
  },
  {
    id: "0x5223ae739e3adcdb665919ac249983914aabb1b2991137f243bde79e65b87bc6",
    name: "USDC / PT-syrupUSDC-18DEC2025",
    irm: "0x870aC11D48B15DB9a138Cf899d20F13F79Ba00BC",
    lltv: "915000000000000000",
    oracle: "0x1Cb3939C52ac5BD8A281C3c7dC7AFaA56Aa17120",
    loanToken: {
      address: "0xA0b86991c6218b36c1d19D4a2e9Eb0cE3606eB48",
      symbol: "USDC",
    },
    collateralToken: {
      address: "0xfa9fbcF2e52037328F9376aD8FADbaC07B0E863D",
      symbol: "PT-syrupUSDC-18DEC2025",
    },
  },
  {
    id: "0xa46c4c323e03210bf59573aec2f292e451ae8ec40d9be0415522e77db2e5d402",
    name: "USDT / PT-cUSDO-19JUN2025",
    irm: "0x870aC11D48B15DB9a138Cf899d20F13F79Ba00BC",
    lltv: "915000000000000000",
    oracle: "0xf5A3555B42dF994d1a6d62379075E2d96Ef16f9C",
    loanToken: {
      address: "0xdAC17F958D2ee523a2206206994597C13D831ec7",
      symbol: "USDT",
    },
    collateralToken: {
      address: "0x933B9FfEE0Ad3Ef8E4DBb52688ea905826D73755",
      symbol: "PT-cUSDO-19JUN2025",
    },
  },
  {
    id: "0x8d8ab648ffa225f0b6af1c7de5d6bc5f6711771eaa8d48ce6efd83d40281da73",
    name: "USDC / ACRDX",
    irm: "0x870aC11D48B15DB9a138Cf899d20F13F79Ba00BC",
    lltv: "625000000000000000",
    oracle: "0x81698aA39584bc5975E89f47F55b76B431019248",
    loanToken: {
      address: "0xA0b86991c6218b36c1d19D4a2e9Eb0cE3606eB48",
      symbol: "USDC",
    },
    collateralToken: {
      address: "0x9477724Bb54AD5417de8Baff29e59DF3fB4DA74f",
      symbol: "ACRDX",
    },
  },
  {
    id: "0x66233e87913d94695fb09e8b8e586e754a7cd6dae6700b5e4b3aa08d3e73eb01",
    name: "USDT / PT-wsrUSD-31JUL2025",
    irm: "0x870aC11D48B15DB9a138Cf899d20F13F79Ba00BC",
    lltv: "915000000000000000",
    oracle: "0xEf2730755ce3AA5F20eFbff6bD3eE8942760942b",
    loanToken: {
      address: "0xdAC17F958D2ee523a2206206994597C13D831ec7",
      symbol: "USDT",
    },
    collateralToken: {
      address: "0x3bd0C522eA444eA2B3F28777e8C20248b6E33252",
      symbol: "PT-wsrUSD-31JUL2025",
    },
  },
  {
    id: "0x1aba34974778fcec0ab70e7e7af67ca3ce444e62580fd351faff86cd222774a9",
    name: "USDC / PT-yvCurve-GHO-USR(GHOUSR)-2026/01/18",
    irm: "0x870aC11D48B15DB9a138Cf899d20F13F79Ba00BC",
    lltv: "915000000000000000",
    oracle: "0x540DA4839F752AffEAF525f1af2EcF8F7e55D81f",
    loanToken: {
      address: "0xA0b86991c6218b36c1d19D4a2e9Eb0cE3606eB48",
      symbol: "USDC",
    },
    collateralToken: {
      address: "0x6F5DdB7689D7bd74D29B7d6A06ceE8e39655a5Dc",
      symbol: "PT-yvCurve-GHO-USR(GHOUSR)-2026/01/18",
    },
  },
  {
    id: "0x41af37b39c4369160933b9a7523c54ca5ec9d83fe39aada8ff8cc75426290582",
    name: "USDC / PT-sw-stkGHO-1759536005",
    irm: "0x870aC11D48B15DB9a138Cf899d20F13F79Ba00BC",
    lltv: "915000000000000000",
    oracle: "0xA9F505fA754C6D1164127A9Ba4496a0B5d980D33",
    loanToken: {
      address: "0xA0b86991c6218b36c1d19D4a2e9Eb0cE3606eB48",
      symbol: "USDC",
    },
    collateralToken: {
      address: "0x3928cbCcC982EFbaDBc004977827325B0BE4c346",
      symbol: "PT-sw-stkGHO-1759536005",
    },
  },
  {
    id: "0x8fee949ce04cda521a29d5fd9a3b071b80e9246a22db41be2b3f4feae28e86ae",
    name: "USDC / PT-slvlUSD(lvlUSD)-2026/01/18",
    irm: "0x870aC11D48B15DB9a138Cf899d20F13F79Ba00BC",
    lltv: "915000000000000000",
    oracle: "0x6ac3F157419DFA455b81813B544B7568f52891f7",
    loanToken: {
      address: "0xA0b86991c6218b36c1d19D4a2e9Eb0cE3606eB48",
      symbol: "USDC",
    },
    collateralToken: {
      address: "0x9eBb9230276e858eFb8209618055ADD25a2bf41B",
      symbol: "PT-slvlUSD(lvlUSD)-2026/01/18",
    },
  },
  {
    id: "0xb4b257c2b8001847d361a55fcd30a7bd630750bf492b85b37c4646e42e8e0d8c",
    name: "USDC / PT-iUSD-19FEB2026",
    irm: "0x870aC11D48B15DB9a138Cf899d20F13F79Ba00BC",
    lltv: "915000000000000000",
    oracle: "0x0822E6CB88Ae78612b285aaABDD97aBE3E50A1d6",
    loanToken: {
      address: "0xA0b86991c6218b36c1d19D4a2e9Eb0cE3606eB48",
      symbol: "USDC",
    },
    collateralToken: {
      address: "0xEC4402d1389E749C14A7caEef3e4c1f861e09Bc8",
      symbol: "PT-iUSD-19FEB2026",
    },
  },
  {
    id: "0x5d72e02f3655a343d8477932a8446b1881609c6b4e3044c20d3a5d7e61554cb7",
    name: "USDC / PT-sw-xUSD(USDC)-2025/10/10",
    irm: "0x870aC11D48B15DB9a138Cf899d20F13F79Ba00BC",
    lltv: "915000000000000000",
    oracle: "0x3e14b645856d1cec3C7a61F22312086339d2dc33",
    loanToken: {
      address: "0xA0b86991c6218b36c1d19D4a2e9Eb0cE3606eB48",
      symbol: "USDC",
    },
    collateralToken: {
      address: "0x1dC1b09D656c07404aa2747A9930C0b4D297B4F3",
      symbol: "PT-sw-xUSD(USDC)-2025/10/10",
    },
  },
  {
    id: "0x4239615cec9e6da3a7a2f665b82b625fae50dd8f2e153d28f2b271bc0a01392d",
    name: "USDT / PT-sUSDE-29MAY2025",
    irm: "0x870aC11D48B15DB9a138Cf899d20F13F79Ba00BC",
    lltv: "945000000000000000",
    oracle: "0x383C9a039b7325898F1f0d86356d097Cb6E6DECe",
    loanToken: {
      address: "0xdAC17F958D2ee523a2206206994597C13D831ec7",
      symbol: "USDT",
    },
    collateralToken: {
      address: "0xb7de5dFCb74d25c2f21841fbd6230355C50d9308",
      symbol: "PT-sUSDE-29MAY2025",
    },
  },
  {
    id: "0xa67cfcdf2a2637c78fd6e1879e27448be7abe90c6ef1be4a1ca4337db886c8e3",
    name: "USDC / stakedao-crvfrxUSD",
    irm: "0x870aC11D48B15DB9a138Cf899d20F13F79Ba00BC",
    lltv: "945000000000000000",
    oracle: "0x70979F4Ad0Cd9d894d73bc747Cc8DD7a269B5551",
    loanToken: {
      address: "0xA0b86991c6218b36c1d19D4a2e9Eb0cE3606eB48",
      symbol: "USDC",
    },
    collateralToken: {
      address: "0xF7dAf52958690F1dc89CD377d638e9Fc94E76ACF",
      symbol: "stakedao-crvfrxUSD",
    },
  },
  {
    id: "0xfb8d92086861bae6fb778917afd1de5dbbc4ec70edfb636fed48238e225e7e3d",
    name: "USDC / FLHYon",
    irm: "0x870aC11D48B15DB9a138Cf899d20F13F79Ba00BC",
    lltv: "860000000000000000",
    oracle: "0xD703c55B871D999eA5435aC3721B19296Ac249D1",
    loanToken: {
      address: "0xA0b86991c6218b36c1d19D4a2e9Eb0cE3606eB48",
      symbol: "USDC",
    },
    collateralToken: {
      address: "0x54C1Ff361b402f66c13107421E6A431C3375EF24",
      symbol: "FLHYon",
    },
  },
  {
    id: "0xfc91948b556d7529ad6f5318825286ed2c34d862427b4832817e880a7edbd16e",
    name: "USDC / PT-USD0++-27MAR2025",
    irm: "0x870aC11D48B15DB9a138Cf899d20F13F79Ba00BC",
    lltv: "860000000000000000",
    oracle: "0xE316c92D2B1f50a53E72461856fD50b2519e5800",
    loanToken: {
      address: "0xA0b86991c6218b36c1d19D4a2e9Eb0cE3606eB48",
      symbol: "USDC",
    },
    collateralToken: {
      address: "0x5BaE9a5D67d1CA5b09B14c91935f635CFBF3b685",
      symbol: "PT-USD0++-27MAR2025",
    },
  },
  {
    id: "0x04cb29e91de681136643ace9ca1d7af7b15b43c33c1fbc34f45812a70ba640a1",
    name: "USDC / uniBTC",
    irm: "0x870aC11D48B15DB9a138Cf899d20F13F79Ba00BC",
    lltv: "770000000000000000",
    oracle: "0x62610A25971aC5030bC6578332b19fd6B9d883eF",
    loanToken: {
      address: "0xA0b86991c6218b36c1d19D4a2e9Eb0cE3606eB48",
      symbol: "USDC",
    },
    collateralToken: {
      address: "0x004E9C3EF86bc1ca1f0bB5C7662861Ee93350568",
      symbol: "uniBTC",
    },
  },
  {
    id: "0x32a8b98a4c4b9f3b56798e6a7593799f5e1c33108302eacf981efa108fc4b131",
    name: "USDC / PT-USDe-5FEB2026",
    irm: "0x870aC11D48B15DB9a138Cf899d20F13F79Ba00BC",
    lltv: "915000000000000000",
    oracle: "0x58B796F085D43Ba18aabd39524e2Fb56DE1AA021",
    loanToken: {
      address: "0xA0b86991c6218b36c1d19D4a2e9Eb0cE3606eB48",
      symbol: "USDC",
    },
    collateralToken: {
      address: "0x1F84a51296691320478c98b8d77f2Bbd17D34350",
      symbol: "PT-USDe-5FEB2026",
    },
  },
  {
    id: "0xe1fea9eb02bc317896351ecac1fc57c9ab58e06630d4510c6fa2cba1fcb0014a",
    name: "USDT / PT-cUSD-29JAN2026",
    irm: "0x870aC11D48B15DB9a138Cf899d20F13F79Ba00BC",
    lltv: "915000000000000000",
    oracle: "0xe9000e1441a1f377c746a781bFA921936a63E420",
    loanToken: {
      address: "0xdAC17F958D2ee523a2206206994597C13D831ec7",
      symbol: "USDT",
    },
    collateralToken: {
      address: "0x545A490f9ab534AdF409A2E682bc4098f49952e3",
      symbol: "PT-cUSD-29JAN2026",
    },
  },
  {
    id: "0xcce802466ea61ec62007fe60d7b4370a10e765f9f223592790b2b7178abb9383",
    name: "USDC / PT-sdeUSD-1753142406",
    irm: "0x870aC11D48B15DB9a138Cf899d20F13F79Ba00BC",
    lltv: "915000000000000000",
    oracle: "0x1ebe961b0245E20bF74D2d4007290B989065DC27",
    loanToken: {
      address: "0xA0b86991c6218b36c1d19D4a2e9Eb0cE3606eB48",
      symbol: "USDC",
    },
    collateralToken: {
      address: "0xb4B8925c4CBce692F37C9D946883f2E330a042a9",
      symbol: "PT-sdeUSD-1753142406",
    },
  },
  {
    id: "0x226966874fecfb817a431ffb7458d0acb082579eb99b448e9ec98d9249e06341",
    name: "USDT / PT-stcUSD-29JAN2026",
    irm: "0x870aC11D48B15DB9a138Cf899d20F13F79Ba00BC",
    lltv: "915000000000000000",
    oracle: "0xC028F1530fAAD8d23e465a0DB8F383fFe11dC53b",
    loanToken: {
      address: "0xdAC17F958D2ee523a2206206994597C13D831ec7",
      symbol: "USDT",
    },
    collateralToken: {
      address: "0xC3c7E5E277d31CD24a3Ac4cC9af3B6770F30eA33",
      symbol: "PT-stcUSD-29JAN2026",
    },
  },
  {
    id: "0x54cfc72607065414310f3843d1894c6b5a3941a4dbed401980215c8df5d744ca",
    name: "USDC / mEDGE",
    irm: "0x870aC11D48B15DB9a138Cf899d20F13F79Ba00BC",
    lltv: "915000000000000000",
    oracle: "0xa9247a26Ec95D1E72C2BbC941b402df5Efe4E13A",
    loanToken: {
      address: "0xA0b86991c6218b36c1d19D4a2e9Eb0cE3606eB48",
      symbol: "USDC",
    },
    collateralToken: {
      address: "0xbB51E2a15A9158EBE2b0Ceb8678511e063AB7a55",
      symbol: "mEDGE",
    },
  },
  {
    id: "0x0b5b619d34dbcea86bbc1debccb9d7e9deebaf0dc0b31e7b995e29e214d6c355",
    name: "USDT / sUSN",
    irm: "0x870aC11D48B15DB9a138Cf899d20F13F79Ba00BC",
    lltv: "860000000000000000",
    oracle: "0x6E2188F15e91ea23653cCA3d367C0c1974A6169B",
    loanToken: {
      address: "0xdAC17F958D2ee523a2206206994597C13D831ec7",
      symbol: "USDT",
    },
    collateralToken: {
      address: "0xE24a3DC889621612422A64E6388927901608B91D",
      symbol: "sUSN",
    },
  },
  {
    id: "0xc60780d85041ac1fac6967386219cf00f5ef6a0a28c53b8632d4f2ce2961fdaf",
    name: "EURC / steakUSDC",
    irm: "0x870aC11D48B15DB9a138Cf899d20F13F79Ba00BC",
    lltv: "915000000000000000",
    oracle: "0x5aEC41BFd14ae95d7644087EB1aa4475fbBA222D",
    loanToken: {
      address: "0x1aBaEA1f7C830bD89Acc67eC4af516284b1bC33c",
      symbol: "EURC",
    },
    collateralToken: {
      address: "0xbeef088055857739C12CD3765F20b7679Def0f51",
      symbol: "steakUSDC",
    },
  },
  {
    id: "0xf12143027d7f757a1b4572bf2158d7dc88eef93631328b28fdbd351cdf1039bf",
    name: "USDC / PT-sBOLD-1765325646",
    irm: "0x870aC11D48B15DB9a138Cf899d20F13F79Ba00BC",
    lltv: "915000000000000000",
    oracle: "0x9e74B4DbD2a0f027074A68E3f0373Fc4e960b5e1",
    loanToken: {
      address: "0xA0b86991c6218b36c1d19D4a2e9Eb0cE3606eB48",
      symbol: "USDC",
    },
    collateralToken: {
      address: "0x1Ff893C9071d04F8A965a90FcB0de22406A3eEaa",
      symbol: "PT-sBOLD-1765325646",
    },
  },
  {
    id: "0x34f27ab8a10558f9ead7b642bfb0d1787acec7368770000fb1a25ef94633ce9c",
    name: "USDC / CANA",
    irm: "0x870aC11D48B15DB9a138Cf899d20F13F79Ba00BC",
    lltv: "860000000000000000",
    oracle: "0x344F17d42dF6884CE3F735564c7C3318Cd675d47",
    loanToken: {
      address: "0xA0b86991c6218b36c1d19D4a2e9Eb0cE3606eB48",
      symbol: "USDC",
    },
    collateralToken: {
      address: "0x01995A697752266d8E748738aAa3F06464B8350B",
      symbol: "CANA",
    },
  },
  {
    id: "0x30fef2c1d57648e7b82d7b485a37d7657e47383719fb606ef066e6ef78eec5da",
    name: "USDT / CANA",
    irm: "0x870aC11D48B15DB9a138Cf899d20F13F79Ba00BC",
    lltv: "860000000000000000",
    oracle: "0x89cFE24066057A1e78964eb087ED198cf36852da",
    loanToken: {
      address: "0xdAC17F958D2ee523a2206206994597C13D831ec7",
      symbol: "USDT",
    },
    collateralToken: {
      address: "0x01995A697752266d8E748738aAa3F06464B8350B",
      symbol: "CANA",
    },
  },
  {
    id: "0x4ef32e4877329436968f4a29b0c8285531d113dad29b727d88beafe5ed45be6a",
    name: "USDC / PT-sdeUSD-1753142406",
    irm: "0x870aC11D48B15DB9a138Cf899d20F13F79Ba00BC",
    lltv: "915000000000000000",
    oracle: "0xc6c5140d6aE2D1B3759E400CD59C499C496106cC",
    loanToken: {
      address: "0xA0b86991c6218b36c1d19D4a2e9Eb0cE3606eB48",
      symbol: "USDC",
    },
    collateralToken: {
      address: "0xb4B8925c4CBce692F37C9D946883f2E330a042a9",
      symbol: "PT-sdeUSD-1753142406",
    },
  },
  {
    id: "0xef225fee0f37d8827e2f6da31b85f1a4ae8ab0af45f856b85f487a97fdfecbea",
    name: "USDC / USDCUSDU",
    irm: "0x870aC11D48B15DB9a138Cf899d20F13F79Ba00BC",
    lltv: "945000000000000000",
    oracle: "0x0ab33fC1AFFB89AfF0187318adD2A6677e495c6f",
    loanToken: {
      address: "0xA0b86991c6218b36c1d19D4a2e9Eb0cE3606eB48",
      symbol: "USDC",
    },
    collateralToken: {
      address: "0xE74dD7525663193B5e5e596b581B5343735a585c",
      symbol: "USDCUSDU",
    },
  },
  {
    id: "0xaaf6549df354a014f5b17f69317cbd22f988e5f61f32da27f41442d1e092f63a",
    name: "USDT / wstUSR",
    irm: "0x870aC11D48B15DB9a138Cf899d20F13F79Ba00BC",
    lltv: "915000000000000000",
    oracle: "0xa62A262D86a90af6663b09C64D7c7E45feA1e46d",
    loanToken: {
      address: "0xdAC17F958D2ee523a2206206994597C13D831ec7",
      symbol: "USDT",
    },
    collateralToken: {
      address: "0x1202F5C7b4B9E47a1A484E8B270be34dbbC75055",
      symbol: "wstUSR",
    },
  },
  {
    id: "0x4760de05a2d34cde1109898c450f37c65fb943e64b5324fe710a0dc051ef2185",
    name: "USDT / cbBTC",
    irm: "0x870aC11D48B15DB9a138Cf899d20F13F79Ba00BC",
    lltv: "860000000000000000",
    oracle: "0x08411F9D8b2E56beb0aC02a22D3db226287F80D2",
    loanToken: {
      address: "0xdAC17F958D2ee523a2206206994597C13D831ec7",
      symbol: "USDT",
    },
    collateralToken: {
      address: "0xcbB7C0000aB88B473b1f5aFd9ef808440eed33Bf",
      symbol: "cbBTC",
    },
  },
  {
    id: "0x18a2bae3b92633af38c658ff744afe6b8eb38e805a482ed451b22c6005329ac5",
    name: "USDT / cbBTC",
    irm: "0x870aC11D48B15DB9a138Cf899d20F13F79Ba00BC",
    lltv: "860000000000000000",
    oracle: "0xF5FABaAa8EdE971D6cEe4e0FcaF8a793F3f89d03",
    loanToken: {
      address: "0xdAC17F958D2ee523a2206206994597C13D831ec7",
      symbol: "USDT",
    },
    collateralToken: {
      address: "0xcbB7C0000aB88B473b1f5aFd9ef808440eed33Bf",
      symbol: "cbBTC",
    },
  },
  {
    id: "0x3f4da90cb181c45ae2d8689f0d30675d9072f31194c5af211b4029749b63fc95",
    name: "WETH / cbBTC",
    irm: "0x870aC11D48B15DB9a138Cf899d20F13F79Ba00BC",
    lltv: "915000000000000000",
    oracle: "0x04cF969d5E1C019ef4f0e579C9097d3648d9E8f4",
    loanToken: {
      address: "0xC02aaA39b223FE8D0A0e5C4F27eAD9083C756Cc2",
      symbol: "WETH",
    },
    collateralToken: {
      address: "0xcbB7C0000aB88B473b1f5aFd9ef808440eed33Bf",
      symbol: "cbBTC",
    },
  },
  {
    id: "0xd2242e08e4f1af183f8adf0793ea84b351c7b9ab704687d487e069f008ee743e",
    name: "USDC / PT-iUSD-25JUN2026",
    irm: "0x870aC11D48B15DB9a138Cf899d20F13F79Ba00BC",
    lltv: "915000000000000000",
    oracle: "0xE207EE9Ed6Cf5e0C0ED5cDbD6Cb0a58695e38866",
    loanToken: {
      address: "0xA0b86991c6218b36c1d19D4a2e9Eb0cE3606eB48",
      symbol: "USDC",
    },
    collateralToken: {
      address: "0x5DbF246B37E1b9ac5D08bb38233d71322AE7D166",
      symbol: "PT-iUSD-25JUN2026",
    },
  },
  {
    id: "0xe90ba4c931894c61f121cf19ce2254aad02257e83148342f90e328b408b458c9",
    name: "PYUSD / PT-USDe-5FEB2026",
    irm: "0x870aC11D48B15DB9a138Cf899d20F13F79Ba00BC",
    lltv: "915000000000000000",
    oracle: "0x3Be69f206282748dc56Ff82fA0f47Db711Fd18D4",
    loanToken: {
      address: "0x6c3ea9036406852006290770BEdFcAbA0e23A0e8",
      symbol: "PYUSD",
    },
    collateralToken: {
      address: "0x1F84a51296691320478c98b8d77f2Bbd17D34350",
      symbol: "PT-USDe-5FEB2026",
    },
  },
  {
    id: "0x7824faa23ffe3a05f48cfa1b7aefb37ac70d6615c969e1a2d37c38d62b15e296",
    name: "USDC / BGBTC",
    irm: "0x870aC11D48B15DB9a138Cf899d20F13F79Ba00BC",
    lltv: "860000000000000000",
    oracle: "0x60694eBba05C02b1D6810A5d7787B9A0a302C854",
    loanToken: {
      address: "0xA0b86991c6218b36c1d19D4a2e9Eb0cE3606eB48",
      symbol: "USDC",
    },
    collateralToken: {
      address: "0x0520930F21b14Cafac7a27b102487beE7138a017",
      symbol: "BGBTC",
    },
  },
  {
    id: "0x9245300ba4a0a4e9ca6180714718a6bb72b2ebe141745fd476e0fcd2641135fe",
    name: "USDC / stcUSD",
    irm: "0x870aC11D48B15DB9a138Cf899d20F13F79Ba00BC",
    lltv: "915000000000000000",
    oracle: "0xb1E92b4e1E546B02a0f07500e68bE1380Cb694A1",
    loanToken: {
      address: "0xA0b86991c6218b36c1d19D4a2e9Eb0cE3606eB48",
      symbol: "USDC",
    },
    collateralToken: {
      address: "0x88887bE419578051FF9F4eb6C858A951921D8888",
      symbol: "stcUSD",
    },
  },
  {
    id: "0x822bd7e2c048cb2412b4f5677b6a8c83f07f247afbfacf4c46d8b13a5e0ab08a",
    name: "USDC / PENDLE-LPT-WRAPPED",
    irm: "0x870aC11D48B15DB9a138Cf899d20F13F79Ba00BC",
    lltv: "915000000000000000",
    oracle: "0x7E333f1f6CdF5F96fa08D4BFc836d6b0CA4A7567",
    loanToken: {
      address: "0xA0b86991c6218b36c1d19D4a2e9Eb0cE3606eB48",
      symbol: "USDC",
    },
    collateralToken: {
      address: "0xb95c605635a3486d0A346CA790095d729F186E58",
      symbol: "PENDLE-LPT-WRAPPED",
    },
  },
  {
    id: "0x5242d93cc2ced1450bad362dd5f582b797a4dd693c3269c583cafad80d49e24b",
    name: "USDC / LBTC",
    irm: "0x870aC11D48B15DB9a138Cf899d20F13F79Ba00BC",
    lltv: "860000000000000000",
    oracle: "0x85F74F58d21E7EB0991774fE7b89b930b60cBba6",
    loanToken: {
      address: "0xA0b86991c6218b36c1d19D4a2e9Eb0cE3606eB48",
      symbol: "USDC",
    },
    collateralToken: {
      address: "0x8236a87084f8B84306f72007F36F2618A5634494",
      symbol: "LBTC",
    },
  },
  {
    id: "0xe3004c6bb58319a0d6601c267a3f7cc3af71fc05f96cb1f3ec67dc23c985ed33",
    name: "USDC / cbBTC",
    irm: "0x870aC11D48B15DB9a138Cf899d20F13F79Ba00BC",
    lltv: "860000000000000000",
    oracle: "0x66e4fDF062c51F2F6950e329a8F19a0E67dD92d6",
    loanToken: {
      address: "0xA0b86991c6218b36c1d19D4a2e9Eb0cE3606eB48",
      symbol: "USDC",
    },
    collateralToken: {
      address: "0xcbB7C0000aB88B473b1f5aFd9ef808440eed33Bf",
      symbol: "cbBTC",
    },
  },
  {
    id: "0x292901e42af7fa47290845357e6b827b711824ce54d4015283651e2f4f385da6",
    name: "USDC / MORPHO",
    irm: "0x870aC11D48B15DB9a138Cf899d20F13F79Ba00BC",
    lltv: "385000000000000000",
    oracle: "0xf093eE422C976D2289FC654b69EF87B9B645edb8",
    loanToken: {
      address: "0xA0b86991c6218b36c1d19D4a2e9Eb0cE3606eB48",
      symbol: "USDC",
    },
    collateralToken: {
      address: "0x58D97B57BB95320F9a05dC918Aef65434969c2B2",
      symbol: "MORPHO",
    },
  },
  {
    id: "0x1e9d614631a7df0ec07fb05b2c8cb2491575fd1a63a33bf187a6afb295a4fc64",
    name: "USDC / PT-reUSD-10DEC2026",
    irm: "0x870aC11D48B15DB9a138Cf899d20F13F79Ba00BC",
    lltv: "915000000000000000",
    oracle: "0x217d6DdCDB95112C51657F6270e8C079CFDB51f0",
    loanToken: {
      address: "0xA0b86991c6218b36c1d19D4a2e9Eb0cE3606eB48",
      symbol: "USDC",
    },
    collateralToken: {
      address: "0xeCfaFdC7741323a945A163ed068B5a3C43483957",
      symbol: "PT-reUSD-10DEC2026",
    },
  },
  {
    id: "0xccb4aaf943ea1fca0bfeab669d2cc4eef091a06682c3e58c248b6a9e35b7a6de",
    name: "USDC / PT-SY wstUSR-25JUN2026",
    irm: "0x870aC11D48B15DB9a138Cf899d20F13F79Ba00BC",
    lltv: "915000000000000000",
    oracle: "0x5F51A2C3E0178a360Ce2BDE42B08DB369f30268E",
    loanToken: {
      address: "0xA0b86991c6218b36c1d19D4a2e9Eb0cE3606eB48",
      symbol: "USDC",
    },
    collateralToken: {
      address: "0x90A2d7A50692f2620b467747A32CFa61889997B1",
      symbol: "PT-SY wstUSR-25JUN2026",
    },
  },
  {
    id: "0x354c1d720e5939819d37b07c63fadea3bdfef6a9fea3422c685adf8daf0132dd",
    name: "USDC / PT-stcUSD-23JUL2026",
    irm: "0x870aC11D48B15DB9a138Cf899d20F13F79Ba00BC",
    lltv: "915000000000000000",
    oracle: "0xA69760E3b8EA0A59eFaf22178690216597315b73",
    loanToken: {
      address: "0xA0b86991c6218b36c1d19D4a2e9Eb0cE3606eB48",
      symbol: "USDC",
    },
    collateralToken: {
      address: "0x2d3C279E5FcDF5b793c0a75ed90738D7369B0b83",
      symbol: "PT-stcUSD-23JUL2026",
    },
  },
  {
    id: "0x6acd18854e43f93f5a90446004c35c72a68af1ad99f08cb247782ce6457914ca",
    name: "USDT / PT-reUSD-10DEC2026",
    irm: "0x870aC11D48B15DB9a138Cf899d20F13F79Ba00BC",
    lltv: "915000000000000000",
    oracle: "0x217d6DdCDB95112C51657F6270e8C079CFDB51f0",
    loanToken: {
      address: "0xdAC17F958D2ee523a2206206994597C13D831ec7",
      symbol: "USDT",
    },
    collateralToken: {
      address: "0xeCfaFdC7741323a945A163ed068B5a3C43483957",
      symbol: "PT-reUSD-10DEC2026",
    },
  },
  {
    id: "0x6b52b01a57cb5b6d4d22ad6025c87c387dfa2cc8e416e61b20eb4f8826b7a070",
    name: "USDT / stcUSD",
    irm: "0x870aC11D48B15DB9a138Cf899d20F13F79Ba00BC",
    lltv: "915000000000000000",
    oracle: "0xb1a30794bB7B5D6D10Acc7A59aF664100ca77Cf1",
    loanToken: {
      address: "0xdAC17F958D2ee523a2206206994597C13D831ec7",
      symbol: "USDT",
    },
    collateralToken: {
      address: "0x88887bE419578051FF9F4eb6C858A951921D8888",
      symbol: "stcUSD",
    },
  },
  {
    id: "0x7559acbcb98c2e10bc157ffb52c71687981cde4bed78861bfd1199da9eff9cd8",
    name: "USDT / USD0++",
    irm: "0x870aC11D48B15DB9a138Cf899d20F13F79Ba00BC",
    lltv: "860000000000000000",
    oracle: "0x1325Eb089Ac14B437E78D5D481e32611F6907eF8",
    loanToken: {
      address: "0xdAC17F958D2ee523a2206206994597C13D831ec7",
      symbol: "USDT",
    },
    collateralToken: {
      address: "0x35D8949372D46B7a3D5A56006AE77B215fc69bC0",
      symbol: "USD0++",
    },
  },
  {
    id: "0xdbe1255c018c911753accc6678f07e83690f7e9c539a45fbf1d1e821173f3f84",
    name: "DAI / CANA",
    irm: "0x870aC11D48B15DB9a138Cf899d20F13F79Ba00BC",
    lltv: "860000000000000000",
    oracle: "0x756351dcBc53477124A7324EB024B3616Bb7FF50",
    loanToken: {
      address: "0x6B175474E89094C44Da98b954EedeAC495271d0F",
      symbol: "DAI",
    },
    collateralToken: {
      address: "0x01995A697752266d8E748738aAa3F06464B8350B",
      symbol: "CANA",
    },
  },
  {
    id: "0xefcc25ddfb12eec31cc3fd568ed04b4eb568a332600df308d09dbda248edf72e",
    name: "WETH / sDAI",
    irm: "0x870aC11D48B15DB9a138Cf899d20F13F79Ba00BC",
    lltv: "860000000000000000",
    oracle: "0x89064883cf21BD8977fCfFd326E75805dc47b3d9",
    loanToken: {
      address: "0xC02aaA39b223FE8D0A0e5C4F27eAD9083C756Cc2",
      symbol: "WETH",
    },
    collateralToken: {
      address: "0x83F20F44975D03b1b09e64809B757c47f942BEeA",
      symbol: "sDAI",
    },
  },
  {
    id: "0xbf532b96536406e273a8c3d260d898d98e8692818855deddbd8d228e47ecfff3",
    name: "USDC / USDe",
    irm: "0x870aC11D48B15DB9a138Cf899d20F13F79Ba00BC",
    lltv: "860000000000000000",
    oracle: "0xaE4750d0813B5E37A51f7629beedd72AF1f9cA35",
    loanToken: {
      address: "0xA0b86991c6218b36c1d19D4a2e9Eb0cE3606eB48",
      symbol: "USDC",
    },
    collateralToken: {
      address: "0x4c9EDD5852cd905f086C759E8383e09bff1E68B3",
      symbol: "USDe",
    },
  },
  {
    id: "0xb9c683303636f1907455ac7c10358ac95b1b61df2d2f972545bed0b9d02d8fdc",
    name: "PYUSD / cbBTC",
    irm: "0x870aC11D48B15DB9a138Cf899d20F13F79Ba00BC",
    lltv: "860000000000000000",
    oracle: "0xA6D6950c9F177F1De7f7757FB33539e3Ec60182a",
    loanToken: {
      address: "0x6c3ea9036406852006290770BEdFcAbA0e23A0e8",
      symbol: "PYUSD",
    },
    collateralToken: {
      address: "0xcbB7C0000aB88B473b1f5aFd9ef808440eed33Bf",
      symbol: "cbBTC",
    },
  },
  {
    id: "0x3d8cbe1beee969b8cd1afce485d05b4ff1fa57ebff4eb089a88024e2e585c93d",
    name: "USDe / CANA",
    irm: "0x870aC11D48B15DB9a138Cf899d20F13F79Ba00BC",
    lltv: "860000000000000000",
    oracle: "0xB06e5A64D5d74B317072F58Cd04841372a6E1De3",
    loanToken: {
      address: "0x4c9EDD5852cd905f086C759E8383e09bff1E68B3",
      symbol: "USDe",
    },
    collateralToken: {
      address: "0x01995A697752266d8E748738aAa3F06464B8350B",
      symbol: "CANA",
    },
  },
  {
    id: "0xd5321763d16eaeaf96340c37f463ee02a7b9f83e304defb42db24def46401a8e",
    name: "USDC / USDT",
    irm: "0x870aC11D48B15DB9a138Cf899d20F13F79Ba00BC",
    lltv: "980000000000000000",
    oracle: "0xEdBDe08315B42D6Cec812eCeBF355ec7005291C8",
    loanToken: {
      address: "0xA0b86991c6218b36c1d19D4a2e9Eb0cE3606eB48",
      symbol: "USDC",
    },
    collateralToken: {
      address: "0xdAC17F958D2ee523a2206206994597C13D831ec7",
      symbol: "USDT",
    },
  },
  {
    id: "0x16ea90f0988eec0f1151a4175c0d8231da70568f66bf3902cad6d533479f382f",
    name: "USDC / msY",
    irm: "0x870aC11D48B15DB9a138Cf899d20F13F79Ba00BC",
    lltv: "915000000000000000",
    oracle: "0xcB62f468B5724B7748293fc78E42C3DA840a8338",
    loanToken: {
      address: "0xA0b86991c6218b36c1d19D4a2e9Eb0cE3606eB48",
      symbol: "USDC",
    },
    collateralToken: {
      address: "0x890A5122Aa1dA30fEC4286DE7904Ff808F0bd74A",
      symbol: "msY",
    },
  },
  {
    id: "0xa6a83a7256d5ba5cfb4da63d8aa0188458a8f1cbc7739efa02cdaaaeab67793e",
    name: "EURC / cbBTC",
    irm: "0x870aC11D48B15DB9a138Cf899d20F13F79Ba00BC",
    lltv: "860000000000000000",
    oracle: "0xe7F21a6f85A30e56cc5B6bdCF63665FA468fa196",
    loanToken: {
      address: "0x1aBaEA1f7C830bD89Acc67eC4af516284b1bC33c",
      symbol: "EURC",
    },
    collateralToken: {
      address: "0xcbB7C0000aB88B473b1f5aFd9ef808440eed33Bf",
      symbol: "cbBTC",
    },
  },
  {
    id: "0x20b6f886adc8ee6aa80c4407e3f3b5d6ce4e53981852e878b06f368daf6aa163",
    name: "EURC / cbBTC",
    irm: "0x870aC11D48B15DB9a138Cf899d20F13F79Ba00BC",
    lltv: "860000000000000000",
    oracle: "0xdccDE6454736d3C935DB9a20fB9c2595858ed24F",
    loanToken: {
      address: "0x1aBaEA1f7C830bD89Acc67eC4af516284b1bC33c",
      symbol: "EURC",
    },
    collateralToken: {
      address: "0xcbB7C0000aB88B473b1f5aFd9ef808440eed33Bf",
      symbol: "cbBTC",
    },
  },
  {
    id: "0xa0156d9555e70628f70b4dc0a3ac627f011aafcdb6aca1a20b5258300b345831",
    name: "USDC / yoUSD",
    irm: "0x870aC11D48B15DB9a138Cf899d20F13F79Ba00BC",
    lltv: "860000000000000000",
    oracle: "0xe3FD2b17A88679fBB802fb70c6Df98De921eA4da",
    loanToken: {
      address: "0xA0b86991c6218b36c1d19D4a2e9Eb0cE3606eB48",
      symbol: "USDC",
    },
    collateralToken: {
      address: "0x0000000f2eB9f69274678c76222B35eEc7588a65",
      symbol: "yoUSD",
    },
  },
  {
    id: "0x34784cde86bea85d8bd03caacd89d4dd000a38349925e85a3d79550d58b8d82d",
    name: "EURC / steakUSDC",
    irm: "0x870aC11D48B15DB9a138Cf899d20F13F79Ba00BC",
    lltv: "915000000000000000",
    oracle: "0x6A8dc45e4c7512740D5371d7BDd7A4b38A8227EC",
    loanToken: {
      address: "0x1aBaEA1f7C830bD89Acc67eC4af516284b1bC33c",
      symbol: "EURC",
    },
    collateralToken: {
      address: "0xbeef088055857739C12CD3765F20b7679Def0f51",
      symbol: "steakUSDC",
    },
  },
  {
    id: "0xe6d7554fd20769b5ee59ff8608bc4f8dd7eb3aedb00e65c8184fb953e8af159a",
    name: "USDC / unknown",
    irm: "0x870aC11D48B15DB9a138Cf899d20F13F79Ba00BC",
    lltv: "945000000000000000",
    oracle: "0xCc00d98162fEf57d6A1057a36C25D5326e3805c8",
    loanToken: {
      address: "0xA0b86991c6218b36c1d19D4a2e9Eb0cE3606eB48",
      symbol: "USDC",
    },
    collateralToken: {
      address: "0x3975ad8A782e26C63BE015FE42CAB11D4BB4814F",
      symbol: "unknown",
    },
  },
  {
    id: "0x9ff17ee333e340b4f833ba0ba36899a44ea6808ea2d739928f80fec89cf7ba2e",
    name: "USDC / unknown",
    irm: "0x870aC11D48B15DB9a138Cf899d20F13F79Ba00BC",
    lltv: "945000000000000000",
    oracle: "0x22ec58046c98933bE51c1DF5C165Ae8cb2fc3B36",
    loanToken: {
      address: "0xA0b86991c6218b36c1d19D4a2e9Eb0cE3606eB48",
      symbol: "USDC",
    },
    collateralToken: {
      address: "0xC3361F107c0b82864D5B100A2f3C3E0a1a3586DA",
      symbol: "unknown",
    },
  },
  {
    id: "0x9803506296436f42ab78a8de7ba9b2fe5fa07adc2b70bb47007e43981b4c01d1",
    name: "USDC / unknown",
    irm: "0x870aC11D48B15DB9a138Cf899d20F13F79Ba00BC",
    lltv: "945000000000000000",
    oracle: "0x06613Ebbf04d8FCB592746d556E946b4cfb8D14F",
    loanToken: {
      address: "0xA0b86991c6218b36c1d19D4a2e9Eb0cE3606eB48",
      symbol: "USDC",
    },
    collateralToken: {
      address: "0xB5879522992cF7A20c8e8041CEEeb82697bd255C",
      symbol: "unknown",
    },
  },
  {
    id: "0x3d6e82f0537b9529dacf657db264842c3e993d3adeb632945acfb82238c9e872",
    name: "USDC / unknown",
    irm: "0x870aC11D48B15DB9a138Cf899d20F13F79Ba00BC",
    lltv: "945000000000000000",
    oracle: "0xE31cDBa141AEE85C188aF0326414348ac430a08b",
    loanToken: {
      address: "0xA0b86991c6218b36c1d19D4a2e9Eb0cE3606eB48",
      symbol: "USDC",
    },
    collateralToken: {
      address: "0x15Fdf122152642048f797e57Ca8Fff8986192BE5",
      symbol: "unknown",
    },
  },
  {
    id: "0x9c1f0e3cb1c0b7ecbecf983e8ebe7c81599b3fb4c3a60b6a39fa03fc1ba5dc8e",
    name: "USDC / stakedao-llsreUSD",
    irm: "0x870aC11D48B15DB9a138Cf899d20F13F79Ba00BC",
    lltv: "945000000000000000",
    oracle: "0xCc00d98162fEf57d6A1057a36C25D5326e3805c8",
    loanToken: {
      address: "0xA0b86991c6218b36c1d19D4a2e9Eb0cE3606eB48",
      symbol: "USDC",
    },
    collateralToken: {
      address: "0x6aEe69A11D5fB0e71c813Fe8419D84b12FB11FdA",
      symbol: "stakedao-llsreUSD",
    },
  },
  {
    id: "0x28e2f0cb2cfb2f7fdcf70ab257f6ed52ab2532d454e7792583afd3402f672698",
    name: "USDC / jrUSDe",
    irm: "0x870aC11D48B15DB9a138Cf899d20F13F79Ba00BC",
    lltv: "860000000000000000",
    oracle: "0xb847B24b5D13C3F67347005c9B57074b01978bAA",
    loanToken: {
      address: "0xA0b86991c6218b36c1d19D4a2e9Eb0cE3606eB48",
      symbol: "USDC",
    },
    collateralToken: {
      address: "0xC58D044404d8B14e953C115E67823784dEA53d8F",
      symbol: "jrUSDe",
    },
  },
  {
    id: "0xc22ef501c05e41c41afcafdabbfd7c33f4b2e2ba327544571b050343d6b200ec",
    name: "USDC / msY",
    irm: "0x870aC11D48B15DB9a138Cf899d20F13F79Ba00BC",
    lltv: "860000000000000000",
    oracle: "0xcB62f468B5724B7748293fc78E42C3DA840a8338",
    loanToken: {
      address: "0xA0b86991c6218b36c1d19D4a2e9Eb0cE3606eB48",
      symbol: "USDC",
    },
    collateralToken: {
      address: "0x890A5122Aa1dA30fEC4286DE7904Ff808F0bd74A",
      symbol: "msY",
    },
  },
  {
    id: "0x5ea4bd9031b9daf7c0c6bf19f6e699615a4ee464624fa5802a91572a67a11a68",
    name: "USDC / hgETH",
    irm: "0x870aC11D48B15DB9a138Cf899d20F13F79Ba00BC",
    lltv: "860000000000000000",
    oracle: "0x9E5748365D17E49f5a421237884791C27DBa0448",
    loanToken: {
      address: "0xA0b86991c6218b36c1d19D4a2e9Eb0cE3606eB48",
      symbol: "USDC",
    },
    collateralToken: {
      address: "0xc824A08dB624942c5E5F330d56530cD1598859fD",
      symbol: "hgETH",
    },
  },
  {
    id: "0xf9e56386e74f06af6099340525788eec624fd9c0fc0ad9a647702d3f75e3b6a9",
    name: "USDT / csUSDL",
    irm: "0x870aC11D48B15DB9a138Cf899d20F13F79Ba00BC",
    lltv: "965000000000000000",
    oracle: "0xbBCF7d1247583049722c79bA4249bEb188c37a33",
    loanToken: {
      address: "0xdAC17F958D2ee523a2206206994597C13D831ec7",
      symbol: "USDT",
    },
    collateralToken: {
      address: "0xbEeFc011e94f43b8B7b455eBaB290C7Ab4E216f1",
      symbol: "csUSDL",
    },
  },
  {
    id: "0x66cd49c47e1178e2c446ea9ebb94cc4b0a98448b1616c471a0733c23e98d658d",
    name: "USDC / PT-srUSDe-2APR2026",
    irm: "0x870aC11D48B15DB9a138Cf899d20F13F79Ba00BC",
    lltv: "915000000000000000",
    oracle: "0x0fcb5EA4CD4438562404DE0edB777Fe9faEAABE6",
    loanToken: {
      address: "0xA0b86991c6218b36c1d19D4a2e9Eb0cE3606eB48",
      symbol: "USDC",
    },
    collateralToken: {
      address: "0x9Bf45ab47747F4B4dD09B3C2c73953484b4eB375",
      symbol: "PT-srUSDe-2APR2026",
    },
  },
  {
    id: "0xb600c99775e4e24c78273aed3336887a51f97169ebb0732a2c67944fcec1f3ac",
    name: "USDC / savUSDUSDC",
    irm: "0x870aC11D48B15DB9a138Cf899d20F13F79Ba00BC",
    lltv: "945000000000000000",
    oracle: "0x0CF14B486d41A165067AAa8d1913302571FA9bb1",
    loanToken: {
      address: "0xA0b86991c6218b36c1d19D4a2e9Eb0cE3606eB48",
      symbol: "USDC",
    },
    collateralToken: {
      address: "0x1B91ADD55CD43068bD4ca64Fb6C5ca0439Dc9622",
      symbol: "savUSDUSDC",
    },
  },
  {
    id: "0x19eb5bb9a8a686748d686deef2b6089ce0b61568a68947d5a1006cc0c4c4e67b",
    name: "USDC / bbqUSDCturbo",
    irm: "0x870aC11D48B15DB9a138Cf899d20F13F79Ba00BC",
    lltv: "915000000000000000",
    oracle: "0xcEB6017685e28Ee3eB3650890fc5af932E910FA2",
    loanToken: {
      address: "0xA0b86991c6218b36c1d19D4a2e9Eb0cE3606eB48",
      symbol: "USDC",
    },
    collateralToken: {
      address: "0xBEEFFF4716a49418D69c251cab8759bB107e57C8",
      symbol: "bbqUSDCturbo",
    },
  },
  {
    id: "0x9c77e1b1d7ecc1de0b1f52c0a0ffe39d62edec877bdf87d8f324e1ff0c47f841",
    name: "USDC / savUSD",
    irm: "0x870aC11D48B15DB9a138Cf899d20F13F79Ba00BC",
    lltv: "915000000000000000",
    oracle: "0xb4DCdafF1f508FA65fBbC8C8bD09b09F531FA883",
    loanToken: {
      address: "0xA0b86991c6218b36c1d19D4a2e9Eb0cE3606eB48",
      symbol: "USDC",
    },
    collateralToken: {
      address: "0xb8D89678E75a973E74698c976716308abB8a46A4",
      symbol: "savUSD",
    },
  },
  {
    id: "0x0bba30ca7699761242662b41d91fcba0d05b5ba547ec47e1d66c0896c0abdc96",
    name: "WETH / cbBTC",
    irm: "0x870aC11D48B15DB9a138Cf899d20F13F79Ba00BC",
    lltv: "915000000000000000",
    oracle: "0xac21963fD5a4b477704EFC522c5670960941861F",
    loanToken: {
      address: "0xC02aaA39b223FE8D0A0e5C4F27eAD9083C756Cc2",
      symbol: "WETH",
    },
    collateralToken: {
      address: "0xcbB7C0000aB88B473b1f5aFd9ef808440eed33Bf",
      symbol: "cbBTC",
    },
  },
  {
    id: "0xfd4079d94bfbd35545e3dadfe4101619db0946174357cbe8810fd8e8537a50cd",
    name: "USDC / mGLOBAL",
    irm: "0x870aC11D48B15DB9a138Cf899d20F13F79Ba00BC",
    lltv: "860000000000000000",
    oracle: "0x87633B7453604A46383c0EC726B784b8A1194E05",
    loanToken: {
      address: "0xA0b86991c6218b36c1d19D4a2e9Eb0cE3606eB48",
      symbol: "USDC",
    },
    collateralToken: {
      address: "0x7433806912Eae67919e66aea853d46Fa0aef98A8",
      symbol: "mGLOBAL",
    },
  },
  {
    id: "0x9ba3a3d0ec2886d41f4c7c93c72aaa77b2454e4d3db3603e37797c429d048cfb",
    name: "USDT / USD0++",
    irm: "0x870aC11D48B15DB9a138Cf899d20F13F79Ba00BC",
    lltv: "860000000000000000",
    oracle: "0x06B8e2c2133E41CDf962B3AeAE99F12E64E457da",
    loanToken: {
      address: "0xdAC17F958D2ee523a2206206994597C13D831ec7",
      symbol: "USDT",
    },
    collateralToken: {
      address: "0x35D8949372D46B7a3D5A56006AE77B215fc69bC0",
      symbol: "USD0++",
    },
  },
  {
    id: "0xbd13ede62af3ddfe55a4c054d855063c15598572f91c61c34046b60d6d7838f0",
    name: "USDT / PT-SY wstUSR-25JUN2026",
    irm: "0x870aC11D48B15DB9a138Cf899d20F13F79Ba00BC",
    lltv: "915000000000000000",
    oracle: "0x5F51A2C3E0178a360Ce2BDE42B08DB369f30268E",
    loanToken: {
      address: "0xdAC17F958D2ee523a2206206994597C13D831ec7",
      symbol: "USDT",
    },
    collateralToken: {
      address: "0x90A2d7A50692f2620b467747A32CFa61889997B1",
      symbol: "PT-SY wstUSR-25JUN2026",
    },
  },
  {
    id: "0x51acccb0bed9e030523974bfbd64b0c3089a7364bb8c75361b28cea731535f4a",
    name: "WETH / cbBTC",
    irm: "0x870aC11D48B15DB9a138Cf899d20F13F79Ba00BC",
    lltv: "915000000000000000",
    oracle: "0xDd8FcA2454fFD2D1D37C09Cc1dF7F4ba730baA1C",
    loanToken: {
      address: "0xC02aaA39b223FE8D0A0e5C4F27eAD9083C756Cc2",
      symbol: "WETH",
    },
    collateralToken: {
      address: "0xcbB7C0000aB88B473b1f5aFd9ef808440eed33Bf",
      symbol: "cbBTC",
    },
  },
  {
    id: "0x0327849f3c97e7e94825211efdd26c421e1d0c68415ae0c367f77cf4d773d7f2",
    name: "WETH / LsETH",
    irm: "0x870aC11D48B15DB9a138Cf899d20F13F79Ba00BC",
    lltv: "945000000000000000",
    oracle: "0x756F5d3735Aa73740A4461f017529afDDfa3AB8a",
    loanToken: {
      address: "0xC02aaA39b223FE8D0A0e5C4F27eAD9083C756Cc2",
      symbol: "WETH",
    },
    collateralToken: {
      address: "0x8c1BEd5b9a0928467c9B1341Da1D7BD5e10b6549",
      symbol: "LsETH",
    },
  },
  {
    id: "0x6f252f8726c705af2caa40b97a1b0458db0dd84722a3405c55379fc809c3bd6c",
    name: "USDT / PENDLE-LPT-WRAPPED",
    irm: "0x870aC11D48B15DB9a138Cf899d20F13F79Ba00BC",
    lltv: "915000000000000000",
    oracle: "0x09592d0cd70adbB7B25729aEE8Fb9979999DBF95",
    loanToken: {
      address: "0xdAC17F958D2ee523a2206206994597C13D831ec7",
      symbol: "USDT",
    },
    collateralToken: {
      address: "0x380c355FAA9B6696C2434314f10f9a2Ce451d15a",
      symbol: "PENDLE-LPT-WRAPPED",
    },
  },
  {
    id: "0x80fea13225f27a1f4798c35d89e791711f963ed74eb3a86bcaffe28143095e94",
    name: "PYUSD / PT-sUSDE-13AUG2026",
    irm: "0x870aC11D48B15DB9a138Cf899d20F13F79Ba00BC",
    lltv: "915000000000000000",
    oracle: "0x7560CaC78c21F882d33355C45a44835653f69ec2",
    loanToken: {
      address: "0x6c3ea9036406852006290770BEdFcAbA0e23A0e8",
      symbol: "PYUSD",
    },
    collateralToken: {
      address: "0x5A19fa369F2895dCD8d2cEE62E4Ceae58eF92BBb",
      symbol: "PT-sUSDE-13AUG2026",
    },
  },
  {
    id: "0x2b8019e6b9bd3a6cb615c5ff73c21bb514cdbc30d1f7a797c082e5975500ef4b",
    name: "USDT / cbBTC",
    irm: "0x870aC11D48B15DB9a138Cf899d20F13F79Ba00BC",
    lltv: "860000000000000000",
    oracle: "0x76d14b72A9468c2895f8697AF71294e32b1B7249",
    loanToken: {
      address: "0xdAC17F958D2ee523a2206206994597C13D831ec7",
      symbol: "USDT",
    },
    collateralToken: {
      address: "0xcbB7C0000aB88B473b1f5aFd9ef808440eed33Bf",
      symbol: "cbBTC",
    },
  },
  {
    id: "0xfa5b0b24e68c993c1df02bcd6c1c774a9d3e4b311967d94ad1f2d0fee8f82a86",
    name: "USDC / PT-mHYPER-29JAN2026",
    irm: "0x870aC11D48B15DB9a138Cf899d20F13F79Ba00BC",
    lltv: "860000000000000000",
    oracle: "0x41E2C788DaEF91a5BA86c7bD6cA5b064dE7B91EB",
    loanToken: {
      address: "0xA0b86991c6218b36c1d19D4a2e9Eb0cE3606eB48",
      symbol: "USDC",
    },
    collateralToken: {
      address: "0x9079E3Af3ee265c8C49A75670dB2A02Bbfb8E822",
      symbol: "PT-mHYPER-29JAN2026",
    },
  },
  {
    id: "0xe51cc5a39bef425e4ceb3d187b554bc054af0853b95bab8670c53f74125f6672",
    name: "USDC / oBTC",
    irm: "0x870aC11D48B15DB9a138Cf899d20F13F79Ba00BC",
    lltv: "860000000000000000",
    oracle: "0xA6D6950c9F177F1De7f7757FB33539e3Ec60182a",
    loanToken: {
      address: "0xA0b86991c6218b36c1d19D4a2e9Eb0cE3606eB48",
      symbol: "USDC",
    },
    collateralToken: {
      address: "0x9f14f9F28c73a702CDf5887F97FF40cad25dfC10",
      symbol: "oBTC",
    },
  },
  {
    id: "0x5baddd7c6613f8814d0d2a12ea7dfe2e50fb7723eeb082d2f2c4cdad3ec91560",
    name: "DAI / PT-sUSDE-24OCT2024",
    irm: "0x870aC11D48B15DB9a138Cf899d20F13F79Ba00BC",
    lltv: "860000000000000000",
    oracle: "0x5D916980D5Ae1737a8330Bf24dF812b2911Aae25",
    loanToken: {
      address: "0x6B175474E89094C44Da98b954EedeAC495271d0F",
      symbol: "DAI",
    },
    collateralToken: {
      address: "0xAE5099C39f023C91d3dd55244CAFB36225B0850E",
      symbol: "PT-sUSDE-24OCT2024",
    },
  },
  {
    id: "0x153dc0dea31d03870df5c82f4d149937495e6a9a701e887e65e445fe5b35e4fc",
    name: "WBTC / HemiCbWBTC",
    irm: "0x870aC11D48B15DB9a138Cf899d20F13F79Ba00BC",
    lltv: "945000000000000000",
    oracle: "0xCDd2eC85885478d5F035C7B562429d7C1e906939",
    loanToken: {
      address: "0x2260FAC5E5542a773Aa44fBCfeDf7C193bc2C599",
      symbol: "WBTC",
    },
    collateralToken: {
      address: "0x7D7C47c038446E65D77e785Ab1A3BF38B4e5cacc",
      symbol: "HemiCbWBTC",
    },
  },
  {
    id: "0x09786b3d012184d0f23b841db681097b585928278018b5d624ea7f57d48efe36",
    name: "USDC / SPYon",
    irm: "0x870aC11D48B15DB9a138Cf899d20F13F79Ba00BC",
    lltv: "625000000000000000",
    oracle: "0x3609077522F896707af2cE8f587B8260151a9502",
    loanToken: {
      address: "0xA0b86991c6218b36c1d19D4a2e9Eb0cE3606eB48",
      symbol: "USDC",
    },
    collateralToken: {
      address: "0xFeDC5f4a6c38211c1338aa411018DFAf26612c08",
      symbol: "SPYon",
    },
  },
  {
    id: "0xa7deb3feb35b61af19dcb51560236b80b613ac1b591d5ed9dc3b094bbf8f301a",
    name: "USDT / PT-tUSDe-18DEC2025",
    irm: "0x870aC11D48B15DB9a138Cf899d20F13F79Ba00BC",
    lltv: "915000000000000000",
    oracle: "0xE9D31eeFc1FFd963CC505ba8c242185636661945",
    loanToken: {
      address: "0xdAC17F958D2ee523a2206206994597C13D831ec7",
      symbol: "USDT",
    },
    collateralToken: {
      address: "0x1135b22d6e8FD0809392478eEDcd8c107dB6aF9D",
      symbol: "PT-tUSDe-18DEC2025",
    },
  },
  {
    id: "0xa69617cff423f2e8b2fe634fddb0f03015ee3cbed38992a2f0cc221e59ea4072",
    name: "USDC / iFALC",
    irm: "0x870aC11D48B15DB9a138Cf899d20F13F79Ba00BC",
    lltv: "860000000000000000",
    oracle: "0x3Bd893d7b1654B7F88bDCA87A274936dBc220E7e",
    loanToken: {
      address: "0xA0b86991c6218b36c1d19D4a2e9Eb0cE3606eB48",
      symbol: "USDC",
    },
    collateralToken: {
      address: "0xb530a1B5259A71187F1D69aCF0488F102637a3ED",
      symbol: "iFALC",
    },
  },
  {
    id: "0x80ad4aaa2cd5d3c2f9eba0bcf952c2a958d0e97542a709dea34bb150893cea14",
    name: "USDC / QQQon",
    irm: "0x870aC11D48B15DB9a138Cf899d20F13F79Ba00BC",
    lltv: "625000000000000000",
    oracle: "0x06387f461eE84956F3740E3C8CaeF03D914d7aF7",
    loanToken: {
      address: "0xA0b86991c6218b36c1d19D4a2e9Eb0cE3606eB48",
      symbol: "USDC",
    },
    collateralToken: {
      address: "0x0e397938C1Aa0680954093495B70A9F5e2249aBa",
      symbol: "QQQon",
    },
  },
  {
    id: "0x8b4497306e4ef6e4a61d8f1bd0965edfc14e0c92e1f45f6f7b7df65ef001827b",
    name: "WBTC / PT-corn-SolvBTC.BBN-26DEC2024",
    irm: "0x870aC11D48B15DB9a138Cf899d20F13F79Ba00BC",
    lltv: "860000000000000000",
    oracle: "0xE7F1f98334049253f295f0DC7d38Bbb9aFbC59cF",
    loanToken: {
      address: "0x2260FAC5E5542a773Aa44fBCfeDf7C193bc2C599",
      symbol: "WBTC",
    },
    collateralToken: {
      address: "0x23e479ddcda990E8523494895759bD98cD2fDBF6",
      symbol: "PT-corn-SolvBTC.BBN-26DEC2024",
    },
  },
  {
    id: "0x33778d3d3bfe5a6e2678e2aeecca65b819b594b3f646b6cdb0a245bbbbcb3a7f",
    name: "USDC / PT-alUSD-11DEC2025",
    irm: "0x870aC11D48B15DB9a138Cf899d20F13F79Ba00BC",
    lltv: "860000000000000000",
    oracle: "0xf3eE3D4056F74eF150d301B3514de4334314DFfa",
    loanToken: {
      address: "0xA0b86991c6218b36c1d19D4a2e9Eb0cE3606eB48",
      symbol: "USDC",
    },
    collateralToken: {
      address: "0xd2E230f71CA8DB211067BC4070A94D268b313fA3",
      symbol: "PT-alUSD-11DEC2025",
    },
  },
  {
    id: "0x48ad2c89e42c5e387280d0cc2935d6b71d428b4a0e012cf43a1a1aa2e65a1cf0",
    name: "USDe / PT-pUSDe-16OCT2025",
    irm: "0x870aC11D48B15DB9a138Cf899d20F13F79Ba00BC",
    lltv: "915000000000000000",
    oracle: "0x474279318E735cb95Febe0Ec817c7362b53Afbf7",
    loanToken: {
      address: "0x4c9EDD5852cd905f086C759E8383e09bff1E68B3",
      symbol: "USDe",
    },
    collateralToken: {
      address: "0xF3f491e5608f8B8a6Fd9E9d66a4a4036d7FD282C",
      symbol: "PT-pUSDe-16OCT2025",
    },
  },
  {
    id: "0xa44f90f459658de554346679e449b6166e76d03d9a97bc8573c7dec91c1dbf3a",
    name: "USDT / stUSD",
    irm: "0x870aC11D48B15DB9a138Cf899d20F13F79Ba00BC",
    lltv: "945000000000000000",
    oracle: "0xAb1Ee26435fB5E7b005A1d438336d80D097931e7",
    loanToken: {
      address: "0xdAC17F958D2ee523a2206206994597C13D831ec7",
      symbol: "USDT",
    },
    collateralToken: {
      address: "0x0022228a2cc5E7eF0274A7Baa600d44da5aB5776",
      symbol: "stUSD",
    },
  },
  {
    id: "0xa39263bf7275f772863c464ef4e9e972aaa0f1a6a1bf2a47f92bf57a542d2458",
    name: "WBTC / PT-LBTC-27MAR2025",
    irm: "0x870aC11D48B15DB9a138Cf899d20F13F79Ba00BC",
    lltv: "915000000000000000",
    oracle: "0xbeB935DC2ce0Bf829F37D7fb147144E7AF0a0D91",
    loanToken: {
      address: "0x2260FAC5E5542a773Aa44fBCfeDf7C193bc2C599",
      symbol: "WBTC",
    },
    collateralToken: {
      address: "0xEc5a52C685CC3Ad79a6a347aBACe330d69e0b1eD",
      symbol: "PT-LBTC-27MAR2025",
    },
  },
  {
    id: "0x711c3a1d9dd92be8b88e7c7dfc4324567820e945efd4f15a23dd512bf130aeac",
    name: "WETH / PT-beraSTONE-10APR2025",
    irm: "0x870aC11D48B15DB9a138Cf899d20F13F79Ba00BC",
    lltv: "915000000000000000",
    oracle: "0x78DF105DdA3B0aff024AD54B476d014C83cb798e",
    loanToken: {
      address: "0xC02aaA39b223FE8D0A0e5C4F27eAD9083C756Cc2",
      symbol: "WETH",
    },
    collateralToken: {
      address: "0x40b7B4aB1E95e28DF06971581276966FDF95688E",
      symbol: "PT-beraSTONE-10APR2025",
    },
  },
  {
    id: "0x550edc2e9fe71158ccfa7c478a31f4e60ef508d94ada3931dc2aee4f666f8f81",
    name: "USDC / yvUSDC-1",
    irm: "0x870aC11D48B15DB9a138Cf899d20F13F79Ba00BC",
    lltv: "915000000000000000",
    oracle: "0x5fAfC7A5A4b5d8cE966E0aAc62243A8c5A807f01",
    loanToken: {
      address: "0xA0b86991c6218b36c1d19D4a2e9Eb0cE3606eB48",
      symbol: "USDC",
    },
    collateralToken: {
      address: "0xBe53A109B494E5c9f97b9Cd39Fe969BE68BF6204",
      symbol: "yvUSDC-1",
    },
  },
  {
    id: "0x6e988863b5c88c6a0038e07f346d79a941ba30e6bab0e1267f3bcf72275d572a",
    name: "USDC / USDU",
    irm: "0x870aC11D48B15DB9a138Cf899d20F13F79Ba00BC",
    lltv: "915000000000000000",
    oracle: "0x1325Eb089Ac14B437E78D5D481e32611F6907eF8",
    loanToken: {
      address: "0xA0b86991c6218b36c1d19D4a2e9Eb0cE3606eB48",
      symbol: "USDC",
    },
    collateralToken: {
      address: "0xdde3eC717f220Fc6A29D6a4Be73F91DA5b718e55",
      symbol: "USDU",
    },
  },
  {
    id: "0x228eb4c7d01b0471de75b9b8548ba6fddd96a007a91cc50661a64ad52251ff81",
    name: "USDC / PT-cUSDO-28MAY2026",
    irm: "0x870aC11D48B15DB9a138Cf899d20F13F79Ba00BC",
    lltv: "915000000000000000",
    oracle: "0x831607731C1dA3697d752d0f40c1cF0968F14fEb",
    loanToken: {
      address: "0xA0b86991c6218b36c1d19D4a2e9Eb0cE3606eB48",
      symbol: "USDC",
    },
    collateralToken: {
      address: "0x67aEeEd39C1675e0Df93Ad8BaB543b17992d433B",
      symbol: "PT-cUSDO-28MAY2026",
    },
  },
  {
    id: "0xab4e2a2b60871cbbe808841b1debc1eea1a8a72a9a7bb03f9143a4fee87749fd",
    name: "WETH / EIGEN",
    irm: "0x870aC11D48B15DB9a138Cf899d20F13F79Ba00BC",
    lltv: "770000000000000000",
    oracle: "0xEBD18969356f629027cCdf69f42ce417b215ad58",
    loanToken: {
      address: "0xC02aaA39b223FE8D0A0e5C4F27eAD9083C756Cc2",
      symbol: "WETH",
    },
    collateralToken: {
      address: "0xec53bF9167f50cDEB3Ae105f56099aaaB9061F83",
      symbol: "EIGEN",
    },
  },
  {
    id: "0x584f1254a5a60cf3387f9f2bc67c7ad16ef491ee65784a484d4c9099030e8888",
    name: "wstETH / USDS",
    irm: "0x870aC11D48B15DB9a138Cf899d20F13F79Ba00BC",
    lltv: "860000000000000000",
    oracle: "0x73700AeDBB8C3C4692d820D0b9bCf45C38d0f091",
    loanToken: {
      address: "0x7f39C581F595B53c5cb19bD0b3f8dA6c935E2Ca0",
      symbol: "wstETH",
    },
    collateralToken: {
      address: "0xdC035D45d973E3EC169d2276DDab16f1e407384F",
      symbol: "USDS",
    },
  },
  {
    id: "0x278290bf72ec20495f3f57910bebac7f2f6a6aeff9e9d550f225b4ba26454fe0",
    name: "USDC / PT-USR-29MAY2025",
    irm: "0x870aC11D48B15DB9a138Cf899d20F13F79Ba00BC",
    lltv: "915000000000000000",
    oracle: "0x65b6FD971e1436130020a3531417f01De127a711",
    loanToken: {
      address: "0xA0b86991c6218b36c1d19D4a2e9Eb0cE3606eB48",
      symbol: "USDC",
    },
    collateralToken: {
      address: "0xae4bE3acD95B6a4Ac5A0524ab95dA90c721f6C83",
      symbol: "PT-USR-29MAY2025",
    },
  },
  {
    id: "0x93ebfc97672613e57af22b45decf9665a319d4960a81b21fd2a5cceddc75d9aa",
    name: "USDC / alUSD",
    irm: "0x870aC11D48B15DB9a138Cf899d20F13F79Ba00BC",
    lltv: "915000000000000000",
    oracle: "0xaBF6b27C4B8e49B9C6188B19819d1B0703C13983",
    loanToken: {
      address: "0xA0b86991c6218b36c1d19D4a2e9Eb0cE3606eB48",
      symbol: "USDC",
    },
    collateralToken: {
      address: "0xDCD0f5ab30856F28385F641580Bbd85f88349124",
      symbol: "alUSD",
    },
  },
  {
    id: "0xea023e57814fb9a814a5a9ee9f3e7ece5b771dd8cc703e50b911e9cde064a12d",
    name: "WETH / WOETH",
    irm: "0x870aC11D48B15DB9a138Cf899d20F13F79Ba00BC",
    lltv: "860000000000000000",
    oracle: "0xb7948b5bEEe825E609990484A99340D8767B420e",
    loanToken: {
      address: "0xC02aaA39b223FE8D0A0e5C4F27eAD9083C756Cc2",
      symbol: "WETH",
    },
    collateralToken: {
      address: "0xDcEe70654261AF21C44c093C300eD3Bb97b78192",
      symbol: "WOETH",
    },
  },
  {
    id: "0x30927a43c586652365f5e5b0aa3a0f4293b5db9405ef434d724f9f8174d074a7",
    name: "USDC / CarryTradeUSDTRYLeverage",
    irm: "0x870aC11D48B15DB9a138Cf899d20F13F79Ba00BC",
    lltv: "770000000000000000",
    oracle: "0xc69731B51C6dBb2fb818D8DB1F4116FB8A379288",
    loanToken: {
      address: "0xA0b86991c6218b36c1d19D4a2e9Eb0cE3606eB48",
      symbol: "USDC",
    },
    collateralToken: {
      address: "0x2bf11d2E04Bc40daa95c24B8b90EC4F5c57Dd326",
      symbol: "CarryTradeUSDTRYLeverage",
    },
  },
  {
    id: "0x29d646517e795e06b9b9eeb9975f4273dc9695cc70b9a195fa009a5172e18f19",
    name: "USDC / PT-USD3-29JAN2026",
    irm: "0x870aC11D48B15DB9a138Cf899d20F13F79Ba00BC",
    lltv: "915000000000000000",
    oracle: "0xfb064FE02Cc8AE0Dc6Cf0522ec92d1e9F82a0826",
    loanToken: {
      address: "0xA0b86991c6218b36c1d19D4a2e9Eb0cE3606eB48",
      symbol: "USDC",
    },
    collateralToken: {
      address: "0xe39d1D3CAcEA800fD5aFB87dD98A42a8a364da08",
      symbol: "PT-USD3-29JAN2026",
    },
  },
  {
    id: "0x9940da579c167e13a14f07ba4a38e54cb8fa2abb35a3976ec1af07f77e972268",
    name: "USDC / PT-wstUSR-27MAR2025",
    irm: "0x870aC11D48B15DB9a138Cf899d20F13F79Ba00BC",
    lltv: "915000000000000000",
    oracle: "0x5631200e3Fd465c42b4227819FD907AFA35e00C9",
    loanToken: {
      address: "0xA0b86991c6218b36c1d19D4a2e9Eb0cE3606eB48",
      symbol: "USDC",
    },
    collateralToken: {
      address: "0xA8c8861b5ccF8CCe0ade6811CD2A7A7d3222B0B8",
      symbol: "PT-wstUSR-27MAR2025",
    },
  },
  {
    id: "0xac3db6e1b107b3239c6356f7018058ba66dfc8bb9d619f90a567ca58d33ffa36",
    name: "USDC / sUSDU",
    irm: "0x870aC11D48B15DB9a138Cf899d20F13F79Ba00BC",
    lltv: "965000000000000000",
    oracle: "0x9301C2dD12552aD11Ce36DF5b53eA33818ad1165",
    loanToken: {
      address: "0xA0b86991c6218b36c1d19D4a2e9Eb0cE3606eB48",
      symbol: "USDC",
    },
    collateralToken: {
      address: "0xcE22b5Fb17ccbc0C5d87DC2e0dF47DD71E3AdC0a",
      symbol: "sUSDU",
    },
  },
  {
    id: "0xdb8938f97571aeab0deb0c34cf7e6278cff969538f49eebe6f4fc75a9a111293",
    name: "USDC / ETH+",
    irm: "0x870aC11D48B15DB9a138Cf899d20F13F79Ba00BC",
    lltv: "860000000000000000",
    oracle: "0x83Fb5ff55eAA528F0C0f95c3f270b85E5d094756",
    loanToken: {
      address: "0xA0b86991c6218b36c1d19D4a2e9Eb0cE3606eB48",
      symbol: "USDC",
    },
    collateralToken: {
      address: "0xE72B141DF173b999AE7c1aDcbF60Cc9833Ce56a8",
      symbol: "ETH+",
    },
  },
  {
    id: "0xa37bf4fe4141c5e33ec138e55184897ce873ea276872dd8259aa97b8149c6a07",
    name: "USDC / PT-alUSD-23OCT2025",
    irm: "0x870aC11D48B15DB9a138Cf899d20F13F79Ba00BC",
    lltv: "860000000000000000",
    oracle: "0xD53A8b8Da10aD5597F25296d33C969E40906FB21",
    loanToken: {
      address: "0xA0b86991c6218b36c1d19D4a2e9Eb0cE3606eB48",
      symbol: "USDC",
    },
    collateralToken: {
      address: "0x6645aa5A6F4ff29B30D53A483A02Acc2cb85B241",
      symbol: "PT-alUSD-23OCT2025",
    },
  },
  {
    id: "0xd9f7e73314bc8fa209afea85654ebf5441af3fb9409e3356f8dc582e9b6d0813",
    name: "USDC / PT-sw-RLP-1750896023",
    irm: "0x870aC11D48B15DB9a138Cf899d20F13F79Ba00BC",
    lltv: "915000000000000000",
    oracle: "0x794cA637aa2CfBF89808783B977abAbb5c2eDA84",
    loanToken: {
      address: "0xA0b86991c6218b36c1d19D4a2e9Eb0cE3606eB48",
      symbol: "USDC",
    },
    collateralToken: {
      address: "0x1F7Aa7104db822987E1F44A66dF709A8C4Fb301a",
      symbol: "PT-sw-RLP-1750896023",
    },
  },
  {
    id: "0x6cd5fd13ae90d2e4ecc70032e64ca48b263d94763168a7e7e11ecbf9dbe56c19",
    name: "USDC / wUSDM",
    irm: "0x870aC11D48B15DB9a138Cf899d20F13F79Ba00BC",
    lltv: "965000000000000000",
    oracle: "0x38Ed40ab78D2D00467CedD5B1631C040768cdfCa",
    loanToken: {
      address: "0xA0b86991c6218b36c1d19D4a2e9Eb0cE3606eB48",
      symbol: "USDC",
    },
    collateralToken: {
      address: "0x57F5E098CaD7A3D1Eed53991D4d66C45C9AF7812",
      symbol: "wUSDM",
    },
  },
  {
    id: "0x231bca4be855554a2dcd22b56e4e1828b1038b19b4f7632333baf9fc1204155d",
    name: "USDT / wUSDM",
    irm: "0x870aC11D48B15DB9a138Cf899d20F13F79Ba00BC",
    lltv: "965000000000000000",
    oracle: "0x38Ed40ab78D2D00467CedD5B1631C040768cdfCa",
    loanToken: {
      address: "0xdAC17F958D2ee523a2206206994597C13D831ec7",
      symbol: "USDT",
    },
    collateralToken: {
      address: "0x57F5E098CaD7A3D1Eed53991D4d66C45C9AF7812",
      symbol: "wUSDM",
    },
  },
  {
    id: "0xcc611d3ca8ce8dcc63e4e8c3cd17c9acb2ca1768eeb143b71e2dc8e6a98c3f65",
    name: "USDC / PT-RLP-4SEP2025",
    irm: "0x870aC11D48B15DB9a138Cf899d20F13F79Ba00BC",
    lltv: "860000000000000000",
    oracle: "0xe1B4af0d9D73CAb204De39e1c798F26c3891Be27",
    loanToken: {
      address: "0xA0b86991c6218b36c1d19D4a2e9Eb0cE3606eB48",
      symbol: "USDC",
    },
    collateralToken: {
      address: "0x742B4166878Bfd339Db65a29a17E49b81a6B6Aac",
      symbol: "PT-RLP-4SEP2025",
    },
  },
  {
    id: "0xc3250fa72657f5d956a55fd7febf5bf953c18aa04bff2e4088415b1e5c2923b0",
    name: "WETH / PT-rsETH-26JUN2025",
    irm: "0x870aC11D48B15DB9a138Cf899d20F13F79Ba00BC",
    lltv: "915000000000000000",
    oracle: "0x7b27e8a778818e6767A93381e397EaCe3B8f80a2",
    loanToken: {
      address: "0xC02aaA39b223FE8D0A0e5C4F27eAD9083C756Cc2",
      symbol: "WETH",
    },
    collateralToken: {
      address: "0xE08C45F3cfE70f4e03668Dc6E84Af842bEE95A68",
      symbol: "PT-rsETH-26JUN2025",
    },
  },
  {
    id: "0xe583bbc1382a94b2438c3bc132ce1227700f0f791ce90226b189ba6cb5449dfd",
    name: "JPYC / USDC",
    irm: "0x870aC11D48B15DB9a138Cf899d20F13F79Ba00BC",
    lltv: "915000000000000000",
    oracle: "0x9F40c1d2354eD374f8c6A6B09A1B5cf3Da659D1f",
    loanToken: {
      address: "0xE7C3D8C9a439feDe00D2600032D5dB0Be71C3c29",
      symbol: "JPYC",
    },
    collateralToken: {
      address: "0xA0b86991c6218b36c1d19D4a2e9Eb0cE3606eB48",
      symbol: "USDC",
    },
  },
  {
    id: "0xe161f2204b2d5a356a91c324e1a77d791da217fdec6b52a84b5b9e0b56516413",
    name: "USDC / PT-USR-4SEP2025",
    irm: "0x870aC11D48B15DB9a138Cf899d20F13F79Ba00BC",
    lltv: "915000000000000000",
    oracle: "0xB49e92DD51Fa1E75D23Bc70EF71Fc37e3A030494",
    loanToken: {
      address: "0xA0b86991c6218b36c1d19D4a2e9Eb0cE3606eB48",
      symbol: "USDC",
    },
    collateralToken: {
      address: "0x5a5b93F762739fa94F3EcC0b34Af2e56702E7f70",
      symbol: "PT-USR-4SEP2025",
    },
  },
  {
    id: "0x6920dba94e92cec814cb2be2d5817e6d959ca750c71bd6973402c8a2372ea21b",
    name: "USDC / PT-USR-4DEC2025",
    irm: "0x870aC11D48B15DB9a138Cf899d20F13F79Ba00BC",
    lltv: "915000000000000000",
    oracle: "0x7D516d206AE898D9b4Bea6498DB0f1fDB629828d",
    loanToken: {
      address: "0xA0b86991c6218b36c1d19D4a2e9Eb0cE3606eB48",
      symbol: "USDC",
    },
    collateralToken: {
      address: "0x23e0D07095DAec91B6Ae016cA9F08222dCc64c49",
      symbol: "PT-USR-4DEC2025",
    },
  },
  {
    id: "0x710f43275b69b99f2ab64588a9602d72745ab707e4e82fc175ce3d18984168ae",
    name: "USR / wstETH",
    irm: "0x870aC11D48B15DB9a138Cf899d20F13F79Ba00BC",
    lltv: "860000000000000000",
    oracle: "0x16F4cC0fC967aC05D4f8757c5DF16788A4b04A24",
    loanToken: {
      address: "0x66a1E37c9b0eAddca17d3662D6c05F4DECf3e110",
      symbol: "USR",
    },
    collateralToken: {
      address: "0x7f39C581F595B53c5cb19bD0b3f8dA6c935E2Ca0",
      symbol: "wstETH",
    },
  },
  {
    id: "0x19c1e2ce49350437d56f6059a8654540548e168d70b5f272f9e8e1f5472dbbe1",
    name: "WETH / PT-DETH-29JAN2026",
    irm: "0x870aC11D48B15DB9a138Cf899d20F13F79Ba00BC",
    lltv: "915000000000000000",
    oracle: "0x195199ba563C1e3c4FB24a8Ca0107C1c7F81da1d",
    loanToken: {
      address: "0xC02aaA39b223FE8D0A0e5C4F27eAD9083C756Cc2",
      symbol: "WETH",
    },
    collateralToken: {
      address: "0x8209b01357946A64a0793e9773F6F3Fe5A5F2526",
      symbol: "PT-DETH-29JAN2026",
    },
  },
  {
    id: "0x609394de3f492816db0ea097bab22db5bcb0e4a9c3a073902438974705e09238",
    name: "USDe / PT-sUSDE-27NOV2025",
    irm: "0x870aC11D48B15DB9a138Cf899d20F13F79Ba00BC",
    lltv: "915000000000000000",
    oracle: "0xE2C6847e9f0aDd6f9Bf92A782C691d4EDeD69bb8",
    loanToken: {
      address: "0x4c9EDD5852cd905f086C759E8383e09bff1E68B3",
      symbol: "USDe",
    },
    collateralToken: {
      address: "0xe6A934089BBEe34F832060CE98848359883749B3",
      symbol: "PT-sUSDE-27NOV2025",
    },
  },
  {
    id: "0x1ca75949a91c157183f53282d73c37191e7cd84002310f6632047d874aad4a0f",
    name: "USDC / PT-mHYPER-20NOV2025",
    irm: "0x870aC11D48B15DB9a138Cf899d20F13F79Ba00BC",
    lltv: "860000000000000000",
    oracle: "0x8Ad7D0E0523555CEB9ba9ac4d3c90DF211F959bF",
    loanToken: {
      address: "0xA0b86991c6218b36c1d19D4a2e9Eb0cE3606eB48",
      symbol: "USDC",
    },
    collateralToken: {
      address: "0xE4d30cCF87Cb3E5E637b64A2EE21bD5d3901839A",
      symbol: "PT-mHYPER-20NOV2025",
    },
  },
  {
    id: "0x9fc79d4a7c4b0d51e41a7930e15b5187ec2c383215a28bb0b8576e658a6e89a1",
    name: "USDC / WETH",
    irm: "0x870aC11D48B15DB9a138Cf899d20F13F79Ba00BC",
    lltv: "625000000000000000",
    oracle: "0x5EA7998188E9b9ea1b146067ef29D32D7a7fE70C",
    loanToken: {
      address: "0xA0b86991c6218b36c1d19D4a2e9Eb0cE3606eB48",
      symbol: "USDC",
    },
    collateralToken: {
      address: "0xC02aaA39b223FE8D0A0e5C4F27eAD9083C756Cc2",
      symbol: "WETH",
    },
  },
  {
    id: "0x356099b091dc136bcb3ed07147a96fd7999eac6bab54c1d47ebfda9d7da7c5a1",
    name: "JPYC / USDC",
    irm: "0x870aC11D48B15DB9a138Cf899d20F13F79Ba00BC",
    lltv: "860000000000000000",
    oracle: "0x9F40c1d2354eD374f8c6A6B09A1B5cf3Da659D1f",
    loanToken: {
      address: "0xE7C3D8C9a439feDe00D2600032D5dB0Be71C3c29",
      symbol: "JPYC",
    },
    collateralToken: {
      address: "0xA0b86991c6218b36c1d19D4a2e9Eb0cE3606eB48",
      symbol: "USDC",
    },
  },
  {
    id: "0x1260f0313a8fdf0fc1792aa8fc2545c30227e553a23b087e5abe9bd91caf39a9",
    name: "WETH / PT-agETH-26JUN2025",
    irm: "0x870aC11D48B15DB9a138Cf899d20F13F79Ba00BC",
    lltv: "915000000000000000",
    oracle: "0x9d03b8a9a3E911b205Ef5E9d0A25Cc15Fda6432c",
    loanToken: {
      address: "0xC02aaA39b223FE8D0A0e5C4F27eAD9083C756Cc2",
      symbol: "WETH",
    },
    collateralToken: {
      address: "0x6E43F6abce001c14C7115d20908d0c272338eAf1",
      symbol: "PT-agETH-26JUN2025",
    },
  },
  {
    id: "0xd8849a4724965af31cba10bf8fe7a28008235716ed8000c375e64e53addf339a",
    name: "USDC / EURCV",
    irm: "0x870aC11D48B15DB9a138Cf899d20F13F79Ba00BC",
    lltv: "860000000000000000",
    oracle: "0xC33aE283e5002fcb2Dd0ABe303EC563E121Bc84B",
    loanToken: {
      address: "0xA0b86991c6218b36c1d19D4a2e9Eb0cE3606eB48",
      symbol: "USDC",
    },
    collateralToken: {
      address: "0x5F7827FDeb7c20b443265Fc2F40845B715385Ff2",
      symbol: "EURCV",
    },
  },
  {
    id: "0x87af71136db4486984164d66d6c42ddd9db4679d5eea77aa52bc70b3c5179f2e",
    name: "AUSD / sUSDe",
    irm: "0x870aC11D48B15DB9a138Cf899d20F13F79Ba00BC",
    lltv: "915000000000000000",
    oracle: "0x235FD3A500Ee30DCf875df8E3290551C39752b09",
    loanToken: {
      address: "0x00000000eFE302BEAA2b3e6e1b18d08D69a9012a",
      symbol: "AUSD",
    },
    collateralToken: {
      address: "0x9D39A5DE30e57443BfF2A8307A4256c8797A3497",
      symbol: "sUSDe",
    },
  },
  {
    id: "0x5bb06ba9aa95dab3ef87a0eabd0bcf534bc05861d34a7e2201a5ca6978a81edd",
    name: "USDC / tacBTC",
    irm: "0x870aC11D48B15DB9a138Cf899d20F13F79Ba00BC",
    lltv: "860000000000000000",
    oracle: "0x04Eb45Fa34C5d58C531351628BdC7E7e35bbD260",
    loanToken: {
      address: "0xA0b86991c6218b36c1d19D4a2e9Eb0cE3606eB48",
      symbol: "USDC",
    },
    collateralToken: {
      address: "0x6Bf340dB729d82af1F6443A0Ea0d79647b1c3DDf",
      symbol: "tacBTC",
    },
  },
  {
    id: "0x73ff251b2bc36dd3cba9f51009e529f239e241a358f9553199e1cd9681419ae1",
    name: "USDe / PT-USDe-27NOV2025",
    irm: "0x870aC11D48B15DB9a138Cf899d20F13F79Ba00BC",
    lltv: "915000000000000000",
    oracle: "0xd51007bED5f58B92933152181bAd4D8d7ad564b6",
    loanToken: {
      address: "0x4c9EDD5852cd905f086C759E8383e09bff1E68B3",
      symbol: "USDe",
    },
    collateralToken: {
      address: "0x62C6E813b9589C3631Ba0Cdb013acdB8544038B7",
      symbol: "PT-USDe-27NOV2025",
    },
  },
  {
    id: "0x6149bbe79b7f9357a6f13308650ad76c7ba342569622bf170ddf86072a845743",
    name: "USDC / fUSDC",
    irm: "0x870aC11D48B15DB9a138Cf899d20F13F79Ba00BC",
    lltv: "945000000000000000",
    oracle: "0x88D08EC5eCdbF0baaDdFd37c656399Ac0b5e08C8",
    loanToken: {
      address: "0xA0b86991c6218b36c1d19D4a2e9Eb0cE3606eB48",
      symbol: "USDC",
    },
    collateralToken: {
      address: "0xb0f05E4De970A1aaf77f8C2F823953a367504BA9",
      symbol: "fUSDC",
    },
  },
  {
    id: "0x70e4dd5e58fa6675cab35ac3d65765e39776beb7043476ce9d80cd247fe459a0",
    name: "USDC / sUSDf",
    irm: "0x870aC11D48B15DB9a138Cf899d20F13F79Ba00BC",
    lltv: "915000000000000000",
    oracle: "0x26cB901F9A107007BD5e912C6C4C028B273f0e5e",
    loanToken: {
      address: "0xA0b86991c6218b36c1d19D4a2e9Eb0cE3606eB48",
      symbol: "USDC",
    },
    collateralToken: {
      address: "0xc8CF6D7991f15525488b2A83Df53468D682Ba4B0",
      symbol: "sUSDf",
    },
  },
  {
    id: "0x9cb645a8588af9b16d82c919ee81cc8c6009ef6cf76b8b6453551ab60edab9f9",
    name: "USDC / tacETH",
    irm: "0x870aC11D48B15DB9a138Cf899d20F13F79Ba00BC",
    lltv: "860000000000000000",
    oracle: "0xB19556cd20d5F0270A9B053B82F5239d76483D6f",
    loanToken: {
      address: "0xA0b86991c6218b36c1d19D4a2e9Eb0cE3606eB48",
      symbol: "USDC",
    },
    collateralToken: {
      address: "0x294eecec65A0142e84AEdfD8eB2FBEA8c9a9fbad",
      symbol: "tacETH",
    },
  },
  {
    id: "0x01a2d4854fbfcbcfa595d22e41da4099e0f1c2b21fbaf106f0ad567ef85bae41",
    name: "EURCV / WBTC",
    irm: "0x870aC11D48B15DB9a138Cf899d20F13F79Ba00BC",
    lltv: "860000000000000000",
    oracle: "0x60b450916ee528e860439556ed90F05E10EB68D6",
    loanToken: {
      address: "0x5F7827FDeb7c20b443265Fc2F40845B715385Ff2",
      symbol: "EURCV",
    },
    collateralToken: {
      address: "0x2260FAC5E5542a773Aa44fBCfeDf7C193bc2C599",
      symbol: "WBTC",
    },
  },
  {
    id: "0x6c65bb7104ae6fc1dc2cdc97fcb7df2a4747363e76135b32d9170b2520bb65eb",
    name: "USDC / arUSD",
    irm: "0x870aC11D48B15DB9a138Cf899d20F13F79Ba00BC",
    lltv: "860000000000000000",
    oracle: "0xBC15fcCbf5D2AF119f18832069f56423549E1483",
    loanToken: {
      address: "0xA0b86991c6218b36c1d19D4a2e9Eb0cE3606eB48",
      symbol: "USDC",
    },
    collateralToken: {
      address: "0x07D1718fF05a8C53C8F05aDAEd57C0d672945f9a",
      symbol: "arUSD",
    },
  },
  {
    id: "0xd67812ad1888e232e5cf91d77785fbf33c226f0497e0cfa96d1b991f8314e8e1",
    name: "WETH / tacETH",
    irm: "0x870aC11D48B15DB9a138Cf899d20F13F79Ba00BC",
    lltv: "915000000000000000",
    oracle: "0xDF92B3AEB96801892436BBBe108bb1deB66D62a6",
    loanToken: {
      address: "0xC02aaA39b223FE8D0A0e5C4F27eAD9083C756Cc2",
      symbol: "WETH",
    },
    collateralToken: {
      address: "0x294eecec65A0142e84AEdfD8eB2FBEA8c9a9fbad",
      symbol: "tacETH",
    },
  },
  {
    id: "0x3d353ef0436b85c3b12d53536c19b21c533c046b07c9d92d791a1510e7ef0b74",
    name: "USDC / PT-mAPOLLO-30APR2026",
    irm: "0x870aC11D48B15DB9a138Cf899d20F13F79Ba00BC",
    lltv: "860000000000000000",
    oracle: "0xd2943a157708a674ED6eAE27c37F91755e55154C",
    loanToken: {
      address: "0xA0b86991c6218b36c1d19D4a2e9Eb0cE3606eB48",
      symbol: "USDC",
    },
    collateralToken: {
      address: "0x64b393288AB2a0Fe7Af6b73A9159493E60aB0605",
      symbol: "PT-mAPOLLO-30APR2026",
    },
  },
  {
    id: "0x1e947ac63808a6e27c665926078ec288bbb8849fac173a67cfd949f334964405",
    name: "USDC / n-st-mHYPER",
    irm: "0x870aC11D48B15DB9a138Cf899d20F13F79Ba00BC",
    lltv: "860000000000000000",
    oracle: "0x94F6Cb4FaE0EB3Fa74e9847dfF2fF52fd5ec7e6e",
    loanToken: {
      address: "0xA0b86991c6218b36c1d19D4a2e9Eb0cE3606eB48",
      symbol: "USDC",
    },
    collateralToken: {
      address: "0x94F6Cb4FaE0EB3Fa74e9847dfF2fF52fd5ec7e6e",
      symbol: "n-st-mHYPER",
    },
  },
  {
    id: "0x0bdde77fdaeaea9bd6e2a91021bf26c2b97a1c25d2070caaa10504698ab9159e",
    name: "PYUSD / wUSDL",
    irm: "0x870aC11D48B15DB9a138Cf899d20F13F79Ba00BC",
    lltv: "980000000000000000",
    oracle: "0x0A1577C7EcA50871EeCAb68E799F2EFa69F1fa96",
    loanToken: {
      address: "0x6c3ea9036406852006290770BEdFcAbA0e23A0e8",
      symbol: "PYUSD",
    },
    collateralToken: {
      address: "0x7751E2F4b8ae93EF6B79d86419d42FE3295A4559",
      symbol: "wUSDL",
    },
  },
  {
    id: "0xd8cb3574ec8bc5b4dcec68f87dd3a57c4ed73b0f2dc712da212f8198eb93dc1f",
    name: "USDC / PT-sUSDE-26DEC2024",
    irm: "0x870aC11D48B15DB9a138Cf899d20F13F79Ba00BC",
    lltv: "915000000000000000",
    oracle: "0xB35B25ADC53157f4b76a0eECc94EfE915A0AA968",
    loanToken: {
      address: "0xA0b86991c6218b36c1d19D4a2e9Eb0cE3606eB48",
      symbol: "USDC",
    },
    collateralToken: {
      address: "0xEe9085fC268F6727d5D4293dBABccF901ffDCC29",
      symbol: "PT-sUSDE-26DEC2024",
    },
  },
  {
    id: "0x39fe55e5102beac5fb3caff54142f26250b97dcdb5bea6122818c7760f38b331",
    name: "USDC / xUSD",
    irm: "0x870aC11D48B15DB9a138Cf899d20F13F79Ba00BC",
    lltv: "770000000000000000",
    oracle: "0x2F05Ac98D85101b5F826D51337dF573CF02A0A38",
    loanToken: {
      address: "0xA0b86991c6218b36c1d19D4a2e9Eb0cE3606eB48",
      symbol: "USDC",
    },
    collateralToken: {
      address: "0xE2Fc85BfB48C4cF147921fBE110cf92Ef9f26F94",
      symbol: "xUSD",
    },
  },
  {
    id: "0x5d4eacdc8dd5a5b0315a344936d2c9fb01c291c2547d901660eed558e7347316",
    name: "USDC / PT-pUSDe-16OCT2025",
    irm: "0x870aC11D48B15DB9a138Cf899d20F13F79Ba00BC",
    lltv: "860000000000000000",
    oracle: "0xe65898129eAD7a2b2Fb633dF9BAd0A9d860384bd",
    loanToken: {
      address: "0xA0b86991c6218b36c1d19D4a2e9Eb0cE3606eB48",
      symbol: "USDC",
    },
    collateralToken: {
      address: "0xF3f491e5608f8B8a6Fd9E9d66a4a4036d7FD282C",
      symbol: "PT-pUSDe-16OCT2025",
    },
  },
  {
    id: "0xaf53761f4931911877474ab8c7ff856987207ee7ec15e8513ff9cf86939229a0",
    name: "USDC / FLUID",
    irm: "0x870aC11D48B15DB9a138Cf899d20F13F79Ba00BC",
    lltv: "625000000000000000",
    oracle: "0x5158585e78b12bCc53791D19fFa6DCe8Fa56D306",
    loanToken: {
      address: "0xA0b86991c6218b36c1d19D4a2e9Eb0cE3606eB48",
      symbol: "USDC",
    },
    collateralToken: {
      address: "0x6f40d4A6237C257fff2dB00FA0510DeEECd303eb",
      symbol: "FLUID",
    },
  },
  {
    id: "0xde2bb82278de27e7851625e2d7c25280adc6d499c000cc6904eb0ab29124a481",
    name: "USDC / PEPE",
    irm: "0x870aC11D48B15DB9a138Cf899d20F13F79Ba00BC",
    lltv: "625000000000000000",
    oracle: "0xAe53190c12cb206A497EB45d2be1dd0A87046501",
    loanToken: {
      address: "0xA0b86991c6218b36c1d19D4a2e9Eb0cE3606eB48",
      symbol: "USDC",
    },
    collateralToken: {
      address: "0x6982508145454Ce325dDbE47a25d4ec3d2311933",
      symbol: "PEPE",
    },
  },
  {
    id: "0x31a277fde40c1bd37dd00cb2167fe1d5831b450efecc63323679228a101e9979",
    name: "USDC / SPX",
    irm: "0x870aC11D48B15DB9a138Cf899d20F13F79Ba00BC",
    lltv: "625000000000000000",
    oracle: "0x5D4ad982F7F67003c7F0c2F1807f7c3d08B80c8b",
    loanToken: {
      address: "0xA0b86991c6218b36c1d19D4a2e9Eb0cE3606eB48",
      symbol: "USDC",
    },
    collateralToken: {
      address: "0xE0f63A424a4439cBE457D80E4f4b51aD25b2c56C",
      symbol: "SPX",
    },
  },
  {
    id: "0x7f1224a8598b97a8455d298bd58b0f720f1b4f19a815198b8cdecc9feedada93",
    name: "USDC / kBTC",
    irm: "0x870aC11D48B15DB9a138Cf899d20F13F79Ba00BC",
    lltv: "860000000000000000",
    oracle: "0x5502a4cb797B6Db44275D1BbEA743463d256D554",
    loanToken: {
      address: "0xA0b86991c6218b36c1d19D4a2e9Eb0cE3606eB48",
      symbol: "USDC",
    },
    collateralToken: {
      address: "0x73E0C0d45E048D25Fc26Fa3159b0aA04BfA4Db98",
      symbol: "kBTC",
    },
  },
  {
    id: "0xe14957305e2baf4d02f6a14c6234fd33b8a199e7c9d8930a96fad2a837643ed1",
    name: "USDC / synUSD+",
    irm: "0x870aC11D48B15DB9a138Cf899d20F13F79Ba00BC",
    lltv: "945000000000000000",
    oracle: "0x881525A0A135Ac21F24cec904D72552282C0b53e",
    loanToken: {
      address: "0xA0b86991c6218b36c1d19D4a2e9Eb0cE3606eB48",
      symbol: "USDC",
    },
    collateralToken: {
      address: "0xD17049eD25d8f99FE3BFD10CEF2263da9995cFD8",
      symbol: "synUSD+",
    },
  },
  {
    id: "0xc05394d0261ed1c3c1af310007fdc4e64b3bcf650822b70526763fefc64b729e",
    name: "USDC / xUSD",
    irm: "0x870aC11D48B15DB9a138Cf899d20F13F79Ba00BC",
    lltv: "770000000000000000",
    oracle: "0xc36F094172a04D93f97f7154183e13bf241c0EEF",
    loanToken: {
      address: "0xA0b86991c6218b36c1d19D4a2e9Eb0cE3606eB48",
      symbol: "USDC",
    },
    collateralToken: {
      address: "0xE2Fc85BfB48C4cF147921fBE110cf92Ef9f26F94",
      symbol: "xUSD",
    },
  },
  {
    id: "0x4fb4e03d4fc8ac1f045068a1fd8dcb63833d93add74a89a417627995f851f679",
    name: "USDC / PT-pUSDe-16OCT2025",
    irm: "0x870aC11D48B15DB9a138Cf899d20F13F79Ba00BC",
    lltv: "860000000000000000",
    oracle: "0x064956547540611E7b8D019ff43e3A0a143352E3",
    loanToken: {
      address: "0xA0b86991c6218b36c1d19D4a2e9Eb0cE3606eB48",
      symbol: "USDC",
    },
    collateralToken: {
      address: "0xF3f491e5608f8B8a6Fd9E9d66a4a4036d7FD282C",
      symbol: "PT-pUSDe-16OCT2025",
    },
  },
  {
    id: "0xa5fad8c45b73457d03fcaa8ee546f86c42d17da3fdc4d3910c4cc9baafb411c5",
    name: "USDC / MORPHO",
    irm: "0x870aC11D48B15DB9a138Cf899d20F13F79Ba00BC",
    lltv: "385000000000000000",
    oracle: "0x35BD95b96a125DA71c2f507F0831309A8e3B75c8",
    loanToken: {
      address: "0xA0b86991c6218b36c1d19D4a2e9Eb0cE3606eB48",
      symbol: "USDC",
    },
    collateralToken: {
      address: "0x58D97B57BB95320F9a05dC918Aef65434969c2B2",
      symbol: "MORPHO",
    },
  },
  {
    id: "0x89a880bba43af4120f18559659d3787a7cbce97bda9384af5497e041d8a29d10",
    name: "USDC / COMP",
    irm: "0x870aC11D48B15DB9a138Cf899d20F13F79Ba00BC",
    lltv: "385000000000000000",
    oracle: "0x05Bf168d04c95f042c0a5B4c6D614fF8857e8231",
    loanToken: {
      address: "0xA0b86991c6218b36c1d19D4a2e9Eb0cE3606eB48",
      symbol: "USDC",
    },
    collateralToken: {
      address: "0xc00e94Cb662C3520282E6f5717214004A7f26888",
      symbol: "COMP",
    },
  },
  {
    id: "0x3db06e455a1a18829d1e0357a2d22971a9e3be0e915deab0f35372eb349db5d4",
    name: "USDC / uniBTC",
    irm: "0x870aC11D48B15DB9a138Cf899d20F13F79Ba00BC",
    lltv: "860000000000000000",
    oracle: "0x62610A25971aC5030bC6578332b19fd6B9d883eF",
    loanToken: {
      address: "0xA0b86991c6218b36c1d19D4a2e9Eb0cE3606eB48",
      symbol: "USDC",
    },
    collateralToken: {
      address: "0x004E9C3EF86bc1ca1f0bB5C7662861Ee93350568",
      symbol: "uniBTC",
    },
  },
  {
    id: "0x4f19814b23fc9a394c10726341818b735c1f790ac869bd6be9d2b46c851c0e8e",
    name: "USDT / USDC",
    irm: "0x870aC11D48B15DB9a138Cf899d20F13F79Ba00BC",
    lltv: "770000000000000000",
    oracle: "0x25750070138753e4Df6fCeD1707ec84EE0DcAbbA",
    loanToken: {
      address: "0xdAC17F958D2ee523a2206206994597C13D831ec7",
      symbol: "USDT",
    },
    collateralToken: {
      address: "0xA0b86991c6218b36c1d19D4a2e9Eb0cE3606eB48",
      symbol: "USDC",
    },
  },
  {
    id: "0x3ba1ed5d949901d4fa4e53d9c02f7dc6d4eca723a21990bb7316430f17ef356a",
    name: "USDC / PT-savUSD-14MAY2026",
    irm: "0x870aC11D48B15DB9a138Cf899d20F13F79Ba00BC",
    lltv: "915000000000000000",
    oracle: "0x8A93389555514dC3798117b89c722B7091e40454",
    loanToken: {
      address: "0xA0b86991c6218b36c1d19D4a2e9Eb0cE3606eB48",
      symbol: "USDC",
    },
    collateralToken: {
      address: "0x606B5C773dC4D6E625C411cF60565f8c30C467d2",
      symbol: "PT-savUSD-14MAY2026",
    },
  },
  {
    id: "0x287291c4d5438102a3e7b2356225333a0eda964808b20ba3740393612260a90a",
    name: "USDC / PT-avUSD-14MAY2026",
    irm: "0x870aC11D48B15DB9a138Cf899d20F13F79Ba00BC",
    lltv: "915000000000000000",
    oracle: "0x594DA44f083F4aD85938FC87Bc91c84db623B6Dd",
    loanToken: {
      address: "0xA0b86991c6218b36c1d19D4a2e9Eb0cE3606eB48",
      symbol: "USDC",
    },
    collateralToken: {
      address: "0xcc16Cd49194e7AA3DCa780c742580e2f9b418874",
      symbol: "PT-avUSD-14MAY2026",
    },
  },
  {
    id: "0xb7f6d3ddb564b35d77be832e084c7c090ee1b385e139f1d87e6cfa34a6a18856",
    name: "WBTC / PT-SolvBTC.BBN-26JUN2025",
    irm: "0x870aC11D48B15DB9a138Cf899d20F13F79Ba00BC",
    lltv: "915000000000000000",
    oracle: "0x69cBA630Ca35e85157A906412E635F5e9dC846F0",
    loanToken: {
      address: "0x2260FAC5E5542a773Aa44fBCfeDf7C193bc2C599",
      symbol: "WBTC",
    },
    collateralToken: {
      address: "0x4f62A7a25a4fD6Ae386e957284aFB5FBF1E1f32c",
      symbol: "PT-SolvBTC.BBN-26JUN2025",
    },
  },
  {
    id: "0x9dd533d05afa8dfce6a2ed82219e1c1dcebb16fe7722fb5912b989ef69df487f",
    name: "WBTC / PT-corn-eBTC-27MAR2025",
    irm: "0x870aC11D48B15DB9a138Cf899d20F13F79Ba00BC",
    lltv: "915000000000000000",
    oracle: "0x132afAB1fAdB9498F30be1b29F05A95062a9534C",
    loanToken: {
      address: "0x2260FAC5E5542a773Aa44fBCfeDf7C193bc2C599",
      symbol: "WBTC",
    },
    collateralToken: {
      address: "0x44A7876cA99460ef3218bf08b5f52E2dbE199566",
      symbol: "PT-corn-eBTC-27MAR2025",
    },
  },
  {
    id: "0x2a3fb4e86d7294ced8be46851a4e9a5b946494b4ee373ccb464227b48aa0beb3",
    name: "WBTC / PT-SolvBTC.BBN-27MAR2025",
    irm: "0x870aC11D48B15DB9a138Cf899d20F13F79Ba00BC",
    lltv: "915000000000000000",
    oracle: "0xD669F9Ca969f73Efba6C53831AC8856BaAd6Db53",
    loanToken: {
      address: "0x2260FAC5E5542a773Aa44fBCfeDf7C193bc2C599",
      symbol: "WBTC",
    },
    collateralToken: {
      address: "0xd1A1984cc5CAcbd36F6a511877d13662C950fd62",
      symbol: "PT-SolvBTC.BBN-27MAR2025",
    },
  },
  {
    id: "0xdbd8f3e55e5005a3922e3df4b1ba636ff9998b94588597420281e3641a05bf59",
    name: "USDC / cbBTC",
    irm: "0x870aC11D48B15DB9a138Cf899d20F13F79Ba00BC",
    lltv: "860000000000000000",
    oracle: "0x830dEBC0aD17716311a8A3eB41C9e11c6d4D509A",
    loanToken: {
      address: "0xA0b86991c6218b36c1d19D4a2e9Eb0cE3606eB48",
      symbol: "USDC",
    },
    collateralToken: {
      address: "0xcbB7C0000aB88B473b1f5aFd9ef808440eed33Bf",
      symbol: "cbBTC",
    },
  },
  {
    id: "0x822e956b3beea61e76653494c1ea7f4fd90f0ff0cfdb331ec5a5af59349efb78",
    name: "USDC / PT-sw-RLP-1750896023",
    irm: "0x870aC11D48B15DB9a138Cf899d20F13F79Ba00BC",
    lltv: "915000000000000000",
    oracle: "0x430bf343Dd91FDE2CF4741704A2C714306D5dBDf",
    loanToken: {
      address: "0xA0b86991c6218b36c1d19D4a2e9Eb0cE3606eB48",
      symbol: "USDC",
    },
    collateralToken: {
      address: "0x1F7Aa7104db822987E1F44A66dF709A8C4Fb301a",
      symbol: "PT-sw-RLP-1750896023",
    },
  },
  {
    id: "0x6fbd29fb416fe156140d5ffee7aa64cfa0fcfda7e2b0fe8147e311ef6bba0a2b",
    name: "USDC / PT-tUSDe-18DEC2025",
    irm: "0x870aC11D48B15DB9a138Cf899d20F13F79Ba00BC",
    lltv: "915000000000000000",
    oracle: "0x303c04b73F79d3Fe7e4D1fDD07aBD2E6382FBdA1",
    loanToken: {
      address: "0xA0b86991c6218b36c1d19D4a2e9Eb0cE3606eB48",
      symbol: "USDC",
    },
    collateralToken: {
      address: "0x1135b22d6e8FD0809392478eEDcd8c107dB6aF9D",
      symbol: "PT-tUSDe-18DEC2025",
    },
  },
  {
    id: "0x3f17220a0b94327d496e596634230e68a51ca2a3ad5f595387ca754161f397f7",
    name: "USDC / PT-reUSD-18DEC2025",
    irm: "0x870aC11D48B15DB9a138Cf899d20F13F79Ba00BC",
    lltv: "915000000000000000",
    oracle: "0xd1D36076BCEE13e48992B02492F46DBca06abe2b",
    loanToken: {
      address: "0xA0b86991c6218b36c1d19D4a2e9Eb0cE3606eB48",
      symbol: "USDC",
    },
    collateralToken: {
      address: "0xCb95d32B87D2ECEB196Af2152147de371aF3C7C9",
      symbol: "PT-reUSD-18DEC2025",
    },
  },
  {
    id: "0xb770620620f2b93d18005fcfbb7b74295cbe7500fb052bd94d19e623ab728b09",
    name: "USDC / sYUSD",
    irm: "0x870aC11D48B15DB9a138Cf899d20F13F79Ba00BC",
    lltv: "915000000000000000",
    oracle: "0x3b8CCb284219D8eB46909D72d9c3B366d32ffE0f",
    loanToken: {
      address: "0xA0b86991c6218b36c1d19D4a2e9Eb0cE3606eB48",
      symbol: "USDC",
    },
    collateralToken: {
      address: "0xfE0ccc9942E98C963Fe6b4e5194EB6e3Baa4cb64",
      symbol: "sYUSD",
    },
  },
  {
    id: "0x8f3ad887c9a81ec349eec0e6410a6cc95eda44d069f240f3f55a62f1430a37c0",
    name: "EURA / WBTC",
    irm: "0x870aC11D48B15DB9a138Cf899d20F13F79Ba00BC",
    lltv: "860000000000000000",
    oracle: "0xD122315BD4E89386045F51f6e65A6EeDb0dD31b9",
    loanToken: {
      address: "0x1a7e4e63778B4f12a199C062f3eFdD288afCBce8",
      symbol: "EURA",
    },
    collateralToken: {
      address: "0x2260FAC5E5542a773Aa44fBCfeDf7C193bc2C599",
      symbol: "WBTC",
    },
  },
  {
    id: "0xaaef8ad6dff96217212b72dbe0d45b3f3af0c255e9b1596c018caf635869db97",
    name: "USDC / PT-wstUSR-29JAN2026",
    irm: "0x870aC11D48B15DB9a138Cf899d20F13F79Ba00BC",
    lltv: "915000000000000000",
    oracle: "0x7a862FbE862723cea2fFe8DcB858E002cD003e3A",
    loanToken: {
      address: "0xA0b86991c6218b36c1d19D4a2e9Eb0cE3606eB48",
      symbol: "USDC",
    },
    collateralToken: {
      address: "0xfCeEB7586bab730fA400A5BF3FcF298d0DB4c7e7",
      symbol: "PT-wstUSR-29JAN2026",
    },
  },
  {
    id: "0x24fbc1eec806d1acde9befd71fb49e1fec96dd09013ae215334f4472df3357d4",
    name: "USDe / PT-tUSDe-18DEC2025",
    irm: "0x870aC11D48B15DB9a138Cf899d20F13F79Ba00BC",
    lltv: "915000000000000000",
    oracle: "0x085fefBBAc570979Ac4B9d51B9096fB9E19D63d6",
    loanToken: {
      address: "0x4c9EDD5852cd905f086C759E8383e09bff1E68B3",
      symbol: "USDe",
    },
    collateralToken: {
      address: "0x1135b22d6e8FD0809392478eEDcd8c107dB6aF9D",
      symbol: "PT-tUSDe-18DEC2025",
    },
  },
  {
    id: "0x093d5b432aace8bf6c4d67494f4ac2542a499571ff7a1bcc9f8778f3200d457d",
    name: "WETH / ezETH",
    irm: "0x870aC11D48B15DB9a138Cf899d20F13F79Ba00BC",
    lltv: "770000000000000000",
    oracle: "0x61025e2B0122ac8bE4e37365A4003d87ad888Cc3",
    loanToken: {
      address: "0xC02aaA39b223FE8D0A0e5C4F27eAD9083C756Cc2",
      symbol: "WETH",
    },
    collateralToken: {
      address: "0xbf5495Efe5DB9ce00f80364C8B423567e58d2110",
      symbol: "ezETH",
    },
  },
  {
    id: "0xb79a07659c64f0d471663f0629bab0997206bebb31ecbd4c750e1dd7fa7bc09a",
    name: "USDC / PENDLE-LPT-WRAPPED",
    irm: "0x870aC11D48B15DB9a138Cf899d20F13F79Ba00BC",
    lltv: "915000000000000000",
    oracle: "0xC78EC8E67571A0848a4272837DfE893e6cFA5F64",
    loanToken: {
      address: "0xA0b86991c6218b36c1d19D4a2e9Eb0cE3606eB48",
      symbol: "USDC",
    },
    collateralToken: {
      address: "0xFbA26f44459FB83d98c9a8C8FDdca7cadca18A85",
      symbol: "PENDLE-LPT-WRAPPED",
    },
  },
  {
    id: "0xee20d15327f55d188277667e3cea881f9df94a4c3b429b0261f7cf2a34f290f9",
    name: "USDC / sUSDf",
    irm: "0x870aC11D48B15DB9a138Cf899d20F13F79Ba00BC",
    lltv: "915000000000000000",
    oracle: "0x610a4143f3Fad1cEb2cf2CbE0787c63719003233",
    loanToken: {
      address: "0xA0b86991c6218b36c1d19D4a2e9Eb0cE3606eB48",
      symbol: "USDC",
    },
    collateralToken: {
      address: "0xc8CF6D7991f15525488b2A83Df53468D682Ba4B0",
      symbol: "sUSDf",
    },
  },
  {
    id: "0x7e9c708876fa3816c46aeb08937b51aa0461c2af3865ecb306433db8a80b1d1b",
    name: "USDC / pufETH",
    irm: "0x870aC11D48B15DB9a138Cf899d20F13F79Ba00BC",
    lltv: "770000000000000000",
    oracle: "0xdFA52B07a794488B3F2CCF3aC22AA7430f86B68b",
    loanToken: {
      address: "0xA0b86991c6218b36c1d19D4a2e9Eb0cE3606eB48",
      symbol: "USDC",
    },
    collateralToken: {
      address: "0xD9A442856C234a39a81a089C06451EBAa4306a72",
      symbol: "pufETH",
    },
  },
  {
    id: "0x8578f229f27eaf75faac449d837c13534ac7a39423315fe35ece2b5b545cda47",
    name: "EURCV / USDC",
    irm: "0x870aC11D48B15DB9a138Cf899d20F13F79Ba00BC",
    lltv: "860000000000000000",
    oracle: "0x133FEF0b4db245058E980cbEC575aD4FAc3EB7C3",
    loanToken: {
      address: "0x5F7827FDeb7c20b443265Fc2F40845B715385Ff2",
      symbol: "EURCV",
    },
    collateralToken: {
      address: "0xA0b86991c6218b36c1d19D4a2e9Eb0cE3606eB48",
      symbol: "USDC",
    },
  },
  {
    id: "0x134c6d598a8314a53b15d5fa5005f8bb16ba97dee6350d4a317d09b7af4dab6f",
    name: "USDT / PENDLE-LPT-WRAPPED",
    irm: "0x870aC11D48B15DB9a138Cf899d20F13F79Ba00BC",
    lltv: "915000000000000000",
    oracle: "0xf78340349486e3A0b932F35eF390EE17706814af",
    loanToken: {
      address: "0xdAC17F958D2ee523a2206206994597C13D831ec7",
      symbol: "USDT",
    },
    collateralToken: {
      address: "0xaB025d7b57B0902A2797599F3eB07477400e62B0",
      symbol: "PENDLE-LPT-WRAPPED",
    },
  },
  {
    id: "0x6b50b52c8221565d68441a2e5daa3fce8077cdf2e34ff69ef9716c22b4a8b138",
    name: "USDC / USDC",
    irm: "0x870aC11D48B15DB9a138Cf899d20F13F79Ba00BC",
    lltv: "860000000000000000",
    oracle: "0xd8361b98590293d9A45DdeFC831F077BbBD320CC",
    loanToken: {
      address: "0xA0b86991c6218b36c1d19D4a2e9Eb0cE3606eB48",
      symbol: "USDC",
    },
    collateralToken: {
      address: "0xA0b86991c6218b36c1d19D4a2e9Eb0cE3606eB48",
      symbol: "USDC",
    },
  },
  {
    id: "0xf84288cdcf652627f66cd7a6d4c43c3ee43ca7146d9a9cfab3a136a861144d6f",
    name: "USR / WBTC",
    irm: "0x870aC11D48B15DB9a138Cf899d20F13F79Ba00BC",
    lltv: "860000000000000000",
    oracle: "0xa300E5C4bcAEA1480c2E6bE90b267e31b7645815",
    loanToken: {
      address: "0x66a1E37c9b0eAddca17d3662D6c05F4DECf3e110",
      symbol: "USR",
    },
    collateralToken: {
      address: "0x2260FAC5E5542a773Aa44fBCfeDf7C193bc2C599",
      symbol: "WBTC",
    },
  },
  {
    id: "0x676eca446d11a2d95a1fcd87706411ebc50c1e84916f073216150c52540d4a77",
    name: "USDC / USDf",
    irm: "0x870aC11D48B15DB9a138Cf899d20F13F79Ba00BC",
    lltv: "915000000000000000",
    oracle: "0xad8ea886C891Fbb8603462675b8569Aae8eD550D",
    loanToken: {
      address: "0xA0b86991c6218b36c1d19D4a2e9Eb0cE3606eB48",
      symbol: "USDC",
    },
    collateralToken: {
      address: "0xFa2B947eEc368f42195f24F36d2aF29f7c24CeC2",
      symbol: "USDf",
    },
  },
  {
    id: "0x27852bb453d4fe6ec918dd27b7136bb233d210aab1758a59ed8daaeec24f7b3d",
    name: "USDC / PT-sUSDE-27FEB2025",
    irm: "0x870aC11D48B15DB9a138Cf899d20F13F79Ba00BC",
    lltv: "915000000000000000",
    oracle: "0x5Da4B29b877B21a4360495C06b88e8da194c169e",
    loanToken: {
      address: "0xA0b86991c6218b36c1d19D4a2e9Eb0cE3606eB48",
      symbol: "USDC",
    },
    collateralToken: {
      address: "0x386AE941D4262B0Ee96354499dF2ab8442734EC0",
      symbol: "PT-sUSDE-27FEB2025",
    },
  },
  {
    id: "0x645fba729787a172a49f1661c53a4de57d69c522ba9bb3f2d1fcef0923f9189a",
    name: "USDC / PT-pUSDe-16OCT2025",
    irm: "0x870aC11D48B15DB9a138Cf899d20F13F79Ba00BC",
    lltv: "915000000000000000",
    oracle: "0xe65898129eAD7a2b2Fb633dF9BAd0A9d860384bd",
    loanToken: {
      address: "0xA0b86991c6218b36c1d19D4a2e9Eb0cE3606eB48",
      symbol: "USDC",
    },
    collateralToken: {
      address: "0xF3f491e5608f8B8a6Fd9E9d66a4a4036d7FD282C",
      symbol: "PT-pUSDe-16OCT2025",
    },
  },
  {
    id: "0x15f30b939b8590be30aa22cd8d6367cf90a0ae460ce7f644ddbf58b8442e619a",
    name: "USDC / cUSDO",
    irm: "0x870aC11D48B15DB9a138Cf899d20F13F79Ba00BC",
    lltv: "915000000000000000",
    oracle: "0x26Be0B9fDAF2855428DEee155b195eE802144ACD",
    loanToken: {
      address: "0xA0b86991c6218b36c1d19D4a2e9Eb0cE3606eB48",
      symbol: "USDC",
    },
    collateralToken: {
      address: "0xaD55aebc9b8c03FC43cd9f62260391c13c23e7c0",
      symbol: "cUSDO",
    },
  },
  {
    id: "0x65d5c83561b2ef3084732e26408332ec10ff2fffa1a31fc19a5fdffd009684e7",
    name: "USDC / sFRAX",
    irm: "0x870aC11D48B15DB9a138Cf899d20F13F79Ba00BC",
    lltv: "860000000000000000",
    oracle: "0xd8361b98590293d9A45DdeFC831F077BbBD320CC",
    loanToken: {
      address: "0xA0b86991c6218b36c1d19D4a2e9Eb0cE3606eB48",
      symbol: "USDC",
    },
    collateralToken: {
      address: "0xA663B02CF0a4b149d2aD41910CB81e23e1c41c32",
      symbol: "sFRAX",
    },
  },
  {
    id: "0xeda8ba4dc73b3c7ee97c38fa08f63d771905500c04bd67246a5c7f17dee84b93",
    name: "USDC / PT-AIDaUSDC-30OCT2025",
    irm: "0x870aC11D48B15DB9a138Cf899d20F13F79Ba00BC",
    lltv: "860000000000000000",
    oracle: "0x8Ad7D0E0523555CEB9ba9ac4d3c90DF211F959bF",
    loanToken: {
      address: "0xA0b86991c6218b36c1d19D4a2e9Eb0cE3606eB48",
      symbol: "USDC",
    },
    collateralToken: {
      address: "0xAa6ee47AEbAEF8d0E159B6d0962AcD82dF335b0F",
      symbol: "PT-AIDaUSDC-30OCT2025",
    },
  },
  {
    id: "0xbf4d7952ceeb29d52678172c348b8ef112d6e32413c547cbf56bbf6addcfa13e",
    name: "USDC / PT-wstUSR-1740182579",
    irm: "0x870aC11D48B15DB9a138Cf899d20F13F79Ba00BC",
    lltv: "915000000000000000",
    oracle: "0x2da48Ed7a26021fb25c8d94708A77a2e04608Cc8",
    loanToken: {
      address: "0xA0b86991c6218b36c1d19D4a2e9Eb0cE3606eB48",
      symbol: "USDC",
    },
    collateralToken: {
      address: "0xD0097149AA4CC0d0e1fC99B8BD73fC17dC32C1E9",
      symbol: "PT-wstUSR-1740182579",
    },
  },
  {
    id: "0x6564018d0239d8072ccac53f556d661bec29f81c023e3aff2aeb961f25108d04",
    name: "WETH / PT-sw-inwstETHs-1752969615",
    irm: "0x870aC11D48B15DB9a138Cf899d20F13F79Ba00BC",
    lltv: "915000000000000000",
    oracle: "0x9c61843B0Ac1cBffb6D55dbd3D526655AF0Ad5ad",
    loanToken: {
      address: "0xC02aaA39b223FE8D0A0e5C4F27eAD9083C756Cc2",
      symbol: "WETH",
    },
    collateralToken: {
      address: "0x4ae0154F83427A5864e5de6513a47dAC9E5D5a69",
      symbol: "PT-sw-inwstETHs-1752969615",
    },
  },
  {
    id: "0xddda840cba83c4b76c93d7fcdd2c4178914f98b2c9a38a7831b160ce116013c1",
    name: "WBTC / PT-EBTC-26JUN2025",
    irm: "0x870aC11D48B15DB9a138Cf899d20F13F79Ba00BC",
    lltv: "915000000000000000",
    oracle: "0x404021ACfe53448aB3Bbe981D482843a18AcEaa3",
    loanToken: {
      address: "0x2260FAC5E5542a773Aa44fBCfeDf7C193bc2C599",
      symbol: "WBTC",
    },
    collateralToken: {
      address: "0xc653F79de1274eE65674BeFda54986020d6f8FC1",
      symbol: "PT-EBTC-26JUN2025",
    },
  },
  {
    id: "0x46981f15ab56d2fdff819d9c2b9c33ed9ce8086e0cce70939175ac7e55377c7f",
    name: "USDC / sDAI",
    irm: "0x870aC11D48B15DB9a138Cf899d20F13F79Ba00BC",
    lltv: "965000000000000000",
    oracle: "0xd6361d441EA8Fd285F7cd8b7d406b424e50c5429",
    loanToken: {
      address: "0xA0b86991c6218b36c1d19D4a2e9Eb0cE3606eB48",
      symbol: "USDC",
    },
    collateralToken: {
      address: "0x83F20F44975D03b1b09e64809B757c47f942BEeA",
      symbol: "sDAI",
    },
  },
  {
    id: "0xc5971d799183725922d62a757c9549047a4b518f6523a2f284dc4abadce662ed",
    name: "USDC / USDf",
    irm: "0x870aC11D48B15DB9a138Cf899d20F13F79Ba00BC",
    lltv: "915000000000000000",
    oracle: "0x972e8167555913800208D0bbc26eC308d2edab22",
    loanToken: {
      address: "0xA0b86991c6218b36c1d19D4a2e9Eb0cE3606eB48",
      symbol: "USDC",
    },
    collateralToken: {
      address: "0xFa2B947eEc368f42195f24F36d2aF29f7c24CeC2",
      symbol: "USDf",
    },
  },
  {
    id: "0x07cd0d69b60deb9f1e6f07025707658969ce1c6ce4f228b0594cc9ecf1a5222a",
    name: "USD0 / WBTC",
    irm: "0x870aC11D48B15DB9a138Cf899d20F13F79Ba00BC",
    lltv: "860000000000000000",
    oracle: "0x0D9cd1Dc03FFEfC459C5641678cf406f40d32cAc",
    loanToken: {
      address: "0x73A15FeD60Bf67631dC6cd7Bc5B6e8da8190aCF5",
      symbol: "USD0",
    },
    collateralToken: {
      address: "0x2260FAC5E5542a773Aa44fBCfeDf7C193bc2C599",
      symbol: "WBTC",
    },
  },
  {
    id: "0x2bab3afb8b2e7ae48af2835a0079c5170435210a59bdab6a0081649dda542859",
    name: "USDC / PT-USDS-14AUG2025",
    irm: "0x870aC11D48B15DB9a138Cf899d20F13F79Ba00BC",
    lltv: "915000000000000000",
    oracle: "0x8dD684a00AbA5e3c7f8157faAC640b6725e62f6c",
    loanToken: {
      address: "0xA0b86991c6218b36c1d19D4a2e9Eb0cE3606eB48",
      symbol: "USDC",
    },
    collateralToken: {
      address: "0xFfEc096c087C13Cc268497B89A613cACE4DF9A48",
      symbol: "PT-USDS-14AUG2025",
    },
  },
  {
    id: "0x05c3f718ee2fe08c0d456fb252f6731063af629462947e2b93edf7ea71b15cb9",
    name: "USDT / SyStUSD",
    irm: "0x870aC11D48B15DB9a138Cf899d20F13F79Ba00BC",
    lltv: "945000000000000000",
    oracle: "0xDC34BD1940D18E234Dc56964C8aAA7c4B9D95D6a",
    loanToken: {
      address: "0xdAC17F958D2ee523a2206206994597C13D831ec7",
      symbol: "USDT",
    },
    collateralToken: {
      address: "0x2C78106719D559115498173F513823f4b3E6a4FB",
      symbol: "SyStUSD",
    },
  },
  {
    id: "0x73dc42f6b9279901cd2563ea7877aeb129eda36fb69bc76abafe3eaeebd0edd6",
    name: "USDC / PT-sUSDf-25SEP2025",
    irm: "0x870aC11D48B15DB9a138Cf899d20F13F79Ba00BC",
    lltv: "915000000000000000",
    oracle: "0x3450a2D41a32bF3a415AC95AF8b196979912410e",
    loanToken: {
      address: "0xA0b86991c6218b36c1d19D4a2e9Eb0cE3606eB48",
      symbol: "USDC",
    },
    collateralToken: {
      address: "0xAB365C0879024481E4ad3b47bd6FeA9c10014FbC",
      symbol: "PT-sUSDf-25SEP2025",
    },
  },
  {
    id: "0xaf4a7f56543cff02c967780efb72c4ea0857c3200128fd0e4e24022f133fb8d6",
    name: "USDC / beraSTONE",
    irm: "0x870aC11D48B15DB9a138Cf899d20F13F79Ba00BC",
    lltv: "860000000000000000",
    oracle: "0xCb7448911F855256A1DE34B4Dd0BF19B5Be92bFC",
    loanToken: {
      address: "0xA0b86991c6218b36c1d19D4a2e9Eb0cE3606eB48",
      symbol: "USDC",
    },
    collateralToken: {
      address: "0x97Ad75064b20fb2B2447feD4fa953bF7F007a706",
      symbol: "beraSTONE",
    },
  },
  {
    id: "0xb8cbb001b00106604cff07b01d3868d65cd47b3030bbdfcf6e279a2fa09c6b28",
    name: "WBTC / uniBTC",
    irm: "0x870aC11D48B15DB9a138Cf899d20F13F79Ba00BC",
    lltv: "860000000000000000",
    oracle: "0xDFE625A283f7D7a24672D9c58A1CCfFb9846Fd9e",
    loanToken: {
      address: "0x2260FAC5E5542a773Aa44fBCfeDf7C193bc2C599",
      symbol: "WBTC",
    },
    collateralToken: {
      address: "0x004E9C3EF86bc1ca1f0bB5C7662861Ee93350568",
      symbol: "uniBTC",
    },
  },
  {
    id: "0x34b6843ac2306086a810e33fc6f42a5c2e91fc045ad146d3fd5cc1f64b599b46",
    name: "USDC / PT-ysUSDC-1745107210",
    irm: "0x870aC11D48B15DB9a138Cf899d20F13F79Ba00BC",
    lltv: "915000000000000000",
    oracle: "0xFAFC62928EC6F9fB59f5c3d80e8e7Be846f67E4b",
    loanToken: {
      address: "0xA0b86991c6218b36c1d19D4a2e9Eb0cE3606eB48",
      symbol: "USDC",
    },
    collateralToken: {
      address: "0x3b9739eE0c3b5bD7b392a801DEaC1dc68cfB0C48",
      symbol: "PT-ysUSDC-1745107210",
    },
  },
  {
    id: "0xe88fa22f107cae0505a612e76a91d6a23a225f76244c85237051a2959c8a6112",
    name: "USDC / PT-fxSAVE-30OCT2025",
    irm: "0x870aC11D48B15DB9a138Cf899d20F13F79Ba00BC",
    lltv: "860000000000000000",
    oracle: "0x32A7A8FF5eD63892857B957ae0Ae9F79343A6C2A",
    loanToken: {
      address: "0xA0b86991c6218b36c1d19D4a2e9Eb0cE3606eB48",
      symbol: "USDC",
    },
    collateralToken: {
      address: "0x21aacE56a8F21210b7E76d8eF1a77253Db85BF0a",
      symbol: "PT-fxSAVE-30OCT2025",
    },
  },
  {
    id: "0xe78c2ab01bc18aca0379dbd15dd063c5db17e6e0f93641645fca7f75eadb8385",
    name: "USDC / PT-reUSD-18DEC2025",
    irm: "0x870aC11D48B15DB9a138Cf899d20F13F79Ba00BC",
    lltv: "915000000000000000",
    oracle: "0x412200c5a5B8c1d5a22cBb24Ee0565aA912812ce",
    loanToken: {
      address: "0xA0b86991c6218b36c1d19D4a2e9Eb0cE3606eB48",
      symbol: "USDC",
    },
    collateralToken: {
      address: "0xCb95d32B87D2ECEB196Af2152147de371aF3C7C9",
      symbol: "PT-reUSD-18DEC2025",
    },
  },
  {
    id: "0xe2f94f4008be0aba556a7376f1aa0785cf21584761ae30a181935b665c4fc38c",
    name: "USDC / apWETH",
    irm: "0x870aC11D48B15DB9a138Cf899d20F13F79Ba00BC",
    lltv: "860000000000000000",
    oracle: "0x24Dc7441b3486094BcE4aA782C91B30B57BD9dD7",
    loanToken: {
      address: "0xA0b86991c6218b36c1d19D4a2e9Eb0cE3606eB48",
      symbol: "USDC",
    },
    collateralToken: {
      address: "0xB1A757A68D4a04a6B5A0F06d0cB4FD739048F614",
      symbol: "apWETH",
    },
  },
  {
    id: "0x9a9a96b822945c73eb7395edca049ba942adc597878854e4502148fa6c2480c8",
    name: "USDC / wstUSR",
    irm: "0x870aC11D48B15DB9a138Cf899d20F13F79Ba00BC",
    lltv: "860000000000000000",
    oracle: "0x874514c2CA3512258C5C8194A7234A06860B080B",
    loanToken: {
      address: "0xA0b86991c6218b36c1d19D4a2e9Eb0cE3606eB48",
      symbol: "USDC",
    },
    collateralToken: {
      address: "0x1202F5C7b4B9E47a1A484E8B270be34dbbC75055",
      symbol: "wstUSR",
    },
  },
  {
    id: "0x92cfee9443ca277ed55f62fe3a6e719c1b26d13a8db2e3294772c2b18b614b3f",
    name: "USDC / enzoBTC",
    irm: "0x870aC11D48B15DB9a138Cf899d20F13F79Ba00BC",
    lltv: "860000000000000000",
    oracle: "0xcB2D5Fe31D23Db890c3BeB39F05980f4525a8841",
    loanToken: {
      address: "0xA0b86991c6218b36c1d19D4a2e9Eb0cE3606eB48",
      symbol: "USDC",
    },
    collateralToken: {
      address: "0x6A9A65B84843F5fD4aC9a0471C4fc11AFfFBce4a",
      symbol: "enzoBTC",
    },
  },
  {
    id: "0x8c2df0d6f57680fafe2934db29e53c91e66238dbcbaeed8e5467d7c0f932cd45",
    name: "USDC / XPE",
    irm: "0x870aC11D48B15DB9a138Cf899d20F13F79Ba00BC",
    lltv: "980000000000000000",
    oracle: "0x1Fe972c50a5056f33040C6a01e1758b1171CF0bf",
    loanToken: {
      address: "0xA0b86991c6218b36c1d19D4a2e9Eb0cE3606eB48",
      symbol: "USDC",
    },
    collateralToken: {
      address: "0x21728dD7bC8e643667331643dC5f7E300F351E72",
      symbol: "XPE",
    },
  },
  {
    id: "0x5bb8385d2c7163a339c0206af3395912edca95ad262f7f4e675262225931948f",
    name: "USDC / synUSD+",
    irm: "0x870aC11D48B15DB9a138Cf899d20F13F79Ba00BC",
    lltv: "860000000000000000",
    oracle: "0x85cBdd20E07EED48dC685B08fa1d46196c37dF6A",
    loanToken: {
      address: "0xA0b86991c6218b36c1d19D4a2e9Eb0cE3606eB48",
      symbol: "USDC",
    },
    collateralToken: {
      address: "0xD17049eD25d8f99FE3BFD10CEF2263da9995cFD8",
      symbol: "synUSD+",
    },
  },
  {
    id: "0x1b90d211812ff1bb0d9013cf67e3061b2ffeb04b80444ed445c6b8109d6f4b55",
    name: "USDC / mFARM",
    irm: "0x870aC11D48B15DB9a138Cf899d20F13F79Ba00BC",
    lltv: "860000000000000000",
    oracle: "0xeEEE04BCa2a37Aa33456c6240D9e5d54A16C06EE",
    loanToken: {
      address: "0xA0b86991c6218b36c1d19D4a2e9Eb0cE3606eB48",
      symbol: "USDC",
    },
    collateralToken: {
      address: "0xA19f6e0dF08a7917F2F8A33Db66D0AF31fF5ECA6",
      symbol: "mFARM",
    },
  },
  {
    id: "0xf86392179f6daf6031e54d6c1ca88346d8848f108d7d077c7ec7797af0d9cb0e",
    name: "USDC / eUSDe",
    irm: "0x870aC11D48B15DB9a138Cf899d20F13F79Ba00BC",
    lltv: "915000000000000000",
    oracle: "0x9c0363336Bf9DaF57a16BB4e2867459bf4Dd5EB0",
    loanToken: {
      address: "0xA0b86991c6218b36c1d19D4a2e9Eb0cE3606eB48",
      symbol: "USDC",
    },
    collateralToken: {
      address: "0x90D2af7d622ca3141efA4d8f1F24d86E5974Cc8F",
      symbol: "eUSDe",
    },
  },
  {
    id: "0x46b46943e982bf04f7b07ff37c95b539e35ccd8cf93c331cd9659398aa8f7bee",
    name: "USDC / sdeUSD",
    irm: "0x870aC11D48B15DB9a138Cf899d20F13F79Ba00BC",
    lltv: "915000000000000000",
    oracle: "0x3024b653940976443fFDEF276bdee5452540eF80",
    loanToken: {
      address: "0xA0b86991c6218b36c1d19D4a2e9Eb0cE3606eB48",
      symbol: "USDC",
    },
    collateralToken: {
      address: "0x5C5b196aBE0d54485975D1Ec29617D42D9198326",
      symbol: "sdeUSD",
    },
  },
  {
    id: "0xd925961ad5df1d12f677ff14cf20bac37ea5ef3b325d64d5a9f4c0cc013a1d47",
    name: "USDC / stUSD",
    irm: "0x870aC11D48B15DB9a138Cf899d20F13F79Ba00BC",
    lltv: "965000000000000000",
    oracle: "0xd884fa9fe289EB06Cc22667252fA6Bea87A91CC3",
    loanToken: {
      address: "0xA0b86991c6218b36c1d19D4a2e9Eb0cE3606eB48",
      symbol: "USDC",
    },
    collateralToken: {
      address: "0x0022228a2cc5E7eF0274A7Baa600d44da5aB5776",
      symbol: "stUSD",
    },
  },
  {
    id: "0x921afaedabc6597ac12ce8c0f1a8d562a2326c401ef1e3c77e861988890fc3ce",
    name: "USDC / mRe7YIELD",
    irm: "0x870aC11D48B15DB9a138Cf899d20F13F79Ba00BC",
    lltv: "915000000000000000",
    oracle: "0x62b375616E934Fd995D11eD074B918Ce3C67c7d1",
    loanToken: {
      address: "0xA0b86991c6218b36c1d19D4a2e9Eb0cE3606eB48",
      symbol: "USDC",
    },
    collateralToken: {
      address: "0x87C9053C819bB28e0D73d33059E1b3DA80AFb0cf",
      symbol: "mRe7YIELD",
    },
  },
  {
    id: "0x01e26c10a6589d17495ff9c4385502065766e7535a2f459b2c2a1b3f9015d97b",
    name: "USDC / muBOND",
    irm: "0x870aC11D48B15DB9a138Cf899d20F13F79Ba00BC",
    lltv: "860000000000000000",
    oracle: "0x270B2bD4CC6d935aa08b70eAC518E2907EB5588b",
    loanToken: {
      address: "0xA0b86991c6218b36c1d19D4a2e9Eb0cE3606eB48",
      symbol: "USDC",
    },
    collateralToken: {
      address: "0x09AD9c6DcadCc3aB0b3E107E8E7DA69c2eEa8599",
      symbol: "muBOND",
    },
  },
  {
    id: "0x53ed197357128ed96070e20ba9f5af4250cda6c67dcac5246876beb483f51303",
    name: "USDC / sDOLA",
    irm: "0x870aC11D48B15DB9a138Cf899d20F13F79Ba00BC",
    lltv: "915000000000000000",
    oracle: "0x0FB39598c4c8F5a975F2858db056B6EEf28e295D",
    loanToken: {
      address: "0xA0b86991c6218b36c1d19D4a2e9Eb0cE3606eB48",
      symbol: "USDC",
    },
    collateralToken: {
      address: "0xb45ad160634c528Cc3D2926d9807104FA3157305",
      symbol: "sDOLA",
    },
  },
  {
    id: "0x3f35b581cf7292b09fdaca648638ec8b53969e9f54ecb6ca0e6252bda70b1f64",
    name: "USDC / sUSDz",
    irm: "0x870aC11D48B15DB9a138Cf899d20F13F79Ba00BC",
    lltv: "860000000000000000",
    oracle: "0x19458F400D93817503c5bF7558624cca09f2487e",
    loanToken: {
      address: "0xA0b86991c6218b36c1d19D4a2e9Eb0cE3606eB48",
      symbol: "USDC",
    },
    collateralToken: {
      address: "0x547213367cfB08ab418E7b54d7883b2C2AA27Fd7",
      symbol: "sUSDz",
    },
  },
  {
    id: "0xfd5ce0f2493b332c4750efbdd8f0cd007781d875f00eaeb8e3d68070e8f1cc40",
    name: "USDC / thBILL",
    irm: "0x870aC11D48B15DB9a138Cf899d20F13F79Ba00BC",
    lltv: "945000000000000000",
    oracle: "0x4864B71bc19C3356A5da9140f49fa41807385833",
    loanToken: {
      address: "0xA0b86991c6218b36c1d19D4a2e9Eb0cE3606eB48",
      symbol: "USDC",
    },
    collateralToken: {
      address: "0x5FA487BCa6158c64046B2813623e20755091DA0b",
      symbol: "thBILL",
    },
  },
  {
    id: "0xf80a664057fe3cadcd9e83f27bb1effe5c15d1d2648acc7634daff1581951b5e",
    name: "USDC / PT-avUSD-14MAY2026",
    irm: "0x870aC11D48B15DB9a138Cf899d20F13F79Ba00BC",
    lltv: "915000000000000000",
    oracle: "0x0C554c29926D4f172202D6aA1E8AdDc481b3f88A",
    loanToken: {
      address: "0xA0b86991c6218b36c1d19D4a2e9Eb0cE3606eB48",
      symbol: "USDC",
    },
    collateralToken: {
      address: "0xcc16Cd49194e7AA3DCa780c742580e2f9b418874",
      symbol: "PT-avUSD-14MAY2026",
    },
  },
  {
    id: "0xebec39761882a799e54a03b97c948e07374cf5d6fc56b04c3de08bd81ca7baa3",
    name: "USDC / PT-fxSAVE-30OCT2025",
    irm: "0x870aC11D48B15DB9a138Cf899d20F13F79Ba00BC",
    lltv: "860000000000000000",
    oracle: "0x8B1dA58effb31DaF3Bbd048b1b968E2E7BBAb8fB",
    loanToken: {
      address: "0xA0b86991c6218b36c1d19D4a2e9Eb0cE3606eB48",
      symbol: "USDC",
    },
    collateralToken: {
      address: "0x21aacE56a8F21210b7E76d8eF1a77253Db85BF0a",
      symbol: "PT-fxSAVE-30OCT2025",
    },
  },
  {
    id: "0xe0b48bf58a09ae426ea172b075311369199961a004081d0aa34709cc8753f572",
    name: "USDC / PT-mAPOLLO-29JAN2026",
    irm: "0x870aC11D48B15DB9a138Cf899d20F13F79Ba00BC",
    lltv: "860000000000000000",
    oracle: "0x6C005eB4333ec2Ee220e68B772Dd4583e342b678",
    loanToken: {
      address: "0xA0b86991c6218b36c1d19D4a2e9Eb0cE3606eB48",
      symbol: "USDC",
    },
    collateralToken: {
      address: "0x955E979D243907917fda6A3a811Fb55c555b7DBA",
      symbol: "PT-mAPOLLO-29JAN2026",
    },
  },
  {
    id: "0x0dcd8a3a4db7baa6ca97ad56d67a565cce2a8f7703dbd9c230ab30a03812591b",
    name: "USDC / n-PT-sUSDe-27NOV2025",
    irm: "0x870aC11D48B15DB9a138Cf899d20F13F79Ba00BC",
    lltv: "915000000000000000",
    oracle: "0x0e61E810f0918081CBFD2aC8c97E5866DAF3F622",
    loanToken: {
      address: "0xA0b86991c6218b36c1d19D4a2e9Eb0cE3606eB48",
      symbol: "USDC",
    },
    collateralToken: {
      address: "0x0e61E810f0918081CBFD2aC8c97E5866DAF3F622",
      symbol: "n-PT-sUSDe-27NOV2025",
    },
  },
  {
    id: "0xda0a6204f5b551bc087754db6134f4154d396f738e1433bab06634559bd39728",
    name: "USDC / USDf",
    irm: "0x870aC11D48B15DB9a138Cf899d20F13F79Ba00BC",
    lltv: "915000000000000000",
    oracle: "0x4302C09ca1A51Df55A2A8F15Ca23D4Ca448E9415",
    loanToken: {
      address: "0xA0b86991c6218b36c1d19D4a2e9Eb0cE3606eB48",
      symbol: "USDC",
    },
    collateralToken: {
      address: "0xFa2B947eEc368f42195f24F36d2aF29f7c24CeC2",
      symbol: "USDf",
    },
  },
  {
    id: "0xbef47159fd478cdd8c34073b71f97ca796aad295a87192fcffc813fad60de9f4",
    name: "USDC / USD0++",
    irm: "0x870aC11D48B15DB9a138Cf899d20F13F79Ba00BC",
    lltv: "860000000000000000",
    oracle: "0x3A72F1F8e549C2398c83Fb223c178162bac2bdC3",
    loanToken: {
      address: "0xA0b86991c6218b36c1d19D4a2e9Eb0cE3606eB48",
      symbol: "USDC",
    },
    collateralToken: {
      address: "0x35D8949372D46B7a3D5A56006AE77B215fc69bC0",
      symbol: "USD0++",
    },
  },
  {
    id: "0x007feb12c442ad23b4e94975e6da43b4dc9ed4d849e34c32f75b8b72052a5b61",
    name: "USDT / reUSD",
    irm: "0x870aC11D48B15DB9a138Cf899d20F13F79Ba00BC",
    lltv: "965000000000000000",
    oracle: "0xA66a4F03Fd8031973f8C7718904ce32385f54E70",
    loanToken: {
      address: "0xdAC17F958D2ee523a2206206994597C13D831ec7",
      symbol: "USDT",
    },
    collateralToken: {
      address: "0x5086bf358635B81D8C47C66d1C8b9E567Db70c72",
      symbol: "reUSD",
    },
  },
  {
    id: "0xf385878b1d2c6581b8ec2fde0497de94f670c05f950604ded7ed13ae15ccf521",
    name: "PYUSD / sUSDe",
    irm: "0x870aC11D48B15DB9a138Cf899d20F13F79Ba00BC",
    lltv: "915000000000000000",
    oracle: "0x23b0B6a7F5941d8ed775F2f9C0D1Af99b2329410",
    loanToken: {
      address: "0x6c3ea9036406852006290770BEdFcAbA0e23A0e8",
      symbol: "PYUSD",
    },
    collateralToken: {
      address: "0x9D39A5DE30e57443BfF2A8307A4256c8797A3497",
      symbol: "sUSDe",
    },
  },
  {
    id: "0xf08d3de5dada3388281eda38fe364cb1a04867a61124d74d1cf1215b5b01b577",
    name: "PYUSD / USDe",
    irm: "0x870aC11D48B15DB9a138Cf899d20F13F79Ba00BC",
    lltv: "945000000000000000",
    oracle: "0x5AC5FE8A8a5e29EB4046D8D7979Ee6762BeEC8d7",
    loanToken: {
      address: "0x6c3ea9036406852006290770BEdFcAbA0e23A0e8",
      symbol: "PYUSD",
    },
    collateralToken: {
      address: "0x4c9EDD5852cd905f086C759E8383e09bff1E68B3",
      symbol: "USDe",
    },
  },
  {
    id: "0xed363aeae6156e0cbbee8b5226ccaa5856d07ad589884afa989d353871f41bde",
    name: "PYUSD / PT-sUSDE-5FEB2026",
    irm: "0x870aC11D48B15DB9a138Cf899d20F13F79Ba00BC",
    lltv: "915000000000000000",
    oracle: "0x0F5153C39D072039cA684Cd2A8b8E5f4c4cdbc8C",
    loanToken: {
      address: "0x6c3ea9036406852006290770BEdFcAbA0e23A0e8",
      symbol: "PYUSD",
    },
    collateralToken: {
      address: "0xE8483517077afa11A9B07f849cee2552f040d7b2",
      symbol: "PT-sUSDE-5FEB2026",
    },
  },
  {
    id: "0xe4527a28206fcbdaee78bb5655c979852d8732bdad8cc789288ebf30513df763",
    name: "PYUSD / cbBTC",
    irm: "0x870aC11D48B15DB9a138Cf899d20F13F79Ba00BC",
    lltv: "860000000000000000",
    oracle: "0x255E34A5A6b5Edd5Ea83B86a37F54974601303e5",
    loanToken: {
      address: "0x6c3ea9036406852006290770BEdFcAbA0e23A0e8",
      symbol: "PYUSD",
    },
    collateralToken: {
      address: "0xcbB7C0000aB88B473b1f5aFd9ef808440eed33Bf",
      symbol: "cbBTC",
    },
  },
  {
    id: "0xa6bef69de7561e1b18550b3963332861e3fa260f075c47e033b3b6eaf398f9ee",
    name: "PYUSD / wstETH",
    irm: "0x870aC11D48B15DB9a138Cf899d20F13F79Ba00BC",
    lltv: "860000000000000000",
    oracle: "0xF8e3f58Cb1166b7ca4A23d407c610236fC9513e0",
    loanToken: {
      address: "0x6c3ea9036406852006290770BEdFcAbA0e23A0e8",
      symbol: "PYUSD",
    },
    collateralToken: {
      address: "0x7f39C581F595B53c5cb19bD0b3f8dA6c935E2Ca0",
      symbol: "wstETH",
    },
  },
  {
    id: "0x84e9070535699d0cbea7e3c2b0a901156d4973134bc6aec6430d4c727e684ad0",
    name: "PYUSD / weETH",
    irm: "0x870aC11D48B15DB9a138Cf899d20F13F79Ba00BC",
    lltv: "860000000000000000",
    oracle: "0x6B03cA03D9BB4EEd35826B4bAb8adB9873AD04ad",
    loanToken: {
      address: "0x6c3ea9036406852006290770BEdFcAbA0e23A0e8",
      symbol: "PYUSD",
    },
    collateralToken: {
      address: "0xCd5fE23C85820F7B72D0926FC9b05b43E359b7ee",
      symbol: "weETH",
    },
  },
  {
    id: "0x6f9bb2e7aed06563a924be05f5484c70b53ec85e36652288ccafa711f847adbc",
    name: "PYUSD / syrupUSDC",
    irm: "0x870aC11D48B15DB9a138Cf899d20F13F79Ba00BC",
    lltv: "915000000000000000",
    oracle: "0xf8A3ADe50843592d23Ad9b74cE3cE6e8Aa9B6B51",
    loanToken: {
      address: "0x6c3ea9036406852006290770BEdFcAbA0e23A0e8",
      symbol: "PYUSD",
    },
    collateralToken: {
      address: "0x80ac24aA929eaF5013f6436cdA2a7ba190f5Cc0b",
      symbol: "syrupUSDC",
    },
  },
  {
    id: "0x621500846c8091e2ae2d5074025d22c7c572b5d5b5c1f4507e8ec7775c253de7",
    name: "PYUSD / WETH",
    irm: "0x870aC11D48B15DB9a138Cf899d20F13F79Ba00BC",
    lltv: "860000000000000000",
    oracle: "0x8e665b6B5EcAFfca3Ae686982Fb54909fd7294CB",
    loanToken: {
      address: "0x6c3ea9036406852006290770BEdFcAbA0e23A0e8",
      symbol: "PYUSD",
    },
    collateralToken: {
      address: "0xC02aaA39b223FE8D0A0e5C4F27eAD9083C756Cc2",
      symbol: "WETH",
    },
  },
  {
    id: "0x4004d24918579a366bb75ef1250381aa08e0f7be63532d270a7158e123dacf07",
    name: "PYUSD / weETH",
    irm: "0x870aC11D48B15DB9a138Cf899d20F13F79Ba00BC",
    lltv: "860000000000000000",
    oracle: "0x831a694505fD28d5556736ADF4276af2b5418C63",
    loanToken: {
      address: "0x6c3ea9036406852006290770BEdFcAbA0e23A0e8",
      symbol: "PYUSD",
    },
    collateralToken: {
      address: "0xCd5fE23C85820F7B72D0926FC9b05b43E359b7ee",
      symbol: "weETH",
    },
  },
  {
    id: "0x0d156fe9288317530166317b550958f3d626364bf81b85810c6569070e82444e",
    name: "PYUSD / sUSDS",
    irm: "0x870aC11D48B15DB9a138Cf899d20F13F79Ba00BC",
    lltv: "945000000000000000",
    oracle: "0x10769f96C53C038630a04FbAe2d3d838917ECAD7",
    loanToken: {
      address: "0x6c3ea9036406852006290770BEdFcAbA0e23A0e8",
      symbol: "PYUSD",
    },
    collateralToken: {
      address: "0xa3931d71877C0E7a3148CB7Eb4463524FEc27fbD",
      symbol: "sUSDS",
    },
  },
  {
    id: "0x0142390c8f7d69f2a8d03ce0fcde72221c4414477dc8635efd016506dcffa993",
    name: "PYUSD / PT-USDe-5FEB2026",
    irm: "0x870aC11D48B15DB9a138Cf899d20F13F79Ba00BC",
    lltv: "915000000000000000",
    oracle: "0x1875a14c3e0cc539C1d3ECd4533928dE671651de",
    loanToken: {
      address: "0x6c3ea9036406852006290770BEdFcAbA0e23A0e8",
      symbol: "PYUSD",
    },
    collateralToken: {
      address: "0x1F84a51296691320478c98b8d77f2Bbd17D34350",
      symbol: "PT-USDe-5FEB2026",
    },
  },
  {
    id: "0xf8cf5fa2eb32f4923b93ed06a0f491a0e9f8b1c7b30875bfe51d852b0e818adf",
    name: "USDC / wbrUSDC",
    irm: "0x870aC11D48B15DB9a138Cf899d20F13F79Ba00BC",
    lltv: "860000000000000000",
    oracle: "0x824D21500634c9bb0f3877541Dbe5ea5e3Ad98d3",
    loanToken: {
      address: "0xA0b86991c6218b36c1d19D4a2e9Eb0cE3606eB48",
      symbol: "USDC",
    },
    collateralToken: {
      address: "0x3EBFa39649EFb8aa0B4e8dCCCd25884D8223c1ee",
      symbol: "wbrUSDC",
    },
  },
  {
    id: "0xd86f7cdb5ed3cf87b69524056c7a9e239243b42ff67381611a366f99236fb5c5",
    name: "USDC / fUSDC",
    irm: "0x870aC11D48B15DB9a138Cf899d20F13F79Ba00BC",
    lltv: "980000000000000000",
    oracle: "0x653f9EB445343E38758916879f6eDd42644a4866",
    loanToken: {
      address: "0xA0b86991c6218b36c1d19D4a2e9Eb0cE3606eB48",
      symbol: "USDC",
    },
    collateralToken: {
      address: "0xb0f05E4De970A1aaf77f8C2F823953a367504BA9",
      symbol: "fUSDC",
    },
  },
  {
    id: "0xd570d9dbcbeff6bbf1be58686f607461c3209248cc83c1909c390f83300b53c4",
    name: "USDC / wbravUSDC",
    irm: "0x870aC11D48B15DB9a138Cf899d20F13F79Ba00BC",
    lltv: "860000000000000000",
    oracle: "0x824D21500634c9bb0f3877541Dbe5ea5e3Ad98d3",
    loanToken: {
      address: "0xA0b86991c6218b36c1d19D4a2e9Eb0cE3606eB48",
      symbol: "USDC",
    },
    collateralToken: {
      address: "0x7309E1E2e74af170c69bdE8FCB30397f8697D5FF",
      symbol: "wbravUSDC",
    },
  },
  {
    id: "0xcca57e45414f653507085d7ddcb827c06405745b4beef37c43ff1452c40c7c17",
    name: "USDC / PT-sYUSD-4SEP2025",
    irm: "0x870aC11D48B15DB9a138Cf899d20F13F79Ba00BC",
    lltv: "915000000000000000",
    oracle: "0x64E1e830DC063634ad1e256F9Eb190e1A98f724C",
    loanToken: {
      address: "0xA0b86991c6218b36c1d19D4a2e9Eb0cE3606eB48",
      symbol: "USDC",
    },
    collateralToken: {
      address: "0x61d799b23C938220D27fC03Ad2044A7AA891fE81",
      symbol: "PT-sYUSD-4SEP2025",
    },
  },
  {
    id: "0xc847119d9432c41b9813407890b2c451905ba54fdafa54074e686f49ab7d7555",
    name: "USDC / PT-fxSAVE-30OCT2025",
    irm: "0x870aC11D48B15DB9a138Cf899d20F13F79Ba00BC",
    lltv: "860000000000000000",
    oracle: "0x8fFfFfd4AfB6115b954Bd326cbe7B4BA576818f6",
    loanToken: {
      address: "0xA0b86991c6218b36c1d19D4a2e9Eb0cE3606eB48",
      symbol: "USDC",
    },
    collateralToken: {
      address: "0x21aacE56a8F21210b7E76d8eF1a77253Db85BF0a",
      symbol: "PT-fxSAVE-30OCT2025",
    },
  },
  {
    id: "0xc0a2d21761551c5edb963147392f4b6b1136b749f320ea34ae7d06b364f8495e",
    name: "USDC / cUSDOUSDC",
    irm: "0x870aC11D48B15DB9a138Cf899d20F13F79Ba00BC",
    lltv: "915000000000000000",
    oracle: "0xb208bFDf2A129386d7f1617D8498a69d2553f949",
    loanToken: {
      address: "0xA0b86991c6218b36c1d19D4a2e9Eb0cE3606eB48",
      symbol: "USDC",
    },
    collateralToken: {
      address: "0x90455bd11Ce8a67C57d467e634Dc142b8e4105Aa",
      symbol: "cUSDOUSDC",
    },
  },
  {
    id: "0x98a5ad6eeefffce964a612864209b9dfb7e623bfc4f7b3a4a647e13084fc77b7",
    name: "USDC / BGBTC",
    irm: "0x870aC11D48B15DB9a138Cf899d20F13F79Ba00BC",
    lltv: "860000000000000000",
    oracle: "0x4cA59dFDaa1dec4AC92fEe1f80Fb1e42147E6273",
    loanToken: {
      address: "0xA0b86991c6218b36c1d19D4a2e9Eb0cE3606eB48",
      symbol: "USDC",
    },
    collateralToken: {
      address: "0x0520930F21b14Cafac7a27b102487beE7138a017",
      symbol: "BGBTC",
    },
  },
  {
    id: "0x7d0a8c42924a2e9ca96faf5bce7739e31ec1616e8cf84425b9756f56d82e066b",
    name: "USDC / PAXG",
    irm: "0x870aC11D48B15DB9a138Cf899d20F13F79Ba00BC",
    lltv: "860000000000000000",
    oracle: "0xa0514F4035F013941cf63C203dCED759C95CFACE",
    loanToken: {
      address: "0xA0b86991c6218b36c1d19D4a2e9Eb0cE3606eB48",
      symbol: "USDC",
    },
    collateralToken: {
      address: "0x45804880De22913dAFE09f4980848ECE6EcbAf78",
      symbol: "PAXG",
    },
  },
  {
    id: "0x58be32c84615ad07826b10a1b73cacd103b70c5f92bb2569c45f2ef6b4832e87",
    name: "USDC / CHYUSD",
    irm: "0x870aC11D48B15DB9a138Cf899d20F13F79Ba00BC",
    lltv: "980000000000000000",
    oracle: "0xFFa25c2A3A2b2632e3CC1E028fdBe7af4e22C62a",
    loanToken: {
      address: "0xA0b86991c6218b36c1d19D4a2e9Eb0cE3606eB48",
      symbol: "USDC",
    },
    collateralToken: {
      address: "0xcD4190c8D631D32a73488FF2A96E1cd92fFEa560",
      symbol: "CHYUSD",
    },
  },
  {
    id: "0x486cee17fb967ec0235388fa7fdcd24082ae1c2842a4a5dda0d01960117ce52e",
    name: "USDC / syrupUSDC",
    irm: "0x870aC11D48B15DB9a138Cf899d20F13F79Ba00BC",
    lltv: "860000000000000000",
    oracle: "0x426e271cD65cf6745C729Fcc09CF2295BF444f80",
    loanToken: {
      address: "0xA0b86991c6218b36c1d19D4a2e9Eb0cE3606eB48",
      symbol: "USDC",
    },
    collateralToken: {
      address: "0x80ac24aA929eaF5013f6436cdA2a7ba190f5Cc0b",
      symbol: "syrupUSDC",
    },
  },
  {
    id: "0x41804f16e23280afd7dedc15c7c4675d44259c71699b565826684dd512dc0127",
    name: "USDC / cbBTC",
    irm: "0x870aC11D48B15DB9a138Cf899d20F13F79Ba00BC",
    lltv: "860000000000000000",
    oracle: "0xA93e3B4A671F2E84b62e6A5845F98292c802484d",
    loanToken: {
      address: "0xA0b86991c6218b36c1d19D4a2e9Eb0cE3606eB48",
      symbol: "USDC",
    },
    collateralToken: {
      address: "0xcbB7C0000aB88B473b1f5aFd9ef808440eed33Bf",
      symbol: "cbBTC",
    },
  },
  {
    id: "0x3593fc5578aef832953314d7a54ded669e614ccdf2a586954e7de61d2b29a42d",
    name: "USDC / wUSDL",
    irm: "0x870aC11D48B15DB9a138Cf899d20F13F79Ba00BC",
    lltv: "965000000000000000",
    oracle: "0x0A1577C7EcA50871EeCAb68E799F2EFa69F1fa96",
    loanToken: {
      address: "0xA0b86991c6218b36c1d19D4a2e9Eb0cE3606eB48",
      symbol: "USDC",
    },
    collateralToken: {
      address: "0x7751E2F4b8ae93EF6B79d86419d42FE3295A4559",
      symbol: "wUSDL",
    },
  },
  {
    id: "0x28c028a1af0fa01da5b9c46bb8d999e3e8e65b8304edc09fd8cbaef03a64cb35",
    name: "USDC / ezETH",
    irm: "0x870aC11D48B15DB9a138Cf899d20F13F79Ba00BC",
    lltv: "770000000000000000",
    oracle: "0x895f9dF47F8a68396eD026978A0771C120DFC279",
    loanToken: {
      address: "0xA0b86991c6218b36c1d19D4a2e9Eb0cE3606eB48",
      symbol: "USDC",
    },
    collateralToken: {
      address: "0xbf5495Efe5DB9ce00f80364C8B423567e58d2110",
      symbol: "ezETH",
    },
  },
  {
    id: "0x19b2dc518e70f0b562a69d1a29edba38638970c9bc3c2f84a8a87548f6c6f53c",
    name: "USDC / SAND",
    irm: "0x870aC11D48B15DB9a138Cf899d20F13F79Ba00BC",
    lltv: "625000000000000000",
    oracle: "0xC7dFBF97067BA3Bcf69FBDF4BBBae7C71CF5538D",
    loanToken: {
      address: "0xA0b86991c6218b36c1d19D4a2e9Eb0cE3606eB48",
      symbol: "USDC",
    },
    collateralToken: {
      address: "0x3845badAde8e6dFF049820680d1F14bD3903a5d0",
      symbol: "SAND",
    },
  },
  {
    id: "0x0f7d9d8eb89097a0addacda1b3fe12fb7ce1ee3a6fd9059d9e67395389005819",
    name: "USDC / PT-USDe-26DEC2024",
    irm: "0x870aC11D48B15DB9a138Cf899d20F13F79Ba00BC",
    lltv: "945000000000000000",
    oracle: "0x81E5E28F33D314e9211885d6f0F4080E755e4595",
    loanToken: {
      address: "0xA0b86991c6218b36c1d19D4a2e9Eb0cE3606eB48",
      symbol: "USDC",
    },
    collateralToken: {
      address: "0xA8778DD6B7f1F61f2CFda5D3cB18be8F99A8dB30",
      symbol: "PT-USDe-26DEC2024",
    },
  },
  {
    id: "0x08535810feadf52d61a182dc7a12ba78f9b38a829ee477e0e1d488d4e262bc0a",
    name: "USDC / wbIB01",
    irm: "0x870aC11D48B15DB9a138Cf899d20F13F79Ba00BC",
    lltv: "965000000000000000",
    oracle: "0x6E8F5b2DF218443E87fe8aA9811E6956716dde88",
    loanToken: {
      address: "0xA0b86991c6218b36c1d19D4a2e9Eb0cE3606eB48",
      symbol: "USDC",
    },
    collateralToken: {
      address: "0xABC56186c2Df63C338E04C9C9B9814E27983a5a9",
      symbol: "wbIB01",
    },
  },
  {
    id: "0x079e3888506e348c01f59739d61542602410126285f519c522997da45e7beb01",
    name: "USDC / sYUSD",
    irm: "0x870aC11D48B15DB9a138Cf899d20F13F79Ba00BC",
    lltv: "915000000000000000",
    oracle: "0x43bF68618e8f0B51B540Af386A9d8e9fc83Eee1f",
    loanToken: {
      address: "0xA0b86991c6218b36c1d19D4a2e9Eb0cE3606eB48",
      symbol: "USDC",
    },
    collateralToken: {
      address: "0xfE0ccc9942E98C963Fe6b4e5194EB6e3Baa4cb64",
      symbol: "sYUSD",
    },
  },
  {
    id: "0x02e207d9f2b7dac5d32cc9768b3e1225b9560f79c1c1132f35e3488b9331606b",
    name: "USDC / yUSD",
    irm: "0x870aC11D48B15DB9a138Cf899d20F13F79Ba00BC",
    lltv: "915000000000000000",
    oracle: "0x3660c76f620d70B957B4CA190455126E89D6454b",
    loanToken: {
      address: "0xA0b86991c6218b36c1d19D4a2e9Eb0cE3606eB48",
      symbol: "USDC",
    },
    collateralToken: {
      address: "0x19Ebd191f7A24ECE672ba13A302212b5eF7F35cb",
      symbol: "yUSD",
    },
  },
  {
    id: "0x02004e867fcd99902ea3177f68be26ab411e351d661a95ac1ecb6e770ccfd948",
    name: "USDC / sDOLA",
    irm: "0x870aC11D48B15DB9a138Cf899d20F13F79Ba00BC",
    lltv: "915000000000000000",
    oracle: "0xcc90D7AfE71fBF17FD15846EBC0ab24b007a4A51",
    loanToken: {
      address: "0xA0b86991c6218b36c1d19D4a2e9Eb0cE3606eB48",
      symbol: "USDC",
    },
    collateralToken: {
      address: "0xb45ad160634c528Cc3D2926d9807104FA3157305",
      symbol: "sDOLA",
    },
  },
  {
    id: "0xa661899c2e4d51d5c535b6d1c662e1100247dd9d50ae177c4ccc9b14c6e6452d",
    name: "USDC / sUSDat",
    irm: "0x870aC11D48B15DB9a138Cf899d20F13F79Ba00BC",
    lltv: "860000000000000000",
    oracle: "0x8ef55279cA19d92Be84Da098fE23521274e6D90F",
    loanToken: {
      address: "0xA0b86991c6218b36c1d19D4a2e9Eb0cE3606eB48",
      symbol: "USDC",
    },
    collateralToken: {
      address: "0xD166337499E176bbC38a1FBd113Ab144e5bd2Df7",
      symbol: "sUSDat",
    },
  },
  {
    id: "0x76644bda0487e0babf76033d2abf2f4e1f966cb15144791a678e857e3e1771ad",
    name: "USDC / wJAAA",
    irm: "0x870aC11D48B15DB9a138Cf899d20F13F79Ba00BC",
    lltv: "980000000000000000",
    oracle: "0xe420b3609aE4eBE9A1AA48F7dd5250bac337e016",
    loanToken: {
      address: "0xA0b86991c6218b36c1d19D4a2e9Eb0cE3606eB48",
      symbol: "USDC",
    },
    collateralToken: {
      address: "0x86b495e4Cb00AB18Ad94BFD7920479cC79E8eBFE",
      symbol: "wJAAA",
    },
  },
  {
    id: "0x60977eff30f04afef416234f4c67160b339f7429fc334888c522896c1c5808f1",
    name: "USDC / USP",
    irm: "0x870aC11D48B15DB9a138Cf899d20F13F79Ba00BC",
    lltv: "915000000000000000",
    oracle: "0x5096642B7c7CD82198932f3FADd873EC2fcDeb6d",
    loanToken: {
      address: "0xA0b86991c6218b36c1d19D4a2e9Eb0cE3606eB48",
      symbol: "USDC",
    },
    collateralToken: {
      address: "0x098697bA3Fee4eA76294C5d6A466a4e3b3E95FE6",
      symbol: "USP",
    },
  },
  {
    id: "0x9182ad77d7a3072f123c4742c307032af2e519f774bb53f69f722feda188df70",
    name: "USDC / vstETH",
    irm: "0x870aC11D48B15DB9a138Cf899d20F13F79Ba00BC",
    lltv: "915000000000000000",
    oracle: "0x0a6600f1842a73397a4e1CF4fd3DBab264892493",
    loanToken: {
      address: "0xA0b86991c6218b36c1d19D4a2e9Eb0cE3606eB48",
      symbol: "USDC",
    },
    collateralToken: {
      address: "0x63C3c33B2EF500E0511246d4cecA5e835685F139",
      symbol: "vstETH",
    },
  },
  {
    id: "0x742efab696c509335be872513b85a73e4afa79d1bdf04af933879dbae79be928",
    name: "USDC / PT-USDe-13AUG2026",
    irm: "0x870aC11D48B15DB9a138Cf899d20F13F79Ba00BC",
    lltv: "860000000000000000",
    oracle: "0xd9CFA6f7C2ca375eFdcc29Ec5Ad629aBF90aAb4b",
    loanToken: {
      address: "0xA0b86991c6218b36c1d19D4a2e9Eb0cE3606eB48",
      symbol: "USDC",
    },
    collateralToken: {
      address: "0x3EC43F4158D51df0928979c09Eaf33CAd287065c",
      symbol: "PT-USDe-13AUG2026",
    },
  },
  {
    id: "0x16a5dc0b52439b0035d64adca97a5f1fedb2572e772589d4d7c0238904d0e4ff",
    name: "USDC / PT-ROY-ST-apyUSD-5NOV2026",
    irm: "0x870aC11D48B15DB9a138Cf899d20F13F79Ba00BC",
    lltv: "915000000000000000",
    oracle: "0xE4fb5e69e1D38776Af1e8fE6aC361720205393Ff",
    loanToken: {
      address: "0xA0b86991c6218b36c1d19D4a2e9Eb0cE3606eB48",
      symbol: "USDC",
    },
    collateralToken: {
      address: "0x44Db865Cc6D5768703fb5Bf73dfB7A5a0f95c1fc",
      symbol: "PT-ROY-ST-apyUSD-5NOV2026",
    },
  },
  {
    id: "0x6ef28d46304865e837deff752bbf28defcdbe51b28f0a557640fbea3dd1778f5",
    name: "USDC / PT-USDat-27AUG2026",
    irm: "0x870aC11D48B15DB9a138Cf899d20F13F79Ba00BC",
    lltv: "915000000000000000",
    oracle: "0x7BBc859dfAee3121a6b809Bb5e245A9Ec87cb185",
    loanToken: {
      address: "0xA0b86991c6218b36c1d19D4a2e9Eb0cE3606eB48",
      symbol: "USDC",
    },
    collateralToken: {
      address: "0x1D69402390657308C91179aa184bF992908c1e08",
      symbol: "PT-USDat-27AUG2026",
    },
  },
  {
    id: "0xeab4d18495fdb5ce6ff92b55006af078848f556e4c3d98721ab24d1367e7e500",
    name: "USDC / PT-apyUSD-5NOV2026",
    irm: "0x870aC11D48B15DB9a138Cf899d20F13F79Ba00BC",
    lltv: "915000000000000000",
    oracle: "0xB25d1f065384352eb42245eBceDFE84bDf7E3f38",
    loanToken: {
      address: "0xA0b86991c6218b36c1d19D4a2e9Eb0cE3606eB48",
      symbol: "USDC",
    },
    collateralToken: {
      address: "0xb5Be35D8fF83D431899b95851CB17a2B4bcEF150",
      symbol: "PT-apyUSD-5NOV2026",
    },
  },
  {
    id: "0x515f1e5c612e4be9e6919d396c439db0d65f43a1fe3716bd66b7c6f2d19a5eb6",
    name: "USDC / PT-apxUSD-5NOV2026",
    irm: "0x870aC11D48B15DB9a138Cf899d20F13F79Ba00BC",
    lltv: "915000000000000000",
    oracle: "0x75d40808FEd3E64949283CA12B38AE9e82FB73cc",
    loanToken: {
      address: "0xA0b86991c6218b36c1d19D4a2e9Eb0cE3606eB48",
      symbol: "USDC",
    },
    collateralToken: {
      address: "0xAF687B5EcB525Ccea96115088999B4eD80C388b6",
      symbol: "PT-apxUSD-5NOV2026",
    },
  },
  {
    id: "0x90a4382a754f05777ba714ba9617ec5162276a485687adaf97ac8429c72c5557",
    name: "USDC / MORPHO",
    irm: "0x870aC11D48B15DB9a138Cf899d20F13F79Ba00BC",
    lltv: "385000000000000000",
    oracle: "0x5E2BCf25Ef638721dD29D0CDcf85734909a6fFcE",
    loanToken: {
      address: "0xA0b86991c6218b36c1d19D4a2e9Eb0cE3606eB48",
      symbol: "USDC",
    },
    collateralToken: {
      address: "0x58D97B57BB95320F9a05dC918Aef65434969c2B2",
      symbol: "MORPHO",
    },
  },
  {
    id: "0x82835f18fa6188d39bb5ae3d00129dd524da76822e6e6398876b550518e8183f",
    name: "USDC / COMP",
    irm: "0x870aC11D48B15DB9a138Cf899d20F13F79Ba00BC",
    lltv: "385000000000000000",
    oracle: "0xEEcD66e6C723c1506532a5f646cC8a502c026A2E",
    loanToken: {
      address: "0xA0b86991c6218b36c1d19D4a2e9Eb0cE3606eB48",
      symbol: "USDC",
    },
    collateralToken: {
      address: "0xc00e94Cb662C3520282E6f5717214004A7f26888",
      symbol: "COMP",
    },
  },
  {
    id: "0x64970e63ae53b591ad89c8233df76ee828466b9c69d85e0e5dc3c1bad40101cb",
    name: "USDC / PT-apyUSD-5NOV2026",
    irm: "0x870aC11D48B15DB9a138Cf899d20F13F79Ba00BC",
    lltv: "860000000000000000",
    oracle: "0xB25d1f065384352eb42245eBceDFE84bDf7E3f38",
    loanToken: {
      address: "0xA0b86991c6218b36c1d19D4a2e9Eb0cE3606eB48",
      symbol: "USDC",
    },
    collateralToken: {
      address: "0xb5Be35D8fF83D431899b95851CB17a2B4bcEF150",
      symbol: "PT-apyUSD-5NOV2026",
    },
  },
  {
    id: "0x95ec96cfdff5bd687751498df994f8dc172f5d27a3fabce143a6eb514c84fecf",
    name: "USDC / PT-apxUSD-5NOV2026",
    irm: "0x870aC11D48B15DB9a138Cf899d20F13F79Ba00BC",
    lltv: "860000000000000000",
    oracle: "0x75d40808FEd3E64949283CA12B38AE9e82FB73cc",
    loanToken: {
      address: "0xA0b86991c6218b36c1d19D4a2e9Eb0cE3606eB48",
      symbol: "USDC",
    },
    collateralToken: {
      address: "0xAF687B5EcB525Ccea96115088999B4eD80C388b6",
      symbol: "PT-apxUSD-5NOV2026",
    },
  },
  {
    id: "0xfc1d88fb47ab16a5dd223153125fc09fd960229f93301f19ce9347e1e28e77de",
    name: "USDC / SPYx",
    irm: "0x870aC11D48B15DB9a138Cf899d20F13F79Ba00BC",
    lltv: "860000000000000000",
    oracle: "0x7961a27E1414569AD11B046FFE6cd41Fc6Fcd4d5",
    loanToken: {
      address: "0xA0b86991c6218b36c1d19D4a2e9Eb0cE3606eB48",
      symbol: "USDC",
    },
    collateralToken: {
      address: "0x90A2a4c76b5D8c0bc892A69EA28Aa775a8f2dD48",
      symbol: "SPYx",
    },
  },
  {
    id: "0x7121f5248fd9db99698275f4ad0f8237639fd6905fac1d1e351483996845c868",
    name: "USDC / CRNC",
    irm: "0x870aC11D48B15DB9a138Cf899d20F13F79Ba00BC",
    lltv: "385000000000000000",
    oracle: "0xC346ee27a56a9E95481D460cdc0aD49E752E3881",
    loanToken: {
      address: "0xA0b86991c6218b36c1d19D4a2e9Eb0cE3606eB48",
      symbol: "USDC",
    },
    collateralToken: {
      address: "0x47d13Fb0803409c7fE169A210d4e906165F1A432",
      symbol: "CRNC",
    },
  },
  {
    id: "0x90f336c58b38a736508e12102b09b58edbb8fb3b149b380e441d45992d3c7b58",
    name: "WETH / weETH",
    irm: "0x870aC11D48B15DB9a138Cf899d20F13F79Ba00BC",
    lltv: "860000000000000000",
    oracle: "0xf0b45bf9C58245Ca4E978810E72B3f18A3f0A68d",
    loanToken: {
      address: "0xC02aaA39b223FE8D0A0e5C4F27eAD9083C756Cc2",
      symbol: "WETH",
    },
    collateralToken: {
      address: "0xCd5fE23C85820F7B72D0926FC9b05b43E359b7ee",
      symbol: "weETH",
    },
  },
  {
    id: "0x218330d3957ce196ec9829f8bfaf0d30d1dca34ce38cf1faa9a034f275692f86",
    name: "USDT / PT-csUSDL-30OCT2025",
    irm: "0x870aC11D48B15DB9a138Cf899d20F13F79Ba00BC",
    lltv: "915000000000000000",
    oracle: "0x82dBE10a7D516D8F8b532570134faA81eA63FC51",
    loanToken: {
      address: "0xdAC17F958D2ee523a2206206994597C13D831ec7",
      symbol: "USDT",
    },
    collateralToken: {
      address: "0xDBf6feC5A012A13c456Bac3B67C3B9CF2830A122",
      symbol: "PT-csUSDL-30OCT2025",
    },
  },
  {
    id: "0xe70609f7ae7fb0488f3603011d4cf669d2e97d15b3d9e3d9d229f768c58982a6",
    name: "USDC / QQQon",
    irm: "0x870aC11D48B15DB9a138Cf899d20F13F79Ba00BC",
    lltv: "915000000000000000",
    oracle: "0x78a9d9BCae51Da68e8A706020B2e895a935Da52C",
    loanToken: {
      address: "0xA0b86991c6218b36c1d19D4a2e9Eb0cE3606eB48",
      symbol: "USDC",
    },
    collateralToken: {
      address: "0x0e397938C1Aa0680954093495B70A9F5e2249aBa",
      symbol: "QQQon",
    },
  },
  {
    id: "0x8e43106df7e0363799313c9899df3fa83e6f5721ba80849642ac6912da666292",
    name: "USDC / splDXY-BEAR",
    irm: "0x870aC11D48B15DB9a138Cf899d20F13F79Ba00BC",
    lltv: "915000000000000000",
    oracle: "0x6000671B89D9B75116242E5Cf3c3DD7eC0518C2e",
    loanToken: {
      address: "0xA0b86991c6218b36c1d19D4a2e9Eb0cE3606eB48",
      symbol: "USDC",
    },
    collateralToken: {
      address: "0xDC7366b8BB83f9ABa2B4F989194D6c03D0A20DE9",
      symbol: "splDXY-BEAR",
    },
  },
  {
    id: "0x811e0e5b937027b87b7b0c1bfa5db9d22109db4df0f445adc6124cd4ed577584",
    name: "USDC / splDXY-BULL",
    irm: "0x870aC11D48B15DB9a138Cf899d20F13F79Ba00BC",
    lltv: "915000000000000000",
    oracle: "0xDC1FD8aE5A5880cFdCbC673696812E6bd8C83bB5",
    loanToken: {
      address: "0xA0b86991c6218b36c1d19D4a2e9Eb0cE3606eB48",
      symbol: "USDC",
    },
    collateralToken: {
      address: "0x8dbcF452799f50D3382105a19FdBfA57B7f29C73",
      symbol: "splDXY-BULL",
    },
  },
  {
    id: "0x7a55f61fa31bb0a0a5801e6ad0834d1489966269b5791677daed9e50aaafabc4",
    name: "USDC / ozWTI",
    irm: "0x870aC11D48B15DB9a138Cf899d20F13F79Ba00BC",
    lltv: "625000000000000000",
    oracle: "0x7B13fb7Faf68Df75414271349f8e65149c131890",
    loanToken: {
      address: "0xA0b86991c6218b36c1d19D4a2e9Eb0cE3606eB48",
      symbol: "USDC",
    },
    collateralToken: {
      address: "0x6a1327C22A5df76eF75E110C09Ad0Fa574376dd9",
      symbol: "ozWTI",
    },
  },
  {
    id: "0x935faae97f5784dc97fba3c6ec072186ad9dbbf16368431c38f6a8b7fc3ec9a3",
    name: "WETH / cbBTC",
    irm: "0x870aC11D48B15DB9a138Cf899d20F13F79Ba00BC",
    lltv: "915000000000000000",
    oracle: "0x0fd64ae6F4Ec9862D70018a594c8e6c5b42c2E10",
    loanToken: {
      address: "0xC02aaA39b223FE8D0A0e5C4F27eAD9083C756Cc2",
      symbol: "WETH",
    },
    collateralToken: {
      address: "0xcbB7C0000aB88B473b1f5aFd9ef808440eed33Bf",
      symbol: "cbBTC",
    },
  },
  {
    id: "0xe7b31a8f3e15de84e9cc2799c1be7ed0e2eb2ddfc5d9e9eebc9ae850a59d0e11",
    name: "WETH / mHyperETH",
    irm: "0x870aC11D48B15DB9a138Cf899d20F13F79Ba00BC",
    lltv: "860000000000000000",
    oracle: "0x3E959aABee627531631F28EC59bfDcf98460a139",
    loanToken: {
      address: "0xC02aaA39b223FE8D0A0e5C4F27eAD9083C756Cc2",
      symbol: "WETH",
    },
    collateralToken: {
      address: "0x5a42864b14C0C8241EF5ab62Dae975b163a2E0C1",
      symbol: "mHyperETH",
    },
  },
  {
    id: "0x20c488469064c8e2f892dab33e8c7a631260817f0db57f7425d4ef1d126efccb",
    name: "WETH / Re7wstETH",
    irm: "0x870aC11D48B15DB9a138Cf899d20F13F79Ba00BC",
    lltv: "915000000000000000",
    oracle: "0xe7AC06781c7F26287f0CA6f140fFB420C3262Efa",
    loanToken: {
      address: "0xC02aaA39b223FE8D0A0e5C4F27eAD9083C756Cc2",
      symbol: "WETH",
    },
    collateralToken: {
      address: "0xE87ed29896B91421ff43f69257ABF78300e40c7a",
      symbol: "Re7wstETH",
    },
  },
  {
    id: "0x89f9fe93b1b68accc76fe10e4564aaebd4021e9abdab59eb66ffca001814c41e",
    name: "WETH / tacETH",
    irm: "0x870aC11D48B15DB9a138Cf899d20F13F79Ba00BC",
    lltv: "965000000000000000",
    oracle: "0xDF92B3AEB96801892436BBBe108bb1deB66D62a6",
    loanToken: {
      address: "0xC02aaA39b223FE8D0A0e5C4F27eAD9083C756Cc2",
      symbol: "WETH",
    },
    collateralToken: {
      address: "0x294eecec65A0142e84AEdfD8eB2FBEA8c9a9fbad",
      symbol: "tacETH",
    },
  },
  {
    id: "0x0e09fd645a1f79b76aa54d0ca5a10a8aac0f031c179b6e1874ef6e9d5d588ad6",
    name: "WETH / fxUSD",
    irm: "0x870aC11D48B15DB9a138Cf899d20F13F79Ba00BC",
    lltv: "915000000000000000",
    oracle: "0xdd12F3312a14F33324184de8501ca65D615B67c5",
    loanToken: {
      address: "0xC02aaA39b223FE8D0A0e5C4F27eAD9083C756Cc2",
      symbol: "WETH",
    },
    collateralToken: {
      address: "0x085780639CC2cACd35E474e71f4d000e2405d8f6",
      symbol: "fxUSD",
    },
  },
  {
    id: "0x5515887d77d35194eb470be99935bfa93e1b929f7e91f96f4861956d66993a9c",
    name: "WETH / pufETH",
    irm: "0x870aC11D48B15DB9a138Cf899d20F13F79Ba00BC",
    lltv: "945000000000000000",
    oracle: "0x01AC47317b7A6cB6A5aCd7EBFf997Ce71BD4e5a9",
    loanToken: {
      address: "0xC02aaA39b223FE8D0A0e5C4F27eAD9083C756Cc2",
      symbol: "WETH",
    },
    collateralToken: {
      address: "0xD9A442856C234a39a81a089C06451EBAa4306a72",
      symbol: "pufETH",
    },
  },
  {
    id: "0xf71dd07a296bb3ea5ecbe51d7ca667dcd8bd3446911169f40f632a391ab250cb",
    name: "USDe / PT-sUSDE-29MAY2025",
    irm: "0x870aC11D48B15DB9a138Cf899d20F13F79Ba00BC",
    lltv: "915000000000000000",
    oracle: "0x765AF645885A82b1d48EDd2443d33a2b4C0b61d8",
    loanToken: {
      address: "0x4c9EDD5852cd905f086C759E8383e09bff1E68B3",
      symbol: "USDe",
    },
    collateralToken: {
      address: "0xb7de5dFCb74d25c2f21841fbd6230355C50d9308",
      symbol: "PT-sUSDE-29MAY2025",
    },
  },
  {
    id: "0xfff1970c0ffae288764186fbb38a9171a17e98676744a1e345809cb8b9e73342",
    name: "USDC / ysUSDS",
    irm: "0x870aC11D48B15DB9a138Cf899d20F13F79Ba00BC",
    lltv: "965000000000000000",
    oracle: "0xd6154930A8df0A488Fae08547E53221B572EEA37",
    loanToken: {
      address: "0xA0b86991c6218b36c1d19D4a2e9Eb0cE3606eB48",
      symbol: "USDC",
    },
    collateralToken: {
      address: "0x4cE9c93513DfF543Bc392870d57dF8C04e89Ba0a",
      symbol: "ysUSDS",
    },
  },
  {
    id: "0xffd010618ed3cb39bb2c5de0e3e58d3d2ec9f52187a180f29723c31756a939bc",
    name: "RLUSD / cbBTC",
    irm: "0x870aC11D48B15DB9a138Cf899d20F13F79Ba00BC",
    lltv: "860000000000000000",
    oracle: "0x8b36909dD84d310CBDe90cb286d9dAB285a245bd",
    loanToken: {
      address: "0x8292Bb45bf1Ee4d140127049757C2E0fF06317eD",
      symbol: "RLUSD",
    },
    collateralToken: {
      address: "0xcbB7C0000aB88B473b1f5aFd9ef808440eed33Bf",
      symbol: "cbBTC",
    },
  },
  {
    id: "0xff348c8e791bf76241fcc9e4516788b379bdc9f5e18d0ab8fe8591cfa0377a53",
    name: "MUSD / wbravUSDC",
    irm: "0x870aC11D48B15DB9a138Cf899d20F13F79Ba00BC",
    lltv: "860000000000000000",
    oracle: "0xF1b5974831a159f3ddE2e0df342350356892bCC6",
    loanToken: {
      address: "0xdD468A1DDc392dcdbEf6db6e34E89AA338F9F186",
      symbol: "MUSD",
    },
    collateralToken: {
      address: "0x7309E1E2e74af170c69bdE8FCB30397f8697D5FF",
      symbol: "wbravUSDC",
    },
  },
  {
    id: "0xfddc016e0c3db77c2257e26244e238d974cb2e62bfdededc2d22b5290497417b",
    name: "USDC / PT-mMEV-29JAN2026",
    irm: "0x870aC11D48B15DB9a138Cf899d20F13F79Ba00BC",
    lltv: "915000000000000000",
    oracle: "0xe22ED8B23eD665D2AB509f6eD7C183cECDaA2318",
    loanToken: {
      address: "0xA0b86991c6218b36c1d19D4a2e9Eb0cE3606eB48",
      symbol: "USDC",
    },
    collateralToken: {
      address: "0x2c543181871718C05bB191B8CE8F2A6538D72762",
      symbol: "PT-mMEV-29JAN2026",
    },
  },
  {
    id: "0xfd9b94f927f321fe65ffe15ffa3e6cea508d2b3f96326c5bd8ee338de55cc13b",
    name: "USDCV / LBTC",
    irm: "0x870aC11D48B15DB9a138Cf899d20F13F79Ba00BC",
    lltv: "860000000000000000",
    oracle: "0x7D00CEBb5118006AeEDf8f7cDF011d90180E0aFd",
    loanToken: {
      address: "0x5422374B27757da72d5265cC745ea906E0446634",
      symbol: "USDCV",
    },
    collateralToken: {
      address: "0x8236a87084f8B84306f72007F36F2618A5634494",
      symbol: "LBTC",
    },
  },
  {
    id: "0xfd4f9cb9e9f0327884def8393e696a2a752dbcf9184f7bbe840469c5c602bb19",
    name: "frxUSD / wstLINK",
    irm: "0x870aC11D48B15DB9a138Cf899d20F13F79Ba00BC",
    lltv: "770000000000000000",
    oracle: "0x5a88029427D98f5DDcE56E010f25B3C55404608B",
    loanToken: {
      address: "0xCAcd6fd266aF91b8AeD52aCCc382b4e165586E29",
      symbol: "frxUSD",
    },
    collateralToken: {
      address: "0x911D86C72155c33993d594B0Ec7E6206B4C803da",
      symbol: "wstLINK",
    },
  },
  {
    id: "0xfd33abdf7da81ad6b453d6b1c265fb4296809bebd9cb51d729ebe12609866d52",
    name: "lvWETH / lvstETH",
    irm: "0x870aC11D48B15DB9a138Cf899d20F13F79Ba00BC",
    lltv: "945000000000000000",
    oracle: "0x36a4690388890b4B5A7661e9f5a50c5Ea5cc9E14",
    loanToken: {
      address: "0xdfCD90269d39e3eD42f47d46f30688d27e05f541",
      symbol: "lvWETH",
    },
    collateralToken: {
      address: "0xA0fbd90aF6625a5F69f7899b81B5BfB67BAEE427",
      symbol: "lvstETH",
    },
  },
  {
    id: "0xfd24fbc82373ad817eccc20dc3ea7f279a17a6b1c573322eab06eba29a5ba311",
    name: "USDC / PAXG",
    irm: "0x870aC11D48B15DB9a138Cf899d20F13F79Ba00BC",
    lltv: "860000000000000000",
    oracle: "0x08e69EBeAf1D0299fF86f3Ba0EaC6f42e17D3Ae5",
    loanToken: {
      address: "0xA0b86991c6218b36c1d19D4a2e9Eb0cE3606eB48",
      symbol: "USDC",
    },
    collateralToken: {
      address: "0x45804880De22913dAFE09f4980848ECE6EcbAf78",
      symbol: "PAXG",
    },
  },
  {
    id: "0xfbedcdd09e4f6728bea4ec4a4c7f614ad0b112c1ed2ca6ec07b3b7cd3d71bcf2",
    name: "USDC / MC_PTs",
    irm: "0x870aC11D48B15DB9a138Cf899d20F13F79Ba00BC",
    lltv: "915000000000000000",
    oracle: "0x9B8935Da5625D43CA72dD93f8111Ada7c9C82592",
    loanToken: {
      address: "0xA0b86991c6218b36c1d19D4a2e9Eb0cE3606eB48",
      symbol: "USDC",
    },
    collateralToken: {
      address: "0xd41830d88dfD08678b0B886E0122193d54b02Acc",
      symbol: "MC_PTs",
    },
  },
  {
    id: "0xfb87d561d72cda2885dce1ebba1054931ef15bbd5ca6aa9d0a4f7f8ef84a89ca",
    name: "USDC / JAAA",
    irm: "0x870aC11D48B15DB9a138Cf899d20F13F79Ba00BC",
    lltv: "860000000000000000",
    oracle: "0xDddd770BADd886dF3864029e4B377B5F6a2B6b83",
    loanToken: {
      address: "0xA0b86991c6218b36c1d19D4a2e9Eb0cE3606eB48",
      symbol: "USDC",
    },
    collateralToken: {
      address: "0x5a0F93D040De44e78F251b03c43be9CF317Dcf64",
      symbol: "JAAA",
    },
  },
  {
    id: "0xfad6df5845f5e298fd64f574ffc4024e487856663c535a31bb9c366473aa18b6",
    name: "LBTC / eBTC",
    irm: "0x870aC11D48B15DB9a138Cf899d20F13F79Ba00BC",
    lltv: "915000000000000000",
    oracle: "0xD64A781af8A188AA4AB63fb6aE929026054d09B6",
    loanToken: {
      address: "0x8236a87084f8B84306f72007F36F2618A5634494",
      symbol: "LBTC",
    },
    collateralToken: {
      address: "0x657e8C867D8B37dCC18fA4Caead9C45EB088C642",
      symbol: "eBTC",
    },
  },
  {
    id: "0xfaa104a391485a79cd2eb3a0ac33b20e4230a269c22fb8462c6301cb80fee407",
    name: "USD0 / wstUSR",
    irm: "0x870aC11D48B15DB9a138Cf899d20F13F79Ba00BC",
    lltv: "915000000000000000",
    oracle: "0xf830098e97380B352bAca31A10962CDEb7Ca761F",
    loanToken: {
      address: "0x73A15FeD60Bf67631dC6cd7Bc5B6e8da8190aCF5",
      symbol: "USD0",
    },
    collateralToken: {
      address: "0x1202F5C7b4B9E47a1A484E8B270be34dbbC75055",
      symbol: "wstUSR",
    },
  },
  {
    id: "0xf9c0ed06e4826397f51270fefe7a6ada5aa698a952183722bd217f4536ac941c",
    name: "GRAM / MAYA",
    irm: "0x870aC11D48B15DB9a138Cf899d20F13F79Ba00BC",
    lltv: "625000000000000000",
    oracle: "0xd6F5D33aC887Ee5EeB000268688aa30DcfB3b84a",
    loanToken: {
      address: "0x845f64673a2407320C2cC12e23b669DC16F7A473",
      symbol: "GRAM",
    },
    collateralToken: {
      address: "0xCe38af70542e57eA2a438d12e662D9851de06D86",
      symbol: "MAYA",
    },
  },
  {
    id: "0xf948456f472a1c22bbdf9df887311842e21fa2bb9b64658a2d017fa6bc2a689f",
    name: "USDT / PT-stcUSD-29JAN2026",
    irm: "0x870aC11D48B15DB9a138Cf899d20F13F79Ba00BC",
    lltv: "915000000000000000",
    oracle: "0x8EEc7858d2E8cD3c8006C22CF768d402AFCF551e",
    loanToken: {
      address: "0xdAC17F958D2ee523a2206206994597C13D831ec7",
      symbol: "USDT",
    },
    collateralToken: {
      address: "0xC3c7E5E277d31CD24a3Ac4cC9af3B6770F30eA33",
      symbol: "PT-stcUSD-29JAN2026",
    },
  },
  {
    id: "0xf93f7e4fef01b912b261262977fcc30fcd91095d5708732bbe141f4a41778f4d",
    name: "ZCHF / svZCHF",
    irm: "0x870aC11D48B15DB9a138Cf899d20F13F79Ba00BC",
    lltv: "965000000000000000",
    oracle: "0x8E80Ed322634f7df749710cf26B98dccC4ebd566",
    loanToken: {
      address: "0xB58E61C3098d85632Df34EecfB899A1Ed80921cB",
      symbol: "ZCHF",
    },
    collateralToken: {
      address: "0x637F00cAb9665cB07d91bfB9c6f3fa8faBFEF8BC",
      symbol: "svZCHF",
    },
  },
  {
    id: "0xf7e8d1713e567d5107cf1729b777e8ecd2fd316b844b98b9b5bc5e81d7289987",
    name: "sUSDS / PT-wstUSR-25SEP2025",
    irm: "0x870aC11D48B15DB9a138Cf899d20F13F79Ba00BC",
    lltv: "915000000000000000",
    oracle: "0x72d3B4eCd553a5c7eFf6191FEb02FA7740F07b57",
    loanToken: {
      address: "0xa3931d71877C0E7a3148CB7Eb4463524FEc27fbD",
      symbol: "sUSDS",
    },
    collateralToken: {
      address: "0x23E60d1488525bf4685f53b3aa8E676c30321066",
      symbol: "PT-wstUSR-25SEP2025",
    },
  },
  {
    id: "0xf6afd03c76ba631ff376892050a6bb0d50431644c57a6dd98e61891ca90bbe41",
    name: "USD0 / USD0++",
    irm: "0x870aC11D48B15DB9a138Cf899d20F13F79Ba00BC",
    lltv: "965000000000000000",
    oracle: "0x0e81d800E2c73247E7481E45aF7F55b96AFc4bE1",
    loanToken: {
      address: "0x73A15FeD60Bf67631dC6cd7Bc5B6e8da8190aCF5",
      symbol: "USD0",
    },
    collateralToken: {
      address: "0x35D8949372D46B7a3D5A56006AE77B215fc69bC0",
      symbol: "USD0++",
    },
  },
  {
    id: "0xf69eb75ce256a3432dbc3f19651baf4c6776c8beb336aa8b4cc6d28aea280aae",
    name: "USDC / ysUSDS",
    irm: "0x870aC11D48B15DB9a138Cf899d20F13F79Ba00BC",
    lltv: "945000000000000000",
    oracle: "0x0D35Db0928127195990D03E6A6788FA6cc592b06",
    loanToken: {
      address: "0xA0b86991c6218b36c1d19D4a2e9Eb0cE3606eB48",
      symbol: "USDC",
    },
    collateralToken: {
      address: "0x4cE9c93513DfF543Bc392870d57dF8C04e89Ba0a",
      symbol: "ysUSDS",
    },
  },
  {
    id: "0xf68208fd031bfbd8616d52c170adf817e7f8a4bccdf23ec343a708a020c41a3f",
    name: "CRNC / USDC",
    irm: "0x870aC11D48B15DB9a138Cf899d20F13F79Ba00BC",
    lltv: "385000000000000000",
    oracle: "0xa261608E9e0b91Bac60aBf88FB04c368C4f3724e",
    loanToken: {
      address: "0x47d13Fb0803409c7fE169A210d4e906165F1A432",
      symbol: "CRNC",
    },
    collateralToken: {
      address: "0xA0b86991c6218b36c1d19D4a2e9Eb0cE3606eB48",
      symbol: "USDC",
    },
  },
  {
    id: "0xf6422731a8f84d9ab7e8b6da15ab9ecc243e12a78200dfb7fd1cdf2391e38068",
    name: "eUSD / USD3",
    irm: "0x870aC11D48B15DB9a138Cf899d20F13F79Ba00BC",
    lltv: "860000000000000000",
    oracle: "0xe35f86ba1626D7a4A5A0B2eB19eb74e7068d9e4C",
    loanToken: {
      address: "0xA0d69E286B938e21CBf7E51D71F6A4c8918f482F",
      symbol: "eUSD",
    },
    collateralToken: {
      address: "0x0d86883FAf4FfD7aEb116390af37746F45b6f378",
      symbol: "USD3",
    },
  },
  {
    id: "0xf568281cb336eb6419951270fffb83dc768694ab9dc759e4eed0a3f51946c64a",
    name: "USDC / JAB78",
    irm: "0x870aC11D48B15DB9a138Cf899d20F13F79Ba00BC",
    lltv: "860000000000000000",
    oracle: "0x057A9A4dbCa82ab2Ad7d3636d8E2A2b117ce21E4",
    loanToken: {
      address: "0xA0b86991c6218b36c1d19D4a2e9Eb0cE3606eB48",
      symbol: "USDC",
    },
    collateralToken: {
      address: "0xC04619cC040254b553439a7e4803355fFA9D7A6f",
      symbol: "JAB78",
    },
  },
  {
    id: "0xf4b847369d2737ee3fbb28a7e4076535c838406aa785be3185b856b3e3ea3af7",
    name: "USDC / unknown",
    irm: "0x870aC11D48B15DB9a138Cf899d20F13F79Ba00BC",
    lltv: "945000000000000000",
    oracle: "0xCc00d98162fEf57d6A1057a36C25D5326e3805c8",
    loanToken: {
      address: "0xA0b86991c6218b36c1d19D4a2e9Eb0cE3606eB48",
      symbol: "USDC",
    },
    collateralToken: {
      address: "0xF3B5390E6D5DEf55a817Aa8f3e6391c31825990C",
      symbol: "unknown",
    },
  },
  {
    id: "0xf4754a0184f440e85b4f60023b2ae1781f7c7e2999e6e97927fa0ee88e95a7d0",
    name: "AUSD / upUSDC",
    irm: "0x870aC11D48B15DB9a138Cf899d20F13F79Ba00BC",
    lltv: "915000000000000000",
    oracle: "0xf2c9EE3Fdc5D1e360d51b4840B4096F63913dF93",
    loanToken: {
      address: "0x00000000eFE302BEAA2b3e6e1b18d08D69a9012a",
      symbol: "AUSD",
    },
    collateralToken: {
      address: "0x80E1048eDE66ec4c364b4F22C8768fc657FF6A42",
      symbol: "upUSDC",
    },
  },
  {
    id: "0xf4614dc6ce4ee662b23762d4b01d158a4a5b437d38022855fa4787db13183299",
    name: "USR / PT-wstUSR-1740182579",
    irm: "0x870aC11D48B15DB9a138Cf899d20F13F79Ba00BC",
    lltv: "915000000000000000",
    oracle: "0x71a8d219c0c332B52aAe47659E802b791d125B18",
    loanToken: {
      address: "0x66a1E37c9b0eAddca17d3662D6c05F4DECf3e110",
      symbol: "USR",
    },
    collateralToken: {
      address: "0xD0097149AA4CC0d0e1fC99B8BD73fC17dC32C1E9",
      symbol: "PT-wstUSR-1740182579",
    },
  },
  {
    id: "0xf41d787430cad2ab9eefedba1d591223916de841664a87417158127649996661",
    name: "USDS / PT-staking-USDS-18DEC2025",
    irm: "0x870aC11D48B15DB9a138Cf899d20F13F79Ba00BC",
    lltv: "965000000000000000",
    oracle: "0x2bDA5e778fA40109b3C9fe9AF42332017810492B",
    loanToken: {
      address: "0xdC035D45d973E3EC169d2276DDab16f1e407384F",
      symbol: "USDS",
    },
    collateralToken: {
      address: "0xA2a420230A5cb045db052E377D20b9c156805b95",
      symbol: "PT-staking-USDS-18DEC2025",
    },
  },
  {
    id: "0xf3bbae74a04e4ec22de4b1f2ea313290c0a50839c038eca27aa4e5e10325bf9c",
    name: "USDT / stcUSD",
    irm: "0x870aC11D48B15DB9a138Cf899d20F13F79Ba00BC",
    lltv: "915000000000000000",
    oracle: "0xa26D8Cd042E85c7F5483a2429B6F4D0211AfC689",
    loanToken: {
      address: "0xdAC17F958D2ee523a2206206994597C13D831ec7",
      symbol: "USDT",
    },
    collateralToken: {
      address: "0x88887bE419578051FF9F4eb6C858A951921D8888",
      symbol: "stcUSD",
    },
  },
  {
    id: "0xf3814af4869a6ce59ffef016e555dd4c1e92bf383b5ab89abe496044c6364746",
    name: "apxUSD / PT-apxUSD-18JUN2026",
    irm: "0x870aC11D48B15DB9a138Cf899d20F13F79Ba00BC",
    lltv: "860000000000000000",
    oracle: "0x9acfA1834d34273954Caf88a7e65E9EeFed17A03",
    loanToken: {
      address: "0x98A878b1Cd98131B271883B390f68D2c90674665",
      symbol: "apxUSD",
    },
    collateralToken: {
      address: "0x92a6A01B07984de46c24E8EBa248449beB8B1dCB",
      symbol: "PT-apxUSD-18JUN2026",
    },
  },
  {
    id: "0xf2e2a93732723b3b6718425bdbb9438730d733b12803c55d98200de4e82179e1",
    name: "cbBTC / mHyperBTC",
    irm: "0x870aC11D48B15DB9a138Cf899d20F13F79Ba00BC",
    lltv: "860000000000000000",
    oracle: "0x0b321E9d43Fa219d480Bc9D00Ca925b7EFA21464",
    loanToken: {
      address: "0xcbB7C0000aB88B473b1f5aFd9ef808440eed33Bf",
      symbol: "cbBTC",
    },
    collateralToken: {
      address: "0xC8495EAFf71D3A563b906295fCF2f685b1783085",
      symbol: "mHyperBTC",
    },
  },
  {
    id: "0xf233b01465a6bf75ea9d89eaac87b7207753fdb1ec021138bdf02b7dcd504361",
    name: "USDf / sUSDf",
    irm: "0x870aC11D48B15DB9a138Cf899d20F13F79Ba00BC",
    lltv: "915000000000000000",
    oracle: "0x08adA026d756CDf2e17D791e74C8b30D554E1D26",
    loanToken: {
      address: "0xFa2B947eEc368f42195f24F36d2aF29f7c24CeC2",
      symbol: "USDf",
    },
    collateralToken: {
      address: "0xc8CF6D7991f15525488b2A83Df53468D682Ba4B0",
      symbol: "sUSDf",
    },
  },
  {
    id: "0xf2202693d799467659f2621e976f53507b8aebe221ca1783974544d9281a8e8d",
    name: "USDtb / PT-USDe-27NOV2025",
    irm: "0x870aC11D48B15DB9a138Cf899d20F13F79Ba00BC",
    lltv: "915000000000000000",
    oracle: "0xec735BCE27b0A01EEDb4e59B3c1F68b6a4D52285",
    loanToken: {
      address: "0xC139190F447e929f090Edeb554D95AbB8b18aC1C",
      symbol: "USDtb",
    },
    collateralToken: {
      address: "0x62C6E813b9589C3631Ba0Cdb013acdB8544038B7",
      symbol: "PT-USDe-27NOV2025",
    },
  },
  {
    id: "0xf2014d7a1a24d137380177d0ce89c3292689e987e4044bc7692dab574903525b",
    name: "USDCV / wstETH",
    irm: "0x870aC11D48B15DB9a138Cf899d20F13F79Ba00BC",
    lltv: "860000000000000000",
    oracle: "0x5De7d3f11337a836D39420d4469Dd571C006202e",
    loanToken: {
      address: "0x5422374B27757da72d5265cC745ea906E0446634",
      symbol: "USDCV",
    },
    collateralToken: {
      address: "0x7f39C581F595B53c5cb19bD0b3f8dA6c935E2Ca0",
      symbol: "wstETH",
    },
  },
  {
    id: "0xf135feb27b5f2bd2d54f344fd38dbb5161ff7f0ef4494901fb23f2fe8e58145a",
    name: "EURCV / steakUSDC",
    irm: "0x870aC11D48B15DB9a138Cf899d20F13F79Ba00BC",
    lltv: "915000000000000000",
    oracle: "0x74eC54c1FE39a7A2299C77Dd0F2D3Cb458BB44c2",
    loanToken: {
      address: "0x5F7827FDeb7c20b443265Fc2F40845B715385Ff2",
      symbol: "EURCV",
    },
    collateralToken: {
      address: "0xbeef088055857739C12CD3765F20b7679Def0f51",
      symbol: "steakUSDC",
    },
  },
  {
    id: "0xefd4ad6c4ccf7a5253cfca014040b358aa193288b2bfdd1bb8f074ce81bf9b77",
    name: "lvlUSD / jUSD",
    irm: "0x870aC11D48B15DB9a138Cf899d20F13F79Ba00BC",
    lltv: "915000000000000000",
    oracle: "0xAe835aa3d4ec07FD7a931505bDac9A921e12df15",
    loanToken: {
      address: "0x7C1156E515aA1A2E851674120074968C905aAF37",
      symbol: "lvlUSD",
    },
    collateralToken: {
      address: "0x000000096CB3D4007fC2b79b935C4540C5c2d745",
      symbol: "jUSD",
    },
  },
  {
    id: "0xef9f1e3e71483c9c9b61d2e27452e26507e52b547775ca899277b35585ef7b01",
    name: "USDS / JOE",
    irm: "0x870aC11D48B15DB9a138Cf899d20F13F79Ba00BC",
    lltv: "770000000000000000",
    oracle: "0x8EE090A8486F40E059B61d23A9Ae9302508Acbbc",
    loanToken: {
      address: "0xdC035D45d973E3EC169d2276DDab16f1e407384F",
      symbol: "USDS",
    },
    collateralToken: {
      address: "0x76e222b07C53D28b89b0bAc18602810Fc22B49A8",
      symbol: "JOE",
    },
  },
  {
    id: "0xeef66cd45aa7722cad9221e86d6482082ad1e1f32274dc5880ee9c6e98d81d3d",
    name: "sUSDS / cbBTC",
    irm: "0x870aC11D48B15DB9a138Cf899d20F13F79Ba00BC",
    lltv: "860000000000000000",
    oracle: "0x1632f3E14754CD8f4b8F8a3b0719a94545042057",
    loanToken: {
      address: "0xa3931d71877C0E7a3148CB7Eb4463524FEc27fbD",
      symbol: "sUSDS",
    },
    collateralToken: {
      address: "0xcbB7C0000aB88B473b1f5aFd9ef808440eed33Bf",
      symbol: "cbBTC",
    },
  },
  {
    id: "0xee9063e252faf85b294186aa1c86a7a603efb548824e697f4346958dc7b5e304",
    name: "JPYC / USDC",
    irm: "0x870aC11D48B15DB9a138Cf899d20F13F79Ba00BC",
    lltv: "860000000000000000",
    oracle: "0xb7423eF8fDc229A915aC84E0D04F05038Bd0bbE7",
    loanToken: {
      address: "0xE7C3D8C9a439feDe00D2600032D5dB0Be71C3c29",
      symbol: "JPYC",
    },
    collateralToken: {
      address: "0xA0b86991c6218b36c1d19D4a2e9Eb0cE3606eB48",
      symbol: "USDC",
    },
  },
  {
    id: "0xee8b6a54d60c18af9085cef5f90fb3de887f4ebe3f84e21c8222740c1de6d79e",
    name: "USDC / PT-csUSDL-30OCT2025",
    irm: "0x870aC11D48B15DB9a138Cf899d20F13F79Ba00BC",
    lltv: "915000000000000000",
    oracle: "0x82dBE10a7D516D8F8b532570134faA81eA63FC51",
    loanToken: {
      address: "0xA0b86991c6218b36c1d19D4a2e9Eb0cE3606eB48",
      symbol: "USDC",
    },
    collateralToken: {
      address: "0xDBf6feC5A012A13c456Bac3B67C3B9CF2830A122",
      symbol: "PT-csUSDL-30OCT2025",
    },
  },
  {
    id: "0xee1e6a6fc07ddf120c22fa8c076b5f2a3f538afebada0a5eff514c00dc99f6a7",
    name: "rUSD / cbBTC",
    irm: "0x870aC11D48B15DB9a138Cf899d20F13F79Ba00BC",
    lltv: "860000000000000000",
    oracle: "0xF7A0e51cebD98a31947CaE1DDa8C0717D10ADd61",
    loanToken: {
      address: "0x09D4214C03D01F49544C0448DBE3A27f768F2b34",
      symbol: "rUSD",
    },
    collateralToken: {
      address: "0xcbB7C0000aB88B473b1f5aFd9ef808440eed33Bf",
      symbol: "cbBTC",
    },
  },
  {
    id: "0xed9e817ac29464b3cc520bf124fb333c330021a8ae768889f414d21df35686e0",
    name: "USDA / PT-ezETH-26DEC2024",
    irm: "0x870aC11D48B15DB9a138Cf899d20F13F79Ba00BC",
    lltv: "860000000000000000",
    oracle: "0xfE63A66aec4e39eE4c959eB7E2ed55Af8a0aB248",
    loanToken: {
      address: "0x0000206329b97DB379d5E1Bf586BbDB969C63274",
      symbol: "USDA",
    },
    collateralToken: {
      address: "0xf7906F274c174A52d444175729E3fa98f9bde285",
      symbol: "PT-ezETH-26DEC2024",
    },
  },
  {
    id: "0xed808d36371491748eaa28b16533cafc270e705139e3ff807ea17ce60d6938c9",
    name: "frxUSD / PT-savUSD-14MAY2026",
    irm: "0x870aC11D48B15DB9a138Cf899d20F13F79Ba00BC",
    lltv: "915000000000000000",
    oracle: "0xa33506EB5019D049D9c7fFa35C947b4794f2fE12",
    loanToken: {
      address: "0xCAcd6fd266aF91b8AeD52aCCc382b4e165586E29",
      symbol: "frxUSD",
    },
    collateralToken: {
      address: "0x606B5C773dC4D6E625C411cF60565f8c30C467d2",
      symbol: "PT-savUSD-14MAY2026",
    },
  },
  {
    id: "0xed72da5ee12b3079203e1429e67c6faa39ce8e6e377938912abcae5810a6e22a",
    name: "USDT / SyStUSD",
    irm: "0x870aC11D48B15DB9a138Cf899d20F13F79Ba00BC",
    lltv: "945000000000000000",
    oracle: "0xFB9132BD07Cd63a0295d71774D576d7410F20c60",
    loanToken: {
      address: "0xdAC17F958D2ee523a2206206994597C13D831ec7",
      symbol: "USDT",
    },
    collateralToken: {
      address: "0x2C78106719D559115498173F513823f4b3E6a4FB",
      symbol: "SyStUSD",
    },
  },
  {
    id: "0xece15af4c0a89d99cd343df90309fe8f5751e629fe17f091985b77f76abebacd",
    name: "lvWETH / lvstETH",
    irm: "0x870aC11D48B15DB9a138Cf899d20F13F79Ba00BC",
    lltv: "945000000000000000",
    oracle: "0x5A28B3ac6dCc9112Db442803DbB893340C61DB51",
    loanToken: {
      address: "0x2C0b3aCd0818314DE41e7523e85C30A58eDb72Da",
      symbol: "lvWETH",
    },
    collateralToken: {
      address: "0xC2b1Ba934CE3176DFa610566e0d3A0F013c8579B",
      symbol: "lvstETH",
    },
  },
  {
    id: "0xec69c18535dcd07b903b0cae79a6584503cae78f1278af2f5da4a2852100e01a",
    name: "USDe / PT-eUSDE-14AUG2025",
    irm: "0x870aC11D48B15DB9a138Cf899d20F13F79Ba00BC",
    lltv: "915000000000000000",
    oracle: "0xac15dD96f1059a7F58c89e1bB57417C804DA6157",
    loanToken: {
      address: "0x4c9EDD5852cd905f086C759E8383e09bff1E68B3",
      symbol: "USDe",
    },
    collateralToken: {
      address: "0x14Bdc3A3AE09f5518b923b69489CBcAfB238e617",
      symbol: "PT-eUSDE-14AUG2025",
    },
  },
  {
    id: "0xebd23a871b52e0a8c92bd719f4413600101b69e946cb72923b3a33fb5bc6ec85",
    name: "apxUSD / PT-apyUSD-5NOV2026",
    irm: "0x870aC11D48B15DB9a138Cf899d20F13F79Ba00BC",
    lltv: "915000000000000000",
    oracle: "0xD3acB26E38465613B9a974caD2bA56FbCC7B87E9",
    loanToken: {
      address: "0x98A878b1Cd98131B271883B390f68D2c90674665",
      symbol: "apxUSD",
    },
    collateralToken: {
      address: "0xb5Be35D8fF83D431899b95851CB17a2B4bcEF150",
      symbol: "PT-apyUSD-5NOV2026",
    },
  },
  {
    id: "0xebc83b2aedb26a5a166884cdae0771c36cddaccebfb907412ea8477af3bd2a9b",
    name: "USDC / JAB78",
    irm: "0x870aC11D48B15DB9a138Cf899d20F13F79Ba00BC",
    lltv: "860000000000000000",
    oracle: "0xB1d8Edd823D53B253ffe418b9944A09a286b20Ab",
    loanToken: {
      address: "0xA0b86991c6218b36c1d19D4a2e9Eb0cE3606eB48",
      symbol: "USDC",
    },
    collateralToken: {
      address: "0xAbc6Fb7F3A8DDE498366553A61E0358b1e49F332",
      symbol: "JAB78",
    },
  },
  {
    id: "0xeb9e8da9606c3762f1128964b6dc30edc6dde10e78b2e6402b28d30974f2bae2",
    name: "BOLD / WBTC",
    irm: "0x870aC11D48B15DB9a138Cf899d20F13F79Ba00BC",
    lltv: "860000000000000000",
    oracle: "0x7dc6e7abCf78d773687Ad80Cb3d5e72f2B7ae2b6",
    loanToken: {
      address: "0x6440f144b7e50D6a8439336510312d2F54beB01D",
      symbol: "BOLD",
    },
    collateralToken: {
      address: "0x2260FAC5E5542a773Aa44fBCfeDf7C193bc2C599",
      symbol: "WBTC",
    },
  },
  {
    id: "0xeb0403429dabb5829047fb5c05dcaa816a41d164424341db7d10cc5dd86a967d",
    name: "sUSDS / deUSD",
    irm: "0x870aC11D48B15DB9a138Cf899d20F13F79Ba00BC",
    lltv: "915000000000000000",
    oracle: "0x7dD3FC7645555f78cC029f64a4C3965C58Aaf4C4",
    loanToken: {
      address: "0xa3931d71877C0E7a3148CB7Eb4463524FEc27fbD",
      symbol: "sUSDS",
    },
    collateralToken: {
      address: "0x15700B564Ca08D9439C58cA5053166E8317aa138",
      symbol: "deUSD",
    },
  },
  {
    id: "0xeae0bb1c269068e21da37d341eb5bc95b1ee13b28c68d6e4e61314f7c1d3813f",
    name: "USUAL / USUALX",
    irm: "0x870aC11D48B15DB9a138Cf899d20F13F79Ba00BC",
    lltv: "860000000000000000",
    oracle: "0xd582E019E955C0b8B0C4889e3C86300ddAd11A13",
    loanToken: {
      address: "0xC4441c2BE5d8fA8126822B9929CA0b81Ea0DE38E",
      symbol: "USUAL",
    },
    collateralToken: {
      address: "0x06B964d96f5dCF7Eae9d7C559B09EDCe244d4B8E",
      symbol: "USUALX",
    },
  },
  {
    id: "0xea6abacc02dadfdb1bc2f4f1571da3fcb9c2b3028230d80fc71447a177cf4e99",
    name: "AUSD / PT-reUSD-10DEC2026",
    irm: "0x870aC11D48B15DB9a138Cf899d20F13F79Ba00BC",
    lltv: "915000000000000000",
    oracle: "0x217d6DdCDB95112C51657F6270e8C079CFDB51f0",
    loanToken: {
      address: "0x00000000eFE302BEAA2b3e6e1b18d08D69a9012a",
      symbol: "AUSD",
    },
    collateralToken: {
      address: "0xeCfaFdC7741323a945A163ed068B5a3C43483957",
      symbol: "PT-reUSD-10DEC2026",
    },
  },
  {
    id: "0xea2da41f0c529bb7a9bdaa737d7118bf554ecda3d2b40597539b9d765bd08db1",
    name: "MUSD / cbBTC",
    irm: "0x870aC11D48B15DB9a138Cf899d20F13F79Ba00BC",
    lltv: "860000000000000000",
    oracle: "0xdEc4641dA42baEE2AD7F0deaE8E92Fa322A2bCF5",
    loanToken: {
      address: "0xdD468A1DDc392dcdbEf6db6e34E89AA338F9F186",
      symbol: "MUSD",
    },
    collateralToken: {
      address: "0xcbB7C0000aB88B473b1f5aFd9ef808440eed33Bf",
      symbol: "cbBTC",
    },
  },
  {
    id: "0xe9ee5aec5830d8d9115e62b2e39b9c0a2dfdaa42dce0dfe6857ef6df05d61270",
    name: "eUSD / wUSDM",
    irm: "0x870aC11D48B15DB9a138Cf899d20F13F79Ba00BC",
    lltv: "965000000000000000",
    oracle: "0x38Ed40ab78D2D00467CedD5B1631C040768cdfCa",
    loanToken: {
      address: "0xA0d69E286B938e21CBf7E51D71F6A4c8918f482F",
      symbol: "eUSD",
    },
    collateralToken: {
      address: "0x57F5E098CaD7A3D1Eed53991D4d66C45C9AF7812",
      symbol: "wUSDM",
    },
  },
  {
    id: "0xe9d96a2f8042486bfd8cfd22692e49cd355e8a51da2f427bdb2d3671fbe978ea",
    name: "AUSD / upGAMMAusdc",
    irm: "0x870aC11D48B15DB9a138Cf899d20F13F79Ba00BC",
    lltv: "915000000000000000",
    oracle: "0x17efab746fdA38842Ff613B8c1f2593D220df495",
    loanToken: {
      address: "0x00000000eFE302BEAA2b3e6e1b18d08D69a9012a",
      symbol: "AUSD",
    },
    collateralToken: {
      address: "0x998D7b14c123c1982404562b68edDB057b0477cB",
      symbol: "upGAMMAusdc",
    },
  },
  {
    id: "0xe9b83f6c683934ef7b059f531b07207ce8047ca6e24501718cbd386d34e1da8b",
    name: "mUSD / cbBTC",
    irm: "0x870aC11D48B15DB9a138Cf899d20F13F79Ba00BC",
    lltv: "860000000000000000",
    oracle: "0x9F983115741D0F7F2EAE07831415057AD3de34d2",
    loanToken: {
      address: "0xacA92E438df0B2401fF60dA7E4337B687a2435DA",
      symbol: "mUSD",
    },
    collateralToken: {
      address: "0xcbB7C0000aB88B473b1f5aFd9ef808440eed33Bf",
      symbol: "cbBTC",
    },
  },
  {
    id: "0xe90a6419afa96192cb088f63b779ddcb629a89f9126600d767d9442868087541",
    name: "AUSD / PST",
    irm: "0x870aC11D48B15DB9a138Cf899d20F13F79Ba00BC",
    lltv: "860000000000000000",
    oracle: "0xa5657B406Fc4282039861C6fcA64452aeFEC8ac0",
    loanToken: {
      address: "0x00000000eFE302BEAA2b3e6e1b18d08D69a9012a",
      symbol: "AUSD",
    },
    collateralToken: {
      address: "0x22aE3D9a738471f405169Af055d31c687087d4c7",
      symbol: "PST",
    },
  },
  {
    id: "0xe8c9d076ee7e6fcadd34165c44c08fe61533e7ab4accbed76d7e7f7d5a011708",
    name: "USDf / sUSDf",
    irm: "0x870aC11D48B15DB9a138Cf899d20F13F79Ba00BC",
    lltv: "965000000000000000",
    oracle: "0xD352E2cf83DB8c6C4FC37E16027ef9fb340a6b87",
    loanToken: {
      address: "0xFa2B947eEc368f42195f24F36d2aF29f7c24CeC2",
      symbol: "USDf",
    },
    collateralToken: {
      address: "0xc8CF6D7991f15525488b2A83Df53468D682Ba4B0",
      symbol: "sUSDf",
    },
  },
  {
    id: "0xe89ac5b1d916e24093b9d08893aec4c8fc26a517831cc00f21d047f578edb9cf",
    name: "USDC / sFRAX",
    irm: "0x870aC11D48B15DB9a138Cf899d20F13F79Ba00BC",
    lltv: "860000000000000000",
    oracle: "0x504188EfF00DB6137010dE02C26b3f72c25eE1f1",
    loanToken: {
      address: "0xA0b86991c6218b36c1d19D4a2e9Eb0cE3606eB48",
      symbol: "USDC",
    },
    collateralToken: {
      address: "0xA663B02CF0a4b149d2aD41910CB81e23e1c41c32",
      symbol: "sFRAX",
    },
  },
  {
    id: "0xe846177f6f5cf576236e22843df4086e1d3e43d840a156780050c8bbd35ef916",
    name: "waEthUSDC / steakUSDC",
    irm: "0x870aC11D48B15DB9a138Cf899d20F13F79Ba00BC",
    lltv: "945000000000000000",
    oracle: "0xB3F54eeE2900ED62571d8282b13bebA2E7c9bf4F",
    loanToken: {
      address: "0xD4fa2D31b7968E448877f69A96DE69f5de8cD23E",
      symbol: "waEthUSDC",
    },
    collateralToken: {
      address: "0xbeef088055857739C12CD3765F20b7679Def0f51",
      symbol: "steakUSDC",
    },
  },
  {
    id: "0xe82a7b5bd1c215567527b88a896f87933c9ce3e486ff4ea13266d31480240d35",
    name: "USDC / PT-mAPOLLO-30APR2026",
    irm: "0x870aC11D48B15DB9a138Cf899d20F13F79Ba00BC",
    lltv: "860000000000000000",
    oracle: "0x301d30a2cc72B7fB87feE7c789c2ce9e548e0Fb5",
    loanToken: {
      address: "0xA0b86991c6218b36c1d19D4a2e9Eb0cE3606eB48",
      symbol: "USDC",
    },
    collateralToken: {
      address: "0x64b393288AB2a0Fe7Af6b73A9159493E60aB0605",
      symbol: "PT-mAPOLLO-30APR2026",
    },
  },
  {
    id: "0xe7f998c0ff11ca2bf091d39b6a3cef1035733528187d520c1c47710c8f1acaeb",
    name: "AUSD / PT-cUSD-23JUL2026",
    irm: "0x870aC11D48B15DB9a138Cf899d20F13F79Ba00BC",
    lltv: "915000000000000000",
    oracle: "0x25b30502467639E8FA118451105269e9B9813DD2",
    loanToken: {
      address: "0x00000000eFE302BEAA2b3e6e1b18d08D69a9012a",
      symbol: "AUSD",
    },
    collateralToken: {
      address: "0x928FB6ED39100a92B2480f5cbB93453f98D9F4cE",
      symbol: "PT-cUSD-23JUL2026",
    },
  },
  {
    id: "0xe77f096e744ab15db0ec90789fb8ae4f629ea72e9ecbd0cce6c7e572f8c1c39e",
    name: "apxUSD / PT-apyUSD-18JUN2026",
    irm: "0x870aC11D48B15DB9a138Cf899d20F13F79Ba00BC",
    lltv: "860000000000000000",
    oracle: "0x2731e03bF13B97bAE7a79E1D575611A0451F2285",
    loanToken: {
      address: "0x98A878b1Cd98131B271883B390f68D2c90674665",
      symbol: "apxUSD",
    },
    collateralToken: {
      address: "0x3365554a61CeFF74A76528f9e86C1E87946d16a5",
      symbol: "PT-apyUSD-18JUN2026",
    },
  },
  {
    id: "0xe75418a06edcb85711bcb5fb52f391cc94eb515f88beee436ca4e44c33487ed9",
    name: "USDC / ysUSDS",
    irm: "0x870aC11D48B15DB9a138Cf899d20F13F79Ba00BC",
    lltv: "945000000000000000",
    oracle: "0xd6154930A8df0A488Fae08547E53221B572EEA37",
    loanToken: {
      address: "0xA0b86991c6218b36c1d19D4a2e9Eb0cE3606eB48",
      symbol: "USDC",
    },
    collateralToken: {
      address: "0x4cE9c93513DfF543Bc392870d57dF8C04e89Ba0a",
      symbol: "ysUSDS",
    },
  },
  {
    id: "0xe6eda5cbaf4a85736271d94bbf2ef93eb11ef7b3555370ab36e591abd443b1ab",
    name: "wM / cbBTC",
    irm: "0x870aC11D48B15DB9a138Cf899d20F13F79Ba00BC",
    lltv: "860000000000000000",
    oracle: "0xF7A0e51cebD98a31947CaE1DDa8C0717D10ADd61",
    loanToken: {
      address: "0x437cc33344a0B27A429f795ff6B469C72698B291",
      symbol: "wM",
    },
    collateralToken: {
      address: "0xcbB7C0000aB88B473b1f5aFd9ef808440eed33Bf",
      symbol: "cbBTC",
    },
  },
  {
    id: "0xe68ee60e932d791c2de5959f85a5f11d2a4e502d7f6262df3f0181efb4d1bfff",
    name: "USDC / PT-fxSAVE-30OCT2025",
    irm: "0x870aC11D48B15DB9a138Cf899d20F13F79Ba00BC",
    lltv: "915000000000000000",
    oracle: "0x76989BEbe87706570cF93Bd596E47a3e9e50E3e4",
    loanToken: {
      address: "0xA0b86991c6218b36c1d19D4a2e9Eb0cE3606eB48",
      symbol: "USDC",
    },
    collateralToken: {
      address: "0x21aacE56a8F21210b7E76d8eF1a77253Db85BF0a",
      symbol: "PT-fxSAVE-30OCT2025",
    },
  },
  {
    id: "0xe681e1da2bff41ff376f6480312bec66f2b808a90173e681f8a1cfd1605533b6",
    name: "apxUSD / PT-apxUSD-5NOV2026",
    irm: "0x870aC11D48B15DB9a138Cf899d20F13F79Ba00BC",
    lltv: "945000000000000000",
    oracle: "0xCD0172EcEc187dACf3bdD6A6450Ed1f13BD74174",
    loanToken: {
      address: "0x98A878b1Cd98131B271883B390f68D2c90674665",
      symbol: "apxUSD",
    },
    collateralToken: {
      address: "0xAF687B5EcB525Ccea96115088999B4eD80C388b6",
      symbol: "PT-apxUSD-5NOV2026",
    },
  },
  {
    id: "0xe64175d0bcccd2fc7dd9ba6808085ea02f27faf080c05f2b0b90430a4087da58",
    name: "EURCV / cbBTC",
    irm: "0x870aC11D48B15DB9a138Cf899d20F13F79Ba00BC",
    lltv: "860000000000000000",
    oracle: "0xc8FcbBeB37b159B209972ADEAd561420E7bC3Fa3",
    loanToken: {
      address: "0x5F7827FDeb7c20b443265Fc2F40845B715385Ff2",
      symbol: "EURCV",
    },
    collateralToken: {
      address: "0xcbB7C0000aB88B473b1f5aFd9ef808440eed33Bf",
      symbol: "cbBTC",
    },
  },
  {
    id: "0xe5cb041381b10f2fefde5d81e87e4dff207052d1fa2defd268c4fcc608de3a8f",
    name: "USDS / WETH",
    irm: "0x870aC11D48B15DB9a138Cf899d20F13F79Ba00BC",
    lltv: "860000000000000000",
    oracle: "0xf751b1D7C04c63B953e4AccC94f825DBAfda166d",
    loanToken: {
      address: "0xdC035D45d973E3EC169d2276DDab16f1e407384F",
      symbol: "USDS",
    },
    collateralToken: {
      address: "0xC02aaA39b223FE8D0A0e5C4F27eAD9083C756Cc2",
      symbol: "WETH",
    },
  },
  {
    id: "0xe55be013051b907f24a51a1a1eaf1296c49bbcd9458825558145a3240fe959b8",
    name: "USDC / ZCHF",
    irm: "0x870aC11D48B15DB9a138Cf899d20F13F79Ba00BC",
    lltv: "915000000000000000",
    oracle: "0x75f2a77024eFd54c4A6087EBd7E3243C7bD1770d",
    loanToken: {
      address: "0xA0b86991c6218b36c1d19D4a2e9Eb0cE3606eB48",
      symbol: "USDC",
    },
    collateralToken: {
      address: "0xB58E61C3098d85632Df34EecfB899A1Ed80921cB",
      symbol: "ZCHF",
    },
  },
  {
    id: "0xe3e2791c54761fbce25d0b577f78a33fe94f948d94b5da4808c7690f063e09bc",
    name: "USDe / jrUSDe",
    irm: "0x870aC11D48B15DB9a138Cf899d20F13F79Ba00BC",
    lltv: "860000000000000000",
    oracle: "0x366e4400F2fE47c1Ef7D545db0EB16608D1Ba1fd",
    loanToken: {
      address: "0x4c9EDD5852cd905f086C759E8383e09bff1E68B3",
      symbol: "USDe",
    },
    collateralToken: {
      address: "0xC58D044404d8B14e953C115E67823784dEA53d8F",
      symbol: "jrUSDe",
    },
  },
  {
    id: "0xe3a88d0eec33fdf2ee0c101c369e16a62c764df4dbd17cc650c40b3ec5acf73d",
    name: "rUSD / PT-RUSD-26FEB2026",
    irm: "0x870aC11D48B15DB9a138Cf899d20F13F79Ba00BC",
    lltv: "915000000000000000",
    oracle: "0x9b544FB6c7EE2881867A1c5bb6be00b85ba03FE7",
    loanToken: {
      address: "0x09D4214C03D01F49544C0448DBE3A27f768F2b34",
      symbol: "rUSD",
    },
    collateralToken: {
      address: "0xeEAa924eB3667F30Be02Db9C55d87566a3F4dF7A",
      symbol: "PT-RUSD-26FEB2026",
    },
  },
  {
    id: "0xe3a79c77ec8c5c62f45294ba05ade9b5345fe9b1bcc2c06bf7d5b7bca8baab9d",
    name: "lvWETH / lvstETH",
    irm: "0x870aC11D48B15DB9a138Cf899d20F13F79Ba00BC",
    lltv: "945000000000000000",
    oracle: "0x95930B0143b6D5016f57D1EFF1486C98b608242c",
    loanToken: {
      address: "0x34DD66BBaBa126E773a56FA6cF470014f1E50725",
      symbol: "lvWETH",
    },
    collateralToken: {
      address: "0xc187570e867A1311625F665e6baF9a82BC014226",
      symbol: "lvstETH",
    },
  },
  {
    id: "0xe3815bbfe33aec2dc04f0e64dae3691604f9f74139880b0b4e678ac46cd25e98",
    name: "USDC / JTRSY",
    irm: "0x870aC11D48B15DB9a138Cf899d20F13F79Ba00BC",
    lltv: "860000000000000000",
    oracle: "0xDddd770BADd886dF3864029e4B377B5F6a2B6b83",
    loanToken: {
      address: "0xA0b86991c6218b36c1d19D4a2e9Eb0cE3606eB48",
      symbol: "USDC",
    },
    collateralToken: {
      address: "0x8c213ee79581Ff4984583C6a801e5263418C4b86",
      symbol: "JTRSY",
    },
  },
  {
    id: "0xe3446542f42bf0f08582bf5cfdc1d94f3873cc9a91fc6009ca629d9c84d08c65",
    name: "USDC / WETH",
    irm: "0x870aC11D48B15DB9a138Cf899d20F13F79Ba00BC",
    lltv: "860000000000000000",
    oracle: "0xe234CaDd30Ee0df63a093fe541BD1c4F48C99629",
    loanToken: {
      address: "0xA0b86991c6218b36c1d19D4a2e9Eb0cE3606eB48",
      symbol: "USDC",
    },
    collateralToken: {
      address: "0xC02aaA39b223FE8D0A0e5C4F27eAD9083C756Cc2",
      symbol: "WETH",
    },
  },
  {
    id: "0xe31af163f7ea13aa0d7719f3d865a8795a7973d9ff54ff418431718ad16f5c2d",
    name: "USDC / sdeUSD",
    irm: "0x870aC11D48B15DB9a138Cf899d20F13F79Ba00BC",
    lltv: "915000000000000000",
    oracle: "0xD634DbbcF06d99eDc0e2D6349Ef1Ea5873d17C02",
    loanToken: {
      address: "0xA0b86991c6218b36c1d19D4a2e9Eb0cE3606eB48",
      symbol: "USDC",
    },
    collateralToken: {
      address: "0x5C5b196aBE0d54485975D1Ec29617D42D9198326",
      symbol: "sdeUSD",
    },
  },
  {
    id: "0xe2b3f229c4257c6b7583cfe22cd241c811f213e4118b769e5893d86ab8fd5688",
    name: "CHYUSD / USDC",
    irm: "0x870aC11D48B15DB9a138Cf899d20F13F79Ba00BC",
    lltv: "980000000000000000",
    oracle: "0xFFa25c2A3A2b2632e3CC1E028fdBe7af4e22C62a",
    loanToken: {
      address: "0xcD4190c8D631D32a73488FF2A96E1cd92fFEa560",
      symbol: "CHYUSD",
    },
    collateralToken: {
      address: "0xA0b86991c6218b36c1d19D4a2e9Eb0cE3606eB48",
      symbol: "USDC",
    },
  },
  {
    id: "0xe2624b38b099ff0a249f729257d7469fb1877f63e8b990db53e8c36209374b7d",
    name: "USDC / W-TEST",
    irm: "0x870aC11D48B15DB9a138Cf899d20F13F79Ba00BC",
    lltv: "860000000000000000",
    oracle: "0x49897Dc703631b69adA1588361064f0048127A79",
    loanToken: {
      address: "0xA0b86991c6218b36c1d19D4a2e9Eb0cE3606eB48",
      symbol: "USDC",
    },
    collateralToken: {
      address: "0x507AF6a3400912463960BabdD1771BEc41400984",
      symbol: "W-TEST",
    },
  },
  {
    id: "0xe23c1a475ee6b768fcc61db3fff1eba34d9514b26cfd9421581e0bded0605647",
    name: "tBTC / LBTC",
    irm: "0x870aC11D48B15DB9a138Cf899d20F13F79Ba00BC",
    lltv: "945000000000000000",
    oracle: "0x80fA2a9f31Bb0bf0CbDBFb65Dc414C13F8320C85",
    loanToken: {
      address: "0x18084fbA666a33d37592fA2633fD49a74DD93a88",
      symbol: "tBTC",
    },
    collateralToken: {
      address: "0x8236a87084f8B84306f72007F36F2618A5634494",
      symbol: "LBTC",
    },
  },
  {
    id: "0xe23380494e365453f72f736f2d941959ae945773eb67a06cf4f538c7c4201264",
    name: "apxUSD / apyUSD",
    irm: "0x870aC11D48B15DB9a138Cf899d20F13F79Ba00BC",
    lltv: "860000000000000000",
    oracle: "0x770661EE520Ff9F7D8FaCAdC4EFF885739Bd8872",
    loanToken: {
      address: "0x98A878b1Cd98131B271883B390f68D2c90674665",
      symbol: "apxUSD",
    },
    collateralToken: {
      address: "0x38EEb52F0771140d10c4E9A9a72349A329Fe8a6A",
      symbol: "apyUSD",
    },
  },
  {
    id: "0xe11d6281ee58fed7e4b908282df80ae018c02bed0328e7596579c112538948c0",
    name: "WBTC / LBTC",
    irm: "0x870aC11D48B15DB9a138Cf899d20F13F79Ba00BC",
    lltv: "915000000000000000",
    oracle: "0xa98105B8227E0f2157816Feb7A331364A9B74F80",
    loanToken: {
      address: "0x2260FAC5E5542a773Aa44fBCfeDf7C193bc2C599",
      symbol: "WBTC",
    },
    collateralToken: {
      address: "0x8236a87084f8B84306f72007F36F2618A5634494",
      symbol: "LBTC",
    },
  },
  {
    id: "0xe094a1a6a0026c540ff0962ac559dc663d2c0ab2c4c582526ac2c124f9f16af9",
    name: "USDC / PT-srUSDe-25JUN2026",
    irm: "0x870aC11D48B15DB9a138Cf899d20F13F79Ba00BC",
    lltv: "915000000000000000",
    oracle: "0xAB13e3c612104f68b91345B70f3b789463a5e79f",
    loanToken: {
      address: "0xA0b86991c6218b36c1d19D4a2e9Eb0cE3606eB48",
      symbol: "USDC",
    },
    collateralToken: {
      address: "0x619D75E3b790eBC21c289f2805Bb7177A7D732E2",
      symbol: "PT-srUSDe-25JUN2026",
    },
  },
  {
    id: "0xe008d83b008f3e35202a9a000cf010fb781e674cc97cc731da6a56d98f624837",
    name: "pmUSD / srRoyUSDC",
    irm: "0x870aC11D48B15DB9a138Cf899d20F13F79Ba00BC",
    lltv: "915000000000000000",
    oracle: "0x02147FD1Dc98c7D30b5E3b8f31B549837d5B1F10",
    loanToken: {
      address: "0xC0c17dD08263C16f6b64E772fB9B723Bf1344DdF",
      symbol: "pmUSD",
    },
    collateralToken: {
      address: "0xcD9f5907F92818bC06c9Ad70217f089E190d2a32",
      symbol: "srRoyUSDC",
    },
  },
  {
    id: "0xdfd730c597116b2ab4b5ec2a10fef3e6bc1e8c9ae495ca7d2a351704592d6bbe",
    name: "USDA / gtWETH",
    irm: "0x870aC11D48B15DB9a138Cf899d20F13F79Ba00BC",
    lltv: "770000000000000000",
    oracle: "0xe4CCAA1849e9058f77f555C0FCcA4925Efd37d8E",
    loanToken: {
      address: "0x0000206329b97DB379d5E1Bf586BbDB969C63274",
      symbol: "USDA",
    },
    collateralToken: {
      address: "0x2371e134e3455e0593363cBF89d3b6cf53740618",
      symbol: "gtWETH",
    },
  },
  {
    id: "0xdfa9393bfb46971861a2be04ad7fe9070496f0e35a695e6b1fe9cba3a0e5769b",
    name: "sUSDS / cbBTC",
    irm: "0x870aC11D48B15DB9a138Cf899d20F13F79Ba00BC",
    lltv: "860000000000000000",
    oracle: "0xaDccABdf3dB1f269Bb17156471918EB7862f4929",
    loanToken: {
      address: "0xa3931d71877C0E7a3148CB7Eb4463524FEc27fbD",
      symbol: "sUSDS",
    },
    collateralToken: {
      address: "0xcbB7C0000aB88B473b1f5aFd9ef808440eed33Bf",
      symbol: "cbBTC",
    },
  },
  {
    id: "0xdf6d7f06538d0dbbeab2c579ee9875f1a938eb7547f323937ea4a104bc93410d",
    name: "USDtb / PT-USDe-31JUL2025",
    irm: "0x870aC11D48B15DB9a138Cf899d20F13F79Ba00BC",
    lltv: "915000000000000000",
    oracle: "0x7cE5c29d249c0E318c85503b1565B81ED7483019",
    loanToken: {
      address: "0xC139190F447e929f090Edeb554D95AbB8b18aC1C",
      symbol: "USDtb",
    },
    collateralToken: {
      address: "0x917459337CaAC939D41d7493B3999f571D20D667",
      symbol: "PT-USDe-31JUL2025",
    },
  },
  {
    id: "0xdf34dfc21484bc8c78feae45261779db5e5259ffbc40cfa18dd9184939d103c3",
    name: "USDCV / WBTC",
    irm: "0x870aC11D48B15DB9a138Cf899d20F13F79Ba00BC",
    lltv: "860000000000000000",
    oracle: "0x9818FDd69e5C4C6b1d27FA2f0D3d5dE9EE07abb3",
    loanToken: {
      address: "0x5422374B27757da72d5265cC745ea906E0446634",
      symbol: "USDCV",
    },
    collateralToken: {
      address: "0x2260FAC5E5542a773Aa44fBCfeDf7C193bc2C599",
      symbol: "WBTC",
    },
  },
  {
    id: "0xddac4d5caa0b1923ef338d53e01876af69c5b68ebf8e268082c7d3e2be2e7f8e",
    name: "USD0 / USD0USD0++",
    irm: "0x870aC11D48B15DB9a138Cf899d20F13F79Ba00BC",
    lltv: "965000000000000000",
    oracle: "0x0e81d800E2c73247E7481E45aF7F55b96AFc4bE1",
    loanToken: {
      address: "0x73A15FeD60Bf67631dC6cd7Bc5B6e8da8190aCF5",
      symbol: "USD0",
    },
    collateralToken: {
      address: "0x1d08E7adC263CfC70b1BaBe6dC5Bb339c16Eec52",
      symbol: "USD0USD0++",
    },
  },
  {
    id: "0xdd5adf9749b2c71f3be6ec1f5f8da302167b9656e10ab7a21dbbcc6ebe459e88",
    name: "USDC / SLC",
    irm: "0x870aC11D48B15DB9a138Cf899d20F13F79Ba00BC",
    lltv: "860000000000000000",
    oracle: "0xAc0Fa280aD4BA07F750DFa550aA3C3f182ca8B3e",
    loanToken: {
      address: "0xA0b86991c6218b36c1d19D4a2e9Eb0cE3606eB48",
      symbol: "USDC",
    },
    collateralToken: {
      address: "0x1264382BC7c302867F965DdE6A700f0F28154581",
      symbol: "SLC",
    },
  },
  {
    id: "0xdd3989b8bdf3abd2b4f16896b76209893664ea6a82444dd039977f52aa8e07a1",
    name: "SolvBTC.BBN / PT-SolvBTC.BBN-27MAR2025",
    irm: "0x870aC11D48B15DB9a138Cf899d20F13F79Ba00BC",
    lltv: "915000000000000000",
    oracle: "0xE405EC577473362b887864216933c589b38638C4",
    loanToken: {
      address: "0xd9D920AA40f578ab794426F5C90F6C731D159DEf",
      symbol: "SolvBTC.BBN",
    },
    collateralToken: {
      address: "0xd1A1984cc5CAcbd36F6a511877d13662C950fd62",
      symbol: "PT-SolvBTC.BBN-27MAR2025",
    },
  },
  {
    id: "0xdcf3783a1ddea3fad34f37a6e72916ef1432a09067b786b9cfa914ed51ab7086",
    name: "lvlUSD / slvlUSD",
    irm: "0x870aC11D48B15DB9a138Cf899d20F13F79Ba00BC",
    lltv: "915000000000000000",
    oracle: "0x46c18118fEC962Fc4A70b3e6665463bf24Bb7039",
    loanToken: {
      address: "0x7C1156E515aA1A2E851674120074968C905aAF37",
      symbol: "lvlUSD",
    },
    collateralToken: {
      address: "0x4737D9b4592B40d51e110b94c9C043c6654067Ae",
      symbol: "slvlUSD",
    },
  },
  {
    id: "0xdc7f83bb0955f213fafc3120e2d64ea1c8f867437a4624c5c7206026e989a929",
    name: "DAI / YT-eUSDE-14AUG2025",
    irm: "0x870aC11D48B15DB9a138Cf899d20F13F79Ba00BC",
    lltv: "860000000000000000",
    oracle: "0xaE4750d0813B5E37A51f7629beedd72AF1f9cA35",
    loanToken: {
      address: "0x6B175474E89094C44Da98b954EedeAC495271d0F",
      symbol: "DAI",
    },
    collateralToken: {
      address: "0xe8eF806c8aaDc541408dcAd36107c7d26a391712",
      symbol: "YT-eUSDE-14AUG2025",
    },
  },
  {
    id: "0xdc3c7f4442b03efb0cca3d611b3739b4a93539c10f161ea1149d0ec098b4f1bb",
    name: "USDC / cbETH",
    irm: "0x870aC11D48B15DB9a138Cf899d20F13F79Ba00BC",
    lltv: "860000000000000000",
    oracle: "0xDddd770BADd886dF3864029e4B377B5F6a2B6b83",
    loanToken: {
      address: "0xA0b86991c6218b36c1d19D4a2e9Eb0cE3606eB48",
      symbol: "USDC",
    },
    collateralToken: {
      address: "0xBe9895146f7AF43049ca1c1AE358B0541Ea49704",
      symbol: "cbETH",
    },
  },
  {
    id: "0xdbfafc67154cd42c095a8c9d6b9e26e92cd7ce1e1ddef8ce010f706e5483c94e",
    name: "DAI / YT-USDe-27MAR2025",
    irm: "0x870aC11D48B15DB9a138Cf899d20F13F79Ba00BC",
    lltv: "915000000000000000",
    oracle: "0x38d130cEe60CDa080A3b3aC94C79c34B6Fc919A7",
    loanToken: {
      address: "0x6B175474E89094C44Da98b954EedeAC495271d0F",
      symbol: "DAI",
    },
    collateralToken: {
      address: "0x4A8036EFA1307F1cA82d932C0895faa18dB0c9eE",
      symbol: "YT-USDe-27MAR2025",
    },
  },
  {
    id: "0xdbd4a96c854d2dc0f3b115f4f675cd3cc14cc317358b4f8e2442a8363b142eca",
    name: "USDC / tacUSD",
    irm: "0x870aC11D48B15DB9a138Cf899d20F13F79Ba00BC",
    lltv: "915000000000000000",
    oracle: "0xf4374587C66D43DAfac255b0622a56f30026aD51",
    loanToken: {
      address: "0xA0b86991c6218b36c1d19D4a2e9Eb0cE3606eB48",
      symbol: "USDC",
    },
    collateralToken: {
      address: "0x699e04F98dE2Fc395a7dcBf36B48EC837A976490",
      symbol: "tacUSD",
    },
  },
  {
    id: "0xdbabefcc4e7f2fce9b6dd3843df46a92b74819453cf2f92092542e43f68b40ea",
    name: "LBTC / PT-EBTC-26JUN2025",
    irm: "0x870aC11D48B15DB9a138Cf899d20F13F79Ba00BC",
    lltv: "915000000000000000",
    oracle: "0x669B24343c48ebF602F1fb90311B16bA5DD07065",
    loanToken: {
      address: "0x8236a87084f8B84306f72007F36F2618A5634494",
      symbol: "LBTC",
    },
    collateralToken: {
      address: "0xc653F79de1274eE65674BeFda54986020d6f8FC1",
      symbol: "PT-EBTC-26JUN2025",
    },
  },
  {
    id: "0xdb978b12a49e089d25f72a592b349a53754f6cb0fbf0466b058dfab10da7c751",
    name: "USDC / PT-wstUSR-25SEP2025",
    irm: "0x870aC11D48B15DB9a138Cf899d20F13F79Ba00BC",
    lltv: "915000000000000000",
    oracle: "0x6860C98fbd1e1868Aad940d04A05AAD4799e9297",
    loanToken: {
      address: "0xA0b86991c6218b36c1d19D4a2e9Eb0cE3606eB48",
      symbol: "USDC",
    },
    collateralToken: {
      address: "0x23E60d1488525bf4685f53b3aa8E676c30321066",
      symbol: "PT-wstUSR-25SEP2025",
    },
  },
  {
    id: "0xdb59f8cd11dcff99b2f950bc06d3474ab6ca92c3ae296e0a37cb6061979705bc",
    name: "USDC / lfgETH",
    irm: "0x870aC11D48B15DB9a138Cf899d20F13F79Ba00BC",
    lltv: "945000000000000000",
    oracle: "0x84b19767900538066aC5F4eB7221a7aa73AB43dE",
    loanToken: {
      address: "0xA0b86991c6218b36c1d19D4a2e9Eb0cE3606eB48",
      symbol: "USDC",
    },
    collateralToken: {
      address: "0xFB22Ded2bd69aff0907e195F23E448aB44E3cA97",
      symbol: "lfgETH",
    },
  },
  {
    id: "0xdb52908f9c18d8e3c490aaf9b056809d3e2b42f195383efd90b8cb32301807fd",
    name: "USDS / PT-sUSDE-27NOV2025",
    irm: "0x870aC11D48B15DB9a138Cf899d20F13F79Ba00BC",
    lltv: "915000000000000000",
    oracle: "0x098fA1fcB5Ed89Bffb2d6876857764fc14837DB5",
    loanToken: {
      address: "0xdC035D45d973E3EC169d2276DDab16f1e407384F",
      symbol: "USDS",
    },
    collateralToken: {
      address: "0xe6A934089BBEe34F832060CE98848359883749B3",
      symbol: "PT-sUSDE-27NOV2025",
    },
  },
  {
    id: "0xda6e6163096ebbcf1fe1d1ff872bd2d3bded1434f189a4648371336340257acd",
    name: "BOLD / ysyBOLD",
    irm: "0x870aC11D48B15DB9a138Cf899d20F13F79Ba00BC",
    lltv: "915000000000000000",
    oracle: "0x173b7573B2604eEd1B36c88902b236af54B02ef4",
    loanToken: {
      address: "0x6440f144b7e50D6a8439336510312d2F54beB01D",
      symbol: "BOLD",
    },
    collateralToken: {
      address: "0x23346B04a7f55b8760E5860AA5A77383D63491cD",
      symbol: "ysyBOLD",
    },
  },
  {
    id: "0xd9b4dd85dadd11dc7a17687798b2c0037f4ca7ab889d7e627384428681a01bc2",
    name: "AUSD / sUSDS",
    irm: "0x870aC11D48B15DB9a138Cf899d20F13F79Ba00BC",
    lltv: "945000000000000000",
    oracle: "0x97f57Ecbd3A5A752B63CB7c87D7E99A9752baF89",
    loanToken: {
      address: "0x00000000eFE302BEAA2b3e6e1b18d08D69a9012a",
      symbol: "AUSD",
    },
    collateralToken: {
      address: "0xa3931d71877C0E7a3148CB7Eb4463524FEc27fbD",
      symbol: "sUSDS",
    },
  },
  {
    id: "0xd98939d075eebc85569dbbe3a5ef7fd46e1d3efa83452173b172eb93ae557cac",
    name: "AUSD / reUSD",
    irm: "0x870aC11D48B15DB9a138Cf899d20F13F79Ba00BC",
    lltv: "915000000000000000",
    oracle: "0xA66a4F03Fd8031973f8C7718904ce32385f54E70",
    loanToken: {
      address: "0x00000000eFE302BEAA2b3e6e1b18d08D69a9012a",
      symbol: "AUSD",
    },
    collateralToken: {
      address: "0x5086bf358635B81D8C47C66d1C8b9E567Db70c72",
      symbol: "reUSD",
    },
  },
  {
    id: "0xd900cd39bfe9815cbf9fe25f10a0fdb20eed3954c47c087829294a2e8742352f",
    name: "USDC / SL",
    irm: "0x870aC11D48B15DB9a138Cf899d20F13F79Ba00BC",
    lltv: "860000000000000000",
    oracle: "0x663b8Bf5f5C34FD241Ec80De23C71716540fD6cA",
    loanToken: {
      address: "0xA0b86991c6218b36c1d19D4a2e9Eb0cE3606eB48",
      symbol: "USDC",
    },
    collateralToken: {
      address: "0xd359082848c1027257616038A1CdFA2a54438561",
      symbol: "SL",
    },
  },
  {
    id: "0xd86df29b48f2d88a0453027212247a29e68ff52c6589c46054f57285da2fa7e3",
    name: "apxUSD / PT-apxUSD-5NOV2026",
    irm: "0x870aC11D48B15DB9a138Cf899d20F13F79Ba00BC",
    lltv: "945000000000000000",
    oracle: "0xeCA7Ce58Af9c9f57fC7ac4e9bca17731F74C8E0B",
    loanToken: {
      address: "0x98A878b1Cd98131B271883B390f68D2c90674665",
      symbol: "apxUSD",
    },
    collateralToken: {
      address: "0xAF687B5EcB525Ccea96115088999B4eD80C388b6",
      symbol: "PT-apxUSD-5NOV2026",
    },
  },
  {
    id: "0xd8609686aa3dca91d6ee89da37b2fdd85680c87cd0695e625b9c79bdbc8db020",
    name: "USDT / BCPGOLD",
    irm: "0x870aC11D48B15DB9a138Cf899d20F13F79Ba00BC",
    lltv: "385000000000000000",
    oracle: "0x130893D8536C0c8Dc3B5f6a5fc1de509a0811FE6",
    loanToken: {
      address: "0xdAC17F958D2ee523a2206206994597C13D831ec7",
      symbol: "USDT",
    },
    collateralToken: {
      address: "0xA0C2b22a2f2229ec608150ED7EC095edB55508d4",
      symbol: "BCPGOLD",
    },
  },
  {
    id: "0xd81431620b647bc146579ff211469c565f217ba78dc2a7749386c67e10760950",
    name: "USDCV / USTBL",
    irm: "0x870aC11D48B15DB9a138Cf899d20F13F79Ba00BC",
    lltv: "915000000000000000",
    oracle: "0x45B38cb324b33b48E782F05285ae3394a59CFd90",
    loanToken: {
      address: "0x5422374B27757da72d5265cC745ea906E0446634",
      symbol: "USDCV",
    },
    collateralToken: {
      address: "0xe4880249745eAc5F1eD9d8F7DF844792D560e750",
      symbol: "USTBL",
    },
  },
  {
    id: "0xd7ffd6abf6dbfe45939da8df918a4426b60ff40bba40727eb663f7a98f2d28a7",
    name: "lvWETH / lvstETH",
    irm: "0x870aC11D48B15DB9a138Cf899d20F13F79Ba00BC",
    lltv: "945000000000000000",
    oracle: "0xCE702756f7b0CD131baa41D87efc2a2455F157bA",
    loanToken: {
      address: "0x71ACEeDd2E55AAbfc739187a0915a24cb7fc376f",
      symbol: "lvWETH",
    },
    collateralToken: {
      address: "0xD3C8675ef21043A315A84950efC539E2c1b520f7",
      symbol: "lvstETH",
    },
  },
  {
    id: "0xd7ae2bdded0d72367b68b87b60419b349cb47404b532b5bf7330bd2d535dfef6",
    name: "PT-corn-SolvBTC.BBN-26DEC2024 / WBTC",
    irm: "0x870aC11D48B15DB9a138Cf899d20F13F79Ba00BC",
    lltv: "915000000000000000",
    oracle: "0x309b563107f6AfBEa888acF1E1BffE0dB8a8d08B",
    loanToken: {
      address: "0x23e479ddcda990E8523494895759bD98cD2fDBF6",
      symbol: "PT-corn-SolvBTC.BBN-26DEC2024",
    },
    collateralToken: {
      address: "0x2260FAC5E5542a773Aa44fBCfeDf7C193bc2C599",
      symbol: "WBTC",
    },
  },
  {
    id: "0xd79d4f7e2ba3de2f5ddf6521fb38e81909f6bead9f9b1971496fbddb7dbca52c",
    name: "lvlUSD / PT-slvlUSD-29MAY2025",
    irm: "0x870aC11D48B15DB9a138Cf899d20F13F79Ba00BC",
    lltv: "915000000000000000",
    oracle: "0x7d682F81730Cd39C85dA92f205Db33659536a781",
    loanToken: {
      address: "0x7C1156E515aA1A2E851674120074968C905aAF37",
      symbol: "lvlUSD",
    },
    collateralToken: {
      address: "0x4D4062bAD41E03b1cdee4C06263F96EB81832341",
      symbol: "PT-slvlUSD-29MAY2025",
    },
  },
  {
    id: "0xd7976c815c85ef77956d8e35f1558db703c76cb07276addb58028d7d31d589f3",
    name: "LBTC / cbBTC",
    irm: "0x870aC11D48B15DB9a138Cf899d20F13F79Ba00BC",
    lltv: "945000000000000000",
    oracle: "0xAcFDA81CFf3bf4b48b86bBa590fb89FFa77e7950",
    loanToken: {
      address: "0x8236a87084f8B84306f72007F36F2618A5634494",
      symbol: "LBTC",
    },
    collateralToken: {
      address: "0xcbB7C0000aB88B473b1f5aFd9ef808440eed33Bf",
      symbol: "cbBTC",
    },
  },
  {
    id: "0xd79043d542e697d589b554cf8312ff7810ad1aa91a4d62c4950535cdfcfb5ccc",
    name: "USDtb / PT-sUSDE-31JUL2025",
    irm: "0x870aC11D48B15DB9a138Cf899d20F13F79Ba00BC",
    lltv: "915000000000000000",
    oracle: "0xeF13fC7616E49bdcF1442Be4dbfe548296CB35Bc",
    loanToken: {
      address: "0xC139190F447e929f090Edeb554D95AbB8b18aC1C",
      symbol: "USDtb",
    },
    collateralToken: {
      address: "0x3b3fB9C57858EF816833dC91565EFcd85D96f634",
      symbol: "PT-sUSDE-31JUL2025",
    },
  },
  {
    id: "0xd78df901ce154470bc58e33d03cfe3af6b66e04d8e761c84f13f1de2c92ccaf1",
    name: "tGBP / sUSDS",
    irm: "0x870aC11D48B15DB9a138Cf899d20F13F79Ba00BC",
    lltv: "915000000000000000",
    oracle: "0x54D626e037DE18595Ec4B97BA120da5c0fA8689f",
    loanToken: {
      address: "0x27f6c8289550fCE67f6B50BeD1F519966aFE5287",
      symbol: "tGBP",
    },
    collateralToken: {
      address: "0xa3931d71877C0E7a3148CB7Eb4463524FEc27fbD",
      symbol: "sUSDS",
    },
  },
  {
    id: "0xd758bc7aed5626cfdc52c6ccce095d1b3a2f62cf3b252f78c50c0e823e8bda49",
    name: "USDC / BUIDL",
    irm: "0x870aC11D48B15DB9a138Cf899d20F13F79Ba00BC",
    lltv: "860000000000000000",
    oracle: "0xDddd770BADd886dF3864029e4B377B5F6a2B6b83",
    loanToken: {
      address: "0xA0b86991c6218b36c1d19D4a2e9Eb0cE3606eB48",
      symbol: "USDC",
    },
    collateralToken: {
      address: "0x7712c34205737192402172409a8F7ccef8aA2AEc",
      symbol: "BUIDL",
    },
  },
  {
    id: "0xd6c52f9f1224b2250f72d7ae7bb8e730f97f75fcf615639ebdfa8302301f30e5",
    name: "ZCHF / sZCHF",
    irm: "0x870aC11D48B15DB9a138Cf899d20F13F79Ba00BC",
    lltv: "965000000000000000",
    oracle: "0xf7418bC12c0A4Ed4d5D8697a269E9639247E17F9",
    loanToken: {
      address: "0xB58E61C3098d85632Df34EecfB899A1Ed80921cB",
      symbol: "ZCHF",
    },
    collateralToken: {
      address: "0x00e632728d5aB91fe8319760fFdD2D7362E28139",
      symbol: "sZCHF",
    },
  },
  {
    id: "0xd6b32ebd17bdcfcb91b5a1bf4940439167067d7bca225a3bea781df1882b265d",
    name: "tGBP / steakUSDC",
    irm: "0x870aC11D48B15DB9a138Cf899d20F13F79Ba00BC",
    lltv: "915000000000000000",
    oracle: "0x23cC7dC3a9EBf5181d4Ef15d9580B8FFE4849004",
    loanToken: {
      address: "0x27f6c8289550fCE67f6B50BeD1F519966aFE5287",
      symbol: "tGBP",
    },
    collateralToken: {
      address: "0xbeef088055857739C12CD3765F20b7679Def0f51",
      symbol: "steakUSDC",
    },
  },
  {
    id: "0xd6a9afe53c062d793f561fdc6458bf2e24d3fc17f4674d7e95f4dfd0e951e06d",
    name: "USDR / XAUt",
    irm: "0x870aC11D48B15DB9a138Cf899d20F13F79Ba00BC",
    lltv: "770000000000000000",
    oracle: "0xc7d1FE3fBe90e8f755250CA3Ce4d2aE50873d9dc",
    loanToken: {
      address: "0x7B43E3875440B44613DC3bC08E7763e6Da63C8f8",
      symbol: "USDR",
    },
    collateralToken: {
      address: "0x68749665FF8D2d112Fa859AA293F07A622782F38",
      symbol: "XAUt",
    },
  },
  {
    id: "0xd3f54cc8f7a0754523aacc9c68ec1a1bb34ad6f4fa817729919f3460449bd197",
    name: "USDT / PKZZZ",
    irm: "0x870aC11D48B15DB9a138Cf899d20F13F79Ba00BC",
    lltv: "915000000000000000",
    oracle: "0x3E7d1eAB13ad0104d2750B8863b489D65364e32D",
    loanToken: {
      address: "0xdAC17F958D2ee523a2206206994597C13D831ec7",
      symbol: "USDT",
    },
    collateralToken: {
      address: "0x05827E261Af3aE38346F4e7Fa9760B4798ae3cf0",
      symbol: "PKZZZ",
    },
  },
  {
    id: "0xd3e70940f9b3f209f9e5533036902dff64dd33b1494e912ebddf65971232e49a",
    name: "USDC / RZR",
    irm: "0x870aC11D48B15DB9a138Cf899d20F13F79Ba00BC",
    lltv: "770000000000000000",
    oracle: "0xc46E157ef92Cde37c0f8044b65d892CBCdaCAf10",
    loanToken: {
      address: "0xA0b86991c6218b36c1d19D4a2e9Eb0cE3606eB48",
      symbol: "USDC",
    },
    collateralToken: {
      address: "0xb4444468e444f89e1c2CAc2F1D3ee7e336cBD1f5",
      symbol: "RZR",
    },
  },
  {
    id: "0xd3b93e2f5f0ba017121d1ba896efe800d097962f6bc43c6786f7393c6a12c58a",
    name: "VUSD / hemiBTC",
    irm: "0x870aC11D48B15DB9a138Cf899d20F13F79Ba00BC",
    lltv: "945000000000000000",
    oracle: "0x9F7c53ae6eFa70251fF6F6dD5401076F33fd4543",
    loanToken: {
      address: "0x677ddbd918637E5F2c79e164D402454dE7dA8619",
      symbol: "VUSD",
    },
    collateralToken: {
      address: "0x06ea695B91700071B161A434fED42D1DcbAD9f00",
      symbol: "hemiBTC",
    },
  },
  {
    id: "0xd2f6566985e04c06c9062b8982039267f4faf81d0c19cc93128bc8f11c706bc4",
    name: "lvWETH / lvstETH",
    irm: "0x870aC11D48B15DB9a138Cf899d20F13F79Ba00BC",
    lltv: "945000000000000000",
    oracle: "0xb6B9827b64fDFFCAf3e0Ea623078D2057c381E9e",
    loanToken: {
      address: "0x475D94f27bEd12291EAB466e9FeE8217Da3d0E01",
      symbol: "lvWETH",
    },
    collateralToken: {
      address: "0xA5d3dBa081ED44897d859fe741B1EE9596bf851e",
      symbol: "lvstETH",
    },
  },
  {
    id: "0xd2dc0d529a928df7bd041fd658c692393b625fe97d3f6bf3346a3bea6be85e59",
    name: "USDC / syzUSD",
    irm: "0x870aC11D48B15DB9a138Cf899d20F13F79Ba00BC",
    lltv: "915000000000000000",
    oracle: "0xDc2C97613d79D87Fba318024CF3f89FeeFb0b94A",
    loanToken: {
      address: "0xA0b86991c6218b36c1d19D4a2e9Eb0cE3606eB48",
      symbol: "USDC",
    },
    collateralToken: {
      address: "0x6DFF69eb720986E98Bb3E8b26cb9E02Ec1a35D12",
      symbol: "syzUSD",
    },
  },
  {
    id: "0xd27961160558fb1118b8aebcf581fad52d97542866317002c934e979dd1b5608",
    name: "USDS / BOBO",
    irm: "0x870aC11D48B15DB9a138Cf899d20F13F79Ba00BC",
    lltv: "770000000000000000",
    oracle: "0x30fc2d5005ADc0652a34B93081346919471B8077",
    loanToken: {
      address: "0xdC035D45d973E3EC169d2276DDab16f1e407384F",
      symbol: "USDS",
    },
    collateralToken: {
      address: "0xB90B2A35C65dBC466b04240097Ca756ad2005295",
      symbol: "BOBO",
    },
  },
  {
    id: "0xd2630c0ebf33ba83c82e8cd400a8e6345370238ca695ce58773b2d3e43de1b0a",
    name: "msETH / ynETHx",
    irm: "0x870aC11D48B15DB9a138Cf899d20F13F79Ba00BC",
    lltv: "915000000000000000",
    oracle: "0xc28F86C86F79282E2d2A1f45442339C55f7eB22D",
    loanToken: {
      address: "0x64351fC9810aDAd17A690E4e1717Df5e7e085160",
      symbol: "msETH",
    },
    collateralToken: {
      address: "0x657d9ABA1DBb59e53f9F3eCAA878447dCfC96dCb",
      symbol: "ynETHx",
    },
  },
  {
    id: "0xd1e844defc605ad0582899c6456b2f4d0aaded83b82bd60be576414d925e3034",
    name: "crvUSD / ",
    irm: "0x870aC11D48B15DB9a138Cf899d20F13F79Ba00BC",
    lltv: "860000000000000000",
    oracle: "0x20BA4D455a7Bd926D77c22A76765dF54d2f0c315",
    loanToken: {
      address: "0xf939E0A03FB07F59A73314E73794Be0E57ac1b4E",
      symbol: "crvUSD",
    },
    collateralToken: {
      address: "0x7086288478ce9dF52862b5E88eD18d232e9a5213",
      symbol: "",
    },
  },
  {
    id: "0xd1331c868bd2783784cd22046978bf365ae2c23ffd94625b0261db9aa8ae3561",
    name: "cUSDO / jUSD",
    irm: "0x870aC11D48B15DB9a138Cf899d20F13F79Ba00BC",
    lltv: "915000000000000000",
    oracle: "0x0D242F77aF3BF377C9A6ec35Ad9b68a8F770546a",
    loanToken: {
      address: "0xaD55aebc9b8c03FC43cd9f62260391c13c23e7c0",
      symbol: "cUSDO",
    },
    collateralToken: {
      address: "0x000000096CB3D4007fC2b79b935C4540C5c2d745",
      symbol: "jUSD",
    },
  },
  {
    id: "0xd0e1c0b6bfc563e9ae4fd3515abad7b3929eaeac3bf18a7cd9c74b869843f16f",
    name: "USR / PT-wstUSR-29JAN2026",
    irm: "0x870aC11D48B15DB9a138Cf899d20F13F79Ba00BC",
    lltv: "915000000000000000",
    oracle: "0x2df1BdB44728ed2b48cAd7975667482F14f2c715",
    loanToken: {
      address: "0x66a1E37c9b0eAddca17d3662D6c05F4DECf3e110",
      symbol: "USR",
    },
    collateralToken: {
      address: "0xfCeEB7586bab730fA400A5BF3FcF298d0DB4c7e7",
      symbol: "PT-wstUSR-29JAN2026",
    },
  },
  {
    id: "0xcff5f8a928ae33020750ba807455c5e473f6f97f9fecd7316b20e4ed2a3abb82",
    name: "AUSD / FLHYon",
    irm: "0x870aC11D48B15DB9a138Cf899d20F13F79Ba00BC",
    lltv: "860000000000000000",
    oracle: "0xD703c55B871D999eA5435aC3721B19296Ac249D1",
    loanToken: {
      address: "0x00000000eFE302BEAA2b3e6e1b18d08D69a9012a",
      symbol: "AUSD",
    },
    collateralToken: {
      address: "0x54C1Ff361b402f66c13107421E6A431C3375EF24",
      symbol: "FLHYon",
    },
  },
  {
    id: "0xcfe8238ad5567886652ced15ee29a431c161a5904e5a6f380baaa1b4fdc8e302",
    name: "USR / wstUSR",
    irm: "0x870aC11D48B15DB9a138Cf899d20F13F79Ba00BC",
    lltv: "915000000000000000",
    oracle: "0x1982FAC5d1116639e4a6647De8BF1cD8c6555AF1",
    loanToken: {
      address: "0x66a1E37c9b0eAddca17d3662D6c05F4DECf3e110",
      symbol: "USR",
    },
    collateralToken: {
      address: "0x1202F5C7b4B9E47a1A484E8B270be34dbbC75055",
      symbol: "wstUSR",
    },
  },
  {
    id: "0xcfb2f15b7d287bee0a6fd4ee59d91d2ea7bc3c5af63d1411df8ffd13694c1668",
    name: "USR / PT-USR-4SEP2025",
    irm: "0x870aC11D48B15DB9a138Cf899d20F13F79Ba00BC",
    lltv: "915000000000000000",
    oracle: "0x2B30C28F413609952A068626bD0b6aC1CBE9A31d",
    loanToken: {
      address: "0x66a1E37c9b0eAddca17d3662D6c05F4DECf3e110",
      symbol: "USR",
    },
    collateralToken: {
      address: "0x5a5b93F762739fa94F3EcC0b34Af2e56702E7f70",
      symbol: "PT-USR-4SEP2025",
    },
  },
  {
    id: "0xcfa3f22264719e44489cac0abe5f99ec8799ce6e40e22fbc1c24633d4697cb6c",
    name: "USDe / PT-srUSDe-15JAN2026",
    irm: "0x870aC11D48B15DB9a138Cf899d20F13F79Ba00BC",
    lltv: "915000000000000000",
    oracle: "0xA5Fa9651C9D0901Bf8E7751C44117F8D49E9FCCc",
    loanToken: {
      address: "0x4c9EDD5852cd905f086C759E8383e09bff1E68B3",
      symbol: "USDe",
    },
    collateralToken: {
      address: "0x1Fb3C5c35D95F48e48FFC8e36bCCe5CB5f29F57c",
      symbol: "PT-srUSDe-15JAN2026",
    },
  },
  {
    id: "0xcf2c42ea759616f1804579a913363bf1da00a3ad9583870bf705bd45ba31637e",
    name: "cbBTC / PT-LBTC-26JUN2025",
    irm: "0x870aC11D48B15DB9a138Cf899d20F13F79Ba00BC",
    lltv: "915000000000000000",
    oracle: "0xE99c483129063C257a0B29257c66ac25ED65316b",
    loanToken: {
      address: "0xcbB7C0000aB88B473b1f5aFd9ef808440eed33Bf",
      symbol: "cbBTC",
    },
    collateralToken: {
      address: "0x6cA4d5d2eCb72E3Bbf17543B3367746B80D22694",
      symbol: "PT-LBTC-26JUN2025",
    },
  },
  {
    id: "0xce6fc003b276f84f9c27864020b74481c526f89944ba838c9cc0d7bec78dd5c6",
    name: "WETH / XDC",
    irm: "0x870aC11D48B15DB9a138Cf899d20F13F79Ba00BC",
    lltv: "945000000000000000",
    oracle: "0x2EDc1F136295DE11670A0FF519E3dfcBE48ae8F9",
    loanToken: {
      address: "0xC02aaA39b223FE8D0A0e5C4F27eAD9083C756Cc2",
      symbol: "WETH",
    },
    collateralToken: {
      address: "0x41AB1b6fcbB2fA9DCEd81aCbdeC13Ea6315F2Bf2",
      symbol: "XDC",
    },
  },
  {
    id: "0xce3a5f1bd26a980be6db1b7acc1a082413bb948d9b19fb4a92cfe5108ff2f275",
    name: "USDS / NPC",
    irm: "0x870aC11D48B15DB9a138Cf899d20F13F79Ba00BC",
    lltv: "770000000000000000",
    oracle: "0x853a46E9B2a81D66Fe5e902AF771879B70933446",
    loanToken: {
      address: "0xdC035D45d973E3EC169d2276DDab16f1e407384F",
      symbol: "USDS",
    },
    collateralToken: {
      address: "0x8eD97a637A790Be1feff5e888d43629dc05408F6",
      symbol: "NPC",
    },
  },
  {
    id: "0xce2efd4b2d2b4a7bf5c2fa27841b3d4d82f1555eaabe7ad095c79e009d854886",
    name: "USDC / PT-srUSDe-25JUN2026",
    irm: "0x870aC11D48B15DB9a138Cf899d20F13F79Ba00BC",
    lltv: "915000000000000000",
    oracle: "0x38856EB62fd0805666645697E6052e9eD8E93622",
    loanToken: {
      address: "0xA0b86991c6218b36c1d19D4a2e9Eb0cE3606eB48",
      symbol: "USDC",
    },
    collateralToken: {
      address: "0x619D75E3b790eBC21c289f2805Bb7177A7D732E2",
      symbol: "PT-srUSDe-25JUN2026",
    },
  },
  {
    id: "0xcde91686d5a37d199bef64c2b9487d5be745c5a617ba4a76712d87cc2a92fcc1",
    name: "USDS / CANA",
    irm: "0x870aC11D48B15DB9a138Cf899d20F13F79Ba00BC",
    lltv: "860000000000000000",
    oracle: "0x91d8628309592639A9D92C755b91188ada948f74",
    loanToken: {
      address: "0xdC035D45d973E3EC169d2276DDab16f1e407384F",
      symbol: "USDS",
    },
    collateralToken: {
      address: "0x01995A697752266d8E748738aAa3F06464B8350B",
      symbol: "CANA",
    },
  },
  {
    id: "0xcdd5861fe5b1784fcc17648a1e81b04d9b0bad9dbb1a649302dd0734f0792e97",
    name: "USDC / PT-USDe-5FEB2026",
    irm: "0x870aC11D48B15DB9a138Cf899d20F13F79Ba00BC",
    lltv: "915000000000000000",
    oracle: "0x040a101b02785cd4462030e18f31996A31D52D8D",
    loanToken: {
      address: "0xA0b86991c6218b36c1d19D4a2e9Eb0cE3606eB48",
      symbol: "USDC",
    },
    collateralToken: {
      address: "0x1F84a51296691320478c98b8d77f2Bbd17D34350",
      symbol: "PT-USDe-5FEB2026",
    },
  },
  {
    id: "0xccc12702b53f19835bd043f65c3317c886b44d5e747ce1da3ef502947a4314e6",
    name: "USDC / stUSDS",
    irm: "0x870aC11D48B15DB9a138Cf899d20F13F79Ba00BC",
    lltv: "860000000000000000",
    oracle: "0x3699ABA2d63532A0890A761CAd609D128A631Dc5",
    loanToken: {
      address: "0xA0b86991c6218b36c1d19D4a2e9Eb0cE3606eB48",
      symbol: "USDC",
    },
    collateralToken: {
      address: "0x99CD4Ec3f88A45940936F469E4bB72A2A701EEB9",
      symbol: "stUSDS",
    },
  },
  {
    id: "0xcc7b191903e4750ad71898a1594d912adbb5bb1c6effcde9c38f0a798112edd1",
    name: "USDA / PT-weETH-27JUN2024",
    irm: "0x870aC11D48B15DB9a138Cf899d20F13F79Ba00BC",
    lltv: "860000000000000000",
    oracle: "0x5441731eED05A8208e795086a5dF41416DD34104",
    loanToken: {
      address: "0x0000206329b97DB379d5E1Bf586BbDB969C63274",
      symbol: "USDA",
    },
    collateralToken: {
      address: "0xc69Ad9baB1dEE23F4605a82b3354F8E40d1E5966",
      symbol: "PT-weETH-27JUN2024",
    },
  },
  {
    id: "0xcc39b6c92fd03ac608b9239618db8b80a4a2034b0450bdf47b404229571312da",
    name: "USD0 / MC-USR",
    irm: "0x870aC11D48B15DB9a138Cf899d20F13F79Ba00BC",
    lltv: "915000000000000000",
    oracle: "0x5eFDCAe531BD6ff8FC84c203F65F31E36d1099FB",
    loanToken: {
      address: "0x73A15FeD60Bf67631dC6cd7Bc5B6e8da8190aCF5",
      symbol: "USD0",
    },
    collateralToken: {
      address: "0xD50DA5F859811A91fD1876C9461fD39c23C747Ad",
      symbol: "MC-USR",
    },
  },
  {
    id: "0xcbd8d55bce36e05c4bbdf93ad867329dd541a594243f9510b5379d04bd9c4c6f",
    name: "TESTUSD / hemiBTC",
    irm: "0x870aC11D48B15DB9a138Cf899d20F13F79Ba00BC",
    lltv: "945000000000000000",
    oracle: "0x2B816cecb2ccF258426d8d5699DB697FD9279bC5",
    loanToken: {
      address: "0xB94724aa74A0296447D13a63A35B050b7F137C6d",
      symbol: "TESTUSD",
    },
    collateralToken: {
      address: "0x06ea695B91700071B161A434fED42D1DcbAD9f00",
      symbol: "hemiBTC",
    },
  },
  {
    id: "0xcbc21405c11c8eb13f1741bfba2a72dfbdab3cb525b79dc5b61148b1183b79a0",
    name: "USDS / PEPE",
    irm: "0x870aC11D48B15DB9a138Cf899d20F13F79Ba00BC",
    lltv: "625000000000000000",
    oracle: "0xAd44b8257fB730E7344bCBe2908679324BD4dcf0",
    loanToken: {
      address: "0xdC035D45d973E3EC169d2276DDab16f1e407384F",
      symbol: "USDS",
    },
    collateralToken: {
      address: "0x6982508145454Ce325dDbE47a25d4ec3d2311933",
      symbol: "PEPE",
    },
  },
  {
    id: "0xcb360b3374723d7c97b5af24d53a9cb3834ad4d3b9f6a0a6a62d22348069a62c",
    name: "USDT / ysUSDS",
    irm: "0x870aC11D48B15DB9a138Cf899d20F13F79Ba00BC",
    lltv: "965000000000000000",
    oracle: "0x0c0b8490a439c0937579d67fDBC15a4219493B2b",
    loanToken: {
      address: "0xdAC17F958D2ee523a2206206994597C13D831ec7",
      symbol: "USDT",
    },
    collateralToken: {
      address: "0x4cE9c93513DfF543Bc392870d57dF8C04e89Ba0a",
      symbol: "ysUSDS",
    },
  },
  {
    id: "0xcb0d60b21e75d3ae77a0dd67d397c59833b9f09f732e93076121768ca273f8a0",
    name: "USDC / PT-AIDaUSDC-14AUG2025",
    irm: "0x870aC11D48B15DB9a138Cf899d20F13F79Ba00BC",
    lltv: "915000000000000000",
    oracle: "0x1285e4d5A689c71E25bB6804AB5b290A743c3Db8",
    loanToken: {
      address: "0xA0b86991c6218b36c1d19D4a2e9Eb0cE3606eB48",
      symbol: "USDC",
    },
    collateralToken: {
      address: "0x6E6551A332c453eaD27bC3B2a084657dee1b5F76",
      symbol: "PT-AIDaUSDC-14AUG2025",
    },
  },
  {
    id: "0xca35ba8a7dfbb886b1e5ca7f5a600484518788feb038bf59b906e7f1e86fdbb4",
    name: "LBTC / eBTC",
    irm: "0x870aC11D48B15DB9a138Cf899d20F13F79Ba00BC",
    lltv: "915000000000000000",
    oracle: "0x2dC7bC2081Ef6464a50c4F81073863F4976B1FC9",
    loanToken: {
      address: "0x8236a87084f8B84306f72007F36F2618A5634494",
      symbol: "LBTC",
    },
    collateralToken: {
      address: "0x657e8C867D8B37dCC18fA4Caead9C45EB088C642",
      symbol: "eBTC",
    },
  },
  {
    id: "0xca260ba9ffe237d9b85106e9fe926baa6a0645d15c8c3976b914301fc6927d1a",
    name: "rUSD / PT-wsrUSD-31JUL2025",
    irm: "0x870aC11D48B15DB9a138Cf899d20F13F79Ba00BC",
    lltv: "915000000000000000",
    oracle: "0x15681aE0146C505761cbc2fac71Cf37d29c2A0bf",
    loanToken: {
      address: "0x09D4214C03D01F49544C0448DBE3A27f768F2b34",
      symbol: "rUSD",
    },
    collateralToken: {
      address: "0x3bd0C522eA444eA2B3F28777e8C20248b6E33252",
      symbol: "PT-wsrUSD-31JUL2025",
    },
  },
  {
    id: "0xc96f9c1562cd9da5d75ec958e84ee4095ef4708d6d27f2ccc7baac1d865242bb",
    name: "HilBTC / tWBTC",
    irm: "0x870aC11D48B15DB9a138Cf899d20F13F79Ba00BC",
    lltv: "860000000000000000",
    oracle: "0x07Ed3029AE401f4B012A257BB0721dee3bE695C3",
    loanToken: {
      address: "0x88563b651ABF39D5e24d8210bcAB62014A504108",
      symbol: "HilBTC",
    },
    collateralToken: {
      address: "0x935D17FF6A8AD0299E6ff77eE04722fDE9e062DC",
      symbol: "tWBTC",
    },
  },
  {
    id: "0xc9633699b614a492cf4f36de2ae7a2d26673d86c0573749fd3fde927b15294bf",
    name: "USDC / PT-USDat-27AUG2026",
    irm: "0x870aC11D48B15DB9a138Cf899d20F13F79Ba00BC",
    lltv: "915000000000000000",
    oracle: "0x710fA87a63aaBD4505Ca06e29E9FdF5160E984d1",
    loanToken: {
      address: "0xA0b86991c6218b36c1d19D4a2e9Eb0cE3606eB48",
      symbol: "USDC",
    },
    collateralToken: {
      address: "0x1D69402390657308C91179aa184bF992908c1e08",
      symbol: "PT-USDat-27AUG2026",
    },
  },
  {
    id: "0xc8f153a103074144c5c21acbe6f0659d99a7921d1be7ec1fa0f29a78d20ecca2",
    name: "BOLD / PT-sBOLD-1765325646",
    irm: "0x870aC11D48B15DB9a138Cf899d20F13F79Ba00BC",
    lltv: "915000000000000000",
    oracle: "0xDf1eC7413299a745Fd6eCaBE299947b44D0BBcE2",
    loanToken: {
      address: "0x6440f144b7e50D6a8439336510312d2F54beB01D",
      symbol: "BOLD",
    },
    collateralToken: {
      address: "0x1Ff893C9071d04F8A965a90FcB0de22406A3eEaa",
      symbol: "PT-sBOLD-1765325646",
    },
  },
  {
    id: "0xc8d4b2c242f83d6e3d30550d437dfe4e86ad79ce9330456f5ba39390d5af7ec8",
    name: "USDT / ysUSDS",
    irm: "0x870aC11D48B15DB9a138Cf899d20F13F79Ba00BC",
    lltv: "945000000000000000",
    oracle: "0x0c0b8490a439c0937579d67fDBC15a4219493B2b",
    loanToken: {
      address: "0xdAC17F958D2ee523a2206206994597C13D831ec7",
      symbol: "USDT",
    },
    collateralToken: {
      address: "0x4cE9c93513DfF543Bc392870d57dF8C04e89Ba0a",
      symbol: "ysUSDS",
    },
  },
  {
    id: "0xc8710f173bebd111231899cd836034c160da5c9af3b662d567725c16a9d46a1c",
    name: "USDT / PT-AIDaUSDT-14AUG2025",
    irm: "0x870aC11D48B15DB9a138Cf899d20F13F79Ba00BC",
    lltv: "915000000000000000",
    oracle: "0x75A7c9FDe77ad4c70aB5E9a0a020D8E9064A64f0",
    loanToken: {
      address: "0xdAC17F958D2ee523a2206206994597C13D831ec7",
      symbol: "USDT",
    },
    collateralToken: {
      address: "0xA28194DE3de7166Ee81C2E13c864b9C7CcA1b8eF",
      symbol: "PT-AIDaUSDT-14AUG2025",
    },
  },
  {
    id: "0xc84cdb5a63207d8c2e7251f758a435c6bd10b4eaefdaf36d7650159bf035962e",
    name: "rUSD / srUSD",
    irm: "0x870aC11D48B15DB9a138Cf899d20F13F79Ba00BC",
    lltv: "980000000000000000",
    oracle: "0x3aBB61053F4b18AA8fd95B7802Cb2E27B61Ab43a",
    loanToken: {
      address: "0x09D4214C03D01F49544C0448DBE3A27f768F2b34",
      symbol: "rUSD",
    },
    collateralToken: {
      address: "0x738d1115B90efa71AE468F1287fc864775e23a31",
      symbol: "srUSD",
    },
  },
  {
    id: "0xc7d717f4052ac4e5463dcc58cea0f6b05dd7d8c67e0aee68ebe30a8af09b259f",
    name: "USDS / SPX",
    irm: "0x870aC11D48B15DB9a138Cf899d20F13F79Ba00BC",
    lltv: "770000000000000000",
    oracle: "0xdA63266b5184D08DbFBace96267837c45D7D34dA",
    loanToken: {
      address: "0xdC035D45d973E3EC169d2276DDab16f1e407384F",
      symbol: "USDS",
    },
    collateralToken: {
      address: "0xE0f63A424a4439cBE457D80E4f4b51aD25b2c56C",
      symbol: "SPX",
    },
  },
  {
    id: "0xc78cb7c7cf3026d33d849ef06f3f68e1b2112ab503789f879d7b9536c13348dc",
    name: "USDA / stUSD",
    irm: "0x870aC11D48B15DB9a138Cf899d20F13F79Ba00BC",
    lltv: "965000000000000000",
    oracle: "0x84Dd864dD53d8A3ad4d255c8AaeE0B3c5926Ad5E",
    loanToken: {
      address: "0x0000206329b97DB379d5E1Bf586BbDB969C63274",
      symbol: "USDA",
    },
    collateralToken: {
      address: "0x0022228a2cc5E7eF0274A7Baa600d44da5aB5776",
      symbol: "stUSD",
    },
  },
  {
    id: "0xc74379db6de2097b5abe991010ccb17d0628ea2cf782886b9b53bebbcd83f770",
    name: "USDC / JAB78",
    irm: "0x870aC11D48B15DB9a138Cf899d20F13F79Ba00BC",
    lltv: "860000000000000000",
    oracle: "0x48F7E36EB6B826B2dF4B2E630B62Cd25e89E40e2",
    loanToken: {
      address: "0xA0b86991c6218b36c1d19D4a2e9Eb0cE3606eB48",
      symbol: "USDC",
    },
    collateralToken: {
      address: "0xBbbc3a5D8c6A58465dB110BF69adF86731b63E56",
      symbol: "JAB78",
    },
  },
  {
    id: "0xc73fd67d52aa7e33f507f79271ca099465adab7c3882d6cec47951a0806385e1",
    name: "fwDAI / fwUNI",
    irm: "0x870aC11D48B15DB9a138Cf899d20F13F79Ba00BC",
    lltv: "625000000000000000",
    oracle: "0x978141De16E243ad7193d331E6Bd1a45241DFC92",
    loanToken: {
      address: "0x8A6fe57C08C84e0f4eE97aAe68a62e820a37d259",
      symbol: "fwDAI",
    },
    collateralToken: {
      address: "0xE8E1F50392Bd61D0F8F48E8E7aF51D3b8a52090a",
      symbol: "fwUNI",
    },
  },
  {
    id: "0xc69891665c85d1cce4eade67f15b9fda64c6bfbf3f1a92fffcc4d97b5cb61cfd",
    name: "rUSD / PT-wsrUSD-30OCT2025",
    irm: "0x870aC11D48B15DB9a138Cf899d20F13F79Ba00BC",
    lltv: "915000000000000000",
    oracle: "0x3b497349342694c64a73F38385591F415F9320Ad",
    loanToken: {
      address: "0x09D4214C03D01F49544C0448DBE3A27f768F2b34",
      symbol: "rUSD",
    },
    collateralToken: {
      address: "0x10a099BAf814B5FDa138c4e6b60eD42c0d975be8",
      symbol: "PT-wsrUSD-30OCT2025",
    },
  },
  {
    id: "0xc4d9010ea4dbc3b5bbb11360324cd84de72f94f108862db37d2aef6f2bdb0423",
    name: "JPYC / WBTC",
    irm: "0x870aC11D48B15DB9a138Cf899d20F13F79Ba00BC",
    lltv: "625000000000000000",
    oracle: "0xE55829708B70077f142215cf740cAEb55dDC83a4",
    loanToken: {
      address: "0xE7C3D8C9a439feDe00D2600032D5dB0Be71C3c29",
      symbol: "JPYC",
    },
    collateralToken: {
      address: "0x2260FAC5E5542a773Aa44fBCfeDf7C193bc2C599",
      symbol: "WBTC",
    },
  },
  {
    id: "0xc48fbb6ac634123f64461e546a6e5bd06bbfa65adae19e9172a8bb4456b932ca",
    name: "VUSD / hemiBTC",
    irm: "0x870aC11D48B15DB9a138Cf899d20F13F79Ba00BC",
    lltv: "945000000000000000",
    oracle: "0x2B816cecb2ccF258426d8d5699DB697FD9279bC5",
    loanToken: {
      address: "0x677ddbd918637E5F2c79e164D402454dE7dA8619",
      symbol: "VUSD",
    },
    collateralToken: {
      address: "0x06ea695B91700071B161A434fED42D1DcbAD9f00",
      symbol: "hemiBTC",
    },
  },
  {
    id: "0xc4646bfe3b828231309542fa35eb3ca602aae01aa775029c127d8568c06d7fd3",
    name: "crvUSD / ysUSDS",
    irm: "0x870aC11D48B15DB9a138Cf899d20F13F79Ba00BC",
    lltv: "965000000000000000",
    oracle: "0x6a4bDF040FE684284afa53E501f65c8E33839652",
    loanToken: {
      address: "0xf939E0A03FB07F59A73314E73794Be0E57ac1b4E",
      symbol: "crvUSD",
    },
    collateralToken: {
      address: "0x4cE9c93513DfF543Bc392870d57dF8C04e89Ba0a",
      symbol: "ysUSDS",
    },
  },
  {
    id: "0xc3a8c2088e2474829088ed5496cc832fc0ecf582df34a14e353b607034d0376d",
    name: "AUSD / PT-cUSD-29JAN2026",
    irm: "0x870aC11D48B15DB9a138Cf899d20F13F79Ba00BC",
    lltv: "915000000000000000",
    oracle: "0x29CE518f4449f1dEe2EAA6d32621987Dcc18e29d",
    loanToken: {
      address: "0x00000000eFE302BEAA2b3e6e1b18d08D69a9012a",
      symbol: "AUSD",
    },
    collateralToken: {
      address: "0x545A490f9ab534AdF409A2E682bc4098f49952e3",
      symbol: "PT-cUSD-29JAN2026",
    },
  },
  {
    id: "0xc26fb49a683ba55846974fe8283d63ab40dff0788c5ef4e79990426f080b60ec",
    name: "USDS / Neiro",
    irm: "0x870aC11D48B15DB9a138Cf899d20F13F79Ba00BC",
    lltv: "770000000000000000",
    oracle: "0x7E9d2573D3D4cb731ee158fda170B24A30d718ff",
    loanToken: {
      address: "0xdC035D45d973E3EC169d2276DDab16f1e407384F",
      symbol: "USDS",
    },
    collateralToken: {
      address: "0x812Ba41e071C7b7fA4EBcFB62dF5F45f6fA853Ee",
      symbol: "Neiro",
    },
  },
  {
    id: "0xc1f8ab27abbe4defca7ba1cbc02f695df1f637760b490ff1466887dc3af6f398",
    name: "USD0 / USR",
    irm: "0x870aC11D48B15DB9a138Cf899d20F13F79Ba00BC",
    lltv: "915000000000000000",
    oracle: "0xCA63193640352d06eeA34dc08B8e87aD5013C1cc",
    loanToken: {
      address: "0x73A15FeD60Bf67631dC6cd7Bc5B6e8da8190aCF5",
      symbol: "USD0",
    },
    collateralToken: {
      address: "0x66a1E37c9b0eAddca17d3662D6c05F4DECf3e110",
      symbol: "USR",
    },
  },
  {
    id: "0xc1e71c12787b2ca5a244c679512b967f2e10f5ceeaed85080aac606fd20b8541",
    name: "USDC / mHYPER",
    irm: "0x870aC11D48B15DB9a138Cf899d20F13F79Ba00BC",
    lltv: "860000000000000000",
    oracle: "0xfA0Db44Ccb2f8D5077e9C87dD501a106D72cAE1F",
    loanToken: {
      address: "0xA0b86991c6218b36c1d19D4a2e9Eb0cE3606eB48",
      symbol: "USDC",
    },
    collateralToken: {
      address: "0x9b5528528656DBC094765E2abB79F293c21191B9",
      symbol: "mHYPER",
    },
  },
  {
    id: "0xc184c2aafb37a571454213746023b2f9fc16d37ce017729a96f19feea60677d1",
    name: "USDe / srUSDe",
    irm: "0x870aC11D48B15DB9a138Cf899d20F13F79Ba00BC",
    lltv: "915000000000000000",
    oracle: "0x4479FF2357637052a1Ed5010Fdd665D1b8b68453",
    loanToken: {
      address: "0x4c9EDD5852cd905f086C759E8383e09bff1E68B3",
      symbol: "USDe",
    },
    collateralToken: {
      address: "0x3d7d6fdf07EE548B939A80edbc9B2256d0cdc003",
      symbol: "srUSDe",
    },
  },
  {
    id: "0xc124e76fe8373c4ab7be3b53342b701cdc9b05b432ea5bba792696097df4211c",
    name: "WETH / sUSDS",
    irm: "0x870aC11D48B15DB9a138Cf899d20F13F79Ba00BC",
    lltv: "860000000000000000",
    oracle: "0x0C426d174FC88B7A25d59945Ab2F7274Bf7B4C79",
    loanToken: {
      address: "0xC02aaA39b223FE8D0A0e5C4F27eAD9083C756Cc2",
      symbol: "WETH",
    },
    collateralToken: {
      address: "0xa3931d71877C0E7a3148CB7Eb4463524FEc27fbD",
      symbol: "sUSDS",
    },
  },
  {
    id: "0xc12387d79d5d7ba35c5d2ed60b71dc4d6341889a30afea50a790c4e8967c209c",
    name: "USDU / USDUUSDC",
    irm: "0x870aC11D48B15DB9a138Cf899d20F13F79Ba00BC",
    lltv: "915000000000000000",
    oracle: "0x3544BdF11EE46261e4a7823D9100B4F66B0450B4",
    loanToken: {
      address: "0xdde3eC717f220Fc6A29D6a4Be73F91DA5b718e55",
      symbol: "USDU",
    },
    collateralToken: {
      address: "0x771c91e699B4B23420de3F81dE2aA38C4041632b",
      symbol: "USDUUSDC",
    },
  },
  {
    id: "0xc0dd730c7fd67dc5d7c595ec893f0eca852f7ebfd8259cc71ed82958452f8938",
    name: "USDC / FBTC",
    irm: "0x870aC11D48B15DB9a138Cf899d20F13F79Ba00BC",
    lltv: "860000000000000000",
    oracle: "0xDddd770BADd886dF3864029e4B377B5F6a2B6b83",
    loanToken: {
      address: "0xA0b86991c6218b36c1d19D4a2e9Eb0cE3606eB48",
      symbol: "USDC",
    },
    collateralToken: {
      address: "0xC96dE26018A54D51c097160568752c4E3BD6C364",
      symbol: "FBTC",
    },
  },
  {
    id: "0xc0ae375fd761ff19b3f04de5534c0f1ec110f80e1c2ede27c42c1c43c3040394",
    name: "RLUSD / syrupUSDC",
    irm: "0x870aC11D48B15DB9a138Cf899d20F13F79Ba00BC",
    lltv: "915000000000000000",
    oracle: "0xf766F4F1Bcb0CBBF4EEF5E26FF7c7f66a713c1B5",
    loanToken: {
      address: "0x8292Bb45bf1Ee4d140127049757C2E0fF06317eD",
      symbol: "RLUSD",
    },
    collateralToken: {
      address: "0x80ac24aA929eaF5013f6436cdA2a7ba190f5Cc0b",
      symbol: "syrupUSDC",
    },
  },
  {
    id: "0xc032473959060d2c7bea5488718b6f3f15300873bb9668d9c9d0e4d2d4aca296",
    name: "USDtb / sUSDS",
    irm: "0x870aC11D48B15DB9a138Cf899d20F13F79Ba00BC",
    lltv: "915000000000000000",
    oracle: "0x15b68dd823bB37150c3BaAfF841C6dFff4bbb6AE",
    loanToken: {
      address: "0xC139190F447e929f090Edeb554D95AbB8b18aC1C",
      symbol: "USDtb",
    },
    collateralToken: {
      address: "0xa3931d71877C0E7a3148CB7Eb4463524FEc27fbD",
      symbol: "sUSDS",
    },
  },
  {
    id: "0xc0257b98c04fe09d162ded37d5966fd59c9f0e25ecff4a146483b61cd01d2979",
    name: "USDS / PT-USDe-27NOV2025",
    irm: "0x870aC11D48B15DB9a138Cf899d20F13F79Ba00BC",
    lltv: "915000000000000000",
    oracle: "0x20Cea639A895c3c85dce326dc6A736508C310B4b",
    loanToken: {
      address: "0xdC035D45d973E3EC169d2276DDab16f1e407384F",
      symbol: "USDS",
    },
    collateralToken: {
      address: "0x62C6E813b9589C3631Ba0Cdb013acdB8544038B7",
      symbol: "PT-USDe-27NOV2025",
    },
  },
  {
    id: "0xc00af0f3f14c54d0a4fc0020b2e86a54fb8be8ab2f6bc6f9fdb7fc3569e1933a",
    name: "tGBP / cbBTC",
    irm: "0x870aC11D48B15DB9a138Cf899d20F13F79Ba00BC",
    lltv: "860000000000000000",
    oracle: "0xF7A0e51cebD98a31947CaE1DDa8C0717D10ADd61",
    loanToken: {
      address: "0x27f6c8289550fCE67f6B50BeD1F519966aFE5287",
      symbol: "tGBP",
    },
    collateralToken: {
      address: "0xcbB7C0000aB88B473b1f5aFd9ef808440eed33Bf",
      symbol: "cbBTC",
    },
  },
  {
    id: "0xbff58e615f1d20a517128537db7c4eed833d23bf0b6b014f1c451e7d7bd28b88",
    name: "USD0 / PT-sUSDE-27MAR2025",
    irm: "0x870aC11D48B15DB9a138Cf899d20F13F79Ba00BC",
    lltv: "915000000000000000",
    oracle: "0x185Ac12f836f446026374e2DcfAC6B017560bE49",
    loanToken: {
      address: "0x73A15FeD60Bf67631dC6cd7Bc5B6e8da8190aCF5",
      symbol: "USD0",
    },
    collateralToken: {
      address: "0xE00bd3Df25fb187d6ABBB620b3dfd19839947b81",
      symbol: "PT-sUSDE-27MAR2025",
    },
  },
  {
    id: "0xbfe12269a41fd7231af57357882a1043cc5181ae1ef390ba6086777858c278c1",
    name: "WBTC / PT-corn-SolvBTC.BBN-26DEC2024",
    irm: "0x870aC11D48B15DB9a138Cf899d20F13F79Ba00BC",
    lltv: "860000000000000000",
    oracle: "0x94C2DfA8917F1657a55D1d604fd31C930A10Bca3",
    loanToken: {
      address: "0x2260FAC5E5542a773Aa44fBCfeDf7C193bc2C599",
      symbol: "WBTC",
    },
    collateralToken: {
      address: "0x23e479ddcda990E8523494895759bD98cD2fDBF6",
      symbol: "PT-corn-SolvBTC.BBN-26DEC2024",
    },
  },
  {
    id: "0xbf2526a242545bbf0f3d42ffb879fa1eb562ed74704bce0a319b975818dd525a",
    name: "USDtb / PT-sUSDE-25SEP2025",
    irm: "0x870aC11D48B15DB9a138Cf899d20F13F79Ba00BC",
    lltv: "915000000000000000",
    oracle: "0xc28690681238CA9a35EacF7daBbe9d07B4722e9D",
    loanToken: {
      address: "0xC139190F447e929f090Edeb554D95AbB8b18aC1C",
      symbol: "USDtb",
    },
    collateralToken: {
      address: "0x9F56094C450763769BA0EA9Fe2876070c0fD5F77",
      symbol: "PT-sUSDE-25SEP2025",
    },
  },
  {
    id: "0xbf0432567b44ef5ce013ffcd7dd756c522252503f7986a406e780715b32c74fc",
    name: "AUSD / wSPYx",
    irm: "0x870aC11D48B15DB9a138Cf899d20F13F79Ba00BC",
    lltv: "860000000000000000",
    oracle: "0x01Fd716a703eD6A54922b1F2C8cc2Ed5a018bAC5",
    loanToken: {
      address: "0x00000000eFE302BEAA2b3e6e1b18d08D69a9012a",
      symbol: "AUSD",
    },
    collateralToken: {
      address: "0xc88FcD8B874fDb3256E8B55b3decB8c24EAb4c02",
      symbol: "wSPYx",
    },
  },
  {
    id: "0xbec3a93801b559a8652552886481922e5676246b4e328788b2b53e13c21fd1c4",
    name: "apxUSD / ROY-ST-apyUSD",
    irm: "0x870aC11D48B15DB9a138Cf899d20F13F79Ba00BC",
    lltv: "915000000000000000",
    oracle: "0x6c0824B17eF83459fd3959eb76a16aBD0F59DF35",
    loanToken: {
      address: "0x98A878b1Cd98131B271883B390f68D2c90674665",
      symbol: "apxUSD",
    },
    collateralToken: {
      address: "0xBd373c9D3D8976a4FECC504a93c768BBE8C3227C",
      symbol: "ROY-ST-apyUSD",
    },
  },
  {
    id: "0xbea2e02b7a53869ea2fe41f604f6b530bcd9e3bda791a45d92d765b47d2f77f0",
    name: "USDC / wUTXO",
    irm: "0x870aC11D48B15DB9a138Cf899d20F13F79Ba00BC",
    lltv: "860000000000000000",
    oracle: "0x3D12252A45fCF76DacF8b8b0Ed8ce8Bb901f2292",
    loanToken: {
      address: "0xA0b86991c6218b36c1d19D4a2e9Eb0cE3606eB48",
      symbol: "USDC",
    },
    collateralToken: {
      address: "0xd76B994b6E6350bc298c836cBb58b117496e49E3",
      symbol: "wUTXO",
    },
  },
  {
    id: "0xbe29c9313655657b82c2e4e1e0eddb2fb581faf74a98eb6d3b7592ab78b26e86",
    name: "USDC / USDC",
    irm: "0x870aC11D48B15DB9a138Cf899d20F13F79Ba00BC",
    lltv: "860000000000000000",
    oracle: "0x504188EfF00DB6137010dE02C26b3f72c25eE1f1",
    loanToken: {
      address: "0xA0b86991c6218b36c1d19D4a2e9Eb0cE3606eB48",
      symbol: "USDC",
    },
    collateralToken: {
      address: "0xA0b86991c6218b36c1d19D4a2e9Eb0cE3606eB48",
      symbol: "USDC",
    },
  },
  {
    id: "0xbd5cff99f6a6988399f1f95835186a46e4642c615bf6364c33027504514791f8",
    name: "USDS / SHIB",
    irm: "0x870aC11D48B15DB9a138Cf899d20F13F79Ba00BC",
    lltv: "625000000000000000",
    oracle: "0xe99e31a10502aC2348f529A10Ed602D850ed05B7",
    loanToken: {
      address: "0xdC035D45d973E3EC169d2276DDab16f1e407384F",
      symbol: "USDS",
    },
    collateralToken: {
      address: "0x95aD61b0a150d79219dCF64E1E6Cc01f0B64C4cE",
      symbol: "SHIB",
    },
  },
  {
    id: "0xbd42fedebbc755f733e32b2e12ca73864a6cb5d695e391fec51b5391be00e975",
    name: "USDC / LBTC",
    irm: "0x870aC11D48B15DB9a138Cf899d20F13F79Ba00BC",
    lltv: "860000000000000000",
    oracle: "0xDddd770BADd886dF3864029e4B377B5F6a2B6b83",
    loanToken: {
      address: "0xA0b86991c6218b36c1d19D4a2e9Eb0cE3606eB48",
      symbol: "USDC",
    },
    collateralToken: {
      address: "0x8236a87084f8B84306f72007F36F2618A5634494",
      symbol: "LBTC",
    },
  },
  {
    id: "0xbd2a27358bdaf3fb902a0ad17f86d4633f9ac5377941298720b37a4d90deab96",
    name: "crvUSD / ",
    irm: "0x870aC11D48B15DB9a138Cf899d20F13F79Ba00BC",
    lltv: "860000000000000000",
    oracle: "0xad7e157815df05029125B568E39d5402550d60bb",
    loanToken: {
      address: "0xf939E0A03FB07F59A73314E73794Be0E57ac1b4E",
      symbol: "crvUSD",
    },
    collateralToken: {
      address: "0xAc904BAfBb5FB04Deb2b6198FdCEedE75a78Ce5a",
      symbol: "",
    },
  },
  {
    id: "0xbd21598fa11eb462887f6e13a99f9b6c6396866d863cc748373bc4bf7dbdffbe",
    name: "CRNC / USDC",
    irm: "0x870aC11D48B15DB9a138Cf899d20F13F79Ba00BC",
    lltv: "385000000000000000",
    oracle: "0xC346ee27a56a9E95481D460cdc0aD49E752E3881",
    loanToken: {
      address: "0x47d13Fb0803409c7fE169A210d4e906165F1A432",
      symbol: "CRNC",
    },
    collateralToken: {
      address: "0xA0b86991c6218b36c1d19D4a2e9Eb0cE3606eB48",
      symbol: "USDC",
    },
  },
  {
    id: "0xbc92aa5a8bbd3eeeb692ff6b42a20c18e065681175d31fc15e98d6e079c2e15f",
    name: "USDf / sUSDf",
    irm: "0x870aC11D48B15DB9a138Cf899d20F13F79Ba00BC",
    lltv: "945000000000000000",
    oracle: "0x0000000000000000000000000000000000000000",
    loanToken: {
      address: "0xFa2B947eEc368f42195f24F36d2aF29f7c24CeC2",
      symbol: "USDf",
    },
    collateralToken: {
      address: "0xc8CF6D7991f15525488b2A83Df53468D682Ba4B0",
      symbol: "sUSDf",
    },
  },
  {
    id: "0xbc81f138bfa9b05089a4e3d88ac6bc1367407b44680c22b83b95cdd98d3eed7c",
    name: "USDC / cUSDO",
    irm: "0x870aC11D48B15DB9a138Cf899d20F13F79Ba00BC",
    lltv: "915000000000000000",
    oracle: "0xb208bFDf2A129386d7f1617D8498a69d2553f949",
    loanToken: {
      address: "0xA0b86991c6218b36c1d19D4a2e9Eb0cE3606eB48",
      symbol: "USDC",
    },
    collateralToken: {
      address: "0xaD55aebc9b8c03FC43cd9f62260391c13c23e7c0",
      symbol: "cUSDO",
    },
  },
  {
    id: "0xba8c21d3e47814574a61bee82e7053274f731ad253b24865acab8476fa477ee7",
    name: "AUSD / PT-srUSDe-2APR2026",
    irm: "0x870aC11D48B15DB9a138Cf899d20F13F79Ba00BC",
    lltv: "915000000000000000",
    oracle: "0x8CFb9C525639D7ff649DCa96795acCAd60Ae8B35",
    loanToken: {
      address: "0x00000000eFE302BEAA2b3e6e1b18d08D69a9012a",
      symbol: "AUSD",
    },
    collateralToken: {
      address: "0x9Bf45ab47747F4B4dD09B3C2c73953484b4eB375",
      symbol: "PT-srUSDe-2APR2026",
    },
  },
  {
    id: "0xba1e4ffd3b7d5fb5a605c0467c7a0c61c474f06ae2907b570a6d553bab08e564",
    name: "AUSD / hgETH",
    irm: "0x870aC11D48B15DB9a138Cf899d20F13F79Ba00BC",
    lltv: "860000000000000000",
    oracle: "0x9E5748365D17E49f5a421237884791C27DBa0448",
    loanToken: {
      address: "0x00000000eFE302BEAA2b3e6e1b18d08D69a9012a",
      symbol: "AUSD",
    },
    collateralToken: {
      address: "0xc824A08dB624942c5E5F330d56530cD1598859fD",
      symbol: "hgETH",
    },
  },
  {
    id: "0xb9fc64c41ae47e9776716d2e7383e79cb3747c7eb53b42ca613af054e602bd79",
    name: "AUSD / cbBTC",
    irm: "0x870aC11D48B15DB9a138Cf899d20F13F79Ba00BC",
    lltv: "860000000000000000",
    oracle: "0xc85A73FCe1345516233f7685EDADa655e2442b30",
    loanToken: {
      address: "0x00000000eFE302BEAA2b3e6e1b18d08D69a9012a",
      symbol: "AUSD",
    },
    collateralToken: {
      address: "0xcbB7C0000aB88B473b1f5aFd9ef808440eed33Bf",
      symbol: "cbBTC",
    },
  },
  {
    id: "0xb8ec89ee1370e74df246d09bed040e11a00f658daab5f993ffd739040a1553be",
    name: "MUSD / tBTC",
    irm: "0x870aC11D48B15DB9a138Cf899d20F13F79Ba00BC",
    lltv: "860000000000000000",
    oracle: "0x20F148275aE02ebBF6A7799C3daf7802c67a2B97",
    loanToken: {
      address: "0xdD468A1DDc392dcdbEf6db6e34E89AA338F9F186",
      symbol: "MUSD",
    },
    collateralToken: {
      address: "0x18084fbA666a33d37592fA2633fD49a74DD93a88",
      symbol: "tBTC",
    },
  },
  {
    id: "0xb8c79760db7ddfd2e612d0e7066d6ac1ac411d8f6f1cf0db987849a2e19cf13b",
    name: "GRAM / INCE",
    irm: "0x870aC11D48B15DB9a138Cf899d20F13F79Ba00BC",
    lltv: "625000000000000000",
    oracle: "0x3b099260529497D876D88EBD50B23cb3fA241BBc",
    loanToken: {
      address: "0x845f64673a2407320C2cC12e23b669DC16F7A473",
      symbol: "GRAM",
    },
    collateralToken: {
      address: "0x519e8e5D13D5a109bDde53EB6b5d03E50ce70a0c",
      symbol: "INCE",
    },
  },
  {
    id: "0xb7d1981ca0657c42bf003aca966f6a873ade2ae55d472d019a4ea03bc74f29f0",
    name: "frxUSD / stakedao-frxUSDOUSD",
    irm: "0x870aC11D48B15DB9a138Cf899d20F13F79Ba00BC",
    lltv: "945000000000000000",
    oracle: "0xF0fC06217C5a728776AAc76F4bc5cf3112730960",
    loanToken: {
      address: "0xCAcd6fd266aF91b8AeD52aCCc382b4e165586E29",
      symbol: "frxUSD",
    },
    collateralToken: {
      address: "0x95B2b136eb0Bf075072D0c759e475453711A33f5",
      symbol: "stakedao-frxUSDOUSD",
    },
  },
  {
    id: "0xb789fb4a502bf40ad6a3c7bbdf656d127a917584d6bbf15da2fd4dad2bee1491",
    name: "AUSD / cbBTC",
    irm: "0x870aC11D48B15DB9a138Cf899d20F13F79Ba00BC",
    lltv: "860000000000000000",
    oracle: "0xFBe21C1c525257df005Cb9eC77DE55EF041e7E55",
    loanToken: {
      address: "0x00000000eFE302BEAA2b3e6e1b18d08D69a9012a",
      symbol: "AUSD",
    },
    collateralToken: {
      address: "0xcbB7C0000aB88B473b1f5aFd9ef808440eed33Bf",
      symbol: "cbBTC",
    },
  },
  {
    id: "0xb7681f7574630f038cea55e3c3bb53a0a6be12683bd94cb4555fdc1f55529dea",
    name: "USDC / wstETH",
    irm: "0x870aC11D48B15DB9a138Cf899d20F13F79Ba00BC",
    lltv: "860000000000000000",
    oracle: "0xDddd770BADd886dF3864029e4B377B5F6a2B6b83",
    loanToken: {
      address: "0xA0b86991c6218b36c1d19D4a2e9Eb0cE3606eB48",
      symbol: "USDC",
    },
    collateralToken: {
      address: "0x7f39C581F595B53c5cb19bD0b3f8dA6c935E2Ca0",
      symbol: "wstETH",
    },
  },
  {
    id: "0xb750e8136060fc5833ecf3f237f99c63f3ba237b7b90559ac6fa3033a6b432e6",
    name: "cbBTC / tacBTC",
    irm: "0x870aC11D48B15DB9a138Cf899d20F13F79Ba00BC",
    lltv: "915000000000000000",
    oracle: "0x9548e929637Fb8eeD4f0D6247d886dA11f930a33",
    loanToken: {
      address: "0xcbB7C0000aB88B473b1f5aFd9ef808440eed33Bf",
      symbol: "cbBTC",
    },
    collateralToken: {
      address: "0x6Bf340dB729d82af1F6443A0Ea0d79647b1c3DDf",
      symbol: "tacBTC",
    },
  },
  {
    id: "0xb70734511ce7332caaa5b880c61d3407f4e64f76a2a91b782eae6038ac66c89f",
    name: "EURCV / WBTC",
    irm: "0x870aC11D48B15DB9a138Cf899d20F13F79Ba00BC",
    lltv: "860000000000000000",
    oracle: "0xA05d27f807f50B4b2Cd12368974f2dD0eF33f4F4",
    loanToken: {
      address: "0x5F7827FDeb7c20b443265Fc2F40845B715385Ff2",
      symbol: "EURCV",
    },
    collateralToken: {
      address: "0x2260FAC5E5542a773Aa44fBCfeDf7C193bc2C599",
      symbol: "WBTC",
    },
  },
  {
    id: "0xb6c1599ac357c1b23fcd46f4ef69495fb11d91bc0fa90c7c3e6ab644592c8017",
    name: "USDA / PT-weETH-26DEC2024",
    irm: "0x870aC11D48B15DB9a138Cf899d20F13F79Ba00BC",
    lltv: "860000000000000000",
    oracle: "0x1620AcF8cF042C23CEeA0c6356E14e54D37CE8FF",
    loanToken: {
      address: "0x0000206329b97DB379d5E1Bf586BbDB969C63274",
      symbol: "USDA",
    },
    collateralToken: {
      address: "0x6ee2b5E19ECBa773a352E5B21415Dc419A700d1d",
      symbol: "PT-weETH-26DEC2024",
    },
  },
  {
    id: "0xb5f8d5554d85b782d7080314bba3544983755a75eb5c432f5eae1c47c6af4da4",
    name: "EURCV / cbBTC",
    irm: "0x870aC11D48B15DB9a138Cf899d20F13F79Ba00BC",
    lltv: "860000000000000000",
    oracle: "0xD08d519D6e91575C4e7AE1e49bd54da369521c0e",
    loanToken: {
      address: "0x5F7827FDeb7c20b443265Fc2F40845B715385Ff2",
      symbol: "EURCV",
    },
    collateralToken: {
      address: "0xcbB7C0000aB88B473b1f5aFd9ef808440eed33Bf",
      symbol: "cbBTC",
    },
  },
  {
    id: "0xb5e223dd87e4baea98cbf15412b6c6b93504a9affb095f0c136519abe2df184e",
    name: "USDC / PT-RLP-4DEC2025",
    irm: "0x870aC11D48B15DB9a138Cf899d20F13F79Ba00BC",
    lltv: "860000000000000000",
    oracle: "0xBdA406918637E038E6cCe90c0f075e116A850dfA",
    loanToken: {
      address: "0xA0b86991c6218b36c1d19D4a2e9Eb0cE3606eB48",
      symbol: "USDC",
    },
    collateralToken: {
      address: "0x3A70F0C696dcB3A4aB3833cD9726397dD61AC85e",
      symbol: "PT-RLP-4DEC2025",
    },
  },
  {
    id: "0xb53d0a79befd4cd1d69ed8aa8d55aa8a39f308afce71a905e89a7da678e72a71",
    name: "USDC / BGBTC",
    irm: "0x870aC11D48B15DB9a138Cf899d20F13F79Ba00BC",
    lltv: "860000000000000000",
    oracle: "0xb7F3B2Cc8a1D8a7a8c59BAB0AeB6D67fb334561f",
    loanToken: {
      address: "0xA0b86991c6218b36c1d19D4a2e9Eb0cE3606eB48",
      symbol: "USDC",
    },
    collateralToken: {
      address: "0x0520930F21b14Cafac7a27b102487beE7138a017",
      symbol: "BGBTC",
    },
  },
  {
    id: "0xb4fdb43faaaa3b0524fa324d1889b7bfacdce2ed032730f2cc666390990951a5",
    name: "USDtb / PT-USDe-5FEB2026",
    irm: "0x870aC11D48B15DB9a138Cf899d20F13F79Ba00BC",
    lltv: "915000000000000000",
    oracle: "0xBDe1222E141563B8797718460E2C2f0902e5CDd0",
    loanToken: {
      address: "0xC139190F447e929f090Edeb554D95AbB8b18aC1C",
      symbol: "USDtb",
    },
    collateralToken: {
      address: "0x1F84a51296691320478c98b8d77f2Bbd17D34350",
      symbol: "PT-USDe-5FEB2026",
    },
  },
  {
    id: "0xb3e89d2d30bc597e0f53111e351c847ab5345d737dcae18a22196040324fe076",
    name: "USDC / cbBTC",
    irm: "0x870aC11D48B15DB9a138Cf899d20F13F79Ba00BC",
    lltv: "860000000000000000",
    oracle: "0x1304530C1073BB9D1FFBA2650D5807DF098E0134",
    loanToken: {
      address: "0xA0b86991c6218b36c1d19D4a2e9Eb0cE3606eB48",
      symbol: "USDC",
    },
    collateralToken: {
      address: "0xcbB7C0000aB88B473b1f5aFd9ef808440eed33Bf",
      symbol: "cbBTC",
    },
  },
  {
    id: "0xb3325fd674f0a63a4cc4559d51a4cd2bff557d3b1695b414bf825fcda0b3d903",
    name: "scrvUSD / yvCurve-yYB-f",
    irm: "0x870aC11D48B15DB9a138Cf899d20F13F79Ba00BC",
    lltv: "770000000000000000",
    oracle: "0x97641E7F4D2024D802f928bBb2C348aDf9b6CA87",
    loanToken: {
      address: "0x0655977FEb2f289A4aB78af67BAB0d17aAb84367",
      symbol: "scrvUSD",
    },
    collateralToken: {
      address: "0x0844C227b892be5d7c837000C096f64bFc316c2d",
      symbol: "yvCurve-yYB-f",
    },
  },
  {
    id: "0xb1115c39bd889bbf0295e1482a50a3c3582bd08668fd73bedcbc26c3cb939225",
    name: "USDS / CULT",
    irm: "0x870aC11D48B15DB9a138Cf899d20F13F79Ba00BC",
    lltv: "625000000000000000",
    oracle: "0x851D005673a4BfD00B59eDe31424cD8BeB679CeF",
    loanToken: {
      address: "0xdC035D45d973E3EC169d2276DDab16f1e407384F",
      symbol: "USDS",
    },
    collateralToken: {
      address: "0x0000000000c5dc95539589fbD24BE07c6C14eCa4",
      symbol: "CULT",
    },
  },
  {
    id: "0xb0a087ed8ca669c1e7e1b06f6dc11347e85b5e452618ed4309064baed411dd27",
    name: "GRAM / BELA",
    irm: "0x870aC11D48B15DB9a138Cf899d20F13F79Ba00BC",
    lltv: "625000000000000000",
    oracle: "0x1A32b9bE7a979dbD1Cc259Fa370D997cdAAB54bA",
    loanToken: {
      address: "0x845f64673a2407320C2cC12e23b669DC16F7A473",
      symbol: "GRAM",
    },
    collateralToken: {
      address: "0x11e089AA00FBcF9fd8EEf6F91e5385cFf6eDf054",
      symbol: "BELA",
    },
  },
  {
    id: "0xb093ebb56fa0357308d11fda5ccb8c88810c7853b6f389984b62245ef4d2ec57",
    name: "cbBTC / tBTC",
    irm: "0x870aC11D48B15DB9a138Cf899d20F13F79Ba00BC",
    lltv: "945000000000000000",
    oracle: "0x7e0B410d21AcCbB2B48d9793Fe6d563F3F762b4D",
    loanToken: {
      address: "0xcbB7C0000aB88B473b1f5aFd9ef808440eed33Bf",
      symbol: "cbBTC",
    },
    collateralToken: {
      address: "0x18084fbA666a33d37592fA2633fD49a74DD93a88",
      symbol: "tBTC",
    },
  },
  {
    id: "0xafad4cf0a0f30584fa78c679daa8684adf9bd182824070fbfc7d2e347a62fd29",
    name: "USDC / VBILL",
    irm: "0x870aC11D48B15DB9a138Cf899d20F13F79Ba00BC",
    lltv: "860000000000000000",
    oracle: "0xDddd770BADd886dF3864029e4B377B5F6a2B6b83",
    loanToken: {
      address: "0xA0b86991c6218b36c1d19D4a2e9Eb0cE3606eB48",
      symbol: "USDC",
    },
    collateralToken: {
      address: "0x2255718832bC9fD3bE1CaF75084F4803DA14FF01",
      symbol: "VBILL",
    },
  },
  {
    id: "0xaf98d9659a4938c504e77c8faf07a5eaa593f852f4b6914d02ddb2fcfe344e6a",
    name: "AUSD / cbBTC",
    irm: "0x870aC11D48B15DB9a138Cf899d20F13F79Ba00BC",
    lltv: "860000000000000000",
    oracle: "0x0E053750DFA4E809E5f7b119832C799c2aA138ac",
    loanToken: {
      address: "0x00000000eFE302BEAA2b3e6e1b18d08D69a9012a",
      symbol: "AUSD",
    },
    collateralToken: {
      address: "0xcbB7C0000aB88B473b1f5aFd9ef808440eed33Bf",
      symbol: "cbBTC",
    },
  },
  {
    id: "0xaf3461ee177e8774148b0607b8644a2d5ea2abe3d17ff08c6d68cd7a8b983e59",
    name: "crvUSD / ",
    irm: "0x870aC11D48B15DB9a138Cf899d20F13F79Ba00BC",
    lltv: "860000000000000000",
    oracle: "0xd8F97E77BCc8C34B0695F1dCBA1D3b01CcA88FE7",
    loanToken: {
      address: "0xf939E0A03FB07F59A73314E73794Be0E57ac1b4E",
      symbol: "crvUSD",
    },
    collateralToken: {
      address: "0xa461249dB0C9f91de3d43582468b9DC0E712664d",
      symbol: "",
    },
  },
  {
    id: "0xaefaa497a88e643756ab78b3748731ec1b6f19e7c5862952a6372bf9a16acce9",
    name: "PT-mAPOLLO-29JAN2026 / USDC",
    irm: "0x870aC11D48B15DB9a138Cf899d20F13F79Ba00BC",
    lltv: "860000000000000000",
    oracle: "0xe8a557002f377Efc48EeD61bdBB8BEb875D79e02",
    loanToken: {
      address: "0x955E979D243907917fda6A3a811Fb55c555b7DBA",
      symbol: "PT-mAPOLLO-29JAN2026",
    },
    collateralToken: {
      address: "0xA0b86991c6218b36c1d19D4a2e9Eb0cE3606eB48",
      symbol: "USDC",
    },
  },
  {
    id: "0xaef5792807116a62025a296f9f5f0078267560900cfe70c5dcba034928d00b83",
    name: "EURCV / WBTC",
    irm: "0x870aC11D48B15DB9a138Cf899d20F13F79Ba00BC",
    lltv: "860000000000000000",
    oracle: "0x5b793e439A923389C6ad165D8b50581E8AFc78fe",
    loanToken: {
      address: "0x5F7827FDeb7c20b443265Fc2F40845B715385Ff2",
      symbol: "EURCV",
    },
    collateralToken: {
      address: "0x2260FAC5E5542a773Aa44fBCfeDf7C193bc2C599",
      symbol: "WBTC",
    },
  },
  {
    id: "0xae1c1750e2324098820355939d6da6ab046bc33ccbf1aaf192f6c96dba18b5d1",
    name: "lvlUSD / PT-slvlUSD-25SEP2025",
    irm: "0x870aC11D48B15DB9a138Cf899d20F13F79Ba00BC",
    lltv: "915000000000000000",
    oracle: "0x3A7bB36Ee3f3eE32A60e9f2b33c1e5f2E83ad766",
    loanToken: {
      address: "0x7C1156E515aA1A2E851674120074968C905aAF37",
      symbol: "lvlUSD",
    },
    collateralToken: {
      address: "0x2CA5f2C4300450D53214B00546795c1c07B89acB",
      symbol: "PT-slvlUSD-25SEP2025",
    },
  },
  {
    id: "0xad0e588483d2220247ecbc6bf83bf86c2ea0b8dde847b232b07c8f0a78021076",
    name: "USD0 / mMEV",
    irm: "0x870aC11D48B15DB9a138Cf899d20F13F79Ba00BC",
    lltv: "915000000000000000",
    oracle: "0xfE8fcA606085f4a20d2edEeAd5B91f2cA083a70C",
    loanToken: {
      address: "0x73A15FeD60Bf67631dC6cd7Bc5B6e8da8190aCF5",
      symbol: "USD0",
    },
    collateralToken: {
      address: "0x030b69280892c888670EDCDCD8B69Fd8026A0BF3",
      symbol: "mMEV",
    },
  },
  {
    id: "0xacdc4ae3e7853e0195819a8c4fb1151b1bff4b364cd40ffcbb469d8efdefe0f6",
    name: "USDC / CHIM",
    irm: "0x870aC11D48B15DB9a138Cf899d20F13F79Ba00BC",
    lltv: "915000000000000000",
    oracle: "0x55CD221DA9Ec7f68eF91D23Ba18F07f9a11a2aEf",
    loanToken: {
      address: "0xA0b86991c6218b36c1d19D4a2e9Eb0cE3606eB48",
      symbol: "USDC",
    },
    collateralToken: {
      address: "0x1ad108c9e16D807ae4E5Bc7ED24457559Cb9B76A",
      symbol: "CHIM",
    },
  },
  {
    id: "0xabb6eb30c6abf4c87a87392129cc9b82cdf140cc643406a87397c2a28901af5d",
    name: "AUSD / USCC",
    irm: "0x870aC11D48B15DB9a138Cf899d20F13F79Ba00BC",
    lltv: "915000000000000000",
    oracle: "0x68066D2891254F1F3285Cac0bB16B65B28EE3cAb",
    loanToken: {
      address: "0x00000000eFE302BEAA2b3e6e1b18d08D69a9012a",
      symbol: "AUSD",
    },
    collateralToken: {
      address: "0x14d60E7FDC0D71d8611742720E4C50E7a974020c",
      symbol: "USCC",
    },
  },
  {
    id: "0xab3196447663a41382ba4b4d55eab3fa702ee2cf071db224fd72492953040056",
    name: "AUSD / syrupUSDC",
    irm: "0x870aC11D48B15DB9a138Cf899d20F13F79Ba00BC",
    lltv: "915000000000000000",
    oracle: "0xEa876EF062E90a6478e726800A83f44D4EAe09Bc",
    loanToken: {
      address: "0x00000000eFE302BEAA2b3e6e1b18d08D69a9012a",
      symbol: "AUSD",
    },
    collateralToken: {
      address: "0x80ac24aA929eaF5013f6436cdA2a7ba190f5Cc0b",
      symbol: "syrupUSDC",
    },
  },
  {
    id: "0xab0489f992caf7af2c27be87fc3f22ff90e7c8fe68bceabdff611b8c7f3e542d",
    name: "msETH / weETH",
    irm: "0x870aC11D48B15DB9a138Cf899d20F13F79Ba00BC",
    lltv: "915000000000000000",
    oracle: "0xbD60A6770b27E084E8617335ddE769241B0e71D8",
    loanToken: {
      address: "0x64351fC9810aDAd17A690E4e1717Df5e7e085160",
      symbol: "msETH",
    },
    collateralToken: {
      address: "0xCd5fE23C85820F7B72D0926FC9b05b43E359b7ee",
      symbol: "weETH",
    },
  },
  {
    id: "0xaa7231d6bee28b578efe38b52e801d5d3067023853342fc06ded437d2a80ef98",
    name: "EURCV / EUTBL",
    irm: "0x870aC11D48B15DB9a138Cf899d20F13F79Ba00BC",
    lltv: "965000000000000000",
    oracle: "0xf071b0a62ef2a54c1Dca791134421EE16c2C43d9",
    loanToken: {
      address: "0x5F7827FDeb7c20b443265Fc2F40845B715385Ff2",
      symbol: "EURCV",
    },
    collateralToken: {
      address: "0xa0769f7A8fC65e47dE93797b4e21C073c117Fc80",
      symbol: "EUTBL",
    },
  },
  {
    id: "0xaa0a318da172ec8f270ea406b205ffe7cdd5de67515996723ff410e2677be80b",
    name: "USDC / bbqUSDCturbo",
    irm: "0x870aC11D48B15DB9a138Cf899d20F13F79Ba00BC",
    lltv: "915000000000000000",
    oracle: "0xDe40Ef08eba5e6A624598002A8E6f27AD5A2dCe2",
    loanToken: {
      address: "0xA0b86991c6218b36c1d19D4a2e9Eb0cE3606eB48",
      symbol: "USDC",
    },
    collateralToken: {
      address: "0xBEEFFF4716a49418D69c251cab8759bB107e57C8",
      symbol: "bbqUSDCturbo",
    },
  },
  {
    id: "0xa9df100a64d18dc8ad741fe8b8a45acbd54a71808b7901d0570d808271673238",
    name: "lvWETH / lvstETH",
    irm: "0x870aC11D48B15DB9a138Cf899d20F13F79Ba00BC",
    lltv: "945000000000000000",
    oracle: "0xfEC63CBC3485ed19f053DFdc102F0E2051a5c95b",
    loanToken: {
      address: "0xd48Cc6043Be7d0f2803E9A351BB2821B68afb921",
      symbol: "lvWETH",
    },
    collateralToken: {
      address: "0x262edCD1853634bC8f52BABB4cB42d4272a68328",
      symbol: "lvstETH",
    },
  },
  {
    id: "0xa9d6a0caea685bb0099ba2d52a58fb7ed33a6447616c25df93bdb8330337a9c3",
    name: "wUSDL / csUSDC",
    irm: "0x870aC11D48B15DB9a138Cf899d20F13F79Ba00BC",
    lltv: "965000000000000000",
    oracle: "0x269Ca0eEeAC4B618E50Af4C5bf40b030Cc3a7C2E",
    loanToken: {
      address: "0x7751E2F4b8ae93EF6B79d86419d42FE3295A4559",
      symbol: "wUSDL",
    },
    collateralToken: {
      address: "0x7204B7Dbf9412567835633B6F00C3Edc3a8D6330",
      symbol: "csUSDC",
    },
  },
  {
    id: "0xa9ad5b54349a6c3c4c6647b4ffbee369e771b8ea5c8ef387f522fac9a308286d",
    name: "USDC / JAB78",
    irm: "0x870aC11D48B15DB9a138Cf899d20F13F79Ba00BC",
    lltv: "770000000000000000",
    oracle: "0x5Fc8A49193260651B716467Fd8B897aBf5677765",
    loanToken: {
      address: "0xA0b86991c6218b36c1d19D4a2e9Eb0cE3606eB48",
      symbol: "USDC",
    },
    collateralToken: {
      address: "0x16eE62eDF5B73F347eB7c7D2936734Ed3c16b97e",
      symbol: "JAB78",
    },
  },
  {
    id: "0xa97c8e3a828bf9b16221ea63c313bc871920d78559b0e962da3ea809c0e93eee",
    name: "XAUM / crvUSD",
    irm: "0x870aC11D48B15DB9a138Cf899d20F13F79Ba00BC",
    lltv: "770000000000000000",
    oracle: "0xED19a0aed8ADeCfe1A20aA7a3ee1dFfB10994e7a",
    loanToken: {
      address: "0x2103E845C5E135493Bb6c2A4f0B8651956eA8682",
      symbol: "XAUM",
    },
    collateralToken: {
      address: "0xf939E0A03FB07F59A73314E73794Be0E57ac1b4E",
      symbol: "crvUSD",
    },
  },
  {
    id: "0xa89d9cb8213087100e2edc580292aa03deb65779eb631b4be5491076efff63f9",
    name: "USDf / PT-sUSDf-25SEP2025",
    irm: "0x870aC11D48B15DB9a138Cf899d20F13F79Ba00BC",
    lltv: "915000000000000000",
    oracle: "0x1A405B1d97Ec5c9aDa5177Bdf7D69520b4fdD819",
    loanToken: {
      address: "0xFa2B947eEc368f42195f24F36d2aF29f7c24CeC2",
      symbol: "USDf",
    },
    collateralToken: {
      address: "0xAB365C0879024481E4ad3b47bd6FeA9c10014FbC",
      symbol: "PT-sUSDf-25SEP2025",
    },
  },
  {
    id: "0xa891e13072bbe6a7f22f0715e93a7780779cf081d53876f2458d836f11a074f9",
    name: "USDC / cbBTC",
    irm: "0x870aC11D48B15DB9a138Cf899d20F13F79Ba00BC",
    lltv: "915000000000000000",
    oracle: "0xA93e3B4A671F2E84b62e6A5845F98292c802484d",
    loanToken: {
      address: "0xA0b86991c6218b36c1d19D4a2e9Eb0cE3606eB48",
      symbol: "USDC",
    },
    collateralToken: {
      address: "0xcbB7C0000aB88B473b1f5aFd9ef808440eed33Bf",
      symbol: "cbBTC",
    },
  },
  {
    id: "0xa82577b1d641042e79aa649b4954ff80959c647cefa12806e648fee6b516a0c7",
    name: "AUSD / PRIME",
    irm: "0x870aC11D48B15DB9a138Cf899d20F13F79Ba00BC",
    lltv: "860000000000000000",
    oracle: "0xE30E3247eF5E6c4a004dEe0a2d65C9383aC81303",
    loanToken: {
      address: "0x00000000eFE302BEAA2b3e6e1b18d08D69a9012a",
      symbol: "AUSD",
    },
    collateralToken: {
      address: "0x19ebb35279A16207Ec4ba82799CC64715065F7F6",
      symbol: "PRIME",
    },
  },
  {
    id: "0xa7ed1d25d22232695244bf63fdee33688d6d3540e569dd3d88919a7982ed1d7a",
    name: "USDS / REKT",
    irm: "0x870aC11D48B15DB9a138Cf899d20F13F79Ba00BC",
    lltv: "770000000000000000",
    oracle: "0x50ca523eEB5aED11C3A74F730dE82Aea9bD04d78",
    loanToken: {
      address: "0xdC035D45d973E3EC169d2276DDab16f1e407384F",
      symbol: "USDS",
    },
    collateralToken: {
      address: "0xdd3B11eF34cd511a2DA159034a05fcb94D806686",
      symbol: "REKT",
    },
  },
  {
    id: "0xa79d8028dec527565028fd9fc075b02b498f2b69a1d519dff543ba99b812ff6b",
    name: "USDS / PT-sUSDE-27NOV2025",
    irm: "0x870aC11D48B15DB9a138Cf899d20F13F79Ba00BC",
    lltv: "915000000000000000",
    oracle: "0xd46F66D7Fc5aD6f54b9B62D36B9A4d99f3Cca451",
    loanToken: {
      address: "0xdC035D45d973E3EC169d2276DDab16f1e407384F",
      symbol: "USDS",
    },
    collateralToken: {
      address: "0xe6A934089BBEe34F832060CE98848359883749B3",
      symbol: "PT-sUSDE-27NOV2025",
    },
  },
  {
    id: "0xa72f4af2570dca1b356aa6c1e6a804d0d3df5b23bb092189776d0dc652feabb4",
    name: "USDA / rsETH",
    irm: "0x870aC11D48B15DB9a138Cf899d20F13F79Ba00BC",
    lltv: "770000000000000000",
    oracle: "0x599AD2053bFE462AB535f6370B9aBBa137CDeb83",
    loanToken: {
      address: "0x0000206329b97DB379d5E1Bf586BbDB969C63274",
      symbol: "USDA",
    },
    collateralToken: {
      address: "0xA1290d69c65A6Fe4DF752f95823fae25cB99e5A7",
      symbol: "rsETH",
    },
  },
  {
    id: "0xa6e1ba01b1ae2b8f73e026596a6c11551efe07ed55314cb12abfc1e76a4b6f14",
    name: "scrvUSD / yvyCRV",
    irm: "0x870aC11D48B15DB9a138Cf899d20F13F79Ba00BC",
    lltv: "770000000000000000",
    oracle: "0x100CfC365b6252e7C1D352a258Be85767407d190",
    loanToken: {
      address: "0x0655977FEb2f289A4aB78af67BAB0d17aAb84367",
      symbol: "scrvUSD",
    },
    collateralToken: {
      address: "0x27B5739e22ad9033bcBf192059122d163b60349D",
      symbol: "yvyCRV",
    },
  },
  {
    id: "0xa6ba19a21aa621528b7daa98e4205d0e43c883351a9e22c897be4481a69fe126",
    name: "USDC / PT-reUSD-10DEC2026",
    irm: "0x870aC11D48B15DB9a138Cf899d20F13F79Ba00BC",
    lltv: "915000000000000000",
    oracle: "0x1C210D5E530eAF3556e64e0afBDe9612b9457C3d",
    loanToken: {
      address: "0xA0b86991c6218b36c1d19D4a2e9Eb0cE3606eB48",
      symbol: "USDC",
    },
    collateralToken: {
      address: "0xeCfaFdC7741323a945A163ed068B5a3C43483957",
      symbol: "PT-reUSD-10DEC2026",
    },
  },
  {
    id: "0xa63a020dc9ae1a2b90a96ade4077a0124ec37d469150879760ef8cdb4577ad47",
    name: "USDC / PT-sBOLD-1765325646",
    irm: "0x870aC11D48B15DB9a138Cf899d20F13F79Ba00BC",
    lltv: "860000000000000000",
    oracle: "0x9e74B4DbD2a0f027074A68E3f0373Fc4e960b5e1",
    loanToken: {
      address: "0xA0b86991c6218b36c1d19D4a2e9Eb0cE3606eB48",
      symbol: "USDC",
    },
    collateralToken: {
      address: "0x1Ff893C9071d04F8A965a90FcB0de22406A3eEaa",
      symbol: "PT-sBOLD-1765325646",
    },
  },
  {
    id: "0xa6395c255b2890a4df6be45df96bdc063af453a7c834c85c63b053d0443b7506",
    name: "USDCV / USTBL",
    irm: "0x870aC11D48B15DB9a138Cf899d20F13F79Ba00BC",
    lltv: "965000000000000000",
    oracle: "0x45B38cb324b33b48E782F05285ae3394a59CFd90",
    loanToken: {
      address: "0x5422374B27757da72d5265cC745ea906E0446634",
      symbol: "USDCV",
    },
    collateralToken: {
      address: "0xe4880249745eAc5F1eD9d8F7DF844792D560e750",
      symbol: "USTBL",
    },
  },
  {
    id: "0xa5f6b409e74e34a0aa8b75642db4c954c533cf537ee48e04d4bae1888869bd3f",
    name: "USDC / CarryTradeUSDTRYLeverage",
    irm: "0x870aC11D48B15DB9a138Cf899d20F13F79Ba00BC",
    lltv: "625000000000000000",
    oracle: "0xb5eff91f3937fDf4250A680016EF2331b3930BaB",
    loanToken: {
      address: "0xA0b86991c6218b36c1d19D4a2e9Eb0cE3606eB48",
      symbol: "USDC",
    },
    collateralToken: {
      address: "0x2bf11d2E04Bc40daa95c24B8b90EC4F5c57Dd326",
      symbol: "CarryTradeUSDTRYLeverage",
    },
  },
  {
    id: "0xa5c0eb58bc78ed86ba709a16f47f45d7e96c52c8975e2828d2d485c8fbde4434",
    name: "USDC / v-wmtUSDC",
    irm: "0x870aC11D48B15DB9a138Cf899d20F13F79Ba00BC",
    lltv: "860000000000000000",
    oracle: "0x9792558Bc33DFF171115CdbFC198f44278719B62",
    loanToken: {
      address: "0xA0b86991c6218b36c1d19D4a2e9Eb0cE3606eB48",
      symbol: "USDC",
    },
    collateralToken: {
      address: "0xF65460B84c13eeb911303336Ab0f9D63CC79839f",
      symbol: "v-wmtUSDC",
    },
  },
  {
    id: "0xa5a49fa08443783f5a5cdc99b604033378f65148ec5cb6b2e718e801c4e7fe08",
    name: "USDS / IMF",
    irm: "0x870aC11D48B15DB9a138Cf899d20F13F79Ba00BC",
    lltv: "625000000000000000",
    oracle: "0x82f0952DbB57d5a0b77Dc39A209D699a4584dFcd",
    loanToken: {
      address: "0xdC035D45d973E3EC169d2276DDab16f1e407384F",
      symbol: "USDS",
    },
    collateralToken: {
      address: "0x05BE1d4c307C19450A6Fd7cE7307cE72a3829A60",
      symbol: "IMF",
    },
  },
  {
    id: "0xa4bb66e932dfa4b54c0b612dfffdbdc426f7906306a78178acd8562739121b9a",
    name: "lvlUSD / PT-lvlUSD-25SEP2025",
    irm: "0x870aC11D48B15DB9a138Cf899d20F13F79Ba00BC",
    lltv: "915000000000000000",
    oracle: "0x4692d04C4A05896540cBf4e4cb48A52508E04652",
    loanToken: {
      address: "0x7C1156E515aA1A2E851674120074968C905aAF37",
      symbol: "lvlUSD",
    },
    collateralToken: {
      address: "0x207F7205fd6c4b602Fa792C8b2B60e6006D4a0b8",
      symbol: "PT-lvlUSD-25SEP2025",
    },
  },
  {
    id: "0xa4a856c3a52f426f59c3a29d0854af473e4d3df84718709ff25a36a1c9e3c0ac",
    name: "USR / PT-sw-RLP-1750896023",
    irm: "0x870aC11D48B15DB9a138Cf899d20F13F79Ba00BC",
    lltv: "915000000000000000",
    oracle: "0xe3B8734a9B571E9c98A00Df8E588590C837a09c3",
    loanToken: {
      address: "0x66a1E37c9b0eAddca17d3662D6c05F4DECf3e110",
      symbol: "USR",
    },
    collateralToken: {
      address: "0x1F7Aa7104db822987E1F44A66dF709A8C4Fb301a",
      symbol: "PT-sw-RLP-1750896023",
    },
  },
  {
    id: "0xa4577bf93e8c70d9f91b6e000ae084ae0a7a29d4ebe28cbfea24975c28dccfb5",
    name: "USR / eBTC",
    irm: "0x870aC11D48B15DB9a138Cf899d20F13F79Ba00BC",
    lltv: "860000000000000000",
    oracle: "0x2bAFc4882CA171F364dFAF45877bD75C2585509B",
    loanToken: {
      address: "0x66a1E37c9b0eAddca17d3662D6c05F4DECf3e110",
      symbol: "USR",
    },
    collateralToken: {
      address: "0x657e8C867D8B37dCC18fA4Caead9C45EB088C642",
      symbol: "eBTC",
    },
  },
  {
    id: "0xa44c2f20a875c1b62b31ca0f68ff46f816145e3f9a6fcb3eec931ce26f6079bc",
    name: "AUSD / AA_FalconXUSDC",
    irm: "0x870aC11D48B15DB9a138Cf899d20F13F79Ba00BC",
    lltv: "770000000000000000",
    oracle: "0x52eA2C12734B5bB61e1edf52Bb0f01D9206493Fc",
    loanToken: {
      address: "0x00000000eFE302BEAA2b3e6e1b18d08D69a9012a",
      symbol: "AUSD",
    },
    collateralToken: {
      address: "0xC26A6Fa2C37b38E549a4a1807543801Db684f99C",
      symbol: "AA_FalconXUSDC",
    },
  },
  {
    id: "0xa43ea70e2982ea14d09784c9c759e79df3cf89884142b0b534ace4711ee24265",
    name: "USDC / PT-sw-RLP-1750896023",
    irm: "0x870aC11D48B15DB9a138Cf899d20F13F79Ba00BC",
    lltv: "915000000000000000",
    oracle: "0xBe94eD0c1649775fA5Fc51862aBe7A8D9D43CA2a",
    loanToken: {
      address: "0xA0b86991c6218b36c1d19D4a2e9Eb0cE3606eB48",
      symbol: "USDC",
    },
    collateralToken: {
      address: "0x1F7Aa7104db822987E1F44A66dF709A8C4Fb301a",
      symbol: "PT-sw-RLP-1750896023",
    },
  },
  {
    id: "0xa42ba90e4d3013dee8eb0d7bb7ae0817297337eeecd525dbdd48c7b5c5e6988d",
    name: "USDA / pufETH",
    irm: "0x870aC11D48B15DB9a138Cf899d20F13F79Ba00BC",
    lltv: "770000000000000000",
    oracle: "0x0bc6FaE2640bd074F5451CBBBac73BF86bCcBcfa",
    loanToken: {
      address: "0x0000206329b97DB379d5E1Bf586BbDB969C63274",
      symbol: "USDA",
    },
    collateralToken: {
      address: "0xD9A442856C234a39a81a089C06451EBAa4306a72",
      symbol: "pufETH",
    },
  },
  {
    id: "0xa3724490242354d512a92b79d779fa2037845233f0096c9acac36a1033097aee",
    name: "apxUSD / sDOLA",
    irm: "0x870aC11D48B15DB9a138Cf899d20F13F79Ba00BC",
    lltv: "860000000000000000",
    oracle: "0xB78d26ba977898Defe668886d56b0FA1ca04cD4e",
    loanToken: {
      address: "0x98A878b1Cd98131B271883B390f68D2c90674665",
      symbol: "apxUSD",
    },
    collateralToken: {
      address: "0xb45ad160634c528Cc3D2926d9807104FA3157305",
      symbol: "sDOLA",
    },
  },
  {
    id: "0xa317ab09a76b2213271a4df078cb3f132a4d192b456b1eb56051ff32cca6f0a1",
    name: "rUSD / PT-RUSD-31JUL2025",
    irm: "0x870aC11D48B15DB9a138Cf899d20F13F79Ba00BC",
    lltv: "915000000000000000",
    oracle: "0x67A71BdaC427378928C75DC7132b166Dd50C589E",
    loanToken: {
      address: "0x09D4214C03D01F49544C0448DBE3A27f768F2b34",
      symbol: "rUSD",
    },
    collateralToken: {
      address: "0xf736acF34FF7Cd9B3565b73a1f15E652859bF322",
      symbol: "PT-RUSD-31JUL2025",
    },
  },
  {
    id: "0xa2b4219c16c5430610bd10ed01cb3b852bad64e933d560a181d216bad9f3dc4d",
    name: "USDC / USDC",
    irm: "0x870aC11D48B15DB9a138Cf899d20F13F79Ba00BC",
    lltv: "915000000000000000",
    oracle: "0xc6c5140d6aE2D1B3759E400CD59C499C496106cC",
    loanToken: {
      address: "0xA0b86991c6218b36c1d19D4a2e9Eb0cE3606eB48",
      symbol: "USDC",
    },
    collateralToken: {
      address: "0xA0b86991c6218b36c1d19D4a2e9Eb0cE3606eB48",
      symbol: "USDC",
    },
  },
  {
    id: "0xa29e0885093b1fba89ac56ec045495148686514a95ef43ac3ab69124331873e0",
    name: "CRNC / USDC",
    irm: "0x870aC11D48B15DB9a138Cf899d20F13F79Ba00BC",
    lltv: "385000000000000000",
    oracle: "0x26E397ec5Dffa81ea06B7E1bBFB2fDE2E464cD01",
    loanToken: {
      address: "0x47d13Fb0803409c7fE169A210d4e906165F1A432",
      symbol: "CRNC",
    },
    collateralToken: {
      address: "0xA0b86991c6218b36c1d19D4a2e9Eb0cE3606eB48",
      symbol: "USDC",
    },
  },
  {
    id: "0xa28e5ebd9bc44207b95805c1a79b1e668f211309ddfe13ab418db597a342133b",
    name: "USDC / USDf",
    irm: "0x870aC11D48B15DB9a138Cf899d20F13F79Ba00BC",
    lltv: "915000000000000000",
    oracle: "0xfb54dB22A98899c1932a0e633cAd7bDecE86434C",
    loanToken: {
      address: "0xA0b86991c6218b36c1d19D4a2e9Eb0cE3606eB48",
      symbol: "USDC",
    },
    collateralToken: {
      address: "0xFa2B947eEc368f42195f24F36d2aF29f7c24CeC2",
      symbol: "USDf",
    },
  },
  {
    id: "0xa1efba5243dcfe7ccc5b25c70e68717cbb36980c2a1628d58637a32785e6ad75",
    name: "USDC / wUTXO",
    irm: "0x870aC11D48B15DB9a138Cf899d20F13F79Ba00BC",
    lltv: "860000000000000000",
    oracle: "0xEFe92E017162Fe142E5e2a25a39b41A3A615EC58",
    loanToken: {
      address: "0xA0b86991c6218b36c1d19D4a2e9Eb0cE3606eB48",
      symbol: "USDC",
    },
    collateralToken: {
      address: "0xd76B994b6E6350bc298c836cBb58b117496e49E3",
      symbol: "wUTXO",
    },
  },
  {
    id: "0xa1d49b6cbeff96db0111e763f13309bda861ac7984b11ffd36a3f288b614098c",
    name: "lvlUSD / PT-lvlUSD-29MAY2025",
    irm: "0x870aC11D48B15DB9a138Cf899d20F13F79Ba00BC",
    lltv: "915000000000000000",
    oracle: "0x96d4FE2Aeb531ABc3370A58Fbfa52c9B1B900E77",
    loanToken: {
      address: "0x7C1156E515aA1A2E851674120074968C905aAF37",
      symbol: "lvlUSD",
    },
    collateralToken: {
      address: "0x9BcA74F805AB0a22DDD0886dB0942199a0feBa71",
      symbol: "PT-lvlUSD-29MAY2025",
    },
  },
  {
    id: "0xa1a5a726403e8445f2c3fd4d58ac4c49e8ba9d6342d74a09f7931a3958104876",
    name: "DAI / PENDLE-LPT",
    irm: "0x870aC11D48B15DB9a138Cf899d20F13F79Ba00BC",
    lltv: "915000000000000000",
    oracle: "0xc80aA2aB3ae2aEeEE884c69BE72be24A027021fd",
    loanToken: {
      address: "0x6B175474E89094C44Da98b954EedeAC495271d0F",
      symbol: "DAI",
    },
    collateralToken: {
      address: "0xdacE1121e10500e9e29d071F01593fD76B000f08",
      symbol: "PENDLE-LPT",
    },
  },
  {
    id: "0xa144da775ce7b0818cb7e225b64511bd6f8e8485e34844c98d21b50a58dd6193",
    name: "lvWETH / lvstETH",
    irm: "0x870aC11D48B15DB9a138Cf899d20F13F79Ba00BC",
    lltv: "945000000000000000",
    oracle: "0xA2f0ace307389CCEBD7F208915b1E40c4E595efC",
    loanToken: {
      address: "0xD32440dbe434dEf191da5A74581beEccE31EB7ca",
      symbol: "lvWETH",
    },
    collateralToken: {
      address: "0xf8E21A49b3Febe4A9532F563CA6228C4674F68d8",
      symbol: "lvstETH",
    },
  },
  {
    id: "0xa11602fcdc5988f10f89a53a44a48caaddf460ba1e22e387299e78d92a8b5d6b",
    name: "CRNC / USDC",
    irm: "0x870aC11D48B15DB9a138Cf899d20F13F79Ba00BC",
    lltv: "385000000000000000",
    oracle: "0x2fd86b5cD0Ea1FBCa7c52298db3C57CAc048AE82",
    loanToken: {
      address: "0x47d13Fb0803409c7fE169A210d4e906165F1A432",
      symbol: "CRNC",
    },
    collateralToken: {
      address: "0xA0b86991c6218b36c1d19D4a2e9Eb0cE3606eB48",
      symbol: "USDC",
    },
  },
  {
    id: "0x9fd40616289131209c25b8ce9ac0a5b2268ad4ebfa5694f6c6f7bf04637d60ed",
    name: "AUSD / SPYx",
    irm: "0x870aC11D48B15DB9a138Cf899d20F13F79Ba00BC",
    lltv: "625000000000000000",
    oracle: "0xc7A739E7391DB46C4bD277f0D298851F10bbBA05",
    loanToken: {
      address: "0x00000000eFE302BEAA2b3e6e1b18d08D69a9012a",
      symbol: "AUSD",
    },
    collateralToken: {
      address: "0x90A2a4c76b5D8c0bc892A69EA28Aa775a8f2dD48",
      symbol: "SPYx",
    },
  },
  {
    id: "0x9f93305ce26c48170a11ae960425a084ab6567bb56d61a4de631855224091702",
    name: "USDC / TOKEN",
    irm: "0x870aC11D48B15DB9a138Cf899d20F13F79Ba00BC",
    lltv: "980000000000000000",
    oracle: "0x454e632B8a235ACe145c5bC6F5aa318ad551f5ba",
    loanToken: {
      address: "0xcbfb9B444d9735C345Df3A0F66cd89bD741692E9",
      symbol: "USDC",
    },
    collateralToken: {
      address: "0x910836B41791e07B4AC107c0DFbc41Ffd07d2702",
      symbol: "TOKEN",
    },
  },
  {
    id: "0x9ea35e2e131ba2046fe6d0be3674764578e9e293cfda074dbf2b3eb86464212d",
    name: "crvUSD / ",
    irm: "0x870aC11D48B15DB9a138Cf899d20F13F79Ba00BC",
    lltv: "860000000000000000",
    oracle: "0xb2e1c8EfaaDf45342E4682c4ce7FC4A9fd253F06",
    loanToken: {
      address: "0xf939E0A03FB07F59A73314E73794Be0E57ac1b4E",
      symbol: "crvUSD",
    },
    collateralToken: {
      address: "0x6f471267d09953f27F983Cfe17556eFf3e3b2DFB",
      symbol: "",
    },
  },
  {
    id: "0x9e30a7622d6b2d68d4d4a8ef3781094c173dea388cc7298eafeb89bd905b6602",
    name: "RLUSD / cbBTC",
    irm: "0x870aC11D48B15DB9a138Cf899d20F13F79Ba00BC",
    lltv: "860000000000000000",
    oracle: "0xFF36cada4949A3722a2a7ab0aF23984758058C99",
    loanToken: {
      address: "0x8292Bb45bf1Ee4d140127049757C2E0fF06317eD",
      symbol: "RLUSD",
    },
    collateralToken: {
      address: "0xcbB7C0000aB88B473b1f5aFd9ef808440eed33Bf",
      symbol: "cbBTC",
    },
  },
  {
    id: "0x9dbbac18961c6547452ffdc681d6ced6a1703a5e970a0c960bf29a363f2ecc1b",
    name: "WBTC / EURCV",
    irm: "0x870aC11D48B15DB9a138Cf899d20F13F79Ba00BC",
    lltv: "860000000000000000",
    oracle: "0x5b793e439A923389C6ad165D8b50581E8AFc78fe",
    loanToken: {
      address: "0x2260FAC5E5542a773Aa44fBCfeDf7C193bc2C599",
      symbol: "WBTC",
    },
    collateralToken: {
      address: "0x5F7827FDeb7c20b443265Fc2F40845B715385Ff2",
      symbol: "EURCV",
    },
  },
  {
    id: "0x9daa16d29cb9ac775001c55e72ca2be911757cd3edd7d35b3f297563447f8a96",
    name: "sUSDS / PT-sUSDE-29MAY2025",
    irm: "0x870aC11D48B15DB9a138Cf899d20F13F79Ba00BC",
    lltv: "915000000000000000",
    oracle: "0x71445fF8B23499e08B28DCfcD7Ed6F2c84dfC713",
    loanToken: {
      address: "0xa3931d71877C0E7a3148CB7Eb4463524FEc27fbD",
      symbol: "sUSDS",
    },
    collateralToken: {
      address: "0xb7de5dFCb74d25c2f21841fbd6230355C50d9308",
      symbol: "PT-sUSDE-29MAY2025",
    },
  },
  {
    id: "0x9d1246ff6c1db879a64d0752458b18b45a1c897bd498761bf35e481e949ee5b4",
    name: "AUSD / cbBTC",
    irm: "0x870aC11D48B15DB9a138Cf899d20F13F79Ba00BC",
    lltv: "860000000000000000",
    oracle: "0x26129a403aa4d0d1c540F2C3669422b636E0D591",
    loanToken: {
      address: "0x00000000eFE302BEAA2b3e6e1b18d08D69a9012a",
      symbol: "AUSD",
    },
    collateralToken: {
      address: "0xcbB7C0000aB88B473b1f5aFd9ef808440eed33Bf",
      symbol: "cbBTC",
    },
  },
  {
    id: "0x9cee9bbaa26920d8a7be1515ee680caeca5890fe2b664e5568e2ad54656dd1ff",
    name: "USDT / cbBTC",
    irm: "0x870aC11D48B15DB9a138Cf899d20F13F79Ba00BC",
    lltv: "860000000000000000",
    oracle: "0x31b8bF9E48f85aFa6B9738eaDE4Af605e7771E4D",
    loanToken: {
      address: "0xdAC17F958D2ee523a2206206994597C13D831ec7",
      symbol: "USDT",
    },
    collateralToken: {
      address: "0xcbB7C0000aB88B473b1f5aFd9ef808440eed33Bf",
      symbol: "cbBTC",
    },
  },
  {
    id: "0x9cd7e77c4da7cb0216f7525af26271a2281f5fca5f16f78b83f36043d6e0a194",
    name: "USDC / WETH",
    irm: "0x870aC11D48B15DB9a138Cf899d20F13F79Ba00BC",
    lltv: "860000000000000000",
    oracle: "0xDddd770BADd886dF3864029e4B377B5F6a2B6b83",
    loanToken: {
      address: "0xA0b86991c6218b36c1d19D4a2e9Eb0cE3606eB48",
      symbol: "USDC",
    },
    collateralToken: {
      address: "0xC02aaA39b223FE8D0A0e5C4F27eAD9083C756Cc2",
      symbol: "WETH",
    },
  },
  {
    id: "0x9be0fb56b4d52d3632683b632514a2304f6fe1103e081acc358ded09e8e9a1e7",
    name: "AUSD / syzUSD",
    irm: "0x870aC11D48B15DB9a138Cf899d20F13F79Ba00BC",
    lltv: "915000000000000000",
    oracle: "0x0604084149dCB25a1739899624333D69dB1A507e",
    loanToken: {
      address: "0x00000000eFE302BEAA2b3e6e1b18d08D69a9012a",
      symbol: "AUSD",
    },
    collateralToken: {
      address: "0x6DFF69eb720986E98Bb3E8b26cb9E02Ec1a35D12",
      symbol: "syzUSD",
    },
  },
  {
    id: "0x9bdf55afe3832abff223c7d10b2af529b395ec2489e32d872156421c32ec7a5f",
    name: "USDS / BITCOIN",
    irm: "0x870aC11D48B15DB9a138Cf899d20F13F79Ba00BC",
    lltv: "625000000000000000",
    oracle: "0xD131B09707A4a9D7Ce7c74D454d6Ae335e9955Fd",
    loanToken: {
      address: "0xdC035D45d973E3EC169d2276DDab16f1e407384F",
      symbol: "USDS",
    },
    collateralToken: {
      address: "0x72e4f9F808C49A2a61dE9C5896298920Dc4EEEa9",
      symbol: "BITCOIN",
    },
  },
  {
    id: "0x9af1cd7c32fe78c694ca9326163a25b008ff0cf2d17c80b86adf7a7ef01c7966",
    name: "sUSDS / PT-RLP-4SEP2025",
    irm: "0x870aC11D48B15DB9a138Cf899d20F13F79Ba00BC",
    lltv: "915000000000000000",
    oracle: "0xa5f3399476D94F652B163a71b37781c00C0b6468",
    loanToken: {
      address: "0xa3931d71877C0E7a3148CB7Eb4463524FEc27fbD",
      symbol: "sUSDS",
    },
    collateralToken: {
      address: "0x742B4166878Bfd339Db65a29a17E49b81a6B6Aac",
      symbol: "PT-RLP-4SEP2025",
    },
  },
  {
    id: "0x9a33209eee9e93f5f7aed04085f9f5e0ce9a7a103c476f5c30a0e5ca03c3d540",
    name: "USDT / PENDLE-LPT-WRAPPED",
    irm: "0x870aC11D48B15DB9a138Cf899d20F13F79Ba00BC",
    lltv: "915000000000000000",
    oracle: "0xF47020f01e77257Fe86B9ECb36552486E0Ae66e0",
    loanToken: {
      address: "0xdAC17F958D2ee523a2206206994597C13D831ec7",
      symbol: "USDT",
    },
    collateralToken: {
      address: "0x8ddac7aa85Ce324AF75a3bFcB876375555d43BB8",
      symbol: "PENDLE-LPT-WRAPPED",
    },
  },
  {
    id: "0x997654bf02d46d50e38392609ae6d3b41a2045b0abaafe1d30cd28aff7899568",
    name: "USDC / PAXG",
    irm: "0x870aC11D48B15DB9a138Cf899d20F13F79Ba00BC",
    lltv: "860000000000000000",
    oracle: "0xDddd770BADd886dF3864029e4B377B5F6a2B6b83",
    loanToken: {
      address: "0xA0b86991c6218b36c1d19D4a2e9Eb0cE3606eB48",
      symbol: "USDC",
    },
    collateralToken: {
      address: "0x45804880De22913dAFE09f4980848ECE6EcbAf78",
      symbol: "PAXG",
    },
  },
  {
    id: "0x995e1cd47d58c64540e9cc5975ecfe538a12b33dc042595d67662aa60272753c",
    name: "USDC / weETH",
    irm: "0x870aC11D48B15DB9a138Cf899d20F13F79Ba00BC",
    lltv: "860000000000000000",
    oracle: "0xDddd770BADd886dF3864029e4B377B5F6a2B6b83",
    loanToken: {
      address: "0xA0b86991c6218b36c1d19D4a2e9Eb0cE3606eB48",
      symbol: "USDC",
    },
    collateralToken: {
      address: "0xCd5fE23C85820F7B72D0926FC9b05b43E359b7ee",
      symbol: "weETH",
    },
  },
  {
    id: "0x98f593f110c5ce358a3a0bedffd12207186060f194304b980f00440bb532d3f2",
    name: "USDA / PT-USDe-25JUL2024",
    irm: "0x870aC11D48B15DB9a138Cf899d20F13F79Ba00BC",
    lltv: "860000000000000000",
    oracle: "0x81B379f99CeE4Ee08f8CBC476e80e756D3b172cc",
    loanToken: {
      address: "0x0000206329b97DB379d5E1Bf586BbDB969C63274",
      symbol: "USDA",
    },
    collateralToken: {
      address: "0xa0021EF8970104c2d008F38D92f115ad56a9B8e1",
      symbol: "PT-USDe-25JUL2024",
    },
  },
  {
    id: "0x98e713d1f057fabc103ef0f3426cae0d55726bceb6bdc54302448cd31de3f1ad",
    name: "WBTC / tBTC",
    irm: "0x870aC11D48B15DB9a138Cf899d20F13F79Ba00BC",
    lltv: "945000000000000000",
    oracle: "0x166bEFB14e5896Bb7958c07296Ab776930AeA89a",
    loanToken: {
      address: "0x2260FAC5E5542a773Aa44fBCfeDf7C193bc2C599",
      symbol: "WBTC",
    },
    collateralToken: {
      address: "0x18084fbA666a33d37592fA2633fD49a74DD93a88",
      symbol: "tBTC",
    },
  },
  {
    id: "0x98caecbaec1d775784c8da1100849f006dd97a12561c51af28f5db63c4fd5fbd",
    name: "AUSD / PT-srUSDe-25JUN2026",
    irm: "0x870aC11D48B15DB9a138Cf899d20F13F79Ba00BC",
    lltv: "915000000000000000",
    oracle: "0x20358B3340D8400Df30B1177e9EcDbB0FF2c19Ab",
    loanToken: {
      address: "0x00000000eFE302BEAA2b3e6e1b18d08D69a9012a",
      symbol: "AUSD",
    },
    collateralToken: {
      address: "0x619D75E3b790eBC21c289f2805Bb7177A7D732E2",
      symbol: "PT-srUSDe-25JUN2026",
    },
  },
  {
    id: "0x987134eb4716fc3dee2cb9ca8d8fba692389f7e43c717db4fe0cedaf287816e9",
    name: "LINK / wstLINK",
    irm: "0x870aC11D48B15DB9a138Cf899d20F13F79Ba00BC",
    lltv: "915000000000000000",
    oracle: "0x833B6dB67987Ac248d4bD1195B91Dd953e6dB6d1",
    loanToken: {
      address: "0x514910771AF9Ca656af840dff83E8264EcF986CA",
      symbol: "LINK",
    },
    collateralToken: {
      address: "0x911D86C72155c33993d594B0Ec7E6206B4C803da",
      symbol: "wstLINK",
    },
  },
  {
    id: "0x987118ea266c483fe0602f727b897f94a0dd3ff8032dd6cd36b4701d9bee8e6b",
    name: "tBTC / wstETH",
    irm: "0x870aC11D48B15DB9a138Cf899d20F13F79Ba00BC",
    lltv: "915000000000000000",
    oracle: "0xf0Db32f5c678d02DD8EB1839e60F1fD16DBF49e2",
    loanToken: {
      address: "0x18084fbA666a33d37592fA2633fD49a74DD93a88",
      symbol: "tBTC",
    },
    collateralToken: {
      address: "0x7f39C581F595B53c5cb19bD0b3f8dA6c935E2Ca0",
      symbol: "wstETH",
    },
  },
  {
    id: "0x981653e37cdafeeccbf29609567b303bacc90273ee45e074f960b3947f60532b",
    name: "USR / PT-SY wstUSR-25JUN2026",
    irm: "0x870aC11D48B15DB9a138Cf899d20F13F79Ba00BC",
    lltv: "915000000000000000",
    oracle: "0x2A60F94bfD855c449FF55C0C9829FB964bCf050e",
    loanToken: {
      address: "0x66a1E37c9b0eAddca17d3662D6c05F4DECf3e110",
      symbol: "USR",
    },
    collateralToken: {
      address: "0x90A2d7A50692f2620b467747A32CFa61889997B1",
      symbol: "PT-SY wstUSR-25JUN2026",
    },
  },
  {
    id: "0x9811611e4fe333811855cb3d8f0b500498e3f2ad5eae8b23df40d196d6ab4d8d",
    name: "USDC / sUSDEsUSDS",
    irm: "0x870aC11D48B15DB9a138Cf899d20F13F79Ba00BC",
    lltv: "915000000000000000",
    oracle: "0x9d318dDbDa03B3946E2EDcf35859C89e888fE09a",
    loanToken: {
      address: "0xA0b86991c6218b36c1d19D4a2e9Eb0cE3606eB48",
      symbol: "USDC",
    },
    collateralToken: {
      address: "0x3CEf1AFC0E8324b57293a6E7cE663781bbEFBB79",
      symbol: "sUSDEsUSDS",
    },
  },
  {
    id: "0x97f2d3c41bcb15ae3a77dccdf02c71e526b37822a7a06ad564b7a8b371570e3a",
    name: "USDC / rETH",
    irm: "0x870aC11D48B15DB9a138Cf899d20F13F79Ba00BC",
    lltv: "860000000000000000",
    oracle: "0xDddd770BADd886dF3864029e4B377B5F6a2B6b83",
    loanToken: {
      address: "0xA0b86991c6218b36c1d19D4a2e9Eb0cE3606eB48",
      symbol: "USDC",
    },
    collateralToken: {
      address: "0xae78736Cd615f374D3085123A210448E74Fc6393",
      symbol: "rETH",
    },
  },
  {
    id: "0x97d033a5753c279025cbf6a13b63ebef0ccc7bdf8a6788b3c71fcf01c31fcc94",
    name: "BOLD / ysyBOLD",
    irm: "0x870aC11D48B15DB9a138Cf899d20F13F79Ba00BC",
    lltv: "915000000000000000",
    oracle: "0x0056cf52be1b744A434Aeb4C4bE015A0068BE9bE",
    loanToken: {
      address: "0x6440f144b7e50D6a8439336510312d2F54beB01D",
      symbol: "BOLD",
    },
    collateralToken: {
      address: "0x23346B04a7f55b8760E5860AA5A77383D63491cD",
      symbol: "ysyBOLD",
    },
  },
  {
    id: "0x97c7f0bc22b318ad87f11b651297998201fbdcd0272d3e1023e8794dbb5ea649",
    name: "EURC / steakUSDC",
    irm: "0x870aC11D48B15DB9a138Cf899d20F13F79Ba00BC",
    lltv: "915000000000000000",
    oracle: "0x47260D67C77dddE6451D785FB1Ab5C9B4A2C7Aa0",
    loanToken: {
      address: "0x1aBaEA1f7C830bD89Acc67eC4af516284b1bC33c",
      symbol: "EURC",
    },
    collateralToken: {
      address: "0xbeef088055857739C12CD3765F20b7679Def0f51",
      symbol: "steakUSDC",
    },
  },
  {
    id: "0x97a3d2d9189de8616829f313bfc02fea0026b47e794ee08c9c48dee54377d6da",
    name: "AUSD / PT-srUSDe-15JAN2026",
    irm: "0x870aC11D48B15DB9a138Cf899d20F13F79Ba00BC",
    lltv: "915000000000000000",
    oracle: "0xF313A005556922FE8dde37e4d87D89faf2184F42",
    loanToken: {
      address: "0x00000000eFE302BEAA2b3e6e1b18d08D69a9012a",
      symbol: "AUSD",
    },
    collateralToken: {
      address: "0x1Fb3C5c35D95F48e48FFC8e36bCCe5CB5f29F57c",
      symbol: "PT-srUSDe-15JAN2026",
    },
  },
  {
    id: "0x9780dbcca32562ff8b89c014294ed4ed1c262b8dcbb77f05bd1feacb355503ae",
    name: "fwUSDT / fwUNI",
    irm: "0x870aC11D48B15DB9a138Cf899d20F13F79Ba00BC",
    lltv: "625000000000000000",
    oracle: "0x443132dfa279514d836ca3437f2831E1fCb092E3",
    loanToken: {
      address: "0xef87f4608e601E8564800265AeE1c1FfaDF73283",
      symbol: "fwUSDT",
    },
    collateralToken: {
      address: "0xE8E1F50392Bd61D0F8F48E8E7aF51D3b8a52090a",
      symbol: "fwUNI",
    },
  },
  {
    id: "0x97670b09989b5a2cc1547800b3265f177d06a3fcaf646a10af23476bf59d3b59",
    name: "MAYA / CUSD",
    irm: "0x870aC11D48B15DB9a138Cf899d20F13F79Ba00BC",
    lltv: "625000000000000000",
    oracle: "0xfd73C872EB04eebeACeA478F8Ca6Cb628144d2f6",
    loanToken: {
      address: "0xC4D461889F3ae06e97118342862251241AC24dDC",
      symbol: "MAYA",
    },
    collateralToken: {
      address: "0xe30f0B62E8Ae5ce2934151146dAe5651c2288C84",
      symbol: "CUSD",
    },
  },
  {
    id: "0x9762977fb60d369826e610bb48e561f9a6fa6f8b3bc7a1b77710b160257387a0",
    name: "USDC / ysUSDS",
    irm: "0x870aC11D48B15DB9a138Cf899d20F13F79Ba00BC",
    lltv: "980000000000000000",
    oracle: "0x0D35Db0928127195990D03E6A6788FA6cc592b06",
    loanToken: {
      address: "0xA0b86991c6218b36c1d19D4a2e9Eb0cE3606eB48",
      symbol: "USDC",
    },
    collateralToken: {
      address: "0x4cE9c93513DfF543Bc392870d57dF8C04e89Ba0a",
      symbol: "ysUSDS",
    },
  },
  {
    id: "0x973b23002efe233943715a2dfb98b66a0434d4b192b00bb4924230b3916433f7",
    name: "USDS / REKT",
    irm: "0x870aC11D48B15DB9a138Cf899d20F13F79Ba00BC",
    lltv: "625000000000000000",
    oracle: "0x50ca523eEB5aED11C3A74F730dE82Aea9bD04d78",
    loanToken: {
      address: "0xdC035D45d973E3EC169d2276DDab16f1e407384F",
      symbol: "USDS",
    },
    collateralToken: {
      address: "0xdd3B11eF34cd511a2DA159034a05fcb94D806686",
      symbol: "REKT",
    },
  },
  {
    id: "0x972e8cd51940dd0311b7b6f5adeb86bc7563e3c7502c5d2c00b200195cb89f39",
    name: "USR / PT-RLP-4SEP2025",
    irm: "0x870aC11D48B15DB9a138Cf899d20F13F79Ba00BC",
    lltv: "860000000000000000",
    oracle: "0x562276a190AD4De8F1A46746907e2b4ea3fCb81C",
    loanToken: {
      address: "0x66a1E37c9b0eAddca17d3662D6c05F4DECf3e110",
      symbol: "USR",
    },
    collateralToken: {
      address: "0x742B4166878Bfd339Db65a29a17E49b81a6B6Aac",
      symbol: "PT-RLP-4SEP2025",
    },
  },
  {
    id: "0x96cad5abf2bd0b30de441639a54125b6d1c6ba14c211fdc1d21abe5ec2bef542",
    name: "USDC / AA_RockawayXUSDC",
    irm: "0x870aC11D48B15DB9a138Cf899d20F13F79Ba00BC",
    lltv: "915000000000000000",
    oracle: "0x4bAff53CEEb99640447864A1605966D02fDFB661",
    loanToken: {
      address: "0xA0b86991c6218b36c1d19D4a2e9Eb0cE3606eB48",
      symbol: "USDC",
    },
    collateralToken: {
      address: "0xEC6a70F62a83418c7fb238182eD2865F80491a8B",
      symbol: "AA_RockawayXUSDC",
    },
  },
  {
    id: "0x96102cf47f704982c942272f780af6ebb326e8053d2d0a313486ac966011b37a",
    name: "USDC / USDС",
    irm: "0x870aC11D48B15DB9a138Cf899d20F13F79Ba00BC",
    lltv: "980000000000000000",
    oracle: "0x2a01EB9496094dA03c4E364Def50f5aD1280AD72",
    loanToken: {
      address: "0xA0b86991c6218b36c1d19D4a2e9Eb0cE3606eB48",
      symbol: "USDC",
    },
    collateralToken: {
      address: "0x5C351E5da659Ac83969045d6e0642ea0895A5A58",
      symbol: "USDС",
    },
  },
  {
    id: "0x957b4bafa7e138316cd80de93dd1b3044f449fc69e0aa58dcec6473f4c7540e0",
    name: "USDT / USDT",
    irm: "0x870aC11D48B15DB9a138Cf899d20F13F79Ba00BC",
    lltv: "965000000000000000",
    oracle: "0x24CC84c52f15c06170c1b7cBfaeD4b9D1D1FDd55",
    loanToken: {
      address: "0xdAC17F958D2ee523a2206206994597C13D831ec7",
      symbol: "USDT",
    },
    collateralToken: {
      address: "0x3D4762b4bB4B4C922377Fe5b887E900D7fB64cDf",
      symbol: "USDT",
    },
  },
  {
    id: "0x9551f52490815c3dd64dcd349050ce6f42ef64d70f5805c14920b4fd6d3b2544",
    name: "EURCV / LBTC",
    irm: "0x870aC11D48B15DB9a138Cf899d20F13F79Ba00BC",
    lltv: "860000000000000000",
    oracle: "0xeF618B6D665980b75a22D08BA7107575c884331d",
    loanToken: {
      address: "0x5F7827FDeb7c20b443265Fc2F40845B715385Ff2",
      symbol: "EURCV",
    },
    collateralToken: {
      address: "0x8236a87084f8B84306f72007F36F2618A5634494",
      symbol: "LBTC",
    },
  },
  {
    id: "0x953151614e82ac81cd978d354d7f741bf7f479cdfbe6d48818f8f9454e08657f",
    name: "USDC / USDO",
    irm: "0x870aC11D48B15DB9a138Cf899d20F13F79Ba00BC",
    lltv: "915000000000000000",
    oracle: "0x26Be0B9fDAF2855428DEee155b195eE802144ACD",
    loanToken: {
      address: "0xA0b86991c6218b36c1d19D4a2e9Eb0cE3606eB48",
      symbol: "USDC",
    },
    collateralToken: {
      address: "0x8238884Ec9668Ef77B90C6dfF4D1a9F4F4823BFe",
      symbol: "USDO",
    },
  },
  {
    id: "0x94d5be9c270fd4464c9187024028c393ea200ea3677801faf5b096a5f285724d",
    name: "USDC / USDf",
    irm: "0x870aC11D48B15DB9a138Cf899d20F13F79Ba00BC",
    lltv: "915000000000000000",
    oracle: "0xEac6365FDcE8fe3D6a17C164f0d67D33Bd49D8B6",
    loanToken: {
      address: "0xA0b86991c6218b36c1d19D4a2e9Eb0cE3606eB48",
      symbol: "USDC",
    },
    collateralToken: {
      address: "0xFa2B947eEc368f42195f24F36d2aF29f7c24CeC2",
      symbol: "USDf",
    },
  },
  {
    id: "0x94685ffdef839c95c7bdc39a6f044b4112942918d9e0854492768963d5dbfc20",
    name: "USDC / USCC",
    irm: "0x870aC11D48B15DB9a138Cf899d20F13F79Ba00BC",
    lltv: "860000000000000000",
    oracle: "0xDddd770BADd886dF3864029e4B377B5F6a2B6b83",
    loanToken: {
      address: "0xA0b86991c6218b36c1d19D4a2e9Eb0cE3606eB48",
      symbol: "USDC",
    },
    collateralToken: {
      address: "0x14d60E7FDC0D71d8611742720E4C50E7a974020c",
      symbol: "USCC",
    },
  },
  {
    id: "0x9464b3d42133c10c8b216d3d9429b43e98c2f3856a87940ef18b8bdd3e7bd831",
    name: "AUSD / PT-USDat-27AUG2026",
    irm: "0x870aC11D48B15DB9a138Cf899d20F13F79Ba00BC",
    lltv: "915000000000000000",
    oracle: "0xDAd04877702ca7F4a02ECCDfa1D0BFD2bB2Be6b8",
    loanToken: {
      address: "0x00000000eFE302BEAA2b3e6e1b18d08D69a9012a",
      symbol: "AUSD",
    },
    collateralToken: {
      address: "0x1D69402390657308C91179aa184bF992908c1e08",
      symbol: "PT-USDat-27AUG2026",
    },
  },
  {
    id: "0x93dcb7701a3cb2c3002f6a3b88311b2158687a08e00cdc4c28803cbae5f1aba0",
    name: "ARZ / unknown",
    irm: "0x870aC11D48B15DB9a138Cf899d20F13F79Ba00BC",
    lltv: "915000000000000000",
    oracle: "0x0b0E64c05083FdF9ED7C5D3d8262c4216eFc9394",
    loanToken: {
      address: "0xE9185Ee218cae427aF7B9764A011bb89FeA761B4",
      symbol: "ARZ",
    },
    collateralToken: {
      address: "0x833589fCD6eDb6E08f4c7C32D4f71b54bdA02913",
      symbol: "unknown",
    },
  },
  {
    id: "0x935e27ebdbb04030e85c85f9a17a249442024fa5328a445a461b5551f9588fe7",
    name: "AUSD / msY",
    irm: "0x870aC11D48B15DB9a138Cf899d20F13F79Ba00BC",
    lltv: "915000000000000000",
    oracle: "0xcB62f468B5724B7748293fc78E42C3DA840a8338",
    loanToken: {
      address: "0x00000000eFE302BEAA2b3e6e1b18d08D69a9012a",
      symbol: "AUSD",
    },
    collateralToken: {
      address: "0x890A5122Aa1dA30fEC4286DE7904Ff808F0bd74A",
      symbol: "msY",
    },
  },
  {
    id: "0x92e9bbdb019ee88d0b1a42e8670e55a5c6506da35923d8e64de69522b317c3e8",
    name: "apxUSD / PT-apyUSD-5NOV2026",
    irm: "0x870aC11D48B15DB9a138Cf899d20F13F79Ba00BC",
    lltv: "915000000000000000",
    oracle: "0x0F175EB06Fae59B9A3Dd789e2F210e2A9eced412",
    loanToken: {
      address: "0x98A878b1Cd98131B271883B390f68D2c90674665",
      symbol: "apxUSD",
    },
    collateralToken: {
      address: "0xb5Be35D8fF83D431899b95851CB17a2B4bcEF150",
      symbol: "PT-apyUSD-5NOV2026",
    },
  },
  {
    id: "0x92dae8ca320e8e5f43f6435b02acf24073b517509cb303516599faaf9571c4fc",
    name: "USDC / IB01.bt",
    irm: "0x870aC11D48B15DB9a138Cf899d20F13F79Ba00BC",
    lltv: "625000000000000000",
    oracle: "0x12cDDB96f233c7c4E67dA5F25f612a6f6Fa9Ac95",
    loanToken: {
      address: "0xA0b86991c6218b36c1d19D4a2e9Eb0cE3606eB48",
      symbol: "USDC",
    },
    collateralToken: {
      address: "0x09896Fed3a813E6c3512E455972CeCD8D703055a",
      symbol: "IB01.bt",
    },
  },
  {
    id: "0x92710b6ed467c5cf0797ca86104fe61aff6b22ecedad6534a1941aaf0584e705",
    name: "ezUSD / USDT",
    irm: "0x870aC11D48B15DB9a138Cf899d20F13F79Ba00BC",
    lltv: "915000000000000000",
    oracle: "0x8fFfFfd4AfB6115b954Bd326cbe7B4BA576818f6",
    loanToken: {
      address: "0x77B80F4ac4c6Cbb4982689749177349cf1635115",
      symbol: "ezUSD",
    },
    collateralToken: {
      address: "0xdAC17F958D2ee523a2206206994597C13D831ec7",
      symbol: "USDT",
    },
  },
  {
    id: "0x922b6e66275321a2991c25b4bd976281efbbf2799b5ec28d8e2d3aa1bd753072",
    name: "Fighting / Decipher",
    irm: "0x870aC11D48B15DB9a138Cf899d20F13F79Ba00BC",
    lltv: "915000000000000000",
    oracle: "0x1477e246c88a1F66bA9CCa2A17Dd1b1fbea31Be9",
    loanToken: {
      address: "0x660ee976951DcF061a9a7f77AA43eDf17Ede8015",
      symbol: "Fighting",
    },
    collateralToken: {
      address: "0x9b58b8a40Fd8Be64b5f8652b2CaE230D3987B369",
      symbol: "Decipher",
    },
  },
  {
    id: "0x90ed810f27e4c8f1f9331e0b576e653a563e68c6fb191f85e412d36a3517d525",
    name: "AUSD / PT-STRCx-27AUG2026",
    irm: "0x870aC11D48B15DB9a138Cf899d20F13F79Ba00BC",
    lltv: "915000000000000000",
    oracle: "0x5A3673A3224D4c22EAB938590C1B8F58bbA64522",
    loanToken: {
      address: "0x00000000eFE302BEAA2b3e6e1b18d08D69a9012a",
      symbol: "AUSD",
    },
    collateralToken: {
      address: "0x4ad88F62310D377c60F6B0c25Bde8011f315EeA7",
      symbol: "PT-STRCx-27AUG2026",
    },
  },
  {
    id: "0x908545e78f164344b664f34c9e8ac8d167977d2aa6428dbeab9e96cfa53c9744",
    name: "USDC / USTB",
    irm: "0x870aC11D48B15DB9a138Cf899d20F13F79Ba00BC",
    lltv: "860000000000000000",
    oracle: "0xDddd770BADd886dF3864029e4B377B5F6a2B6b83",
    loanToken: {
      address: "0xA0b86991c6218b36c1d19D4a2e9Eb0cE3606eB48",
      symbol: "USDC",
    },
    collateralToken: {
      address: "0x43415eB6ff9DB7E26A15b704e7A3eDCe97d31C4e",
      symbol: "USTB",
    },
  },
  {
    id: "0x9040b02d056d6e4a071497728982d00ebe7f83793c21e16a95b5995e3b40a1e2",
    name: "USDC / CHIM",
    irm: "0x870aC11D48B15DB9a138Cf899d20F13F79Ba00BC",
    lltv: "915000000000000000",
    oracle: "0x457be32C8191Eca31e83B18ff558a72480149820",
    loanToken: {
      address: "0xA0b86991c6218b36c1d19D4a2e9Eb0cE3606eB48",
      symbol: "USDC",
    },
    collateralToken: {
      address: "0x113C7f2465723DAb2FAa1155849Fa88Ac2267F43",
      symbol: "CHIM",
    },
  },
  {
    id: "0x8f4a3ff11b01b7eccc720733b22263fc775db80fd7943ce4e933f1c5c0b976cf",
    name: "lvWETH / lvstETH",
    irm: "0x870aC11D48B15DB9a138Cf899d20F13F79Ba00BC",
    lltv: "945000000000000000",
    oracle: "0x632527D0B2BcF053cc9B86BEfCc183b01df139a8",
    loanToken: {
      address: "0x948503419F0407Eaf7B3C0E7aB8F808543484Fe8",
      symbol: "lvWETH",
    },
    collateralToken: {
      address: "0x8350e622bd7Ddc332171EcF91e718ab534E9beCE",
      symbol: "lvstETH",
    },
  },
  {
    id: "0x8f43d05bc822c0ce96ee6187ce7bebbcbee19ea600d8b29d0cf94317fb3eed7b",
    name: "AUSD / reUSD",
    irm: "0x870aC11D48B15DB9a138Cf899d20F13F79Ba00BC",
    lltv: "965000000000000000",
    oracle: "0xA66a4F03Fd8031973f8C7718904ce32385f54E70",
    loanToken: {
      address: "0x00000000eFE302BEAA2b3e6e1b18d08D69a9012a",
      symbol: "AUSD",
    },
    collateralToken: {
      address: "0x5086bf358635B81D8C47C66d1C8b9E567Db70c72",
      symbol: "reUSD",
    },
  },
  {
    id: "0x8f309d4b3066f80574810ed249472ba0ea1272e10834ae10dafa9f4f41aa63f4",
    name: "frxUSD / USP",
    irm: "0x870aC11D48B15DB9a138Cf899d20F13F79Ba00BC",
    lltv: "860000000000000000",
    oracle: "0x98Dd32A7Bc0a5e3c3C0179FAC9DCD523AF55b433",
    loanToken: {
      address: "0xCAcd6fd266aF91b8AeD52aCCc382b4e165586E29",
      symbol: "frxUSD",
    },
    collateralToken: {
      address: "0x098697bA3Fee4eA76294C5d6A466a4e3b3E95FE6",
      symbol: "USP",
    },
  },
  {
    id: "0x8efb1e67e7f02e15af8ca7e7dc4eb7a1fe99ad3d7f53c110a89daeaa52e9f7b0",
    name: "waEthUSDC / gtusdcp",
    irm: "0x870aC11D48B15DB9a138Cf899d20F13F79Ba00BC",
    lltv: "945000000000000000",
    oracle: "0x1a108B57E05f3BEadE9301a7E57fFC747298240E",
    loanToken: {
      address: "0xD4fa2D31b7968E448877f69A96DE69f5de8cD23E",
      symbol: "waEthUSDC",
    },
    collateralToken: {
      address: "0x8c106EEDAd96553e64287A5A6839c3Cc78afA3D0",
      symbol: "gtusdcp",
    },
  },
  {
    id: "0x8ef93964d88388b6421543bcadc5a3e95bfd1412166ea184303bc6b71d44e684",
    name: "tGBP / XAUt",
    irm: "0x870aC11D48B15DB9a138Cf899d20F13F79Ba00BC",
    lltv: "770000000000000000",
    oracle: "0x7a70163B27a6BF43a8c2e43f9588935A98B5EFD3",
    loanToken: {
      address: "0x27f6c8289550fCE67f6B50BeD1F519966aFE5287",
      symbol: "tGBP",
    },
    collateralToken: {
      address: "0x68749665FF8D2d112Fa859AA293F07A622782F38",
      symbol: "XAUt",
    },
  },
  {
    id: "0x8ed44f0370f077e44f745df3dc6307415a69efb6fcd818f53f8e5b8518eece99",
    name: "USR / PT-USR-4DEC2025",
    irm: "0x870aC11D48B15DB9a138Cf899d20F13F79Ba00BC",
    lltv: "915000000000000000",
    oracle: "0x7819203CB3b2c32e44Ef11F69be6ed3D6ffaDEA0",
    loanToken: {
      address: "0x66a1E37c9b0eAddca17d3662D6c05F4DECf3e110",
      symbol: "USR",
    },
    collateralToken: {
      address: "0x23e0D07095DAec91B6Ae016cA9F08222dCc64c49",
      symbol: "PT-USR-4DEC2025",
    },
  },
  {
    id: "0x8ecb30551f50b3a67c784357c7df1f3407c4ae3c8197fe3473bddf6fa84a5825",
    name: "LBTC / WBTC",
    irm: "0x870aC11D48B15DB9a138Cf899d20F13F79Ba00BC",
    lltv: "945000000000000000",
    oracle: "0x23B18136c2E1AFaD3e3c6652Ada24F14252eb147",
    loanToken: {
      address: "0x8236a87084f8B84306f72007F36F2618A5634494",
      symbol: "LBTC",
    },
    collateralToken: {
      address: "0x2260FAC5E5542a773Aa44fBCfeDf7C193bc2C599",
      symbol: "WBTC",
    },
  },
  {
    id: "0x8ec7dfedc1d46378df8fac0ce8f5d1d82b5cc1b05148951f54315608f163f7ca",
    name: "USDC / USDCsUSDat",
    irm: "0x870aC11D48B15DB9a138Cf899d20F13F79Ba00BC",
    lltv: "860000000000000000",
    oracle: "0x31fB36CaEAdf52501A612d9079a17A01EeD615e6",
    loanToken: {
      address: "0xA0b86991c6218b36c1d19D4a2e9Eb0cE3606eB48",
      symbol: "USDC",
    },
    collateralToken: {
      address: "0x6206cA315c2fCDd2A857b47EFB285AA12c529a7a",
      symbol: "USDCsUSDat",
    },
  },
  {
    id: "0x8ebcaf72c7cd75e8c621ec77ec343b3152c48908c4a6e217da82fe6af23c1928",
    name: "lvlUSD / PT-slvlUSD-25SEP2025",
    irm: "0x870aC11D48B15DB9a138Cf899d20F13F79Ba00BC",
    lltv: "915000000000000000",
    oracle: "0xDAeb58A601c4793667e0B0F67815cd952E752E0B",
    loanToken: {
      address: "0x7C1156E515aA1A2E851674120074968C905aAF37",
      symbol: "lvlUSD",
    },
    collateralToken: {
      address: "0x2CA5f2C4300450D53214B00546795c1c07B89acB",
      symbol: "PT-slvlUSD-25SEP2025",
    },
  },
  {
    id: "0x8e4e9609472623039519bbf1b8166d12eca99f1d4a65bd344214414398aea6ca",
    name: "lvWETH / lvstETH",
    irm: "0x870aC11D48B15DB9a138Cf899d20F13F79Ba00BC",
    lltv: "945000000000000000",
    oracle: "0x5aEb8e5BE27f8EBc8BF2F6256c59e5221E7466B8",
    loanToken: {
      address: "0x5356fB835c247AbaC68d9Ab20321fAf1D3A36575",
      symbol: "lvWETH",
    },
    collateralToken: {
      address: "0xf979EA3bd92f825bB6C798631e763c7162A16394",
      symbol: "lvstETH",
    },
  },
  {
    id: "0x8e0e3f0f5832de87cb879c3f1801a7801981cc0d97838f74ed18db6b882593a5",
    name: "yvCurve-yYB-f / crvUSD",
    irm: "0x870aC11D48B15DB9a138Cf899d20F13F79Ba00BC",
    lltv: "770000000000000000",
    oracle: "0x6D56F12000Ff15B4508CD3E024e6840781a9FAe8",
    loanToken: {
      address: "0x0844C227b892be5d7c837000C096f64bFc316c2d",
      symbol: "yvCurve-yYB-f",
    },
    collateralToken: {
      address: "0xf939E0A03FB07F59A73314E73794Be0E57ac1b4E",
      symbol: "crvUSD",
    },
  },
  {
    id: "0x8d6e42d1785e4ae5e69ba9d4547a4483ee1a5febc303931e92a24067ae04e746",
    name: "AUSD / cbBTC",
    irm: "0x870aC11D48B15DB9a138Cf899d20F13F79Ba00BC",
    lltv: "860000000000000000",
    oracle: "0x0acdC416C592a592Edf2E64b178aA8d4d47e05A8",
    loanToken: {
      address: "0x00000000eFE302BEAA2b3e6e1b18d08D69a9012a",
      symbol: "AUSD",
    },
    collateralToken: {
      address: "0xcbB7C0000aB88B473b1f5aFd9ef808440eed33Bf",
      symbol: "cbBTC",
    },
  },
  {
    id: "0x8d52fdd5b40a132d4ec16ccd3ff6f4cc8f992911f2c7987cd59c3284eedabef4",
    name: "USDC / PT-USDG-28MAY2026",
    irm: "0x870aC11D48B15DB9a138Cf899d20F13F79Ba00BC",
    lltv: "945000000000000000",
    oracle: "0x8A01940D89CF95D9F6e92a90B17C0Ca5C953fE73",
    loanToken: {
      address: "0xA0b86991c6218b36c1d19D4a2e9Eb0cE3606eB48",
      symbol: "USDC",
    },
    collateralToken: {
      address: "0x9db38D74a0D29380899aD354121DfB521aDb0548",
      symbol: "PT-USDG-28MAY2026",
    },
  },
  {
    id: "0x8d18658cd2688b702222c11467133c1c2237bd058ba2467e47bc360067ebe038",
    name: "wUSDL / cbBTC",
    irm: "0x870aC11D48B15DB9a138Cf899d20F13F79Ba00BC",
    lltv: "860000000000000000",
    oracle: "0x72EeFF006E96C20aA00e72aC552f35EB9eE836bB",
    loanToken: {
      address: "0x7751E2F4b8ae93EF6B79d86419d42FE3295A4559",
      symbol: "wUSDL",
    },
    collateralToken: {
      address: "0xcbB7C0000aB88B473b1f5aFd9ef808440eed33Bf",
      symbol: "cbBTC",
    },
  },
  {
    id: "0x8cdb63a27a48ac27fadc0f158a732104bcc4e10bb61c9a5095ea7c127204e26c",
    name: "USDS / PT-USDe-27NOV2025",
    irm: "0x870aC11D48B15DB9a138Cf899d20F13F79Ba00BC",
    lltv: "915000000000000000",
    oracle: "0x52A34E1D7Cb12c70DaF0e8bdeb91E1d02deEf97d",
    loanToken: {
      address: "0xdC035D45d973E3EC169d2276DDab16f1e407384F",
      symbol: "USDS",
    },
    collateralToken: {
      address: "0x62C6E813b9589C3631Ba0Cdb013acdB8544038B7",
      symbol: "PT-USDe-27NOV2025",
    },
  },
  {
    id: "0x8c708ffa8377bd3131aedd15f2eccb9e2243d7daeeeb9a7dc5132ae329ddbb86",
    name: "USDC / PT-sUSDE-27FEB2025",
    irm: "0x870aC11D48B15DB9a138Cf899d20F13F79Ba00BC",
    lltv: "915000000000000000",
    oracle: "0x73a3387768306bE3994c57445Eec893bB5B64b0f",
    loanToken: {
      address: "0xA0b86991c6218b36c1d19D4a2e9Eb0cE3606eB48",
      symbol: "USDC",
    },
    collateralToken: {
      address: "0x386AE941D4262B0Ee96354499dF2ab8442734EC0",
      symbol: "PT-sUSDE-27FEB2025",
    },
  },
  {
    id: "0x8be9d9888d68083a58216fe1cd3254dc35b9e919f3131dae50b80f787e901a71",
    name: "USDC / weETH",
    irm: "0x870aC11D48B15DB9a138Cf899d20F13F79Ba00BC",
    lltv: "770000000000000000",
    oracle: "0x57028ECa448fb11b9911c6F7bA0b4f82eaa23d57",
    loanToken: {
      address: "0xA0b86991c6218b36c1d19D4a2e9Eb0cE3606eB48",
      symbol: "USDC",
    },
    collateralToken: {
      address: "0xCd5fE23C85820F7B72D0926FC9b05b43E359b7ee",
      symbol: "weETH",
    },
  },
  {
    id: "0x8bafbc117fd372bea5b96e96ed493932c6b1a5f721312d3895cd12fafdc844ca",
    name: "USDQ / XAUt",
    irm: "0x870aC11D48B15DB9a138Cf899d20F13F79Ba00BC",
    lltv: "770000000000000000",
    oracle: "0xc7d1FE3fBe90e8f755250CA3Ce4d2aE50873d9dc",
    loanToken: {
      address: "0xc83e27f270cce0A3A3A29521173a83F402c1768b",
      symbol: "USDQ",
    },
    collateralToken: {
      address: "0x68749665FF8D2d112Fa859AA293F07A622782F38",
      symbol: "XAUt",
    },
  },
  {
    id: "0x8b9e61d02f1937c22ec43ff02a04ad94abf16bdf08bf161ae04c30581b354860",
    name: "WETH / brETH",
    irm: "0x870aC11D48B15DB9a138Cf899d20F13F79Ba00BC",
    lltv: "945000000000000000",
    oracle: "0xf3e2bbD29503dcC734102eeb570e4598Ad817280",
    loanToken: {
      address: "0xC02aaA39b223FE8D0A0e5C4F27eAD9083C756Cc2",
      symbol: "WETH",
    },
    collateralToken: {
      address: "0x3588e6Cb5DCa99E35bA2E2a5D42cdDb46365e71B",
      symbol: "brETH",
    },
  },
  {
    id: "0x8b01286c2c38d7d9fcdb14ab71d9a86b231f56a3f741ddf4e763d181eb6d9072",
    name: "USDC / splDXY-BEAR",
    irm: "0x870aC11D48B15DB9a138Cf899d20F13F79Ba00BC",
    lltv: "915000000000000000",
    oracle: "0x7e22eEc2506aE777b5093F030de69dF04b2c4c93",
    loanToken: {
      address: "0xA0b86991c6218b36c1d19D4a2e9Eb0cE3606eB48",
      symbol: "USDC",
    },
    collateralToken: {
      address: "0x4f7310E8bDa646A7DA4b8F1bBE83073380C5Dc53",
      symbol: "splDXY-BEAR",
    },
  },
  {
    id: "0x8a8650a5ed923712ca86a9b83bd12ea520131c646c4da5de3a443416e1bb8c98",
    name: "FRAX / sUSDe",
    irm: "0x870aC11D48B15DB9a138Cf899d20F13F79Ba00BC",
    lltv: "915000000000000000",
    oracle: "0x5D916980D5Ae1737a8330Bf24dF812b2911Aae25",
    loanToken: {
      address: "0x853d955aCEf822Db058eb8505911ED77F175b99e",
      symbol: "FRAX",
    },
    collateralToken: {
      address: "0x9D39A5DE30e57443BfF2A8307A4256c8797A3497",
      symbol: "sUSDe",
    },
  },
  {
    id: "0x8a436b87576269695131901667ef3d373947b8880d3facca3c31c4c383e28bb6",
    name: "alphaFraxUSDenhanced / PT-avUSD-14MAY2026",
    irm: "0x870aC11D48B15DB9a138Cf899d20F13F79Ba00BC",
    lltv: "915000000000000000",
    oracle: "0x611871C21452fa7c1c9e3306EDbdfE94AC061d8F",
    loanToken: {
      address: "0xd8CD72A2eB7A4312404C00AeD5172C0026da0C27",
      symbol: "alphaFraxUSDenhanced",
    },
    collateralToken: {
      address: "0xcc16Cd49194e7AA3DCa780c742580e2f9b418874",
      symbol: "PT-avUSD-14MAY2026",
    },
  },
  {
    id: "0x89f95c4e891ba644ab44a924cbb478ffa86f3b7a2e928320718ecbbbe02df02f",
    name: "USDC / unknown",
    irm: "0x870aC11D48B15DB9a138Cf899d20F13F79Ba00BC",
    lltv: "860000000000000000",
    oracle: "0x3F15979913C6ac4e3495BBD53fe37E1e42811516",
    loanToken: {
      address: "0xA0b86991c6218b36c1d19D4a2e9Eb0cE3606eB48",
      symbol: "USDC",
    },
    collateralToken: {
      address: "0x84B78Bc998E4B1a63F2CF9EbfE76C55FC96a5A9b",
      symbol: "unknown",
    },
  },
  {
    id: "0x896111ed91a5ae232f98193b453fae1eb6670ce504e228636b7d0baae23fd52d",
    name: "sUSDS / PT-sUSDE-31JUL2025",
    irm: "0x870aC11D48B15DB9a138Cf899d20F13F79Ba00BC",
    lltv: "915000000000000000",
    oracle: "0x96F4357692aa35aA986bBefD19C68B89f1D14304",
    loanToken: {
      address: "0xa3931d71877C0E7a3148CB7Eb4463524FEc27fbD",
      symbol: "sUSDS",
    },
    collateralToken: {
      address: "0x3b3fB9C57858EF816833dC91565EFcd85D96f634",
      symbol: "PT-sUSDE-31JUL2025",
    },
  },
  {
    id: "0x88d720d2c07060d3152b3a3d81e40fc36a00b11b5fb62d8968c7f97234491759",
    name: "USDC / WBTC",
    irm: "0x870aC11D48B15DB9a138Cf899d20F13F79Ba00BC",
    lltv: "860000000000000000",
    oracle: "0x2954ed04B5E1634DBA3d9CAbE5bd23273BCBF2bF",
    loanToken: {
      address: "0xA0b86991c6218b36c1d19D4a2e9Eb0cE3606eB48",
      symbol: "USDC",
    },
    collateralToken: {
      address: "0x2260FAC5E5542a773Aa44fBCfeDf7C193bc2C599",
      symbol: "WBTC",
    },
  },
  {
    id: "0x8868527fb91cd74fe89dd3167a9261b0e507b7a03863a225596d5fff65d9f71d",
    name: "USDz / PT-sUSDE-24OCT2024",
    irm: "0x870aC11D48B15DB9a138Cf899d20F13F79Ba00BC",
    lltv: "965000000000000000",
    oracle: "0xaE4750d0813B5E37A51f7629beedd72AF1f9cA35",
    loanToken: {
      address: "0x69000405f9DcE69BD4Cbf4f2865b79144A69BFE0",
      symbol: "USDz",
    },
    collateralToken: {
      address: "0xAE5099C39f023C91d3dd55244CAFB36225B0850E",
      symbol: "PT-sUSDE-24OCT2024",
    },
  },
  {
    id: "0x8859b5f3817689dd74718330b131c6a7164fcf1e04a8cb3742f2259a3ad2bf7d",
    name: "sUSDS / wstETH",
    irm: "0x870aC11D48B15DB9a138Cf899d20F13F79Ba00BC",
    lltv: "860000000000000000",
    oracle: "0x2Ab7F9E3b7285147D4FE9062d9fC8E63e7bb0d8F",
    loanToken: {
      address: "0xa3931d71877C0E7a3148CB7Eb4463524FEc27fbD",
      symbol: "sUSDS",
    },
    collateralToken: {
      address: "0x7f39C581F595B53c5cb19bD0b3f8dA6c935E2Ca0",
      symbol: "wstETH",
    },
  },
  {
    id: "0x87e3786114cbe9d3fcace0eb4099fa70a4b916039db4a29626cae89147180ca3",
    name: "frxUSD / unknown",
    irm: "0x870aC11D48B15DB9a138Cf899d20F13F79Ba00BC",
    lltv: "945000000000000000",
    oracle: "0xF694F0EE087d849DB66d14793f6508a794a02746",
    loanToken: {
      address: "0xCAcd6fd266aF91b8AeD52aCCc382b4e165586E29",
      symbol: "frxUSD",
    },
    collateralToken: {
      address: "0xdA36Ab65d5Af53763CAcD63AE7D441932032326f",
      symbol: "unknown",
    },
  },
  {
    id: "0x87cc83250092ba9b9d30160ef18edb2dc36b6bd18e3fe6e4846d6a72fd8864e0",
    name: "JPYC / wstETH",
    irm: "0x870aC11D48B15DB9a138Cf899d20F13F79Ba00BC",
    lltv: "625000000000000000",
    oracle: "0x27529F9dae7C5919c3e2EB5c59112057bAd3883f",
    loanToken: {
      address: "0xE7C3D8C9a439feDe00D2600032D5dB0Be71C3c29",
      symbol: "JPYC",
    },
    collateralToken: {
      address: "0x7f39C581F595B53c5cb19bD0b3f8dA6c935E2Ca0",
      symbol: "wstETH",
    },
  },
  {
    id: "0x86b1df5fee1615791a2c3241b2b9b0a42315eea73f00ab830ff7583260a01f85",
    name: "USDC / ysUSDS",
    irm: "0x870aC11D48B15DB9a138Cf899d20F13F79Ba00BC",
    lltv: "965000000000000000",
    oracle: "0x0D35Db0928127195990D03E6A6788FA6cc592b06",
    loanToken: {
      address: "0xA0b86991c6218b36c1d19D4a2e9Eb0cE3606eB48",
      symbol: "USDC",
    },
    collateralToken: {
      address: "0x4cE9c93513DfF543Bc392870d57dF8C04e89Ba0a",
      symbol: "ysUSDS",
    },
  },
  {
    id: "0x85189e96de72073e33cf8680c4990da0495cc993f49d56d24dfd79fc2627eae6",
    name: "USDC / CRNC",
    irm: "0x870aC11D48B15DB9a138Cf899d20F13F79Ba00BC",
    lltv: "385000000000000000",
    oracle: "0xA1DF54C44298AA5eC9aC8FeD8310aC1775fEa12B",
    loanToken: {
      address: "0xA0b86991c6218b36c1d19D4a2e9Eb0cE3606eB48",
      symbol: "USDC",
    },
    collateralToken: {
      address: "0x47d13Fb0803409c7fE169A210d4e906165F1A432",
      symbol: "CRNC",
    },
  },
  {
    id: "0x85114b25eef88f5cb19b190f01702e62d41a4ea91960d198a27addc2c11915a3",
    name: "crvUSD / ",
    irm: "0x870aC11D48B15DB9a138Cf899d20F13F79Ba00BC",
    lltv: "860000000000000000",
    oracle: "0xd7111130e2Aac93b18120aa0CDbd03239052B0CC",
    loanToken: {
      address: "0xf939E0A03FB07F59A73314E73794Be0E57ac1b4E",
      symbol: "crvUSD",
    },
    collateralToken: {
      address: "0x19f8F160F4d0077d8527324544B5c68E883Dd592",
      symbol: "",
    },
  },
  {
    id: "0x84dc1d2f50afc19a8755f67f6388e99b2d3aca73522024cd846757f83c3976f0",
    name: "alphaForexV2 / USP",
    irm: "0x870aC11D48B15DB9a138Cf899d20F13F79Ba00BC",
    lltv: "860000000000000000",
    oracle: "0x5096642B7c7CD82198932f3FADd873EC2fcDeb6d",
    loanToken: {
      address: "0x153Bd1abE60104Bd46aa05a27fA12D1346D64A57",
      symbol: "alphaForexV2",
    },
    collateralToken: {
      address: "0x098697bA3Fee4eA76294C5d6A466a4e3b3E95FE6",
      symbol: "USP",
    },
  },
  {
    id: "0x84d0c5c07b5dc83710d3922a7eba2b03f3a3e78cea72556633433bd1b4304e36",
    name: "crvUSD / ",
    irm: "0x870aC11D48B15DB9a138Cf899d20F13F79Ba00BC",
    lltv: "860000000000000000",
    oracle: "0x20c4fA59f032bEC6de1905B7201CB88DFD968abA",
    loanToken: {
      address: "0xf939E0A03FB07F59A73314E73794Be0E57ac1b4E",
      symbol: "crvUSD",
    },
    collateralToken: {
      address: "0x385E12cf4040543Bc8C18e05C1298Be5B04f3f5e",
      symbol: "",
    },
  },
  {
    id: "0x84c5a39c655a7adb0fadee7a78dd8891906f8e1d639b3557e1c551e843777fd0",
    name: "USDC / CASH+",
    irm: "0x870aC11D48B15DB9a138Cf899d20F13F79Ba00BC",
    lltv: "625000000000000000",
    oracle: "0xc48144A2d40B764cf9D63947E64403990631840c",
    loanToken: {
      address: "0xA0b86991c6218b36c1d19D4a2e9Eb0cE3606eB48",
      symbol: "USDC",
    },
    collateralToken: {
      address: "0x498D9329555471bF6073A5f2D047F746d522A373",
      symbol: "CASH+",
    },
  },
  {
    id: "0x8431ee2659113aa76739b507fdfaa0bd07b450ea4dfd78919bb22d67f5f34d95",
    name: "WBTC / LBTC",
    irm: "0x870aC11D48B15DB9a138Cf899d20F13F79Ba00BC",
    lltv: "915000000000000000",
    oracle: "0xAe12416c1F21B0698c27fe042D9309C83baC6597",
    loanToken: {
      address: "0x2260FAC5E5542a773Aa44fBCfeDf7C193bc2C599",
      symbol: "WBTC",
    },
    collateralToken: {
      address: "0x8236a87084f8B84306f72007F36F2618A5634494",
      symbol: "LBTC",
    },
  },
  {
    id: "0x8398104e6c0dfa0a5aacee488310c5a52ec8c68fde2d57fd5cd32e9ddf39a142",
    name: "USDA / gtUSDCcore",
    irm: "0x870aC11D48B15DB9a138Cf899d20F13F79Ba00BC",
    lltv: "945000000000000000",
    oracle: "0xBDbbe1eb5A99531796C8d04787F898Ce5dBF2C8b",
    loanToken: {
      address: "0x0000206329b97DB379d5E1Bf586BbDB969C63274",
      symbol: "USDA",
    },
    collateralToken: {
      address: "0x8eB67A509616cd6A7c1B3c8C21D48FF57df3d458",
      symbol: "gtUSDCcore",
    },
  },
  {
    id: "0x838a937e132a2801dc5749d46d56af31846f4a0ee1d75619c4ff3310782bc98f",
    name: "USDf / sUSDf",
    irm: "0x870aC11D48B15DB9a138Cf899d20F13F79Ba00BC",
    lltv: "945000000000000000",
    oracle: "0x6f397fA3eCed7d3e689f262C36E219768Ae42eAF",
    loanToken: {
      address: "0xFa2B947eEc368f42195f24F36d2aF29f7c24CeC2",
      symbol: "USDf",
    },
    collateralToken: {
      address: "0xc8CF6D7991f15525488b2A83Df53468D682Ba4B0",
      symbol: "sUSDf",
    },
  },
  {
    id: "0x83847a159bd310d3da8f5b502096bbd58e65f786ac967783f71bdf18c93ce951",
    name: "tGBP / steakUSDC",
    irm: "0x870aC11D48B15DB9a138Cf899d20F13F79Ba00BC",
    lltv: "915000000000000000",
    oracle: "0x0Cd0026370C08A4D0f3376d60D8E376FeF66FD5c",
    loanToken: {
      address: "0x27f6c8289550fCE67f6B50BeD1F519966aFE5287",
      symbol: "tGBP",
    },
    collateralToken: {
      address: "0xbeef088055857739C12CD3765F20b7679Def0f51",
      symbol: "steakUSDC",
    },
  },
  {
    id: "0x836fa462acbf5d5f7198c23bdd29b421b8deba4ae9772aa0bf6796e0b402acfb",
    name: "rUSD / jUSD",
    irm: "0x870aC11D48B15DB9a138Cf899d20F13F79Ba00BC",
    lltv: "915000000000000000",
    oracle: "0x206e1c82f3340543513Fc7929ceC5E77927dd9a7",
    loanToken: {
      address: "0x09D4214C03D01F49544C0448DBE3A27f768F2b34",
      symbol: "rUSD",
    },
    collateralToken: {
      address: "0x000000096CB3D4007fC2b79b935C4540C5c2d745",
      symbol: "jUSD",
    },
  },
  {
    id: "0x834d7c40bfcc86c8672f96cb4d8c04aa9a6caa52fb9172be2401fa359ece195e",
    name: "USDC / PT-srUSDe-2APR2026",
    irm: "0x870aC11D48B15DB9a138Cf899d20F13F79Ba00BC",
    lltv: "915000000000000000",
    oracle: "0xb847B24b5D13C3F67347005c9B57074b01978bAA",
    loanToken: {
      address: "0xA0b86991c6218b36c1d19D4a2e9Eb0cE3606eB48",
      symbol: "USDC",
    },
    collateralToken: {
      address: "0x9Bf45ab47747F4B4dD09B3C2c73953484b4eB375",
      symbol: "PT-srUSDe-2APR2026",
    },
  },
  {
    id: "0x82053fe2fc3a3d6cb856458948e9c3589e76f20f3a2079606739b517587267ce",
    name: "EURCV / cbBTC",
    irm: "0x870aC11D48B15DB9a138Cf899d20F13F79Ba00BC",
    lltv: "860000000000000000",
    oracle: "0xbA75FD248bF33D669D4c5Adf25d3e32779656E47",
    loanToken: {
      address: "0x5F7827FDeb7c20b443265Fc2F40845B715385Ff2",
      symbol: "EURCV",
    },
    collateralToken: {
      address: "0xcbB7C0000aB88B473b1f5aFd9ef808440eed33Bf",
      symbol: "cbBTC",
    },
  },
  {
    id: "0x81b97c7305aca46c62f2ffce63a09c6a4d647163e25f31c44fadcbeab838b3f8",
    name: "USDS / BITCOIN",
    irm: "0x870aC11D48B15DB9a138Cf899d20F13F79Ba00BC",
    lltv: "770000000000000000",
    oracle: "0xD131B09707A4a9D7Ce7c74D454d6Ae335e9955Fd",
    loanToken: {
      address: "0xdC035D45d973E3EC169d2276DDab16f1e407384F",
      symbol: "USDS",
    },
    collateralToken: {
      address: "0x72e4f9F808C49A2a61dE9C5896298920Dc4EEEa9",
      symbol: "BITCOIN",
    },
  },
  {
    id: "0x8126619a27fb94ca660e86b9efd4c068545c652a677b2f2423b93ed4d7940042",
    name: "wNXM / stNXM",
    irm: "0x870aC11D48B15DB9a138Cf899d20F13F79Ba00BC",
    lltv: "625000000000000000",
    oracle: "0x3ce04FFcFa90653e932578345e70905D4768112C",
    loanToken: {
      address: "0x0d438F3b5175Bebc262bF23753C1E53d03432bDE",
      symbol: "wNXM",
    },
    collateralToken: {
      address: "0x5B423e07dFBA087D72840851F63A51CBe1967CdA",
      symbol: "stNXM",
    },
  },
  {
    id: "0x7fe29ba3e86fc34b6442cb72ca127834dc7e0d3a18e82d25c3e46cdddbe0ee4f",
    name: "xCVX / xETH",
    irm: "0x870aC11D48B15DB9a138Cf899d20F13F79Ba00BC",
    lltv: "770000000000000000",
    oracle: "0x4ef4f2826FD7AcDC1b31ffc206677d11295a6Bc5",
    loanToken: {
      address: "0xB90D347e10a085B591955Cbd0603aC7866fCADC8",
      symbol: "xCVX",
    },
    collateralToken: {
      address: "0xe063F04f280c60aECa68b38341C2eEcBeC703ae2",
      symbol: "xETH",
    },
  },
  {
    id: "0x7f4668f71977ff4cd26a150804a4d923f14087dee155a48ac5cf28cdfd1f422d",
    name: "tBTC / cbBTC",
    irm: "0x870aC11D48B15DB9a138Cf899d20F13F79Ba00BC",
    lltv: "945000000000000000",
    oracle: "0xeff0fC7BE808016c85ef2beddc615C5e11F43990",
    loanToken: {
      address: "0x18084fbA666a33d37592fA2633fD49a74DD93a88",
      symbol: "tBTC",
    },
    collateralToken: {
      address: "0xcbB7C0000aB88B473b1f5aFd9ef808440eed33Bf",
      symbol: "cbBTC",
    },
  },
  {
    id: "0x7f3b4717b21cb212b4ba62318c3bc6e0af352f8ad8ea93344dcbab1d865de4ee",
    name: "lvWETH / lvstETH",
    irm: "0x870aC11D48B15DB9a138Cf899d20F13F79Ba00BC",
    lltv: "945000000000000000",
    oracle: "0x73dE0263D5733ac7a510Eed88c320930d7A6525d",
    loanToken: {
      address: "0xFd7c67aF5b7b062694428ded7EF71ee3Ef320208",
      symbol: "lvWETH",
    },
    collateralToken: {
      address: "0xB0a3b2aC55d6DA18Fe56120D47774dF567f675ac",
      symbol: "lvstETH",
    },
  },
  {
    id: "0x7f2eec1f78d0412e61fa3be531e36052460583e7f9b5c1efc1407f10c48a775d",
    name: "USDA / gtUSDC",
    irm: "0x870aC11D48B15DB9a138Cf899d20F13F79Ba00BC",
    lltv: "860000000000000000",
    oracle: "0x3B8c4A340336941524DE276FF730b3Be71157B55",
    loanToken: {
      address: "0x0000206329b97DB379d5E1Bf586BbDB969C63274",
      symbol: "USDA",
    },
    collateralToken: {
      address: "0xdd0f28e19C1780eb6396170735D45153D261490d",
      symbol: "gtUSDC",
    },
  },
  {
    id: "0x7f19e51fac2041007562f61923bd05d61b6374cbdaef517831b77ccc7457085d",
    name: "USDe / PT-eUSDE-14AUG2025",
    irm: "0x870aC11D48B15DB9a138Cf899d20F13F79Ba00BC",
    lltv: "915000000000000000",
    oracle: "0x89703C1bedC64B0B740c5af8bF634745b7B5d863",
    loanToken: {
      address: "0x4c9EDD5852cd905f086C759E8383e09bff1E68B3",
      symbol: "USDe",
    },
    collateralToken: {
      address: "0x14Bdc3A3AE09f5518b923b69489CBcAfB238e617",
      symbol: "PT-eUSDE-14AUG2025",
    },
  },
  {
    id: "0x7ebe56009de21641961b3a1deefc3677f1c81cd69ddf1dcceed29dc66bd3b33b",
    name: "DAI / ysUSDS",
    irm: "0x870aC11D48B15DB9a138Cf899d20F13F79Ba00BC",
    lltv: "980000000000000000",
    oracle: "0x70b4C99a2002950aceDdEeCEC718C83f3d5eD3e8",
    loanToken: {
      address: "0x6B175474E89094C44Da98b954EedeAC495271d0F",
      symbol: "DAI",
    },
    collateralToken: {
      address: "0x4cE9c93513DfF543Bc392870d57dF8C04e89Ba0a",
      symbol: "ysUSDS",
    },
  },
  {
    id: "0x7e85f2429c67cca7ef7a6e75fef2cb68e3a4d8500ee4b303317a4f15ba55bbba",
    name: "MUSD / tBTC",
    irm: "0x870aC11D48B15DB9a138Cf899d20F13F79Ba00BC",
    lltv: "860000000000000000",
    oracle: "0x9A3108e83f543B43c896744210377Bc94e4Ab1dd",
    loanToken: {
      address: "0xdD468A1DDc392dcdbEf6db6e34E89AA338F9F186",
      symbol: "MUSD",
    },
    collateralToken: {
      address: "0x18084fbA666a33d37592fA2633fD49a74DD93a88",
      symbol: "tBTC",
    },
  },
  {
    id: "0x7e72f1671f1fd2c0900b6ef8bb6b55299d6a58fd398e3b8e05c12e3c429c401b",
    name: "FRAX / sUSDe",
    irm: "0x870aC11D48B15DB9a138Cf899d20F13F79Ba00BC",
    lltv: "860000000000000000",
    oracle: "0x5D916980D5Ae1737a8330Bf24dF812b2911Aae25",
    loanToken: {
      address: "0x853d955aCEf822Db058eb8505911ED77F175b99e",
      symbol: "FRAX",
    },
    collateralToken: {
      address: "0x9D39A5DE30e57443BfF2A8307A4256c8797A3497",
      symbol: "sUSDe",
    },
  },
  {
    id: "0x7de72f6f56d7c74ece0556a7497ce8e0075f58384ff86af4a3bc153927cee2f9",
    name: "USDC / JAB78",
    irm: "0x870aC11D48B15DB9a138Cf899d20F13F79Ba00BC",
    lltv: "860000000000000000",
    oracle: "0xb8d3267Ff95f17474DC97B2D627744EB7222E719",
    loanToken: {
      address: "0xA0b86991c6218b36c1d19D4a2e9Eb0cE3606eB48",
      symbol: "USDC",
    },
    collateralToken: {
      address: "0xC04619cC040254b553439a7e4803355fFA9D7A6f",
      symbol: "JAB78",
    },
  },
  {
    id: "0x7ddde63e40deefdd5940120f58f88be7a4d11e709335a2024e3b616afbdf7120",
    name: "USDC / syrupUSDC",
    irm: "0x870aC11D48B15DB9a138Cf899d20F13F79Ba00BC",
    lltv: "915000000000000000",
    oracle: "0x4F570BcEaC722f277c5BAAA374D4D69AC095Cd46",
    loanToken: {
      address: "0xA0b86991c6218b36c1d19D4a2e9Eb0cE3606eB48",
      symbol: "USDC",
    },
    collateralToken: {
      address: "0x80ac24aA929eaF5013f6436cdA2a7ba190f5Cc0b",
      symbol: "syrupUSDC",
    },
  },
  {
    id: "0x7cf74de9cfcb48b680515f9137fae9fcd7071be92988e3e35089b29e715b6c07",
    name: "AUSD / WBTC",
    irm: "0x870aC11D48B15DB9a138Cf899d20F13F79Ba00BC",
    lltv: "860000000000000000",
    oracle: "0x032F1C64899b2C89835E51aCeD9434b0aDEaA69d",
    loanToken: {
      address: "0x00000000eFE302BEAA2b3e6e1b18d08D69a9012a",
      symbol: "AUSD",
    },
    collateralToken: {
      address: "0x2260FAC5E5542a773Aa44fBCfeDf7C193bc2C599",
      symbol: "WBTC",
    },
  },
  {
    id: "0x7c64f8e743029ccc41ed415e348b2904bdacffc1eb71ec3e206c12a3cef1ca05",
    name: "AUSD / cbBTC",
    irm: "0x870aC11D48B15DB9a138Cf899d20F13F79Ba00BC",
    lltv: "860000000000000000",
    oracle: "0x9F983115741D0F7F2EAE07831415057AD3de34d2",
    loanToken: {
      address: "0x00000000eFE302BEAA2b3e6e1b18d08D69a9012a",
      symbol: "AUSD",
    },
    collateralToken: {
      address: "0xcbB7C0000aB88B473b1f5aFd9ef808440eed33Bf",
      symbol: "cbBTC",
    },
  },
  {
    id: "0x7bf57130cf88dcfe052a4cfd6c7cce28ec7d0be7264f2a6b8a3b3f1b2fb02494",
    name: "cbBTC / PT-corn-SolvBTC.BBN-26DEC2024",
    irm: "0x870aC11D48B15DB9a138Cf899d20F13F79Ba00BC",
    lltv: "915000000000000000",
    oracle: "0x309b563107f6AfBEa888acF1E1BffE0dB8a8d08B",
    loanToken: {
      address: "0xcbB7C0000aB88B473b1f5aFd9ef808440eed33Bf",
      symbol: "cbBTC",
    },
    collateralToken: {
      address: "0x23e479ddcda990E8523494895759bD98cD2fDBF6",
      symbol: "PT-corn-SolvBTC.BBN-26DEC2024",
    },
  },
  {
    id: "0x7a832f3178090d6aa31385a4c69d1c4602bc8a42f4ee890fe31a533b7e4b4791",
    name: "USDC / PYUSD",
    irm: "0x870aC11D48B15DB9a138Cf899d20F13F79Ba00BC",
    lltv: "860000000000000000",
    oracle: "0xDddd770BADd886dF3864029e4B377B5F6a2B6b83",
    loanToken: {
      address: "0xA0b86991c6218b36c1d19D4a2e9Eb0cE3606eB48",
      symbol: "USDC",
    },
    collateralToken: {
      address: "0x6c3ea9036406852006290770BEdFcAbA0e23A0e8",
      symbol: "PYUSD",
    },
  },
  {
    id: "0x7a8182d6de7d6b2162bfcc596d74d5afa42fb3d3c8380d4856187c783a9def87",
    name: "USDC / splDXY-BULL",
    irm: "0x870aC11D48B15DB9a138Cf899d20F13F79Ba00BC",
    lltv: "915000000000000000",
    oracle: "0x3Bc9C811089444ee82336678da04c38A1a9A61EC",
    loanToken: {
      address: "0xA0b86991c6218b36c1d19D4a2e9Eb0cE3606eB48",
      symbol: "USDC",
    },
    collateralToken: {
      address: "0x8dbcF452799f50D3382105a19FdBfA57B7f29C73",
      symbol: "splDXY-BULL",
    },
  },
  {
    id: "0x7a287c9bf2c80085722f5cd45fcefee10b8f6c598f02dde67b106829320d8fa2",
    name: "wSTRCx / apxUSD",
    irm: "0x870aC11D48B15DB9a138Cf899d20F13F79Ba00BC",
    lltv: "915000000000000000",
    oracle: "0x2b10A2d787a1ed76a68fCe7588A4EEbA6cc8794b",
    loanToken: {
      address: "0x34D78E7B06542Dab48f9bf9f0835c7582141314e",
      symbol: "wSTRCx",
    },
    collateralToken: {
      address: "0x98A878b1Cd98131B271883B390f68D2c90674665",
      symbol: "apxUSD",
    },
  },
  {
    id: "0x78a00992e045e8bcf3f1008945209e5af8c63c545713f1e1251ac2ba5778f685",
    name: "msETH / ynETHx",
    irm: "0x870aC11D48B15DB9a138Cf899d20F13F79Ba00BC",
    lltv: "945000000000000000",
    oracle: "0xc28F86C86F79282E2d2A1f45442339C55f7eB22D",
    loanToken: {
      address: "0x64351fC9810aDAd17A690E4e1717Df5e7e085160",
      symbol: "msETH",
    },
    collateralToken: {
      address: "0x657d9ABA1DBb59e53f9F3eCAA878447dCfC96dCb",
      symbol: "ynETHx",
    },
  },
  {
    id: "0x7832d00f0294515e97ccdbe10282dd768b4c016d8ee4a8e7ad29b6cdcc167a4d",
    name: "scrvUSD / asdCRV",
    irm: "0x870aC11D48B15DB9a138Cf899d20F13F79Ba00BC",
    lltv: "770000000000000000",
    oracle: "0xe4EC7B955a73Fd4121b7841CC4538A60cb4AC542",
    loanToken: {
      address: "0x0655977FEb2f289A4aB78af67BAB0d17aAb84367",
      symbol: "scrvUSD",
    },
    collateralToken: {
      address: "0x43E54C2E7b3e294De3A155785F52AB49d87B9922",
      symbol: "asdCRV",
    },
  },
  {
    id: "0x77e624dd9dd980810c2b804249e88f3598d9c7ec91f16aa5fbf6e3fdf6087f82",
    name: "USDS / stUSDS",
    irm: "0x870aC11D48B15DB9a138Cf899d20F13F79Ba00BC",
    lltv: "860000000000000000",
    oracle: "0x0A976226d113B67Bd42D672Ac9f83f92B44b454C",
    loanToken: {
      address: "0xdC035D45d973E3EC169d2276DDab16f1e407384F",
      symbol: "USDS",
    },
    collateralToken: {
      address: "0x99CD4Ec3f88A45940936F469E4bB72A2A701EEB9",
      symbol: "stUSDS",
    },
  },
  {
    id: "0x7643c3cacfeecb46249e9a2caf2a0e2f2ffeff9e9d46d20b42c9f30cfd5afeac",
    name: "USDtb / PT-sUSDE-27NOV2025",
    irm: "0x870aC11D48B15DB9a138Cf899d20F13F79Ba00BC",
    lltv: "915000000000000000",
    oracle: "0xc2aEF934844BFa3E84a3367d6678de81Ede564F6",
    loanToken: {
      address: "0xC139190F447e929f090Edeb554D95AbB8b18aC1C",
      symbol: "USDtb",
    },
    collateralToken: {
      address: "0xe6A934089BBEe34F832060CE98848359883749B3",
      symbol: "PT-sUSDE-27NOV2025",
    },
  },
  {
    id: "0x7629b62c42febfccd87a8eb76bd91587b33bbcd474cb79bc4964aeb0479e4e53",
    name: "frxUSD / unknown",
    irm: "0x870aC11D48B15DB9a138Cf899d20F13F79Ba00BC",
    lltv: "945000000000000000",
    oracle: "0xDE00641b654B5E6447D0277a8bEad00309Fc86c2",
    loanToken: {
      address: "0xCAcd6fd266aF91b8AeD52aCCc382b4e165586E29",
      symbol: "frxUSD",
    },
    collateralToken: {
      address: "0x61ec68a5a79905a82Bd594dC847E284Df17a8760",
      symbol: "unknown",
    },
  },
  {
    id: "0x755c29687fc635da7f61647be27ac3b0663f2f3a2a8acd245c927b9954e800af",
    name: "EURCV / cbBTC",
    irm: "0x870aC11D48B15DB9a138Cf899d20F13F79Ba00BC",
    lltv: "860000000000000000",
    oracle: "0x336d953f421C38c495B18C4498A569B1A843813f",
    loanToken: {
      address: "0x5F7827FDeb7c20b443265Fc2F40845B715385Ff2",
      symbol: "EURCV",
    },
    collateralToken: {
      address: "0xcbB7C0000aB88B473b1f5aFd9ef808440eed33Bf",
      symbol: "cbBTC",
    },
  },
  {
    id: "0x75514afcce6d681f80c5029f9d581e00841618c16d585bd04f8688e983dba61e",
    name: "crvUSD / ",
    irm: "0x870aC11D48B15DB9a138Cf899d20F13F79Ba00BC",
    lltv: "860000000000000000",
    oracle: "0x1903515C7518E6F25b683b285ab7492C9BbffC33",
    loanToken: {
      address: "0xf939E0A03FB07F59A73314E73794Be0E57ac1b4E",
      symbol: "crvUSD",
    },
    collateralToken: {
      address: "0x517068E51009e0e5E2a25f91e04837e66414D8Ac",
      symbol: "",
    },
  },
  {
    id: "0x7527be7772eb6e2e6bd9a5a9cc83dcd67fd1c9e6103d09868d0308eb3b70af2c",
    name: "sUSDS / deUSD",
    irm: "0x870aC11D48B15DB9a138Cf899d20F13F79Ba00BC",
    lltv: "915000000000000000",
    oracle: "0x27C549756d0a1c0d012525b1C39E5d9b1Cf30013",
    loanToken: {
      address: "0xa3931d71877C0E7a3148CB7Eb4463524FEc27fbD",
      symbol: "sUSDS",
    },
    collateralToken: {
      address: "0x15700B564Ca08D9439C58cA5053166E8317aa138",
      symbol: "deUSD",
    },
  },
  {
    id: "0x74ef8d7022b0ef0c0e6dc001fbda3c8bd9a3e706f03bb559c833e1dce7302d3a",
    name: "crvUSD / ",
    irm: "0x870aC11D48B15DB9a138Cf899d20F13F79Ba00BC",
    lltv: "860000000000000000",
    oracle: "0xd2F7C3B2fC97cC7b6AfDd76D163394680EFc35b9",
    loanToken: {
      address: "0xf939E0A03FB07F59A73314E73794Be0E57ac1b4E",
      symbol: "crvUSD",
    },
    collateralToken: {
      address: "0x0ea1a65A2c255f24Ee8D81eA6AaC54Decd9d269e",
      symbol: "",
    },
  },
  {
    id: "0x74d08bdc168cf1f57d725ca33f051671f9461a263188557b05d4fa663348b1eb",
    name: "USDf / sUSDf",
    irm: "0x870aC11D48B15DB9a138Cf899d20F13F79Ba00BC",
    lltv: "915000000000000000",
    oracle: "0x6f397fA3eCed7d3e689f262C36E219768Ae42eAF",
    loanToken: {
      address: "0xFa2B947eEc368f42195f24F36d2aF29f7c24CeC2",
      symbol: "USDf",
    },
    collateralToken: {
      address: "0xc8CF6D7991f15525488b2A83Df53468D682Ba4B0",
      symbol: "sUSDf",
    },
  },
  {
    id: "0x74812bbebc266a8054473a62722aeab79ed54fd9f7f23ddb88dfe6af35ef6eb5",
    name: "USDS / BOBO",
    irm: "0x870aC11D48B15DB9a138Cf899d20F13F79Ba00BC",
    lltv: "625000000000000000",
    oracle: "0x30fc2d5005ADc0652a34B93081346919471B8077",
    loanToken: {
      address: "0xdC035D45d973E3EC169d2276DDab16f1e407384F",
      symbol: "USDS",
    },
    collateralToken: {
      address: "0xB90B2A35C65dBC466b04240097Ca756ad2005295",
      symbol: "BOBO",
    },
  },
  {
    id: "0x742f1e02169fc3317dc05baff91dd7e796fb6e0a46afb683dbf78b206bfa5f13",
    name: "USDf / PT-sUSDf-25SEP2025",
    irm: "0x870aC11D48B15DB9a138Cf899d20F13F79Ba00BC",
    lltv: "915000000000000000",
    oracle: "0x01663dae09EC45aB7151Ef8910C3a9741C0c712e",
    loanToken: {
      address: "0xFa2B947eEc368f42195f24F36d2aF29f7c24CeC2",
      symbol: "USDf",
    },
    collateralToken: {
      address: "0xAB365C0879024481E4ad3b47bd6FeA9c10014FbC",
      symbol: "PT-sUSDf-25SEP2025",
    },
  },
  {
    id: "0x73a0be5679ba2382c8a36f05e1b1d3cb4f1e8f29ca422d4da5a69b65abf2bdfe",
    name: "fwUSDC / fwWBTC",
    irm: "0x870aC11D48B15DB9a138Cf899d20F13F79Ba00BC",
    lltv: "860000000000000000",
    oracle: "0xDddd770BADd886dF3864029e4B377B5F6a2B6b83",
    loanToken: {
      address: "0x0492560FA7Cfd6A85E50D8bE3F77318994F8f429",
      symbol: "fwUSDC",
    },
    collateralToken: {
      address: "0x2078f336Fdd260f708BEc4a20c82b063274E1b23",
      symbol: "fwWBTC",
    },
  },
  {
    id: "0x7376950d9c0d6b3c0b3dc02080e367ccb0de588e7986f4b2bc3b393147ed04a7",
    name: "tGBP / PAXG",
    irm: "0x870aC11D48B15DB9a138Cf899d20F13F79Ba00BC",
    lltv: "770000000000000000",
    oracle: "0x161A23d5D1073a57A2C9a754C971cE4F37568ED5",
    loanToken: {
      address: "0x27f6c8289550fCE67f6B50BeD1F519966aFE5287",
      symbol: "tGBP",
    },
    collateralToken: {
      address: "0x45804880De22913dAFE09f4980848ECE6EcbAf78",
      symbol: "PAXG",
    },
  },
  {
    id: "0x736c8418c442f5a82255a6c8fc3acf781a45edab36c87a298936c557819b8677",
    name: "GRAM / MAYA",
    irm: "0x870aC11D48B15DB9a138Cf899d20F13F79Ba00BC",
    lltv: "625000000000000000",
    oracle: "0x50c0bC249Bc38AB346eE5c81AbB9efef2312643f",
    loanToken: {
      address: "0x845f64673a2407320C2cC12e23b669DC16F7A473",
      symbol: "GRAM",
    },
    collateralToken: {
      address: "0xCe38af70542e57eA2a438d12e662D9851de06D86",
      symbol: "MAYA",
    },
  },
  {
    id: "0x7311366b78cee201e820a528ab20e3db948a2c4c26f97746debbd19c5947248b",
    name: "USDC / xstETH",
    irm: "0x870aC11D48B15DB9a138Cf899d20F13F79Ba00BC",
    lltv: "860000000000000000",
    oracle: "0x48848d4A645AD46C21015e44D703aa9b58d93aD9",
    loanToken: {
      address: "0xA0b86991c6218b36c1d19D4a2e9Eb0cE3606eB48",
      symbol: "USDC",
    },
    collateralToken: {
      address: "0x5a097b014C547718e79030a077A91Ae37679EfF5",
      symbol: "xstETH",
    },
  },
  {
    id: "0x72cc79433e9f91c2a185422725510f4bdd19c9006010f464f851468b2371b756",
    name: "pmUSD / srRoyUSDC",
    irm: "0x870aC11D48B15DB9a138Cf899d20F13F79Ba00BC",
    lltv: "860000000000000000",
    oracle: "0x02147FD1Dc98c7D30b5E3b8f31B549837d5B1F10",
    loanToken: {
      address: "0xC0c17dD08263C16f6b64E772fB9B723Bf1344DdF",
      symbol: "pmUSD",
    },
    collateralToken: {
      address: "0xcD9f5907F92818bC06c9Ad70217f089E190d2a32",
      symbol: "srRoyUSDC",
    },
  },
  {
    id: "0x72b271e9a56801034185619ab2f51522ad67086e79b91dc9ca19cee6f55b287e",
    name: "EURCV / cbBTC",
    irm: "0x870aC11D48B15DB9a138Cf899d20F13F79Ba00BC",
    lltv: "860000000000000000",
    oracle: "0xE4D86fD3bE3D82630d39927acB2a97B1F2b26d1d",
    loanToken: {
      address: "0x5F7827FDeb7c20b443265Fc2F40845B715385Ff2",
      symbol: "EURCV",
    },
    collateralToken: {
      address: "0xcbB7C0000aB88B473b1f5aFd9ef808440eed33Bf",
      symbol: "cbBTC",
    },
  },
  {
    id: "0x71d214ecf6c58413f943849752a7e727691a084be7dfe9cf7c2d7efc82c610c7",
    name: "USDS / ysUSDS",
    irm: "0x870aC11D48B15DB9a138Cf899d20F13F79Ba00BC",
    lltv: "980000000000000000",
    oracle: "0x70b4C99a2002950aceDdEeCEC718C83f3d5eD3e8",
    loanToken: {
      address: "0xdC035D45d973E3EC169d2276DDab16f1e407384F",
      symbol: "USDS",
    },
    collateralToken: {
      address: "0x4cE9c93513DfF543Bc392870d57dF8C04e89Ba0a",
      symbol: "ysUSDS",
    },
  },
  {
    id: "0x71c98d81578032db021bba1b81500ba52302637d8a92942cc09bd6f934e1dc57",
    name: "sUSDS / WBTC",
    irm: "0x870aC11D48B15DB9a138Cf899d20F13F79Ba00BC",
    lltv: "860000000000000000",
    oracle: "0xaDccABdf3dB1f269Bb17156471918EB7862f4929",
    loanToken: {
      address: "0xa3931d71877C0E7a3148CB7Eb4463524FEc27fbD",
      symbol: "sUSDS",
    },
    collateralToken: {
      address: "0x2260FAC5E5542a773Aa44fBCfeDf7C193bc2C599",
      symbol: "WBTC",
    },
  },
  {
    id: "0x71c0ed6dc446470316162d86e7d915794fa8c61dbc4e50f87caadfe87f4fd805",
    name: "USR / wstUSR",
    irm: "0x870aC11D48B15DB9a138Cf899d20F13F79Ba00BC",
    lltv: "945000000000000000",
    oracle: "0x37b05Fc9ED464499E1cAb9979740c80302d07b0D",
    loanToken: {
      address: "0x66a1E37c9b0eAddca17d3662D6c05F4DECf3e110",
      symbol: "USR",
    },
    collateralToken: {
      address: "0x1202F5C7b4B9E47a1A484E8B270be34dbbC75055",
      symbol: "wstUSR",
    },
  },
  {
    id: "0x7033d618c0ac66abb86ec429f8f4006e61bc3320e9762b3774a118e62f4334af",
    name: "EURCV / steakUSDC",
    irm: "0x870aC11D48B15DB9a138Cf899d20F13F79Ba00BC",
    lltv: "915000000000000000",
    oracle: "0xed621DD43e0EEbfe9ddc10bd2815B861734bEb0c",
    loanToken: {
      address: "0x5F7827FDeb7c20b443265Fc2F40845B715385Ff2",
      symbol: "EURCV",
    },
    collateralToken: {
      address: "0xbeef088055857739C12CD3765F20b7679Def0f51",
      symbol: "steakUSDC",
    },
  },
  {
    id: "0x6f4535ffb5083438521d635d35faf9ac60dd37fc256698c3ee51813562f3b60f",
    name: "sUSDS / WBTC",
    irm: "0x870aC11D48B15DB9a138Cf899d20F13F79Ba00BC",
    lltv: "860000000000000000",
    oracle: "0x1632f3E14754CD8f4b8F8a3b0719a94545042057",
    loanToken: {
      address: "0xa3931d71877C0E7a3148CB7Eb4463524FEc27fbD",
      symbol: "sUSDS",
    },
    collateralToken: {
      address: "0x2260FAC5E5542a773Aa44fBCfeDf7C193bc2C599",
      symbol: "WBTC",
    },
  },
  {
    id: "0x6e546cd9cd2e69dc25dedcf91be9d603398d2fbe120147961a0146ac0a5c8a11",
    name: "USDC / JAB78",
    irm: "0x870aC11D48B15DB9a138Cf899d20F13F79Ba00BC",
    lltv: "770000000000000000",
    oracle: "0xa45c4a15C43E026aC1550E14BeFb443862779eB6",
    loanToken: {
      address: "0xA0b86991c6218b36c1d19D4a2e9Eb0cE3606eB48",
      symbol: "USDC",
    },
    collateralToken: {
      address: "0x9B815cC227e607c00a54709828d5158C0f8a167D",
      symbol: "JAB78",
    },
  },
  {
    id: "0x6d5ceaf737f6ed7f5972c46e87d359a77d36fffa484eeddf2f8188e1605fa9d4",
    name: "USDA / WBTC",
    irm: "0x870aC11D48B15DB9a138Cf899d20F13F79Ba00BC",
    lltv: "860000000000000000",
    oracle: "0x032F1C64899b2C89835E51aCeD9434b0aDEaA69d",
    loanToken: {
      address: "0x0000206329b97DB379d5E1Bf586BbDB969C63274",
      symbol: "USDA",
    },
    collateralToken: {
      address: "0x2260FAC5E5542a773Aa44fBCfeDf7C193bc2C599",
      symbol: "WBTC",
    },
  },
  {
    id: "0x6d388ff5d62b779fc3579c8449b5dd84a893df668a9a64d2aded1bee36887b57",
    name: "rUSD / PT-RUSD-30OCT2025",
    irm: "0x870aC11D48B15DB9a138Cf899d20F13F79Ba00BC",
    lltv: "915000000000000000",
    oracle: "0xd2a62CfBf3D9aFd03A7BCe238332EE334B95E543",
    loanToken: {
      address: "0x09D4214C03D01F49544C0448DBE3A27f768F2b34",
      symbol: "rUSD",
    },
    collateralToken: {
      address: "0xdcFDf8434e8FDfFF2dD7dfC9299877e813348EE7",
      symbol: "PT-RUSD-30OCT2025",
    },
  },
  {
    id: "0x6ce3b99a54d5db5c642361a6cb0419d2b0db7fd3f85e78f6cdd0dec80d21ba19",
    name: "unknown / USDS",
    irm: "0x870aC11D48B15DB9a138Cf899d20F13F79Ba00BC",
    lltv: "860000000000000000",
    oracle: "0x73700AeDBB8C3C4692d820D0b9bCf45C38d0f091",
    loanToken: {
      address: "0x1F32b1c2345538c0c6f582fCB022739c4A194Ebb",
      symbol: "unknown",
    },
    collateralToken: {
      address: "0xdC035D45d973E3EC169d2276DDab16f1e407384F",
      symbol: "USDS",
    },
  },
  {
    id: "0x6cda45ff81d05e75048db002a6836a21ba6e322579ab9af2fd0666f251a69264",
    name: "AUSD / USDe",
    irm: "0x870aC11D48B15DB9a138Cf899d20F13F79Ba00BC",
    lltv: "945000000000000000",
    oracle: "0x1325Eb089Ac14B437E78D5D481e32611F6907eF8",
    loanToken: {
      address: "0x00000000eFE302BEAA2b3e6e1b18d08D69a9012a",
      symbol: "AUSD",
    },
    collateralToken: {
      address: "0x4c9EDD5852cd905f086C759E8383e09bff1E68B3",
      symbol: "USDe",
    },
  },
  {
    id: "0x6c9be3f8a64a2fff14394d04e2e0901e5b82aab1dc5f21320f7c27ce2d87b2a3",
    name: "lvWETH / lvstETH",
    irm: "0x870aC11D48B15DB9a138Cf899d20F13F79Ba00BC",
    lltv: "945000000000000000",
    oracle: "0xF16B976Dfa444122A1E1D8129Aa39aCBca958ce5",
    loanToken: {
      address: "0x17FEFCa74329fdD5cb1F95526b44277057F5EAf4",
      symbol: "lvWETH",
    },
    collateralToken: {
      address: "0xEfc62BA71640e3ac1f5e9fCEe45E808fCfde7E1d",
      symbol: "lvstETH",
    },
  },
  {
    id: "0x6c5942c5701a26908249de68596085b2144390f0c0242b9b545a30b5a31f09f4",
    name: "USDC / fxSAVE",
    irm: "0x870aC11D48B15DB9a138Cf899d20F13F79Ba00BC",
    lltv: "860000000000000000",
    oracle: "0x8cc76B27BdEaC2A0004f8f91dEC03F6446a206eE",
    loanToken: {
      address: "0xA0b86991c6218b36c1d19D4a2e9Eb0cE3606eB48",
      symbol: "USDC",
    },
    collateralToken: {
      address: "0x7743e50F534a7f9F1791DdE7dCD89F7783Eefc39",
      symbol: "fxSAVE",
    },
  },
  {
    id: "0x6b9d015f41120c5663490114f3810a541fb776eaa7d432d697c2adce017ea8ff",
    name: "BOLD / sBOLD",
    irm: "0x870aC11D48B15DB9a138Cf899d20F13F79Ba00BC",
    lltv: "915000000000000000",
    oracle: "0xC72C295c25538BE6A135aa2822Aa3a3F9d4D42b9",
    loanToken: {
      address: "0x6440f144b7e50D6a8439336510312d2F54beB01D",
      symbol: "BOLD",
    },
    collateralToken: {
      address: "0x50Bd66D59911F5e086Ec87aE43C811e0D059DD11",
      symbol: "sBOLD",
    },
  },
  {
    id: "0x6aed664dab53ed472682c66bfe7299c0352e997bbf008aa5573895f9e9115f03",
    name: "EURA / wstETH",
    irm: "0x870aC11D48B15DB9a138Cf899d20F13F79Ba00BC",
    lltv: "860000000000000000",
    oracle: "0x44D6d497fb53294f283983E2931972840eb3DD90",
    loanToken: {
      address: "0x1a7e4e63778B4f12a199C062f3eFdD288afCBce8",
      symbol: "EURA",
    },
    collateralToken: {
      address: "0x7f39C581F595B53c5cb19bD0b3f8dA6c935E2Ca0",
      symbol: "wstETH",
    },
  },
  {
    id: "0x6a8f296524b7f300b56e3653bbfc0ce4dd0dff225f1d5ec09c4fd190886ae53e",
    name: "frxUSD / PT-avUSD-14MAY2026",
    irm: "0x870aC11D48B15DB9a138Cf899d20F13F79Ba00BC",
    lltv: "915000000000000000",
    oracle: "0x611871C21452fa7c1c9e3306EDbdfE94AC061d8F",
    loanToken: {
      address: "0xCAcd6fd266aF91b8AeD52aCCc382b4e165586E29",
      symbol: "frxUSD",
    },
    collateralToken: {
      address: "0xcc16Cd49194e7AA3DCa780c742580e2f9b418874",
      symbol: "PT-avUSD-14MAY2026",
    },
  },
  {
    id: "0x6a73e467773013349a9ac21ed0a955ad27e91a76ce31ae986d45be3155f956ea",
    name: "USR / PT-RLP-4DEC2025",
    irm: "0x870aC11D48B15DB9a138Cf899d20F13F79Ba00BC",
    lltv: "860000000000000000",
    oracle: "0xE8bee0eb3C2dc0b6AB2Ca456165605409eb4Ca2B",
    loanToken: {
      address: "0x66a1E37c9b0eAddca17d3662D6c05F4DECf3e110",
      symbol: "USR",
    },
    collateralToken: {
      address: "0x3A70F0C696dcB3A4aB3833cD9726397dD61AC85e",
      symbol: "PT-RLP-4DEC2025",
    },
  },
  {
    id: "0x6995c4a9473489baac455c0655361ff0570a45a98679c0bd4917cfb8b17bacf3",
    name: "AUSD / PT-SY wstUSR-25JUN2026",
    irm: "0x870aC11D48B15DB9a138Cf899d20F13F79Ba00BC",
    lltv: "915000000000000000",
    oracle: "0x5F51A2C3E0178a360Ce2BDE42B08DB369f30268E",
    loanToken: {
      address: "0x00000000eFE302BEAA2b3e6e1b18d08D69a9012a",
      symbol: "AUSD",
    },
    collateralToken: {
      address: "0x90A2d7A50692f2620b467747A32CFa61889997B1",
      symbol: "PT-SY wstUSR-25JUN2026",
    },
  },
  {
    id: "0x6917b95060488821b992aa8da85929c169fe7a17885eebb0c7a1585224e3b069",
    name: "LBTC / cbBTC",
    irm: "0x870aC11D48B15DB9a138Cf899d20F13F79Ba00BC",
    lltv: "945000000000000000",
    oracle: "0xBc25035AE0111BB39999962eE8CE25c60dA8cAC9",
    loanToken: {
      address: "0x8236a87084f8B84306f72007F36F2618A5634494",
      symbol: "LBTC",
    },
    collateralToken: {
      address: "0xcbB7C0000aB88B473b1f5aFd9ef808440eed33Bf",
      symbol: "cbBTC",
    },
  },
  {
    id: "0x68c028b0e6c8a62c1c1c35a5f26e77e2dfda3a3942788612bf1cfe1ce7196420",
    name: "apxUSD / PT-ROY-ST-apyUSD-5NOV2026",
    irm: "0x870aC11D48B15DB9a138Cf899d20F13F79Ba00BC",
    lltv: "945000000000000000",
    oracle: "0xE31460BBdA06A184535003Dc3a61d3d36D280f99",
    loanToken: {
      address: "0x98A878b1Cd98131B271883B390f68D2c90674665",
      symbol: "apxUSD",
    },
    collateralToken: {
      address: "0x44Db865Cc6D5768703fb5Bf73dfB7A5a0f95c1fc",
      symbol: "PT-ROY-ST-apyUSD-5NOV2026",
    },
  },
  {
    id: "0x6894e287c615cf987993975d4ede5c30e469e4bc901ff8d0f4fd67eb8189f2a8",
    name: "USUAL / USUALX",
    irm: "0x870aC11D48B15DB9a138Cf899d20F13F79Ba00BC",
    lltv: "945000000000000000",
    oracle: "0x7bA6A0590a97c256a015d34102Fc9df6b74b1f1c",
    loanToken: {
      address: "0xC4441c2BE5d8fA8126822B9929CA0b81Ea0DE38E",
      symbol: "USUAL",
    },
    collateralToken: {
      address: "0x06B964d96f5dCF7Eae9d7C559B09EDCe244d4B8E",
      symbol: "USUALX",
    },
  },
  {
    id: "0x68590485a47b4fbd0bbfbc0b075737b828a6c9af0c7079009b43b83c95d32d3c",
    name: "USDC / PKZZZ",
    irm: "0x870aC11D48B15DB9a138Cf899d20F13F79Ba00BC",
    lltv: "915000000000000000",
    oracle: "0x8fFfFfd4AfB6115b954Bd326cbe7B4BA576818f6",
    loanToken: {
      address: "0xA0b86991c6218b36c1d19D4a2e9Eb0cE3606eB48",
      symbol: "USDC",
    },
    collateralToken: {
      address: "0x05827E261Af3aE38346F4e7Fa9760B4798ae3cf0",
      symbol: "PKZZZ",
    },
  },
  {
    id: "0x67c633b6e31241cc04d4a2e0fc295172ab037815d541ef37b6701e2d3abfcb5c",
    name: "USDT / cbBTC",
    irm: "0x870aC11D48B15DB9a138Cf899d20F13F79Ba00BC",
    lltv: "860000000000000000",
    oracle: "0xA93e3B4A671F2E84b62e6A5845F98292c802484d",
    loanToken: {
      address: "0xdAC17F958D2ee523a2206206994597C13D831ec7",
      symbol: "USDT",
    },
    collateralToken: {
      address: "0xcbB7C0000aB88B473b1f5aFd9ef808440eed33Bf",
      symbol: "cbBTC",
    },
  },
  {
    id: "0x67992b26ac5eee3c3a6cea090690ad3b41ee33d1d53ed7937823695ffd92a283",
    name: "USDC / sUSDz",
    irm: "0x870aC11D48B15DB9a138Cf899d20F13F79Ba00BC",
    lltv: "945000000000000000",
    oracle: "0x19458F400D93817503c5bF7558624cca09f2487e",
    loanToken: {
      address: "0xA0b86991c6218b36c1d19D4a2e9Eb0cE3606eB48",
      symbol: "USDC",
    },
    collateralToken: {
      address: "0x547213367cfB08ab418E7b54d7883b2C2AA27Fd7",
      symbol: "sUSDz",
    },
  },
  {
    id: "0x664bce01b281e4596a51fb268e4fe4e13c98200ce9651d24458a4380c2b31280",
    name: "EURCV / EUTBL",
    irm: "0x870aC11D48B15DB9a138Cf899d20F13F79Ba00BC",
    lltv: "915000000000000000",
    oracle: "0xf071b0a62ef2a54c1Dca791134421EE16c2C43d9",
    loanToken: {
      address: "0x5F7827FDeb7c20b443265Fc2F40845B715385Ff2",
      symbol: "EURCV",
    },
    collateralToken: {
      address: "0xa0769f7A8fC65e47dE93797b4e21C073c117Fc80",
      symbol: "EUTBL",
    },
  },
  {
    id: "0x64d6a777c466c2eb82a1efb4814aa2eab673a95e66fc229fea54125608e6f342",
    name: "wM / USD0++",
    irm: "0x870aC11D48B15DB9a138Cf899d20F13F79Ba00BC",
    lltv: "860000000000000000",
    oracle: "0x1325Eb089Ac14B437E78D5D481e32611F6907eF8",
    loanToken: {
      address: "0x437cc33344a0B27A429f795ff6B469C72698B291",
      symbol: "wM",
    },
    collateralToken: {
      address: "0x35D8949372D46B7a3D5A56006AE77B215fc69bC0",
      symbol: "USD0++",
    },
  },
  {
    id: "0x64d2f82e674b764d618b630297813cd34bdc42a0fa66f92efa2ac8b1efe4bbd5",
    name: "msUSD / siUSD",
    irm: "0x870aC11D48B15DB9a138Cf899d20F13F79Ba00BC",
    lltv: "915000000000000000",
    oracle: "0xC7bB5f34D645f3849a3091Ce4b6724631ee811Af",
    loanToken: {
      address: "0xab5eB14c09D416F0aC63661E57EDB7AEcDb9BEfA",
      symbol: "msUSD",
    },
    collateralToken: {
      address: "0xDBDC1Ef57537E34680B898E1FEBD3D68c7389bCB",
      symbol: "siUSD",
    },
  },
  {
    id: "0x6463cfbf0e1d061072cce8b2286d70d264c75670ebf8ee1691283822f82cb7cc",
    name: "WETH / cbBTC",
    irm: "0x870aC11D48B15DB9a138Cf899d20F13F79Ba00BC",
    lltv: "915000000000000000",
    oracle: "0xe9c732C1f1E97F452450eC1c112D7ADB264514bD",
    loanToken: {
      address: "0xC02aaA39b223FE8D0A0e5C4F27eAD9083C756Cc2",
      symbol: "WETH",
    },
    collateralToken: {
      address: "0xcbB7C0000aB88B473b1f5aFd9ef808440eed33Bf",
      symbol: "cbBTC",
    },
  },
  {
    id: "0x63267eda1c5069feafb5395e55eac3c67789e0ae7465ecc92b950d755296cb71",
    name: "lvWETH / lvstETH",
    irm: "0x870aC11D48B15DB9a138Cf899d20F13F79Ba00BC",
    lltv: "945000000000000000",
    oracle: "0x864E93bE6377896C9DD570C3C48651CADC15201C",
    loanToken: {
      address: "0x774723993c39082D44B7FA212b514006fAfe72de",
      symbol: "lvWETH",
    },
    collateralToken: {
      address: "0x19E7E4c7498d5F573268736F33611066EAeEF5A5",
      symbol: "lvstETH",
    },
  },
  {
    id: "0x62e97eeb5a4380801c33fe19e7b9f1f44a20194f1c0d006e418649edcb0ba166",
    name: "USDC / splDXY-BEAR",
    irm: "0x870aC11D48B15DB9a138Cf899d20F13F79Ba00BC",
    lltv: "915000000000000000",
    oracle: "0x9ED72467f09053C2dEE0D2348d6bab4b94e77030",
    loanToken: {
      address: "0xA0b86991c6218b36c1d19D4a2e9Eb0cE3606eB48",
      symbol: "USDC",
    },
    collateralToken: {
      address: "0xDC7366b8BB83f9ABa2B4F989194D6c03D0A20DE9",
      symbol: "splDXY-BEAR",
    },
  },
  {
    id: "0x62428c0cb931a0ec133a646e166914561185b7da30f7c5f877471c6718420a71",
    name: "USD0 / USDe",
    irm: "0x870aC11D48B15DB9a138Cf899d20F13F79Ba00BC",
    lltv: "860000000000000000",
    oracle: "0xaE4750d0813B5E37A51f7629beedd72AF1f9cA35",
    loanToken: {
      address: "0x73A15FeD60Bf67631dC6cd7Bc5B6e8da8190aCF5",
      symbol: "USD0",
    },
    collateralToken: {
      address: "0x4c9EDD5852cd905f086C759E8383e09bff1E68B3",
      symbol: "USDe",
    },
  },
  {
    id: "0x61ec07c8ff28ad5928cf28953fe4266d92311c62343a10ca4cb197e4f06302ab",
    name: "WETH / USDU",
    irm: "0x870aC11D48B15DB9a138Cf899d20F13F79Ba00BC",
    lltv: "860000000000000000",
    oracle: "0x711F1DEB3bC986A994f0955a85108EA438CD9439",
    loanToken: {
      address: "0xC02aaA39b223FE8D0A0e5C4F27eAD9083C756Cc2",
      symbol: "WETH",
    },
    collateralToken: {
      address: "0xdde3eC717f220Fc6A29D6a4Be73F91DA5b718e55",
      symbol: "USDU",
    },
  },
  {
    id: "0x61b01462df103a57205fea706a58cd0efa4a56570245e7ccea19677a056a835f",
    name: "DAI / PENDLE-LPT",
    irm: "0x870aC11D48B15DB9a138Cf899d20F13F79Ba00BC",
    lltv: "860000000000000000",
    oracle: "0x5D916980D5Ae1737a8330Bf24dF812b2911Aae25",
    loanToken: {
      address: "0x6B175474E89094C44Da98b954EedeAC495271d0F",
      symbol: "DAI",
    },
    collateralToken: {
      address: "0xbBf399db59A845066aAFce9AE55e68c505FA97B7",
      symbol: "PENDLE-LPT",
    },
  },
  {
    id: "0x6117053ec7814a6e70f67d983653c2d6d224b7053a8784969ad1afbc851537df",
    name: "sUSDS / PT-sUSDE-25SEP2025",
    irm: "0x870aC11D48B15DB9a138Cf899d20F13F79Ba00BC",
    lltv: "915000000000000000",
    oracle: "0xaBA8e7D2ebC771F294DE4Ff4dD6B1CCd6762362A",
    loanToken: {
      address: "0xa3931d71877C0E7a3148CB7Eb4463524FEc27fbD",
      symbol: "sUSDS",
    },
    collateralToken: {
      address: "0x9F56094C450763769BA0EA9Fe2876070c0fD5F77",
      symbol: "PT-sUSDE-25SEP2025",
    },
  },
  {
    id: "0x610fa7c5b97fd5f428ad620321aaef9c5111e5fe9072114ecf1f22a117d3dc06",
    name: "apxUSD / PT-apyUSD-5NOV2026",
    irm: "0x870aC11D48B15DB9a138Cf899d20F13F79Ba00BC",
    lltv: "945000000000000000",
    oracle: "0x33E298FCFf24A5b171E70Aa54a12eD4504A60f3F",
    loanToken: {
      address: "0x98A878b1Cd98131B271883B390f68D2c90674665",
      symbol: "apxUSD",
    },
    collateralToken: {
      address: "0xb5Be35D8fF83D431899b95851CB17a2B4bcEF150",
      symbol: "PT-apyUSD-5NOV2026",
    },
  },
  {
    id: "0x60f8d21c3a1a80ea7e51627bd86332b92094a69cbe7c6c6bda266faae4d31529",
    name: "apxUSD / wSTRCx",
    irm: "0x870aC11D48B15DB9a138Cf899d20F13F79Ba00BC",
    lltv: "915000000000000000",
    oracle: "0xEc7708cA49065B2C145A72CA328A67e1441ebD24",
    loanToken: {
      address: "0x98A878b1Cd98131B271883B390f68D2c90674665",
      symbol: "apxUSD",
    },
    collateralToken: {
      address: "0x34D78E7B06542Dab48f9bf9f0835c7582141314e",
      symbol: "wSTRCx",
    },
  },
  {
    id: "0x604e98b52f2375c5d3c6e92766c14174eb45ffbb61d36091f21277ae8930e42c",
    name: "USDS / NPC",
    irm: "0x870aC11D48B15DB9a138Cf899d20F13F79Ba00BC",
    lltv: "625000000000000000",
    oracle: "0x853a46E9B2a81D66Fe5e902AF771879B70933446",
    loanToken: {
      address: "0xdC035D45d973E3EC169d2276DDab16f1e407384F",
      symbol: "USDS",
    },
    collateralToken: {
      address: "0x8eD97a637A790Be1feff5e888d43629dc05408F6",
      symbol: "NPC",
    },
  },
  {
    id: "0x601de270f7044c0a82edfa1c40c16c8ed125bdcc7029697192d072d48178c51f",
    name: "USR / BONDUSD",
    irm: "0x870aC11D48B15DB9a138Cf899d20F13F79Ba00BC",
    lltv: "945000000000000000",
    oracle: "0x1b4A3F92e5Fffd1d35A98751c9FE4472483579bB",
    loanToken: {
      address: "0x66a1E37c9b0eAddca17d3662D6c05F4DECf3e110",
      symbol: "USR",
    },
    collateralToken: {
      address: "0xE66029Af07488C3329A426D35B8DFaFeD3356b3b",
      symbol: "BONDUSD",
    },
  },
  {
    id: "0x5ffdf15c5a4d7c6affb3f12634eeda1a20e60b92c0eb547f61754f656b55841e",
    name: "USDS / PEPE",
    irm: "0x870aC11D48B15DB9a138Cf899d20F13F79Ba00BC",
    lltv: "770000000000000000",
    oracle: "0xAd44b8257fB730E7344bCBe2908679324BD4dcf0",
    loanToken: {
      address: "0xdC035D45d973E3EC169d2276DDab16f1e407384F",
      symbol: "USDS",
    },
    collateralToken: {
      address: "0x6982508145454Ce325dDbE47a25d4ec3d2311933",
      symbol: "PEPE",
    },
  },
  {
    id: "0x5fbb467c8f4f3a64ec8c3a58d04febbcce3eaec510f4dfaec5b1b57c8f189a14",
    name: "USDS / Neiro",
    irm: "0x870aC11D48B15DB9a138Cf899d20F13F79Ba00BC",
    lltv: "625000000000000000",
    oracle: "0x7E9d2573D3D4cb731ee158fda170B24A30d718ff",
    loanToken: {
      address: "0xdC035D45d973E3EC169d2276DDab16f1e407384F",
      symbol: "USDS",
    },
    collateralToken: {
      address: "0x812Ba41e071C7b7fA4EBcFB62dF5F45f6fA853Ee",
      symbol: "Neiro",
    },
  },
  {
    id: "0x5f3bdbc954380ae438384b403da54f28dc13f17499af0d5b0906b8ebfcd383f3",
    name: "USDC / PT-sUSDE-5FEB2026",
    irm: "0x870aC11D48B15DB9a138Cf899d20F13F79Ba00BC",
    lltv: "915000000000000000",
    oracle: "0x8D6262E99d11e982B361a117ac16fD7C97939c5e",
    loanToken: {
      address: "0xA0b86991c6218b36c1d19D4a2e9Eb0cE3606eB48",
      symbol: "USDC",
    },
    collateralToken: {
      address: "0xE8483517077afa11A9B07f849cee2552f040d7b2",
      symbol: "PT-sUSDE-5FEB2026",
    },
  },
  {
    id: "0x5ef01cc3877b1e19e356f284cdcfb23ce3d235fbd556e8c67e16f3e224ffcd87",
    name: "AUSD / sNUSD",
    irm: "0x870aC11D48B15DB9a138Cf899d20F13F79Ba00BC",
    lltv: "915000000000000000",
    oracle: "0x28E82e7f25DbcD487af27C80DE4F62553260fecA",
    loanToken: {
      address: "0x00000000eFE302BEAA2b3e6e1b18d08D69a9012a",
      symbol: "AUSD",
    },
    collateralToken: {
      address: "0x08EFCC2F3e61185D0EA7F8830B3FEc9Bfa2EE313",
      symbol: "sNUSD",
    },
  },
  {
    id: "0x5de846e07c99a4a11060462006d033ff7bbccef63c414d6d3c6a6876fa6af18f",
    name: "AUSD / cbBTC",
    irm: "0x870aC11D48B15DB9a138Cf899d20F13F79Ba00BC",
    lltv: "860000000000000000",
    oracle: "0x4C6EE25Fd75D9a4b03E6354306ccc98E3dCC610c",
    loanToken: {
      address: "0x00000000eFE302BEAA2b3e6e1b18d08D69a9012a",
      symbol: "AUSD",
    },
    collateralToken: {
      address: "0xcbB7C0000aB88B473b1f5aFd9ef808440eed33Bf",
      symbol: "cbBTC",
    },
  },
  {
    id: "0x5d822d3ae29211399bb7a50506bf107f989cd9e8e2d80e9abe9fed6b59b69605",
    name: "USDf / sUSDf",
    irm: "0x870aC11D48B15DB9a138Cf899d20F13F79Ba00BC",
    lltv: "945000000000000000",
    oracle: "0xC793DeA5e437BF4BC4d8F24C7F3b9f31BC6892A7",
    loanToken: {
      address: "0xFa2B947eEc368f42195f24F36d2aF29f7c24CeC2",
      symbol: "USDf",
    },
    collateralToken: {
      address: "0xc8CF6D7991f15525488b2A83Df53468D682Ba4B0",
      symbol: "sUSDf",
    },
  },
  {
    id: "0x5d09770b08517329e25b7dff8f32ad7098c8b6fd075660cdabec3e717ca8068f",
    name: "USDA / Re7USDT",
    irm: "0x870aC11D48B15DB9a138Cf899d20F13F79Ba00BC",
    lltv: "915000000000000000",
    oracle: "0x1f083a4c51E6cAa627A8Cbe7452bF3D6eb815F57",
    loanToken: {
      address: "0x0000206329b97DB379d5E1Bf586BbDB969C63274",
      symbol: "USDA",
    },
    collateralToken: {
      address: "0x95EeF579155cd2C5510F312c8fA39208c3Be01a8",
      symbol: "Re7USDT",
    },
  },
  {
    id: "0x5c212dc37123466613dd211434aee90defab713ff5d54cb6ca03b12c1d5a5ce0",
    name: "USDC / BTC.b",
    irm: "0x870aC11D48B15DB9a138Cf899d20F13F79Ba00BC",
    lltv: "860000000000000000",
    oracle: "0xDddd770BADd886dF3864029e4B377B5F6a2B6b83",
    loanToken: {
      address: "0xA0b86991c6218b36c1d19D4a2e9Eb0cE3606eB48",
      symbol: "USDC",
    },
    collateralToken: {
      address: "0xB0F70C0bD6FD87dbEb7C10dC692a2a6106817072",
      symbol: "BTC.b",
    },
  },
  {
    id: "0x5bfc5484227f34c205e652c0426192dde746fdb709d8947125a06c03f07ea4c7",
    name: "USDU / cbBTC",
    irm: "0x870aC11D48B15DB9a138Cf899d20F13F79Ba00BC",
    lltv: "860000000000000000",
    oracle: "0xF7A0e51cebD98a31947CaE1DDa8C0717D10ADd61",
    loanToken: {
      address: "0xdde3eC717f220Fc6A29D6a4Be73F91DA5b718e55",
      symbol: "USDU",
    },
    collateralToken: {
      address: "0xcbB7C0000aB88B473b1f5aFd9ef808440eed33Bf",
      symbol: "cbBTC",
    },
  },
  {
    id: "0x5a9a736feaefa36d605af46ca54ee1640b127285e9763e9668dd91b1c91bca28",
    name: "scrvUSD / aCRV",
    irm: "0x870aC11D48B15DB9a138Cf899d20F13F79Ba00BC",
    lltv: "770000000000000000",
    oracle: "0x59C11b41B763F87B755eccE466921c78eFa3e8C9",
    loanToken: {
      address: "0x0655977FEb2f289A4aB78af67BAB0d17aAb84367",
      symbol: "scrvUSD",
    },
    collateralToken: {
      address: "0x2b95A1Dcc3D405535f9ed33c219ab38E8d7e0884",
      symbol: "aCRV",
    },
  },
  {
    id: "0x5991b5b0325d6e3ce92e77478f071a024aa3dfe947d95d45af6d19bb36afd131",
    name: "USDC / syrupUSDT",
    irm: "0x870aC11D48B15DB9a138Cf899d20F13F79Ba00BC",
    lltv: "860000000000000000",
    oracle: "0xDddd770BADd886dF3864029e4B377B5F6a2B6b83",
    loanToken: {
      address: "0xA0b86991c6218b36c1d19D4a2e9Eb0cE3606eB48",
      symbol: "USDC",
    },
    collateralToken: {
      address: "0x356B8d89c1e1239Cbbb9dE4815c39A1474d5BA7D",
      symbol: "syrupUSDT",
    },
  },
  {
    id: "0x58ff51cdd73bed3559c03affc95c59ed170130f9096a3cf8dbcd51f445dc71a8",
    name: "apxUSD / PT-apxUSD-5NOV2026",
    irm: "0x870aC11D48B15DB9a138Cf899d20F13F79Ba00BC",
    lltv: "915000000000000000",
    oracle: "0xAdEB005F51bd448277E45bD9e39908266E19B088",
    loanToken: {
      address: "0x98A878b1Cd98131B271883B390f68D2c90674665",
      symbol: "apxUSD",
    },
    collateralToken: {
      address: "0xAF687B5EcB525Ccea96115088999B4eD80C388b6",
      symbol: "PT-apxUSD-5NOV2026",
    },
  },
  {
    id: "0x58384c769c95eb22870688ac572d273ae682be784702ee11ec966ae99c18cd4e",
    name: "USDf / fUSDf",
    irm: "0x870aC11D48B15DB9a138Cf899d20F13F79Ba00BC",
    lltv: "945000000000000000",
    oracle: "0xeEBd57031Ca61906C81Dc78d9513debF647d2E0c",
    loanToken: {
      address: "0xFa2B947eEc368f42195f24F36d2aF29f7c24CeC2",
      symbol: "USDf",
    },
    collateralToken: {
      address: "0x3c124fB80e6eedD88D108C2F04013AE5CD571Abc",
      symbol: "fUSDf",
    },
  },
  {
    id: "0x582fdc4176da0ab5c65e086603ab9ecd9188e889e16efef6e35854cf14e15065",
    name: "AUSD / sUSDat",
    irm: "0x870aC11D48B15DB9a138Cf899d20F13F79Ba00BC",
    lltv: "860000000000000000",
    oracle: "0x78e16Ed8a8ebC86B707316dC84BA7e3E74A3b23A",
    loanToken: {
      address: "0x00000000eFE302BEAA2b3e6e1b18d08D69a9012a",
      symbol: "AUSD",
    },
    collateralToken: {
      address: "0xD166337499E176bbC38a1FBd113Ab144e5bd2Df7",
      symbol: "sUSDat",
    },
  },
  {
    id: "0x57e8783f294473667d2c300d0752ed3bed3226f16076fb41209f32f64da7ed24",
    name: "USDS / sUSDS+s",
    irm: "0x870aC11D48B15DB9a138Cf899d20F13F79Ba00BC",
    lltv: "980000000000000000",
    oracle: "0xE2d12bA4bCB63c25aA0C36b63Db5e3522D686c39",
    loanToken: {
      address: "0xdC035D45d973E3EC169d2276DDab16f1e407384F",
      symbol: "USDS",
    },
    collateralToken: {
      address: "0x0f90a6962e86b5587b4c11bA2B9697dC3bA84800",
      symbol: "sUSDS+s",
    },
  },
  {
    id: "0x578996c3c3ac4f100c4284b5c239673b04840e07945d04b681763c7b3401997c",
    name: "DAI / MKR",
    irm: "0x870aC11D48B15DB9a138Cf899d20F13F79Ba00BC",
    lltv: "770000000000000000",
    oracle: "0x20565E2B5633Dabc3f94FEfb573DfE956F6c435d",
    loanToken: {
      address: "0x6B175474E89094C44Da98b954EedeAC495271d0F",
      symbol: "DAI",
    },
    collateralToken: {
      address: "0x9f8F72aA9304c8B593d555F12eF6589cC3A579A2",
      symbol: "MKR",
    },
  },
  {
    id: "0x577ef4e9add200a2397c3eea1420584561c596d883b5361b18b0d35b62f3c724",
    name: "USDC / WETH",
    irm: "0x870aC11D48B15DB9a138Cf899d20F13F79Ba00BC",
    lltv: "385000000000000000",
    oracle: "0xaE4750d0813B5E37A51f7629beedd72AF1f9cA35",
    loanToken: {
      address: "0xA0b86991c6218b36c1d19D4a2e9Eb0cE3606eB48",
      symbol: "USDC",
    },
    collateralToken: {
      address: "0xC02aaA39b223FE8D0A0e5C4F27eAD9083C756Cc2",
      symbol: "WETH",
    },
  },
  {
    id: "0x576acd27f398d0076250ee1fe7c5655d36e915dd4c4b2e2bed2ac112250fa35f",
    name: "AUSD / wstETH",
    irm: "0x870aC11D48B15DB9a138Cf899d20F13F79Ba00BC",
    lltv: "860000000000000000",
    oracle: "0xD44Ae11b9e914DD564b8D2166B11EF59C4E26b94",
    loanToken: {
      address: "0x00000000eFE302BEAA2b3e6e1b18d08D69a9012a",
      symbol: "AUSD",
    },
    collateralToken: {
      address: "0x7f39C581F595B53c5cb19bD0b3f8dA6c935E2Ca0",
      symbol: "wstETH",
    },
  },
  {
    id: "0x56373aafef5d6a954874cfcc296b41e9a3c5e4b5d3b6bb999283696213ee442c",
    name: "AUSD / cbBTC",
    irm: "0x870aC11D48B15DB9a138Cf899d20F13F79Ba00BC",
    lltv: "860000000000000000",
    oracle: "0xBCc155057F289bF8187baBDf21Eb67fba597067e",
    loanToken: {
      address: "0x00000000eFE302BEAA2b3e6e1b18d08D69a9012a",
      symbol: "AUSD",
    },
    collateralToken: {
      address: "0xcbB7C0000aB88B473b1f5aFd9ef808440eed33Bf",
      symbol: "cbBTC",
    },
  },
  {
    id: "0x55f82d3c3e0d2c64c3ca4aab01e3038489c9b3b8714ab277d9c61c2a14c1f066",
    name: "USDA / PT-weETH-26DEC2024",
    irm: "0x870aC11D48B15DB9a138Cf899d20F13F79Ba00BC",
    lltv: "860000000000000000",
    oracle: "0xE8b74600CF80e3B38e2B186c981325FF7Ede161B",
    loanToken: {
      address: "0x0000206329b97DB379d5E1Bf586BbDB969C63274",
      symbol: "USDA",
    },
    collateralToken: {
      address: "0x6ee2b5E19ECBa773a352E5B21415Dc419A700d1d",
      symbol: "PT-weETH-26DEC2024",
    },
  },
  {
    id: "0x55ce9937dc9c8889abadbe3d30e5d06ca7a9aa85913db2138ef5170983644755",
    name: "ZCHF / xCVX",
    irm: "0x870aC11D48B15DB9a138Cf899d20F13F79Ba00BC",
    lltv: "770000000000000000",
    oracle: "0x4ef4f2826FD7AcDC1b31ffc206677d11295a6Bc5",
    loanToken: {
      address: "0xB58E61C3098d85632Df34EecfB899A1Ed80921cB",
      symbol: "ZCHF",
    },
    collateralToken: {
      address: "0xB90D347e10a085B591955Cbd0603aC7866fCADC8",
      symbol: "xCVX",
    },
  },
  {
    id: "0x55609be688a4d96e715bfe39969133bd4e7f83db4f77bb06216109189a11f2e5",
    name: "VUSD / hemiBTC",
    irm: "0x870aC11D48B15DB9a138Cf899d20F13F79Ba00BC",
    lltv: "770000000000000000",
    oracle: "0xda360F40ECe64F63B87E214297734e57Fb281e8C",
    loanToken: {
      address: "0xCa83DDE9c22254f58e771bE5E157773212AcBAc3",
      symbol: "VUSD",
    },
    collateralToken: {
      address: "0x06ea695B91700071B161A434fED42D1DcbAD9f00",
      symbol: "hemiBTC",
    },
  },
  {
    id: "0x554a7c19653b5b58b9e7e8349ae89f50f36298e02b44fb196816fc018fea4031",
    name: "ZCHF / xCVX",
    irm: "0x870aC11D48B15DB9a138Cf899d20F13F79Ba00BC",
    lltv: "625000000000000000",
    oracle: "0x4ef4f2826FD7AcDC1b31ffc206677d11295a6Bc5",
    loanToken: {
      address: "0xB58E61C3098d85632Df34EecfB899A1Ed80921cB",
      symbol: "ZCHF",
    },
    collateralToken: {
      address: "0xB90D347e10a085B591955Cbd0603aC7866fCADC8",
      symbol: "xCVX",
    },
  },
  {
    id: "0x54e42432a7c0309ba650080cab6fcff377034fd9de174bbd3a4b519186ffc0f8",
    name: "AUSD / PT-stcUSD-23JUL2026",
    irm: "0x870aC11D48B15DB9a138Cf899d20F13F79Ba00BC",
    lltv: "915000000000000000",
    oracle: "0x11aEFbf08bAB2b3f3141c2CC4749A638c4c3b674",
    loanToken: {
      address: "0x00000000eFE302BEAA2b3e6e1b18d08D69a9012a",
      symbol: "AUSD",
    },
    collateralToken: {
      address: "0x2d3C279E5FcDF5b793c0a75ed90738D7369B0b83",
      symbol: "PT-stcUSD-23JUL2026",
    },
  },
  {
    id: "0x54ce65cbbe6ed3efafb69eb2a36fe6aecddde7110ccef6119607eced963650a5",
    name: "USDC / ysUSDS",
    irm: "0x870aC11D48B15DB9a138Cf899d20F13F79Ba00BC",
    lltv: "980000000000000000",
    oracle: "0xd6154930A8df0A488Fae08547E53221B572EEA37",
    loanToken: {
      address: "0xA0b86991c6218b36c1d19D4a2e9Eb0cE3606eB48",
      symbol: "USDC",
    },
    collateralToken: {
      address: "0x4cE9c93513DfF543Bc392870d57dF8C04e89Ba0a",
      symbol: "ysUSDS",
    },
  },
  {
    id: "0x5413b86d5c0a2950aedcbdb6b5074a63e92fda3375f76d0eeea0f359605508f7",
    name: "AUSD / PT-wsrUSD-26FEB2026",
    irm: "0x870aC11D48B15DB9a138Cf899d20F13F79Ba00BC",
    lltv: "915000000000000000",
    oracle: "0x2045ebFB4aaf5aaE679FC387374515647Dc41553",
    loanToken: {
      address: "0x00000000eFE302BEAA2b3e6e1b18d08D69a9012a",
      symbol: "AUSD",
    },
    collateralToken: {
      address: "0x5AA4AfE7359d5a68D193f03E013d553DEb7DbD1f",
      symbol: "PT-wsrUSD-26FEB2026",
    },
  },
  {
    id: "0x540266e1879fff261908dcd4f4c623ce99dcd4c9ae7004e9c97ed80bfcb9ea21",
    name: "USDA / Re7WETH",
    irm: "0x870aC11D48B15DB9a138Cf899d20F13F79Ba00BC",
    lltv: "860000000000000000",
    oracle: "0x76052A2A28fDCB8124f4686C63C68355b142de3B",
    loanToken: {
      address: "0x0000206329b97DB379d5E1Bf586BbDB969C63274",
      symbol: "USDA",
    },
    collateralToken: {
      address: "0x78Fc2c2eD1A4cDb5402365934aE5648aDAd094d0",
      symbol: "Re7WETH",
    },
  },
  {
    id: "0x52b1a14ca2cd6b99cd9b39bb52f6d0dec07dc718d7be3bedb8e925f32ee6d0d9",
    name: "AUSD / syrupUSDC",
    irm: "0x870aC11D48B15DB9a138Cf899d20F13F79Ba00BC",
    lltv: "915000000000000000",
    oracle: "0x80032f4cb6E3573b9ed61E888AF658E48Fb790cC",
    loanToken: {
      address: "0x00000000eFE302BEAA2b3e6e1b18d08D69a9012a",
      symbol: "AUSD",
    },
    collateralToken: {
      address: "0x80ac24aA929eaF5013f6436cdA2a7ba190f5Cc0b",
      symbol: "syrupUSDC",
    },
  },
  {
    id: "0x5265ed20a4458a0c802c06e5cb1b54e91982db3cb7fd90d8820c424e5ceb4489",
    name: "USD0 / PT-sUSDE-29MAY2025",
    irm: "0x870aC11D48B15DB9a138Cf899d20F13F79Ba00BC",
    lltv: "915000000000000000",
    oracle: "0xefC7Abe6E30732860D4f8Fe5f91F1C868505688F",
    loanToken: {
      address: "0x73A15FeD60Bf67631dC6cd7Bc5B6e8da8190aCF5",
      symbol: "USD0",
    },
    collateralToken: {
      address: "0xb7de5dFCb74d25c2f21841fbd6230355C50d9308",
      symbol: "PT-sUSDE-29MAY2025",
    },
  },
  {
    id: "0x523da18ff9c5a19bd813550d7d1a727f74152ce38fd46f6d9e6e40a46de76dbf",
    name: "EURCV / WBTC",
    irm: "0x870aC11D48B15DB9a138Cf899d20F13F79Ba00BC",
    lltv: "860000000000000000",
    oracle: "0xfE55e3BCF0C90E050da9Ac9E7CE7142f3054Bc9D",
    loanToken: {
      address: "0x5F7827FDeb7c20b443265Fc2F40845B715385Ff2",
      symbol: "EURCV",
    },
    collateralToken: {
      address: "0x2260FAC5E5542a773Aa44fBCfeDf7C193bc2C599",
      symbol: "WBTC",
    },
  },
  {
    id: "0x51c094110992e3ce06db11ca7fa576788258300cca77d2f26131b476f81e0cb2",
    name: "USDC / PT-USDat-27AUG2026",
    irm: "0x870aC11D48B15DB9a138Cf899d20F13F79Ba00BC",
    lltv: "915000000000000000",
    oracle: "0xDAd04877702ca7F4a02ECCDfa1D0BFD2bB2Be6b8",
    loanToken: {
      address: "0xA0b86991c6218b36c1d19D4a2e9Eb0cE3606eB48",
      symbol: "USDC",
    },
    collateralToken: {
      address: "0x1D69402390657308C91179aa184bF992908c1e08",
      symbol: "PT-USDat-27AUG2026",
    },
  },
  {
    id: "0x513803f12c258fd1c3016348a788ab108c87858bac3c39a4a5154d4297f5cad9",
    name: "USDC / PT-wstUSR-1750896030",
    irm: "0x870aC11D48B15DB9a138Cf899d20F13F79Ba00BC",
    lltv: "915000000000000000",
    oracle: "0xf6C1A5532b61b997293CC09803ea475375e46fb7",
    loanToken: {
      address: "0xA0b86991c6218b36c1d19D4a2e9Eb0cE3606eB48",
      symbol: "USDC",
    },
    collateralToken: {
      address: "0x4A977653c58CFD82d42fd706cf68A0c1B6d0ca56",
      symbol: "PT-wstUSR-1750896030",
    },
  },
  {
    id: "0x50eccf3ce146eae380de93d362a2da80f81ee8acd72ac91ea0de141cae08e395",
    name: "sUSDS / PT-sUSDE-27NOV2025",
    irm: "0x870aC11D48B15DB9a138Cf899d20F13F79Ba00BC",
    lltv: "915000000000000000",
    oracle: "0x22a2b64234a1F80A7DEFeff9BB3A8127B8667956",
    loanToken: {
      address: "0xa3931d71877C0E7a3148CB7Eb4463524FEc27fbD",
      symbol: "sUSDS",
    },
    collateralToken: {
      address: "0xe6A934089BBEe34F832060CE98848359883749B3",
      symbol: "PT-sUSDE-27NOV2025",
    },
  },
  {
    id: "0x50e1cfa489db54c5e33c03cd5e30c45558bea125520fcc7e3a84e505061e2829",
    name: "AUSD / wstETH",
    irm: "0x870aC11D48B15DB9a138Cf899d20F13F79Ba00BC",
    lltv: "860000000000000000",
    oracle: "0xBC693693fDBB177Ad05ff38633110016BC043AC5",
    loanToken: {
      address: "0x00000000eFE302BEAA2b3e6e1b18d08D69a9012a",
      symbol: "AUSD",
    },
    collateralToken: {
      address: "0x7f39C581F595B53c5cb19bD0b3f8dA6c935E2Ca0",
      symbol: "wstETH",
    },
  },
  {
    id: "0x4fbdeb7979204a25b8dec7e4ed65998d358d32debee19ae738202becc52ec4b8",
    name: "frxUSD / unknown",
    irm: "0x870aC11D48B15DB9a138Cf899d20F13F79Ba00BC",
    lltv: "915000000000000000",
    oracle: "0x0c63A83a404AE7FA679A35F98C38C05A60Aa820C",
    loanToken: {
      address: "0xCAcd6fd266aF91b8AeD52aCCc382b4e165586E29",
      symbol: "frxUSD",
    },
    collateralToken: {
      address: "0x12D706F0aDFF3BE5d9Fa119424A85388FeCD6960",
      symbol: "unknown",
    },
  },
  {
    id: "0x4ebe73200ef920f3b0fbbaf7d9b2472538d650efed4b171a24a4f0b7ca339388",
    name: "DAI / wstETH",
    irm: "0x870aC11D48B15DB9a138Cf899d20F13F79Ba00BC",
    lltv: "860000000000000000",
    oracle: "0x51bB52307882A6B0d87558b7955902e76cE03cF5",
    loanToken: {
      address: "0x6B175474E89094C44Da98b954EedeAC495271d0F",
      symbol: "DAI",
    },
    collateralToken: {
      address: "0x7f39C581F595B53c5cb19bD0b3f8dA6c935E2Ca0",
      symbol: "wstETH",
    },
  },
  {
    id: "0x4db564389eea41a5db10a0d4bd6a1c7be471bbc13d5fe8674892c3e4f186dc27",
    name: "frxUSD / cbBTC",
    irm: "0x870aC11D48B15DB9a138Cf899d20F13F79Ba00BC",
    lltv: "860000000000000000",
    oracle: "0xF7A0e51cebD98a31947CaE1DDa8C0717D10ADd61",
    loanToken: {
      address: "0xCAcd6fd266aF91b8AeD52aCCc382b4e165586E29",
      symbol: "frxUSD",
    },
    collateralToken: {
      address: "0xcbB7C0000aB88B473b1f5aFd9ef808440eed33Bf",
      symbol: "cbBTC",
    },
  },
  {
    id: "0x4d6dc8e8d62fd70f9e1a4102a294d3f1249deaf7481371685703d2d6af9d3d93",
    name: "USR / ",
    irm: "0x870aC11D48B15DB9a138Cf899d20F13F79Ba00BC",
    lltv: "860000000000000000",
    oracle: "0x4D2d98D0F094E74f64E2056b0a544F318108C552",
    loanToken: {
      address: "0x66a1E37c9b0eAddca17d3662D6c05F4DECf3e110",
      symbol: "USR",
    },
    collateralToken: {
      address: "0xE11dbbCe9D0bfbe919a8427C3AE5E04E9572cf68",
      symbol: "",
    },
  },
  {
    id: "0x4d476977cc953c75516f56df0ce6a07d5fffc1de039f56178057576db20452a7",
    name: "USR / PT-RLP-9APR2026",
    irm: "0x870aC11D48B15DB9a138Cf899d20F13F79Ba00BC",
    lltv: "860000000000000000",
    oracle: "0x1fe882B57bc42f207ecc9bA32F5815e94c36f589",
    loanToken: {
      address: "0x66a1E37c9b0eAddca17d3662D6c05F4DECf3e110",
      symbol: "USR",
    },
    collateralToken: {
      address: "0x29fD7180E5cCEd14Ad148c7997e6B6857a8BE86e",
      symbol: "PT-RLP-9APR2026",
    },
  },
  {
    id: "0x4cd900f6dcfe6ae89a5bde12af4289679a7810e2b25f48efa297a4b28f62b8c2",
    name: "USDC / PT-reUSD-25JUN2026",
    irm: "0x870aC11D48B15DB9a138Cf899d20F13F79Ba00BC",
    lltv: "915000000000000000",
    oracle: "0x19BfF3233ab2F0Fc81F4CceF6907C993EcF1bf13",
    loanToken: {
      address: "0xA0b86991c6218b36c1d19D4a2e9Eb0cE3606eB48",
      symbol: "USDC",
    },
    collateralToken: {
      address: "0x3EAA0F0f0A5d3D595ae4e4b0D27f439d01c3E7b2",
      symbol: "PT-reUSD-25JUN2026",
    },
  },
  {
    id: "0x4c8974cfb67ce221fa6983b5209553ebe69cc4d4815737e7e8e6db7a16a66fd9",
    name: "EURCV / steakUSDC",
    irm: "0x870aC11D48B15DB9a138Cf899d20F13F79Ba00BC",
    lltv: "915000000000000000",
    oracle: "0xDC90FB5C08fb373279672728ad2d8c3988DBeF16",
    loanToken: {
      address: "0x5F7827FDeb7c20b443265Fc2F40845B715385Ff2",
      symbol: "EURCV",
    },
    collateralToken: {
      address: "0xbeef088055857739C12CD3765F20b7679Def0f51",
      symbol: "steakUSDC",
    },
  },
  {
    id: "0x4c35e54387d17e417f38689082cffea7df3c79d0e84eccd4721acfaa8717e5a9",
    name: "wUSDM / cbBTC",
    irm: "0x870aC11D48B15DB9a138Cf899d20F13F79Ba00BC",
    lltv: "860000000000000000",
    oracle: "0x11105336EAA0F9FA2d8ce3242F611A62D463f4cB",
    loanToken: {
      address: "0x57F5E098CaD7A3D1Eed53991D4d66C45C9AF7812",
      symbol: "wUSDM",
    },
    collateralToken: {
      address: "0xcbB7C0000aB88B473b1f5aFd9ef808440eed33Bf",
      symbol: "cbBTC",
    },
  },
  {
    id: "0x4b86442549b52826e0fc11770ec5154450cb3c5c14dc751a761d81dcfbe7a7b2",
    name: "AUSD / RLP",
    irm: "0x870aC11D48B15DB9a138Cf899d20F13F79Ba00BC",
    lltv: "860000000000000000",
    oracle: "0x19018450A02bC5c1994eaD517498311f64B2626a",
    loanToken: {
      address: "0x00000000eFE302BEAA2b3e6e1b18d08D69a9012a",
      symbol: "AUSD",
    },
    collateralToken: {
      address: "0x4956b52aE2fF65D74CA2d61207523288e4528f96",
      symbol: "RLP",
    },
  },
  {
    id: "0x4b64c12b086173a928162ca5f7a80584a3a87927784314da8734517e64e24485",
    name: "USDS / PT-staking-USDS-18DEC2025",
    irm: "0x870aC11D48B15DB9a138Cf899d20F13F79Ba00BC",
    lltv: "965000000000000000",
    oracle: "0x0F9D6c72959d836D4DECdE30Ab0AD836979EFE87",
    loanToken: {
      address: "0xdC035D45d973E3EC169d2276DDab16f1e407384F",
      symbol: "USDS",
    },
    collateralToken: {
      address: "0xA2a420230A5cb045db052E377D20b9c156805b95",
      symbol: "PT-staking-USDS-18DEC2025",
    },
  },
  {
    id: "0x4affe8d17d001e243cac3b414ab52112b1574103ef550d410e16c7815ae44580",
    name: "frxUSD / sDOLA",
    irm: "0x870aC11D48B15DB9a138Cf899d20F13F79Ba00BC",
    lltv: "915000000000000000",
    oracle: "0x1eB7aC7Ff00568B2c01636487cA938821E931e32",
    loanToken: {
      address: "0xCAcd6fd266aF91b8AeD52aCCc382b4e165586E29",
      symbol: "frxUSD",
    },
    collateralToken: {
      address: "0xb45ad160634c528Cc3D2926d9807104FA3157305",
      symbol: "sDOLA",
    },
  },
  {
    id: "0x4a837d0c26ea6c49d3bd4c4b5cbcd400357e6bf1872cc969a72e08ea2beb39b3",
    name: "crvUSD / scrvUSD",
    irm: "0x870aC11D48B15DB9a138Cf899d20F13F79Ba00BC",
    lltv: "980000000000000000",
    oracle: "0x04448c2f45341B15c1E5C8cDB8BC4E29187809aC",
    loanToken: {
      address: "0xf939E0A03FB07F59A73314E73794Be0E57ac1b4E",
      symbol: "crvUSD",
    },
    collateralToken: {
      address: "0x0655977FEb2f289A4aB78af67BAB0d17aAb84367",
      symbol: "scrvUSD",
    },
  },
  {
    id: "0x4a650d485206a6ee696b032adec2eed3dfdc1809d405116f8390a1657795dee5",
    name: "USDtb / PT-sUSDE-5FEB2026",
    irm: "0x870aC11D48B15DB9a138Cf899d20F13F79Ba00BC",
    lltv: "915000000000000000",
    oracle: "0xdDA9B3080d7c755919Fe89Bc74971B923f16cE00",
    loanToken: {
      address: "0xC139190F447e929f090Edeb554D95AbB8b18aC1C",
      symbol: "USDtb",
    },
    collateralToken: {
      address: "0xE8483517077afa11A9B07f849cee2552f040d7b2",
      symbol: "PT-sUSDE-5FEB2026",
    },
  },
  {
    id: "0x4a4485b1b7efcc440f9435dbf982fb4a428edf2e16549c75158fe8e125c9702d",
    name: "wUSDM / wstETH",
    irm: "0x870aC11D48B15DB9a138Cf899d20F13F79Ba00BC",
    lltv: "860000000000000000",
    oracle: "0xE0adEFAe3C4115BFe7Dc29A172c5F46b4b5df621",
    loanToken: {
      address: "0x57F5E098CaD7A3D1Eed53991D4d66C45C9AF7812",
      symbol: "wUSDM",
    },
    collateralToken: {
      address: "0x7f39C581F595B53c5cb19bD0b3f8dA6c935E2Ca0",
      symbol: "wstETH",
    },
  },
  {
    id: "0x4a314613c7128ab6da63df00329a8574ea7b9dd2a9293836eef10c57a4c90a92",
    name: "lvWETH / lvstETH",
    irm: "0x870aC11D48B15DB9a138Cf899d20F13F79Ba00BC",
    lltv: "945000000000000000",
    oracle: "0x7Ce5A094a748FbEFC48Fc67d4610dB571fb7F088",
    loanToken: {
      address: "0x326171F120ABCB3dD9A5659533a9Db0EA473ddC5",
      symbol: "lvWETH",
    },
    collateralToken: {
      address: "0x900c0beD5ce2DA7D3e49816d97E11FF82D7f9C3E",
      symbol: "lvstETH",
    },
  },
  {
    id: "0x4987abb1971947da9be3a47a58cb846a57b8a33bb3db1b0b2c6a3599c8b3a576",
    name: "USR / mMEV",
    irm: "0x870aC11D48B15DB9a138Cf899d20F13F79Ba00BC",
    lltv: "915000000000000000",
    oracle: "0x4BB6856d158477aC4c69a5Ae87a4e8A8Cd6DD1df",
    loanToken: {
      address: "0x66a1E37c9b0eAddca17d3662D6c05F4DECf3e110",
      symbol: "USR",
    },
    collateralToken: {
      address: "0x030b69280892c888670EDCDCD8B69Fd8026A0BF3",
      symbol: "mMEV",
    },
  },
  {
    id: "0x47c17f2188c54eedad216c6242a0a2c68db155056b23dddb82255c9addc8d652",
    name: "apxUSD / USDC",
    irm: "0x870aC11D48B15DB9a138Cf899d20F13F79Ba00BC",
    lltv: "945000000000000000",
    oracle: "0xC623Ac9D20843CCD4df1B9c3aB54f60F0318D377",
    loanToken: {
      address: "0x98A878b1Cd98131B271883B390f68D2c90674665",
      symbol: "apxUSD",
    },
    collateralToken: {
      address: "0xA0b86991c6218b36c1d19D4a2e9Eb0cE3606eB48",
      symbol: "USDC",
    },
  },
  {
    id: "0x4749ec2572bb317cb8c9b2020a273550135ff9869217b5fbac29b31c11160fc8",
    name: "AUSD / PT-STRCx-27AUG2026",
    irm: "0x870aC11D48B15DB9a138Cf899d20F13F79Ba00BC",
    lltv: "915000000000000000",
    oracle: "0x6bC3c4c041007086d9b8B3F5d3C575579f4776a0",
    loanToken: {
      address: "0x00000000eFE302BEAA2b3e6e1b18d08D69a9012a",
      symbol: "AUSD",
    },
    collateralToken: {
      address: "0x4ad88F62310D377c60F6B0c25Bde8011f315EeA7",
      symbol: "PT-STRCx-27AUG2026",
    },
  },
  {
    id: "0x472cd205789109ead2e8820db9f02b6e2f3316f39f114a3f1de57d9a2b966bb7",
    name: "USDC / USDY",
    irm: "0x870aC11D48B15DB9a138Cf899d20F13F79Ba00BC",
    lltv: "860000000000000000",
    oracle: "0xDddd770BADd886dF3864029e4B377B5F6a2B6b83",
    loanToken: {
      address: "0xA0b86991c6218b36c1d19D4a2e9Eb0cE3606eB48",
      symbol: "USDC",
    },
    collateralToken: {
      address: "0x96F6eF951840721AdBF46Ac996b59E0235CB985C",
      symbol: "USDY",
    },
  },
  {
    id: "0x46efe96ef478b1fd73e01e972b680310a86dfa55615db20342a46f8df44bc88e",
    name: "GRAM / JERRY",
    irm: "0x870aC11D48B15DB9a138Cf899d20F13F79Ba00BC",
    lltv: "625000000000000000",
    oracle: "0x5b720968a714028879A174Ccd6599f21C0a5409b",
    loanToken: {
      address: "0x845f64673a2407320C2cC12e23b669DC16F7A473",
      symbol: "GRAM",
    },
    collateralToken: {
      address: "0x3D678E83acf8EFd9A80509674EF811228D79D0eE",
      symbol: "JERRY",
    },
  },
  {
    id: "0x46de157284f68a4664c5ec77c4e4a077110b0acbdc77edb72ed4b69741161333",
    name: "USDC / yPrism",
    irm: "0x870aC11D48B15DB9a138Cf899d20F13F79Ba00BC",
    lltv: "860000000000000000",
    oracle: "0x299a9b81bA29a0D0272F04EB3dC67bA9de9BA000",
    loanToken: {
      address: "0xA0b86991c6218b36c1d19D4a2e9Eb0cE3606eB48",
      symbol: "USDC",
    },
    collateralToken: {
      address: "0xDd5eff0756dB08BAD0Ff16b66f88F506e7318894",
      symbol: "yPrism",
    },
  },
  {
    id: "0x467650db29b29797c6f9cc203edef49499871774589a8e56ca93c936a55655d8",
    name: "tGBP / PAXG",
    irm: "0x870aC11D48B15DB9a138Cf899d20F13F79Ba00BC",
    lltv: "770000000000000000",
    oracle: "0xC9889C7E46A35f5e50a3C2B5c413fB4615B443e5",
    loanToken: {
      address: "0x27f6c8289550fCE67f6B50BeD1F519966aFE5287",
      symbol: "tGBP",
    },
    collateralToken: {
      address: "0x45804880De22913dAFE09f4980848ECE6EcbAf78",
      symbol: "PAXG",
    },
  },
  {
    id: "0x4636a99cf18e101316b09e663891dbee56d68eabd3e2b3d21216dc35bf652a9b",
    name: "USDC / splDXY-BEAR",
    irm: "0x870aC11D48B15DB9a138Cf899d20F13F79Ba00BC",
    lltv: "915000000000000000",
    oracle: "0x7c5fa969E5583C39C1D40d537E57917d88Ef5884",
    loanToken: {
      address: "0xA0b86991c6218b36c1d19D4a2e9Eb0cE3606eB48",
      symbol: "USDC",
    },
    collateralToken: {
      address: "0xDC7366b8BB83f9ABa2B4F989194D6c03D0A20DE9",
      symbol: "splDXY-BEAR",
    },
  },
  {
    id: "0x45dd817c1f3dac9ed4fd53502d905a946422b269fe5cc266542123966148d56b",
    name: "USDC / bravUSDC",
    irm: "0x870aC11D48B15DB9a138Cf899d20F13F79Ba00BC",
    lltv: "945000000000000000",
    oracle: "0x876f6f1FfcE1cDB0d8604b7179312597Ca624C25",
    loanToken: {
      address: "0xA0b86991c6218b36c1d19D4a2e9Eb0cE3606eB48",
      symbol: "USDC",
    },
    collateralToken: {
      address: "0x9f96E4B65059b0398B922792d3fF9F10B4567533",
      symbol: "bravUSDC",
    },
  },
  {
    id: "0x44f51e6b7356132597872e40c8d4a5bb2f1fc2c99e7292ee3b3953d9074086b6",
    name: "USDS / Mog",
    irm: "0x870aC11D48B15DB9a138Cf899d20F13F79Ba00BC",
    lltv: "625000000000000000",
    oracle: "0xa022aDB8C6bD4c25325A662cB928570a8e3966b4",
    loanToken: {
      address: "0xdC035D45d973E3EC169d2276DDab16f1e407384F",
      symbol: "USDS",
    },
    collateralToken: {
      address: "0xaaeE1A9723aaDB7afA2810263653A34bA2C21C7a",
      symbol: "Mog",
    },
  },
  {
    id: "0x44b8b70f5957e1e3665475a07288a051818d3b7b780145304fd6039953627009",
    name: "USR / PT-RLP-4DEC2025",
    irm: "0x870aC11D48B15DB9a138Cf899d20F13F79Ba00BC",
    lltv: "860000000000000000",
    oracle: "0x136cD64076901052281CA907C5f32A22F3BA5E42",
    loanToken: {
      address: "0x66a1E37c9b0eAddca17d3662D6c05F4DECf3e110",
      symbol: "USR",
    },
    collateralToken: {
      address: "0x3A70F0C696dcB3A4aB3833cD9726397dD61AC85e",
      symbol: "PT-RLP-4DEC2025",
    },
  },
  {
    id: "0x444bbce85350aae535b037d090c8bdf6cc4cfc6d79e17725413b4cb0f6183ad4",
    name: "cbBTC / LBTC",
    irm: "0x870aC11D48B15DB9a138Cf899d20F13F79Ba00BC",
    lltv: "945000000000000000",
    oracle: "0x1Ce1a1e68F26019CAf5E823A56e300755D70D078",
    loanToken: {
      address: "0xcbB7C0000aB88B473b1f5aFd9ef808440eed33Bf",
      symbol: "cbBTC",
    },
    collateralToken: {
      address: "0x8236a87084f8B84306f72007F36F2618A5634494",
      symbol: "LBTC",
    },
  },
  {
    id: "0x4404c08cd0f12fe6e5e10202061d2f8d2d6ae83b8f0ec852a15f26e64dfb2745",
    name: "crvUSD / yvyCRV",
    irm: "0x870aC11D48B15DB9a138Cf899d20F13F79Ba00BC",
    lltv: "770000000000000000",
    oracle: "0x411fFB38A25E254a7C0393e8fA04eF30Dc645d03",
    loanToken: {
      address: "0xf939E0A03FB07F59A73314E73794Be0E57ac1b4E",
      symbol: "crvUSD",
    },
    collateralToken: {
      address: "0x27B5739e22ad9033bcBf192059122d163b60349D",
      symbol: "yvyCRV",
    },
  },
  {
    id: "0x43ae7c4b8faba733bcb5832e51776f92a8008746239bffc20cd20fcce8c444b2",
    name: "msUSD / syrupUSDC",
    irm: "0x870aC11D48B15DB9a138Cf899d20F13F79Ba00BC",
    lltv: "915000000000000000",
    oracle: "0x96B6E87277a8A809dc0A28675d8cc40000cd7F33",
    loanToken: {
      address: "0xab5eB14c09D416F0aC63661E57EDB7AEcDb9BEfA",
      symbol: "msUSD",
    },
    collateralToken: {
      address: "0x80ac24aA929eaF5013f6436cdA2a7ba190f5Cc0b",
      symbol: "syrupUSDC",
    },
  },
  {
    id: "0x43a844e5da2b2abc7ec3ec20d1dd5720c3d87978f8d5949acfb4c9b66709da22",
    name: "lvWETH / lvstETH",
    irm: "0x870aC11D48B15DB9a138Cf899d20F13F79Ba00BC",
    lltv: "945000000000000000",
    oracle: "0xb1aC7D1D4B6916E7DD8FFe63e6155232FED5b1D7",
    loanToken: {
      address: "0x653Ba68f6aA4B5b9a957E21628CD514A43E5a684",
      symbol: "lvWETH",
    },
    collateralToken: {
      address: "0x69Da9Ee455f5A230ADEd5D90d2798144350C4B2e",
      symbol: "lvstETH",
    },
  },
  {
    id: "0x439a4b93826f643fead718d912f3bfa3badcd77cb39ee9e4bae4688a28decdf4",
    name: "USDC / AIDaUSDT",
    irm: "0x870aC11D48B15DB9a138Cf899d20F13F79Ba00BC",
    lltv: "860000000000000000",
    oracle: "0x7e3aF96b9954baf8cf891547dF0dB666fd9bC5C6",
    loanToken: {
      address: "0xA0b86991c6218b36c1d19D4a2e9Eb0cE3606eB48",
      symbol: "USDC",
    },
    collateralToken: {
      address: "0xDc45e7027A0489FE6C2E4A0735097d8E6952A340",
      symbol: "AIDaUSDT",
    },
  },
  {
    id: "0x43369594ab6418d271faed215965d3d5b74a7692e0dcf656c6d5b4828c240389",
    name: "WETH / dWETHV3",
    irm: "0x870aC11D48B15DB9a138Cf899d20F13F79Ba00BC",
    lltv: "945000000000000000",
    oracle: "0x6e0b1A5D35a191edE6DdD7Cf888E87A147F2741e",
    loanToken: {
      address: "0xC02aaA39b223FE8D0A0e5C4F27eAD9083C756Cc2",
      symbol: "WETH",
    },
    collateralToken: {
      address: "0xda0002859B2d05F66a753d8241fCDE8623f26F4f",
      symbol: "dWETHV3",
    },
  },
  {
    id: "0x42e157d3739f9ae3f418f5dd0977b7d51c3a677502afd9f3f594f46cc07dec6a",
    name: "crvUSD / ",
    irm: "0x870aC11D48B15DB9a138Cf899d20F13F79Ba00BC",
    lltv: "860000000000000000",
    oracle: "0x18B0d7311a97c5377445C80c768ab5201Bb27B5a",
    loanToken: {
      address: "0xf939E0A03FB07F59A73314E73794Be0E57ac1b4E",
      symbol: "crvUSD",
    },
    collateralToken: {
      address: "0x6BA072F0d22806F2C52e9792AF47f2D59103BEBE",
      symbol: "",
    },
  },
  {
    id: "0x42644ceb5bf95a2c22c85ce5766942c6caeea73db07573e0048b3e340ea9e542",
    name: "crvUSD / ",
    irm: "0x870aC11D48B15DB9a138Cf899d20F13F79Ba00BC",
    lltv: "860000000000000000",
    oracle: "0xE9e1734F3AbC217DaCF83bda5740cA6762020c69",
    loanToken: {
      address: "0xf939E0A03FB07F59A73314E73794Be0E57ac1b4E",
      symbol: "crvUSD",
    },
    collateralToken: {
      address: "0xAb122ae30b3eE050F0Eb30009DEec6aCC6B06D36",
      symbol: "",
    },
  },
  {
    id: "0x4212ddead99e2a680fc2e7fe0ea4c00dba16c37cb1f46d36b3d9fde14874ac37",
    name: "CUSD / MAYA",
    irm: "0x870aC11D48B15DB9a138Cf899d20F13F79Ba00BC",
    lltv: "625000000000000000",
    oracle: "0xF3689Aa19e70dcDe1A1c534751C5a05796775A5c",
    loanToken: {
      address: "0xe30f0B62E8Ae5ce2934151146dAe5651c2288C84",
      symbol: "CUSD",
    },
    collateralToken: {
      address: "0xC4D461889F3ae06e97118342862251241AC24dDC",
      symbol: "MAYA",
    },
  },
  {
    id: "0x3f8d2586f96fd5d5cd182a8256abd51a373ba9ad56d55a5302ee1fcafaa8c588",
    name: "AUSD / PT-srUSDe-15JAN2026",
    irm: "0x870aC11D48B15DB9a138Cf899d20F13F79Ba00BC",
    lltv: "915000000000000000",
    oracle: "0xF86aA25940787eb65ECB8D66d9fC9020f7c84E7F",
    loanToken: {
      address: "0x00000000eFE302BEAA2b3e6e1b18d08D69a9012a",
      symbol: "AUSD",
    },
    collateralToken: {
      address: "0x1Fb3C5c35D95F48e48FFC8e36bCCe5CB5f29F57c",
      symbol: "PT-srUSDe-15JAN2026",
    },
  },
  {
    id: "0x3f4d007982a480dd99052c05d811cf6838ce61b2a2be8dc52fca107f783d1f15",
    name: "eUSD / ETH+",
    irm: "0x870aC11D48B15DB9a138Cf899d20F13F79Ba00BC",
    lltv: "770000000000000000",
    oracle: "0xb3e24f938dB830C903450dcFe200E0AC121d8033",
    loanToken: {
      address: "0xA0d69E286B938e21CBf7E51D71F6A4c8918f482F",
      symbol: "eUSD",
    },
    collateralToken: {
      address: "0xE72B141DF173b999AE7c1aDcbF60Cc9833Ce56a8",
      symbol: "ETH+",
    },
  },
  {
    id: "0x3f1d5c88c72432b04f2074499fe217468af49ddaa98bcb6ec80b08f76a82c6ec",
    name: "USDS / Mog",
    irm: "0x870aC11D48B15DB9a138Cf899d20F13F79Ba00BC",
    lltv: "770000000000000000",
    oracle: "0xa022aDB8C6bD4c25325A662cB928570a8e3966b4",
    loanToken: {
      address: "0xdC035D45d973E3EC169d2276DDab16f1e407384F",
      symbol: "USDS",
    },
    collateralToken: {
      address: "0xaaeE1A9723aaDB7afA2810263653A34bA2C21C7a",
      symbol: "Mog",
    },
  },
  {
    id: "0x3efaf643d50d16440b4fa629b0700f3d5323e34ac577aacb0220324d7f0e3327",
    name: "WETH / sUSDU",
    irm: "0x870aC11D48B15DB9a138Cf899d20F13F79Ba00BC",
    lltv: "860000000000000000",
    oracle: "0x32c1d7e4F4e0ACcb5bbD7e6A2F0F4a0454e79e35",
    loanToken: {
      address: "0xC02aaA39b223FE8D0A0e5C4F27eAD9083C756Cc2",
      symbol: "WETH",
    },
    collateralToken: {
      address: "0xcE22b5Fb17ccbc0C5d87DC2e0dF47DD71E3AdC0a",
      symbol: "sUSDU",
    },
  },
  {
    id: "0x3eb72424727f9e0b23717be5fc69be672495b24b3cd101805b175729e2295308",
    name: "AUSD / PT-STRCx-27AUG2026",
    irm: "0x870aC11D48B15DB9a138Cf899d20F13F79Ba00BC",
    lltv: "915000000000000000",
    oracle: "0xCEfc4A1b3af7c68613f198fe3e3ab10015172288",
    loanToken: {
      address: "0x00000000eFE302BEAA2b3e6e1b18d08D69a9012a",
      symbol: "AUSD",
    },
    collateralToken: {
      address: "0x4ad88F62310D377c60F6B0c25Bde8011f315EeA7",
      symbol: "PT-STRCx-27AUG2026",
    },
  },
  {
    id: "0x3e29fdb9fefb8930c040f661368c505edc5081e86112c6da4238d683f6f282ac",
    name: "rUSD / wsrUSD",
    irm: "0x870aC11D48B15DB9a138Cf899d20F13F79Ba00BC",
    lltv: "980000000000000000",
    oracle: "0x04c25d6b74d9f7DeA952bbC6f427fd3d03581aB4",
    loanToken: {
      address: "0x09D4214C03D01F49544C0448DBE3A27f768F2b34",
      symbol: "rUSD",
    },
    collateralToken: {
      address: "0xd3fD63209FA2D55B07A0f6db36C2f43900be3094",
      symbol: "wsrUSD",
    },
  },
  {
    id: "0x3df62177d8dd48708addac57caad778286f104c98a6866817b105795be0605e8",
    name: "FRAX / sUSDe",
    irm: "0x870aC11D48B15DB9a138Cf899d20F13F79Ba00BC",
    lltv: "945000000000000000",
    oracle: "0x5D916980D5Ae1737a8330Bf24dF812b2911Aae25",
    loanToken: {
      address: "0x853d955aCEf822Db058eb8505911ED77F175b99e",
      symbol: "FRAX",
    },
    collateralToken: {
      address: "0x9D39A5DE30e57443BfF2A8307A4256c8797A3497",
      symbol: "sUSDe",
    },
  },
  {
    id: "0x3d46d27fc3ca354fd7c480969b8526f54389ec0f02f7178bdcb4f517d388338c",
    name: "JPYC / WETH",
    irm: "0x870aC11D48B15DB9a138Cf899d20F13F79Ba00BC",
    lltv: "625000000000000000",
    oracle: "0xC4B49C208743D88522fD90baED0E0C790d041A15",
    loanToken: {
      address: "0xE7C3D8C9a439feDe00D2600032D5dB0Be71C3c29",
      symbol: "JPYC",
    },
    collateralToken: {
      address: "0xC02aaA39b223FE8D0A0e5C4F27eAD9083C756Cc2",
      symbol: "WETH",
    },
  },
  {
    id: "0x3ccaeeefe263eb204e9bec7fdc88262aa8818b88c40e1b37fbf224ff274a9d08",
    name: "DAI / LDO",
    irm: "0x870aC11D48B15DB9a138Cf899d20F13F79Ba00BC",
    lltv: "770000000000000000",
    oracle: "0xf58E7127D2C036B95ac47e9A0739C3d4cBDA9000",
    loanToken: {
      address: "0x6B175474E89094C44Da98b954EedeAC495271d0F",
      symbol: "DAI",
    },
    collateralToken: {
      address: "0x5A98FcBEA516Cf06857215779Fd812CA3beF1B32",
      symbol: "LDO",
    },
  },
  {
    id: "0x3cc3913fc5f88bd2b5276d1be37f11a4ac79f45e209909dbeffa6fbd013ff01e",
    name: "USD0 / sUSDe",
    irm: "0x870aC11D48B15DB9a138Cf899d20F13F79Ba00BC",
    lltv: "860000000000000000",
    oracle: "0x5D916980D5Ae1737a8330Bf24dF812b2911Aae25",
    loanToken: {
      address: "0x73A15FeD60Bf67631dC6cd7Bc5B6e8da8190aCF5",
      symbol: "USD0",
    },
    collateralToken: {
      address: "0x9D39A5DE30e57443BfF2A8307A4256c8797A3497",
      symbol: "sUSDe",
    },
  },
  {
    id: "0x3cc1d2d2425360ed2dbc071cee115cbad71c278ba694a3f57b4136a47c0a88ca",
    name: "USDC / AAVE",
    irm: "0x870aC11D48B15DB9a138Cf899d20F13F79Ba00BC",
    lltv: "860000000000000000",
    oracle: "0xDddd770BADd886dF3864029e4B377B5F6a2B6b83",
    loanToken: {
      address: "0xA0b86991c6218b36c1d19D4a2e9Eb0cE3606eB48",
      symbol: "USDC",
    },
    collateralToken: {
      address: "0x7Fc66500c84A76Ad7e9c93437bFc5Ac33E2DDaE9",
      symbol: "AAVE",
    },
  },
  {
    id: "0x3c83db1ca5109a9db710154c6d3576aca3cae0c033fa635776b7cef5f3aac967",
    name: "WETH / hgETH",
    irm: "0x870aC11D48B15DB9a138Cf899d20F13F79Ba00BC",
    lltv: "915000000000000000",
    oracle: "0x70CF192D6b76d57a46AafC9285Ced110034eB013",
    loanToken: {
      address: "0xC02aaA39b223FE8D0A0e5C4F27eAD9083C756Cc2",
      symbol: "WETH",
    },
    collateralToken: {
      address: "0xc824A08dB624942c5E5F330d56530cD1598859fD",
      symbol: "hgETH",
    },
  },
  {
    id: "0x3c80fd8318295fff3b1540eb915abff4fce991e8c55af3a8e263e47118185fde",
    name: "USDC / StockMarketTRBasisTrade",
    irm: "0x870aC11D48B15DB9a138Cf899d20F13F79Ba00BC",
    lltv: "860000000000000000",
    oracle: "0x03674062e686DF26f527F982741Bf77e3C0c3542",
    loanToken: {
      address: "0xA0b86991c6218b36c1d19D4a2e9Eb0cE3606eB48",
      symbol: "USDC",
    },
    collateralToken: {
      address: "0x827Ce7E8e35861D9Ac7fE002755767b695A5594a",
      symbol: "StockMarketTRBasisTrade",
    },
  },
  {
    id: "0x3b59533a1db6a2eefc67952c25b864f542fa2e5e099945ae7401d15cf712388f",
    name: "USD0 / LBTC",
    irm: "0x870aC11D48B15DB9a138Cf899d20F13F79Ba00BC",
    lltv: "860000000000000000",
    oracle: "0xCAFd2c1BF29c3c52C54a53E6ad30abC98652EA23",
    loanToken: {
      address: "0x73A15FeD60Bf67631dC6cd7Bc5B6e8da8190aCF5",
      symbol: "USD0",
    },
    collateralToken: {
      address: "0x8236a87084f8B84306f72007F36F2618A5634494",
      symbol: "LBTC",
    },
  },
  {
    id: "0x3b4a3f2c1f0f48330b4284a0595ed76a4add5bf153bab55aefea734b937076e7",
    name: "AUSD / PT-stcUSD-29JAN2026",
    irm: "0x870aC11D48B15DB9a138Cf899d20F13F79Ba00BC",
    lltv: "915000000000000000",
    oracle: "0x57C4Af82eC8f4f30e4e1b5E68Cd13f8A5A306049",
    loanToken: {
      address: "0x00000000eFE302BEAA2b3e6e1b18d08D69a9012a",
      symbol: "AUSD",
    },
    collateralToken: {
      address: "0xC3c7E5E277d31CD24a3Ac4cC9af3B6770F30eA33",
      symbol: "PT-stcUSD-29JAN2026",
    },
  },
  {
    id: "0x3b08e9d4d0e45fda60f75c618341c39b3ceb82547d7cc72b0dc1a93f7eddb880",
    name: "AUSD / SPYx",
    irm: "0x870aC11D48B15DB9a138Cf899d20F13F79Ba00BC",
    lltv: "625000000000000000",
    oracle: "0xB03D212D27E22F0767F28e0dA1B31E8D9FE51C09",
    loanToken: {
      address: "0x00000000eFE302BEAA2b3e6e1b18d08D69a9012a",
      symbol: "AUSD",
    },
    collateralToken: {
      address: "0x90A2a4c76b5D8c0bc892A69EA28Aa775a8f2dD48",
      symbol: "SPYx",
    },
  },
  {
    id: "0x3ad59f343a8f90117ef3d6cfd2357400f43eeea52bcc963034e3a9d0f4e1337f",
    name: "ZCHF / xETH",
    irm: "0x870aC11D48B15DB9a138Cf899d20F13F79Ba00BC",
    lltv: "860000000000000000",
    oracle: "0xCc466992240c143394C7052Cf5d6A7c99B1dBDaC",
    loanToken: {
      address: "0xB58E61C3098d85632Df34EecfB899A1Ed80921cB",
      symbol: "ZCHF",
    },
    collateralToken: {
      address: "0xe063F04f280c60aECa68b38341C2eEcBeC703ae2",
      symbol: "xETH",
    },
  },
  {
    id: "0x3a7c4f7a5b837facbad5ca9313042d5864c4ef5dda582c5d7339dfd431f39dc1",
    name: "frxUSD / stakedao-av/frxUSD",
    irm: "0x870aC11D48B15DB9a138Cf899d20F13F79Ba00BC",
    lltv: "945000000000000000",
    oracle: "0x19747F93d0cd37FdF8bf52Bc158880888418316a",
    loanToken: {
      address: "0xCAcd6fd266aF91b8AeD52aCCc382b4e165586E29",
      symbol: "frxUSD",
    },
    collateralToken: {
      address: "0x4926F23927fbABe8580c183E07E34D4B147EaFc0",
      symbol: "stakedao-av/frxUSD",
    },
  },
  {
    id: "0x394494c539655eb489089b33eba5119ff7e322646cac3fa3e817814164bab094",
    name: "wUSDL / PAXG",
    irm: "0x870aC11D48B15DB9a138Cf899d20F13F79Ba00BC",
    lltv: "770000000000000000",
    oracle: "0x8570eda6BB803FF714471FaA47793C88255094d9",
    loanToken: {
      address: "0x7751E2F4b8ae93EF6B79d86419d42FE3295A4559",
      symbol: "wUSDL",
    },
    collateralToken: {
      address: "0x45804880De22913dAFE09f4980848ECE6EcbAf78",
      symbol: "PAXG",
    },
  },
  {
    id: "0x38db4aa4aaced737f63444a47ffa150b0cd62d4d92d2eb1809da8e9b62b50738",
    name: "tGBP / cbBTC",
    irm: "0x870aC11D48B15DB9a138Cf899d20F13F79Ba00BC",
    lltv: "860000000000000000",
    oracle: "0xb78CDdA14f87Cd27E91bF62aC4f32413ADed4Cc8",
    loanToken: {
      address: "0x27f6c8289550fCE67f6B50BeD1F519966aFE5287",
      symbol: "tGBP",
    },
    collateralToken: {
      address: "0xcbB7C0000aB88B473b1f5aFd9ef808440eed33Bf",
      symbol: "cbBTC",
    },
  },
  {
    id: "0x38d28aa002b2961f734763f6afeeb78a36a9b947cb12b988c35a5bb4bde0d1c7",
    name: "USDS / JOE",
    irm: "0x870aC11D48B15DB9a138Cf899d20F13F79Ba00BC",
    lltv: "625000000000000000",
    oracle: "0x8EE090A8486F40E059B61d23A9Ae9302508Acbbc",
    loanToken: {
      address: "0xdC035D45d973E3EC169d2276DDab16f1e407384F",
      symbol: "USDS",
    },
    collateralToken: {
      address: "0x76e222b07C53D28b89b0bAc18602810Fc22B49A8",
      symbol: "JOE",
    },
  },
  {
    id: "0x3875de955cfd8f8328a5df0ca04654ace58dfe94a49352645044e850daa41c18",
    name: "BOLD / cbETH",
    irm: "0x870aC11D48B15DB9a138Cf899d20F13F79Ba00BC",
    lltv: "860000000000000000",
    oracle: "0xaBEdb5a7f7758D20C1ca3De1d4cfa4928677ed2d",
    loanToken: {
      address: "0x6440f144b7e50D6a8439336510312d2F54beB01D",
      symbol: "BOLD",
    },
    collateralToken: {
      address: "0xBe9895146f7AF43049ca1c1AE358B0541Ea49704",
      symbol: "cbETH",
    },
  },
  {
    id: "0x3845819ef4d8ad934bdb923d7112653adfa9efa19acffeafc3ff75043d301231",
    name: "AUSD / PT-stcUSD-29JAN2026",
    irm: "0x870aC11D48B15DB9a138Cf899d20F13F79Ba00BC",
    lltv: "915000000000000000",
    oracle: "0x486A6B92c4fb03571a624f258349a012bA083d96",
    loanToken: {
      address: "0x00000000eFE302BEAA2b3e6e1b18d08D69a9012a",
      symbol: "AUSD",
    },
    collateralToken: {
      address: "0xC3c7E5E277d31CD24a3Ac4cC9af3B6770F30eA33",
      symbol: "PT-stcUSD-29JAN2026",
    },
  },
  {
    id: "0x37ae637f68cfb0bc00bd7597dcdd1c1e036a2d3eb672bb8e8e411446e22336bd",
    name: "LBTC / USDC",
    irm: "0x870aC11D48B15DB9a138Cf899d20F13F79Ba00BC",
    lltv: "860000000000000000",
    oracle: "0xC261Ef874038d67c1a1156174B4b77B9C4272F76",
    loanToken: {
      address: "0x8236a87084f8B84306f72007F36F2618A5634494",
      symbol: "LBTC",
    },
    collateralToken: {
      address: "0xA0b86991c6218b36c1d19D4a2e9Eb0cE3606eB48",
      symbol: "USDC",
    },
  },
  {
    id: "0x37997b3cf7cea3555abb101f94f39963e8256be71408165937d4fb7642039ac7",
    name: "USDS / APU",
    irm: "0x870aC11D48B15DB9a138Cf899d20F13F79Ba00BC",
    lltv: "625000000000000000",
    oracle: "0x79EC5E09282ea619c277d99308e94fB1835f83fB",
    loanToken: {
      address: "0xdC035D45d973E3EC169d2276DDab16f1e407384F",
      symbol: "USDS",
    },
    collateralToken: {
      address: "0x594DaaD7D77592a2b97b725A7AD59D7E188b5bFa",
      symbol: "APU",
    },
  },
  {
    id: "0x36b01349f1d6044288eab3a189c528c1ef8f236433d805cd2d9a930843fe61be",
    name: "lvlUSD / PT-lvlUSD-29MAY2025",
    irm: "0x870aC11D48B15DB9a138Cf899d20F13F79Ba00BC",
    lltv: "915000000000000000",
    oracle: "0x0E6D96E8aA0de4783a049d6793F33d55497c27A9",
    loanToken: {
      address: "0x7C1156E515aA1A2E851674120074968C905aAF37",
      symbol: "lvlUSD",
    },
    collateralToken: {
      address: "0x9BcA74F805AB0a22DDD0886dB0942199a0feBa71",
      symbol: "PT-lvlUSD-29MAY2025",
    },
  },
  {
    id: "0x366bc0aa9aa70a1f075096e825e9b1c7221878a90edd52081d2af5cfca3beb89",
    name: "USDS / PT-staking-USDS-25SEP2025",
    irm: "0x870aC11D48B15DB9a138Cf899d20F13F79Ba00BC",
    lltv: "965000000000000000",
    oracle: "0xaA31f21E3d23bF3A8F401E670171b0DA10F8466f",
    loanToken: {
      address: "0xdC035D45d973E3EC169d2276DDab16f1e407384F",
      symbol: "USDS",
    },
    collateralToken: {
      address: "0xC347584b415715B1b66774B2899Fef2FD3b56d6e",
      symbol: "PT-staking-USDS-25SEP2025",
    },
  },
  {
    id: "0x3626752bbe7ea4a5b7e628fcfa14e983c3726d3ec408339fb8b2e31a5de938f7",
    name: "EURC / WBTC",
    irm: "0x870aC11D48B15DB9a138Cf899d20F13F79Ba00BC",
    lltv: "860000000000000000",
    oracle: "0xA05d27f807f50B4b2Cd12368974f2dD0eF33f4F4",
    loanToken: {
      address: "0x1aBaEA1f7C830bD89Acc67eC4af516284b1bC33c",
      symbol: "EURC",
    },
    collateralToken: {
      address: "0x2260FAC5E5542a773Aa44fBCfeDf7C193bc2C599",
      symbol: "WBTC",
    },
  },
  {
    id: "0x36084d9f96e5afa80bd61b153e5afaa779bcdd2e2efb177b6f175b6a0001f6f4",
    name: "PT-mAPOLLO-29JAN2026 / USDC",
    irm: "0x870aC11D48B15DB9a138Cf899d20F13F79Ba00BC",
    lltv: "860000000000000000",
    oracle: "0x6C005eB4333ec2Ee220e68B772Dd4583e342b678",
    loanToken: {
      address: "0x955E979D243907917fda6A3a811Fb55c555b7DBA",
      symbol: "PT-mAPOLLO-29JAN2026",
    },
    collateralToken: {
      address: "0xA0b86991c6218b36c1d19D4a2e9Eb0cE3606eB48",
      symbol: "USDC",
    },
  },
  {
    id: "0x35cab197d4eaeeea1e8e279ed136e193500e65ff68b4bf8af54f98d4923660eb",
    name: "LBTC / PT-LBTC-26JUN2025",
    irm: "0x870aC11D48B15DB9a138Cf899d20F13F79Ba00BC",
    lltv: "915000000000000000",
    oracle: "0x7e93c1e24A40dF71666Ae832313300A048aADD2d",
    loanToken: {
      address: "0x8236a87084f8B84306f72007F36F2618A5634494",
      symbol: "LBTC",
    },
    collateralToken: {
      address: "0x6cA4d5d2eCb72E3Bbf17543B3367746B80D22694",
      symbol: "PT-LBTC-26JUN2025",
    },
  },
  {
    id: "0x35c92b233f962d894b5558063c926aa44fab0a5178a176211543a63039edd328",
    name: "frxUSD / unknown",
    irm: "0x870aC11D48B15DB9a138Cf899d20F13F79Ba00BC",
    lltv: "915000000000000000",
    oracle: "0x9223b246e1b80beCCD027bB7eB085087283C73a6",
    loanToken: {
      address: "0xCAcd6fd266aF91b8AeD52aCCc382b4e165586E29",
      symbol: "frxUSD",
    },
    collateralToken: {
      address: "0x728c3B9Eb722F7aFC17F0D26A80d625C53059086",
      symbol: "unknown",
    },
  },
  {
    id: "0x35669bebe1faac708df40050c4841b841e00b3b7a51fb7e091361dd0f3d3b52c",
    name: "USDA / PT-USD0++-31OCT2024",
    irm: "0x870aC11D48B15DB9a138Cf899d20F13F79Ba00BC",
    lltv: "915000000000000000",
    oracle: "0x360f5B35aac22CBbd8F0b6E916DaAeD1013FEaED",
    loanToken: {
      address: "0x0000206329b97DB379d5E1Bf586BbDB969C63274",
      symbol: "USDA",
    },
    collateralToken: {
      address: "0x270d664d2Fc7D962012a787Aec8661CA83DF24EB",
      symbol: "PT-USD0++-31OCT2024",
    },
  },
  {
    id: "0x3558ed8709ed89fc50b173e6aaa0fb5a9b5cc8af2f3bb4bfcd4e46fdc27e8a53",
    name: "PYUSD / WBTC",
    irm: "0x870aC11D48B15DB9a138Cf899d20F13F79Ba00BC",
    lltv: "860000000000000000",
    oracle: "0xFE44dc5afA1d302DCc4f71A8Ae3e5bb8cc04EC3b",
    loanToken: {
      address: "0x6c3ea9036406852006290770BEdFcAbA0e23A0e8",
      symbol: "PYUSD",
    },
    collateralToken: {
      address: "0x2260FAC5E5542a773Aa44fBCfeDf7C193bc2C599",
      symbol: "WBTC",
    },
  },
  {
    id: "0x351c12a2747b369ee31eb3b4f8814e34ce4909c8a361810c31d51f5ed2ab4239",
    name: "cbBTC / pumpBTC",
    irm: "0x870aC11D48B15DB9a138Cf899d20F13F79Ba00BC",
    lltv: "945000000000000000",
    oracle: "0x427C6C90bFcbb69e0Df2e7Ac0aBeDEe7001b9EAc",
    loanToken: {
      address: "0xcbB7C0000aB88B473b1f5aFd9ef808440eed33Bf",
      symbol: "cbBTC",
    },
    collateralToken: {
      address: "0xF469fBD2abcd6B9de8E169d128226C0Fc90a012e",
      symbol: "pumpBTC",
    },
  },
  {
    id: "0x347aa5f94a12dd46d3e17e542ca1c4033bd6952bde4b22af3caa33c82e52451a",
    name: "USDS / APU",
    irm: "0x870aC11D48B15DB9a138Cf899d20F13F79Ba00BC",
    lltv: "770000000000000000",
    oracle: "0x79EC5E09282ea619c277d99308e94fB1835f83fB",
    loanToken: {
      address: "0xdC035D45d973E3EC169d2276DDab16f1e407384F",
      symbol: "USDS",
    },
    collateralToken: {
      address: "0x594DaaD7D77592a2b97b725A7AD59D7E188b5bFa",
      symbol: "APU",
    },
  },
  {
    id: "0x3462a9442ec1aa46fc38bf91472b593b8fb86bf18eac47ebf82493dc4bed5b1b",
    name: "USDtb / PT-USDe-25SEP2025",
    irm: "0x870aC11D48B15DB9a138Cf899d20F13F79Ba00BC",
    lltv: "915000000000000000",
    oracle: "0x771d56303814d47ed20c7DF7F5d8C45600Df12B7",
    loanToken: {
      address: "0xC139190F447e929f090Edeb554D95AbB8b18aC1C",
      symbol: "USDtb",
    },
    collateralToken: {
      address: "0xBC6736d346a5eBC0dEbc997397912CD9b8FAe10a",
      symbol: "PT-USDe-25SEP2025",
    },
  },
  {
    id: "0x344d7122e517ec0bc93c16262b39eb42c4da31e2ea736751fe65e572deebd8c3",
    name: "BOLD / cbBTC",
    irm: "0x870aC11D48B15DB9a138Cf899d20F13F79Ba00BC",
    lltv: "860000000000000000",
    oracle: "0xc3055b53BB901D70f65aC8c8cF700F4944018C5A",
    loanToken: {
      address: "0x6440f144b7e50D6a8439336510312d2F54beB01D",
      symbol: "BOLD",
    },
    collateralToken: {
      address: "0xcbB7C0000aB88B473b1f5aFd9ef808440eed33Bf",
      symbol: "cbBTC",
    },
  },
  {
    id: "0x33b93586bd199025528407e66bf00a887192fab6853150480ce30c2f1b1ac209",
    name: "USDC / unknown",
    irm: "0x870aC11D48B15DB9a138Cf899d20F13F79Ba00BC",
    lltv: "945000000000000000",
    oracle: "0xCc00d98162fEf57d6A1057a36C25D5326e3805c8",
    loanToken: {
      address: "0xA0b86991c6218b36c1d19D4a2e9Eb0cE3606eB48",
      symbol: "USDC",
    },
    collateralToken: {
      address: "0xd2757C74CC58e7DEE9D39A0641181E7be4354C10",
      symbol: "unknown",
    },
  },
  {
    id: "0x335e8e8f1324b1e43e16c5101f4db793fed10a6e63340bc4b3ad38106559e9d9",
    name: "AUSD / PT-cUSD-29JAN2026",
    irm: "0x870aC11D48B15DB9a138Cf899d20F13F79Ba00BC",
    lltv: "915000000000000000",
    oracle: "0x332C4cB17b1a11a29bc903D2E49752b2e6a60474",
    loanToken: {
      address: "0x00000000eFE302BEAA2b3e6e1b18d08D69a9012a",
      symbol: "AUSD",
    },
    collateralToken: {
      address: "0x545A490f9ab534AdF409A2E682bc4098f49952e3",
      symbol: "PT-cUSD-29JAN2026",
    },
  },
  {
    id: "0x328aadb887d060f3d03727f6baaee56ed88570a97dc2ab49b2064a9410ccfd06",
    name: "frxUSD / unknown",
    irm: "0x870aC11D48B15DB9a138Cf899d20F13F79Ba00BC",
    lltv: "915000000000000000",
    oracle: "0x9aA3BFB984f520Eb18A34030110010509A985B52",
    loanToken: {
      address: "0xCAcd6fd266aF91b8AeD52aCCc382b4e165586E29",
      symbol: "frxUSD",
    },
    collateralToken: {
      address: "0xA31b5941F2e74d89bDC66632959FE6A152692920",
      symbol: "unknown",
    },
  },
  {
    id: "0x327b999e8ca772016bcbe19480cc0347fa6cd926df2edc1fc2ae866411a3832b",
    name: "AUSD / sUSDS",
    irm: "0x870aC11D48B15DB9a138Cf899d20F13F79Ba00BC",
    lltv: "945000000000000000",
    oracle: "0x5864E1864bE806DbCe94B2DA62c9f501fF5B5526",
    loanToken: {
      address: "0x00000000eFE302BEAA2b3e6e1b18d08D69a9012a",
      symbol: "AUSD",
    },
    collateralToken: {
      address: "0xa3931d71877C0E7a3148CB7Eb4463524FEc27fbD",
      symbol: "sUSDS",
    },
  },
  {
    id: "0x326e69205500d7c4b96da8d18df90c5584c91d178b4730c51656d39f64388a2e",
    name: "fwUSDC / fwUNI",
    irm: "0x870aC11D48B15DB9a138Cf899d20F13F79Ba00BC",
    lltv: "625000000000000000",
    oracle: "0x630A3B4a095220f4b36082DEc1DeaE903346e372",
    loanToken: {
      address: "0x0492560FA7Cfd6A85E50D8bE3F77318994F8f429",
      symbol: "fwUSDC",
    },
    collateralToken: {
      address: "0xE8E1F50392Bd61D0F8F48E8E7aF51D3b8a52090a",
      symbol: "fwUNI",
    },
  },
  {
    id: "0x3170feb9e3c0172beb9901f6035e4e005f42177c5c14e8c0538c27078864654e",
    name: "LBTC / PT-LBTC-27MAR2025",
    irm: "0x870aC11D48B15DB9a138Cf899d20F13F79Ba00BC",
    lltv: "915000000000000000",
    oracle: "0x5283B67Fadc6Bb299C0DC90f97191132ace413a5",
    loanToken: {
      address: "0x8236a87084f8B84306f72007F36F2618A5634494",
      symbol: "LBTC",
    },
    collateralToken: {
      address: "0xEc5a52C685CC3Ad79a6a347aBACe330d69e0b1eD",
      symbol: "PT-LBTC-27MAR2025",
    },
  },
  {
    id: "0x30a834d1d528aafa57d37e40f8ec2b0a12ad6c304edddddef0c8b50bec0e634b",
    name: "fwDAI / fwWETH",
    irm: "0x870aC11D48B15DB9a138Cf899d20F13F79Ba00BC",
    lltv: "860000000000000000",
    oracle: "0xf883c9cfb8345B0A9969f05F528c136738DFa992",
    loanToken: {
      address: "0x8A6fe57C08C84e0f4eE97aAe68a62e820a37d259",
      symbol: "fwDAI",
    },
    collateralToken: {
      address: "0xa250CC729Bb3323e7933022a67B52200fE354767",
      symbol: "fwWETH",
    },
  },
  {
    id: "0x30a0da8cabf25a31805d9f3eca9005540e419f408beecf5cf715c67f3958ee55",
    name: "PENDLE-LPT / USDC",
    irm: "0x870aC11D48B15DB9a138Cf899d20F13F79Ba00BC",
    lltv: "915000000000000000",
    oracle: "0xBA1e635C8a62D0265418AF33F7F2F419d8e86ed7",
    loanToken: {
      address: "0xA77c0DE4d26B7C97D1D42ABD6733201206122E25",
      symbol: "PENDLE-LPT",
    },
    collateralToken: {
      address: "0xA0b86991c6218b36c1d19D4a2e9Eb0cE3606eB48",
      symbol: "USDC",
    },
  },
  {
    id: "0x308cb8d01d8fe656ceaf4841abc62cee6587f9e46533622e30a0053337953432",
    name: "USR / RLP",
    irm: "0x870aC11D48B15DB9a138Cf899d20F13F79Ba00BC",
    lltv: "860000000000000000",
    oracle: "0x848b5d34c3CBEE40E550a705C419C299F7033ecA",
    loanToken: {
      address: "0x66a1E37c9b0eAddca17d3662D6c05F4DECf3e110",
      symbol: "USR",
    },
    collateralToken: {
      address: "0x4956b52aE2fF65D74CA2d61207523288e4528f96",
      symbol: "RLP",
    },
  },
  {
    id: "0x306f4a9c310615e8ed3f50563272edd86e30f88310a9c220bf62699517a63269",
    name: "USDC / XAUt",
    irm: "0x870aC11D48B15DB9a138Cf899d20F13F79Ba00BC",
    lltv: "860000000000000000",
    oracle: "0xDddd770BADd886dF3864029e4B377B5F6a2B6b83",
    loanToken: {
      address: "0xA0b86991c6218b36c1d19D4a2e9Eb0cE3606eB48",
      symbol: "USDC",
    },
    collateralToken: {
      address: "0x68749665FF8D2d112Fa859AA293F07A622782F38",
      symbol: "XAUt",
    },
  },
  {
    id: "0x2f4ea313fb7df23a82c19d95e8b90acc8179bd053e0d9ef745cdf28d6a49499c",
    name: "USDS / cbBTC",
    irm: "0x870aC11D48B15DB9a138Cf899d20F13F79Ba00BC",
    lltv: "860000000000000000",
    oracle: "0xA5AEb90F9f122989fE69Ae6224Ed923A0caF33B4",
    loanToken: {
      address: "0xdC035D45d973E3EC169d2276DDab16f1e407384F",
      symbol: "USDS",
    },
    collateralToken: {
      address: "0xcbB7C0000aB88B473b1f5aFd9ef808440eed33Bf",
      symbol: "cbBTC",
    },
  },
  {
    id: "0x2f1f7f439143b7985b68394c87a98b9ed7b8cfd2a15fb14c99b3bf76a38cbe7d",
    name: "RLUSD / syrupUSDC",
    irm: "0x870aC11D48B15DB9a138Cf899d20F13F79Ba00BC",
    lltv: "915000000000000000",
    oracle: "0xc910368a162a145dc292B2eaD6Af7839140d2c06",
    loanToken: {
      address: "0x8292Bb45bf1Ee4d140127049757C2E0fF06317eD",
      symbol: "RLUSD",
    },
    collateralToken: {
      address: "0x80ac24aA929eaF5013f6436cdA2a7ba190f5Cc0b",
      symbol: "syrupUSDC",
    },
  },
  {
    id: "0x2e9009781994c6ad5e15a242b56462459f692b1463a72c8751c5bce3fc2261d7",
    name: "PT-corn-eBTC-27MAR2025 / WBTC",
    irm: "0x870aC11D48B15DB9a138Cf899d20F13F79Ba00BC",
    lltv: "915000000000000000",
    oracle: "0x132afAB1fAdB9498F30be1b29F05A95062a9534C",
    loanToken: {
      address: "0x44A7876cA99460ef3218bf08b5f52E2dbE199566",
      symbol: "PT-corn-eBTC-27MAR2025",
    },
    collateralToken: {
      address: "0x2260FAC5E5542a773Aa44fBCfeDf7C193bc2C599",
      symbol: "WBTC",
    },
  },
  {
    id: "0x2e09b73c35e0769bdf589a9556e6ac3c892485ea502ac8c445cec9e79b0378af",
    name: "USDf / sUSDf",
    irm: "0x870aC11D48B15DB9a138Cf899d20F13F79Ba00BC",
    lltv: "915000000000000000",
    oracle: "0x84bf7A62708108fA640292684F04b0f7362C88F9",
    loanToken: {
      address: "0xFa2B947eEc368f42195f24F36d2aF29f7c24CeC2",
      symbol: "USDf",
    },
    collateralToken: {
      address: "0xc8CF6D7991f15525488b2A83Df53468D682Ba4B0",
      symbol: "sUSDf",
    },
  },
  {
    id: "0x2d789ee30a763b8d9def29887c3628447de2aec0faa5f5de40b361349ff94305",
    name: "USDC / USDT",
    irm: "0x870aC11D48B15DB9a138Cf899d20F13F79Ba00BC",
    lltv: "980000000000000000",
    oracle: "0x3A7bB36Ee3f3eE32A60e9f2b33c1e5f2E83ad766",
    loanToken: {
      address: "0xA0b86991c6218b36c1d19D4a2e9Eb0cE3606eB48",
      symbol: "USDC",
    },
    collateralToken: {
      address: "0xdAC17F958D2ee523a2206206994597C13D831ec7",
      symbol: "USDT",
    },
  },
  {
    id: "0x2d247686d85f2d8943c74168a96293fb65e9052f616159451ad41c3282d3c3ce",
    name: "USDC / PT-tUSDe-18DEC2025",
    irm: "0x870aC11D48B15DB9a138Cf899d20F13F79Ba00BC",
    lltv: "915000000000000000",
    oracle: "0x1793BD72a8486a628b735f33FD10350A47D34D15",
    loanToken: {
      address: "0xA0b86991c6218b36c1d19D4a2e9Eb0cE3606eB48",
      symbol: "USDC",
    },
    collateralToken: {
      address: "0x1135b22d6e8FD0809392478eEDcd8c107dB6aF9D",
      symbol: "PT-tUSDe-18DEC2025",
    },
  },
  {
    id: "0x2b440ed5df25c1540d0436d98d2272c43b291d3bf33ec58550d074c6a0067b28",
    name: "waEthUSDC / steakUSDC",
    irm: "0x870aC11D48B15DB9a138Cf899d20F13F79Ba00BC",
    lltv: "945000000000000000",
    oracle: "0x63A8089B704BE9288571e7C7B04f7AB72B97cA8c",
    loanToken: {
      address: "0xD4fa2D31b7968E448877f69A96DE69f5de8cD23E",
      symbol: "waEthUSDC",
    },
    collateralToken: {
      address: "0xBEEF01735c132Ada46AA9aA4c54623cAA92A64CB",
      symbol: "steakUSDC",
    },
  },
  {
    id: "0x2acda03be2d8f16fbd97c94db0bf4e30f98695f805550b5732b9a5b000113184",
    name: "USR / PT-sw-RLP-1750896023",
    irm: "0x870aC11D48B15DB9a138Cf899d20F13F79Ba00BC",
    lltv: "915000000000000000",
    oracle: "0x430bf343Dd91FDE2CF4741704A2C714306D5dBDf",
    loanToken: {
      address: "0x66a1E37c9b0eAddca17d3662D6c05F4DECf3e110",
      symbol: "USR",
    },
    collateralToken: {
      address: "0x1F7Aa7104db822987E1F44A66dF709A8C4Fb301a",
      symbol: "PT-sw-RLP-1750896023",
    },
  },
  {
    id: "0x2acd87889d08af4831eaa378a28ff68e9994dc44affd02fed2c636103fb21649",
    name: "crvUSD / yvCurve-yYB-f",
    irm: "0x870aC11D48B15DB9a138Cf899d20F13F79Ba00BC",
    lltv: "770000000000000000",
    oracle: "0x6D56F12000Ff15B4508CD3E024e6840781a9FAe8",
    loanToken: {
      address: "0xf939E0A03FB07F59A73314E73794Be0E57ac1b4E",
      symbol: "crvUSD",
    },
    collateralToken: {
      address: "0x0844C227b892be5d7c837000C096f64bFc316c2d",
      symbol: "yvCurve-yYB-f",
    },
  },
  {
    id: "0x2a2f62fe3d123077da35f281fbe69ebc296759b34873d627cf44c94f05fecf7e",
    name: "frxUSD / sUSG",
    irm: "0x870aC11D48B15DB9a138Cf899d20F13F79Ba00BC",
    lltv: "860000000000000000",
    oracle: "0x983C54E46F6fe7793fA4fD01B72fC3c065AE1b11",
    loanToken: {
      address: "0xCAcd6fd266aF91b8AeD52aCCc382b4e165586E29",
      symbol: "frxUSD",
    },
    collateralToken: {
      address: "0xF17D6f98A5C6EAA99d149079984119e0A4EF6900",
      symbol: "sUSG",
    },
  },
  {
    id: "0x29cdb218675d395732eef7a806e53b8135b98a121c32579811fb78245d66c208",
    name: "fwUSDC / fwWETH",
    irm: "0x870aC11D48B15DB9a138Cf899d20F13F79Ba00BC",
    lltv: "860000000000000000",
    oracle: "0x0F948CBa8231Db7898ef36A4212581Ad7b1B4580",
    loanToken: {
      address: "0x0492560FA7Cfd6A85E50D8bE3F77318994F8f429",
      symbol: "fwUSDC",
    },
    collateralToken: {
      address: "0xa250CC729Bb3323e7933022a67B52200fE354767",
      symbol: "fwWETH",
    },
  },
  {
    id: "0x297e31709fe6a1bd93134a75593b8df840f6747fc947ecf2430c0cd807df827d",
    name: "USDC / splDXY-BULL",
    irm: "0x870aC11D48B15DB9a138Cf899d20F13F79Ba00BC",
    lltv: "915000000000000000",
    oracle: "0x18770Dff1fa9c38a78b3F2ae48de5b65FC5859bD",
    loanToken: {
      address: "0xA0b86991c6218b36c1d19D4a2e9Eb0cE3606eB48",
      symbol: "USDC",
    },
    collateralToken: {
      address: "0x3B859C74d628dAe76C95fA3b2A9d1A50aB153E2D",
      symbol: "splDXY-BULL",
    },
  },
  {
    id: "0x29200655ad6ee4b86a0f4132e86736844479b4f4ff55d0a40fb31e8264fb811c",
    name: "USDS / SPX",
    irm: "0x870aC11D48B15DB9a138Cf899d20F13F79Ba00BC",
    lltv: "625000000000000000",
    oracle: "0xdA63266b5184D08DbFBace96267837c45D7D34dA",
    loanToken: {
      address: "0xdC035D45d973E3EC169d2276DDab16f1e407384F",
      symbol: "USDS",
    },
    collateralToken: {
      address: "0xE0f63A424a4439cBE457D80E4f4b51aD25b2c56C",
      symbol: "SPX",
    },
  },
  {
    id: "0x2910f6b4ff92dacd6987a6bf74a4c6d15ed1f3acbde6d04fc8cf41c43bb5dbbf",
    name: "USDS / cbBTC",
    irm: "0x870aC11D48B15DB9a138Cf899d20F13F79Ba00BC",
    lltv: "860000000000000000",
    oracle: "0x986E3Ab9d4A48a43D16cba332f2c0A8AE5983f6d",
    loanToken: {
      address: "0xdC035D45d973E3EC169d2276DDab16f1e407384F",
      symbol: "USDS",
    },
    collateralToken: {
      address: "0xcbB7C0000aB88B473b1f5aFd9ef808440eed33Bf",
      symbol: "cbBTC",
    },
  },
  {
    id: "0x28100f64c2ba7a91ea3ec606c249d4d676548a144fa9c93a6e189e8fad3ba361",
    name: "MUSD / tBTC",
    irm: "0x870aC11D48B15DB9a138Cf899d20F13F79Ba00BC",
    lltv: "860000000000000000",
    oracle: "0xdD468A1DDc392dcdbEf6db6e34E89AA338F9F186",
    loanToken: {
      address: "0xdD468A1DDc392dcdbEf6db6e34E89AA338F9F186",
      symbol: "MUSD",
    },
    collateralToken: {
      address: "0x18084fbA666a33d37592fA2633fD49a74DD93a88",
      symbol: "tBTC",
    },
  },
  {
    id: "0x27dc2546042d49c948772a38432849a60fdb41f26af32fac42336f2278591296",
    name: "WETH / wstETH",
    irm: "0x870aC11D48B15DB9a138Cf899d20F13F79Ba00BC",
    lltv: "965000000000000000",
    oracle: "0x3A7bB36Ee3f3eE32A60e9f2b33c1e5f2E83ad766",
    loanToken: {
      address: "0xC02aaA39b223FE8D0A0e5C4F27eAD9083C756Cc2",
      symbol: "WETH",
    },
    collateralToken: {
      address: "0x7f39C581F595B53c5cb19bD0b3f8dA6c935E2Ca0",
      symbol: "wstETH",
    },
  },
  {
    id: "0x26e7fcd32471786bb15ee4586cb3ccd36d6062f1fa294eee7b64b2df0b9f82cf",
    name: "USDT / sUSDS",
    irm: "0x870aC11D48B15DB9a138Cf899d20F13F79Ba00BC",
    lltv: "945000000000000000",
    oracle: "0x9F48b0791C701be7a51B66A4e550A5f0B52A8f5e",
    loanToken: {
      address: "0xdAC17F958D2ee523a2206206994597C13D831ec7",
      symbol: "USDT",
    },
    collateralToken: {
      address: "0xa3931d71877C0E7a3148CB7Eb4463524FEc27fbD",
      symbol: "sUSDS",
    },
  },
  {
    id: "0x26d93047a4c4a33f45e2e8c6c96ec555f63307c7271406b5eefa4ade47da94fb",
    name: "crvUSD / asdCRV",
    irm: "0x870aC11D48B15DB9a138Cf899d20F13F79Ba00BC",
    lltv: "770000000000000000",
    oracle: "0x7faDfAc6E39a8Cd966148C8E0cc78C41F1a4C0b9",
    loanToken: {
      address: "0xf939E0A03FB07F59A73314E73794Be0E57ac1b4E",
      symbol: "crvUSD",
    },
    collateralToken: {
      address: "0x43E54C2E7b3e294De3A155785F52AB49d87B9922",
      symbol: "asdCRV",
    },
  },
  {
    id: "0x26d1fa9aea555c8b991f57d8400be4299c5182cca0864f87abea17a90e0e1b5a",
    name: "USDT / PKZZZ",
    irm: "0x870aC11D48B15DB9a138Cf899d20F13F79Ba00BC",
    lltv: "915000000000000000",
    oracle: "0xD72918C89697a6d40a6288662D1e752D1734464f",
    loanToken: {
      address: "0xdAC17F958D2ee523a2206206994597C13D831ec7",
      symbol: "USDT",
    },
    collateralToken: {
      address: "0x05827E261Af3aE38346F4e7Fa9760B4798ae3cf0",
      symbol: "PKZZZ",
    },
  },
  {
    id: "0x266ba349369c295ce5e0383258e2761b6372c4be9b12d28ee86bd06766b0c3e4",
    name: "USDC / PT-USDe-5FEB2026",
    irm: "0x870aC11D48B15DB9a138Cf899d20F13F79Ba00BC",
    lltv: "915000000000000000",
    oracle: "0x2034274F7F6edF2cBd19e21dbA10e9F63508838F",
    loanToken: {
      address: "0xA0b86991c6218b36c1d19D4a2e9Eb0cE3606eB48",
      symbol: "USDC",
    },
    collateralToken: {
      address: "0x1F84a51296691320478c98b8d77f2Bbd17D34350",
      symbol: "PT-USDe-5FEB2026",
    },
  },
  {
    id: "0x2639d2b1cff02c049f7ef4ca7135b7fd0c94a427e357fc7a7d3d00b22fc33b91",
    name: "AUSD / PT-srUSDe-15JAN2026",
    irm: "0x870aC11D48B15DB9a138Cf899d20F13F79Ba00BC",
    lltv: "915000000000000000",
    oracle: "0xE2D51A4D556C5fB74d96618d7f10f3252b8ACa4F",
    loanToken: {
      address: "0x00000000eFE302BEAA2b3e6e1b18d08D69a9012a",
      symbol: "AUSD",
    },
    collateralToken: {
      address: "0x1Fb3C5c35D95F48e48FFC8e36bCCe5CB5f29F57c",
      symbol: "PT-srUSDe-15JAN2026",
    },
  },
  {
    id: "0x25cfb1cceac845a269e621e8891e5c8c28134dde298353c5ee51be40b8b9eabc",
    name: "USDC / PT-PendleInfiniFi-siUSD-9OCT2025",
    irm: "0x870aC11D48B15DB9a138Cf899d20F13F79Ba00BC",
    lltv: "915000000000000000",
    oracle: "0x2Ca646255593a8E77A0b5ab268238964c1e8f78A",
    loanToken: {
      address: "0xA0b86991c6218b36c1d19D4a2e9Eb0cE3606eB48",
      symbol: "USDC",
    },
    collateralToken: {
      address: "0x711214da1A94F478B96C1Ca3D14A750f496F2a80",
      symbol: "PT-PendleInfiniFi-siUSD-9OCT2025",
    },
  },
  {
    id: "0x25bcb1c0b3dc48c6c24a5aaa2375c50a20287335d56a626fcefce8ff414d8c58",
    name: "tBTC / wstETH",
    irm: "0x870aC11D48B15DB9a138Cf899d20F13F79Ba00BC",
    lltv: "860000000000000000",
    oracle: "0xf0Db32f5c678d02DD8EB1839e60F1fD16DBF49e2",
    loanToken: {
      address: "0x18084fbA666a33d37592fA2633fD49a74DD93a88",
      symbol: "tBTC",
    },
    collateralToken: {
      address: "0x7f39C581F595B53c5cb19bD0b3f8dA6c935E2Ca0",
      symbol: "wstETH",
    },
  },
  {
    id: "0x24a1ac1fb21a206906af5acf2d65a6e6d9627823c195efef112d3a9b6cd5eab6",
    name: "frxUSD / stakedao-FrxMsUSD",
    irm: "0x870aC11D48B15DB9a138Cf899d20F13F79Ba00BC",
    lltv: "945000000000000000",
    oracle: "0xC5860e9e6b6F6E9D79DCe5c5AB0F7A4b878Bd431",
    loanToken: {
      address: "0xCAcd6fd266aF91b8AeD52aCCc382b4e165586E29",
      symbol: "frxUSD",
    },
    collateralToken: {
      address: "0x3B855AA8CC56a3cBd5dBb5456F5A13Ce86AA0fe8",
      symbol: "stakedao-FrxMsUSD",
    },
  },
  {
    id: "0x249d2c9e33e52990ec83b824b87135bd193f4c10b8546b08b6f886344be8951f",
    name: "fwUSDT / fwWETH",
    irm: "0x870aC11D48B15DB9a138Cf899d20F13F79Ba00BC",
    lltv: "860000000000000000",
    oracle: "0xe9eE579684716c7Bb837224F4c7BeEfA4f1F3d7f",
    loanToken: {
      address: "0xef87f4608e601E8564800265AeE1c1FfaDF73283",
      symbol: "fwUSDT",
    },
    collateralToken: {
      address: "0xa250CC729Bb3323e7933022a67B52200fE354767",
      symbol: "fwWETH",
    },
  },
  {
    id: "0x24391f5552cb2497489c1d3f2eb371374f55d8eaa787392a65bfc58ca19cab0a",
    name: "USDe / PT-jrUSDe-15JAN2026",
    irm: "0x870aC11D48B15DB9a138Cf899d20F13F79Ba00BC",
    lltv: "860000000000000000",
    oracle: "0x934D5bf527191f61E32F93c0699ed8CF4339948D",
    loanToken: {
      address: "0x4c9EDD5852cd905f086C759E8383e09bff1E68B3",
      symbol: "USDe",
    },
    collateralToken: {
      address: "0x53F3373F0D811902405f91eB0d5cc3957887220D",
      symbol: "PT-jrUSDe-15JAN2026",
    },
  },
  {
    id: "0x23ca280807ae6e4b5d9442e5727393987f495922edf9d28f6d0be32807d4b0e4",
    name: "reUSD / PT-reUSD-25JUN2026",
    irm: "0x870aC11D48B15DB9a138Cf899d20F13F79Ba00BC",
    lltv: "915000000000000000",
    oracle: "0x859AE5B1b6c23020f0870578E255E0c23C95a22f",
    loanToken: {
      address: "0x5086bf358635B81D8C47C66d1C8b9E567Db70c72",
      symbol: "reUSD",
    },
    collateralToken: {
      address: "0x3EAA0F0f0A5d3D595ae4e4b0D27f439d01c3E7b2",
      symbol: "PT-reUSD-25JUN2026",
    },
  },
  {
    id: "0x2281da4b9cb073085ee3794289a03290caa553a2d3b95c1f937a3e51decc9b14",
    name: "USDC / tBTC",
    irm: "0x870aC11D48B15DB9a138Cf899d20F13F79Ba00BC",
    lltv: "860000000000000000",
    oracle: "0xDddd770BADd886dF3864029e4B377B5F6a2B6b83",
    loanToken: {
      address: "0xA0b86991c6218b36c1d19D4a2e9Eb0cE3606eB48",
      symbol: "USDC",
    },
    collateralToken: {
      address: "0x18084fbA666a33d37592fA2633fD49a74DD93a88",
      symbol: "tBTC",
    },
  },
  {
    id: "0x226a59cd57c8c75ddaf440e2be68b92dbf8dafaed6a715290d0789d1fdc521c2",
    name: "USDC / deUSD",
    irm: "0x870aC11D48B15DB9a138Cf899d20F13F79Ba00BC",
    lltv: "860000000000000000",
    oracle: "0x0A19215Ffd2B1B3FC47C49EBD7Fa6BaEF8EA75a0",
    loanToken: {
      address: "0xA0b86991c6218b36c1d19D4a2e9Eb0cE3606eB48",
      symbol: "USDC",
    },
    collateralToken: {
      address: "0x15700B564Ca08D9439C58cA5053166E8317aa138",
      symbol: "deUSD",
    },
  },
  {
    id: "0x225d12cefa6cc4068babd266f9e2b37ee2a2b0cf4eed0de25877b4ecb38d2cdb",
    name: "AUSD / wstETH",
    irm: "0x870aC11D48B15DB9a138Cf899d20F13F79Ba00BC",
    lltv: "860000000000000000",
    oracle: "0x48F7E36EB6B826B2dF4B2E630B62Cd25e89E40e2",
    loanToken: {
      address: "0x00000000eFE302BEAA2b3e6e1b18d08D69a9012a",
      symbol: "AUSD",
    },
    collateralToken: {
      address: "0x7f39C581F595B53c5cb19bD0b3f8dA6c935E2Ca0",
      symbol: "wstETH",
    },
  },
  {
    id: "0x21181d33ac70b7290592338113e5af6e68c0e623ffaf932515727bb35f5690ef",
    name: "AUSD / stcUSD",
    irm: "0x870aC11D48B15DB9a138Cf899d20F13F79Ba00BC",
    lltv: "915000000000000000",
    oracle: "0x67c5d1f448E624BEC01C31335fA22829155fB9Ce",
    loanToken: {
      address: "0x00000000eFE302BEAA2b3e6e1b18d08D69a9012a",
      symbol: "AUSD",
    },
    collateralToken: {
      address: "0x88887bE419578051FF9F4eb6C858A951921D8888",
      symbol: "stcUSD",
    },
  },
  {
    id: "0x20e945846ccfde97b395a20895dd8d61e893bd45ef3ef4ac3d84211987698f4d",
    name: "sUSDS / wstETH",
    irm: "0x870aC11D48B15DB9a138Cf899d20F13F79Ba00BC",
    lltv: "860000000000000000",
    oracle: "0x2021defA41B20A399816e0A40cE6cb8907824B39",
    loanToken: {
      address: "0xa3931d71877C0E7a3148CB7Eb4463524FEc27fbD",
      symbol: "sUSDS",
    },
    collateralToken: {
      address: "0x7f39C581F595B53c5cb19bD0b3f8dA6c935E2Ca0",
      symbol: "wstETH",
    },
  },
  {
    id: "0x1f728a6b33cc853d99deec0a8b5417ba852cc9242690d8763399796b12b90fa8",
    name: "rUSD / PT-wsrUSD-26FEB2026",
    irm: "0x870aC11D48B15DB9a138Cf899d20F13F79Ba00BC",
    lltv: "915000000000000000",
    oracle: "0xb454b7c496E2293eBaA10Ea997e0Acec69ac6aCd",
    loanToken: {
      address: "0x09D4214C03D01F49544C0448DBE3A27f768F2b34",
      symbol: "rUSD",
    },
    collateralToken: {
      address: "0x5AA4AfE7359d5a68D193f03E013d553DEb7DbD1f",
      symbol: "PT-wsrUSD-26FEB2026",
    },
  },
  {
    id: "0x1f10c0899fdab5d90b11fd830d52c0c468ba8a7cde67deaa37bebbf512ac47ca",
    name: "frxUSD / unknown",
    irm: "0x870aC11D48B15DB9a138Cf899d20F13F79Ba00BC",
    lltv: "915000000000000000",
    oracle: "0x9eD400f338d82f8095b3cf00fC92Ef931DC1C185",
    loanToken: {
      address: "0xCAcd6fd266aF91b8AeD52aCCc382b4e165586E29",
      symbol: "frxUSD",
    },
    collateralToken: {
      address: "0x62923a64D7940be920FD5cdc27873Ab8eEc59F9F",
      symbol: "unknown",
    },
  },
  {
    id: "0x1e1ae51d4be670307788612599a46a73649ef85e28bab194d3ae00c3cd693ea7",
    name: "USR / PT-wstUSR-27MAR2025",
    irm: "0x870aC11D48B15DB9a138Cf899d20F13F79Ba00BC",
    lltv: "915000000000000000",
    oracle: "0x5Ef991b38e0929aF633B23a390dEe5AC926Df492",
    loanToken: {
      address: "0x66a1E37c9b0eAddca17d3662D6c05F4DECf3e110",
      symbol: "USR",
    },
    collateralToken: {
      address: "0xA8c8861b5ccF8CCe0ade6811CD2A7A7d3222B0B8",
      symbol: "PT-wstUSR-27MAR2025",
    },
  },
  {
    id: "0x1dca6989b0d2b0a546530b3a739e91402eee2e1536a2d3ded4f5ce589a9cd1c2",
    name: "USR / BONDUSD",
    irm: "0x870aC11D48B15DB9a138Cf899d20F13F79Ba00BC",
    lltv: "945000000000000000",
    oracle: "0x1b4A3F92e5Fffd1d35A98751c9FE4472483579bB",
    loanToken: {
      address: "0x66a1E37c9b0eAddca17d3662D6c05F4DECf3e110",
      symbol: "USR",
    },
    collateralToken: {
      address: "0x8413D2a624A9fA8b6D3eC7b22CF7F62E55D6Bc83",
      symbol: "BONDUSD",
    },
  },
  {
    id: "0x1d2292732e18f5fdd7c39b22cf7baa9b021fa36e67fdb1fa531a13acdd1a7bfb",
    name: "cbBTC / LBTC",
    irm: "0x870aC11D48B15DB9a138Cf899d20F13F79Ba00BC",
    lltv: "860000000000000000",
    oracle: "0x1Ce1a1e68F26019CAf5E823A56e300755D70D078",
    loanToken: {
      address: "0xcbB7C0000aB88B473b1f5aFd9ef808440eed33Bf",
      symbol: "cbBTC",
    },
    collateralToken: {
      address: "0x8236a87084f8B84306f72007F36F2618A5634494",
      symbol: "LBTC",
    },
  },
  {
    id: "0x1cad95d20b52cbb3d40f9aa3a858cafcfcf4d067eaf0ddaa966414bfe222a25d",
    name: "AUSD / sUSDat",
    irm: "0x870aC11D48B15DB9a138Cf899d20F13F79Ba00BC",
    lltv: "860000000000000000",
    oracle: "0x3bb2Cf8A85feB20bAA7C75966F9a9bdFd26C4A53",
    loanToken: {
      address: "0x00000000eFE302BEAA2b3e6e1b18d08D69a9012a",
      symbol: "AUSD",
    },
    collateralToken: {
      address: "0xD166337499E176bbC38a1FBd113Ab144e5bd2Df7",
      symbol: "sUSDat",
    },
  },
  {
    id: "0x1c4b9ce834604969d33dc277bd8473d8aee856e5a577c08427b6deeb97cc72d6",
    name: "crvUSD / ",
    irm: "0x870aC11D48B15DB9a138Cf899d20F13F79Ba00BC",
    lltv: "860000000000000000",
    oracle: "0x077Af6c2D4A75D4145d141F9e9421864C3940CB3",
    loanToken: {
      address: "0xf939E0A03FB07F59A73314E73794Be0E57ac1b4E",
      symbol: "crvUSD",
    },
    collateralToken: {
      address: "0xb0Ce26C88e4e7DCa51968b6047f44646f5064278",
      symbol: "",
    },
  },
  {
    id: "0x1c01d66377f67afbd80b36ca54c821956b726c66b5b83085d55c04022cce60ee",
    name: "USDC / wUSDT",
    irm: "0x870aC11D48B15DB9a138Cf899d20F13F79Ba00BC",
    lltv: "860000000000000000",
    oracle: "0x065e56367F5e5a0EfF81dB475c10C0b3D3e6A847",
    loanToken: {
      address: "0xA0b86991c6218b36c1d19D4a2e9Eb0cE3606eB48",
      symbol: "USDC",
    },
    collateralToken: {
      address: "0xE74ca2168fE32bAe88C07aE3A637975e540F4137",
      symbol: "wUSDT",
    },
  },
  {
    id: "0x1b729f8063dc714a626ade140366f3ecda1e0529fe78b7b310dfbecd57785c60",
    name: "USDC / ACRDX",
    irm: "0x870aC11D48B15DB9a138Cf899d20F13F79Ba00BC",
    lltv: "860000000000000000",
    oracle: "0x0266192a71C1aB0a59e08A22C513CD42Bbb05356",
    loanToken: {
      address: "0xB6A9c3375b3a57dA78F7C467Bd7B91cb8665A61e",
      symbol: "USDC",
    },
    collateralToken: {
      address: "0x5CFf44513C84BFA387bB0D62Af723F76Dfc6b379",
      symbol: "ACRDX",
    },
  },
  {
    id: "0x1b5257c55110508ed23579933f89e8e77c18c1f0c26d144d8c2b15305d095410",
    name: "WETH / PT-agETH-26JUN2025",
    irm: "0x870aC11D48B15DB9a138Cf899d20F13F79Ba00BC",
    lltv: "915000000000000000",
    oracle: "0xB2Afff6b538b4A182C3626A6F54d99F9b3B7c623",
    loanToken: {
      address: "0xC02aaA39b223FE8D0A0e5C4F27eAD9083C756Cc2",
      symbol: "WETH",
    },
    collateralToken: {
      address: "0x6E43F6abce001c14C7115d20908d0c272338eAf1",
      symbol: "PT-agETH-26JUN2025",
    },
  },
  {
    id: "0x1a516baea7dd26c9526a293057212a53a693d621023add54bfd04a627f9c28d6",
    name: "USR / RLP",
    irm: "0x870aC11D48B15DB9a138Cf899d20F13F79Ba00BC",
    lltv: "860000000000000000",
    oracle: "0xac04f5AC202A510190e283b763007Bd220A9a3B9",
    loanToken: {
      address: "0x66a1E37c9b0eAddca17d3662D6c05F4DECf3e110",
      symbol: "USR",
    },
    collateralToken: {
      address: "0x4956b52aE2fF65D74CA2d61207523288e4528f96",
      symbol: "RLP",
    },
  },
  {
    id: "0x1a2d4bcea7613222d476d4265ab6615aae3bcf25be2bc84bec47000ef1451584",
    name: "rUSD / srUSD",
    irm: "0x870aC11D48B15DB9a138Cf899d20F13F79Ba00BC",
    lltv: "980000000000000000",
    oracle: "0xC9F335B9C952883aa6806501990D030c0Efc9AFd",
    loanToken: {
      address: "0x09D4214C03D01F49544C0448DBE3A27f768F2b34",
      symbol: "rUSD",
    },
    collateralToken: {
      address: "0x738d1115B90efa71AE468F1287fc864775e23a31",
      symbol: "srUSD",
    },
  },
  {
    id: "0x1a01594467db83fefd93ad9028e3c13ca7f8499f7086afefb667966f6a2b3b11",
    name: "USDS / SHIB",
    irm: "0x870aC11D48B15DB9a138Cf899d20F13F79Ba00BC",
    lltv: "770000000000000000",
    oracle: "0xe99e31a10502aC2348f529A10Ed602D850ed05B7",
    loanToken: {
      address: "0xdC035D45d973E3EC169d2276DDab16f1e407384F",
      symbol: "USDS",
    },
    collateralToken: {
      address: "0x95aD61b0a150d79219dCF64E1E6Cc01f0B64C4cE",
      symbol: "SHIB",
    },
  },
  {
    id: "0x19c2aba40b0ef8f0817818a234c565207ad15c6a91b26928a3bebf0812297dcb",
    name: "USDC / SKY",
    irm: "0x870aC11D48B15DB9a138Cf899d20F13F79Ba00BC",
    lltv: "770000000000000000",
    oracle: "0xf04527439BA444d87E5151444ef5EA1f88E481b0",
    loanToken: {
      address: "0xA0b86991c6218b36c1d19D4a2e9Eb0cE3606eB48",
      symbol: "USDC",
    },
    collateralToken: {
      address: "0x56072C95FAA701256059aa122697B133aDEd9279",
      symbol: "SKY",
    },
  },
  {
    id: "0x1980361f4e12e1c551e5e6b1fbc7c3eb4d977dbf97c08fb63e0e38e17bcc2f67",
    name: "AUSD / PT-reUSD-25JUN2026",
    irm: "0x870aC11D48B15DB9a138Cf899d20F13F79Ba00BC",
    lltv: "915000000000000000",
    oracle: "0x5749F59D948910896527b20763a6d91F54227955",
    loanToken: {
      address: "0x00000000eFE302BEAA2b3e6e1b18d08D69a9012a",
      symbol: "AUSD",
    },
    collateralToken: {
      address: "0x3EAA0F0f0A5d3D595ae4e4b0D27f439d01c3E7b2",
      symbol: "PT-reUSD-25JUN2026",
    },
  },
  {
    id: "0x17b7b7b9b5907e2aa759661a1dc8749c43de5b2aa990ccc0bdfdbf1badb7dab3",
    name: "AUSD / stcUSD",
    irm: "0x870aC11D48B15DB9a138Cf899d20F13F79Ba00BC",
    lltv: "915000000000000000",
    oracle: "0xa26D8Cd042E85c7F5483a2429B6F4D0211AfC689",
    loanToken: {
      address: "0x00000000eFE302BEAA2b3e6e1b18d08D69a9012a",
      symbol: "AUSD",
    },
    collateralToken: {
      address: "0x88887bE419578051FF9F4eb6C858A951921D8888",
      symbol: "stcUSD",
    },
  },
  {
    id: "0x17af0be1f59e3eb8e3de2ed7655ed544c9465d089f21b89c465874a6447f2590",
    name: "LBTC / PT-corn-eBTC-27MAR2025",
    irm: "0x870aC11D48B15DB9a138Cf899d20F13F79Ba00BC",
    lltv: "915000000000000000",
    oracle: "0x8F3726189E65c86edC4BeB0e2bADaa9e1f0578c9",
    loanToken: {
      address: "0x8236a87084f8B84306f72007F36F2618A5634494",
      symbol: "LBTC",
    },
    collateralToken: {
      address: "0x44A7876cA99460ef3218bf08b5f52E2dbE199566",
      symbol: "PT-corn-eBTC-27MAR2025",
    },
  },
  {
    id: "0x1749e02006bc6bd6a86af52d231511f6911d5e42318e028e51a28dfabc68dd47",
    name: "RLUSD / PT-sUSDE-13AUG2026",
    irm: "0x870aC11D48B15DB9a138Cf899d20F13F79Ba00BC",
    lltv: "915000000000000000",
    oracle: "0x968eb911Db90BB8eA9E4792b05C94500bC1A62D7",
    loanToken: {
      address: "0x8292Bb45bf1Ee4d140127049757C2E0fF06317eD",
      symbol: "RLUSD",
    },
    collateralToken: {
      address: "0x5A19fa369F2895dCD8d2cEE62E4Ceae58eF92BBb",
      symbol: "PT-sUSDE-13AUG2026",
    },
  },
  {
    id: "0x17476541f0c8f93df7fda63e99fd8896c53972e6f93eb89982305bf8d693c1bc",
    name: "USDC / syrupUSDC",
    irm: "0x870aC11D48B15DB9a138Cf899d20F13F79Ba00BC",
    lltv: "860000000000000000",
    oracle: "0xDddd770BADd886dF3864029e4B377B5F6a2B6b83",
    loanToken: {
      address: "0xA0b86991c6218b36c1d19D4a2e9Eb0cE3606eB48",
      symbol: "USDC",
    },
    collateralToken: {
      address: "0x80ac24aA929eaF5013f6436cdA2a7ba190f5Cc0b",
      symbol: "syrupUSDC",
    },
  },
  {
    id: "0x16f269c5cc745b486060d42e21aef2f33edfe4b8cf6dce95e518a789469aae78",
    name: "AUSD / PT-USDG-28MAY2026",
    irm: "0x870aC11D48B15DB9a138Cf899d20F13F79Ba00BC",
    lltv: "945000000000000000",
    oracle: "0xEA268c588072e2639448E3a9433AB92E871335E2",
    loanToken: {
      address: "0x00000000eFE302BEAA2b3e6e1b18d08D69a9012a",
      symbol: "AUSD",
    },
    collateralToken: {
      address: "0x9db38D74a0D29380899aD354121DfB521aDb0548",
      symbol: "PT-USDG-28MAY2026",
    },
  },
  {
    id: "0x16a710483b0a56a631cd1d4538caf718d6e1b1e0626b1fc0184a5a4f41c3d7ae",
    name: "USDC / USD0++",
    irm: "0x870aC11D48B15DB9a138Cf899d20F13F79Ba00BC",
    lltv: "860000000000000000",
    oracle: "0x67fEDC82BEe170B235Ac088913CAB8e052c43e08",
    loanToken: {
      address: "0xA0b86991c6218b36c1d19D4a2e9Eb0cE3606eB48",
      symbol: "USDC",
    },
    collateralToken: {
      address: "0x35D8949372D46B7a3D5A56006AE77B215fc69bC0",
      symbol: "USD0++",
    },
  },
  {
    id: "0x1636d136f8f1e870b22a8df5f658e7558b4a7843e959a1915eb8ee8668c3132a",
    name: "frxUSD / unknown",
    irm: "0x870aC11D48B15DB9a138Cf899d20F13F79Ba00BC",
    lltv: "860000000000000000",
    oracle: "0x2ec657b9B275A1bcBA480Dd080bbA5E974ca9118",
    loanToken: {
      address: "0xCAcd6fd266aF91b8AeD52aCCc382b4e165586E29",
      symbol: "frxUSD",
    },
    collateralToken: {
      address: "0x2f010444C6a61feaEBCDd4040fA8B30F519e6c31",
      symbol: "unknown",
    },
  },
  {
    id: "0x15fb11dde91ada418e8aa6f286337a78c98cd363e595923cae0eb99b6ce80831",
    name: "USDC / PT-USDG-28MAY2026",
    irm: "0x870aC11D48B15DB9a138Cf899d20F13F79Ba00BC",
    lltv: "945000000000000000",
    oracle: "0x8ec85C167a43EBe4EB183e8d9B876D1cdad9A9fB",
    loanToken: {
      address: "0xA0b86991c6218b36c1d19D4a2e9Eb0cE3606eB48",
      symbol: "USDC",
    },
    collateralToken: {
      address: "0x9db38D74a0D29380899aD354121DfB521aDb0548",
      symbol: "PT-USDG-28MAY2026",
    },
  },
  {
    id: "0x15bb2a6af0c909eed19fb1f2ceeead34ecbdcba626de752c6b09389ee14eec32",
    name: "RLUSD / kBTC",
    irm: "0x870aC11D48B15DB9a138Cf899d20F13F79Ba00BC",
    lltv: "860000000000000000",
    oracle: "0xBCC3D9834b84B32Cf540DBE948DEd4B47bec5ddb",
    loanToken: {
      address: "0x8292Bb45bf1Ee4d140127049757C2E0fF06317eD",
      symbol: "RLUSD",
    },
    collateralToken: {
      address: "0x73E0C0d45E048D25Fc26Fa3159b0aA04BfA4Db98",
      symbol: "kBTC",
    },
  },
  {
    id: "0x15a166a0dabc9709b83a07cc7f30cbf3d628582795ab39628191017586961c39",
    name: "SolvBTC.BBN / PT-SolvBTC.BBN-26JUN2025",
    irm: "0x870aC11D48B15DB9a138Cf899d20F13F79Ba00BC",
    lltv: "915000000000000000",
    oracle: "0x0d3634BB3B87D92a69f9Ad5013dB07e44C88Ce03",
    loanToken: {
      address: "0xd9D920AA40f578ab794426F5C90F6C731D159DEf",
      symbol: "SolvBTC.BBN",
    },
    collateralToken: {
      address: "0x4f62A7a25a4fD6Ae386e957284aFB5FBF1E1f32c",
      symbol: "PT-SolvBTC.BBN-26JUN2025",
    },
  },
  {
    id: "0x154f642fb5484ae77e507187b9b5178a00bfd4101e81f1e9f4df88743e25d0fc",
    name: "USDf / sUSDf",
    irm: "0x870aC11D48B15DB9a138Cf899d20F13F79Ba00BC",
    lltv: "965000000000000000",
    oracle: "0x6f397fA3eCed7d3e689f262C36E219768Ae42eAF",
    loanToken: {
      address: "0xFa2B947eEc368f42195f24F36d2aF29f7c24CeC2",
      symbol: "USDf",
    },
    collateralToken: {
      address: "0xc8CF6D7991f15525488b2A83Df53468D682Ba4B0",
      symbol: "sUSDf",
    },
  },
  {
    id: "0x1500bf50feba561f004d35c7695d96d685fa117c4985b91a75885c4aa24b6ceb",
    name: "wstETH / WETH",
    irm: "0x870aC11D48B15DB9a138Cf899d20F13F79Ba00BC",
    lltv: "945000000000000000",
    oracle: "0x6F234Ff075B35312756A6B0a19DDb55Ff683E59d",
    loanToken: {
      address: "0x7f39C581F595B53c5cb19bD0b3f8dA6c935E2Ca0",
      symbol: "wstETH",
    },
    collateralToken: {
      address: "0xC02aaA39b223FE8D0A0e5C4F27eAD9083C756Cc2",
      symbol: "WETH",
    },
  },
  {
    id: "0x14517db49f84dfd2ef3de085918d62b25982ccb2896c9195f9ffffaa7cbf84ff",
    name: "fwDAI / fwWBTC",
    irm: "0x870aC11D48B15DB9a138Cf899d20F13F79Ba00BC",
    lltv: "860000000000000000",
    oracle: "0xeA1433b67667878941Ca2a61C359e379397b155E",
    loanToken: {
      address: "0x8A6fe57C08C84e0f4eE97aAe68a62e820a37d259",
      symbol: "fwDAI",
    },
    collateralToken: {
      address: "0x2078f336Fdd260f708BEc4a20c82b063274E1b23",
      symbol: "fwWBTC",
    },
  },
  {
    id: "0x13dd22c3111106f703052d5f9166812f0bf1f4679f3db7dfd82037971ce5468f",
    name: "sUSDS / RLP",
    irm: "0x870aC11D48B15DB9a138Cf899d20F13F79Ba00BC",
    lltv: "860000000000000000",
    oracle: "0xcA3d6Fa03266d9CA262f2bbcCD231A8885F4b8f9",
    loanToken: {
      address: "0xa3931d71877C0E7a3148CB7Eb4463524FEc27fbD",
      symbol: "sUSDS",
    },
    collateralToken: {
      address: "0x4956b52aE2fF65D74CA2d61207523288e4528f96",
      symbol: "RLP",
    },
  },
  {
    id: "0x138344aa9c48c519090b4f450b7c79c3d42909f9feac1b17c3808768db8c4ed4",
    name: "tBTC / eBTC",
    irm: "0x870aC11D48B15DB9a138Cf899d20F13F79Ba00BC",
    lltv: "915000000000000000",
    oracle: "0x7b4eD9A001EAA93aD1BaaAe907C4abc10B1821BB",
    loanToken: {
      address: "0x18084fbA666a33d37592fA2633fD49a74DD93a88",
      symbol: "tBTC",
    },
    collateralToken: {
      address: "0x657e8C867D8B37dCC18fA4Caead9C45EB088C642",
      symbol: "eBTC",
    },
  },
  {
    id: "0x12c962c4ebec395500a21ffb330e893339325f6c9cf7c57c7fe5f972342e5e28",
    name: "AUSD / SPYx",
    irm: "0x870aC11D48B15DB9a138Cf899d20F13F79Ba00BC",
    lltv: "860000000000000000",
    oracle: "0xc7A739E7391DB46C4bD277f0D298851F10bbBA05",
    loanToken: {
      address: "0x00000000eFE302BEAA2b3e6e1b18d08D69a9012a",
      symbol: "AUSD",
    },
    collateralToken: {
      address: "0x90A2a4c76b5D8c0bc892A69EA28Aa775a8f2dD48",
      symbol: "SPYx",
    },
  },
  {
    id: "0x12c7bc9b039acac6adf2ab7285e84a12be58e9e1d882db622c8a55be3390e193",
    name: "tBTC / PT-LBTC-26JUN2025",
    irm: "0x870aC11D48B15DB9a138Cf899d20F13F79Ba00BC",
    lltv: "915000000000000000",
    oracle: "0x49aB43523596bC9220f61b1125e7fDA3f46aFDFc",
    loanToken: {
      address: "0x18084fbA666a33d37592fA2633fD49a74DD93a88",
      symbol: "tBTC",
    },
    collateralToken: {
      address: "0x6cA4d5d2eCb72E3Bbf17543B3367746B80D22694",
      symbol: "PT-LBTC-26JUN2025",
    },
  },
  {
    id: "0x1136d311dae7340fe6c6c133434f0ee64ab8b59fd4d6c7ea9d20fd3f91190671",
    name: "USDC / PT-sUSDE-5FEB2026",
    irm: "0x870aC11D48B15DB9a138Cf899d20F13F79Ba00BC",
    lltv: "915000000000000000",
    oracle: "0xEC3679d32199B370C4f5bdf34152342B05CbC35c",
    loanToken: {
      address: "0xA0b86991c6218b36c1d19D4a2e9Eb0cE3606eB48",
      symbol: "USDC",
    },
    collateralToken: {
      address: "0xE8483517077afa11A9B07f849cee2552f040d7b2",
      symbol: "PT-sUSDE-5FEB2026",
    },
  },
  {
    id: "0x111e6c2b41258ab2761f01a074db1573157c0ee675c8930f436031b7e5ea4566",
    name: "BOLD / sBOLD",
    irm: "0x870aC11D48B15DB9a138Cf899d20F13F79Ba00BC",
    lltv: "915000000000000000",
    oracle: "0x0bB177db332caA6f29fD5Bf9304900F58E866814",
    loanToken: {
      address: "0x6440f144b7e50D6a8439336510312d2F54beB01D",
      symbol: "BOLD",
    },
    collateralToken: {
      address: "0x50Bd66D59911F5e086Ec87aE43C811e0D059DD11",
      symbol: "sBOLD",
    },
  },
  {
    id: "0x1036170c5ebeaf73da6b26e56a47a2a878ab65a06bbdd82ba490a74fc4f7063f",
    name: "frxUSD / savUSD",
    irm: "0x870aC11D48B15DB9a138Cf899d20F13F79Ba00BC",
    lltv: "915000000000000000",
    oracle: "0x639499c2FDBbB91b814e76932414c3a9a964bcB6",
    loanToken: {
      address: "0xCAcd6fd266aF91b8AeD52aCCc382b4e165586E29",
      symbol: "frxUSD",
    },
    collateralToken: {
      address: "0xb8D89678E75a973E74698c976716308abB8a46A4",
      symbol: "savUSD",
    },
  },
  {
    id: "0x0f9936369516f574c469bd1f9fd65966f61b9e144949248f4b92c769ea9117f9",
    name: "lvlUSD / PT-slvlUSD-25SEP2025",
    irm: "0x870aC11D48B15DB9a138Cf899d20F13F79Ba00BC",
    lltv: "915000000000000000",
    oracle: "0xea8BF62278a8431FD4b084A7B7813788FF8D4003",
    loanToken: {
      address: "0x7C1156E515aA1A2E851674120074968C905aAF37",
      symbol: "lvlUSD",
    },
    collateralToken: {
      address: "0x2CA5f2C4300450D53214B00546795c1c07B89acB",
      symbol: "PT-slvlUSD-25SEP2025",
    },
  },
  {
    id: "0x0f24f5d36eb2de56fce0b5d70202ec8faf9fe43e0f946399b09b43d3650cac77",
    name: "lvWETH / lvstETH",
    irm: "0x870aC11D48B15DB9a138Cf899d20F13F79Ba00BC",
    lltv: "945000000000000000",
    oracle: "0xe0d34E4468CFde22B413340640E996aea7d0000C",
    loanToken: {
      address: "0x419d2136c9E84acC918d8894bAb6327036c0BF5F",
      symbol: "lvWETH",
    },
    collateralToken: {
      address: "0x40616E42c93853A94F617271BfCA0369cbf0cacd",
      symbol: "lvstETH",
    },
  },
  {
    id: "0x0f12333e9a383a0eb031933f74ae5f8c20f9d184ca1f941200aa887f30b8e9c8",
    name: "CANA / wstETH",
    irm: "0x870aC11D48B15DB9a138Cf899d20F13F79Ba00BC",
    lltv: "770000000000000000",
    oracle: "0x63ccFA2336c9Abd204f72b5E238ef304DBd79112",
    loanToken: {
      address: "0x01995A697752266d8E748738aAa3F06464B8350B",
      symbol: "CANA",
    },
    collateralToken: {
      address: "0x7f39C581F595B53c5cb19bD0b3f8dA6c935E2Ca0",
      symbol: "wstETH",
    },
  },
  {
    id: "0x0e71562603ba2985c1b0fe104ef276335b68066c960fcbd39b2c2332be19edd8",
    name: "USDC / cUSDOUSDC",
    irm: "0x870aC11D48B15DB9a138Cf899d20F13F79Ba00BC",
    lltv: "915000000000000000",
    oracle: "0x2A36a54C7c00215D86Caf9a283A44817D3390A2A",
    loanToken: {
      address: "0xA0b86991c6218b36c1d19D4a2e9Eb0cE3606eB48",
      symbol: "USDC",
    },
    collateralToken: {
      address: "0x90455bd11Ce8a67C57d467e634Dc142b8e4105Aa",
      symbol: "cUSDOUSDC",
    },
  },
  {
    id: "0x0de01f0171ead1aff75562dc97983cdef4751cedb409a103e9e4ccee396327f6",
    name: "lvlUSD / slvlUSD",
    irm: "0x870aC11D48B15DB9a138Cf899d20F13F79Ba00BC",
    lltv: "915000000000000000",
    oracle: "0x50356C32c984BF921a0eFB1F4264Ac328e429c2c",
    loanToken: {
      address: "0x7C1156E515aA1A2E851674120074968C905aAF37",
      symbol: "lvlUSD",
    },
    collateralToken: {
      address: "0x4737D9b4592B40d51e110b94c9C043c6654067Ae",
      symbol: "slvlUSD",
    },
  },
  {
    id: "0x0dc13084b87f5828ea22a0953fdd2f26b4e7d3b3b792738fe94f44ff1a9f0cdb",
    name: "wSTRCx / apxUSD",
    irm: "0x870aC11D48B15DB9a138Cf899d20F13F79Ba00BC",
    lltv: "965000000000000000",
    oracle: "0x2b10A2d787a1ed76a68fCe7588A4EEbA6cc8794b",
    loanToken: {
      address: "0x34D78E7B06542Dab48f9bf9f0835c7582141314e",
      symbol: "wSTRCx",
    },
    collateralToken: {
      address: "0x98A878b1Cd98131B271883B390f68D2c90674665",
      symbol: "apxUSD",
    },
  },
  {
    id: "0x0d55c325847ed87d53506c2aca7de046cb59d8c22928fd55fb2790c4811d20db",
    name: "msETH / rswETH",
    irm: "0x870aC11D48B15DB9a138Cf899d20F13F79Ba00BC",
    lltv: "945000000000000000",
    oracle: "0x56e2d0957d2376dF4A0519b91D1Fa19D2d63bd9b",
    loanToken: {
      address: "0x64351fC9810aDAd17A690E4e1717Df5e7e085160",
      symbol: "msETH",
    },
    collateralToken: {
      address: "0xFAe103DC9cf190eD75350761e95403b7b8aFa6c0",
      symbol: "rswETH",
    },
  },
  {
    id: "0x0d4e6103803b66702b0aefc95d923b5583ac458dc613ba6be8404efd851636ca",
    name: "USDA / gtUSDC",
    irm: "0x870aC11D48B15DB9a138Cf899d20F13F79Ba00BC",
    lltv: "965000000000000000",
    oracle: "0xb3edb92ABdc8Cf574d3447F7B8a9978B79FdAC0f",
    loanToken: {
      address: "0x0000206329b97DB379d5E1Bf586BbDB969C63274",
      symbol: "USDA",
    },
    collateralToken: {
      address: "0xdd0f28e19C1780eb6396170735D45153D261490d",
      symbol: "gtUSDC",
    },
  },
  {
    id: "0x0cd36e6ecd9d846cffd921d011d2507bc4c2c421929cec65205b3cd72925367c",
    name: "crvUSD / ",
    irm: "0x870aC11D48B15DB9a138Cf899d20F13F79Ba00BC",
    lltv: "860000000000000000",
    oracle: "0xa9f7900476F43C45Ebf56cEa669B9c960C176112",
    loanToken: {
      address: "0xf939E0A03FB07F59A73314E73794Be0E57ac1b4E",
      symbol: "crvUSD",
    },
    collateralToken: {
      address: "0x3ce8Ec9f3d89aD0A2DdbCC3FDB8991BD241Fc82E",
      symbol: "",
    },
  },
  {
    id: "0x0cc2d99b87c4b24b6630e45943d37e86e3fc5ecd751edef1df549a4aa7148a41",
    name: "USDC / eBTC",
    irm: "0x870aC11D48B15DB9a138Cf899d20F13F79Ba00BC",
    lltv: "860000000000000000",
    oracle: "0xDddd770BADd886dF3864029e4B377B5F6a2B6b83",
    loanToken: {
      address: "0xA0b86991c6218b36c1d19D4a2e9Eb0cE3606eB48",
      symbol: "USDC",
    },
    collateralToken: {
      address: "0x657e8C867D8B37dCC18fA4Caead9C45EB088C642",
      symbol: "eBTC",
    },
  },
  {
    id: "0x0be56a001ebf37e4e1fc01c3b3f5e61efd9041284c9b877a47173acaed6ca11d",
    name: "crvUSD / ysUSDS",
    irm: "0x870aC11D48B15DB9a138Cf899d20F13F79Ba00BC",
    lltv: "945000000000000000",
    oracle: "0x6a4bDF040FE684284afa53E501f65c8E33839652",
    loanToken: {
      address: "0xf939E0A03FB07F59A73314E73794Be0E57ac1b4E",
      symbol: "crvUSD",
    },
    collateralToken: {
      address: "0x4cE9c93513DfF543Bc392870d57dF8C04e89Ba0a",
      symbol: "ysUSDS",
    },
  },
  {
    id: "0x0b08ec9e5363d5af926f186b47300c1cfef6afae298df4d457db71438534fd27",
    name: "WBTC / PT-corn-eBTC-27MAR2025",
    irm: "0x870aC11D48B15DB9a138Cf899d20F13F79Ba00BC",
    lltv: "915000000000000000",
    oracle: "0xda351be3eE86bda9949BCe255c36393FF402742F",
    loanToken: {
      address: "0x2260FAC5E5542a773Aa44fBCfeDf7C193bc2C599",
      symbol: "WBTC",
    },
    collateralToken: {
      address: "0x44A7876cA99460ef3218bf08b5f52E2dbE199566",
      symbol: "PT-corn-eBTC-27MAR2025",
    },
  },
  {
    id: "0x0af7f7f961ccf778fcc40f0a43d2878cc595fd81203e1a9fea1b65266805cf32",
    name: "USDC / USCC",
    irm: "0x870aC11D48B15DB9a138Cf899d20F13F79Ba00BC",
    lltv: "965000000000000000",
    oracle: "0xC0D8DCD624dD8DacA93E719b83C071e2A632D9Da",
    loanToken: {
      address: "0xA0b86991c6218b36c1d19D4a2e9Eb0cE3606eB48",
      symbol: "USDC",
    },
    collateralToken: {
      address: "0x14d60E7FDC0D71d8611742720E4C50E7a974020c",
      symbol: "USCC",
    },
  },
  {
    id: "0x0a9d7d7deb2be40cf027b87f3bb4a4776095be5d1a9d8d64253e8f9f4f64fa85",
    name: "bbqUSDT / PT-cUSDO-20NOV2025",
    irm: "0x870aC11D48B15DB9a138Cf899d20F13F79Ba00BC",
    lltv: "915000000000000000",
    oracle: "0xEc5333619ce2AE075e5FffF1A4F9540f81f2F041",
    loanToken: {
      address: "0xA0804346780b4c2e3bE118ac957D1DB82F9d7484",
      symbol: "bbqUSDT",
    },
    collateralToken: {
      address: "0xB10DA2F9147f9cf2B8826877Cd0c95c18A0f42dc",
      symbol: "PT-cUSDO-20NOV2025",
    },
  },
  {
    id: "0x0a73995d050136746336dce4675647e9b388df28049d7785b236ed1490436341",
    name: "USDCV / USTBL",
    irm: "0x870aC11D48B15DB9a138Cf899d20F13F79Ba00BC",
    lltv: "965000000000000000",
    oracle: "0x0e9fb68Cbf4b976Ac06De34227918AE28b416199",
    loanToken: {
      address: "0x5422374B27757da72d5265cC745ea906E0446634",
      symbol: "USDCV",
    },
    collateralToken: {
      address: "0xe4880249745eAc5F1eD9d8F7DF844792D560e750",
      symbol: "USTBL",
    },
  },
  {
    id: "0x09cf702bb8b6fe8c6effb6021744e365f598b89bc28f3ea7cd6c55115af825df",
    name: "AUSD / sUSDS",
    irm: "0x870aC11D48B15DB9a138Cf899d20F13F79Ba00BC",
    lltv: "945000000000000000",
    oracle: "0x954f55c1278e3Ff5cC0a20cA4cE10c1863e5f230",
    loanToken: {
      address: "0x00000000eFE302BEAA2b3e6e1b18d08D69a9012a",
      symbol: "AUSD",
    },
    collateralToken: {
      address: "0xa3931d71877C0E7a3148CB7Eb4463524FEc27fbD",
      symbol: "sUSDS",
    },
  },
  {
    id: "0x09c5c320ea11e05222f1d0b40c399af61541da0c8d7cace89113cc6d7714dd0e",
    name: "USDC / LINK",
    irm: "0x870aC11D48B15DB9a138Cf899d20F13F79Ba00BC",
    lltv: "860000000000000000",
    oracle: "0xDddd770BADd886dF3864029e4B377B5F6a2B6b83",
    loanToken: {
      address: "0xA0b86991c6218b36c1d19D4a2e9Eb0cE3606eB48",
      symbol: "USDC",
    },
    collateralToken: {
      address: "0x514910771AF9Ca656af840dff83E8264EcF986CA",
      symbol: "LINK",
    },
  },
  {
    id: "0x09aef3af89e02c30619a03f138d9471d1265312b2f0f635f44bdd5be31f60cc7",
    name: "JPYC / USDT",
    irm: "0x870aC11D48B15DB9a138Cf899d20F13F79Ba00BC",
    lltv: "915000000000000000",
    oracle: "0xB9C77Fba93164C7d753E3b7777C2a613FaCf4939",
    loanToken: {
      address: "0xE7C3D8C9a439feDe00D2600032D5dB0Be71C3c29",
      symbol: "JPYC",
    },
    collateralToken: {
      address: "0xdAC17F958D2ee523a2206206994597C13D831ec7",
      symbol: "USDT",
    },
  },
  {
    id: "0x0976b2b8e796994ef3e2fcc6c2f808c420917d531bb9cfaa4537773ca6860e1c",
    name: "USDS / IMF",
    irm: "0x870aC11D48B15DB9a138Cf899d20F13F79Ba00BC",
    lltv: "770000000000000000",
    oracle: "0x82f0952DbB57d5a0b77Dc39A209D699a4584dFcd",
    loanToken: {
      address: "0xdC035D45d973E3EC169d2276DDab16f1e407384F",
      symbol: "USDS",
    },
    collateralToken: {
      address: "0x05BE1d4c307C19450A6Fd7cE7307cE72a3829A60",
      symbol: "IMF",
    },
  },
  {
    id: "0x09597e3ede0ff531ac42b8c64e2a261984dc10954ae032f5e1fc07419db52f80",
    name: "RLUSD / sUSDS",
    irm: "0x870aC11D48B15DB9a138Cf899d20F13F79Ba00BC",
    lltv: "945000000000000000",
    oracle: "0xE3A25233EecddDDb273d9c88caab94adb113884c",
    loanToken: {
      address: "0x8292Bb45bf1Ee4d140127049757C2E0fF06317eD",
      symbol: "RLUSD",
    },
    collateralToken: {
      address: "0xa3931d71877C0E7a3148CB7Eb4463524FEc27fbD",
      symbol: "sUSDS",
    },
  },
  {
    id: "0x091756a1ba71f388fd5a959150c255acc55ce1e3714010a069ecb96f51b74235",
    name: "ZCHF / xETH",
    irm: "0x870aC11D48B15DB9a138Cf899d20F13F79Ba00BC",
    lltv: "625000000000000000",
    oracle: "0xCc466992240c143394C7052Cf5d6A7c99B1dBDaC",
    loanToken: {
      address: "0xB58E61C3098d85632Df34EecfB899A1Ed80921cB",
      symbol: "ZCHF",
    },
    collateralToken: {
      address: "0xe063F04f280c60aECa68b38341C2eEcBeC703ae2",
      symbol: "xETH",
    },
  },
  {
    id: "0x08e15c7f520c931cd414fa00d2b8611ce94fdee93272126dac46baf0f4082a67",
    name: "USDC / PT-USDat-27AUG2026",
    irm: "0x870aC11D48B15DB9a138Cf899d20F13F79Ba00BC",
    lltv: "860000000000000000",
    oracle: "0x710fA87a63aaBD4505Ca06e29E9FdF5160E984d1",
    loanToken: {
      address: "0xA0b86991c6218b36c1d19D4a2e9Eb0cE3606eB48",
      symbol: "USDC",
    },
    collateralToken: {
      address: "0x1D69402390657308C91179aa184bF992908c1e08",
      symbol: "PT-USDat-27AUG2026",
    },
  },
  {
    id: "0x08cfaaa2e7797b4e1326d1d174dd364c9fb3a2a718623a3b7f97ea1debba47b8",
    name: "FRAX / USDe",
    irm: "0x870aC11D48B15DB9a138Cf899d20F13F79Ba00BC",
    lltv: "860000000000000000",
    oracle: "0xaE4750d0813B5E37A51f7629beedd72AF1f9cA35",
    loanToken: {
      address: "0x853d955aCEf822Db058eb8505911ED77F175b99e",
      symbol: "FRAX",
    },
    collateralToken: {
      address: "0x4c9EDD5852cd905f086C759E8383e09bff1E68B3",
      symbol: "USDe",
    },
  },
  {
    id: "0x08bd0186c5d6ee272f973a307815ac9a8f5ed42bc8308d4b109f254011776c34",
    name: "AUSD / wsrUSD",
    irm: "0x870aC11D48B15DB9a138Cf899d20F13F79Ba00BC",
    lltv: "915000000000000000",
    oracle: "0x938D2eDb20425cF80F008E7ec314Eb456940Da15",
    loanToken: {
      address: "0x00000000eFE302BEAA2b3e6e1b18d08D69a9012a",
      symbol: "AUSD",
    },
    collateralToken: {
      address: "0xd3fD63209FA2D55B07A0f6db36C2f43900be3094",
      symbol: "wsrUSD",
    },
  },
  {
    id: "0x07fdfe1154f9b10fe0a8107c26e46b2b935234af77e81e560d253af35ed96665",
    name: "tBTC / LBTC",
    irm: "0x870aC11D48B15DB9a138Cf899d20F13F79Ba00BC",
    lltv: "915000000000000000",
    oracle: "0x80fA2a9f31Bb0bf0CbDBFb65Dc414C13F8320C85",
    loanToken: {
      address: "0x18084fbA666a33d37592fA2633fD49a74DD93a88",
      symbol: "tBTC",
    },
    collateralToken: {
      address: "0x8236a87084f8B84306f72007F36F2618A5634494",
      symbol: "LBTC",
    },
  },
  {
    id: "0x0781f40a5eaef72ca4d8f732b5f8067ba4d7e9f90a4ff70e2639c72cf9ee3d42",
    name: "USDT / MUSD",
    irm: "0x870aC11D48B15DB9a138Cf899d20F13F79Ba00BC",
    lltv: "915000000000000000",
    oracle: "0x04D6aA725a74ee9314C505e6929687b835D550a4",
    loanToken: {
      address: "0xdAC17F958D2ee523a2206206994597C13D831ec7",
      symbol: "USDT",
    },
    collateralToken: {
      address: "0xdD468A1DDc392dcdbEf6db6e34E89AA338F9F186",
      symbol: "MUSD",
    },
  },
  {
    id: "0x074973eb292ffcb3cb22c71138eed4b2ad7030f5620918d41617609f8270aa4f",
    name: "USDA / wstETH",
    irm: "0x870aC11D48B15DB9a138Cf899d20F13F79Ba00BC",
    lltv: "860000000000000000",
    oracle: "0x032F1C64899b2C89835E51aCeD9434b0aDEaA69d",
    loanToken: {
      address: "0x0000206329b97DB379d5E1Bf586BbDB969C63274",
      symbol: "USDA",
    },
    collateralToken: {
      address: "0x7f39C581F595B53c5cb19bD0b3f8dA6c935E2Ca0",
      symbol: "wstETH",
    },
  },
  {
    id: "0x0716a7a07f28196759311ac1cdc9b3faf63d9834375169d34d72725eda272f5b",
    name: "USDC / mTBILL",
    irm: "0x870aC11D48B15DB9a138Cf899d20F13F79Ba00BC",
    lltv: "915000000000000000",
    oracle: "0x2E3E64eE52Bd06B3bfA602aeBda8897478d9a5BA",
    loanToken: {
      address: "0xA0b86991c6218b36c1d19D4a2e9Eb0cE3606eB48",
      symbol: "USDC",
    },
    collateralToken: {
      address: "0xDD629E5241CbC5919847783e6C96B2De4754e438",
      symbol: "mTBILL",
    },
  },
  {
    id: "0x070030dcd03a08fa6f76a6b9d9a18e28496b9c62043d552f31bfa9b2d519a543",
    name: "USR / PT-wstUSR-25SEP2025",
    irm: "0x870aC11D48B15DB9a138Cf899d20F13F79Ba00BC",
    lltv: "915000000000000000",
    oracle: "0xDB4F60247D2da0c6235b07f94Bb8AE72F5267322",
    loanToken: {
      address: "0x66a1E37c9b0eAddca17d3662D6c05F4DECf3e110",
      symbol: "USR",
    },
    collateralToken: {
      address: "0x23E60d1488525bf4685f53b3aa8E676c30321066",
      symbol: "PT-wstUSR-25SEP2025",
    },
  },
  {
    id: "0x06cd324a963c18a7c046be97dba2a4af9b82f0ca3a2e451a38ccfb9c76667e5f",
    name: "USDf / PT-sUSDf-25SEP2025",
    irm: "0x870aC11D48B15DB9a138Cf899d20F13F79Ba00BC",
    lltv: "915000000000000000",
    oracle: "0x893FE4c073cB634b6eCF7eDc6917266ae188036b",
    loanToken: {
      address: "0xFa2B947eEc368f42195f24F36d2aF29f7c24CeC2",
      symbol: "USDf",
    },
    collateralToken: {
      address: "0xAB365C0879024481E4ad3b47bd6FeA9c10014FbC",
      symbol: "PT-sUSDf-25SEP2025",
    },
  },
  {
    id: "0x0655e0c8686d94d9e0c0d2b78d7f99492676e52d712db5ac061b3c78da4b7587",
    name: "USDS / CULT",
    irm: "0x870aC11D48B15DB9a138Cf899d20F13F79Ba00BC",
    lltv: "770000000000000000",
    oracle: "0x851D005673a4BfD00B59eDe31424cD8BeB679CeF",
    loanToken: {
      address: "0xdC035D45d973E3EC169d2276DDab16f1e407384F",
      symbol: "USDS",
    },
    collateralToken: {
      address: "0x0000000000c5dc95539589fbD24BE07c6C14eCa4",
      symbol: "CULT",
    },
  },
  {
    id: "0x05af3d869d7356cffb477d64d6122004d6da40de6f18a1d987fbdf9d6b1cf568",
    name: "AUSD / wNVDAx",
    irm: "0x870aC11D48B15DB9a138Cf899d20F13F79Ba00BC",
    lltv: "860000000000000000",
    oracle: "0xCB88FA5f48dc5751D82F20a3a4BA14803f827A73",
    loanToken: {
      address: "0x00000000eFE302BEAA2b3e6e1b18d08D69a9012a",
      symbol: "AUSD",
    },
    collateralToken: {
      address: "0x93E62845C1DD5822EbC807ab71A5Fb750DecD15A",
      symbol: "wNVDAx",
    },
  },
  {
    id: "0x0587e251513bd44079f799bc3e8bd82f7922267295b5f7fa276c27dfdca13550",
    name: "USDC / ACS",
    irm: "0x870aC11D48B15DB9a138Cf899d20F13F79Ba00BC",
    lltv: "770000000000000000",
    oracle: "0x359767f0CE82592eED2F13F19B0252eB539C2A2D",
    loanToken: {
      address: "0xA0b86991c6218b36c1d19D4a2e9Eb0cE3606eB48",
      symbol: "USDC",
    },
    collateralToken: {
      address: "0x1769AA7B5B4AAe76B7E6D797B379c21cAE12c46d",
      symbol: "ACS",
    },
  },
  {
    id: "0x055e1e84856c5749b90a8dd326b94562dff88ab693f6b8dda8c05087143c1031",
    name: "USDC / cbBTC",
    irm: "0x870aC11D48B15DB9a138Cf899d20F13F79Ba00BC",
    lltv: "860000000000000000",
    oracle: "0xDddd770BADd886dF3864029e4B377B5F6a2B6b83",
    loanToken: {
      address: "0xA0b86991c6218b36c1d19D4a2e9Eb0cE3606eB48",
      symbol: "USDC",
    },
    collateralToken: {
      address: "0xcbB7C0000aB88B473b1f5aFd9ef808440eed33Bf",
      symbol: "cbBTC",
    },
  },
  {
    id: "0x04d2230e467510a3e3d745452f0278828634395f663d8b9339cd8bf0e8c4dd19",
    name: "USDC / USYC",
    irm: "0x870aC11D48B15DB9a138Cf899d20F13F79Ba00BC",
    lltv: "860000000000000000",
    oracle: "0xDddd770BADd886dF3864029e4B377B5F6a2B6b83",
    loanToken: {
      address: "0xA0b86991c6218b36c1d19D4a2e9Eb0cE3606eB48",
      symbol: "USDC",
    },
    collateralToken: {
      address: "0x136471a34f6ef19fE571EFFC1CA711fdb8E49f2b",
      symbol: "USYC",
    },
  },
  {
    id: "0x04b580ba9e6e886b67e47265cc8e314820123d5683563bb24097ad80513d6e4f",
    name: "AUSD / SPYx",
    irm: "0x870aC11D48B15DB9a138Cf899d20F13F79Ba00BC",
    lltv: "860000000000000000",
    oracle: "0x63d2A9b914Ba18FB28c408fDbC6cB84884153700",
    loanToken: {
      address: "0x00000000eFE302BEAA2b3e6e1b18d08D69a9012a",
      symbol: "AUSD",
    },
    collateralToken: {
      address: "0x90A2a4c76b5D8c0bc892A69EA28Aa775a8f2dD48",
      symbol: "SPYx",
    },
  },
  {
    id: "0x04af39f2a191e76cfb083fac5c6f0c2980a5055876bc327c058b797db0ae4923",
    name: "USDC / PT-jrUSDe-2APR2026",
    irm: "0x870aC11D48B15DB9a138Cf899d20F13F79Ba00BC",
    lltv: "860000000000000000",
    oracle: "0xF142d4969bDA35222DEdA5e54B12Fa50aFEC3086",
    loanToken: {
      address: "0xA0b86991c6218b36c1d19D4a2e9Eb0cE3606eB48",
      symbol: "USDC",
    },
    collateralToken: {
      address: "0xd0609Ac13000d88B0BEbf5Bb21074916eDd92Bb1",
      symbol: "PT-jrUSDe-2APR2026",
    },
  },
  {
    id: "0x04663e98d677d8ef38b76d5a19d1fddc1aff10a86b71dc7f01cd8f5a18a16f06",
    name: "apxUSD / PT-apyUSD-18JUN2026",
    irm: "0x870aC11D48B15DB9a138Cf899d20F13F79Ba00BC",
    lltv: "860000000000000000",
    oracle: "0x1E7F3938A2a39B43d95a7A807a90e6eF09520949",
    loanToken: {
      address: "0x98A878b1Cd98131B271883B390f68D2c90674665",
      symbol: "apxUSD",
    },
    collateralToken: {
      address: "0x3365554a61CeFF74A76528f9e86C1E87946d16a5",
      symbol: "PT-apyUSD-18JUN2026",
    },
  },
  {
    id: "0x028360c22e2ba7d771e700a291c6505a2c3c69c357ac2aa074d920758bce87b6",
    name: "PT-corn-SolvBTC.BBN-26DEC2024 / cbBTC",
    irm: "0x870aC11D48B15DB9a138Cf899d20F13F79Ba00BC",
    lltv: "915000000000000000",
    oracle: "0x309b563107f6AfBEa888acF1E1BffE0dB8a8d08B",
    loanToken: {
      address: "0x23e479ddcda990E8523494895759bD98cD2fDBF6",
      symbol: "PT-corn-SolvBTC.BBN-26DEC2024",
    },
    collateralToken: {
      address: "0xcbB7C0000aB88B473b1f5aFd9ef808440eed33Bf",
      symbol: "cbBTC",
    },
  },
  {
    id: "0x0249b6db0b1f30e5a6cd362ab3468bf1b9b58bc51ced6ba5dd5b885180acdc43",
    name: "USDT / tBTC",
    irm: "0x870aC11D48B15DB9a138Cf899d20F13F79Ba00BC",
    lltv: "860000000000000000",
    oracle: "0x26B1a98e509E70f11Ff2011991447D44bd0dB60e",
    loanToken: {
      address: "0xdAC17F958D2ee523a2206206994597C13D831ec7",
      symbol: "USDT",
    },
    collateralToken: {
      address: "0x18084fbA666a33d37592fA2633fD49a74DD93a88",
      symbol: "tBTC",
    },
  },
  {
    id: "0x010e577cd5d40210ae600cd877710c252a26afd7b50b1280642c76c4612bd6df",
    name: "AUSD / wstUSR",
    irm: "0x870aC11D48B15DB9a138Cf899d20F13F79Ba00BC",
    lltv: "915000000000000000",
    oracle: "0xDdFF4aCd31d0e1D3943dD2C3F07cC3a2Aa899e74",
    loanToken: {
      address: "0x00000000eFE302BEAA2b3e6e1b18d08D69a9012a",
      symbol: "AUSD",
    },
    collateralToken: {
      address: "0x1202F5C7b4B9E47a1A484E8B270be34dbbC75055",
      symbol: "wstUSR",
    },
  },
  {
    id: "0x00c29d13b1be92d2b209634211457161ba9d5594fd6ad0987ec75fc3a1adc254",
    name: "USDC / wUTXO",
    irm: "0x870aC11D48B15DB9a138Cf899d20F13F79Ba00BC",
    lltv: "860000000000000000",
    oracle: "0xC54291Ae4e0293943831D91eCa037d7C30792e7E",
    loanToken: {
      address: "0xA0b86991c6218b36c1d19D4a2e9Eb0cE3606eB48",
      symbol: "USDC",
    },
    collateralToken: {
      address: "0xd76B994b6E6350bc298c836cBb58b117496e49E3",
      symbol: "wUTXO",
    },
  },
  {
    id: "0x008df4701e94fbeb1a04efa571cad8d8638af0ad57e18123430ca1b29768b52b",
    name: "fwUSDT / fwWBTC",
    irm: "0x870aC11D48B15DB9a138Cf899d20F13F79Ba00BC",
    lltv: "860000000000000000",
    oracle: "0x008bF4B1cDA0cc9f0e882E0697f036667652E1ef",
    loanToken: {
      address: "0xef87f4608e601E8564800265AeE1c1FfaDF73283",
      symbol: "fwUSDT",
    },
    collateralToken: {
      address: "0x2078f336Fdd260f708BEc4a20c82b063274E1b23",
      symbol: "fwWBTC",
    },
  },
  {
    id: "0x008cbf30b3a54f2ba03bed5f6d27cca523fa5b80b8324c4aa6806a1f05a89b9b",
    name: "cbBTC / PT-LBTC-27MAR2025",
    irm: "0x870aC11D48B15DB9a138Cf899d20F13F79Ba00BC",
    lltv: "915000000000000000",
    oracle: "0x309b563107f6AfBEa888acF1E1BffE0dB8a8d08B",
    loanToken: {
      address: "0xcbB7C0000aB88B473b1f5aFd9ef808440eed33Bf",
      symbol: "cbBTC",
    },
    collateralToken: {
      address: "0xEc5a52C685CC3Ad79a6a347aBACe330d69e0b1eD",
      symbol: "PT-LBTC-27MAR2025",
    },
  },
  {
    id: "0x0013c259d2fa48b010412882b312cd7d4d732747b7a5a9e53c1ff7aaa2e07ddb",
    name: "USDC / splDXY-BULL",
    irm: "0x870aC11D48B15DB9a138Cf899d20F13F79Ba00BC",
    lltv: "915000000000000000",
    oracle: "0xA4eD2a8F1536efb139124B38763B04af496b61D7",
    loanToken: {
      address: "0xA0b86991c6218b36c1d19D4a2e9Eb0cE3606eB48",
      symbol: "USDC",
    },
    collateralToken: {
      address: "0x8dbcF452799f50D3382105a19FdBfA57B7f29C73",
      symbol: "splDXY-BULL",
    },
  },
] as const
